/* eslint-disable */
// @ts-nocheck
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Represents a phone number by Aspen requirements. Digits only with length of 10. */
  AspenPhoneNumberType: { input: any; output: any; }
  /** CityUid represents custom scalar type that should be the value of City.CityUid field. */
  CityUid: { input: any; output: any; }
  /** The `Date` scalar represents an ISO-8601 compliant date type. */
  Date: { input: any; output: any; }
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z,
   *     compliant with the 'date-time' format outlined in section 5.6 of
   *     the RFC 3339 profile of the ISO 8601 standard for representation
   *     of dates and times using the Gregorian calendar.
   */
  DateTime: { input: any; output: any; }
  /** The built-in `Decimal` scalar type. */
  Decimal: { input: any; output: any; }
  /** The 'Dimension' type represents dimensions as whole numeric values between `1` and `4000`. */
  Dimension: { input: any; output: any; }
  /** The EmailAddress scalar type constitutes a valid email address, represented as a UTF-8 character sequence. The scalar follows the specification defined by the HTML Spec https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: any; output: any; }
  /** The 'HexColor' type represents color in `rgb:ffffff` string format. */
  HexColor: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The LocalTime scalar type is a local time string (i.e., with no associated timezone) in 24-hr HH:mm:ss. */
  LocalTime: { input: any; output: any; }
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: any; output: any; }
  /** The multiplier path scalar represents a valid GraphQL multiplier path string. */
  MultiplierPath: { input: any; output: any; }
  /** The NonEmptyString scalar type represents non empty textual data, represented as UTF‐8 character sequences with at least one character */
  NonEmptyString: { input: any; output: any; }
  /** The NonNegativeInt scalar type represents a unsigned 32-bit numeric non-fractional value equal to or greater than 0. */
  NonNegativeInt: { input: any; output: any; }
  /** The 'Quality' type represents quality as whole numeric values between `1` and `100`. */
  Quality: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type Accordions = Entry & _Node & {
  __typename?: 'Accordions';
  _id: Scalars['ID']['output'];
  accordionsCollection?: Maybe<AccordionsAccordionsCollection>;
  accordionsContentSectionsCollection?: Maybe<AccordionsAccordionsContentSectionsCollection>;
  accordionsHeading?: Maybe<Scalars['String']['output']>;
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<Asset>;
  buttonCollectionAlignment?: Maybe<Scalars['String']['output']>;
  buttonsCollection?: Maybe<AccordionsButtonsCollection>;
  centerAlign?: Maybe<Scalars['Boolean']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  descriptionAlignment?: Maybe<Scalars['String']['output']>;
  descriptionRichText?: Maybe<AccordionsDescriptionRichText>;
  disablePaddingOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  expandIconPosition?: Maybe<Scalars['String']['output']>;
  expandIconType?: Maybe<Scalars['String']['output']>;
  fullWidth?: Maybe<Scalars['Boolean']['output']>;
  image?: Maybe<FocalPointImage>;
  imagePositionRight?: Maybe<Scalars['Boolean']['output']>;
  imageRoundedCorner?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<AccordionsLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  roundedCornersSize?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  titleAlignment?: Maybe<Scalars['String']['output']>;
  titleColor?: Maybe<Scalars['String']['output']>;
  titleHtag?: Maybe<Scalars['String']['output']>;
  withInnerGap?: Maybe<Scalars['Boolean']['output']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsAccordionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccordionsAccordionsFilter>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsAccordionsContentSectionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsAccordionsContentSectionsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentSectionFilter>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsAccordionsHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsBackgroundImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsButtonCollectionAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsCenterAlignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsDescriptionAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsDescriptionRichTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsDisablePaddingOnArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsExpandIconPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsExpandIconTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsFullWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsImagePositionRightArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsImageRoundedCornerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsRoundedCornersSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsTitleAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsTitleColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsWithInnerGapArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type AccordionsAccordionsCollection = {
  __typename?: 'AccordionsAccordionsCollection';
  items: Array<Maybe<AccordionsAccordionsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AccordionsAccordionsContentSectionsCollection = {
  __typename?: 'AccordionsAccordionsContentSectionsCollection';
  items: Array<Maybe<ContentSection>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AccordionsAccordionsContentSectionsCollectionOrder =
  | 'alignment_ASC'
  | 'alignment_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'titleIcon_ASC'
  | 'titleIcon_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AccordionsAccordionsFilter = {
  AND?: InputMaybe<Array<InputMaybe<AccordionsAccordionsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AccordionsAccordionsFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AccordionsAccordionsItem = AgendaStepper | ContentTypeRichText;

export type AccordionsButtonsCollection = {
  __typename?: 'AccordionsButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AccordionsButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type AccordionsCollection = {
  __typename?: 'AccordionsCollection';
  items: Array<Maybe<Accordions>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AccordionsDescriptionRichText = {
  __typename?: 'AccordionsDescriptionRichText';
  json: Scalars['JSON']['output'];
  links: AccordionsDescriptionRichTextLinks;
};

export type AccordionsDescriptionRichTextAssets = {
  __typename?: 'AccordionsDescriptionRichTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type AccordionsDescriptionRichTextEntries = {
  __typename?: 'AccordionsDescriptionRichTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type AccordionsDescriptionRichTextLinks = {
  __typename?: 'AccordionsDescriptionRichTextLinks';
  assets: AccordionsDescriptionRichTextAssets;
  entries: AccordionsDescriptionRichTextEntries;
  resources: AccordionsDescriptionRichTextResources;
};

export type AccordionsDescriptionRichTextResources = {
  __typename?: 'AccordionsDescriptionRichTextResources';
  block: Array<AccordionsDescriptionRichTextResourcesBlock>;
  hyperlink: Array<AccordionsDescriptionRichTextResourcesHyperlink>;
  inline: Array<AccordionsDescriptionRichTextResourcesInline>;
};

export type AccordionsDescriptionRichTextResourcesBlock = ResourceLink & {
  __typename?: 'AccordionsDescriptionRichTextResourcesBlock';
  sys: ResourceSys;
};

export type AccordionsDescriptionRichTextResourcesHyperlink = ResourceLink & {
  __typename?: 'AccordionsDescriptionRichTextResourcesHyperlink';
  sys: ResourceSys;
};

export type AccordionsDescriptionRichTextResourcesInline = ResourceLink & {
  __typename?: 'AccordionsDescriptionRichTextResourcesInline';
  sys: ResourceSys;
};

export type AccordionsFilter = {
  AND?: InputMaybe<Array<InputMaybe<AccordionsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AccordionsFilter>>>;
  accordions?: InputMaybe<CfaccordionsMultiTypeNestedFilter>;
  accordionsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  accordionsContentSections?: InputMaybe<CfContentSectionNestedFilter>;
  accordionsContentSectionsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  accordionsHeading?: InputMaybe<Scalars['String']['input']>;
  accordionsHeading_contains?: InputMaybe<Scalars['String']['input']>;
  accordionsHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  accordionsHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  accordionsHeading_not?: InputMaybe<Scalars['String']['input']>;
  accordionsHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  accordionsHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonCollectionAlignment?: InputMaybe<Scalars['String']['input']>;
  buttonCollectionAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  buttonCollectionAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonCollectionAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonCollectionAlignment_not?: InputMaybe<Scalars['String']['input']>;
  buttonCollectionAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonCollectionAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionAlignment?: InputMaybe<Scalars['String']['input']>;
  descriptionAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionAlignment_not?: InputMaybe<Scalars['String']['input']>;
  descriptionAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionRichText_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionRichText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionRichText_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  expandIconPosition?: InputMaybe<Scalars['String']['input']>;
  expandIconPosition_contains?: InputMaybe<Scalars['String']['input']>;
  expandIconPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  expandIconPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  expandIconPosition_not?: InputMaybe<Scalars['String']['input']>;
  expandIconPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  expandIconPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  expandIconType?: InputMaybe<Scalars['String']['input']>;
  expandIconType_contains?: InputMaybe<Scalars['String']['input']>;
  expandIconType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  expandIconType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  expandIconType_not?: InputMaybe<Scalars['String']['input']>;
  expandIconType_not_contains?: InputMaybe<Scalars['String']['input']>;
  expandIconType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<CfFocalPointImageNestedFilter>;
  imagePositionRight?: InputMaybe<Scalars['Boolean']['input']>;
  imagePositionRight_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imagePositionRight_not?: InputMaybe<Scalars['Boolean']['input']>;
  imageRoundedCorner?: InputMaybe<Scalars['String']['input']>;
  imageRoundedCorner_contains?: InputMaybe<Scalars['String']['input']>;
  imageRoundedCorner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageRoundedCorner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageRoundedCorner_not?: InputMaybe<Scalars['String']['input']>;
  imageRoundedCorner_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageRoundedCorner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roundedCornersSize?: InputMaybe<Scalars['String']['input']>;
  roundedCornersSize_contains?: InputMaybe<Scalars['String']['input']>;
  roundedCornersSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  roundedCornersSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roundedCornersSize_not?: InputMaybe<Scalars['String']['input']>;
  roundedCornersSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  roundedCornersSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleAlignment?: InputMaybe<Scalars['String']['input']>;
  titleAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  titleAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleAlignment_not?: InputMaybe<Scalars['String']['input']>;
  titleAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColor?: InputMaybe<Scalars['String']['input']>;
  titleColor_contains?: InputMaybe<Scalars['String']['input']>;
  titleColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColor_not?: InputMaybe<Scalars['String']['input']>;
  titleColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withInnerGap?: InputMaybe<Scalars['Boolean']['input']>;
  withInnerGap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  withInnerGap_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccordionsLinkingCollections = {
  __typename?: 'AccordionsLinkingCollections';
  blogDetailsPageCollection?: Maybe<BlogDetailsPageCollection>;
  columnsCollection?: Maybe<ColumnsCollection>;
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  pageCollection?: Maybe<PageCollection>;
  providerDetailsPageCollection?: Maybe<ProviderDetailsPageCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceLineHeroCollection?: Maybe<ServiceLineHeroCollection>;
  tabCollection?: Maybe<TabCollection>;
};


export type AccordionsLinkingCollectionsBlogDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsBlogDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AccordionsLinkingCollectionsColumnsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsColumnsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AccordionsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AccordionsLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AccordionsLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AccordionsLinkingCollectionsProviderDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsProviderDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AccordionsLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AccordionsLinkingCollectionsServiceLineHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsServiceLineHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AccordionsLinkingCollectionsTabCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsTabCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type AccordionsLinkingCollectionsBlogDetailsPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AccordionsLinkingCollectionsColumnsCollectionOrder =
  | 'allowEqualHeights_ASC'
  | 'allowEqualHeights_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'mobileDisplayAccordion_ASC'
  | 'mobileDisplayAccordion_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AccordionsLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AccordionsLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AccordionsLinkingCollectionsProviderDetailsPageCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AccordionsLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AccordionsLinkingCollectionsServiceLineHeroCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type AccordionsLinkingCollectionsTabCollectionOrder =
  | 'jumplinkName_ASC'
  | 'jumplinkName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AccordionsOrder =
  | 'accordionsHeading_ASC'
  | 'accordionsHeading_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonCollectionAlignment_ASC'
  | 'buttonCollectionAlignment_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'descriptionAlignment_ASC'
  | 'descriptionAlignment_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'expandIconPosition_ASC'
  | 'expandIconPosition_DESC'
  | 'expandIconType_ASC'
  | 'expandIconType_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'imagePositionRight_ASC'
  | 'imagePositionRight_DESC'
  | 'imageRoundedCorner_ASC'
  | 'imageRoundedCorner_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'roundedCornersSize_ASC'
  | 'roundedCornersSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleAlignment_ASC'
  | 'titleAlignment_DESC'
  | 'titleColor_ASC'
  | 'titleColor_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'withInnerGap_ASC'
  | 'withInnerGap_DESC';

/** Account Information */
export type Account = {
  __typename?: 'Account';
  accountNumber?: Maybe<Scalars['Long']['output']>;
  /** @deprecated Use me.personalInformation.dateOfBirth */
  birthDate?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use me.personalInformation.email */
  email?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use me.personalInformation.firstName */
  firstName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use me.personalInformation.lastName */
  lastName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use me.personalInformation.phones */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** @deprecated Username is not existing patient account attribute. Do not use it. */
  username?: Maybe<Scalars['String']['output']>;
};

/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooter = Entry & _Node & {
  __typename?: 'AdFooter';
  _id: Scalars['ID']['output'];
  about?: Maybe<AdFooterAbout>;
  bookNowButton?: Maybe<Entry>;
  componentName?: Maybe<Scalars['String']['output']>;
  contactNumber?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  copyright?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<DisclaimerV2>;
  exclusivelyAt?: Maybe<Entry>;
  footerPolicyGroupCollection?: Maybe<AdFooterFooterPolicyGroupCollection>;
  isLightFooter?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<AdFooterLinkingCollections>;
  logo?: Maybe<Asset>;
  navigationGroupsCollection?: Maybe<AdFooterNavigationGroupsCollection>;
  socialNetworksCollection?: Maybe<AdFooterSocialNetworksCollection>;
  stickyFooterButton?: Maybe<Button>;
  stickyFooterButtonsCollection?: Maybe<AdFooterStickyFooterButtonsCollection>;
  stickyFooterScheduleButton?: Maybe<Button>;
  sys: Sys;
  useDesktopStickyFooter?: Maybe<Scalars['Boolean']['output']>;
  useMobileStickyFooter?: Maybe<Scalars['Boolean']['output']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterAboutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterBookNowButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterComponentNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterContactNumberArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterCopyrightArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterDisclaimerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DisclaimerV2Filter>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterExclusivelyAtArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterFooterPolicyGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AdFooterFooterPolicyGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterIsLightFooterArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterLogoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterNavigationGroupsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AdFooterNavigationGroupsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FooterNavigationGroupFilter>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterSocialNetworksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterStickyFooterButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterStickyFooterButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AdFooterStickyFooterButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterStickyFooterScheduleButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterUseDesktopStickyFooterArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterUseMobileStickyFooterArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type AdFooterAbout = {
  __typename?: 'AdFooterAbout';
  json: Scalars['JSON']['output'];
  links: AdFooterAboutLinks;
};

export type AdFooterAboutAssets = {
  __typename?: 'AdFooterAboutAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type AdFooterAboutEntries = {
  __typename?: 'AdFooterAboutEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type AdFooterAboutLinks = {
  __typename?: 'AdFooterAboutLinks';
  assets: AdFooterAboutAssets;
  entries: AdFooterAboutEntries;
  resources: AdFooterAboutResources;
};

export type AdFooterAboutResources = {
  __typename?: 'AdFooterAboutResources';
  block: Array<AdFooterAboutResourcesBlock>;
  hyperlink: Array<AdFooterAboutResourcesHyperlink>;
  inline: Array<AdFooterAboutResourcesInline>;
};

export type AdFooterAboutResourcesBlock = ResourceLink & {
  __typename?: 'AdFooterAboutResourcesBlock';
  sys: ResourceSys;
};

export type AdFooterAboutResourcesHyperlink = ResourceLink & {
  __typename?: 'AdFooterAboutResourcesHyperlink';
  sys: ResourceSys;
};

export type AdFooterAboutResourcesInline = ResourceLink & {
  __typename?: 'AdFooterAboutResourcesInline';
  sys: ResourceSys;
};

export type AdFooterCollection = {
  __typename?: 'AdFooterCollection';
  items: Array<Maybe<AdFooter>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdFooterFilter = {
  AND?: InputMaybe<Array<InputMaybe<AdFooterFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AdFooterFilter>>>;
  about_contains?: InputMaybe<Scalars['String']['input']>;
  about_exists?: InputMaybe<Scalars['Boolean']['input']>;
  about_not_contains?: InputMaybe<Scalars['String']['input']>;
  bookNowButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName?: InputMaybe<Scalars['String']['input']>;
  componentName_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentName_not?: InputMaybe<Scalars['String']['input']>;
  componentName_not_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  contactNumber_contains?: InputMaybe<Scalars['String']['input']>;
  contactNumber_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contactNumber_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactNumber_not?: InputMaybe<Scalars['String']['input']>;
  contactNumber_not_contains?: InputMaybe<Scalars['String']['input']>;
  contactNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copyright?: InputMaybe<Scalars['String']['input']>;
  copyright_contains?: InputMaybe<Scalars['String']['input']>;
  copyright_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copyright_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  copyright_not?: InputMaybe<Scalars['String']['input']>;
  copyright_not_contains?: InputMaybe<Scalars['String']['input']>;
  copyright_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disclaimer?: InputMaybe<CfDisclaimerV2NestedFilter>;
  disclaimer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  exclusivelyAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  footerPolicyGroup?: InputMaybe<CfNavigationLinkNestedFilter>;
  footerPolicyGroupCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLightFooter?: InputMaybe<Scalars['Boolean']['input']>;
  isLightFooter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLightFooter_not?: InputMaybe<Scalars['Boolean']['input']>;
  logo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  navigationGroups?: InputMaybe<CfFooterNavigationGroupNestedFilter>;
  navigationGroupsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialNetworksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stickyFooterButton?: InputMaybe<CfButtonNestedFilter>;
  stickyFooterButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stickyFooterButtons?: InputMaybe<CfButtonNestedFilter>;
  stickyFooterButtonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stickyFooterScheduleButton?: InputMaybe<CfButtonNestedFilter>;
  stickyFooterScheduleButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  useDesktopStickyFooter?: InputMaybe<Scalars['Boolean']['input']>;
  useDesktopStickyFooter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useDesktopStickyFooter_not?: InputMaybe<Scalars['Boolean']['input']>;
  useMobileStickyFooter?: InputMaybe<Scalars['Boolean']['input']>;
  useMobileStickyFooter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useMobileStickyFooter_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdFooterFooterPolicyGroupCollection = {
  __typename?: 'AdFooterFooterPolicyGroupCollection';
  items: Array<Maybe<NavigationLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdFooterFooterPolicyGroupCollectionOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AdFooterLinkingCollections = {
  __typename?: 'AdFooterLinkingCollections';
  appCollection?: Maybe<AppCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type AdFooterLinkingCollectionsAppCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AdFooterLinkingCollectionsAppCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AdFooterLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type AdFooterLinkingCollectionsAppCollectionOrder =
  | 'brandImageLink_ASC'
  | 'brandImageLink_DESC'
  | 'branding_ASC'
  | 'branding_DESC'
  | 'isDeprecated_ASC'
  | 'isDeprecated_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AdFooterNavigationGroupsCollection = {
  __typename?: 'AdFooterNavigationGroupsCollection';
  items: Array<Maybe<FooterNavigationGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdFooterNavigationGroupsCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'navigationGroupTitle_ASC'
  | 'navigationGroupTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AdFooterOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'contactNumber_ASC'
  | 'contactNumber_DESC'
  | 'copyright_ASC'
  | 'copyright_DESC'
  | 'isLightFooter_ASC'
  | 'isLightFooter_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useDesktopStickyFooter_ASC'
  | 'useDesktopStickyFooter_DESC'
  | 'useMobileStickyFooter_ASC'
  | 'useMobileStickyFooter_DESC';

export type AdFooterSocialNetworksCollection = {
  __typename?: 'AdFooterSocialNetworksCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdFooterStickyFooterButtonsCollection = {
  __typename?: 'AdFooterStickyFooterButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdFooterStickyFooterButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type AddPatientAuthorizationErrors = InvalidFieldError;

export type AddPatientAuthorizationInput = {
  facilityCode: Scalars['NonEmptyString']['input'];
  financialPoliciesAuthorization: Scalars['Boolean']['input'];
  medicalHistoryObtainingAuthorization: Scalars['Boolean']['input'];
  privacyPracticesAuthorization: Scalars['Boolean']['input'];
  releaseOfInfoToInsurersAuthorization: Scalars['Boolean']['input'];
  /** PNG format image base64 encoded string */
  signature: Scalars['NonEmptyString']['input'];
  thirdPartyInformationSharingAuthorizationInput?: InputMaybe<ThirdPartyInformationSharingAuthorizationInput>;
};

export type AddPatientAuthorizationPayload = {
  __typename?: 'AddPatientAuthorizationPayload';
  errors?: Maybe<Array<AddPatientAuthorizationErrors>>;
  result?: Maybe<PatientAuthorizations>;
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaModal) */
export type AgendaModal = Entry & _Node & {
  __typename?: 'AgendaModal';
  _id: Scalars['ID']['output'];
  bodyText?: Maybe<ContentTypeRichText>;
  contentfulMetadata: ContentfulMetadata;
  headlineHeading?: Maybe<Scalars['String']['output']>;
  headlineText?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<AgendaModalLinkingCollections>;
  modalName?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaModal) */
export type AgendaModalBodyTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaModal) */
export type AgendaModalHeadlineHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaModal) */
export type AgendaModalHeadlineTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaModal) */
export type AgendaModalIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaModal) */
export type AgendaModalLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaModal) */
export type AgendaModalModalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type AgendaModalCollection = {
  __typename?: 'AgendaModalCollection';
  items: Array<Maybe<AgendaModal>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AgendaModalFilter = {
  AND?: InputMaybe<Array<InputMaybe<AgendaModalFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AgendaModalFilter>>>;
  bodyText?: InputMaybe<CfContentTypeRichTextNestedFilter>;
  bodyText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headlineHeading?: InputMaybe<Scalars['String']['input']>;
  headlineHeading_contains?: InputMaybe<Scalars['String']['input']>;
  headlineHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headlineHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headlineHeading_not?: InputMaybe<Scalars['String']['input']>;
  headlineHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  headlineHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headlineText?: InputMaybe<Scalars['String']['input']>;
  headlineText_contains?: InputMaybe<Scalars['String']['input']>;
  headlineText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headlineText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headlineText_not?: InputMaybe<Scalars['String']['input']>;
  headlineText_not_contains?: InputMaybe<Scalars['String']['input']>;
  headlineText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modalName?: InputMaybe<Scalars['String']['input']>;
  modalName_contains?: InputMaybe<Scalars['String']['input']>;
  modalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modalName_not?: InputMaybe<Scalars['String']['input']>;
  modalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  modalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type AgendaModalLinkingCollections = {
  __typename?: 'AgendaModalLinkingCollections';
  agendaStepperCollection?: Maybe<AgendaStepperCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type AgendaModalLinkingCollectionsAgendaStepperCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgendaModalLinkingCollectionsAgendaStepperCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AgendaModalLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type AgendaModalLinkingCollectionsAgendaStepperCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'areStepsCenteredForMobile_ASC'
  | 'areStepsCenteredForMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'hideStepperDot_ASC'
  | 'hideStepperDot_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isHighlightedSteps_ASC'
  | 'isHighlightedSteps_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useNumericStepper_ASC'
  | 'useNumericStepper_DESC';

export type AgendaModalOrder =
  | 'headlineHeading_ASC'
  | 'headlineHeading_DESC'
  | 'headlineText_ASC'
  | 'headlineText_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'modalName_ASC'
  | 'modalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepper = Entry & _Node & {
  __typename?: 'AgendaStepper';
  _id: Scalars['ID']['output'];
  analyticsContext?: Maybe<AnalyticsContext>;
  anchorId?: Maybe<Scalars['String']['output']>;
  areStepsCenteredForMobile?: Maybe<Scalars['Boolean']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<ContentTypeRichText>;
  disablePaddingOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fullWidth?: Maybe<Scalars['Boolean']['output']>;
  hideStepperDot?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  isHighlightedSteps?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<AgendaStepperLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  stepsCollection?: Maybe<AgendaStepperStepsCollection>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  titleHtag?: Maybe<Scalars['String']['output']>;
  useNumericStepper?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperAnalyticsContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperAreStepsCenteredForMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperDisablePaddingOnArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperFullWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperHideStepperDotArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperIsHighlightedStepsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperStepsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgendaStepperStepsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AgendaModalFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperUseNumericStepperArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type AgendaStepperCollection = {
  __typename?: 'AgendaStepperCollection';
  items: Array<Maybe<AgendaStepper>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AgendaStepperFilter = {
  AND?: InputMaybe<Array<InputMaybe<AgendaStepperFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AgendaStepperFilter>>>;
  analyticsContext?: InputMaybe<CfAnalyticsContextNestedFilter>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  areStepsCenteredForMobile?: InputMaybe<Scalars['Boolean']['input']>;
  areStepsCenteredForMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  areStepsCenteredForMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<CfContentTypeRichTextNestedFilter>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideStepperDot?: InputMaybe<Scalars['Boolean']['input']>;
  hideStepperDot_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideStepperDot_not?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isHighlightedSteps?: InputMaybe<Scalars['Boolean']['input']>;
  isHighlightedSteps_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isHighlightedSteps_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steps?: InputMaybe<CfAgendaModalNestedFilter>;
  stepsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  useNumericStepper?: InputMaybe<Scalars['Boolean']['input']>;
  useNumericStepper_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useNumericStepper_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgendaStepperLinkingCollections = {
  __typename?: 'AgendaStepperLinkingCollections';
  accordionsCollection?: Maybe<AccordionsCollection>;
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type AgendaStepperLinkingCollectionsAccordionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgendaStepperLinkingCollectionsAccordionsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AgendaStepperLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AgendaStepperLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgendaStepperLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type AgendaStepperLinkingCollectionsAccordionsCollectionOrder =
  | 'accordionsHeading_ASC'
  | 'accordionsHeading_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonCollectionAlignment_ASC'
  | 'buttonCollectionAlignment_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'descriptionAlignment_ASC'
  | 'descriptionAlignment_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'expandIconPosition_ASC'
  | 'expandIconPosition_DESC'
  | 'expandIconType_ASC'
  | 'expandIconType_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'imagePositionRight_ASC'
  | 'imagePositionRight_DESC'
  | 'imageRoundedCorner_ASC'
  | 'imageRoundedCorner_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'roundedCornersSize_ASC'
  | 'roundedCornersSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleAlignment_ASC'
  | 'titleAlignment_DESC'
  | 'titleColor_ASC'
  | 'titleColor_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'withInnerGap_ASC'
  | 'withInnerGap_DESC';

export type AgendaStepperLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AgendaStepperOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'areStepsCenteredForMobile_ASC'
  | 'areStepsCenteredForMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'hideStepperDot_ASC'
  | 'hideStepperDot_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isHighlightedSteps_ASC'
  | 'isHighlightedSteps_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useNumericStepper_ASC'
  | 'useNumericStepper_DESC';

export type AgendaStepperStepsCollection = {
  __typename?: 'AgendaStepperStepsCollection';
  items: Array<Maybe<AgendaModal>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AgendaStepperStepsCollectionOrder =
  | 'headlineHeading_ASC'
  | 'headlineHeading_DESC'
  | 'headlineText_ASC'
  | 'headlineText_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'modalName_ASC'
  | 'modalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContext = Entry & _Node & {
  __typename?: 'AnalyticsContext';
  _id: Scalars['ID']['output'];
  appointmentSelectedFacilityId?: Maybe<Scalars['String']['output']>;
  appointmentSelectedFacilityName?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  clickName?: Maybe<Scalars['String']['output']>;
  clickPosition?: Maybe<Scalars['String']['output']>;
  clickType?: Maybe<Scalars['String']['output']>;
  componentName?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  errorDetails?: Maybe<Scalars['String']['output']>;
  errorStatus?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Scalars['String']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  linkText?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<AnalyticsContextLinkingCollections>;
  navigationType?: Maybe<Scalars['String']['output']>;
  pageName?: Maybe<Scalars['String']['output']>;
  pageUrl?: Maybe<Scalars['String']['output']>;
  siteSection?: Maybe<Scalars['String']['output']>;
  socialMediaName?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  virtualPageTitle?: Maybe<Scalars['String']['output']>;
  virtualPageUrl?: Maybe<Scalars['String']['output']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextAppointmentSelectedFacilityIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextAppointmentSelectedFacilityNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextBrandArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextClickNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextClickPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextClickTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextComponentNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextErrorDetailsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextErrorStatusArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextErrorTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextEventArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextEventNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextLinkTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextLinkUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextNavigationTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextPageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextPageUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextSiteSectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextSocialMediaNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextVirtualPageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextVirtualPageUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsContextCollection = {
  __typename?: 'AnalyticsContextCollection';
  items: Array<Maybe<AnalyticsContext>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AnalyticsContextFilter = {
  AND?: InputMaybe<Array<InputMaybe<AnalyticsContextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AnalyticsContextFilter>>>;
  appointmentSelectedFacilityId?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityId_contains?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentSelectedFacilityId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appointmentSelectedFacilityId_not?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityId_not_contains?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appointmentSelectedFacilityName?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityName_contains?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentSelectedFacilityName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appointmentSelectedFacilityName_not?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityName_not_contains?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  brand_contains?: InputMaybe<Scalars['String']['input']>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brand_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brand_not?: InputMaybe<Scalars['String']['input']>;
  brand_not_contains?: InputMaybe<Scalars['String']['input']>;
  brand_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickName?: InputMaybe<Scalars['String']['input']>;
  clickName_contains?: InputMaybe<Scalars['String']['input']>;
  clickName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  clickName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickName_not?: InputMaybe<Scalars['String']['input']>;
  clickName_not_contains?: InputMaybe<Scalars['String']['input']>;
  clickName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickPosition?: InputMaybe<Scalars['String']['input']>;
  clickPosition_contains?: InputMaybe<Scalars['String']['input']>;
  clickPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  clickPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickPosition_not?: InputMaybe<Scalars['String']['input']>;
  clickPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  clickPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickType?: InputMaybe<Scalars['String']['input']>;
  clickType_contains?: InputMaybe<Scalars['String']['input']>;
  clickType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  clickType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickType_not?: InputMaybe<Scalars['String']['input']>;
  clickType_not_contains?: InputMaybe<Scalars['String']['input']>;
  clickType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentName?: InputMaybe<Scalars['String']['input']>;
  componentName_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentName_not?: InputMaybe<Scalars['String']['input']>;
  componentName_not_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  errorDetails?: InputMaybe<Scalars['String']['input']>;
  errorDetails_contains?: InputMaybe<Scalars['String']['input']>;
  errorDetails_exists?: InputMaybe<Scalars['Boolean']['input']>;
  errorDetails_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorDetails_not?: InputMaybe<Scalars['String']['input']>;
  errorDetails_not_contains?: InputMaybe<Scalars['String']['input']>;
  errorDetails_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorStatus?: InputMaybe<Scalars['String']['input']>;
  errorStatus_contains?: InputMaybe<Scalars['String']['input']>;
  errorStatus_exists?: InputMaybe<Scalars['Boolean']['input']>;
  errorStatus_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorStatus_not?: InputMaybe<Scalars['String']['input']>;
  errorStatus_not_contains?: InputMaybe<Scalars['String']['input']>;
  errorStatus_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorType?: InputMaybe<Scalars['String']['input']>;
  errorType_contains?: InputMaybe<Scalars['String']['input']>;
  errorType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  errorType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorType_not?: InputMaybe<Scalars['String']['input']>;
  errorType_not_contains?: InputMaybe<Scalars['String']['input']>;
  errorType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  event?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  eventName_contains?: InputMaybe<Scalars['String']['input']>;
  eventName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eventName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventName_not?: InputMaybe<Scalars['String']['input']>;
  eventName_not_contains?: InputMaybe<Scalars['String']['input']>;
  eventName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  event_contains?: InputMaybe<Scalars['String']['input']>;
  event_exists?: InputMaybe<Scalars['Boolean']['input']>;
  event_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  event_not?: InputMaybe<Scalars['String']['input']>;
  event_not_contains?: InputMaybe<Scalars['String']['input']>;
  event_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  linkText_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText_not?: InputMaybe<Scalars['String']['input']>;
  linkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  linkUrl_contains?: InputMaybe<Scalars['String']['input']>;
  linkUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkUrl_not?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationType?: InputMaybe<Scalars['String']['input']>;
  navigationType_contains?: InputMaybe<Scalars['String']['input']>;
  navigationType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  navigationType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationType_not?: InputMaybe<Scalars['String']['input']>;
  navigationType_not_contains?: InputMaybe<Scalars['String']['input']>;
  navigationType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageName?: InputMaybe<Scalars['String']['input']>;
  pageName_contains?: InputMaybe<Scalars['String']['input']>;
  pageName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageName_not?: InputMaybe<Scalars['String']['input']>;
  pageName_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageUrl?: InputMaybe<Scalars['String']['input']>;
  pageUrl_contains?: InputMaybe<Scalars['String']['input']>;
  pageUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageUrl_not?: InputMaybe<Scalars['String']['input']>;
  pageUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteSection?: InputMaybe<Scalars['String']['input']>;
  siteSection_contains?: InputMaybe<Scalars['String']['input']>;
  siteSection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  siteSection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteSection_not?: InputMaybe<Scalars['String']['input']>;
  siteSection_not_contains?: InputMaybe<Scalars['String']['input']>;
  siteSection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialMediaName?: InputMaybe<Scalars['String']['input']>;
  socialMediaName_contains?: InputMaybe<Scalars['String']['input']>;
  socialMediaName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialMediaName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialMediaName_not?: InputMaybe<Scalars['String']['input']>;
  socialMediaName_not_contains?: InputMaybe<Scalars['String']['input']>;
  socialMediaName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  virtualPageTitle?: InputMaybe<Scalars['String']['input']>;
  virtualPageTitle_contains?: InputMaybe<Scalars['String']['input']>;
  virtualPageTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  virtualPageTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  virtualPageTitle_not?: InputMaybe<Scalars['String']['input']>;
  virtualPageTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  virtualPageTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  virtualPageUrl?: InputMaybe<Scalars['String']['input']>;
  virtualPageUrl_contains?: InputMaybe<Scalars['String']['input']>;
  virtualPageUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  virtualPageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  virtualPageUrl_not?: InputMaybe<Scalars['String']['input']>;
  virtualPageUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  virtualPageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AnalyticsContextLinkingCollections = {
  __typename?: 'AnalyticsContextLinkingCollections';
  agendaStepperCollection?: Maybe<AgendaStepperCollection>;
  buttonCollection?: Maybe<ButtonCollection>;
  cardCollection?: Maybe<CardCollection>;
  categoryCollection?: Maybe<CategoryCollection>;
  contentTypeRichTextCollection?: Maybe<ContentTypeRichTextCollection>;
  entryCollection?: Maybe<EntryCollection>;
  error404Collection?: Maybe<Error404Collection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  medicalServiceCollection?: Maybe<MedicalServiceCollection>;
  navigationLinkCollection?: Maybe<NavigationLinkCollection>;
  pageCollection?: Maybe<PageCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
};


export type AnalyticsContextLinkingCollectionsAgendaStepperCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsAgendaStepperCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsContextLinkingCollectionsButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsButtonCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsContextLinkingCollectionsCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsContextLinkingCollectionsCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsCategoryCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsContextLinkingCollectionsContentTypeRichTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsContentTypeRichTextCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsContextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsContextLinkingCollectionsError404CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsError404CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsContextLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsContextLinkingCollectionsMedicalServiceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsMedicalServiceCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsContextLinkingCollectionsNavigationLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsNavigationLinkCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsContextLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AnalyticsContextLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type AnalyticsContextLinkingCollectionsAgendaStepperCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'areStepsCenteredForMobile_ASC'
  | 'areStepsCenteredForMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'hideStepperDot_ASC'
  | 'hideStepperDot_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isHighlightedSteps_ASC'
  | 'isHighlightedSteps_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useNumericStepper_ASC'
  | 'useNumericStepper_DESC';

export type AnalyticsContextLinkingCollectionsButtonCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type AnalyticsContextLinkingCollectionsCardCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonIconPosition_ASC'
  | 'buttonIconPosition_DESC'
  | 'buttonIconSize_ASC'
  | 'buttonIconSize_DESC'
  | 'buttonIcon_ASC'
  | 'buttonIcon_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'buttonVariant_ASC'
  | 'buttonVariant_DESC'
  | 'cardIconAlignment_ASC'
  | 'cardIconAlignment_DESC'
  | 'cardIcon_ASC'
  | 'cardIcon_DESC'
  | 'cardTextAlignment_ASC'
  | 'cardTextAlignment_DESC'
  | 'eventType_ASC'
  | 'eventType_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRatio_ASC'
  | 'imageRatio_DESC'
  | 'imageUrl_ASC'
  | 'imageUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pdfDownloadTitle_ASC'
  | 'pdfDownloadTitle_DESC'
  | 'priority_ASC'
  | 'priority_DESC'
  | 'showBorder_ASC'
  | 'showBorder_DESC'
  | 'slot_ASC'
  | 'slot_DESC'
  | 'stepName_ASC'
  | 'stepName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tcText_ASC'
  | 'tcText_DESC'
  | 'tcUrl_ASC'
  | 'tcUrl_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AnalyticsContextLinkingCollectionsCategoryCollectionOrder =
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'link_ASC'
  | 'link_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AnalyticsContextLinkingCollectionsContentTypeRichTextCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'titleIcon_ASC'
  | 'titleIcon_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AnalyticsContextLinkingCollectionsError404CollectionOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'heading_ASC'
  | 'heading_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subtitle_ASC'
  | 'subtitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AnalyticsContextLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AnalyticsContextLinkingCollectionsMedicalServiceCollectionOrder =
  | 'iconName_ASC'
  | 'iconName_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AnalyticsContextLinkingCollectionsNavigationLinkCollectionOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AnalyticsContextLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AnalyticsContextLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AnalyticsContextOrder =
  | 'appointmentSelectedFacilityId_ASC'
  | 'appointmentSelectedFacilityId_DESC'
  | 'appointmentSelectedFacilityName_ASC'
  | 'appointmentSelectedFacilityName_DESC'
  | 'brand_ASC'
  | 'brand_DESC'
  | 'clickName_ASC'
  | 'clickName_DESC'
  | 'clickPosition_ASC'
  | 'clickPosition_DESC'
  | 'clickType_ASC'
  | 'clickType_DESC'
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'errorDetails_ASC'
  | 'errorDetails_DESC'
  | 'errorStatus_ASC'
  | 'errorStatus_DESC'
  | 'errorType_ASC'
  | 'errorType_DESC'
  | 'eventName_ASC'
  | 'eventName_DESC'
  | 'event_ASC'
  | 'event_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'linkUrl_ASC'
  | 'linkUrl_DESC'
  | 'navigationType_ASC'
  | 'navigationType_DESC'
  | 'pageName_ASC'
  | 'pageName_DESC'
  | 'pageUrl_ASC'
  | 'pageUrl_DESC'
  | 'siteSection_ASC'
  | 'siteSection_DESC'
  | 'socialMediaName_ASC'
  | 'socialMediaName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'virtualPageTitle_ASC'
  | 'virtualPageTitle_DESC'
  | 'virtualPageUrl_ASC'
  | 'virtualPageUrl_DESC';

export type AnsweredQuestionnaireQuestionInput = {
  answer: QuestionnaireAnswerInput;
  questionId: Scalars['NonEmptyString']['input'];
};

/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type App = Entry & _Node & {
  __typename?: 'App';
  _id: Scalars['ID']['output'];
  brandImageLink?: Maybe<Scalars['String']['output']>;
  branding?: Maybe<Scalars['String']['output']>;
  breadcrumbsPosition?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  config?: Maybe<Scalars['JSON']['output']>;
  contentfulMetadata: ContentfulMetadata;
  featureFlags?: Maybe<FeatureFlags>;
  footer?: Maybe<AdFooter>;
  header?: Maybe<Header>;
  isDeprecated?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<AppLinkingCollections>;
  logo?: Maybe<Asset>;
  logoMobile?: Maybe<Asset>;
  name?: Maybe<Scalars['String']['output']>;
  notFoundPage?: Maybe<Error404>;
  sys: Sys;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppBrandImageLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppBrandingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppBreadcrumbsPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppConfigArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppFeatureFlagsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FeatureFlagsFilter>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppFooterArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AdFooterFilter>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppHeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderFilter>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppIsDeprecatedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppLogoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppLogoMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppNotFoundPageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Error404Filter>;
};

export type AppCollection = {
  __typename?: 'AppCollection';
  items: Array<Maybe<App>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AppFilter = {
  AND?: InputMaybe<Array<InputMaybe<AppFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AppFilter>>>;
  brandImageLink?: InputMaybe<Scalars['String']['input']>;
  brandImageLink_contains?: InputMaybe<Scalars['String']['input']>;
  brandImageLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brandImageLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandImageLink_not?: InputMaybe<Scalars['String']['input']>;
  brandImageLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  brandImageLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  branding?: InputMaybe<Scalars['String']['input']>;
  branding_contains?: InputMaybe<Scalars['String']['input']>;
  branding_exists?: InputMaybe<Scalars['Boolean']['input']>;
  branding_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  branding_not?: InputMaybe<Scalars['String']['input']>;
  branding_not_contains?: InputMaybe<Scalars['String']['input']>;
  branding_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  breadcrumbsPosition_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  breadcrumbsPosition_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  breadcrumbsPosition_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  breadcrumbsPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  config_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  featureFlags?: InputMaybe<CfFeatureFlagsNestedFilter>;
  featureFlags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  footer?: InputMaybe<CfAdFooterNestedFilter>;
  footer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  header?: InputMaybe<CfHeaderNestedFilter>;
  header_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  isDeprecated_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isDeprecated_not?: InputMaybe<Scalars['Boolean']['input']>;
  logoMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notFoundPage?: InputMaybe<CfError404NestedFilter>;
  notFoundPage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type AppLinkingCollections = {
  __typename?: 'AppLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type AppLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type AppOrder =
  | 'brandImageLink_ASC'
  | 'brandImageLink_DESC'
  | 'branding_ASC'
  | 'branding_DESC'
  | 'isDeprecated_ASC'
  | 'isDeprecated_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ApplyPolicy =
  | 'AFTER_RESOLVER'
  | 'BEFORE_RESOLVER'
  | 'VALIDATION';

/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPage = Entry & _Node & {
  __typename?: 'AppointmentBookingPage';
  _id: Scalars['ID']['output'];
  bottomContentCollection?: Maybe<AppointmentBookingPageBottomContentCollection>;
  brand?: Maybe<Brand>;
  canonical?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  featuredContent?: Maybe<SingleMessage>;
  indexed?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<AppointmentBookingPageLinkingCollections>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  theme?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageBottomContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppointmentBookingPageBottomContentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryPickerFilter>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageBrandArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandFilter>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageCanonicalArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageFeaturedContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SingleMessageFilter>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageIndexedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageMetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPagePathArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageThemeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type AppointmentBookingPageBottomContentCollection = {
  __typename?: 'AppointmentBookingPageBottomContentCollection';
  items: Array<Maybe<CategoryPicker>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AppointmentBookingPageBottomContentCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'eyebrowHeading_ASC'
  | 'eyebrowHeading_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'mobileThreshold_ASC'
  | 'mobileThreshold_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'setTwoRows_ASC'
  | 'setTwoRows_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'transparentCategories_ASC'
  | 'transparentCategories_DESC';

export type AppointmentBookingPageCollection = {
  __typename?: 'AppointmentBookingPageCollection';
  items: Array<Maybe<AppointmentBookingPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AppointmentBookingPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<AppointmentBookingPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AppointmentBookingPageFilter>>>;
  bottomContent?: InputMaybe<CfCategoryPickerNestedFilter>;
  bottomContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<CfBrandNestedFilter>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical?: InputMaybe<Scalars['String']['input']>;
  canonical_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonical_not?: InputMaybe<Scalars['String']['input']>;
  canonical_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  featuredContent?: InputMaybe<CfSingleMessageNestedFilter>;
  featuredContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_not?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path?: InputMaybe<Scalars['String']['input']>;
  path_contains?: InputMaybe<Scalars['String']['input']>;
  path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_not?: InputMaybe<Scalars['String']['input']>;
  path_not_contains?: InputMaybe<Scalars['String']['input']>;
  path_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  theme?: InputMaybe<Scalars['String']['input']>;
  theme_contains?: InputMaybe<Scalars['String']['input']>;
  theme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  theme_not?: InputMaybe<Scalars['String']['input']>;
  theme_not_contains?: InputMaybe<Scalars['String']['input']>;
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AppointmentBookingPageLinkingCollections = {
  __typename?: 'AppointmentBookingPageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type AppointmentBookingPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type AppointmentBookingPageOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** Represents a binary file in a space. An asset can be any file type. */
export type Asset = {
  __typename?: 'Asset';
  contentType?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  linkedFrom?: Maybe<AssetLinkingCollections>;
  size?: Maybe<Scalars['Int']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetContentTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetFileNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetHeightArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  transform?: InputMaybe<ImageTransformOptions>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type AssetCollection = {
  __typename?: 'AssetCollection';
  items: Array<Maybe<Asset>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AssetFilter = {
  AND?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  contentType_contains?: InputMaybe<Scalars['String']['input']>;
  contentType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentType_not?: InputMaybe<Scalars['String']['input']>;
  contentType_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileName_contains?: InputMaybe<Scalars['String']['input']>;
  fileName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName_not?: InputMaybe<Scalars['String']['input']>;
  fileName_not_contains?: InputMaybe<Scalars['String']['input']>;
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height?: InputMaybe<Scalars['Int']['input']>;
  height_exists?: InputMaybe<Scalars['Boolean']['input']>;
  height_gt?: InputMaybe<Scalars['Int']['input']>;
  height_gte?: InputMaybe<Scalars['Int']['input']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  height_lt?: InputMaybe<Scalars['Int']['input']>;
  height_lte?: InputMaybe<Scalars['Int']['input']>;
  height_not?: InputMaybe<Scalars['Int']['input']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_gt?: InputMaybe<Scalars['Int']['input']>;
  size_gte?: InputMaybe<Scalars['Int']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size_lt?: InputMaybe<Scalars['Int']['input']>;
  size_lte?: InputMaybe<Scalars['Int']['input']>;
  size_not?: InputMaybe<Scalars['Int']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  width?: InputMaybe<Scalars['Int']['input']>;
  width_exists?: InputMaybe<Scalars['Boolean']['input']>;
  width_gt?: InputMaybe<Scalars['Int']['input']>;
  width_gte?: InputMaybe<Scalars['Int']['input']>;
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  width_lt?: InputMaybe<Scalars['Int']['input']>;
  width_lte?: InputMaybe<Scalars['Int']['input']>;
  width_not?: InputMaybe<Scalars['Int']['input']>;
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AssetLinkingCollections = {
  __typename?: 'AssetLinkingCollections';
  accordionsCollection?: Maybe<AccordionsCollection>;
  adFooterCollection?: Maybe<AdFooterCollection>;
  appCollection?: Maybe<AppCollection>;
  cardCollection?: Maybe<CardCollection>;
  entryCollection?: Maybe<EntryCollection>;
  error404Collection?: Maybe<Error404Collection>;
  focalPointImageCollection?: Maybe<FocalPointImageCollection>;
  formFieldCollection?: Maybe<FormFieldCollection>;
  googleMapTemplateCollection?: Maybe<GoogleMapTemplateCollection>;
  halfScreenCollection?: Maybe<HalfScreenCollection>;
  heroV2Collection?: Maybe<HeroV2Collection>;
  navigationLinkCollection?: Maybe<NavigationLinkCollection>;
  pageCollection?: Maybe<PageCollection>;
  patientReviewV2Collection?: Maybe<PatientReviewV2Collection>;
  serviceCollection?: Maybe<ServiceCollection>;
  smallScreenContentCollection?: Maybe<SmallScreenContentCollection>;
  successCardCollection?: Maybe<SuccessCardCollection>;
  videoCollection?: Maybe<VideoCollection>;
};


export type AssetLinkingCollectionsAccordionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsAdFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsAppCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsError404CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsFocalPointImageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsFormFieldCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsGoogleMapTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsHalfScreenCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsHeroV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsNavigationLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsPatientReviewV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsServiceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsSmallScreenContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsSuccessCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetLinkingCollectionsVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type AssetOrder =
  | 'contentType_ASC'
  | 'contentType_DESC'
  | 'fileName_ASC'
  | 'fileName_DESC'
  | 'height_ASC'
  | 'height_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'width_ASC'
  | 'width_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/badge) */
export type Badge = Entry & _Node & {
  __typename?: 'Badge';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BadgeLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  variant?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/badge) */
export type BadgeLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/badge) */
export type BadgeLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/badge) */
export type BadgeNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/badge) */
export type BadgeVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type BadgeCollection = {
  __typename?: 'BadgeCollection';
  items: Array<Maybe<Badge>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BadgeFilter = {
  AND?: InputMaybe<Array<InputMaybe<BadgeFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BadgeFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BadgeLinkingCollections = {
  __typename?: 'BadgeLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  mediaSliderCollection?: Maybe<MediaSliderCollection>;
};


export type BadgeLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BadgeLinkingCollectionsMediaSliderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BadgeLinkingCollectionsMediaSliderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type BadgeLinkingCollectionsMediaSliderCollectionOrder =
  | 'aspectRatio_ASC'
  | 'aspectRatio_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type BadgeOrder =
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

/** This content type is used to create Banners across website. Like Alert Banner at the Top or Bottom of the Header or any promo banner anywhere in the page etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/banner) */
export type Banner = Entry & _Node & {
  __typename?: 'Banner';
  _id: Scalars['ID']['output'];
  alertMessagesCollection?: Maybe<BannerAlertMessagesCollection>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BannerLinkingCollections>;
  mobileAlertMessagesCollection?: Maybe<BannerMobileAlertMessagesCollection>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  variant?: Maybe<Scalars['String']['output']>;
};


/** This content type is used to create Banners across website. Like Alert Banner at the Top or Bottom of the Header or any promo banner anywhere in the page etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/banner) */
export type BannerAlertMessagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BannerAlertMessagesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** This content type is used to create Banners across website. Like Alert Banner at the Top or Bottom of the Header or any promo banner anywhere in the page etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/banner) */
export type BannerLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** This content type is used to create Banners across website. Like Alert Banner at the Top or Bottom of the Header or any promo banner anywhere in the page etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/banner) */
export type BannerMobileAlertMessagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BannerMobileAlertMessagesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** This content type is used to create Banners across website. Like Alert Banner at the Top or Bottom of the Header or any promo banner anywhere in the page etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/banner) */
export type BannerNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This content type is used to create Banners across website. Like Alert Banner at the Top or Bottom of the Header or any promo banner anywhere in the page etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/banner) */
export type BannerVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type BannerAlertMessagesCollection = {
  __typename?: 'BannerAlertMessagesCollection';
  items: Array<Maybe<ContentTypeRichText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BannerAlertMessagesCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'titleIcon_ASC'
  | 'titleIcon_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BannerCollection = {
  __typename?: 'BannerCollection';
  items: Array<Maybe<Banner>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BannerFilter = {
  AND?: InputMaybe<Array<InputMaybe<BannerFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BannerFilter>>>;
  alertMessages?: InputMaybe<CfContentTypeRichTextNestedFilter>;
  alertMessagesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  mobileAlertMessages?: InputMaybe<CfContentTypeRichTextNestedFilter>;
  mobileAlertMessagesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BannerLinkingCollections = {
  __typename?: 'BannerLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  headerCollection?: Maybe<HeaderCollection>;
};


export type BannerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BannerLinkingCollectionsHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BannerLinkingCollectionsHeaderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type BannerLinkingCollectionsHeaderCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC';

export type BannerMobileAlertMessagesCollection = {
  __typename?: 'BannerMobileAlertMessagesCollection';
  items: Array<Maybe<ContentTypeRichText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BannerMobileAlertMessagesCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'titleIcon_ASC'
  | 'titleIcon_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BannerOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type BffAdditionalInfo = {
  __typename?: 'BffAdditionalInfo';
  available_categories?: Maybe<Scalars['String']['output']>;
  available_services?: Maybe<Scalars['String']['output']>;
  can_book?: Maybe<Scalars['Boolean']['output']>;
  cancellation_fee_duration?: Maybe<Scalars['Int']['output']>;
  categories_available?: Maybe<Scalars['Boolean']['output']>;
  center_amenities?: Maybe<Scalars['String']['output']>;
  collect_feedback?: Maybe<Scalars['String']['output']>;
  cst?: Maybe<Scalars['String']['output']>;
  feedback_label?: Maybe<Scalars['String']['output']>;
  feedback_link?: Maybe<Scalars['String']['output']>;
  is_add_ons_available?: Maybe<Scalars['Boolean']['output']>;
  is_auto_pay_enabled_at_center?: Maybe<Scalars['Boolean']['output']>;
  is_center_amenities_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_global_tokenization_supported?: Maybe<Scalars['Boolean']['output']>;
  service_tax_no?: Maybe<Scalars['String']['output']>;
  services_available?: Maybe<Scalars['Boolean']['output']>;
  tin?: Maybe<Scalars['String']['output']>;
  unavailable_categories?: Maybe<Scalars['String']['output']>;
  unavailable_services?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['String']['output']>;
};

export type BffAddress = {
  __typename?: 'BffAddress';
  address_1?: Maybe<Scalars['String']['output']>;
  address_2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

export type BffBrand = {
  __typename?: 'BffBrand';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<BffBrandType>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BffBrandType =
  | 'ASPEN_DENTAL'
  | 'AZ_PET'
  | 'CHAPTER'
  | 'CLEAR_CHOICE'
  | 'LOVET'
  | 'WELL_NOW';

export type BffCacheLineStats = {
  __typename?: 'BffCacheLineStats';
  cachedAt?: Maybe<Scalars['String']['output']>;
  expires?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  secTTL?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['String']['output']>;
};

export type BffCacheStats = {
  __typename?: 'BffCacheStats';
  expires?: Maybe<Scalars['String']['output']>;
  hits?: Maybe<Scalars['Float']['output']>;
  keys?: Maybe<Scalars['Float']['output']>;
  keysSize?: Maybe<Scalars['Float']['output']>;
  misses?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  now?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  valuesSize?: Maybe<Scalars['Float']['output']>;
};

export type BffCenter = {
  __typename?: 'BffCenter';
  additional_info?: Maybe<BffAdditionalInfo>;
  address_info?: Maybe<BffAddress>;
  code?: Maybe<Scalars['String']['output']>;
  contact_info?: Maybe<BffContactInfo>;
  country?: Maybe<BffCountry>;
  culture_code_at_center?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<BffCurrency>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  enable_parallel_services_at_center?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  is_fbe_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_hc_call_center?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<BffLocation>;
  name?: Maybe<Scalars['String']['output']>;
  online_booking_start_date?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<Scalars['String']['output']>;
  state?: Maybe<BffState>;
  working_hours?: Maybe<Array<Maybe<BffWorkinghours>>>;
};

export type BffCenters = {
  __typename?: 'BffCenters';
  centers?: Maybe<Array<Maybe<BffCenter>>>;
  error?: Maybe<Scalars['String']['output']>;
};

export type BffCertifications = {
  __typename?: 'BffCertifications';
  certification?: Maybe<Scalars['String']['output']>;
  certificationCountry?: Maybe<Scalars['String']['output']>;
  certificationName?: Maybe<Scalars['String']['output']>;
  certifierOrIssuer?: Maybe<Scalars['String']['output']>;
  issuedDate?: Maybe<Scalars['String']['output']>;
};

export type BffCity = {
  __typename?: 'BffCity';
  city?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  slugXml?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateAbbreviation?: Maybe<Scalars['String']['output']>;
};

export type BffClient = {
  __typename?: 'BffClient';
  addresses?: Maybe<Array<Maybe<BffClientAddress>>>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BffClientAddress = {
  __typename?: 'BffClientAddress';
  city?: Maybe<Scalars['String']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type BffClientList = {
  __typename?: 'BffClientList';
  clients?: Maybe<Array<Maybe<BffClient>>>;
  errors?: Maybe<Array<Maybe<BffError>>>;
};

export type BffContactInfo = {
  __typename?: 'BffContactInfo';
  email?: Maybe<Scalars['String']['output']>;
  phone_1?: Maybe<BffPhoneNumber>;
  phone_2?: Maybe<BffPhoneNumber>;
};

export type BffCountry = {
  __typename?: 'BffCountry';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  phone_code?: Maybe<Scalars['Int']['output']>;
};

export type BffCredentials = {
  __typename?: 'BffCredentials';
  collegeName?: Maybe<Scalars['String']['output']>;
  collegeState?: Maybe<Scalars['String']['output']>;
  degreeName?: Maybe<Scalars['String']['output']>;
  graduationDate?: Maybe<Scalars['String']['output']>;
};

export type BffCurrency = {
  __typename?: 'BffCurrency';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
};

export type BffDamAsset = {
  __typename?: 'BffDamAsset';
  height?: Maybe<Scalars['Int']['output']>;
  mimetype?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type BffError = {
  __typename?: 'BffError';
  message?: Maybe<Scalars['String']['output']>;
};

/**
 * An office facility
 * Brick and Mortar part of **business** [API](http://example.com)!
 */
export type BffFacility = {
  __typename?: 'BffFacility';
  address?: Maybe<BffFacilityAddress>;
  anytimeAppointingDenture?: Maybe<Scalars['Boolean']['output']>;
  anytimeAppointingMotto?: Maybe<Scalars['Boolean']['output']>;
  attributes?: Maybe<Array<Maybe<NamedAttribute>>>;
  bilingual?: Maybe<Scalars['Boolean']['output']>;
  birdeyeBusinessId?: Maybe<Scalars['String']['output']>;
  /** Brand where the data is from */
  brand?: Maybe<Scalars['String']['output']>;
  clockwiseId?: Maybe<Scalars['String']['output']>;
  /** Facility Code or Id */
  code: Scalars['String']['output'];
  comingSoon?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dma?: Maybe<Scalars['String']['output']>;
  dnis?: Maybe<Scalars['String']['output']>;
  doctors?: Maybe<Array<Maybe<BffProvider>>>;
  email?: Maybe<Scalars['String']['output']>;
  emergencyPhoneNumber?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  firstThreeOctets?: Maybe<Scalars['String']['output']>;
  geomodifier?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  implants?: Maybe<Scalars['String']['output']>;
  insurance?: Maybe<Array<Maybe<BffInsurance>>>;
  insuranceNetwork?: Maybe<Array<Maybe<BffInsurance>>>;
  landmarks?: Maybe<Scalars['String']['output']>;
  legalBillingName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<BffFacilityLocation>;
  minimumPatientAge?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  needsBasedQuestions?: Maybe<Scalars['Boolean']['output']>;
  neighboringAreas?: Maybe<Scalars['String']['output']>;
  onHVP?: Maybe<Scalars['Boolean']['output']>;
  onMotto?: Maybe<Scalars['Boolean']['output']>;
  onP3?: Maybe<Scalars['Boolean']['output']>;
  openDate?: Maybe<Scalars['String']['output']>;
  originalBrand?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pilot1?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  revspringAccountId?: Maybe<Scalars['String']['output']>;
  revspringLocationValue?: Maybe<Scalars['String']['output']>;
  scheduleAppointmentURL?: Maybe<Scalars['String']['output']>;
  schedulingSystem?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<Maybe<BffService>>>;
  siteGroup?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  slugXml?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  workingHours?: Maybe<Array<Maybe<BffWorkingHours>>>;
};

export type BffFacilityAddress = {
  __typename?: 'BffFacilityAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type BffFacilityCollection = {
  __typename?: 'BffFacilityCollection';
  items?: Maybe<Array<Maybe<BffFacility>>>;
  skip?: Maybe<Scalars['Int']['output']>;
  take?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BffFacilityLocation = {
  __typename?: 'BffFacilityLocation';
  directions?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  landmarks?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  neighboringAreas?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  timezoneIANA?: Maybe<Scalars['String']['output']>;
};

export type BffFileCacheStats = {
  __typename?: 'BffFileCacheStats';
  caches?: Maybe<Array<Maybe<BffCacheLineStats>>>;
  localTime?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
};

export type BffFutureDays = {
  __typename?: 'BffFutureDays';
  Day?: Maybe<Scalars['String']['output']>;
  HolidayType?: Maybe<Scalars['String']['output']>;
  IsAvailable?: Maybe<Scalars['Boolean']['output']>;
};

export type BffInsurance = {
  __typename?: 'BffInsurance';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BffLocation = {
  __typename?: 'BffLocation';
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  time_zone?: Maybe<BffTimezone>;
};

export type BffPhoneNumber = {
  __typename?: 'BffPhoneNumber';
  country_id?: Maybe<Scalars['Int']['output']>;
  display_number?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type BffPriceInfo = {
  __typename?: 'BffPriceInfo';
  currency_id?: Maybe<Scalars['Int']['output']>;
  demand_group_id?: Maybe<Scalars['String']['output']>;
  include_tax?: Maybe<Scalars['Boolean']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  ssg?: Maybe<Scalars['Int']['output']>;
  tax_id?: Maybe<Scalars['String']['output']>;
};

export type BffProduct = {
  __typename?: 'BffProduct';
  brand: Scalars['String']['output'];
  brandfolderImageAssetUrl?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  linkText?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  procedures?: Maybe<Array<Maybe<BffProductProcedure>>>;
  subCategory?: Maybe<Scalars['String']['output']>;
  totalPrice: Scalars['Float']['output'];
};

export type BffProductProcedure = {
  __typename?: 'BffProductProcedure';
  /** The price for the procedure, it can be average if not sought by facility, or specific to the facility selected. */
  price: Scalars['Float']['output'];
  procedureCode: Scalars['String']['output'];
  procedureDescription: Scalars['String']['output'];
};

export type BffProvider = {
  __typename?: 'BffProvider';
  active?: Maybe<Scalars['Boolean']['output']>;
  associations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  biography?: Maybe<Scalars['String']['output']>;
  certifications?: Maybe<Array<Maybe<BffCertifications>>>;
  collegeCity?: Maybe<Scalars['String']['output']>;
  collegeName?: Maybe<Scalars['String']['output']>;
  collegeState?: Maybe<Scalars['String']['output']>;
  degreeName?: Maybe<Scalars['String']['output']>;
  degreeNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  educations?: Maybe<Array<Maybe<BffCredentials>>>;
  employeeId?: Maybe<Scalars['String']['output']>;
  employeeStatus?: Maybe<Scalars['String']['output']>;
  ethnicity?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  graduationDate?: Maybe<Scalars['String']['output']>;
  hireDate?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lastName?: Maybe<Scalars['String']['output']>;
  licenses?: Maybe<Array<Maybe<BffProviderLicense>>>;
  mainWorkerFunction?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  npi?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  photoUrlCollection?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerRole?: Maybe<BffProviderRole>;
  providerType?: Maybe<Scalars['String']['output']>;
  quote?: Maybe<Scalars['String']['output']>;
  socialNetworks?: Maybe<Array<Maybe<BffSocialNetworks>>>;
  specialties?: Maybe<Scalars['String']['output']>;
  stateLicense?: Maybe<Scalars['String']['output']>;
  volunteerism?: Maybe<Scalars['String']['output']>;
  workerType?: Maybe<Scalars['String']['output']>;
};

export type BffProviderCollection = {
  __typename?: 'BffProviderCollection';
  items?: Maybe<Array<Maybe<BffProvider>>>;
  skip?: Maybe<Scalars['Int']['output']>;
  take?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BffProviderLicense = {
  __typename?: 'BffProviderLicense';
  state?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type BffProviderRole = {
  __typename?: 'BffProviderRole';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BffRating = {
  __typename?: 'BffRating';
  rating?: Maybe<Scalars['Float']['output']>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
};

export type BffReview = {
  __typename?: 'BffReview';
  comments?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  reviewId?: Maybe<Scalars['String']['output']>;
  reviewTimestamp?: Maybe<Scalars['String']['output']>;
  reviewer?: Maybe<BffReviewReviewer>;
  source?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BffReviewReviewer = {
  __typename?: 'BffReviewReviewer';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type BffReviews = {
  __typename?: 'BffReviews';
  averageRating?: Maybe<Scalars['Float']['output']>;
  businessId?: Maybe<Scalars['String']['output']>;
  ratings?: Maybe<Array<Maybe<BffRating>>>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
  reviews?: Maybe<Array<Maybe<BffReview>>>;
};

export type BffService = {
  __typename?: 'BffService';
  activeFlag?: Maybe<Scalars['Boolean']['output']>;
  add_ons_info?: Maybe<Scalars['String']['output']>;
  additional_info?: Maybe<Scalars['String']['output']>;
  catalog_info?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  dentureCouponCode?: Maybe<Scalars['String']['output']>;
  dentureFee?: Maybe<Scalars['Int']['output']>;
  dentureFlag?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  finishing_services_info?: Maybe<Scalars['String']['output']>;
  formula?: Maybe<Scalars['String']['output']>;
  generalDentFee?: Maybe<Scalars['Int']['output']>;
  generalDentistryCouponCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image_paths?: Maybe<Scalars['String']['output']>;
  is_couple_service?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parallel_groups?: Maybe<Scalars['String']['output']>;
  parallel_service_groups?: Maybe<Scalars['String']['output']>;
  prerequisites_info?: Maybe<Scalars['String']['output']>;
  price_info?: Maybe<BffPriceInfo>;
  procedureCategory?: Maybe<Scalars['String']['output']>;
  procedureCode?: Maybe<Scalars['String']['output']>;
  procedureDescription?: Maybe<Scalars['String']['output']>;
  promotionalPrice?: Maybe<Scalars['Int']['output']>;
  recovery_time?: Maybe<Scalars['Int']['output']>;
  variants_info?: Maybe<Scalars['String']['output']>;
};

export type BffServices = {
  __typename?: 'BffServices';
  error?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<Maybe<BffService>>>;
};

export type BffSession = {
  __typename?: 'BffSession';
  Error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type BffSlot = {
  __typename?: 'BffSlot';
  Available?: Maybe<Scalars['Boolean']['output']>;
  Priority?: Maybe<Scalars['Int']['output']>;
  SalePrice?: Maybe<Scalars['String']['output']>;
  Time?: Maybe<Scalars['String']['output']>;
  Warnings?: Maybe<Scalars['String']['output']>;
};

export type BffSlots = {
  __typename?: 'BffSlots';
  Error?: Maybe<Scalars['String']['output']>;
  future_days?: Maybe<Array<Maybe<BffFutureDays>>>;
  next_available_day?: Maybe<Scalars['String']['output']>;
  slots?: Maybe<Array<Maybe<BffSlot>>>;
};

export type BffSocialNetworks = {
  __typename?: 'BffSocialNetworks';
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BffState = {
  __typename?: 'BffState';
  abbreviation?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  short_name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  slugXml?: Maybe<Scalars['String']['output']>;
};

export type BffTimeSpan = {
  __typename?: 'BffTimeSpan';
  /** The LocalTime scalar type is a local time string (i.e., with no associated timezone) in 24-hr HH:mm:ss. */
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type BffTimezone = {
  __typename?: 'BffTimezone';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  standard_name?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
};

export type BffUsCity = {
  __typename?: 'BffUSCity';
  centers?: Maybe<Array<Maybe<BffFacility>>>;
  city?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  slugXml?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateAbbreviation?: Maybe<Scalars['String']['output']>;
};

export type BffWorkingHours = {
  __typename?: 'BffWorkingHours';
  date?: Maybe<Scalars['String']['output']>;
  open?: Maybe<BffTimeSpan>;
};

export type BffWorkinghours = {
  __typename?: 'BffWorkinghours';
  day_of_week?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  is_closed?: Maybe<Scalars['Boolean']['output']>;
  off_peak_end_time?: Maybe<Scalars['String']['output']>;
  off_peak_start_time?: Maybe<Scalars['String']['output']>;
  offline_end_time?: Maybe<Scalars['String']['output']>;
  offline_start_time?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/birdEyeReviews) */
export type BirdEyeReviews = Entry & _Node & {
  __typename?: 'BirdEyeReviews';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  filteredReviewsMinRating?: Maybe<Scalars['String']['output']>;
  filteredReviewsTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BirdEyeReviewsLinkingCollections>;
  mediaContent?: Maybe<BirdEyeReviewsMediaContent>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  titleHeading?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/birdEyeReviews) */
export type BirdEyeReviewsAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/birdEyeReviews) */
export type BirdEyeReviewsFilteredReviewsMinRatingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/birdEyeReviews) */
export type BirdEyeReviewsFilteredReviewsTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/birdEyeReviews) */
export type BirdEyeReviewsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/birdEyeReviews) */
export type BirdEyeReviewsMediaContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BirdEyeReviewsMediaContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/birdEyeReviews) */
export type BirdEyeReviewsNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/birdEyeReviews) */
export type BirdEyeReviewsTagsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/birdEyeReviews) */
export type BirdEyeReviewsTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/birdEyeReviews) */
export type BirdEyeReviewsTitleHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type BirdEyeReviewsCollection = {
  __typename?: 'BirdEyeReviewsCollection';
  items: Array<Maybe<BirdEyeReviews>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BirdEyeReviewsFilter = {
  AND?: InputMaybe<Array<InputMaybe<BirdEyeReviewsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BirdEyeReviewsFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  filteredReviewsMinRating?: InputMaybe<Scalars['String']['input']>;
  filteredReviewsMinRating_contains?: InputMaybe<Scalars['String']['input']>;
  filteredReviewsMinRating_exists?: InputMaybe<Scalars['Boolean']['input']>;
  filteredReviewsMinRating_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filteredReviewsMinRating_not?: InputMaybe<Scalars['String']['input']>;
  filteredReviewsMinRating_not_contains?: InputMaybe<Scalars['String']['input']>;
  filteredReviewsMinRating_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filteredReviewsTitle?: InputMaybe<Scalars['String']['input']>;
  filteredReviewsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  filteredReviewsTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  filteredReviewsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filteredReviewsTitle_not?: InputMaybe<Scalars['String']['input']>;
  filteredReviewsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  filteredReviewsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaContent?: InputMaybe<CfmediaContentMultiTypeNestedFilter>;
  mediaContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHeading?: InputMaybe<Scalars['String']['input']>;
  titleHeading_contains?: InputMaybe<Scalars['String']['input']>;
  titleHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHeading_not?: InputMaybe<Scalars['String']['input']>;
  titleHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BirdEyeReviewsLinkingCollections = {
  __typename?: 'BirdEyeReviewsLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  pageCollection?: Maybe<PageCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
};


export type BirdEyeReviewsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BirdEyeReviewsLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BirdEyeReviewsLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BirdEyeReviewsLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BirdEyeReviewsLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BirdEyeReviewsLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BirdEyeReviewsLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type BirdEyeReviewsLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BirdEyeReviewsLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BirdEyeReviewsLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BirdEyeReviewsMediaContent = FocalPointImage | Video;

export type BirdEyeReviewsMediaContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<BirdEyeReviewsMediaContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BirdEyeReviewsMediaContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BirdEyeReviewsOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'filteredReviewsMinRating_ASC'
  | 'filteredReviewsMinRating_DESC'
  | 'filteredReviewsTitle_ASC'
  | 'filteredReviewsTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** The author of a blog. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogAuthor) */
export type BlogAuthor = Entry & _Node & {
  __typename?: 'BlogAuthor';
  _id: Scalars['ID']['output'];
  authorBioSummary?: Maybe<BlogAuthorAuthorBioSummary>;
  bioSummary?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  image?: Maybe<Scalars['JSON']['output']>;
  linkedFrom?: Maybe<BlogAuthorLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** The author of a blog. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogAuthor) */
export type BlogAuthorAuthorBioSummaryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** The author of a blog. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogAuthor) */
export type BlogAuthorBioSummaryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** The author of a blog. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogAuthor) */
export type BlogAuthorImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** The author of a blog. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogAuthor) */
export type BlogAuthorLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** The author of a blog. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogAuthor) */
export type BlogAuthorNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** The author of a blog. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogAuthor) */
export type BlogAuthorTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type BlogAuthorAuthorBioSummary = {
  __typename?: 'BlogAuthorAuthorBioSummary';
  json: Scalars['JSON']['output'];
  links: BlogAuthorAuthorBioSummaryLinks;
};

export type BlogAuthorAuthorBioSummaryAssets = {
  __typename?: 'BlogAuthorAuthorBioSummaryAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type BlogAuthorAuthorBioSummaryEntries = {
  __typename?: 'BlogAuthorAuthorBioSummaryEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type BlogAuthorAuthorBioSummaryLinks = {
  __typename?: 'BlogAuthorAuthorBioSummaryLinks';
  assets: BlogAuthorAuthorBioSummaryAssets;
  entries: BlogAuthorAuthorBioSummaryEntries;
  resources: BlogAuthorAuthorBioSummaryResources;
};

export type BlogAuthorAuthorBioSummaryResources = {
  __typename?: 'BlogAuthorAuthorBioSummaryResources';
  block: Array<BlogAuthorAuthorBioSummaryResourcesBlock>;
  hyperlink: Array<BlogAuthorAuthorBioSummaryResourcesHyperlink>;
  inline: Array<BlogAuthorAuthorBioSummaryResourcesInline>;
};

export type BlogAuthorAuthorBioSummaryResourcesBlock = ResourceLink & {
  __typename?: 'BlogAuthorAuthorBioSummaryResourcesBlock';
  sys: ResourceSys;
};

export type BlogAuthorAuthorBioSummaryResourcesHyperlink = ResourceLink & {
  __typename?: 'BlogAuthorAuthorBioSummaryResourcesHyperlink';
  sys: ResourceSys;
};

export type BlogAuthorAuthorBioSummaryResourcesInline = ResourceLink & {
  __typename?: 'BlogAuthorAuthorBioSummaryResourcesInline';
  sys: ResourceSys;
};

export type BlogAuthorCollection = {
  __typename?: 'BlogAuthorCollection';
  items: Array<Maybe<BlogAuthor>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogAuthorFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogAuthorFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogAuthorFilter>>>;
  authorBioSummary_contains?: InputMaybe<Scalars['String']['input']>;
  authorBioSummary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  authorBioSummary_not_contains?: InputMaybe<Scalars['String']['input']>;
  bioSummary?: InputMaybe<Scalars['String']['input']>;
  bioSummary_contains?: InputMaybe<Scalars['String']['input']>;
  bioSummary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bioSummary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bioSummary_not?: InputMaybe<Scalars['String']['input']>;
  bioSummary_not_contains?: InputMaybe<Scalars['String']['input']>;
  bioSummary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogAuthorLinkingCollections = {
  __typename?: 'BlogAuthorLinkingCollections';
  blogDetailsPageCollection?: Maybe<BlogDetailsPageCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type BlogAuthorLinkingCollectionsBlogDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogAuthorLinkingCollectionsBlogDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BlogAuthorLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogAuthorLinkingCollectionsBlogDetailsPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogAuthorOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** Blog main category [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogCategory) */
export type BlogCategory = Entry & _Node & {
  __typename?: 'BlogCategory';
  _id: Scalars['ID']['output'];
  brand?: Maybe<Brand>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlogCategoryLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** Blog main category [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogCategory) */
export type BlogCategoryBrandArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandFilter>;
};


/** Blog main category [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogCategory) */
export type BlogCategoryLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Blog main category [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogCategory) */
export type BlogCategoryNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog main category [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogCategory) */
export type BlogCategorySlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type BlogCategoryCollection = {
  __typename?: 'BlogCategoryCollection';
  items: Array<Maybe<BlogCategory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogCategoryFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogCategoryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogCategoryFilter>>>;
  brand?: InputMaybe<CfBrandNestedFilter>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BlogCategoryLinkingCollections = {
  __typename?: 'BlogCategoryLinkingCollections';
  blogDetailsPageCollection?: Maybe<BlogDetailsPageCollection>;
  blogListCollection?: Maybe<BlogListCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type BlogCategoryLinkingCollectionsBlogDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogCategoryLinkingCollectionsBlogDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BlogCategoryLinkingCollectionsBlogListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogCategoryLinkingCollectionsBlogListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BlogCategoryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogCategoryLinkingCollectionsBlogDetailsPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogCategoryLinkingCollectionsBlogListCollectionOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'cardDesignType_ASC'
  | 'cardDesignType_DESC'
  | 'countAcrossDesktop_ASC'
  | 'countAcrossDesktop_DESC'
  | 'countAcrossMobile_ASC'
  | 'countAcrossMobile_DESC'
  | 'displayType_ASC'
  | 'displayType_DESC'
  | 'hasPagination_ASC'
  | 'hasPagination_DESC'
  | 'loadMoreButtonLabel_ASC'
  | 'loadMoreButtonLabel_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogCategoryOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPage = Entry & _Node & {
  __typename?: 'BlogDetailsPage';
  _id: Scalars['ID']['output'];
  additionalContentCollection?: Maybe<BlogDetailsPageAdditionalContentCollection>;
  author?: Maybe<BlogAuthor>;
  blogImage?: Maybe<Scalars['JSON']['output']>;
  brand?: Maybe<Brand>;
  canonical?: Maybe<Scalars['String']['output']>;
  category?: Maybe<BlogCategory>;
  contentfulMetadata: ContentfulMetadata;
  date?: Maybe<Scalars['DateTime']['output']>;
  disableHeaderBottomAlertBanner?: Maybe<Scalars['Boolean']['output']>;
  disableHeaderTopAlertBanner?: Maybe<Scalars['Boolean']['output']>;
  disableStickyFooterOnDesktop?: Maybe<Scalars['Boolean']['output']>;
  disableStickyFooterOnMobile?: Maybe<Scalars['Boolean']['output']>;
  heroBackgroundColor?: Maybe<Scalars['String']['output']>;
  heroButtonCollection?: Maybe<BlogDetailsPageHeroButtonCollection>;
  heroContentCollection?: Maybe<BlogDetailsPageHeroContentCollection>;
  heroContentTitle?: Maybe<BlogDetailsPageHeroContentTitle>;
  imageAsset?: Maybe<ImageAsset>;
  indexed?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<BlogDetailsPageLinkingCollections>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pageDesignType?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  relatedBlogsContentSection?: Maybe<ContentSection>;
  reviewer?: Maybe<BlogAuthor>;
  subCategory?: Maybe<BlogSubCategory>;
  summary?: Maybe<BlogDetailsPageSummary>;
  sys: Sys;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  text?: Maybe<BlogDetailsPageText>;
  theme?: Maybe<Scalars['String']['output']>;
  timeToRead?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageAdditionalContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlogDetailsPageAdditionalContentFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageAuthorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogAuthorFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageBlogImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageBrandArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageCanonicalArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageCategoryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogCategoryFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageDateArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageDisableHeaderBottomAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageDisableHeaderTopAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageDisableStickyFooterOnDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageDisableStickyFooterOnMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageHeroBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageHeroButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogDetailsPageHeroButtonCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageHeroContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogDetailsPageHeroContentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageHeroContentTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageImageAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageIndexedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageMetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPagePageDesignTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPagePathArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageRelatedBlogsContentSectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentSectionFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageReviewerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogAuthorFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageSubCategoryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogSubCategoryFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageSummaryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageTagsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageThemeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageTimeToReadArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type BlogDetailsPageAdditionalContentCollection = {
  __typename?: 'BlogDetailsPageAdditionalContentCollection';
  items: Array<Maybe<BlogDetailsPageAdditionalContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogDetailsPageAdditionalContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogDetailsPageAdditionalContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogDetailsPageAdditionalContentFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogDetailsPageAdditionalContentItem = Accordions | SingleMessage;

export type BlogDetailsPageCollection = {
  __typename?: 'BlogDetailsPageCollection';
  items: Array<Maybe<BlogDetailsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogDetailsPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogDetailsPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogDetailsPageFilter>>>;
  additionalContent?: InputMaybe<CfadditionalContentMultiTypeNestedFilter>;
  additionalContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  author?: InputMaybe<CfBlogAuthorNestedFilter>;
  author_exists?: InputMaybe<Scalars['Boolean']['input']>;
  blogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<CfBrandNestedFilter>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical?: InputMaybe<Scalars['String']['input']>;
  canonical_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonical_not?: InputMaybe<Scalars['String']['input']>;
  canonical_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<CfBlogCategoryNestedFilter>;
  category_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  date_exists?: InputMaybe<Scalars['Boolean']['input']>;
  date_gt?: InputMaybe<Scalars['DateTime']['input']>;
  date_gte?: InputMaybe<Scalars['DateTime']['input']>;
  date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt?: InputMaybe<Scalars['DateTime']['input']>;
  date_lte?: InputMaybe<Scalars['DateTime']['input']>;
  date_not?: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  disableHeaderBottomAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  heroBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  heroBackgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  heroBackgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroBackgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroBackgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  heroBackgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  heroBackgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroButton?: InputMaybe<CfButtonNestedFilter>;
  heroButtonCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroContent?: InputMaybe<CfContentTypeRichTextNestedFilter>;
  heroContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroContentTitle_contains?: InputMaybe<Scalars['String']['input']>;
  heroContentTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroContentTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageAsset?: InputMaybe<CfImageAssetNestedFilter>;
  imageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_not?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageDesignType?: InputMaybe<Scalars['String']['input']>;
  pageDesignType_contains?: InputMaybe<Scalars['String']['input']>;
  pageDesignType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageDesignType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageDesignType_not?: InputMaybe<Scalars['String']['input']>;
  pageDesignType_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageDesignType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path?: InputMaybe<Scalars['String']['input']>;
  path_contains?: InputMaybe<Scalars['String']['input']>;
  path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_not?: InputMaybe<Scalars['String']['input']>;
  path_not_contains?: InputMaybe<Scalars['String']['input']>;
  path_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedBlogsContentSection?: InputMaybe<CfContentSectionNestedFilter>;
  relatedBlogsContentSection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  reviewer?: InputMaybe<CfBlogAuthorNestedFilter>;
  reviewer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subCategory?: InputMaybe<CfBlogSubCategoryNestedFilter>;
  subCategory_exists?: InputMaybe<Scalars['Boolean']['input']>;
  summary_contains?: InputMaybe<Scalars['String']['input']>;
  summary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  summary_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
  theme_contains?: InputMaybe<Scalars['String']['input']>;
  theme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  theme_not?: InputMaybe<Scalars['String']['input']>;
  theme_not_contains?: InputMaybe<Scalars['String']['input']>;
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeToRead?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_exists?: InputMaybe<Scalars['Boolean']['input']>;
  timeToRead_gt?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_gte?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeToRead_lt?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_lte?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_not?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogDetailsPageHeroButtonCollection = {
  __typename?: 'BlogDetailsPageHeroButtonCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogDetailsPageHeroButtonCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type BlogDetailsPageHeroContentCollection = {
  __typename?: 'BlogDetailsPageHeroContentCollection';
  items: Array<Maybe<ContentTypeRichText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogDetailsPageHeroContentCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'titleIcon_ASC'
  | 'titleIcon_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogDetailsPageHeroContentTitle = {
  __typename?: 'BlogDetailsPageHeroContentTitle';
  json: Scalars['JSON']['output'];
  links: BlogDetailsPageHeroContentTitleLinks;
};

export type BlogDetailsPageHeroContentTitleAssets = {
  __typename?: 'BlogDetailsPageHeroContentTitleAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type BlogDetailsPageHeroContentTitleEntries = {
  __typename?: 'BlogDetailsPageHeroContentTitleEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type BlogDetailsPageHeroContentTitleLinks = {
  __typename?: 'BlogDetailsPageHeroContentTitleLinks';
  assets: BlogDetailsPageHeroContentTitleAssets;
  entries: BlogDetailsPageHeroContentTitleEntries;
  resources: BlogDetailsPageHeroContentTitleResources;
};

export type BlogDetailsPageHeroContentTitleResources = {
  __typename?: 'BlogDetailsPageHeroContentTitleResources';
  block: Array<BlogDetailsPageHeroContentTitleResourcesBlock>;
  hyperlink: Array<BlogDetailsPageHeroContentTitleResourcesHyperlink>;
  inline: Array<BlogDetailsPageHeroContentTitleResourcesInline>;
};

export type BlogDetailsPageHeroContentTitleResourcesBlock = ResourceLink & {
  __typename?: 'BlogDetailsPageHeroContentTitleResourcesBlock';
  sys: ResourceSys;
};

export type BlogDetailsPageHeroContentTitleResourcesHyperlink = ResourceLink & {
  __typename?: 'BlogDetailsPageHeroContentTitleResourcesHyperlink';
  sys: ResourceSys;
};

export type BlogDetailsPageHeroContentTitleResourcesInline = ResourceLink & {
  __typename?: 'BlogDetailsPageHeroContentTitleResourcesInline';
  sys: ResourceSys;
};

export type BlogDetailsPageLinkingCollections = {
  __typename?: 'BlogDetailsPageLinkingCollections';
  blogListCollection?: Maybe<BlogListCollection>;
  entryCollection?: Maybe<EntryCollection>;
  navigationLinkCollection?: Maybe<NavigationLinkCollection>;
};


export type BlogDetailsPageLinkingCollectionsBlogListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogDetailsPageLinkingCollectionsBlogListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BlogDetailsPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BlogDetailsPageLinkingCollectionsNavigationLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogDetailsPageLinkingCollectionsNavigationLinkCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogDetailsPageLinkingCollectionsBlogListCollectionOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'cardDesignType_ASC'
  | 'cardDesignType_DESC'
  | 'countAcrossDesktop_ASC'
  | 'countAcrossDesktop_DESC'
  | 'countAcrossMobile_ASC'
  | 'countAcrossMobile_DESC'
  | 'displayType_ASC'
  | 'displayType_DESC'
  | 'hasPagination_ASC'
  | 'hasPagination_DESC'
  | 'loadMoreButtonLabel_ASC'
  | 'loadMoreButtonLabel_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogDetailsPageLinkingCollectionsNavigationLinkCollectionOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type BlogDetailsPageOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogDetailsPageSummary = {
  __typename?: 'BlogDetailsPageSummary';
  json: Scalars['JSON']['output'];
  links: BlogDetailsPageSummaryLinks;
};

export type BlogDetailsPageSummaryAssets = {
  __typename?: 'BlogDetailsPageSummaryAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type BlogDetailsPageSummaryEntries = {
  __typename?: 'BlogDetailsPageSummaryEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type BlogDetailsPageSummaryLinks = {
  __typename?: 'BlogDetailsPageSummaryLinks';
  assets: BlogDetailsPageSummaryAssets;
  entries: BlogDetailsPageSummaryEntries;
  resources: BlogDetailsPageSummaryResources;
};

export type BlogDetailsPageSummaryResources = {
  __typename?: 'BlogDetailsPageSummaryResources';
  block: Array<BlogDetailsPageSummaryResourcesBlock>;
  hyperlink: Array<BlogDetailsPageSummaryResourcesHyperlink>;
  inline: Array<BlogDetailsPageSummaryResourcesInline>;
};

export type BlogDetailsPageSummaryResourcesBlock = ResourceLink & {
  __typename?: 'BlogDetailsPageSummaryResourcesBlock';
  sys: ResourceSys;
};

export type BlogDetailsPageSummaryResourcesHyperlink = ResourceLink & {
  __typename?: 'BlogDetailsPageSummaryResourcesHyperlink';
  sys: ResourceSys;
};

export type BlogDetailsPageSummaryResourcesInline = ResourceLink & {
  __typename?: 'BlogDetailsPageSummaryResourcesInline';
  sys: ResourceSys;
};

export type BlogDetailsPageText = {
  __typename?: 'BlogDetailsPageText';
  json: Scalars['JSON']['output'];
  links: BlogDetailsPageTextLinks;
};

export type BlogDetailsPageTextAssets = {
  __typename?: 'BlogDetailsPageTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type BlogDetailsPageTextEntries = {
  __typename?: 'BlogDetailsPageTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type BlogDetailsPageTextLinks = {
  __typename?: 'BlogDetailsPageTextLinks';
  assets: BlogDetailsPageTextAssets;
  entries: BlogDetailsPageTextEntries;
  resources: BlogDetailsPageTextResources;
};

export type BlogDetailsPageTextResources = {
  __typename?: 'BlogDetailsPageTextResources';
  block: Array<BlogDetailsPageTextResourcesBlock>;
  hyperlink: Array<BlogDetailsPageTextResourcesHyperlink>;
  inline: Array<BlogDetailsPageTextResourcesInline>;
};

export type BlogDetailsPageTextResourcesBlock = ResourceLink & {
  __typename?: 'BlogDetailsPageTextResourcesBlock';
  sys: ResourceSys;
};

export type BlogDetailsPageTextResourcesHyperlink = ResourceLink & {
  __typename?: 'BlogDetailsPageTextResourcesHyperlink';
  sys: ResourceSys;
};

export type BlogDetailsPageTextResourcesInline = ResourceLink & {
  __typename?: 'BlogDetailsPageTextResourcesInline';
  sys: ResourceSys;
};

/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogList = Entry & _Node & {
  __typename?: 'BlogList';
  _id: Scalars['ID']['output'];
  brand?: Maybe<Brand>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  cardDesignType?: Maybe<Scalars['String']['output']>;
  category?: Maybe<BlogCategory>;
  contentfulMetadata: ContentfulMetadata;
  countAcrossDesktop?: Maybe<Scalars['Int']['output']>;
  countAcrossMobile?: Maybe<Scalars['Int']['output']>;
  displayType?: Maybe<Scalars['String']['output']>;
  featuredBlogsListCollection?: Maybe<BlogListFeaturedBlogsListCollection>;
  hasPagination?: Maybe<Scalars['Boolean']['output']>;
  heroBlogsListCollection?: Maybe<BlogListHeroBlogsListCollection>;
  linkedFrom?: Maybe<BlogListLinkingCollections>;
  loadMoreButtonLabel?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subCategory?: Maybe<BlogSubCategory>;
  sys: Sys;
  tagsFilter?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListBrandArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandFilter>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListButtonLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListCardDesignTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListCategoryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogCategoryFilter>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListCountAcrossDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListCountAcrossMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListDisplayTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListFeaturedBlogsListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListFeaturedBlogsListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlogDetailsPageFilter>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListHasPaginationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListHeroBlogsListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListHeroBlogsListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlogDetailsPageFilter>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListLoadMoreButtonLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListSubCategoryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogSubCategoryFilter>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListTagsFilterArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type BlogListCollection = {
  __typename?: 'BlogListCollection';
  items: Array<Maybe<BlogList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogListFeaturedBlogsListCollection = {
  __typename?: 'BlogListFeaturedBlogsListCollection';
  items: Array<Maybe<BlogDetailsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogListFeaturedBlogsListCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogListFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogListFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogListFilter>>>;
  brand?: InputMaybe<CfBrandNestedFilter>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLabel_not?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardDesignType?: InputMaybe<Scalars['String']['input']>;
  cardDesignType_contains?: InputMaybe<Scalars['String']['input']>;
  cardDesignType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardDesignType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardDesignType_not?: InputMaybe<Scalars['String']['input']>;
  cardDesignType_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardDesignType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<CfBlogCategoryNestedFilter>;
  category_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  countAcrossDesktop?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  countAcrossDesktop_gt?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_gte?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  countAcrossDesktop_lt?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_lte?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_not?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  countAcrossMobile?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  countAcrossMobile_gt?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_gte?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  countAcrossMobile_lt?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_lte?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_not?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  displayType?: InputMaybe<Scalars['String']['input']>;
  displayType_contains?: InputMaybe<Scalars['String']['input']>;
  displayType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayType_not?: InputMaybe<Scalars['String']['input']>;
  displayType_not_contains?: InputMaybe<Scalars['String']['input']>;
  displayType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featuredBlogsList?: InputMaybe<CfBlogDetailsPageNestedFilter>;
  featuredBlogsListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasPagination?: InputMaybe<Scalars['Boolean']['input']>;
  hasPagination_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasPagination_not?: InputMaybe<Scalars['Boolean']['input']>;
  heroBlogsList?: InputMaybe<CfBlogDetailsPageNestedFilter>;
  heroBlogsListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  loadMoreButtonLabel?: InputMaybe<Scalars['String']['input']>;
  loadMoreButtonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  loadMoreButtonLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  loadMoreButtonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  loadMoreButtonLabel_not?: InputMaybe<Scalars['String']['input']>;
  loadMoreButtonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  loadMoreButtonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subCategory?: InputMaybe<CfBlogSubCategoryNestedFilter>;
  subCategory_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  tagsFilter_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagsFilter_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagsFilter_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagsFilter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogListHeroBlogsListCollection = {
  __typename?: 'BlogListHeroBlogsListCollection';
  items: Array<Maybe<BlogDetailsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogListHeroBlogsListCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogListLinkingCollections = {
  __typename?: 'BlogListLinkingCollections';
  blogListPageCollection?: Maybe<BlogListPageCollection>;
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  pageCollection?: Maybe<PageCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
};


export type BlogListLinkingCollectionsBlogListPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListLinkingCollectionsBlogListPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BlogListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BlogListLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BlogListLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BlogListLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogListLinkingCollectionsBlogListPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'shouldDisplayCategoryFilterChips_ASC'
  | 'shouldDisplayCategoryFilterChips_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogListLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogListLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogListLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogListOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'cardDesignType_ASC'
  | 'cardDesignType_DESC'
  | 'countAcrossDesktop_ASC'
  | 'countAcrossDesktop_DESC'
  | 'countAcrossMobile_ASC'
  | 'countAcrossMobile_DESC'
  | 'displayType_ASC'
  | 'displayType_DESC'
  | 'hasPagination_ASC'
  | 'hasPagination_DESC'
  | 'loadMoreButtonLabel_ASC'
  | 'loadMoreButtonLabel_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPage = Entry & _Node & {
  __typename?: 'BlogListPage';
  _id: Scalars['ID']['output'];
  blogList?: Maybe<BlogList>;
  brand?: Maybe<Brand>;
  canonical?: Maybe<Scalars['String']['output']>;
  contentAfterListCollection?: Maybe<BlogListPageContentAfterListCollection>;
  contentListCollection?: Maybe<BlogListPageContentListCollection>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<BlogListPageDescription>;
  disableHeaderBottomAlertBanner?: Maybe<Scalars['Boolean']['output']>;
  disableHeaderTopAlertBanner?: Maybe<Scalars['Boolean']['output']>;
  disableStickyFooterOnDesktop?: Maybe<Scalars['Boolean']['output']>;
  disableStickyFooterOnMobile?: Maybe<Scalars['Boolean']['output']>;
  indexed?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<BlogListPageLinkingCollections>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shouldDisplayCategoryFilterChips?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageBlogListArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogListFilter>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageBrandArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandFilter>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageCanonicalArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageContentAfterListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListPageContentAfterListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SingleMessageFilter>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageContentListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListPageContentListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlogListFilter>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageDisableHeaderBottomAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageDisableHeaderTopAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageDisableStickyFooterOnDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageDisableStickyFooterOnMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageIndexedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageMetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageShouldDisplayCategoryFilterChipsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageTagsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type BlogListPageCollection = {
  __typename?: 'BlogListPageCollection';
  items: Array<Maybe<BlogListPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogListPageContentAfterListCollection = {
  __typename?: 'BlogListPageContentAfterListCollection';
  items: Array<Maybe<SingleMessage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogListPageContentAfterListCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentFillVerticalSpace_ASC'
  | 'contentFillVerticalSpace_DESC'
  | 'displayTitleInline_ASC'
  | 'displayTitleInline_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isBannerImage_ASC'
  | 'isBannerImage_DESC'
  | 'isHeaderAboveSideImages_ASC'
  | 'isHeaderAboveSideImages_DESC'
  | 'isInlineLayout_ASC'
  | 'isInlineLayout_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showSubscriptionForm_ASC'
  | 'showSubscriptionForm_DESC'
  | 'subText_ASC'
  | 'subText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateHeight_ASC'
  | 'templateHeight_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleAlign_ASC'
  | 'titleAlign_DESC'
  | 'titleVariant_ASC'
  | 'titleVariant_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useRoundedCorners_ASC'
  | 'useRoundedCorners_DESC';

export type BlogListPageContentListCollection = {
  __typename?: 'BlogListPageContentListCollection';
  items: Array<Maybe<BlogList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogListPageContentListCollectionOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'cardDesignType_ASC'
  | 'cardDesignType_DESC'
  | 'countAcrossDesktop_ASC'
  | 'countAcrossDesktop_DESC'
  | 'countAcrossMobile_ASC'
  | 'countAcrossMobile_DESC'
  | 'displayType_ASC'
  | 'displayType_DESC'
  | 'hasPagination_ASC'
  | 'hasPagination_DESC'
  | 'loadMoreButtonLabel_ASC'
  | 'loadMoreButtonLabel_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogListPageDescription = {
  __typename?: 'BlogListPageDescription';
  json: Scalars['JSON']['output'];
  links: BlogListPageDescriptionLinks;
};

export type BlogListPageDescriptionAssets = {
  __typename?: 'BlogListPageDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type BlogListPageDescriptionEntries = {
  __typename?: 'BlogListPageDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type BlogListPageDescriptionLinks = {
  __typename?: 'BlogListPageDescriptionLinks';
  assets: BlogListPageDescriptionAssets;
  entries: BlogListPageDescriptionEntries;
  resources: BlogListPageDescriptionResources;
};

export type BlogListPageDescriptionResources = {
  __typename?: 'BlogListPageDescriptionResources';
  block: Array<BlogListPageDescriptionResourcesBlock>;
  hyperlink: Array<BlogListPageDescriptionResourcesHyperlink>;
  inline: Array<BlogListPageDescriptionResourcesInline>;
};

export type BlogListPageDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'BlogListPageDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type BlogListPageDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'BlogListPageDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type BlogListPageDescriptionResourcesInline = ResourceLink & {
  __typename?: 'BlogListPageDescriptionResourcesInline';
  sys: ResourceSys;
};

export type BlogListPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogListPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogListPageFilter>>>;
  blogList?: InputMaybe<CfBlogListNestedFilter>;
  blogList_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<CfBrandNestedFilter>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical?: InputMaybe<Scalars['String']['input']>;
  canonical_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonical_not?: InputMaybe<Scalars['String']['input']>;
  canonical_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentAfterList?: InputMaybe<CfSingleMessageNestedFilter>;
  contentAfterListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentList?: InputMaybe<CfBlogListNestedFilter>;
  contentListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  disableHeaderBottomAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  indexed?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_not?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shouldDisplayCategoryFilterChips?: InputMaybe<Scalars['Boolean']['input']>;
  shouldDisplayCategoryFilterChips_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shouldDisplayCategoryFilterChips_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogListPageLinkingCollections = {
  __typename?: 'BlogListPageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type BlogListPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogListPageOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'shouldDisplayCategoryFilterChips_ASC'
  | 'shouldDisplayCategoryFilterChips_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** Blog Sub Category [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogSubCategory) */
export type BlogSubCategory = Entry & _Node & {
  __typename?: 'BlogSubCategory';
  _id: Scalars['ID']['output'];
  brand?: Maybe<Brand>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlogSubCategoryLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** Blog Sub Category [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogSubCategory) */
export type BlogSubCategoryBrandArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandFilter>;
};


/** Blog Sub Category [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogSubCategory) */
export type BlogSubCategoryLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Blog Sub Category [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogSubCategory) */
export type BlogSubCategoryNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Blog Sub Category [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogSubCategory) */
export type BlogSubCategorySlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type BlogSubCategoryCollection = {
  __typename?: 'BlogSubCategoryCollection';
  items: Array<Maybe<BlogSubCategory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogSubCategoryFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogSubCategoryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogSubCategoryFilter>>>;
  brand?: InputMaybe<CfBrandNestedFilter>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BlogSubCategoryLinkingCollections = {
  __typename?: 'BlogSubCategoryLinkingCollections';
  blogDetailsPageCollection?: Maybe<BlogDetailsPageCollection>;
  blogListCollection?: Maybe<BlogListCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type BlogSubCategoryLinkingCollectionsBlogDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogSubCategoryLinkingCollectionsBlogDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BlogSubCategoryLinkingCollectionsBlogListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogSubCategoryLinkingCollectionsBlogListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BlogSubCategoryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type BlogSubCategoryLinkingCollectionsBlogDetailsPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogSubCategoryLinkingCollectionsBlogListCollectionOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'cardDesignType_ASC'
  | 'cardDesignType_DESC'
  | 'countAcrossDesktop_ASC'
  | 'countAcrossDesktop_DESC'
  | 'countAcrossMobile_ASC'
  | 'countAcrossMobile_DESC'
  | 'displayType_ASC'
  | 'displayType_DESC'
  | 'hasPagination_ASC'
  | 'hasPagination_DESC'
  | 'loadMoreButtonLabel_ASC'
  | 'loadMoreButtonLabel_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogSubCategoryOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** Brands within The Aspen Group [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/brand) */
export type Brand = Entry & _Node & {
  __typename?: 'Brand';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BrandLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** Brands within The Aspen Group [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/brand) */
export type BrandLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Brands within The Aspen Group [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/brand) */
export type BrandNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Brands within The Aspen Group [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/brand) */
export type BrandTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type BrandCollection = {
  __typename?: 'BrandCollection';
  items: Array<Maybe<Brand>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BrandFilter = {
  AND?: InputMaybe<Array<InputMaybe<BrandFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BrandFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BrandLinkingCollections = {
  __typename?: 'BrandLinkingCollections';
  appointmentBookingPageCollection?: Maybe<AppointmentBookingPageCollection>;
  blogCategoryCollection?: Maybe<BlogCategoryCollection>;
  blogDetailsPageCollection?: Maybe<BlogDetailsPageCollection>;
  blogListCollection?: Maybe<BlogListCollection>;
  blogListPageCollection?: Maybe<BlogListPageCollection>;
  blogSubCategoryCollection?: Maybe<BlogSubCategoryCollection>;
  entryCollection?: Maybe<EntryCollection>;
  productCollection?: Maybe<ProductCollection>;
  providerDetailsPageCollection?: Maybe<ProviderDetailsPageCollection>;
  quizCollection?: Maybe<QuizCollection>;
};


export type BrandLinkingCollectionsAppointmentBookingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsAppointmentBookingPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BrandLinkingCollectionsBlogCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsBlogCategoryCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BrandLinkingCollectionsBlogDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsBlogDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BrandLinkingCollectionsBlogListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsBlogListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BrandLinkingCollectionsBlogListPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsBlogListPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BrandLinkingCollectionsBlogSubCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsBlogSubCategoryCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BrandLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BrandLinkingCollectionsProductCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsProductCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BrandLinkingCollectionsProviderDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsProviderDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type BrandLinkingCollectionsQuizCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsQuizCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type BrandLinkingCollectionsAppointmentBookingPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BrandLinkingCollectionsBlogCategoryCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type BrandLinkingCollectionsBlogDetailsPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BrandLinkingCollectionsBlogListCollectionOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'cardDesignType_ASC'
  | 'cardDesignType_DESC'
  | 'countAcrossDesktop_ASC'
  | 'countAcrossDesktop_DESC'
  | 'countAcrossMobile_ASC'
  | 'countAcrossMobile_DESC'
  | 'displayType_ASC'
  | 'displayType_DESC'
  | 'hasPagination_ASC'
  | 'hasPagination_DESC'
  | 'loadMoreButtonLabel_ASC'
  | 'loadMoreButtonLabel_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BrandLinkingCollectionsBlogListPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'shouldDisplayCategoryFilterChips_ASC'
  | 'shouldDisplayCategoryFilterChips_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BrandLinkingCollectionsBlogSubCategoryCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type BrandLinkingCollectionsProductCollectionOrder =
  | 'brandfolderImageAssetUrl_ASC'
  | 'brandfolderImageAssetUrl_DESC'
  | 'category_ASC'
  | 'category_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disclaimer_ASC'
  | 'disclaimer_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'linkUrl_ASC'
  | 'linkUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subCategory_ASC'
  | 'subCategory_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type BrandLinkingCollectionsProviderDetailsPageCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type BrandLinkingCollectionsQuizCollectionOrder =
  | 'clearChoicePoorCreditRedirectPath_ASC'
  | 'clearChoicePoorCreditRedirectPath_DESC'
  | 'isFormBuilder_ASC'
  | 'isFormBuilder_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizType_ASC'
  | 'quizType_DESC'
  | 'submitEndpointUrl_ASC'
  | 'submitEndpointUrl_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type BrandOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type Button = Entry & _Node & {
  __typename?: 'Button';
  _id: Scalars['ID']['output'];
  analyticsContext?: Maybe<AnalyticsContext>;
  buttonLink?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  icon?: Maybe<Scalars['String']['output']>;
  iconPosition?: Maybe<Scalars['String']['output']>;
  iconSize?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ButtonLinkingCollections>;
  mobileButton?: Maybe<MobileButton>;
  name?: Maybe<Scalars['String']['output']>;
  navigationDetails?: Maybe<NavigationLink>;
  quizDetails?: Maybe<Quiz>;
  quizSelector?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  variant?: Maybe<Scalars['String']['output']>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonAnalyticsContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonButtonLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonIconPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonIconSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonMobileButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MobileButtonFilter>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonNavigationDetailsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonQuizDetailsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuizFilter>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonQuizSelectorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ButtonCollection = {
  __typename?: 'ButtonCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ButtonFilter = {
  AND?: InputMaybe<Array<InputMaybe<ButtonFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ButtonFilter>>>;
  analyticsContext?: InputMaybe<CfAnalyticsContextNestedFilter>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonLink_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLink_not?: InputMaybe<Scalars['String']['input']>;
  buttonLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconPosition?: InputMaybe<Scalars['String']['input']>;
  iconPosition_contains?: InputMaybe<Scalars['String']['input']>;
  iconPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconPosition_not?: InputMaybe<Scalars['String']['input']>;
  iconPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconSize?: InputMaybe<Scalars['String']['input']>;
  iconSize_contains?: InputMaybe<Scalars['String']['input']>;
  iconSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconSize_not?: InputMaybe<Scalars['String']['input']>;
  iconSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileButton?: InputMaybe<CfMobileButtonNestedFilter>;
  mobileButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationDetails?: InputMaybe<CfNavigationLinkNestedFilter>;
  navigationDetails_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quizDetails?: InputMaybe<CfQuizNestedFilter>;
  quizDetails_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quizSelector?: InputMaybe<Scalars['String']['input']>;
  quizSelector_contains?: InputMaybe<Scalars['String']['input']>;
  quizSelector_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quizSelector_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quizSelector_not?: InputMaybe<Scalars['String']['input']>;
  quizSelector_not_contains?: InputMaybe<Scalars['String']['input']>;
  quizSelector_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size?: InputMaybe<Scalars['String']['input']>;
  size_contains?: InputMaybe<Scalars['String']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size_not?: InputMaybe<Scalars['String']['input']>;
  size_not_contains?: InputMaybe<Scalars['String']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ButtonLinkingCollections = {
  __typename?: 'ButtonLinkingCollections';
  accordionsCollection?: Maybe<AccordionsCollection>;
  adFooterCollection?: Maybe<AdFooterCollection>;
  blogDetailsPageCollection?: Maybe<BlogDetailsPageCollection>;
  cardCollection?: Maybe<CardCollection>;
  categoryPickerCollection?: Maybe<CategoryPickerCollection>;
  contentTypeRichTextCollection?: Maybe<ContentTypeRichTextCollection>;
  entryCollection?: Maybe<EntryCollection>;
  googleMapTemplateCollection?: Maybe<GoogleMapTemplateCollection>;
  halfScreenCollection?: Maybe<HalfScreenCollection>;
  heroV2Collection?: Maybe<HeroV2Collection>;
  multiCardV2Collection?: Maybe<MultiCardV2Collection>;
  odpHeroCollection?: Maybe<OdpHeroCollection>;
  patientReviewsV2Collection?: Maybe<PatientReviewsV2Collection>;
  productFeatureCollection?: Maybe<ProductFeatureCollection>;
  quickLinksCollection?: Maybe<QuickLinksCollection>;
  serviceCollection?: Maybe<ServiceCollection>;
  serviceLineHeroCollection?: Maybe<ServiceLineHeroCollection>;
  singleMessageCollection?: Maybe<SingleMessageCollection>;
  videoCarouselCollection?: Maybe<VideoCarouselCollection>;
  videoWithContentCollection?: Maybe<VideoWithContentCollection>;
};


export type ButtonLinkingCollectionsAccordionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsAccordionsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsAdFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsAdFooterCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsBlogDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsBlogDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsCategoryPickerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsCategoryPickerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsContentTypeRichTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsContentTypeRichTextCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsGoogleMapTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsGoogleMapTemplateCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsHalfScreenCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsHalfScreenCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsHeroV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsHeroV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsMultiCardV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsMultiCardV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsOdpHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsOdpHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsPatientReviewsV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsPatientReviewsV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsProductFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsProductFeatureCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsQuickLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsQuickLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsServiceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsServiceCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsServiceLineHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsServiceLineHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsSingleMessageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsSingleMessageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsVideoCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsVideoCarouselCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkingCollectionsVideoWithContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsVideoWithContentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ButtonLinkingCollectionsAccordionsCollectionOrder =
  | 'accordionsHeading_ASC'
  | 'accordionsHeading_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonCollectionAlignment_ASC'
  | 'buttonCollectionAlignment_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'descriptionAlignment_ASC'
  | 'descriptionAlignment_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'expandIconPosition_ASC'
  | 'expandIconPosition_DESC'
  | 'expandIconType_ASC'
  | 'expandIconType_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'imagePositionRight_ASC'
  | 'imagePositionRight_DESC'
  | 'imageRoundedCorner_ASC'
  | 'imageRoundedCorner_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'roundedCornersSize_ASC'
  | 'roundedCornersSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleAlignment_ASC'
  | 'titleAlignment_DESC'
  | 'titleColor_ASC'
  | 'titleColor_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'withInnerGap_ASC'
  | 'withInnerGap_DESC';

export type ButtonLinkingCollectionsAdFooterCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'contactNumber_ASC'
  | 'contactNumber_DESC'
  | 'copyright_ASC'
  | 'copyright_DESC'
  | 'isLightFooter_ASC'
  | 'isLightFooter_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useDesktopStickyFooter_ASC'
  | 'useDesktopStickyFooter_DESC'
  | 'useMobileStickyFooter_ASC'
  | 'useMobileStickyFooter_DESC';

export type ButtonLinkingCollectionsBlogDetailsPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ButtonLinkingCollectionsCardCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonIconPosition_ASC'
  | 'buttonIconPosition_DESC'
  | 'buttonIconSize_ASC'
  | 'buttonIconSize_DESC'
  | 'buttonIcon_ASC'
  | 'buttonIcon_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'buttonVariant_ASC'
  | 'buttonVariant_DESC'
  | 'cardIconAlignment_ASC'
  | 'cardIconAlignment_DESC'
  | 'cardIcon_ASC'
  | 'cardIcon_DESC'
  | 'cardTextAlignment_ASC'
  | 'cardTextAlignment_DESC'
  | 'eventType_ASC'
  | 'eventType_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRatio_ASC'
  | 'imageRatio_DESC'
  | 'imageUrl_ASC'
  | 'imageUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pdfDownloadTitle_ASC'
  | 'pdfDownloadTitle_DESC'
  | 'priority_ASC'
  | 'priority_DESC'
  | 'showBorder_ASC'
  | 'showBorder_DESC'
  | 'slot_ASC'
  | 'slot_DESC'
  | 'stepName_ASC'
  | 'stepName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tcText_ASC'
  | 'tcText_DESC'
  | 'tcUrl_ASC'
  | 'tcUrl_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ButtonLinkingCollectionsCategoryPickerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'eyebrowHeading_ASC'
  | 'eyebrowHeading_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'mobileThreshold_ASC'
  | 'mobileThreshold_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'setTwoRows_ASC'
  | 'setTwoRows_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'transparentCategories_ASC'
  | 'transparentCategories_DESC';

export type ButtonLinkingCollectionsContentTypeRichTextCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'titleIcon_ASC'
  | 'titleIcon_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ButtonLinkingCollectionsGoogleMapTemplateCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'desktopZoom_ASC'
  | 'desktopZoom_DESC'
  | 'facilityBadgeLabel_ASC'
  | 'facilityBadgeLabel_DESC'
  | 'facilityBasePath_ASC'
  | 'facilityBasePath_DESC'
  | 'facilityButtonLabel_ASC'
  | 'facilityButtonLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'holidayHoursMessageText_ASC'
  | 'holidayHoursMessageText_DESC'
  | 'listTabIsHorizontalScrolling_ASC'
  | 'listTabIsHorizontalScrolling_DESC'
  | 'locationScheduleButtonUrl_ASC'
  | 'locationScheduleButtonUrl_DESC'
  | 'mobileZoom_ASC'
  | 'mobileZoom_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'searchRadius_ASC'
  | 'searchRadius_DESC'
  | 'searchResultLimit_ASC'
  | 'searchResultLimit_DESC'
  | 'service_ASC'
  | 'service_DESC'
  | 'setAsOfficeButtonText_ASC'
  | 'setAsOfficeButtonText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useCumulativeDesign_ASC'
  | 'useCumulativeDesign_DESC'
  | 'useModernDesign_ASC'
  | 'useModernDesign_DESC'
  | 'useUsaCountryMap_ASC'
  | 'useUsaCountryMap_DESC';

export type ButtonLinkingCollectionsHalfScreenCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC';

export type ButtonLinkingCollectionsHeroV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type ButtonLinkingCollectionsMultiCardV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'bigScreenBackground_ASC'
  | 'bigScreenBackground_DESC'
  | 'cardsAlignment_ASC'
  | 'cardsAlignment_DESC'
  | 'displayAsStepper_ASC'
  | 'displayAsStepper_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'enableMobileCarouselNavigation_ASC'
  | 'enableMobileCarouselNavigation_DESC'
  | 'enableResourceCardMode_ASC'
  | 'enableResourceCardMode_DESC'
  | 'eyebrowColor_ASC'
  | 'eyebrowColor_DESC'
  | 'eyebrowSx_ASC'
  | 'eyebrowSx_DESC'
  | 'eyebrowTextTransform_ASC'
  | 'eyebrowTextTransform_DESC'
  | 'fixBackgroundToBottom_ASC'
  | 'fixBackgroundToBottom_DESC'
  | 'forMobile_ASC'
  | 'forMobile_DESC'
  | 'headerSpacing_ASC'
  | 'headerSpacing_DESC'
  | 'lastRowCardsAlignment_ASC'
  | 'lastRowCardsAlignment_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'numberOfCardsInLineDesktop_ASC'
  | 'numberOfCardsInLineDesktop_DESC'
  | 'roundedImage_ASC'
  | 'roundedImage_DESC'
  | 'sectionEyebrow_ASC'
  | 'sectionEyebrow_DESC'
  | 'sectionInfoAlignment_ASC'
  | 'sectionInfoAlignment_DESC'
  | 'sectionTitleHtag_ASC'
  | 'sectionTitleHtag_DESC'
  | 'sectionTitle_ASC'
  | 'sectionTitle_DESC'
  | 'shouldDisplayCarouselOnDesktop_ASC'
  | 'shouldDisplayCarouselOnDesktop_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useCardMediaRoundedCorners_ASC'
  | 'useCardMediaRoundedCorners_DESC';

export type ButtonLinkingCollectionsOdpHeroCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'appointmentDataSource_ASC'
  | 'appointmentDataSource_DESC'
  | 'callCenterLabel_ASC'
  | 'callCenterLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'promoTitle_ASC'
  | 'promoTitle_DESC'
  | 'showAddress_ASC'
  | 'showAddress_DESC'
  | 'showEmail_ASC'
  | 'showEmail_DESC'
  | 'showFax_ASC'
  | 'showFax_DESC'
  | 'showHours_ASC'
  | 'showHours_DESC'
  | 'showLocationStatusBadge_ASC'
  | 'showLocationStatusBadge_DESC'
  | 'showPhoneNumber_ASC'
  | 'showPhoneNumber_DESC'
  | 'showReviews_ASC'
  | 'showReviews_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ButtonLinkingCollectionsPatientReviewsV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowLargeScreens_ASC'
  | 'eyebrowLargeScreens_DESC'
  | 'eyebrowSmallScreens_ASC'
  | 'eyebrowSmallScreens_DESC'
  | 'maxReviewsLargeScreens_ASC'
  | 'maxReviewsLargeScreens_DESC'
  | 'maxReviewsSmallScreens_ASC'
  | 'maxReviewsSmallScreens_DESC'
  | 'mode_ASC'
  | 'mode_DESC'
  | 'scoreIcon_ASC'
  | 'scoreIcon_DESC'
  | 'subtitleLargeScreens_ASC'
  | 'subtitleLargeScreens_DESC'
  | 'subtitleSmallScreens_ASC'
  | 'subtitleSmallScreens_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'titleLargeScreens_ASC'
  | 'titleLargeScreens_DESC'
  | 'titleSmallScreens_ASC'
  | 'titleSmallScreens_DESC'
  | 'trimThreshold_ASC'
  | 'trimThreshold_DESC';

export type ButtonLinkingCollectionsProductFeatureCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'enableSliderControlsBackgroundGradient_ASC'
  | 'enableSliderControlsBackgroundGradient_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ButtonLinkingCollectionsQuickLinksCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'displayAsTitles_ASC'
  | 'displayAsTitles_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC';

export type ButtonLinkingCollectionsServiceCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'direction_ASC'
  | 'direction_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageLayout_ASC'
  | 'imageLayout_DESC'
  | 'mediaType_ASC'
  | 'mediaType_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'youTubeVideoId_ASC'
  | 'youTubeVideoId_DESC';

export type ButtonLinkingCollectionsServiceLineHeroCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type ButtonLinkingCollectionsSingleMessageCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentFillVerticalSpace_ASC'
  | 'contentFillVerticalSpace_DESC'
  | 'displayTitleInline_ASC'
  | 'displayTitleInline_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isBannerImage_ASC'
  | 'isBannerImage_DESC'
  | 'isHeaderAboveSideImages_ASC'
  | 'isHeaderAboveSideImages_DESC'
  | 'isInlineLayout_ASC'
  | 'isInlineLayout_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showSubscriptionForm_ASC'
  | 'showSubscriptionForm_DESC'
  | 'subText_ASC'
  | 'subText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateHeight_ASC'
  | 'templateHeight_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleAlign_ASC'
  | 'titleAlign_DESC'
  | 'titleVariant_ASC'
  | 'titleVariant_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useRoundedCorners_ASC'
  | 'useRoundedCorners_DESC';

export type ButtonLinkingCollectionsVideoCarouselCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'desktopVideosAspectRatio_ASC'
  | 'desktopVideosAspectRatio_DESC'
  | 'mobileVideosAspectRatio_ASC'
  | 'mobileVideosAspectRatio_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ButtonLinkingCollectionsVideoWithContentCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ButtonOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type CancelTimeslotReservationError = NotAvailableSlotError;

export type CancelTimeslotReservationInput = {
  scheduleSlotUid: Scalars['NonEmptyString']['input'];
};

export type CancelTimeslotReservationPayload = {
  __typename?: 'CancelTimeslotReservationPayload';
  errors?: Maybe<Array<CancelTimeslotReservationError>>;
  result?: Maybe<CanceledTimeslotReservation>;
};

export type CancelVisitError = NonExistingVisitError | VisitNotCancelableError;

export type CancelVisitInput = {
  visitId: Scalars['String']['input'];
};

export type CancelVisitPayload = {
  __typename?: 'CancelVisitPayload';
  canceledVisit?: Maybe<CanceledVisit>;
  errors?: Maybe<Array<CancelVisitError>>;
};

export type CanceledTimeslotReservation = {
  __typename?: 'CanceledTimeslotReservation';
  scheduleSlotUid: Scalars['String']['output'];
};

export type CanceledVisit = {
  __typename?: 'CanceledVisit';
  visitId: Scalars['String']['output'];
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type Card = Entry & _Node & {
  __typename?: 'Card';
  _id: Scalars['ID']['output'];
  analyticsContext?: Maybe<AnalyticsContext>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  buttonIcon?: Maybe<Scalars['String']['output']>;
  buttonIconPosition?: Maybe<Scalars['String']['output']>;
  buttonIconSize?: Maybe<Scalars['String']['output']>;
  buttonSize?: Maybe<Scalars['String']['output']>;
  buttonText?: Maybe<Scalars['String']['output']>;
  buttonUrl?: Maybe<Scalars['String']['output']>;
  buttonVariant?: Maybe<Scalars['String']['output']>;
  buttonsCollection?: Maybe<CardButtonsCollection>;
  cardIcon?: Maybe<Scalars['String']['output']>;
  cardIconAlignment?: Maybe<Scalars['String']['output']>;
  cardTextAlignment?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  focalPointImage?: Maybe<FocalPointImage>;
  image?: Maybe<Asset>;
  imageAsset?: Maybe<ImageAsset>;
  imageRatio?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<CardLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  pdfDownloadTitle?: Maybe<Scalars['String']['output']>;
  pdfFileLink?: Maybe<Asset>;
  priority?: Maybe<Scalars['Int']['output']>;
  richTextDescription?: Maybe<CardRichTextDescription>;
  showBorder?: Maybe<Scalars['Boolean']['output']>;
  slot?: Maybe<Scalars['Int']['output']>;
  stepName?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tc?: Maybe<TermsAndConditions>;
  tcText?: Maybe<Scalars['String']['output']>;
  tcUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleHtag?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardAnalyticsContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardButtonIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardButtonIconPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardButtonIconSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardButtonSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardButtonUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardButtonVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CardButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardCardIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardCardIconAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardCardTextAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardEventTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardFocalPointImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardImageAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardImageRatioArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardImageUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardPdfDownloadTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardPdfFileLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardPriorityArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardRichTextDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardShowBorderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardSlotArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardStepNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardTagsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardTcArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TermsAndConditionsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardTcTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardTcUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type CardButtonsCollection = {
  __typename?: 'CardButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CardButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type CardCollection = {
  __typename?: 'CardCollection';
  items: Array<Maybe<Card>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CardFilter = {
  AND?: InputMaybe<Array<InputMaybe<CardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CardFilter>>>;
  analyticsContext?: InputMaybe<CfAnalyticsContextNestedFilter>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIcon?: InputMaybe<Scalars['String']['input']>;
  buttonIconPosition?: InputMaybe<Scalars['String']['input']>;
  buttonIconPosition_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIconPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonIconPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIconPosition_not?: InputMaybe<Scalars['String']['input']>;
  buttonIconPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIconPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIconSize?: InputMaybe<Scalars['String']['input']>;
  buttonIconSize_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIconSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonIconSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIconSize_not?: InputMaybe<Scalars['String']['input']>;
  buttonIconSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIconSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIcon_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonIcon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIcon_not?: InputMaybe<Scalars['String']['input']>;
  buttonIcon_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIcon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonSize?: InputMaybe<Scalars['String']['input']>;
  buttonSize_contains?: InputMaybe<Scalars['String']['input']>;
  buttonSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonSize_not?: InputMaybe<Scalars['String']['input']>;
  buttonSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonVariant?: InputMaybe<Scalars['String']['input']>;
  buttonVariant_contains?: InputMaybe<Scalars['String']['input']>;
  buttonVariant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonVariant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonVariant_not?: InputMaybe<Scalars['String']['input']>;
  buttonVariant_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardIcon?: InputMaybe<Scalars['String']['input']>;
  cardIconAlignment?: InputMaybe<Scalars['String']['input']>;
  cardIconAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  cardIconAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardIconAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardIconAlignment_not?: InputMaybe<Scalars['String']['input']>;
  cardIconAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardIconAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardIcon_contains?: InputMaybe<Scalars['String']['input']>;
  cardIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardIcon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardIcon_not?: InputMaybe<Scalars['String']['input']>;
  cardIcon_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardIcon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardTextAlignment?: InputMaybe<Scalars['String']['input']>;
  cardTextAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  cardTextAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardTextAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardTextAlignment_not?: InputMaybe<Scalars['String']['input']>;
  cardTextAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardTextAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  eventType_contains?: InputMaybe<Scalars['String']['input']>;
  eventType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eventType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventType_not?: InputMaybe<Scalars['String']['input']>;
  eventType_not_contains?: InputMaybe<Scalars['String']['input']>;
  eventType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  focalPointImage?: InputMaybe<CfFocalPointImageNestedFilter>;
  focalPointImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageAsset?: InputMaybe<CfImageAssetNestedFilter>;
  imageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageRatio?: InputMaybe<Scalars['String']['input']>;
  imageRatio_contains?: InputMaybe<Scalars['String']['input']>;
  imageRatio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageRatio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageRatio_not?: InputMaybe<Scalars['String']['input']>;
  imageRatio_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageRatio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  imageUrl_contains?: InputMaybe<Scalars['String']['input']>;
  imageUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageUrl_not?: InputMaybe<Scalars['String']['input']>;
  imageUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdfDownloadTitle?: InputMaybe<Scalars['String']['input']>;
  pdfDownloadTitle_contains?: InputMaybe<Scalars['String']['input']>;
  pdfDownloadTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pdfDownloadTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdfDownloadTitle_not?: InputMaybe<Scalars['String']['input']>;
  pdfDownloadTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  pdfDownloadTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdfFileLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  priority_exists?: InputMaybe<Scalars['Boolean']['input']>;
  priority_gt?: InputMaybe<Scalars['Int']['input']>;
  priority_gte?: InputMaybe<Scalars['Int']['input']>;
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  priority_lt?: InputMaybe<Scalars['Int']['input']>;
  priority_lte?: InputMaybe<Scalars['Int']['input']>;
  priority_not?: InputMaybe<Scalars['Int']['input']>;
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  richTextDescription_contains?: InputMaybe<Scalars['String']['input']>;
  richTextDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  richTextDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  showBorder?: InputMaybe<Scalars['Boolean']['input']>;
  showBorder_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showBorder_not?: InputMaybe<Scalars['Boolean']['input']>;
  slot?: InputMaybe<Scalars['Int']['input']>;
  slot_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slot_gt?: InputMaybe<Scalars['Int']['input']>;
  slot_gte?: InputMaybe<Scalars['Int']['input']>;
  slot_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  slot_lt?: InputMaybe<Scalars['Int']['input']>;
  slot_lte?: InputMaybe<Scalars['Int']['input']>;
  slot_not?: InputMaybe<Scalars['Int']['input']>;
  slot_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  stepName?: InputMaybe<Scalars['String']['input']>;
  stepName_contains?: InputMaybe<Scalars['String']['input']>;
  stepName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stepName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepName_not?: InputMaybe<Scalars['String']['input']>;
  stepName_not_contains?: InputMaybe<Scalars['String']['input']>;
  stepName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tc?: InputMaybe<CfTermsAndConditionsNestedFilter>;
  tcText?: InputMaybe<Scalars['String']['input']>;
  tcText_contains?: InputMaybe<Scalars['String']['input']>;
  tcText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tcText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcText_not?: InputMaybe<Scalars['String']['input']>;
  tcText_not_contains?: InputMaybe<Scalars['String']['input']>;
  tcText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcUrl?: InputMaybe<Scalars['String']['input']>;
  tcUrl_contains?: InputMaybe<Scalars['String']['input']>;
  tcUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tcUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcUrl_not?: InputMaybe<Scalars['String']['input']>;
  tcUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  tcUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tc_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CardLinkingCollections = {
  __typename?: 'CardLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  multiCardV2Collection?: Maybe<MultiCardV2Collection>;
};


export type CardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CardLinkingCollectionsMultiCardV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CardLinkingCollectionsMultiCardV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type CardLinkingCollectionsMultiCardV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'bigScreenBackground_ASC'
  | 'bigScreenBackground_DESC'
  | 'cardsAlignment_ASC'
  | 'cardsAlignment_DESC'
  | 'displayAsStepper_ASC'
  | 'displayAsStepper_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'enableMobileCarouselNavigation_ASC'
  | 'enableMobileCarouselNavigation_DESC'
  | 'enableResourceCardMode_ASC'
  | 'enableResourceCardMode_DESC'
  | 'eyebrowColor_ASC'
  | 'eyebrowColor_DESC'
  | 'eyebrowSx_ASC'
  | 'eyebrowSx_DESC'
  | 'eyebrowTextTransform_ASC'
  | 'eyebrowTextTransform_DESC'
  | 'fixBackgroundToBottom_ASC'
  | 'fixBackgroundToBottom_DESC'
  | 'forMobile_ASC'
  | 'forMobile_DESC'
  | 'headerSpacing_ASC'
  | 'headerSpacing_DESC'
  | 'lastRowCardsAlignment_ASC'
  | 'lastRowCardsAlignment_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'numberOfCardsInLineDesktop_ASC'
  | 'numberOfCardsInLineDesktop_DESC'
  | 'roundedImage_ASC'
  | 'roundedImage_DESC'
  | 'sectionEyebrow_ASC'
  | 'sectionEyebrow_DESC'
  | 'sectionInfoAlignment_ASC'
  | 'sectionInfoAlignment_DESC'
  | 'sectionTitleHtag_ASC'
  | 'sectionTitleHtag_DESC'
  | 'sectionTitle_ASC'
  | 'sectionTitle_DESC'
  | 'shouldDisplayCarouselOnDesktop_ASC'
  | 'shouldDisplayCarouselOnDesktop_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useCardMediaRoundedCorners_ASC'
  | 'useCardMediaRoundedCorners_DESC';

export type CardOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonIconPosition_ASC'
  | 'buttonIconPosition_DESC'
  | 'buttonIconSize_ASC'
  | 'buttonIconSize_DESC'
  | 'buttonIcon_ASC'
  | 'buttonIcon_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'buttonVariant_ASC'
  | 'buttonVariant_DESC'
  | 'cardIconAlignment_ASC'
  | 'cardIconAlignment_DESC'
  | 'cardIcon_ASC'
  | 'cardIcon_DESC'
  | 'cardTextAlignment_ASC'
  | 'cardTextAlignment_DESC'
  | 'eventType_ASC'
  | 'eventType_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRatio_ASC'
  | 'imageRatio_DESC'
  | 'imageUrl_ASC'
  | 'imageUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pdfDownloadTitle_ASC'
  | 'pdfDownloadTitle_DESC'
  | 'priority_ASC'
  | 'priority_DESC'
  | 'showBorder_ASC'
  | 'showBorder_DESC'
  | 'slot_ASC'
  | 'slot_DESC'
  | 'stepName_ASC'
  | 'stepName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tcText_ASC'
  | 'tcText_DESC'
  | 'tcUrl_ASC'
  | 'tcUrl_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CardRichTextDescription = {
  __typename?: 'CardRichTextDescription';
  json: Scalars['JSON']['output'];
  links: CardRichTextDescriptionLinks;
};

export type CardRichTextDescriptionAssets = {
  __typename?: 'CardRichTextDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type CardRichTextDescriptionEntries = {
  __typename?: 'CardRichTextDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type CardRichTextDescriptionLinks = {
  __typename?: 'CardRichTextDescriptionLinks';
  assets: CardRichTextDescriptionAssets;
  entries: CardRichTextDescriptionEntries;
  resources: CardRichTextDescriptionResources;
};

export type CardRichTextDescriptionResources = {
  __typename?: 'CardRichTextDescriptionResources';
  block: Array<CardRichTextDescriptionResourcesBlock>;
  hyperlink: Array<CardRichTextDescriptionResourcesHyperlink>;
  inline: Array<CardRichTextDescriptionResourcesInline>;
};

export type CardRichTextDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'CardRichTextDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type CardRichTextDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'CardRichTextDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type CardRichTextDescriptionResourcesInline = ResourceLink & {
  __typename?: 'CardRichTextDescriptionResourcesInline';
  sys: ResourceSys;
};

/** A Category for the Categories Array within the Category Picker [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/category) */
export type Category = Entry & _Node & {
  __typename?: 'Category';
  _id: Scalars['ID']['output'];
  analyticsContext?: Maybe<AnalyticsContext>;
  contentfulMetadata: ContentfulMetadata;
  icon?: Maybe<Scalars['String']['output']>;
  imageAsset?: Maybe<ImageAsset>;
  isLocalized?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<CategoryLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** A Category for the Categories Array within the Category Picker [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/category) */
export type CategoryAnalyticsContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** A Category for the Categories Array within the Category Picker [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/category) */
export type CategoryIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A Category for the Categories Array within the Category Picker [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/category) */
export type CategoryImageAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** A Category for the Categories Array within the Category Picker [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/category) */
export type CategoryIsLocalizedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A Category for the Categories Array within the Category Picker [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/category) */
export type CategoryLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A Category for the Categories Array within the Category Picker [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/category) */
export type CategoryLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A Category for the Categories Array within the Category Picker [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/category) */
export type CategoryNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A Category for the Categories Array within the Category Picker [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/category) */
export type CategoryTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryCollection = {
  __typename?: 'CategoryCollection';
  items: Array<Maybe<Category>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CategoryFilter = {
  AND?: InputMaybe<Array<InputMaybe<CategoryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CategoryFilter>>>;
  analyticsContext?: InputMaybe<CfAnalyticsContextNestedFilter>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAsset?: InputMaybe<CfImageAssetNestedFilter>;
  imageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized_not?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  link_contains?: InputMaybe<Scalars['String']['input']>;
  link_exists?: InputMaybe<Scalars['Boolean']['input']>;
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  link_not?: InputMaybe<Scalars['String']['input']>;
  link_not_contains?: InputMaybe<Scalars['String']['input']>;
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CategoryLinkingCollections = {
  __typename?: 'CategoryLinkingCollections';
  categoryPickerCollection?: Maybe<CategoryPickerCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type CategoryLinkingCollectionsCategoryPickerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryLinkingCollectionsCategoryPickerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CategoryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryLinkingCollectionsCategoryPickerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'eyebrowHeading_ASC'
  | 'eyebrowHeading_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'mobileThreshold_ASC'
  | 'mobileThreshold_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'setTwoRows_ASC'
  | 'setTwoRows_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'transparentCategories_ASC'
  | 'transparentCategories_DESC';

export type CategoryOrder =
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'link_ASC'
  | 'link_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPicker = Entry & _Node & {
  __typename?: 'CategoryPicker';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  buttonsCollection?: Maybe<CategoryPickerButtonsCollection>;
  categoriesCollection?: Maybe<CategoryPickerCategoriesCollection>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<ContentTypeRichText>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  eyebrowHeading?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<CategoryPickerLinkingCollections>;
  mobileThreshold?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  setTwoRows?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  titleHeading?: Maybe<Scalars['String']['output']>;
  transparentCategories?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerCategoriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerCategoriesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerEyebrowHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerMobileThresholdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerSetTwoRowsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerTitleHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerTransparentCategoriesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryPickerButtonsCollection = {
  __typename?: 'CategoryPickerButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CategoryPickerButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type CategoryPickerCategoriesCollection = {
  __typename?: 'CategoryPickerCategoriesCollection';
  items: Array<Maybe<Category>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CategoryPickerCategoriesCollectionOrder =
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'link_ASC'
  | 'link_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CategoryPickerCollection = {
  __typename?: 'CategoryPickerCollection';
  items: Array<Maybe<CategoryPicker>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CategoryPickerFilter = {
  AND?: InputMaybe<Array<InputMaybe<CategoryPickerFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CategoryPickerFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  categories?: InputMaybe<CfCategoryNestedFilter>;
  categoriesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<CfContentTypeRichTextNestedFilter>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrowHeading?: InputMaybe<Scalars['String']['input']>;
  eyebrowHeading_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowHeading_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileThreshold?: InputMaybe<Scalars['Int']['input']>;
  mobileThreshold_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileThreshold_gt?: InputMaybe<Scalars['Int']['input']>;
  mobileThreshold_gte?: InputMaybe<Scalars['Int']['input']>;
  mobileThreshold_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  mobileThreshold_lt?: InputMaybe<Scalars['Int']['input']>;
  mobileThreshold_lte?: InputMaybe<Scalars['Int']['input']>;
  mobileThreshold_not?: InputMaybe<Scalars['Int']['input']>;
  mobileThreshold_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  setTwoRows?: InputMaybe<Scalars['Boolean']['input']>;
  setTwoRows_exists?: InputMaybe<Scalars['Boolean']['input']>;
  setTwoRows_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHeading?: InputMaybe<Scalars['String']['input']>;
  titleHeading_contains?: InputMaybe<Scalars['String']['input']>;
  titleHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHeading_not?: InputMaybe<Scalars['String']['input']>;
  titleHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transparentCategories?: InputMaybe<Scalars['Boolean']['input']>;
  transparentCategories_exists?: InputMaybe<Scalars['Boolean']['input']>;
  transparentCategories_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryPickerLinkingCollections = {
  __typename?: 'CategoryPickerLinkingCollections';
  appointmentBookingPageCollection?: Maybe<AppointmentBookingPageCollection>;
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  pageCollection?: Maybe<PageCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
};


export type CategoryPickerLinkingCollectionsAppointmentBookingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerLinkingCollectionsAppointmentBookingPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CategoryPickerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CategoryPickerLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CategoryPickerLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CategoryPickerLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryPickerLinkingCollectionsAppointmentBookingPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CategoryPickerLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CategoryPickerLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CategoryPickerLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CategoryPickerOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'eyebrowHeading_ASC'
  | 'eyebrowHeading_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'mobileThreshold_ASC'
  | 'mobileThreshold_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'setTwoRows_ASC'
  | 'setTwoRows_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'transparentCategories_ASC'
  | 'transparentCategories_DESC';

export type CitiesFilterInput = {
  /** ISO 3166-1 alpha-2 code as described at: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#Officially_assigned_code_elements. Currently US only supported. */
  countryISOCode?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type CitiesList = {
  __typename?: 'CitiesList';
  items: Array<City>;
};

export type City = {
  __typename?: 'City';
  cityUid: Scalars['String']['output'];
  /** ISO 3166-1 alpha-2 code as described at: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#Officially_assigned_code_elements */
  countryIsoCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** ISO 3166-2 code as described at: https://en.wikipedia.org/wiki/ISO_3166-2 */
  stateIsoCode?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export type CityInput = {
  countryIsoCode: Scalars['String']['input'];
  name: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

/** A container component for city links (ODP) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/cityLinks) */
export type CityLinks = Entry & _Node & {
  __typename?: 'CityLinks';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  groupByState?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<CityLinksLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sectionTitle?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  useDisplayName?: Maybe<Scalars['Boolean']['output']>;
};


/** A container component for city links (ODP) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/cityLinks) */
export type CityLinksGroupByStateArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A container component for city links (ODP) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/cityLinks) */
export type CityLinksLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A container component for city links (ODP) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/cityLinks) */
export type CityLinksNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A container component for city links (ODP) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/cityLinks) */
export type CityLinksSectionTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A container component for city links (ODP) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/cityLinks) */
export type CityLinksUseDisplayNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type CityLinksCollection = {
  __typename?: 'CityLinksCollection';
  items: Array<Maybe<CityLinks>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CityLinksFilter = {
  AND?: InputMaybe<Array<InputMaybe<CityLinksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CityLinksFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  groupByState?: InputMaybe<Scalars['Boolean']['input']>;
  groupByState_exists?: InputMaybe<Scalars['Boolean']['input']>;
  groupByState_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle_not?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  useDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  useDisplayName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useDisplayName_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CityLinksLinkingCollections = {
  __typename?: 'CityLinksLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type CityLinksLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CityLinksLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CityLinksLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type CityLinksLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CityLinksOrder =
  | 'groupByState_ASC'
  | 'groupByState_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sectionTitle_ASC'
  | 'sectionTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useDisplayName_ASC'
  | 'useDisplayName_DESC';

/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type Columns = Entry & _Node & {
  __typename?: 'Columns';
  _id: Scalars['ID']['output'];
  allowEqualHeights?: Maybe<Scalars['Boolean']['output']>;
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  columnsCollection?: Maybe<ColumnsColumnsCollection>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  disablePaddingOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  fullWidth?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<ColumnsLinkingCollections>;
  mobileDisplayAccordion?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  titleHtag?: Maybe<Scalars['String']['output']>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsAllowEqualHeightsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsColumnsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ColumnsColumnsFilter>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsDisablePaddingOnArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsFullWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsMobileDisplayAccordionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ColumnsCollection = {
  __typename?: 'ColumnsCollection';
  items: Array<Maybe<Columns>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ColumnsColumnsCollection = {
  __typename?: 'ColumnsColumnsCollection';
  items: Array<Maybe<ColumnsColumnsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ColumnsColumnsFilter = {
  AND?: InputMaybe<Array<InputMaybe<ColumnsColumnsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ColumnsColumnsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ColumnsColumnsItem = Accordions | ContentTypeRichText | ImageAsset | SingleMessage;

export type ColumnsFilter = {
  AND?: InputMaybe<Array<InputMaybe<ColumnsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ColumnsFilter>>>;
  allowEqualHeights?: InputMaybe<Scalars['Boolean']['input']>;
  allowEqualHeights_exists?: InputMaybe<Scalars['Boolean']['input']>;
  allowEqualHeights_not?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  columns?: InputMaybe<CfcolumnsMultiTypeNestedFilter>;
  columnsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  mobileDisplayAccordion?: InputMaybe<Scalars['Boolean']['input']>;
  mobileDisplayAccordion_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileDisplayAccordion_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ColumnsLinkingCollections = {
  __typename?: 'ColumnsLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  pageCollection?: Maybe<PageCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
};


export type ColumnsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ColumnsLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ColumnsLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ColumnsLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ColumnsLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ColumnsLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ColumnsLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ColumnsLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ColumnsLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ColumnsLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ColumnsOrder =
  | 'allowEqualHeights_ASC'
  | 'allowEqualHeights_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'mobileDisplayAccordion_ASC'
  | 'mobileDisplayAccordion_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CompletedVisit = {
  __typename?: 'CompletedVisit';
  facility?: Maybe<Facility>;
  serviceDate: Scalars['DateTime']['output'];
};

export type CompletedVisitsList = {
  __typename?: 'CompletedVisitsList';
  items: Array<CompletedVisit>;
  total: Scalars['Int']['output'];
};

export type ConfirmPatientVisitError = NonConfirmablePastVisitError | NonExistingVisitError;

export type ConfirmPatientVisitInput = {
  visitId: Scalars['NonEmptyString']['input'];
};

export type ConfirmPatientVisitPayload = {
  __typename?: 'ConfirmPatientVisitPayload';
  errors?: Maybe<Array<ConfirmPatientVisitError>>;
  result?: Maybe<ConfirmedPatientVisit>;
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/confirmationStep) */
export type ConfirmationStep = Entry & _Node & {
  __typename?: 'ConfirmationStep';
  _id: Scalars['ID']['output'];
  accountNumberText?: Maybe<Scalars['String']['output']>;
  cardInfoText?: Maybe<Scalars['String']['output']>;
  confirmationPageName?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  copyTextButtonText?: Maybe<Scalars['String']['output']>;
  footerText?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ConfirmationStepLinkingCollections>;
  stepNumber?: Maybe<Scalars['Int']['output']>;
  successCardsCollection?: Maybe<ConfirmationStepSuccessCardsCollection>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/confirmationStep) */
export type ConfirmationStepAccountNumberTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/confirmationStep) */
export type ConfirmationStepCardInfoTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/confirmationStep) */
export type ConfirmationStepConfirmationPageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/confirmationStep) */
export type ConfirmationStepCopyTextButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/confirmationStep) */
export type ConfirmationStepFooterTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/confirmationStep) */
export type ConfirmationStepLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/confirmationStep) */
export type ConfirmationStepStepNumberArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/confirmationStep) */
export type ConfirmationStepSuccessCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ConfirmationStepSuccessCardsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SuccessCardFilter>;
};

export type ConfirmationStepCollection = {
  __typename?: 'ConfirmationStepCollection';
  items: Array<Maybe<ConfirmationStep>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ConfirmationStepFilter = {
  AND?: InputMaybe<Array<InputMaybe<ConfirmationStepFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ConfirmationStepFilter>>>;
  accountNumberText?: InputMaybe<Scalars['String']['input']>;
  accountNumberText_contains?: InputMaybe<Scalars['String']['input']>;
  accountNumberText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  accountNumberText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  accountNumberText_not?: InputMaybe<Scalars['String']['input']>;
  accountNumberText_not_contains?: InputMaybe<Scalars['String']['input']>;
  accountNumberText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardInfoText?: InputMaybe<Scalars['String']['input']>;
  cardInfoText_contains?: InputMaybe<Scalars['String']['input']>;
  cardInfoText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardInfoText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardInfoText_not?: InputMaybe<Scalars['String']['input']>;
  cardInfoText_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardInfoText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmationPageName?: InputMaybe<Scalars['String']['input']>;
  confirmationPageName_contains?: InputMaybe<Scalars['String']['input']>;
  confirmationPageName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationPageName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmationPageName_not?: InputMaybe<Scalars['String']['input']>;
  confirmationPageName_not_contains?: InputMaybe<Scalars['String']['input']>;
  confirmationPageName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copyTextButtonText?: InputMaybe<Scalars['String']['input']>;
  copyTextButtonText_contains?: InputMaybe<Scalars['String']['input']>;
  copyTextButtonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copyTextButtonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  copyTextButtonText_not?: InputMaybe<Scalars['String']['input']>;
  copyTextButtonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  copyTextButtonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  footerText?: InputMaybe<Scalars['String']['input']>;
  footerText_contains?: InputMaybe<Scalars['String']['input']>;
  footerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  footerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  footerText_not?: InputMaybe<Scalars['String']['input']>;
  footerText_not_contains?: InputMaybe<Scalars['String']['input']>;
  footerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepNumber?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stepNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  stepNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_not?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  successCards?: InputMaybe<CfSuccessCardNestedFilter>;
  successCardsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type ConfirmationStepLinkingCollections = {
  __typename?: 'ConfirmationStepLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  stepperCollection?: Maybe<StepperCollection>;
};


export type ConfirmationStepLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ConfirmationStepLinkingCollectionsStepperCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ConfirmationStepLinkingCollectionsStepperCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ConfirmationStepLinkingCollectionsStepperCollectionOrder =
  | 'confirmButtonText_ASC'
  | 'confirmButtonText_DESC'
  | 'continueButtonText_ASC'
  | 'continueButtonText_DESC'
  | 'headingScheduledText_ASC'
  | 'headingScheduledText_DESC'
  | 'headingText_ASC'
  | 'headingText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'needAssistanceText_ASC'
  | 'needAssistanceText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ConfirmationStepOrder =
  | 'accountNumberText_ASC'
  | 'accountNumberText_DESC'
  | 'cardInfoText_ASC'
  | 'cardInfoText_DESC'
  | 'confirmationPageName_ASC'
  | 'confirmationPageName_DESC'
  | 'copyTextButtonText_ASC'
  | 'copyTextButtonText_DESC'
  | 'stepNumber_ASC'
  | 'stepNumber_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ConfirmationStepSuccessCardsCollection = {
  __typename?: 'ConfirmationStepSuccessCardsCollection';
  items: Array<Maybe<SuccessCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ConfirmationStepSuccessCardsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'imageAltText_ASC'
  | 'imageAltText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleText_ASC'
  | 'titleText_DESC';

export type ConfirmedPatientVisit = {
  __typename?: 'ConfirmedPatientVisit';
  accountNumber: Scalars['String']['output'];
  facility?: Maybe<Facility>;
  scheduledDateTime?: Maybe<Scalars['DateTime']['output']>;
  visitId: Scalars['String']['output'];
};

/** Used for common section fields like eyebrow, title, description and choosing heading levels [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentSection) */
export type ContentSection = Entry & _Node & {
  __typename?: 'ContentSection';
  _id: Scalars['ID']['output'];
  alignment?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<ContentSectionDescription>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  eyebrowHtag?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentSectionLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  titleHtag?: Maybe<Scalars['String']['output']>;
  titleIcon?: Maybe<Scalars['String']['output']>;
};


/** Used for common section fields like eyebrow, title, description and choosing heading levels [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentSection) */
export type ContentSectionAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for common section fields like eyebrow, title, description and choosing heading levels [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentSection) */
export type ContentSectionDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for common section fields like eyebrow, title, description and choosing heading levels [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentSection) */
export type ContentSectionEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for common section fields like eyebrow, title, description and choosing heading levels [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentSection) */
export type ContentSectionEyebrowHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for common section fields like eyebrow, title, description and choosing heading levels [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentSection) */
export type ContentSectionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Used for common section fields like eyebrow, title, description and choosing heading levels [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentSection) */
export type ContentSectionNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for common section fields like eyebrow, title, description and choosing heading levels [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentSection) */
export type ContentSectionTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for common section fields like eyebrow, title, description and choosing heading levels [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentSection) */
export type ContentSectionTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for common section fields like eyebrow, title, description and choosing heading levels [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentSection) */
export type ContentSectionTitleIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ContentSectionCollection = {
  __typename?: 'ContentSectionCollection';
  items: Array<Maybe<ContentSection>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentSectionDescription = {
  __typename?: 'ContentSectionDescription';
  json: Scalars['JSON']['output'];
  links: ContentSectionDescriptionLinks;
};

export type ContentSectionDescriptionAssets = {
  __typename?: 'ContentSectionDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ContentSectionDescriptionEntries = {
  __typename?: 'ContentSectionDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ContentSectionDescriptionLinks = {
  __typename?: 'ContentSectionDescriptionLinks';
  assets: ContentSectionDescriptionAssets;
  entries: ContentSectionDescriptionEntries;
  resources: ContentSectionDescriptionResources;
};

export type ContentSectionDescriptionResources = {
  __typename?: 'ContentSectionDescriptionResources';
  block: Array<ContentSectionDescriptionResourcesBlock>;
  hyperlink: Array<ContentSectionDescriptionResourcesHyperlink>;
  inline: Array<ContentSectionDescriptionResourcesInline>;
};

export type ContentSectionDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'ContentSectionDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type ContentSectionDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'ContentSectionDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type ContentSectionDescriptionResourcesInline = ResourceLink & {
  __typename?: 'ContentSectionDescriptionResourcesInline';
  sys: ResourceSys;
};

export type ContentSectionFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentSectionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentSectionFilter>>>;
  alignment?: InputMaybe<Scalars['String']['input']>;
  alignment_contains?: InputMaybe<Scalars['String']['input']>;
  alignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  alignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alignment_not?: InputMaybe<Scalars['String']['input']>;
  alignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  alignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowHtag_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleIcon?: InputMaybe<Scalars['String']['input']>;
  titleIcon_contains?: InputMaybe<Scalars['String']['input']>;
  titleIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleIcon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleIcon_not?: InputMaybe<Scalars['String']['input']>;
  titleIcon_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleIcon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentSectionLinkingCollections = {
  __typename?: 'ContentSectionLinkingCollections';
  accordionsCollection?: Maybe<AccordionsCollection>;
  blogDetailsPageCollection?: Maybe<BlogDetailsPageCollection>;
  entryCollection?: Maybe<EntryCollection>;
  productFeatureCollection?: Maybe<ProductFeatureCollection>;
  videoCarouselCollection?: Maybe<VideoCarouselCollection>;
  videoWithContentCollection?: Maybe<VideoWithContentCollection>;
};


export type ContentSectionLinkingCollectionsAccordionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentSectionLinkingCollectionsAccordionsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentSectionLinkingCollectionsBlogDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentSectionLinkingCollectionsBlogDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentSectionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentSectionLinkingCollectionsProductFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentSectionLinkingCollectionsProductFeatureCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentSectionLinkingCollectionsVideoCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentSectionLinkingCollectionsVideoCarouselCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentSectionLinkingCollectionsVideoWithContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentSectionLinkingCollectionsVideoWithContentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentSectionLinkingCollectionsAccordionsCollectionOrder =
  | 'accordionsHeading_ASC'
  | 'accordionsHeading_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonCollectionAlignment_ASC'
  | 'buttonCollectionAlignment_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'descriptionAlignment_ASC'
  | 'descriptionAlignment_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'expandIconPosition_ASC'
  | 'expandIconPosition_DESC'
  | 'expandIconType_ASC'
  | 'expandIconType_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'imagePositionRight_ASC'
  | 'imagePositionRight_DESC'
  | 'imageRoundedCorner_ASC'
  | 'imageRoundedCorner_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'roundedCornersSize_ASC'
  | 'roundedCornersSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleAlignment_ASC'
  | 'titleAlignment_DESC'
  | 'titleColor_ASC'
  | 'titleColor_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'withInnerGap_ASC'
  | 'withInnerGap_DESC';

export type ContentSectionLinkingCollectionsBlogDetailsPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentSectionLinkingCollectionsProductFeatureCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'enableSliderControlsBackgroundGradient_ASC'
  | 'enableSliderControlsBackgroundGradient_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentSectionLinkingCollectionsVideoCarouselCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'desktopVideosAspectRatio_ASC'
  | 'desktopVideosAspectRatio_DESC'
  | 'mobileVideosAspectRatio_ASC'
  | 'mobileVideosAspectRatio_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentSectionLinkingCollectionsVideoWithContentCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentSectionOrder =
  | 'alignment_ASC'
  | 'alignment_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'titleIcon_ASC'
  | 'titleIcon_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** Content tile with an Image, Title and Description which is used to display in the Header Navigation Menu [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentTile) */
export type ContentTile = Entry & _Node & {
  __typename?: 'ContentTile';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['JSON']['output']>;
  internalPage?: Maybe<Page>;
  linkedFrom?: Maybe<ContentTileLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** Content tile with an Image, Title and Description which is used to display in the Header Navigation Menu [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentTile) */
export type ContentTileDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content tile with an Image, Title and Description which is used to display in the Header Navigation Menu [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentTile) */
export type ContentTileExternalUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content tile with an Image, Title and Description which is used to display in the Header Navigation Menu [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentTile) */
export type ContentTileImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content tile with an Image, Title and Description which is used to display in the Header Navigation Menu [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentTile) */
export type ContentTileInternalPageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageFilter>;
};


/** Content tile with an Image, Title and Description which is used to display in the Header Navigation Menu [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentTile) */
export type ContentTileLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Content tile with an Image, Title and Description which is used to display in the Header Navigation Menu [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentTile) */
export type ContentTileNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content tile with an Image, Title and Description which is used to display in the Header Navigation Menu [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentTile) */
export type ContentTileTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ContentTileCollection = {
  __typename?: 'ContentTileCollection';
  items: Array<Maybe<ContentTile>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentTileFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentTileFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentTileFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  externalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  externalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalUrl_not?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalPage?: InputMaybe<CfPageNestedFilter>;
  internalPage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentTileLinkingCollections = {
  __typename?: 'ContentTileLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  headerSubNavCollection?: Maybe<HeaderSubNavCollection>;
};


export type ContentTileLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentTileLinkingCollectionsHeaderSubNavCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTileLinkingCollectionsHeaderSubNavCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentTileLinkingCollectionsHeaderSubNavCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentTileOrder =
  | 'description_ASC'
  | 'description_DESC'
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichText = Entry & _Node & {
  __typename?: 'ContentTypeRichText';
  _id: Scalars['ID']['output'];
  analyticsContext?: Maybe<AnalyticsContext>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  buttonsCollection?: Maybe<ContentTypeRichTextButtonsCollection>;
  centerAlign?: Maybe<Scalars['Boolean']['output']>;
  contained?: Maybe<Scalars['Boolean']['output']>;
  content?: Maybe<ContentTypeRichTextContent>;
  contentMaxWidth?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  disablePaddingOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  facilitySegmentCollection?: Maybe<Scalars['String']['output']>;
  fullWidth?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentTypeRichTextLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  secondaryContent?: Maybe<ContentTypeRichTextSecondaryContent>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  titleHeading?: Maybe<Scalars['String']['output']>;
  titleIcon?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextAnalyticsContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextCenterAlignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextContainedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextContentMaxWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextDisablePaddingOnArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextFacilitySegmentCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextFullWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextSecondaryContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextTitleHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextTitleIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ContentTypeRichTextButtonsCollection = {
  __typename?: 'ContentTypeRichTextButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentTypeRichTextButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ContentTypeRichTextCollection = {
  __typename?: 'ContentTypeRichTextCollection';
  items: Array<Maybe<ContentTypeRichText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentTypeRichTextContent = {
  __typename?: 'ContentTypeRichTextContent';
  json: Scalars['JSON']['output'];
  links: ContentTypeRichTextContentLinks;
};

export type ContentTypeRichTextContentAssets = {
  __typename?: 'ContentTypeRichTextContentAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ContentTypeRichTextContentEntries = {
  __typename?: 'ContentTypeRichTextContentEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ContentTypeRichTextContentLinks = {
  __typename?: 'ContentTypeRichTextContentLinks';
  assets: ContentTypeRichTextContentAssets;
  entries: ContentTypeRichTextContentEntries;
  resources: ContentTypeRichTextContentResources;
};

export type ContentTypeRichTextContentResources = {
  __typename?: 'ContentTypeRichTextContentResources';
  block: Array<ContentTypeRichTextContentResourcesBlock>;
  hyperlink: Array<ContentTypeRichTextContentResourcesHyperlink>;
  inline: Array<ContentTypeRichTextContentResourcesInline>;
};

export type ContentTypeRichTextContentResourcesBlock = ResourceLink & {
  __typename?: 'ContentTypeRichTextContentResourcesBlock';
  sys: ResourceSys;
};

export type ContentTypeRichTextContentResourcesHyperlink = ResourceLink & {
  __typename?: 'ContentTypeRichTextContentResourcesHyperlink';
  sys: ResourceSys;
};

export type ContentTypeRichTextContentResourcesInline = ResourceLink & {
  __typename?: 'ContentTypeRichTextContentResourcesInline';
  sys: ResourceSys;
};

export type ContentTypeRichTextFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentTypeRichTextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentTypeRichTextFilter>>>;
  analyticsContext?: InputMaybe<CfAnalyticsContextNestedFilter>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign_not?: InputMaybe<Scalars['Boolean']['input']>;
  contained?: InputMaybe<Scalars['Boolean']['input']>;
  contained_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contained_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentMaxWidth?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_contains?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentMaxWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentMaxWidth_not?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content_contains?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  secondaryContent_contains?: InputMaybe<Scalars['String']['input']>;
  secondaryContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryContent_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHeading?: InputMaybe<Scalars['String']['input']>;
  titleHeading_contains?: InputMaybe<Scalars['String']['input']>;
  titleHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHeading_not?: InputMaybe<Scalars['String']['input']>;
  titleHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleIcon?: InputMaybe<Scalars['String']['input']>;
  titleIcon_contains?: InputMaybe<Scalars['String']['input']>;
  titleIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleIcon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleIcon_not?: InputMaybe<Scalars['String']['input']>;
  titleIcon_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleIcon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentTypeRichTextLinkingCollections = {
  __typename?: 'ContentTypeRichTextLinkingCollections';
  accordionsCollection?: Maybe<AccordionsCollection>;
  agendaModalCollection?: Maybe<AgendaModalCollection>;
  agendaStepperCollection?: Maybe<AgendaStepperCollection>;
  bannerCollection?: Maybe<BannerCollection>;
  blogDetailsPageCollection?: Maybe<BlogDetailsPageCollection>;
  categoryPickerCollection?: Maybe<CategoryPickerCollection>;
  columnsCollection?: Maybe<ColumnsCollection>;
  disclaimerV2Collection?: Maybe<DisclaimerV2Collection>;
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  localizedServiceTitleCollection?: Maybe<LocalizedServiceTitleCollection>;
  odpHeroCollection?: Maybe<OdpHeroCollection>;
  pageCollection?: Maybe<PageCollection>;
  productFeatureCollection?: Maybe<ProductFeatureCollection>;
  productFeatureDescriptionListItemCollection?: Maybe<ProductFeatureDescriptionListItemCollection>;
  segmentsContainerCollection?: Maybe<SegmentsContainerCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceLineHeroCollection?: Maybe<ServiceLineHeroCollection>;
};


export type ContentTypeRichTextLinkingCollectionsAccordionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsAccordionsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsAgendaModalCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsAgendaModalCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsAgendaStepperCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsAgendaStepperCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsBannerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsBlogDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsBlogDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsCategoryPickerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsCategoryPickerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsColumnsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsColumnsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsDisclaimerV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsDisclaimerV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsLocalizedServiceTitleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsLocalizedServiceTitleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsOdpHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsOdpHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsProductFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsProductFeatureCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsProductFeatureDescriptionListItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsProductFeatureDescriptionListItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsSegmentsContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsSegmentsContainerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsServiceLineHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsServiceLineHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentTypeRichTextLinkingCollectionsAccordionsCollectionOrder =
  | 'accordionsHeading_ASC'
  | 'accordionsHeading_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonCollectionAlignment_ASC'
  | 'buttonCollectionAlignment_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'descriptionAlignment_ASC'
  | 'descriptionAlignment_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'expandIconPosition_ASC'
  | 'expandIconPosition_DESC'
  | 'expandIconType_ASC'
  | 'expandIconType_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'imagePositionRight_ASC'
  | 'imagePositionRight_DESC'
  | 'imageRoundedCorner_ASC'
  | 'imageRoundedCorner_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'roundedCornersSize_ASC'
  | 'roundedCornersSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleAlignment_ASC'
  | 'titleAlignment_DESC'
  | 'titleColor_ASC'
  | 'titleColor_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'withInnerGap_ASC'
  | 'withInnerGap_DESC';

export type ContentTypeRichTextLinkingCollectionsAgendaModalCollectionOrder =
  | 'headlineHeading_ASC'
  | 'headlineHeading_DESC'
  | 'headlineText_ASC'
  | 'headlineText_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'modalName_ASC'
  | 'modalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentTypeRichTextLinkingCollectionsAgendaStepperCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'areStepsCenteredForMobile_ASC'
  | 'areStepsCenteredForMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'hideStepperDot_ASC'
  | 'hideStepperDot_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isHighlightedSteps_ASC'
  | 'isHighlightedSteps_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useNumericStepper_ASC'
  | 'useNumericStepper_DESC';

export type ContentTypeRichTextLinkingCollectionsBannerCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ContentTypeRichTextLinkingCollectionsBlogDetailsPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextLinkingCollectionsCategoryPickerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'eyebrowHeading_ASC'
  | 'eyebrowHeading_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'mobileThreshold_ASC'
  | 'mobileThreshold_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'setTwoRows_ASC'
  | 'setTwoRows_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'transparentCategories_ASC'
  | 'transparentCategories_DESC';

export type ContentTypeRichTextLinkingCollectionsColumnsCollectionOrder =
  | 'allowEqualHeights_ASC'
  | 'allowEqualHeights_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'mobileDisplayAccordion_ASC'
  | 'mobileDisplayAccordion_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextLinkingCollectionsDisclaimerV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type ContentTypeRichTextLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextLinkingCollectionsLocalizedServiceTitleCollectionOrder =
  | 'callCenterLabel_ASC'
  | 'callCenterLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showAddress_ASC'
  | 'showAddress_DESC'
  | 'showHours_ASC'
  | 'showHours_DESC'
  | 'showPhoneNumber_ASC'
  | 'showPhoneNumber_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextLinkingCollectionsOdpHeroCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'appointmentDataSource_ASC'
  | 'appointmentDataSource_DESC'
  | 'callCenterLabel_ASC'
  | 'callCenterLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'promoTitle_ASC'
  | 'promoTitle_DESC'
  | 'showAddress_ASC'
  | 'showAddress_DESC'
  | 'showEmail_ASC'
  | 'showEmail_DESC'
  | 'showFax_ASC'
  | 'showFax_DESC'
  | 'showHours_ASC'
  | 'showHours_DESC'
  | 'showLocationStatusBadge_ASC'
  | 'showLocationStatusBadge_DESC'
  | 'showPhoneNumber_ASC'
  | 'showPhoneNumber_DESC'
  | 'showReviews_ASC'
  | 'showReviews_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextLinkingCollectionsProductFeatureCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'enableSliderControlsBackgroundGradient_ASC'
  | 'enableSliderControlsBackgroundGradient_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentTypeRichTextLinkingCollectionsProductFeatureDescriptionListItemCollectionOrder =
  | 'icon_ASC'
  | 'icon_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentTypeRichTextLinkingCollectionsSegmentsContainerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentTypeRichTextLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextLinkingCollectionsServiceLineHeroCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type ContentTypeRichTextOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'titleIcon_ASC'
  | 'titleIcon_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextSecondaryContent = {
  __typename?: 'ContentTypeRichTextSecondaryContent';
  json: Scalars['JSON']['output'];
  links: ContentTypeRichTextSecondaryContentLinks;
};

export type ContentTypeRichTextSecondaryContentAssets = {
  __typename?: 'ContentTypeRichTextSecondaryContentAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ContentTypeRichTextSecondaryContentEntries = {
  __typename?: 'ContentTypeRichTextSecondaryContentEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ContentTypeRichTextSecondaryContentLinks = {
  __typename?: 'ContentTypeRichTextSecondaryContentLinks';
  assets: ContentTypeRichTextSecondaryContentAssets;
  entries: ContentTypeRichTextSecondaryContentEntries;
  resources: ContentTypeRichTextSecondaryContentResources;
};

export type ContentTypeRichTextSecondaryContentResources = {
  __typename?: 'ContentTypeRichTextSecondaryContentResources';
  block: Array<ContentTypeRichTextSecondaryContentResourcesBlock>;
  hyperlink: Array<ContentTypeRichTextSecondaryContentResourcesHyperlink>;
  inline: Array<ContentTypeRichTextSecondaryContentResourcesInline>;
};

export type ContentTypeRichTextSecondaryContentResourcesBlock = ResourceLink & {
  __typename?: 'ContentTypeRichTextSecondaryContentResourcesBlock';
  sys: ResourceSys;
};

export type ContentTypeRichTextSecondaryContentResourcesHyperlink = ResourceLink & {
  __typename?: 'ContentTypeRichTextSecondaryContentResourcesHyperlink';
  sys: ResourceSys;
};

export type ContentTypeRichTextSecondaryContentResourcesInline = ResourceLink & {
  __typename?: 'ContentTypeRichTextSecondaryContentResourcesInline';
  sys: ResourceSys;
};

export type ContentfulMetadata = {
  __typename?: 'ContentfulMetadata';
  concepts: Array<Maybe<TaxonomyConcept>>;
  tags: Array<Maybe<ContentfulTag>>;
};

export type ContentfulMetadataConceptsDescendantsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulMetadataConceptsFilter = {
  descendants?: InputMaybe<ContentfulMetadataConceptsDescendantsFilter>;
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulMetadataFilter = {
  concepts?: InputMaybe<ContentfulMetadataConceptsFilter>;
  concepts_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<ContentfulMetadataTagsFilter>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulMetadataTagsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *       Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type ContentfulTag = {
  __typename?: 'ContentfulTag';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CreateTimeslotReservationError = NotAvailableSlotError | TimeslotAlreadyReservedError;

export type CreateTimeslotReservationInput = {
  scheduleSlotUid: Scalars['NonEmptyString']['input'];
};

export type CreateTimeslotReservationPayload = {
  __typename?: 'CreateTimeslotReservationPayload';
  errors?: Maybe<Array<CreateTimeslotReservationError>>;
  result?: Maybe<CreatedTimeslotReservation>;
};

export type CreatedTimeslotReservation = {
  __typename?: 'CreatedTimeslotReservation';
  scheduleSlotUid: Scalars['String']['output'];
};

export type DayOfWeek =
  | 'FRIDAY'
  | 'MONDAY'
  | 'SATURDAY'
  | 'SUNDAY'
  | 'THURSDAY'
  | 'TUESDAY'
  | 'WEDNESDAY';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/DisclaimerV2) */
export type DisclaimerV2 = Entry & _Node & {
  __typename?: 'DisclaimerV2';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  disclaimer?: Maybe<ContentTypeRichText>;
  entryName?: Maybe<Scalars['String']['output']>;
  facilitySegmentCollection?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<DisclaimerV2LinkingCollections>;
  size?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  templateWidth?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/DisclaimerV2) */
export type DisclaimerV2AnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/DisclaimerV2) */
export type DisclaimerV2DisclaimerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/DisclaimerV2) */
export type DisclaimerV2EntryNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/DisclaimerV2) */
export type DisclaimerV2FacilitySegmentCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/DisclaimerV2) */
export type DisclaimerV2LinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/DisclaimerV2) */
export type DisclaimerV2SizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/DisclaimerV2) */
export type DisclaimerV2TemplateWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type DisclaimerV2Collection = {
  __typename?: 'DisclaimerV2Collection';
  items: Array<Maybe<DisclaimerV2>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type DisclaimerV2Filter = {
  AND?: InputMaybe<Array<InputMaybe<DisclaimerV2Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<DisclaimerV2Filter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disclaimer?: InputMaybe<CfContentTypeRichTextNestedFilter>;
  disclaimer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName?: InputMaybe<Scalars['String']['input']>;
  entryName_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryName_not?: InputMaybe<Scalars['String']['input']>;
  entryName_not_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size?: InputMaybe<Scalars['String']['input']>;
  size_contains?: InputMaybe<Scalars['String']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size_not?: InputMaybe<Scalars['String']['input']>;
  size_not_contains?: InputMaybe<Scalars['String']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  templateWidth?: InputMaybe<Scalars['String']['input']>;
  templateWidth_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateWidth_not?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DisclaimerV2LinkingCollections = {
  __typename?: 'DisclaimerV2LinkingCollections';
  adFooterCollection?: Maybe<AdFooterCollection>;
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  halfScreenCollection?: Maybe<HalfScreenCollection>;
  heroV2Collection?: Maybe<HeroV2Collection>;
  pageCollection?: Maybe<PageCollection>;
  productFeatureCollection?: Maybe<ProductFeatureCollection>;
  segmentsContainerCollection?: Maybe<SegmentsContainerCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
};


export type DisclaimerV2LinkingCollectionsAdFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsAdFooterCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type DisclaimerV2LinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type DisclaimerV2LinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type DisclaimerV2LinkingCollectionsHalfScreenCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsHalfScreenCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type DisclaimerV2LinkingCollectionsHeroV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsHeroV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type DisclaimerV2LinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type DisclaimerV2LinkingCollectionsProductFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsProductFeatureCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type DisclaimerV2LinkingCollectionsSegmentsContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsSegmentsContainerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type DisclaimerV2LinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type DisclaimerV2LinkingCollectionsAdFooterCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'contactNumber_ASC'
  | 'contactNumber_DESC'
  | 'copyright_ASC'
  | 'copyright_DESC'
  | 'isLightFooter_ASC'
  | 'isLightFooter_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useDesktopStickyFooter_ASC'
  | 'useDesktopStickyFooter_DESC'
  | 'useMobileStickyFooter_ASC'
  | 'useMobileStickyFooter_DESC';

export type DisclaimerV2LinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type DisclaimerV2LinkingCollectionsHalfScreenCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC';

export type DisclaimerV2LinkingCollectionsHeroV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type DisclaimerV2LinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type DisclaimerV2LinkingCollectionsProductFeatureCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'enableSliderControlsBackgroundGradient_ASC'
  | 'enableSliderControlsBackgroundGradient_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type DisclaimerV2LinkingCollectionsSegmentsContainerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type DisclaimerV2LinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type DisclaimerV2Order =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type Entry = {
  contentfulMetadata: ContentfulMetadata;
  sys: Sys;
};

export type EntryCollection = {
  __typename?: 'EntryCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type EntryFilter = {
  AND?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type EntryOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type Error = {
  message: Scalars['String']['output'];
};

/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404 = Entry & _Node & {
  __typename?: 'Error404';
  _id: Scalars['ID']['output'];
  analyticsContext?: Maybe<AnalyticsContext>;
  backgroundImage?: Maybe<Asset>;
  backgroundImageMobile?: Maybe<Asset>;
  body?: Maybe<Scalars['String']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  darkTextColor?: Maybe<Scalars['Boolean']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<Error404LinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404AnalyticsContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404BackgroundImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404BackgroundImageMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404BodyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404ButtonLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404DarkTextColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404HeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404LinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404NameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404SubtitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type Error404Collection = {
  __typename?: 'Error404Collection';
  items: Array<Maybe<Error404>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Error404Filter = {
  AND?: InputMaybe<Array<InputMaybe<Error404Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<Error404Filter>>>;
  analyticsContext?: InputMaybe<CfAnalyticsContextNestedFilter>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImageMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_exists?: InputMaybe<Scalars['Boolean']['input']>;
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_not?: InputMaybe<Scalars['String']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLabel_not?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  darkTextColor?: InputMaybe<Scalars['Boolean']['input']>;
  darkTextColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  darkTextColor_not?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not?: InputMaybe<Scalars['String']['input']>;
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  subtitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type Error404LinkingCollections = {
  __typename?: 'Error404LinkingCollections';
  appCollection?: Maybe<AppCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type Error404LinkingCollectionsAppCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Error404LinkingCollectionsAppCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type Error404LinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type Error404LinkingCollectionsAppCollectionOrder =
  | 'brandImageLink_ASC'
  | 'brandImageLink_DESC'
  | 'branding_ASC'
  | 'branding_DESC'
  | 'isDeprecated_ASC'
  | 'isDeprecated_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type Error404Order =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'heading_ASC'
  | 'heading_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subtitle_ASC'
  | 'subtitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type FacilitiesFilterInput = {
  brand?: InputMaybe<FacilityBrand>;
};

export type FacilitiesList = {
  __typename?: 'FacilitiesList';
  items: Array<Facility>;
  total: Scalars['Int']['output'];
};

export type Facility = {
  __typename?: 'Facility';
  /** @deprecated Use address fields from facility.Location */
  address: FacilityAddress;
  brand: FacilityBrand;
  code: Scalars['String']['output'];
  comingSoon: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  googleCategories?: Maybe<Array<Scalars['String']['output']>>;
  googlePrimaryCategory?: Maybe<Scalars['String']['output']>;
  identifiers?: Maybe<FacilityIdentifiers>;
  insuranceInfo?: Maybe<FacilityInsuranceInfo>;
  location?: Maybe<FacilityLocation>;
  name: Scalars['String']['output'];
  nearbyFacilities?: Maybe<NearbyFacilitiesList>;
  nearbyRescheduleFacilities?: Maybe<NearbyFacilitiesList>;
  /** @deprecated Use Facility.WorkingHours field. */
  officeWorkingHours: Array<WorkingHours>;
  openDate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use phone number from facility.TechnicalInfrastructure. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pilots?: Maybe<FacilityPilots>;
  procedurePrices?: Maybe<ProcedurePricesList>;
  providers?: Maybe<Array<Provider>>;
  rescheduleSlots?: Maybe<RescheduleSlotsList>;
  reviews?: Maybe<ReviewWithSummary>;
  scheduling?: Maybe<FacilityScheduling>;
  /** @deprecated It is moved to Facility.Scheduling. */
  schedulingUrl?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<Service>>;
  shortName?: Maybe<Scalars['String']['output']>;
  specialHandling?: Maybe<Scalars['String']['output']>;
  subBrand?: Maybe<Scalars['String']['output']>;
  technicalInfrastructure?: Maybe<FacilityTechnicalInfrastructure>;
  /** Working hours for next seven days. */
  workingHours?: Maybe<Array<FacilityDailyWorkingHours>>;
};


export type FacilityNearbyFacilitiesArgs = {
  filter: NearbyFacilitiesFilter;
  skip?: Scalars['NonNegativeInt']['input'];
  take?: Scalars['NonNegativeInt']['input'];
};


export type FacilityNearbyRescheduleFacilitiesArgs = {
  filter: NearbyRescheduleFacilitiesFilter;
  take?: Scalars['NonNegativeInt']['input'];
};


export type FacilityProcedurePricesArgs = {
  filter?: InputMaybe<ProceduresPricesFilterInput>;
  skip?: Scalars['NonNegativeInt']['input'];
  take?: Scalars['NonNegativeInt']['input'];
};


export type FacilityRescheduleSlotsArgs = {
  filter: RescheduleSlotsFilter;
};

export type FacilityAddress = {
  __typename?: 'FacilityAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type FacilityBrand =
  | 'ASPEN_DENTAL'
  | 'AZ_PET'
  | 'CHAPTER'
  | 'CLEAR_CHOICE'
  | 'WELL_NOW';

export type FacilityDailyWorkingHours = {
  __typename?: 'FacilityDailyWorkingHours';
  date: Scalars['Date']['output'];
  open?: Maybe<FacilityWorkingHours>;
};

/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPage = Entry & _Node & {
  __typename?: 'FacilityDetailsPage';
  _id: Scalars['ID']['output'];
  analyticsContext?: Maybe<AnalyticsContext>;
  appName?: Maybe<Scalars['String']['output']>;
  canonical?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  contentsCollection?: Maybe<FacilityDetailsPageContentsCollection>;
  description?: Maybe<Scalars['String']['output']>;
  disableHeaderBottomAlertBanner?: Maybe<Scalars['Boolean']['output']>;
  disableHeaderTopAlertBanner?: Maybe<Scalars['Boolean']['output']>;
  disableStickyFooterOnDesktop?: Maybe<Scalars['Boolean']['output']>;
  disableStickyFooterOnMobile?: Maybe<Scalars['Boolean']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  indexed?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<FacilityDetailsPageLinkingCollections>;
  moreTextSeo?: Maybe<FacilityDetailsPageMoreTextSeo>;
  name?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<ImageAsset>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  textSeo?: Maybe<FacilityDetailsPageTextSeo>;
  title?: Maybe<Scalars['String']['output']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageAnalyticsContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageAppNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageCanonicalArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageContentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FacilityDetailsPageContentsFilter>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageDisableHeaderBottomAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageDisableHeaderTopAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageDisableStickyFooterOnDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageDisableStickyFooterOnMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageFacilityIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageIndexedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageMoreTextSeoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageOgImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPagePageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPagePathArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageTagsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageTextSeoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type FacilityDetailsPageCollection = {
  __typename?: 'FacilityDetailsPageCollection';
  items: Array<Maybe<FacilityDetailsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FacilityDetailsPageContentsCollection = {
  __typename?: 'FacilityDetailsPageContentsCollection';
  items: Array<Maybe<FacilityDetailsPageContentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FacilityDetailsPageContentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<FacilityDetailsPageContentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FacilityDetailsPageContentsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type FacilityDetailsPageContentsItem = Accordions | BirdEyeReviews | BlogList | CategoryPicker | Columns | ContentTypeRichText | DisclaimerV2 | GoogleMapTemplate | HalfScreen | HeroV2 | Marquee | MeetOurStaff | MultiCardV2 | OdpHero | PatientReviewsV2 | ProductDisplay | ProductFeature | QuickLinks | Quiz | Schema | SegmentsContainer | ServiceLineHero | SingleMessage | Spacer | Tabs;

export type FacilityDetailsPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<FacilityDetailsPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FacilityDetailsPageFilter>>>;
  analyticsContext?: InputMaybe<CfAnalyticsContextNestedFilter>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appName?: InputMaybe<Scalars['String']['input']>;
  appName_contains?: InputMaybe<Scalars['String']['input']>;
  appName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appName_not?: InputMaybe<Scalars['String']['input']>;
  appName_not_contains?: InputMaybe<Scalars['String']['input']>;
  appName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonical?: InputMaybe<Scalars['String']['input']>;
  canonical_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonical_not?: InputMaybe<Scalars['String']['input']>;
  canonical_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  contents?: InputMaybe<CfcontentsMultiTypeNestedFilter>;
  contentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disableHeaderBottomAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  facilityId_contains?: InputMaybe<Scalars['String']['input']>;
  facilityId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilityId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityId_not?: InputMaybe<Scalars['String']['input']>;
  facilityId_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilityId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  indexed?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_not?: InputMaybe<Scalars['Boolean']['input']>;
  moreTextSeo_contains?: InputMaybe<Scalars['String']['input']>;
  moreTextSeo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  moreTextSeo_not_contains?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImage?: InputMaybe<CfImageAssetNestedFilter>;
  ogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  pageTitle_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle_not?: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path?: InputMaybe<Scalars['String']['input']>;
  path_contains?: InputMaybe<Scalars['String']['input']>;
  path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_not?: InputMaybe<Scalars['String']['input']>;
  path_not_contains?: InputMaybe<Scalars['String']['input']>;
  path_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textSeo_contains?: InputMaybe<Scalars['String']['input']>;
  textSeo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textSeo_not_contains?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FacilityDetailsPageLinkingCollections = {
  __typename?: 'FacilityDetailsPageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  navigationLinkCollection?: Maybe<NavigationLinkCollection>;
};


export type FacilityDetailsPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FacilityDetailsPageLinkingCollectionsNavigationLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FacilityDetailsPageLinkingCollectionsNavigationLinkCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type FacilityDetailsPageLinkingCollectionsNavigationLinkCollectionOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type FacilityDetailsPageMoreTextSeo = {
  __typename?: 'FacilityDetailsPageMoreTextSeo';
  json: Scalars['JSON']['output'];
  links: FacilityDetailsPageMoreTextSeoLinks;
};

export type FacilityDetailsPageMoreTextSeoAssets = {
  __typename?: 'FacilityDetailsPageMoreTextSeoAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type FacilityDetailsPageMoreTextSeoEntries = {
  __typename?: 'FacilityDetailsPageMoreTextSeoEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type FacilityDetailsPageMoreTextSeoLinks = {
  __typename?: 'FacilityDetailsPageMoreTextSeoLinks';
  assets: FacilityDetailsPageMoreTextSeoAssets;
  entries: FacilityDetailsPageMoreTextSeoEntries;
  resources: FacilityDetailsPageMoreTextSeoResources;
};

export type FacilityDetailsPageMoreTextSeoResources = {
  __typename?: 'FacilityDetailsPageMoreTextSeoResources';
  block: Array<FacilityDetailsPageMoreTextSeoResourcesBlock>;
  hyperlink: Array<FacilityDetailsPageMoreTextSeoResourcesHyperlink>;
  inline: Array<FacilityDetailsPageMoreTextSeoResourcesInline>;
};

export type FacilityDetailsPageMoreTextSeoResourcesBlock = ResourceLink & {
  __typename?: 'FacilityDetailsPageMoreTextSeoResourcesBlock';
  sys: ResourceSys;
};

export type FacilityDetailsPageMoreTextSeoResourcesHyperlink = ResourceLink & {
  __typename?: 'FacilityDetailsPageMoreTextSeoResourcesHyperlink';
  sys: ResourceSys;
};

export type FacilityDetailsPageMoreTextSeoResourcesInline = ResourceLink & {
  __typename?: 'FacilityDetailsPageMoreTextSeoResourcesInline';
  sys: ResourceSys;
};

export type FacilityDetailsPageOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type FacilityDetailsPageTextSeo = {
  __typename?: 'FacilityDetailsPageTextSeo';
  json: Scalars['JSON']['output'];
  links: FacilityDetailsPageTextSeoLinks;
};

export type FacilityDetailsPageTextSeoAssets = {
  __typename?: 'FacilityDetailsPageTextSeoAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type FacilityDetailsPageTextSeoEntries = {
  __typename?: 'FacilityDetailsPageTextSeoEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type FacilityDetailsPageTextSeoLinks = {
  __typename?: 'FacilityDetailsPageTextSeoLinks';
  assets: FacilityDetailsPageTextSeoAssets;
  entries: FacilityDetailsPageTextSeoEntries;
  resources: FacilityDetailsPageTextSeoResources;
};

export type FacilityDetailsPageTextSeoResources = {
  __typename?: 'FacilityDetailsPageTextSeoResources';
  block: Array<FacilityDetailsPageTextSeoResourcesBlock>;
  hyperlink: Array<FacilityDetailsPageTextSeoResourcesHyperlink>;
  inline: Array<FacilityDetailsPageTextSeoResourcesInline>;
};

export type FacilityDetailsPageTextSeoResourcesBlock = ResourceLink & {
  __typename?: 'FacilityDetailsPageTextSeoResourcesBlock';
  sys: ResourceSys;
};

export type FacilityDetailsPageTextSeoResourcesHyperlink = ResourceLink & {
  __typename?: 'FacilityDetailsPageTextSeoResourcesHyperlink';
  sys: ResourceSys;
};

export type FacilityDetailsPageTextSeoResourcesInline = ResourceLink & {
  __typename?: 'FacilityDetailsPageTextSeoResourcesInline';
  sys: ResourceSys;
};

export type FacilityIdentifiers = {
  __typename?: 'FacilityIdentifiers';
  birdeyeBusinessId?: Maybe<Scalars['String']['output']>;
  legalBillingName?: Maybe<Scalars['String']['output']>;
};

export type FacilityInsuranceInfo = {
  __typename?: 'FacilityInsuranceInfo';
  companies: Array<InsuranceCompany>;
  networks: Array<InsuranceCompaniesNetwork>;
};

export type FacilityLocation = {
  __typename?: 'FacilityLocation';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  dst: Scalars['Boolean']['output'];
  ianaTimeZone: Scalars['String']['output'];
  landmarks?: Maybe<Scalars['String']['output']>;
  latitude: Scalars['Decimal']['output'];
  longitude: Scalars['Decimal']['output'];
  neighbouringAreas?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  slugXml?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type FacilityPilots = {
  __typename?: 'FacilityPilots';
  anytimeAppointingDenture: Scalars['Boolean']['output'];
  anytimeAppointingMotto: Scalars['Boolean']['output'];
  needsBasedQuestions: Scalars['Boolean']['output'];
  onHvp: Scalars['Boolean']['output'];
  onMotto: Scalars['Boolean']['output'];
};

export type FacilityScheduling = {
  __typename?: 'FacilityScheduling';
  /** Represents adult visit duration in minutes. */
  adultExamDuration?: Maybe<Scalars['Int']['output']>;
  /** Represents facility's max number of days in future for querying slots. */
  bookingWindowLimit?: Maybe<Scalars['Int']['output']>;
  /** Represents child visit duration in minutes. */
  childExamDuration?: Maybe<Scalars['Int']['output']>;
  minimalPatientAge?: Maybe<Scalars['Int']['output']>;
  schedulingUrl?: Maybe<Scalars['String']['output']>;
};

export type FacilityService =
  | 'HEALTHY_MOUTH_MOVEMENT'
  | 'INVISALIGN'
  | 'MOTTO';

export type FacilityServiceBrand =
  | 'ASPEN_DENTAL'
  | 'INVISALIGN'
  | 'MOTTO';

export type FacilityServiceType =
  | 'CLEAR_ALIGNERS'
  | 'IMPLANTS'
  | 'SPANISH_SPEAKING';

export type FacilityTechnicalInfrastructure = {
  __typename?: 'FacilityTechnicalInfrastructure';
  email?: Maybe<Scalars['String']['output']>;
  emergencyPhoneNumber?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  firstThreeOctets?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type FacilityWithScheduleSlots = {
  __typename?: 'FacilityWithScheduleSlots';
  facility: Facility;
  slots?: Maybe<ScheduleSlotsList>;
};

export type FacilityWorkingHours = {
  __typename?: 'FacilityWorkingHours';
  from?: Maybe<Scalars['LocalTime']['output']>;
  fromTimestamp?: Maybe<Scalars['DateTime']['output']>;
  to?: Maybe<Scalars['LocalTime']['output']>;
  toTimestamp?: Maybe<Scalars['DateTime']['output']>;
};

/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlags = Entry & _Node & {
  __typename?: 'FeatureFlags';
  _id: Scalars['ID']['output'];
  ameliaChat?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contentfulMetadata: ContentfulMetadata;
  continentalUsMapFallbackThreshold?: Maybe<Scalars['Int']['output']>;
  defaultToCdn?: Maybe<Scalars['Boolean']['output']>;
  doNotIndexWholeSite?: Maybe<Scalars['Boolean']['output']>;
  enableFacilityContextInSsr?: Maybe<Scalars['Boolean']['output']>;
  enableFluidTypography?: Maybe<Scalars['Boolean']['output']>;
  enablePatientPortalNavigation?: Maybe<Scalars['Boolean']['output']>;
  enablePatientPortalPhase2?: Maybe<Scalars['Boolean']['output']>;
  enableProvidersSitemap?: Maybe<Scalars['Boolean']['output']>;
  enablePtcSlotFilter?: Maybe<Scalars['Boolean']['output']>;
  enforceContinentalUsZoom?: Maybe<Scalars['Boolean']['output']>;
  featureList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fetchAllLocationsOnEmptyResults?: Maybe<Scalars['Boolean']['output']>;
  hideHeaderFacilityLocator?: Maybe<Scalars['Boolean']['output']>;
  hideHeaderSchedulingButton?: Maybe<Scalars['Boolean']['output']>;
  hideOdpHeaderLinks?: Maybe<Scalars['Boolean']['output']>;
  hideProviderWithNoImage?: Maybe<Scalars['Boolean']['output']>;
  hideSearchWithLocationCards?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<FeatureFlagsLinkingCollections>;
  loadFacilityReviewsFromBeffe?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onPageScheduling?: Maybe<Scalars['Boolean']['output']>;
  onPageSchedulingLocations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  providerHeroTheme?: Maybe<Scalars['String']['output']>;
  salesForceEvergageScript?: Maybe<Scalars['String']['output']>;
  showHeaderNavigationMenu?: Maybe<Scalars['Boolean']['output']>;
  showHeaderWithLocationNav?: Maybe<Scalars['Boolean']['output']>;
  showMobileHeaderLocationBar?: Maybe<Scalars['Boolean']['output']>;
  showProviderPageCtaInMeetOurStaff?: Maybe<Scalars['Boolean']['output']>;
  showProviderPageInsuranceInfo?: Maybe<Scalars['Boolean']['output']>;
  showReadMoreForBioInMeetOurStaff?: Maybe<Scalars['Boolean']['output']>;
  showSetOfficeButtonInGoogleMapsCards?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  transitionallyUseBeffe?: Maybe<Scalars['Boolean']['output']>;
  useFacilityBeffeDataSource?: Maybe<Scalars['Boolean']['output']>;
  useFilterForOdpDetailsContent?: Maybe<Scalars['Boolean']['output']>;
  useGoogleMapAutocompleteSearch?: Maybe<Scalars['Boolean']['output']>;
  useInlineOneTrust?: Maybe<Scalars['Boolean']['output']>;
  useSessionStorageFacilityCode?: Maybe<Scalars['Boolean']['output']>;
  useSimpleFindOfficeLink?: Maybe<Scalars['Boolean']['output']>;
  withLeadingProviderAssociations?: Maybe<Scalars['Boolean']['output']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsAmeliaChatArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsContinentalUsMapFallbackThresholdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsDefaultToCdnArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsDoNotIndexWholeSiteArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsEnableFacilityContextInSsrArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsEnableFluidTypographyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsEnablePatientPortalNavigationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsEnablePatientPortalPhase2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsEnableProvidersSitemapArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsEnablePtcSlotFilterArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsEnforceContinentalUsZoomArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsFeatureListArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsFetchAllLocationsOnEmptyResultsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsHideHeaderFacilityLocatorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsHideHeaderSchedulingButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsHideOdpHeaderLinksArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsHideProviderWithNoImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsHideSearchWithLocationCardsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsLoadFacilityReviewsFromBeffeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsOnPageSchedulingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsOnPageSchedulingLocationsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsProviderHeroThemeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsSalesForceEvergageScriptArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsShowHeaderNavigationMenuArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsShowHeaderWithLocationNavArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsShowMobileHeaderLocationBarArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsShowProviderPageCtaInMeetOurStaffArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsShowProviderPageInsuranceInfoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsShowReadMoreForBioInMeetOurStaffArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsShowSetOfficeButtonInGoogleMapsCardsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsTransitionallyUseBeffeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsUseFacilityBeffeDataSourceArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsUseFilterForOdpDetailsContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsUseGoogleMapAutocompleteSearchArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsUseInlineOneTrustArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsUseSessionStorageFacilityCodeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsUseSimpleFindOfficeLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsWithLeadingProviderAssociationsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type FeatureFlagsCollection = {
  __typename?: 'FeatureFlagsCollection';
  items: Array<Maybe<FeatureFlags>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FeatureFlagsFilter = {
  AND?: InputMaybe<Array<InputMaybe<FeatureFlagsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FeatureFlagsFilter>>>;
  ameliaChat_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ameliaChat_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ameliaChat_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ameliaChat_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  continentalUsMapFallbackThreshold?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_exists?: InputMaybe<Scalars['Boolean']['input']>;
  continentalUsMapFallbackThreshold_gt?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_gte?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  continentalUsMapFallbackThreshold_lt?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_lte?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_not?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  defaultToCdn?: InputMaybe<Scalars['Boolean']['input']>;
  defaultToCdn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  defaultToCdn_not?: InputMaybe<Scalars['Boolean']['input']>;
  doNotIndexWholeSite?: InputMaybe<Scalars['Boolean']['input']>;
  doNotIndexWholeSite_exists?: InputMaybe<Scalars['Boolean']['input']>;
  doNotIndexWholeSite_not?: InputMaybe<Scalars['Boolean']['input']>;
  enableFacilityContextInSsr?: InputMaybe<Scalars['Boolean']['input']>;
  enableFacilityContextInSsr_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableFacilityContextInSsr_not?: InputMaybe<Scalars['Boolean']['input']>;
  enableFluidTypography?: InputMaybe<Scalars['Boolean']['input']>;
  enableFluidTypography_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableFluidTypography_not?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalNavigation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalNavigation_not?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalPhase2?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalPhase2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalPhase2_not?: InputMaybe<Scalars['Boolean']['input']>;
  enableProvidersSitemap?: InputMaybe<Scalars['Boolean']['input']>;
  enableProvidersSitemap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableProvidersSitemap_not?: InputMaybe<Scalars['Boolean']['input']>;
  enablePtcSlotFilter?: InputMaybe<Scalars['Boolean']['input']>;
  enablePtcSlotFilter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enablePtcSlotFilter_not?: InputMaybe<Scalars['Boolean']['input']>;
  enforceContinentalUsZoom?: InputMaybe<Scalars['Boolean']['input']>;
  enforceContinentalUsZoom_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enforceContinentalUsZoom_not?: InputMaybe<Scalars['Boolean']['input']>;
  featureList_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureList_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureList_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureList_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fetchAllLocationsOnEmptyResults?: InputMaybe<Scalars['Boolean']['input']>;
  fetchAllLocationsOnEmptyResults_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fetchAllLocationsOnEmptyResults_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderFacilityLocator?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderFacilityLocator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderFacilityLocator_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderSchedulingButton?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderSchedulingButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderSchedulingButton_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideOdpHeaderLinks?: InputMaybe<Scalars['Boolean']['input']>;
  hideOdpHeaderLinks_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideOdpHeaderLinks_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideProviderWithNoImage?: InputMaybe<Scalars['Boolean']['input']>;
  hideProviderWithNoImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideProviderWithNoImage_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideSearchWithLocationCards?: InputMaybe<Scalars['Boolean']['input']>;
  hideSearchWithLocationCards_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideSearchWithLocationCards_not?: InputMaybe<Scalars['Boolean']['input']>;
  loadFacilityReviewsFromBeffe?: InputMaybe<Scalars['Boolean']['input']>;
  loadFacilityReviewsFromBeffe_exists?: InputMaybe<Scalars['Boolean']['input']>;
  loadFacilityReviewsFromBeffe_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onPageScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  onPageSchedulingLocations_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onPageSchedulingLocations_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onPageSchedulingLocations_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onPageSchedulingLocations_exists?: InputMaybe<Scalars['Boolean']['input']>;
  onPageScheduling_exists?: InputMaybe<Scalars['Boolean']['input']>;
  onPageScheduling_not?: InputMaybe<Scalars['Boolean']['input']>;
  providerHeroTheme?: InputMaybe<Scalars['String']['input']>;
  providerHeroTheme_contains?: InputMaybe<Scalars['String']['input']>;
  providerHeroTheme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  providerHeroTheme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerHeroTheme_not?: InputMaybe<Scalars['String']['input']>;
  providerHeroTheme_not_contains?: InputMaybe<Scalars['String']['input']>;
  providerHeroTheme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  salesForceEvergageScript?: InputMaybe<Scalars['String']['input']>;
  salesForceEvergageScript_contains?: InputMaybe<Scalars['String']['input']>;
  salesForceEvergageScript_exists?: InputMaybe<Scalars['Boolean']['input']>;
  salesForceEvergageScript_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  salesForceEvergageScript_not?: InputMaybe<Scalars['String']['input']>;
  salesForceEvergageScript_not_contains?: InputMaybe<Scalars['String']['input']>;
  salesForceEvergageScript_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showHeaderNavigationMenu?: InputMaybe<Scalars['Boolean']['input']>;
  showHeaderNavigationMenu_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showHeaderNavigationMenu_not?: InputMaybe<Scalars['Boolean']['input']>;
  showHeaderWithLocationNav?: InputMaybe<Scalars['Boolean']['input']>;
  showHeaderWithLocationNav_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showHeaderWithLocationNav_not?: InputMaybe<Scalars['Boolean']['input']>;
  showMobileHeaderLocationBar?: InputMaybe<Scalars['Boolean']['input']>;
  showMobileHeaderLocationBar_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showMobileHeaderLocationBar_not?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageCtaInMeetOurStaff?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageCtaInMeetOurStaff_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageCtaInMeetOurStaff_not?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageInsuranceInfo?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageInsuranceInfo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageInsuranceInfo_not?: InputMaybe<Scalars['Boolean']['input']>;
  showReadMoreForBioInMeetOurStaff?: InputMaybe<Scalars['Boolean']['input']>;
  showReadMoreForBioInMeetOurStaff_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showReadMoreForBioInMeetOurStaff_not?: InputMaybe<Scalars['Boolean']['input']>;
  showSetOfficeButtonInGoogleMapsCards?: InputMaybe<Scalars['Boolean']['input']>;
  showSetOfficeButtonInGoogleMapsCards_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showSetOfficeButtonInGoogleMapsCards_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  transitionallyUseBeffe?: InputMaybe<Scalars['Boolean']['input']>;
  transitionallyUseBeffe_exists?: InputMaybe<Scalars['Boolean']['input']>;
  transitionallyUseBeffe_not?: InputMaybe<Scalars['Boolean']['input']>;
  useFacilityBeffeDataSource?: InputMaybe<Scalars['Boolean']['input']>;
  useFacilityBeffeDataSource_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useFacilityBeffeDataSource_not?: InputMaybe<Scalars['Boolean']['input']>;
  useFilterForOdpDetailsContent?: InputMaybe<Scalars['Boolean']['input']>;
  useFilterForOdpDetailsContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useFilterForOdpDetailsContent_not?: InputMaybe<Scalars['Boolean']['input']>;
  useGoogleMapAutocompleteSearch?: InputMaybe<Scalars['Boolean']['input']>;
  useGoogleMapAutocompleteSearch_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useGoogleMapAutocompleteSearch_not?: InputMaybe<Scalars['Boolean']['input']>;
  useInlineOneTrust?: InputMaybe<Scalars['Boolean']['input']>;
  useInlineOneTrust_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useInlineOneTrust_not?: InputMaybe<Scalars['Boolean']['input']>;
  useSessionStorageFacilityCode?: InputMaybe<Scalars['Boolean']['input']>;
  useSessionStorageFacilityCode_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useSessionStorageFacilityCode_not?: InputMaybe<Scalars['Boolean']['input']>;
  useSimpleFindOfficeLink?: InputMaybe<Scalars['Boolean']['input']>;
  useSimpleFindOfficeLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useSimpleFindOfficeLink_not?: InputMaybe<Scalars['Boolean']['input']>;
  withLeadingProviderAssociations?: InputMaybe<Scalars['Boolean']['input']>;
  withLeadingProviderAssociations_exists?: InputMaybe<Scalars['Boolean']['input']>;
  withLeadingProviderAssociations_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeatureFlagsLinkingCollections = {
  __typename?: 'FeatureFlagsLinkingCollections';
  appCollection?: Maybe<AppCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type FeatureFlagsLinkingCollectionsAppCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FeatureFlagsLinkingCollectionsAppCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FeatureFlagsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type FeatureFlagsLinkingCollectionsAppCollectionOrder =
  | 'brandImageLink_ASC'
  | 'brandImageLink_DESC'
  | 'branding_ASC'
  | 'branding_DESC'
  | 'isDeprecated_ASC'
  | 'isDeprecated_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type FeatureFlagsOrder =
  | 'continentalUsMapFallbackThreshold_ASC'
  | 'continentalUsMapFallbackThreshold_DESC'
  | 'defaultToCdn_ASC'
  | 'defaultToCdn_DESC'
  | 'doNotIndexWholeSite_ASC'
  | 'doNotIndexWholeSite_DESC'
  | 'enableFacilityContextInSsr_ASC'
  | 'enableFacilityContextInSsr_DESC'
  | 'enableFluidTypography_ASC'
  | 'enableFluidTypography_DESC'
  | 'enablePatientPortalNavigation_ASC'
  | 'enablePatientPortalNavigation_DESC'
  | 'enablePatientPortalPhase2_ASC'
  | 'enablePatientPortalPhase2_DESC'
  | 'enableProvidersSitemap_ASC'
  | 'enableProvidersSitemap_DESC'
  | 'enablePtcSlotFilter_ASC'
  | 'enablePtcSlotFilter_DESC'
  | 'enforceContinentalUsZoom_ASC'
  | 'enforceContinentalUsZoom_DESC'
  | 'fetchAllLocationsOnEmptyResults_ASC'
  | 'fetchAllLocationsOnEmptyResults_DESC'
  | 'hideHeaderFacilityLocator_ASC'
  | 'hideHeaderFacilityLocator_DESC'
  | 'hideHeaderSchedulingButton_ASC'
  | 'hideHeaderSchedulingButton_DESC'
  | 'hideOdpHeaderLinks_ASC'
  | 'hideOdpHeaderLinks_DESC'
  | 'hideProviderWithNoImage_ASC'
  | 'hideProviderWithNoImage_DESC'
  | 'hideSearchWithLocationCards_ASC'
  | 'hideSearchWithLocationCards_DESC'
  | 'loadFacilityReviewsFromBeffe_ASC'
  | 'loadFacilityReviewsFromBeffe_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'onPageScheduling_ASC'
  | 'onPageScheduling_DESC'
  | 'providerHeroTheme_ASC'
  | 'providerHeroTheme_DESC'
  | 'salesForceEvergageScript_ASC'
  | 'salesForceEvergageScript_DESC'
  | 'showHeaderNavigationMenu_ASC'
  | 'showHeaderNavigationMenu_DESC'
  | 'showHeaderWithLocationNav_ASC'
  | 'showHeaderWithLocationNav_DESC'
  | 'showMobileHeaderLocationBar_ASC'
  | 'showMobileHeaderLocationBar_DESC'
  | 'showProviderPageCtaInMeetOurStaff_ASC'
  | 'showProviderPageCtaInMeetOurStaff_DESC'
  | 'showProviderPageInsuranceInfo_ASC'
  | 'showProviderPageInsuranceInfo_DESC'
  | 'showReadMoreForBioInMeetOurStaff_ASC'
  | 'showReadMoreForBioInMeetOurStaff_DESC'
  | 'showSetOfficeButtonInGoogleMapsCards_ASC'
  | 'showSetOfficeButtonInGoogleMapsCards_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'transitionallyUseBeffe_ASC'
  | 'transitionallyUseBeffe_DESC'
  | 'useFacilityBeffeDataSource_ASC'
  | 'useFacilityBeffeDataSource_DESC'
  | 'useFilterForOdpDetailsContent_ASC'
  | 'useFilterForOdpDetailsContent_DESC'
  | 'useGoogleMapAutocompleteSearch_ASC'
  | 'useGoogleMapAutocompleteSearch_DESC'
  | 'useInlineOneTrust_ASC'
  | 'useInlineOneTrust_DESC'
  | 'useSessionStorageFacilityCode_ASC'
  | 'useSessionStorageFacilityCode_DESC'
  | 'useSimpleFindOfficeLink_ASC'
  | 'useSimpleFindOfficeLink_DESC'
  | 'withLeadingProviderAssociations_ASC'
  | 'withLeadingProviderAssociations_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/focalPointImage) */
export type FocalPointImage = Entry & _Node & {
  __typename?: 'FocalPointImage';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  focalPoint?: Maybe<Scalars['JSON']['output']>;
  image?: Maybe<Asset>;
  linkedFrom?: Maybe<FocalPointImageLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/focalPointImage) */
export type FocalPointImageFocalPointArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/focalPointImage) */
export type FocalPointImageImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/focalPointImage) */
export type FocalPointImageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/focalPointImage) */
export type FocalPointImageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type FocalPointImageCollection = {
  __typename?: 'FocalPointImageCollection';
  items: Array<Maybe<FocalPointImage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FocalPointImageFilter = {
  AND?: InputMaybe<Array<InputMaybe<FocalPointImageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FocalPointImageFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  focalPoint_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type FocalPointImageLinkingCollections = {
  __typename?: 'FocalPointImageLinkingCollections';
  accordionsCollection?: Maybe<AccordionsCollection>;
  birdEyeReviewsCollection?: Maybe<BirdEyeReviewsCollection>;
  cardCollection?: Maybe<CardCollection>;
  entryCollection?: Maybe<EntryCollection>;
  heroV2Collection?: Maybe<HeroV2Collection>;
  mediaSliderCollection?: Maybe<MediaSliderCollection>;
  odpHeroCollection?: Maybe<OdpHeroCollection>;
  questionnaireCollection?: Maybe<QuestionnaireCollection>;
  sectionContentCollection?: Maybe<SectionContentCollection>;
  serviceLineHeroCollection?: Maybe<ServiceLineHeroCollection>;
  singleMessageCollection?: Maybe<SingleMessageCollection>;
  smallScreenContentCollection?: Maybe<SmallScreenContentCollection>;
};


export type FocalPointImageLinkingCollectionsAccordionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsAccordionsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FocalPointImageLinkingCollectionsBirdEyeReviewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsBirdEyeReviewsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FocalPointImageLinkingCollectionsCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FocalPointImageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FocalPointImageLinkingCollectionsHeroV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsHeroV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FocalPointImageLinkingCollectionsMediaSliderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsMediaSliderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FocalPointImageLinkingCollectionsOdpHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsOdpHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FocalPointImageLinkingCollectionsQuestionnaireCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsQuestionnaireCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FocalPointImageLinkingCollectionsSectionContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsSectionContentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FocalPointImageLinkingCollectionsServiceLineHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsServiceLineHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FocalPointImageLinkingCollectionsSingleMessageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsSingleMessageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FocalPointImageLinkingCollectionsSmallScreenContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsSmallScreenContentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type FocalPointImageLinkingCollectionsAccordionsCollectionOrder =
  | 'accordionsHeading_ASC'
  | 'accordionsHeading_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonCollectionAlignment_ASC'
  | 'buttonCollectionAlignment_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'descriptionAlignment_ASC'
  | 'descriptionAlignment_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'expandIconPosition_ASC'
  | 'expandIconPosition_DESC'
  | 'expandIconType_ASC'
  | 'expandIconType_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'imagePositionRight_ASC'
  | 'imagePositionRight_DESC'
  | 'imageRoundedCorner_ASC'
  | 'imageRoundedCorner_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'roundedCornersSize_ASC'
  | 'roundedCornersSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleAlignment_ASC'
  | 'titleAlignment_DESC'
  | 'titleColor_ASC'
  | 'titleColor_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'withInnerGap_ASC'
  | 'withInnerGap_DESC';

export type FocalPointImageLinkingCollectionsBirdEyeReviewsCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'filteredReviewsMinRating_ASC'
  | 'filteredReviewsMinRating_DESC'
  | 'filteredReviewsTitle_ASC'
  | 'filteredReviewsTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type FocalPointImageLinkingCollectionsCardCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonIconPosition_ASC'
  | 'buttonIconPosition_DESC'
  | 'buttonIconSize_ASC'
  | 'buttonIconSize_DESC'
  | 'buttonIcon_ASC'
  | 'buttonIcon_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'buttonVariant_ASC'
  | 'buttonVariant_DESC'
  | 'cardIconAlignment_ASC'
  | 'cardIconAlignment_DESC'
  | 'cardIcon_ASC'
  | 'cardIcon_DESC'
  | 'cardTextAlignment_ASC'
  | 'cardTextAlignment_DESC'
  | 'eventType_ASC'
  | 'eventType_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRatio_ASC'
  | 'imageRatio_DESC'
  | 'imageUrl_ASC'
  | 'imageUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pdfDownloadTitle_ASC'
  | 'pdfDownloadTitle_DESC'
  | 'priority_ASC'
  | 'priority_DESC'
  | 'showBorder_ASC'
  | 'showBorder_DESC'
  | 'slot_ASC'
  | 'slot_DESC'
  | 'stepName_ASC'
  | 'stepName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tcText_ASC'
  | 'tcText_DESC'
  | 'tcUrl_ASC'
  | 'tcUrl_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type FocalPointImageLinkingCollectionsHeroV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type FocalPointImageLinkingCollectionsMediaSliderCollectionOrder =
  | 'aspectRatio_ASC'
  | 'aspectRatio_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type FocalPointImageLinkingCollectionsOdpHeroCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'appointmentDataSource_ASC'
  | 'appointmentDataSource_DESC'
  | 'callCenterLabel_ASC'
  | 'callCenterLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'promoTitle_ASC'
  | 'promoTitle_DESC'
  | 'showAddress_ASC'
  | 'showAddress_DESC'
  | 'showEmail_ASC'
  | 'showEmail_DESC'
  | 'showFax_ASC'
  | 'showFax_DESC'
  | 'showHours_ASC'
  | 'showHours_DESC'
  | 'showLocationStatusBadge_ASC'
  | 'showLocationStatusBadge_DESC'
  | 'showPhoneNumber_ASC'
  | 'showPhoneNumber_DESC'
  | 'showReviews_ASC'
  | 'showReviews_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type FocalPointImageLinkingCollectionsQuestionnaireCollectionOrder =
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'defaultErrorMessage_ASC'
  | 'defaultErrorMessage_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subTitle_ASC'
  | 'subTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'text_ASC'
  | 'text_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type FocalPointImageLinkingCollectionsSectionContentCollectionOrder =
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageShape_ASC'
  | 'imageShape_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'orientation_ASC'
  | 'orientation_DESC'
  | 'subTitle_ASC'
  | 'subTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type FocalPointImageLinkingCollectionsServiceLineHeroCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type FocalPointImageLinkingCollectionsSingleMessageCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentFillVerticalSpace_ASC'
  | 'contentFillVerticalSpace_DESC'
  | 'displayTitleInline_ASC'
  | 'displayTitleInline_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isBannerImage_ASC'
  | 'isBannerImage_DESC'
  | 'isHeaderAboveSideImages_ASC'
  | 'isHeaderAboveSideImages_DESC'
  | 'isInlineLayout_ASC'
  | 'isInlineLayout_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showSubscriptionForm_ASC'
  | 'showSubscriptionForm_DESC'
  | 'subText_ASC'
  | 'subText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateHeight_ASC'
  | 'templateHeight_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleAlign_ASC'
  | 'titleAlign_DESC'
  | 'titleVariant_ASC'
  | 'titleVariant_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useRoundedCorners_ASC'
  | 'useRoundedCorners_DESC';

export type FocalPointImageLinkingCollectionsSmallScreenContentCollectionOrder =
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowSmallScreen_ASC'
  | 'eyebrowSmallScreen_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type FocalPointImageOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** Footer Navigation Group Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/footerNavigationGroup) */
export type FooterNavigationGroup = Entry & _Node & {
  __typename?: 'FooterNavigationGroup';
  _id: Scalars['ID']['output'];
  componentName?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<FooterNavigationGroupLinkingCollections>;
  navigationGroupLink?: Maybe<Page>;
  navigationGroupTitle?: Maybe<Scalars['String']['output']>;
  navigationLinksForGroupCollection?: Maybe<FooterNavigationGroupNavigationLinksForGroupCollection>;
  sys: Sys;
};


/** Footer Navigation Group Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/footerNavigationGroup) */
export type FooterNavigationGroupComponentNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Footer Navigation Group Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/footerNavigationGroup) */
export type FooterNavigationGroupLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Footer Navigation Group Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/footerNavigationGroup) */
export type FooterNavigationGroupNavigationGroupLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageFilter>;
};


/** Footer Navigation Group Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/footerNavigationGroup) */
export type FooterNavigationGroupNavigationGroupTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Footer Navigation Group Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/footerNavigationGroup) */
export type FooterNavigationGroupNavigationLinksForGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FooterNavigationGroupNavigationLinksForGroupFilter>;
};

export type FooterNavigationGroupCollection = {
  __typename?: 'FooterNavigationGroupCollection';
  items: Array<Maybe<FooterNavigationGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FooterNavigationGroupFilter = {
  AND?: InputMaybe<Array<InputMaybe<FooterNavigationGroupFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FooterNavigationGroupFilter>>>;
  componentName?: InputMaybe<Scalars['String']['input']>;
  componentName_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentName_not?: InputMaybe<Scalars['String']['input']>;
  componentName_not_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  navigationGroupLink?: InputMaybe<CfPageNestedFilter>;
  navigationGroupLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  navigationGroupTitle?: InputMaybe<Scalars['String']['input']>;
  navigationGroupTitle_contains?: InputMaybe<Scalars['String']['input']>;
  navigationGroupTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  navigationGroupTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationGroupTitle_not?: InputMaybe<Scalars['String']['input']>;
  navigationGroupTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  navigationGroupTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationLinksForGroup?: InputMaybe<CfnavigationLinksForGroupMultiTypeNestedFilter>;
  navigationLinksForGroupCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type FooterNavigationGroupLinkingCollections = {
  __typename?: 'FooterNavigationGroupLinkingCollections';
  adFooterCollection?: Maybe<AdFooterCollection>;
  entryCollection?: Maybe<EntryCollection>;
  headerCollection?: Maybe<HeaderCollection>;
};


export type FooterNavigationGroupLinkingCollectionsAdFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FooterNavigationGroupLinkingCollectionsAdFooterCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FooterNavigationGroupLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FooterNavigationGroupLinkingCollectionsHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FooterNavigationGroupLinkingCollectionsHeaderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type FooterNavigationGroupLinkingCollectionsAdFooterCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'contactNumber_ASC'
  | 'contactNumber_DESC'
  | 'copyright_ASC'
  | 'copyright_DESC'
  | 'isLightFooter_ASC'
  | 'isLightFooter_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useDesktopStickyFooter_ASC'
  | 'useDesktopStickyFooter_DESC'
  | 'useMobileStickyFooter_ASC'
  | 'useMobileStickyFooter_DESC';

export type FooterNavigationGroupLinkingCollectionsHeaderCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC';

export type FooterNavigationGroupNavigationLinksForGroupCollection = {
  __typename?: 'FooterNavigationGroupNavigationLinksForGroupCollection';
  items: Array<Maybe<FooterNavigationGroupNavigationLinksForGroupItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FooterNavigationGroupNavigationLinksForGroupFilter = {
  AND?: InputMaybe<Array<InputMaybe<FooterNavigationGroupNavigationLinksForGroupFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FooterNavigationGroupNavigationLinksForGroupFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type FooterNavigationGroupNavigationLinksForGroupItem = NavigationLink | Page;

export type FooterNavigationGroupOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'navigationGroupTitle_ASC'
  | 'navigationGroupTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownField) */
export type FormDropdownField = Entry & _Node & {
  __typename?: 'FormDropdownField';
  _id: Scalars['ID']['output'];
  alertMessage?: Maybe<Scalars['String']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  clearTextItem?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  itemList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  itemsCollection?: Maybe<FormDropdownFieldItemsCollection>;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<FormDropdownFieldLinkingCollections>;
  required?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownField) */
export type FormDropdownFieldAlertMessageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownField) */
export type FormDropdownFieldApiKeyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownField) */
export type FormDropdownFieldClearTextItemArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownField) */
export type FormDropdownFieldItemListArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownField) */
export type FormDropdownFieldItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FormDropdownFieldItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormDropdownListItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownField) */
export type FormDropdownFieldLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownField) */
export type FormDropdownFieldLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownField) */
export type FormDropdownFieldRequiredArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownField) */
export type FormDropdownFieldTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type FormDropdownFieldCollection = {
  __typename?: 'FormDropdownFieldCollection';
  items: Array<Maybe<FormDropdownField>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FormDropdownFieldFilter = {
  AND?: InputMaybe<Array<InputMaybe<FormDropdownFieldFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FormDropdownFieldFilter>>>;
  alertMessage?: InputMaybe<Scalars['String']['input']>;
  alertMessage_contains?: InputMaybe<Scalars['String']['input']>;
  alertMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  alertMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alertMessage_not?: InputMaybe<Scalars['String']['input']>;
  alertMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  alertMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiKey_contains?: InputMaybe<Scalars['String']['input']>;
  apiKey_exists?: InputMaybe<Scalars['Boolean']['input']>;
  apiKey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  apiKey_not?: InputMaybe<Scalars['String']['input']>;
  apiKey_not_contains?: InputMaybe<Scalars['String']['input']>;
  apiKey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clearTextItem?: InputMaybe<Scalars['String']['input']>;
  clearTextItem_contains?: InputMaybe<Scalars['String']['input']>;
  clearTextItem_exists?: InputMaybe<Scalars['Boolean']['input']>;
  clearTextItem_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clearTextItem_not?: InputMaybe<Scalars['String']['input']>;
  clearTextItem_not_contains?: InputMaybe<Scalars['String']['input']>;
  clearTextItem_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  itemList_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  itemList_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  itemList_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  itemList_exists?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<CfFormDropdownListItemNestedFilter>;
  itemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  required_exists?: InputMaybe<Scalars['Boolean']['input']>;
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FormDropdownFieldItemsCollection = {
  __typename?: 'FormDropdownFieldItemsCollection';
  items: Array<Maybe<FormDropdownListItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FormDropdownFieldItemsCollectionOrder =
  | 'divider_ASC'
  | 'divider_DESC'
  | 'iconBoolean_ASC'
  | 'iconBoolean_DESC'
  | 'iconName_ASC'
  | 'iconName_DESC'
  | 'itemText_ASC'
  | 'itemText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type FormDropdownFieldLinkingCollections = {
  __typename?: 'FormDropdownFieldLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  questionnaireCollection?: Maybe<QuestionnaireCollection>;
};


export type FormDropdownFieldLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FormDropdownFieldLinkingCollectionsQuestionnaireCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FormDropdownFieldLinkingCollectionsQuestionnaireCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type FormDropdownFieldLinkingCollectionsQuestionnaireCollectionOrder =
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'defaultErrorMessage_ASC'
  | 'defaultErrorMessage_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subTitle_ASC'
  | 'subTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'text_ASC'
  | 'text_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type FormDropdownFieldOrder =
  | 'alertMessage_ASC'
  | 'alertMessage_DESC'
  | 'apiKey_ASC'
  | 'apiKey_DESC'
  | 'clearTextItem_ASC'
  | 'clearTextItem_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'required_ASC'
  | 'required_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownListItem) */
export type FormDropdownListItem = Entry & _Node & {
  __typename?: 'FormDropdownListItem';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  divider?: Maybe<Scalars['Boolean']['output']>;
  iconBoolean?: Maybe<Scalars['Boolean']['output']>;
  iconName?: Maybe<Scalars['String']['output']>;
  itemText?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<FormDropdownListItemLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownListItem) */
export type FormDropdownListItemDividerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownListItem) */
export type FormDropdownListItemIconBooleanArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownListItem) */
export type FormDropdownListItemIconNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownListItem) */
export type FormDropdownListItemItemTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownListItem) */
export type FormDropdownListItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownListItem) */
export type FormDropdownListItemNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type FormDropdownListItemCollection = {
  __typename?: 'FormDropdownListItemCollection';
  items: Array<Maybe<FormDropdownListItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FormDropdownListItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<FormDropdownListItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FormDropdownListItemFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  divider?: InputMaybe<Scalars['Boolean']['input']>;
  divider_exists?: InputMaybe<Scalars['Boolean']['input']>;
  divider_not?: InputMaybe<Scalars['Boolean']['input']>;
  iconBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  iconBoolean_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconBoolean_not?: InputMaybe<Scalars['Boolean']['input']>;
  iconName?: InputMaybe<Scalars['String']['input']>;
  iconName_contains?: InputMaybe<Scalars['String']['input']>;
  iconName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconName_not?: InputMaybe<Scalars['String']['input']>;
  iconName_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  itemText?: InputMaybe<Scalars['String']['input']>;
  itemText_contains?: InputMaybe<Scalars['String']['input']>;
  itemText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  itemText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  itemText_not?: InputMaybe<Scalars['String']['input']>;
  itemText_not_contains?: InputMaybe<Scalars['String']['input']>;
  itemText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type FormDropdownListItemLinkingCollections = {
  __typename?: 'FormDropdownListItemLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  formDropdownFieldCollection?: Maybe<FormDropdownFieldCollection>;
};


export type FormDropdownListItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FormDropdownListItemLinkingCollectionsFormDropdownFieldCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FormDropdownListItemLinkingCollectionsFormDropdownFieldCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type FormDropdownListItemLinkingCollectionsFormDropdownFieldCollectionOrder =
  | 'alertMessage_ASC'
  | 'alertMessage_DESC'
  | 'apiKey_ASC'
  | 'apiKey_DESC'
  | 'clearTextItem_ASC'
  | 'clearTextItem_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'required_ASC'
  | 'required_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type FormDropdownListItemOrder =
  | 'divider_ASC'
  | 'divider_DESC'
  | 'iconBoolean_ASC'
  | 'iconBoolean_DESC'
  | 'iconName_ASC'
  | 'iconName_DESC'
  | 'itemText_ASC'
  | 'itemText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formField) */
export type FormField = Entry & _Node & {
  __typename?: 'FormField';
  _id: Scalars['ID']['output'];
  alertMessage?: Maybe<Scalars['String']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  image?: Maybe<Asset>;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<FormFieldLinkingCollections>;
  onSubmitFormUrl?: Maybe<Scalars['String']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formField) */
export type FormFieldAlertMessageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formField) */
export type FormFieldApiKeyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formField) */
export type FormFieldImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formField) */
export type FormFieldLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formField) */
export type FormFieldLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formField) */
export type FormFieldOnSubmitFormUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formField) */
export type FormFieldPlaceholderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formField) */
export type FormFieldRequiredArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formField) */
export type FormFieldTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formField) */
export type FormFieldTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type FormFieldCollection = {
  __typename?: 'FormFieldCollection';
  items: Array<Maybe<FormField>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FormFieldFilter = {
  AND?: InputMaybe<Array<InputMaybe<FormFieldFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FormFieldFilter>>>;
  alertMessage?: InputMaybe<Scalars['String']['input']>;
  alertMessage_contains?: InputMaybe<Scalars['String']['input']>;
  alertMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  alertMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alertMessage_not?: InputMaybe<Scalars['String']['input']>;
  alertMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  alertMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiKey_contains?: InputMaybe<Scalars['String']['input']>;
  apiKey_exists?: InputMaybe<Scalars['Boolean']['input']>;
  apiKey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  apiKey_not?: InputMaybe<Scalars['String']['input']>;
  apiKey_not_contains?: InputMaybe<Scalars['String']['input']>;
  apiKey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onSubmitFormUrl?: InputMaybe<Scalars['String']['input']>;
  onSubmitFormUrl_contains?: InputMaybe<Scalars['String']['input']>;
  onSubmitFormUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  onSubmitFormUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onSubmitFormUrl_not?: InputMaybe<Scalars['String']['input']>;
  onSubmitFormUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  onSubmitFormUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  placeholder_contains?: InputMaybe<Scalars['String']['input']>;
  placeholder_exists?: InputMaybe<Scalars['Boolean']['input']>;
  placeholder_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  placeholder_not?: InputMaybe<Scalars['String']['input']>;
  placeholder_not_contains?: InputMaybe<Scalars['String']['input']>;
  placeholder_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  required_exists?: InputMaybe<Scalars['Boolean']['input']>;
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FormFieldLinkingCollections = {
  __typename?: 'FormFieldLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  questionnaireCollection?: Maybe<QuestionnaireCollection>;
};


export type FormFieldLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FormFieldLinkingCollectionsQuestionnaireCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FormFieldLinkingCollectionsQuestionnaireCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type FormFieldLinkingCollectionsQuestionnaireCollectionOrder =
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'defaultErrorMessage_ASC'
  | 'defaultErrorMessage_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subTitle_ASC'
  | 'subTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'text_ASC'
  | 'text_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type FormFieldOrder =
  | 'alertMessage_ASC'
  | 'alertMessage_DESC'
  | 'apiKey_ASC'
  | 'apiKey_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'onSubmitFormUrl_ASC'
  | 'onSubmitFormUrl_DESC'
  | 'placeholder_ASC'
  | 'placeholder_DESC'
  | 'required_ASC'
  | 'required_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type FreeTextAnswer = HasAnswerFormat & {
  __typename?: 'FreeTextAnswer';
  format?: Maybe<QuestionnaireAnswerFormat>;
};

export type FreeTextQuestionnaireAnswerInput = {
  text: Scalars['NonEmptyString']['input'];
};

export type GeneralVisitReasonType =
  | 'BROKEN_TOOTH_TOOTH_PAIN'
  | 'CLEAR_ALIGNERS'
  | 'DENTURES'
  | 'EMERGENCY'
  | 'HEALTHY_MOUTH_MOVEMENT'
  | 'IMPLANTS'
  | 'OTHER'
  | 'UNKNOWN_REASON';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplate = Entry & _Node & {
  __typename?: 'GoogleMapTemplate';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  availableServicesTabs?: Maybe<Tabs>;
  contentfulMetadata: ContentfulMetadata;
  defaultImage?: Maybe<Asset>;
  desktopZoom?: Maybe<Scalars['Float']['output']>;
  facilityBadgeLabel?: Maybe<Scalars['String']['output']>;
  facilityBasePath?: Maybe<Scalars['String']['output']>;
  facilityButtonLabel?: Maybe<Scalars['String']['output']>;
  googleMapsBusinessQuery?: Maybe<Scalars['String']['output']>;
  holidayHoursMessageText?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<GoogleMapTemplateLinkingCollections>;
  listTabIsHorizontalScrolling?: Maybe<Scalars['Boolean']['output']>;
  locationScheduleButtonUrl?: Maybe<Scalars['String']['output']>;
  mobileZoom?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noResultsContent?: Maybe<MultiCardV2>;
  noResultsFoundImage?: Maybe<ImageAsset>;
  noResultsFoundMessage?: Maybe<GoogleMapTemplateNoResultsFoundMessage>;
  officeDetailsButton?: Maybe<Button>;
  scheduleButton?: Maybe<Button>;
  searchRadius?: Maybe<Scalars['Int']['output']>;
  searchResultLimit?: Maybe<Scalars['Int']['output']>;
  selectedImage?: Maybe<Asset>;
  service?: Maybe<Scalars['String']['output']>;
  setAsOfficeButtonText?: Maybe<Scalars['String']['output']>;
  singleComingSoonMessage?: Maybe<GoogleMapTemplateSingleComingSoonMessage>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  titleHtag?: Maybe<Scalars['String']['output']>;
  useCumulativeDesign?: Maybe<Scalars['Boolean']['output']>;
  useModernDesign?: Maybe<Scalars['Boolean']['output']>;
  useUsaCountryMap?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateAvailableServicesTabsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TabsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateDefaultImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateDesktopZoomArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateFacilityBadgeLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateFacilityBasePathArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateFacilityButtonLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateGoogleMapsBusinessQueryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateHolidayHoursMessageTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateListTabIsHorizontalScrollingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateLocationScheduleButtonUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateMobileZoomArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateNoResultsContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MultiCardV2Filter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateNoResultsFoundImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateNoResultsFoundMessageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateOfficeDetailsButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateScheduleButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateSearchRadiusArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateSearchResultLimitArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateSelectedImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateServiceArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateSetAsOfficeButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateSingleComingSoonMessageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateUseCumulativeDesignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateUseModernDesignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateUseUsaCountryMapArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type GoogleMapTemplateCollection = {
  __typename?: 'GoogleMapTemplateCollection';
  items: Array<Maybe<GoogleMapTemplate>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type GoogleMapTemplateFilter = {
  AND?: InputMaybe<Array<InputMaybe<GoogleMapTemplateFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<GoogleMapTemplateFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableServicesTabs?: InputMaybe<CfTabsNestedFilter>;
  availableServicesTabs_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  defaultImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  desktopZoom?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_exists?: InputMaybe<Scalars['Boolean']['input']>;
  desktopZoom_gt?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_gte?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  desktopZoom_lt?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_lte?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_not?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  facilityBadgeLabel?: InputMaybe<Scalars['String']['input']>;
  facilityBadgeLabel_contains?: InputMaybe<Scalars['String']['input']>;
  facilityBadgeLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilityBadgeLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityBadgeLabel_not?: InputMaybe<Scalars['String']['input']>;
  facilityBadgeLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilityBadgeLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityBasePath?: InputMaybe<Scalars['String']['input']>;
  facilityBasePath_contains?: InputMaybe<Scalars['String']['input']>;
  facilityBasePath_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilityBasePath_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityBasePath_not?: InputMaybe<Scalars['String']['input']>;
  facilityBasePath_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilityBasePath_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityButtonLabel?: InputMaybe<Scalars['String']['input']>;
  facilityButtonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  facilityButtonLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilityButtonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityButtonLabel_not?: InputMaybe<Scalars['String']['input']>;
  facilityButtonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilityButtonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googleMapsBusinessQuery?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_contains?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_exists?: InputMaybe<Scalars['Boolean']['input']>;
  googleMapsBusinessQuery_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googleMapsBusinessQuery_not?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_not_contains?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  holidayHoursMessageText?: InputMaybe<Scalars['String']['input']>;
  holidayHoursMessageText_contains?: InputMaybe<Scalars['String']['input']>;
  holidayHoursMessageText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  holidayHoursMessageText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  holidayHoursMessageText_not?: InputMaybe<Scalars['String']['input']>;
  holidayHoursMessageText_not_contains?: InputMaybe<Scalars['String']['input']>;
  holidayHoursMessageText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listTabIsHorizontalScrolling?: InputMaybe<Scalars['Boolean']['input']>;
  listTabIsHorizontalScrolling_exists?: InputMaybe<Scalars['Boolean']['input']>;
  listTabIsHorizontalScrolling_not?: InputMaybe<Scalars['Boolean']['input']>;
  locationScheduleButtonUrl?: InputMaybe<Scalars['String']['input']>;
  locationScheduleButtonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  locationScheduleButtonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  locationScheduleButtonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationScheduleButtonUrl_not?: InputMaybe<Scalars['String']['input']>;
  locationScheduleButtonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  locationScheduleButtonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileZoom?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileZoom_gt?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_gte?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  mobileZoom_lt?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_lte?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_not?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  noResultsContent?: InputMaybe<CfMultiCardV2NestedFilter>;
  noResultsContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  noResultsFoundImage?: InputMaybe<CfImageAssetNestedFilter>;
  noResultsFoundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  noResultsFoundMessage_contains?: InputMaybe<Scalars['String']['input']>;
  noResultsFoundMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  noResultsFoundMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  officeDetailsButton?: InputMaybe<CfButtonNestedFilter>;
  officeDetailsButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleButton?: InputMaybe<CfButtonNestedFilter>;
  scheduleButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchRadius?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchRadius_gt?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_gte?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  searchRadius_lt?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_lte?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_not?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  searchResultLimit?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchResultLimit_gt?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_gte?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  searchResultLimit_lt?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_lte?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_not?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  selectedImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  service_contains?: InputMaybe<Scalars['String']['input']>;
  service_exists?: InputMaybe<Scalars['Boolean']['input']>;
  service_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  service_not?: InputMaybe<Scalars['String']['input']>;
  service_not_contains?: InputMaybe<Scalars['String']['input']>;
  service_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  setAsOfficeButtonText?: InputMaybe<Scalars['String']['input']>;
  setAsOfficeButtonText_contains?: InputMaybe<Scalars['String']['input']>;
  setAsOfficeButtonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  setAsOfficeButtonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  setAsOfficeButtonText_not?: InputMaybe<Scalars['String']['input']>;
  setAsOfficeButtonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  setAsOfficeButtonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  singleComingSoonMessage_contains?: InputMaybe<Scalars['String']['input']>;
  singleComingSoonMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  singleComingSoonMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  useCumulativeDesign?: InputMaybe<Scalars['Boolean']['input']>;
  useCumulativeDesign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useCumulativeDesign_not?: InputMaybe<Scalars['Boolean']['input']>;
  useModernDesign?: InputMaybe<Scalars['Boolean']['input']>;
  useModernDesign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useModernDesign_not?: InputMaybe<Scalars['Boolean']['input']>;
  useUsaCountryMap?: InputMaybe<Scalars['Boolean']['input']>;
  useUsaCountryMap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useUsaCountryMap_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GoogleMapTemplateLinkingCollections = {
  __typename?: 'GoogleMapTemplateLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  headerCollection?: Maybe<HeaderCollection>;
  pageCollection?: Maybe<PageCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
};


export type GoogleMapTemplateLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type GoogleMapTemplateLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<GoogleMapTemplateLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type GoogleMapTemplateLinkingCollectionsHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<GoogleMapTemplateLinkingCollectionsHeaderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type GoogleMapTemplateLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<GoogleMapTemplateLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type GoogleMapTemplateLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<GoogleMapTemplateLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type GoogleMapTemplateLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type GoogleMapTemplateLinkingCollectionsHeaderCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC';

export type GoogleMapTemplateLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type GoogleMapTemplateLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type GoogleMapTemplateNoResultsFoundMessage = {
  __typename?: 'GoogleMapTemplateNoResultsFoundMessage';
  json: Scalars['JSON']['output'];
  links: GoogleMapTemplateNoResultsFoundMessageLinks;
};

export type GoogleMapTemplateNoResultsFoundMessageAssets = {
  __typename?: 'GoogleMapTemplateNoResultsFoundMessageAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type GoogleMapTemplateNoResultsFoundMessageEntries = {
  __typename?: 'GoogleMapTemplateNoResultsFoundMessageEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type GoogleMapTemplateNoResultsFoundMessageLinks = {
  __typename?: 'GoogleMapTemplateNoResultsFoundMessageLinks';
  assets: GoogleMapTemplateNoResultsFoundMessageAssets;
  entries: GoogleMapTemplateNoResultsFoundMessageEntries;
  resources: GoogleMapTemplateNoResultsFoundMessageResources;
};

export type GoogleMapTemplateNoResultsFoundMessageResources = {
  __typename?: 'GoogleMapTemplateNoResultsFoundMessageResources';
  block: Array<GoogleMapTemplateNoResultsFoundMessageResourcesBlock>;
  hyperlink: Array<GoogleMapTemplateNoResultsFoundMessageResourcesHyperlink>;
  inline: Array<GoogleMapTemplateNoResultsFoundMessageResourcesInline>;
};

export type GoogleMapTemplateNoResultsFoundMessageResourcesBlock = ResourceLink & {
  __typename?: 'GoogleMapTemplateNoResultsFoundMessageResourcesBlock';
  sys: ResourceSys;
};

export type GoogleMapTemplateNoResultsFoundMessageResourcesHyperlink = ResourceLink & {
  __typename?: 'GoogleMapTemplateNoResultsFoundMessageResourcesHyperlink';
  sys: ResourceSys;
};

export type GoogleMapTemplateNoResultsFoundMessageResourcesInline = ResourceLink & {
  __typename?: 'GoogleMapTemplateNoResultsFoundMessageResourcesInline';
  sys: ResourceSys;
};

export type GoogleMapTemplateOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'desktopZoom_ASC'
  | 'desktopZoom_DESC'
  | 'facilityBadgeLabel_ASC'
  | 'facilityBadgeLabel_DESC'
  | 'facilityBasePath_ASC'
  | 'facilityBasePath_DESC'
  | 'facilityButtonLabel_ASC'
  | 'facilityButtonLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'holidayHoursMessageText_ASC'
  | 'holidayHoursMessageText_DESC'
  | 'listTabIsHorizontalScrolling_ASC'
  | 'listTabIsHorizontalScrolling_DESC'
  | 'locationScheduleButtonUrl_ASC'
  | 'locationScheduleButtonUrl_DESC'
  | 'mobileZoom_ASC'
  | 'mobileZoom_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'searchRadius_ASC'
  | 'searchRadius_DESC'
  | 'searchResultLimit_ASC'
  | 'searchResultLimit_DESC'
  | 'service_ASC'
  | 'service_DESC'
  | 'setAsOfficeButtonText_ASC'
  | 'setAsOfficeButtonText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useCumulativeDesign_ASC'
  | 'useCumulativeDesign_DESC'
  | 'useModernDesign_ASC'
  | 'useModernDesign_DESC'
  | 'useUsaCountryMap_ASC'
  | 'useUsaCountryMap_DESC';

export type GoogleMapTemplateSingleComingSoonMessage = {
  __typename?: 'GoogleMapTemplateSingleComingSoonMessage';
  json: Scalars['JSON']['output'];
  links: GoogleMapTemplateSingleComingSoonMessageLinks;
};

export type GoogleMapTemplateSingleComingSoonMessageAssets = {
  __typename?: 'GoogleMapTemplateSingleComingSoonMessageAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type GoogleMapTemplateSingleComingSoonMessageEntries = {
  __typename?: 'GoogleMapTemplateSingleComingSoonMessageEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type GoogleMapTemplateSingleComingSoonMessageLinks = {
  __typename?: 'GoogleMapTemplateSingleComingSoonMessageLinks';
  assets: GoogleMapTemplateSingleComingSoonMessageAssets;
  entries: GoogleMapTemplateSingleComingSoonMessageEntries;
  resources: GoogleMapTemplateSingleComingSoonMessageResources;
};

export type GoogleMapTemplateSingleComingSoonMessageResources = {
  __typename?: 'GoogleMapTemplateSingleComingSoonMessageResources';
  block: Array<GoogleMapTemplateSingleComingSoonMessageResourcesBlock>;
  hyperlink: Array<GoogleMapTemplateSingleComingSoonMessageResourcesHyperlink>;
  inline: Array<GoogleMapTemplateSingleComingSoonMessageResourcesInline>;
};

export type GoogleMapTemplateSingleComingSoonMessageResourcesBlock = ResourceLink & {
  __typename?: 'GoogleMapTemplateSingleComingSoonMessageResourcesBlock';
  sys: ResourceSys;
};

export type GoogleMapTemplateSingleComingSoonMessageResourcesHyperlink = ResourceLink & {
  __typename?: 'GoogleMapTemplateSingleComingSoonMessageResourcesHyperlink';
  sys: ResourceSys;
};

export type GoogleMapTemplateSingleComingSoonMessageResourcesInline = ResourceLink & {
  __typename?: 'GoogleMapTemplateSingleComingSoonMessageResourcesInline';
  sys: ResourceSys;
};

export type Guarantor = {
  __typename?: 'Guarantor';
  personalInformation?: Maybe<PersonalInformation>;
  relation?: Maybe<PatientRelationToGuarantor>;
};

export type GuarantorInput = {
  nonExistingGuarantor?: InputMaybe<NewGuarantorInput>;
};

export type GuarantorRequiredError = Error & {
  __typename?: 'GuarantorRequiredError';
  message: Scalars['String']['output'];
};

/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreen = Entry & _Node & {
  __typename?: 'HalfScreen';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  body?: Maybe<HalfScreenBody>;
  buttonCollection?: Maybe<HalfScreenButtonCollection>;
  contentSmallScreen?: Maybe<SmallScreenContent>;
  contentfulMetadata: ContentfulMetadata;
  disclaimer?: Maybe<DisclaimerV2>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  eyebrowStyle?: Maybe<Scalars['String']['output']>;
  facilitySegmentCollection?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<HalfScreenHeading>;
  hideContentHalf?: Maybe<Scalars['Boolean']['output']>;
  image?: Maybe<Asset>;
  imageAsset?: Maybe<ImageAsset>;
  imageAssetTwo?: Maybe<ImageAsset>;
  isInsetLayout?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<HalfScreenLinkingCollections>;
  mediaFirst?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subHeading?: Maybe<HalfScreenSubHeading>;
  sys: Sys;
  templateSize?: Maybe<Scalars['String']['output']>;
  termsAndConditions?: Maybe<TermsAndConditions>;
  textAlignment?: Maybe<Scalars['String']['output']>;
  useStaticImageSize?: Maybe<Scalars['Boolean']['output']>;
  video?: Maybe<Video>;
  videoAsset?: Maybe<VideoAsset>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenBodyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenButtonCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenContentSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SmallScreenContentFilter>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenDisclaimerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DisclaimerV2Filter>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenEyebrowStyleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenFacilitySegmentCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenHideContentHalfArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenImageAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenImageAssetTwoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenIsInsetLayoutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenMediaFirstArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenSubHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenTemplateSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenTermsAndConditionsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TermsAndConditionsFilter>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenTextAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenUseStaticImageSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenVideoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoFilter>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenVideoAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoAssetFilter>;
};

export type HalfScreenBody = {
  __typename?: 'HalfScreenBody';
  json: Scalars['JSON']['output'];
  links: HalfScreenBodyLinks;
};

export type HalfScreenBodyAssets = {
  __typename?: 'HalfScreenBodyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type HalfScreenBodyEntries = {
  __typename?: 'HalfScreenBodyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type HalfScreenBodyLinks = {
  __typename?: 'HalfScreenBodyLinks';
  assets: HalfScreenBodyAssets;
  entries: HalfScreenBodyEntries;
  resources: HalfScreenBodyResources;
};

export type HalfScreenBodyResources = {
  __typename?: 'HalfScreenBodyResources';
  block: Array<HalfScreenBodyResourcesBlock>;
  hyperlink: Array<HalfScreenBodyResourcesHyperlink>;
  inline: Array<HalfScreenBodyResourcesInline>;
};

export type HalfScreenBodyResourcesBlock = ResourceLink & {
  __typename?: 'HalfScreenBodyResourcesBlock';
  sys: ResourceSys;
};

export type HalfScreenBodyResourcesHyperlink = ResourceLink & {
  __typename?: 'HalfScreenBodyResourcesHyperlink';
  sys: ResourceSys;
};

export type HalfScreenBodyResourcesInline = ResourceLink & {
  __typename?: 'HalfScreenBodyResourcesInline';
  sys: ResourceSys;
};

export type HalfScreenButtonCollection = {
  __typename?: 'HalfScreenButtonCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HalfScreenButtonCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type HalfScreenCollection = {
  __typename?: 'HalfScreenCollection';
  items: Array<Maybe<HalfScreen>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HalfScreenFilter = {
  AND?: InputMaybe<Array<InputMaybe<HalfScreenFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HalfScreenFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_exists?: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  button?: InputMaybe<CfButtonNestedFilter>;
  buttonCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentSmallScreen?: InputMaybe<CfSmallScreenContentNestedFilter>;
  contentSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disclaimer?: InputMaybe<CfDisclaimerV2NestedFilter>;
  disclaimer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowStyle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowStyle_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  hideContentHalf?: InputMaybe<Scalars['Boolean']['input']>;
  hideContentHalf_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideContentHalf_not?: InputMaybe<Scalars['Boolean']['input']>;
  imageAsset?: InputMaybe<CfImageAssetNestedFilter>;
  imageAssetTwo?: InputMaybe<CfImageAssetNestedFilter>;
  imageAssetTwo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isInsetLayout?: InputMaybe<Scalars['Boolean']['input']>;
  isInsetLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isInsetLayout_not?: InputMaybe<Scalars['Boolean']['input']>;
  mediaFirst?: InputMaybe<Scalars['Boolean']['input']>;
  mediaFirst_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaFirst_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  subHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  templateSize?: InputMaybe<Scalars['String']['input']>;
  templateSize_contains?: InputMaybe<Scalars['String']['input']>;
  templateSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateSize_not?: InputMaybe<Scalars['String']['input']>;
  templateSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  termsAndConditions?: InputMaybe<CfTermsAndConditionsNestedFilter>;
  termsAndConditions_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textAlignment?: InputMaybe<Scalars['String']['input']>;
  textAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textAlignment_not?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  useStaticImageSize?: InputMaybe<Scalars['Boolean']['input']>;
  useStaticImageSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useStaticImageSize_not?: InputMaybe<Scalars['Boolean']['input']>;
  video?: InputMaybe<CfVideoNestedFilter>;
  videoAsset?: InputMaybe<CfVideoAssetNestedFilter>;
  videoAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  video_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HalfScreenHeading = {
  __typename?: 'HalfScreenHeading';
  json: Scalars['JSON']['output'];
  links: HalfScreenHeadingLinks;
};

export type HalfScreenHeadingAssets = {
  __typename?: 'HalfScreenHeadingAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type HalfScreenHeadingEntries = {
  __typename?: 'HalfScreenHeadingEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type HalfScreenHeadingLinks = {
  __typename?: 'HalfScreenHeadingLinks';
  assets: HalfScreenHeadingAssets;
  entries: HalfScreenHeadingEntries;
  resources: HalfScreenHeadingResources;
};

export type HalfScreenHeadingResources = {
  __typename?: 'HalfScreenHeadingResources';
  block: Array<HalfScreenHeadingResourcesBlock>;
  hyperlink: Array<HalfScreenHeadingResourcesHyperlink>;
  inline: Array<HalfScreenHeadingResourcesInline>;
};

export type HalfScreenHeadingResourcesBlock = ResourceLink & {
  __typename?: 'HalfScreenHeadingResourcesBlock';
  sys: ResourceSys;
};

export type HalfScreenHeadingResourcesHyperlink = ResourceLink & {
  __typename?: 'HalfScreenHeadingResourcesHyperlink';
  sys: ResourceSys;
};

export type HalfScreenHeadingResourcesInline = ResourceLink & {
  __typename?: 'HalfScreenHeadingResourcesInline';
  sys: ResourceSys;
};

export type HalfScreenLinkingCollections = {
  __typename?: 'HalfScreenLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  pageCollection?: Maybe<PageCollection>;
  providerDetailsPageCollection?: Maybe<ProviderDetailsPageCollection>;
  segmentsContainerCollection?: Maybe<SegmentsContainerCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
};


export type HalfScreenLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type HalfScreenLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type HalfScreenLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type HalfScreenLinkingCollectionsProviderDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenLinkingCollectionsProviderDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type HalfScreenLinkingCollectionsSegmentsContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenLinkingCollectionsSegmentsContainerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type HalfScreenLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type HalfScreenLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HalfScreenLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HalfScreenLinkingCollectionsProviderDetailsPageCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HalfScreenLinkingCollectionsSegmentsContainerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HalfScreenLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HalfScreenOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC';

export type HalfScreenSubHeading = {
  __typename?: 'HalfScreenSubHeading';
  json: Scalars['JSON']['output'];
  links: HalfScreenSubHeadingLinks;
};

export type HalfScreenSubHeadingAssets = {
  __typename?: 'HalfScreenSubHeadingAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type HalfScreenSubHeadingEntries = {
  __typename?: 'HalfScreenSubHeadingEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type HalfScreenSubHeadingLinks = {
  __typename?: 'HalfScreenSubHeadingLinks';
  assets: HalfScreenSubHeadingAssets;
  entries: HalfScreenSubHeadingEntries;
  resources: HalfScreenSubHeadingResources;
};

export type HalfScreenSubHeadingResources = {
  __typename?: 'HalfScreenSubHeadingResources';
  block: Array<HalfScreenSubHeadingResourcesBlock>;
  hyperlink: Array<HalfScreenSubHeadingResourcesHyperlink>;
  inline: Array<HalfScreenSubHeadingResourcesInline>;
};

export type HalfScreenSubHeadingResourcesBlock = ResourceLink & {
  __typename?: 'HalfScreenSubHeadingResourcesBlock';
  sys: ResourceSys;
};

export type HalfScreenSubHeadingResourcesHyperlink = ResourceLink & {
  __typename?: 'HalfScreenSubHeadingResourcesHyperlink';
  sys: ResourceSys;
};

export type HalfScreenSubHeadingResourcesInline = ResourceLink & {
  __typename?: 'HalfScreenSubHeadingResourcesInline';
  sys: ResourceSys;
};

export type HasAnswerFormat = {
  format?: Maybe<QuestionnaireAnswerFormat>;
};

export type HasPredefinedAnswer = {
  answers?: Maybe<Array<PredefinedAnswer>>;
};

/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type Header = Entry & _Node & {
  __typename?: 'Header';
  _id: Scalars['ID']['output'];
  bookNowButton?: Maybe<Entry>;
  bottomAlertBanner?: Maybe<Banner>;
  componentName?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  darkHeader?: Maybe<Scalars['Boolean']['output']>;
  googleMapsForLocationCards?: Maybe<GoogleMapTemplate>;
  hideFullSiteSearch?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<HeaderLinkingCollections>;
  locationBarFindOfficeUrl?: Maybe<Scalars['String']['output']>;
  locationBarWithOfficeTitle?: Maybe<Scalars['String']['output']>;
  locationBarWithOutOfficeTitle?: Maybe<Scalars['String']['output']>;
  locationNavigationLinksCollection?: Maybe<HeaderLocationNavigationLinksCollection>;
  myAccountLabel?: Maybe<Scalars['String']['output']>;
  navigationLinksCollection?: Maybe<HeaderNavigationLinksCollection>;
  navigationMenu?: Maybe<HeaderNavMenu>;
  phoneNumber?: Maybe<NavigationLink>;
  profileLinkUrl?: Maybe<Scalars['String']['output']>;
  schedulingButtonText?: Maybe<Scalars['String']['output']>;
  schedulingButtonTextMobile?: Maybe<Scalars['String']['output']>;
  schedulingButtonUrl?: Maybe<Scalars['String']['output']>;
  schedulingButtonUrlMobile?: Maybe<Scalars['String']['output']>;
  schedulingNavigationLinksCollection?: Maybe<HeaderSchedulingNavigationLinksCollection>;
  secondaryNavigationLinksCollection?: Maybe<HeaderSecondaryNavigationLinksCollection>;
  showSecondaryNavInMobileToolbar?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  topAlertBanner?: Maybe<Banner>;
  topNavigationLinksCollection?: Maybe<HeaderTopNavigationLinksCollection>;
  useHeaderLocationCards?: Maybe<Scalars['Boolean']['output']>;
  useNewLayout?: Maybe<Scalars['Boolean']['output']>;
  usePopupScheduling?: Maybe<Scalars['Boolean']['output']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderBookNowButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderBottomAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BannerFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderComponentNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderDarkHeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderGoogleMapsForLocationCardsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GoogleMapTemplateFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderHideFullSiteSearchArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderLocationBarFindOfficeUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderLocationBarWithOfficeTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderLocationBarWithOutOfficeTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderLocationNavigationLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeaderLocationNavigationLinksFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderMyAccountLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderNavigationLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeaderNavigationLinksFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderNavigationMenuArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderNavMenuFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderPhoneNumberArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderProfileLinkUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderSchedulingButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderSchedulingButtonTextMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderSchedulingButtonUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderSchedulingButtonUrlMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderSchedulingNavigationLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderSchedulingNavigationLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NavigationGroupFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderSecondaryNavigationLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeaderSecondaryNavigationLinksFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderShowSecondaryNavInMobileToolbarArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderTopAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BannerFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderTopNavigationLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeaderTopNavigationLinksFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderUseHeaderLocationCardsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderUseNewLayoutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderUsePopupSchedulingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type HeaderCollection = {
  __typename?: 'HeaderCollection';
  items: Array<Maybe<Header>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeaderFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeaderFilter>>>;
  bookNowButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bottomAlertBanner?: InputMaybe<CfBannerNestedFilter>;
  bottomAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName?: InputMaybe<Scalars['String']['input']>;
  componentName_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentName_not?: InputMaybe<Scalars['String']['input']>;
  componentName_not_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  darkHeader?: InputMaybe<Scalars['Boolean']['input']>;
  darkHeader_exists?: InputMaybe<Scalars['Boolean']['input']>;
  darkHeader_not?: InputMaybe<Scalars['Boolean']['input']>;
  googleMapsForLocationCards?: InputMaybe<CfGoogleMapTemplateNestedFilter>;
  googleMapsForLocationCards_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideFullSiteSearch?: InputMaybe<Scalars['Boolean']['input']>;
  hideFullSiteSearch_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideFullSiteSearch_not?: InputMaybe<Scalars['Boolean']['input']>;
  locationBarFindOfficeUrl?: InputMaybe<Scalars['String']['input']>;
  locationBarFindOfficeUrl_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarFindOfficeUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  locationBarFindOfficeUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationBarFindOfficeUrl_not?: InputMaybe<Scalars['String']['input']>;
  locationBarFindOfficeUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarFindOfficeUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationBarWithOfficeTitle?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOfficeTitle_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOfficeTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  locationBarWithOfficeTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationBarWithOfficeTitle_not?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOfficeTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOfficeTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationBarWithOutOfficeTitle?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOutOfficeTitle_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOutOfficeTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  locationBarWithOutOfficeTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationBarWithOutOfficeTitle_not?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOutOfficeTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOutOfficeTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationNavigationLinks?: InputMaybe<CflocationNavigationLinksMultiTypeNestedFilter>;
  locationNavigationLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  myAccountLabel?: InputMaybe<Scalars['String']['input']>;
  myAccountLabel_contains?: InputMaybe<Scalars['String']['input']>;
  myAccountLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  myAccountLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  myAccountLabel_not?: InputMaybe<Scalars['String']['input']>;
  myAccountLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  myAccountLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationLinks?: InputMaybe<CfnavigationLinksMultiTypeNestedFilter>;
  navigationLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  navigationMenu?: InputMaybe<CfHeaderNavMenuNestedFilter>;
  navigationMenu_exists?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<CfNavigationLinkNestedFilter>;
  phoneNumber_exists?: InputMaybe<Scalars['Boolean']['input']>;
  profileLinkUrl?: InputMaybe<Scalars['String']['input']>;
  profileLinkUrl_contains?: InputMaybe<Scalars['String']['input']>;
  profileLinkUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  profileLinkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profileLinkUrl_not?: InputMaybe<Scalars['String']['input']>;
  profileLinkUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  profileLinkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonText?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonTextMobile?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonTextMobile_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonTextMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingButtonTextMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonTextMobile_not?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonTextMobile_not_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonTextMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonText_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingButtonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonText_not?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonUrl?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrlMobile?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrlMobile_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrlMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingButtonUrlMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonUrlMobile_not?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrlMobile_not_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrlMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingButtonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonUrl_not?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingNavigationLinks?: InputMaybe<CfNavigationGroupNestedFilter>;
  schedulingNavigationLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryNavigationLinks?: InputMaybe<CfsecondaryNavigationLinksMultiTypeNestedFilter>;
  secondaryNavigationLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showSecondaryNavInMobileToolbar?: InputMaybe<Scalars['Boolean']['input']>;
  showSecondaryNavInMobileToolbar_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showSecondaryNavInMobileToolbar_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  topAlertBanner?: InputMaybe<CfBannerNestedFilter>;
  topAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  topNavigationLinks?: InputMaybe<CftopNavigationLinksMultiTypeNestedFilter>;
  topNavigationLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useHeaderLocationCards?: InputMaybe<Scalars['Boolean']['input']>;
  useHeaderLocationCards_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useHeaderLocationCards_not?: InputMaybe<Scalars['Boolean']['input']>;
  useNewLayout?: InputMaybe<Scalars['Boolean']['input']>;
  useNewLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useNewLayout_not?: InputMaybe<Scalars['Boolean']['input']>;
  usePopupScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  usePopupScheduling_exists?: InputMaybe<Scalars['Boolean']['input']>;
  usePopupScheduling_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeaderLinkingCollections = {
  __typename?: 'HeaderLinkingCollections';
  appCollection?: Maybe<AppCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type HeaderLinkingCollectionsAppCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderLinkingCollectionsAppCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type HeaderLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type HeaderLinkingCollectionsAppCollectionOrder =
  | 'brandImageLink_ASC'
  | 'brandImageLink_DESC'
  | 'branding_ASC'
  | 'branding_DESC'
  | 'isDeprecated_ASC'
  | 'isDeprecated_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeaderLocationNavigationLinksCollection = {
  __typename?: 'HeaderLocationNavigationLinksCollection';
  items: Array<Maybe<HeaderLocationNavigationLinksItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderLocationNavigationLinksFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeaderLocationNavigationLinksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeaderLocationNavigationLinksFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type HeaderLocationNavigationLinksItem = NavigationLink | Page;

/** The Header Navigation Menu Link and Sub Menu(navigation groups with links) displayed on hover of this link. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerMainNav) */
export type HeaderMainNav = Entry & _Node & {
  __typename?: 'HeaderMainNav';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  headerMainNavLink?: Maybe<NavigationLink>;
  headerSubNavMenu?: Maybe<HeaderSubNav>;
  linkedFrom?: Maybe<HeaderMainNavLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** The Header Navigation Menu Link and Sub Menu(navigation groups with links) displayed on hover of this link. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerMainNav) */
export type HeaderMainNavHeaderMainNavLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


/** The Header Navigation Menu Link and Sub Menu(navigation groups with links) displayed on hover of this link. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerMainNav) */
export type HeaderMainNavHeaderSubNavMenuArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderSubNavFilter>;
};


/** The Header Navigation Menu Link and Sub Menu(navigation groups with links) displayed on hover of this link. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerMainNav) */
export type HeaderMainNavLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** The Header Navigation Menu Link and Sub Menu(navigation groups with links) displayed on hover of this link. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerMainNav) */
export type HeaderMainNavNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type HeaderMainNavCollection = {
  __typename?: 'HeaderMainNavCollection';
  items: Array<Maybe<HeaderMainNav>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderMainNavFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeaderMainNavFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeaderMainNavFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headerMainNavLink?: InputMaybe<CfNavigationLinkNestedFilter>;
  headerMainNavLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerSubNavMenu?: InputMaybe<CfHeaderSubNavNestedFilter>;
  headerSubNavMenu_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type HeaderMainNavLinkingCollections = {
  __typename?: 'HeaderMainNavLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  headerNavMenuCollection?: Maybe<HeaderNavMenuCollection>;
};


export type HeaderMainNavLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type HeaderMainNavLinkingCollectionsHeaderNavMenuCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderMainNavLinkingCollectionsHeaderNavMenuCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type HeaderMainNavLinkingCollectionsHeaderNavMenuCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeaderMainNavOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** The navigation menu displayed in the header with main nav links and the sub nav groups and links. The sub nav will be displayed when hover over the main nav links. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerNavMenu) */
export type HeaderNavMenu = Entry & _Node & {
  __typename?: 'HeaderNavMenu';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  headerMainNavLinksCollection?: Maybe<HeaderNavMenuHeaderMainNavLinksCollection>;
  linkedFrom?: Maybe<HeaderNavMenuLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** The navigation menu displayed in the header with main nav links and the sub nav groups and links. The sub nav will be displayed when hover over the main nav links. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerNavMenu) */
export type HeaderNavMenuHeaderMainNavLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderNavMenuHeaderMainNavLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeaderMainNavFilter>;
};


/** The navigation menu displayed in the header with main nav links and the sub nav groups and links. The sub nav will be displayed when hover over the main nav links. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerNavMenu) */
export type HeaderNavMenuLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** The navigation menu displayed in the header with main nav links and the sub nav groups and links. The sub nav will be displayed when hover over the main nav links. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerNavMenu) */
export type HeaderNavMenuNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type HeaderNavMenuCollection = {
  __typename?: 'HeaderNavMenuCollection';
  items: Array<Maybe<HeaderNavMenu>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderNavMenuFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeaderNavMenuFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeaderNavMenuFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headerMainNavLinks?: InputMaybe<CfHeaderMainNavNestedFilter>;
  headerMainNavLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type HeaderNavMenuHeaderMainNavLinksCollection = {
  __typename?: 'HeaderNavMenuHeaderMainNavLinksCollection';
  items: Array<Maybe<HeaderMainNav>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderNavMenuHeaderMainNavLinksCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeaderNavMenuLinkingCollections = {
  __typename?: 'HeaderNavMenuLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  headerCollection?: Maybe<HeaderCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type HeaderNavMenuLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type HeaderNavMenuLinkingCollectionsHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderNavMenuLinkingCollectionsHeaderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type HeaderNavMenuLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderNavMenuLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type HeaderNavMenuLinkingCollectionsHeaderCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC';

export type HeaderNavMenuLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HeaderNavMenuOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeaderNavigationLinksCollection = {
  __typename?: 'HeaderNavigationLinksCollection';
  items: Array<Maybe<HeaderNavigationLinksItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderNavigationLinksFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeaderNavigationLinksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeaderNavigationLinksFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type HeaderNavigationLinksItem = FooterNavigationGroup | NavigationGroup | NavigationLink | Page;

export type HeaderOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC';

export type HeaderSchedulingNavigationLinksCollection = {
  __typename?: 'HeaderSchedulingNavigationLinksCollection';
  items: Array<Maybe<NavigationGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderSchedulingNavigationLinksCollectionOrder =
  | 'displayAsExpandedForMobileMenu_ASC'
  | 'displayAsExpandedForMobileMenu_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeaderSecondaryNavigationLinksCollection = {
  __typename?: 'HeaderSecondaryNavigationLinksCollection';
  items: Array<Maybe<HeaderSecondaryNavigationLinksItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderSecondaryNavigationLinksFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeaderSecondaryNavigationLinksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeaderSecondaryNavigationLinksFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type HeaderSecondaryNavigationLinksItem = NavigationLink | Page;

/** The navigation groups with sub links when hover over the header main nav link [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerSubNav) */
export type HeaderSubNav = Entry & _Node & {
  __typename?: 'HeaderSubNav';
  _id: Scalars['ID']['output'];
  contentTilesCollection?: Maybe<HeaderSubNavContentTilesCollection>;
  contentfulMetadata: ContentfulMetadata;
  headerSubNavGroupsCollection?: Maybe<HeaderSubNavHeaderSubNavGroupsCollection>;
  linkedFrom?: Maybe<HeaderSubNavLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** The navigation groups with sub links when hover over the header main nav link [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerSubNav) */
export type HeaderSubNavContentTilesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderSubNavContentTilesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTileFilter>;
};


/** The navigation groups with sub links when hover over the header main nav link [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerSubNav) */
export type HeaderSubNavHeaderSubNavGroupsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderSubNavHeaderSubNavGroupsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NavigationGroupFilter>;
};


/** The navigation groups with sub links when hover over the header main nav link [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerSubNav) */
export type HeaderSubNavLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** The navigation groups with sub links when hover over the header main nav link [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerSubNav) */
export type HeaderSubNavNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type HeaderSubNavCollection = {
  __typename?: 'HeaderSubNavCollection';
  items: Array<Maybe<HeaderSubNav>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderSubNavContentTilesCollection = {
  __typename?: 'HeaderSubNavContentTilesCollection';
  items: Array<Maybe<ContentTile>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderSubNavContentTilesCollectionOrder =
  | 'description_ASC'
  | 'description_DESC'
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HeaderSubNavFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeaderSubNavFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeaderSubNavFilter>>>;
  contentTiles?: InputMaybe<CfContentTileNestedFilter>;
  contentTilesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headerSubNavGroups?: InputMaybe<CfNavigationGroupNestedFilter>;
  headerSubNavGroupsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type HeaderSubNavHeaderSubNavGroupsCollection = {
  __typename?: 'HeaderSubNavHeaderSubNavGroupsCollection';
  items: Array<Maybe<NavigationGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderSubNavHeaderSubNavGroupsCollectionOrder =
  | 'displayAsExpandedForMobileMenu_ASC'
  | 'displayAsExpandedForMobileMenu_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeaderSubNavLinkingCollections = {
  __typename?: 'HeaderSubNavLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  headerMainNavCollection?: Maybe<HeaderMainNavCollection>;
};


export type HeaderSubNavLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type HeaderSubNavLinkingCollectionsHeaderMainNavCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderSubNavLinkingCollectionsHeaderMainNavCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type HeaderSubNavLinkingCollectionsHeaderMainNavCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeaderSubNavOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeaderTopNavigationLinksCollection = {
  __typename?: 'HeaderTopNavigationLinksCollection';
  items: Array<Maybe<HeaderTopNavigationLinksItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderTopNavigationLinksFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeaderTopNavigationLinksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeaderTopNavigationLinksFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type HeaderTopNavigationLinksItem = NavigationLink | Page;

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2 = Entry & _Node & {
  __typename?: 'HeroV2';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColorSmallScreen?: Maybe<Scalars['String']['output']>;
  body?: Maybe<HeroV2Body>;
  bodySize?: Maybe<Scalars['String']['output']>;
  buttonsCollection?: Maybe<HeroV2ButtonsCollection>;
  contentAlign?: Maybe<Scalars['String']['output']>;
  contentPosition?: Maybe<Scalars['String']['output']>;
  contentPositionSmallScreen?: Maybe<Scalars['String']['output']>;
  contentSmallScreen?: Maybe<SmallScreenContent>;
  contentWidth?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  darkOverlay?: Maybe<Scalars['Boolean']['output']>;
  darkTextColor?: Maybe<Scalars['Boolean']['output']>;
  disclaimer?: Maybe<DisclaimerV2>;
  display?: Maybe<Scalars['String']['output']>;
  entryName?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  eyebrowStyle?: Maybe<Scalars['String']['output']>;
  facilitySegmentCollection?: Maybe<Scalars['String']['output']>;
  focalPointImage?: Maybe<FocalPointImage>;
  heading?: Maybe<HeroV2Heading>;
  headingSize?: Maybe<Scalars['String']['output']>;
  heightStyle?: Maybe<Scalars['String']['output']>;
  imageAsset?: Maybe<ImageAsset>;
  linkedFrom?: Maybe<HeroV2LinkingCollections>;
  mediaAspectRatioSmallScreen?: Maybe<Scalars['String']['output']>;
  promoHeadline?: Maybe<HeroV2PromoHeadline>;
  promoHeadlineSize?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  templateWidth?: Maybe<Scalars['String']['output']>;
  termsConditions?: Maybe<TermsAndConditions>;
  video?: Maybe<Asset>;
  videoAsset?: Maybe<VideoAsset>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2AnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2BackgroundColorSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2BodyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2BodySizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2ButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroV2ButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2ContentAlignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2ContentPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2ContentPositionSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2ContentSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SmallScreenContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2ContentWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2DarkOverlayArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2DarkTextColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2DisclaimerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DisclaimerV2Filter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2DisplayArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2EntryNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2EyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2EyebrowStyleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2FacilitySegmentCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2FocalPointImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2HeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2HeadingSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2HeightStyleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2ImageAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2LinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2MediaAspectRatioSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2PromoHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2PromoHeadlineSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2TemplateWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2TermsConditionsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TermsAndConditionsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2VideoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2VideoAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoAssetFilter>;
};

export type HeroV2Body = {
  __typename?: 'HeroV2Body';
  json: Scalars['JSON']['output'];
  links: HeroV2BodyLinks;
};

export type HeroV2BodyAssets = {
  __typename?: 'HeroV2BodyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type HeroV2BodyEntries = {
  __typename?: 'HeroV2BodyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type HeroV2BodyLinks = {
  __typename?: 'HeroV2BodyLinks';
  assets: HeroV2BodyAssets;
  entries: HeroV2BodyEntries;
  resources: HeroV2BodyResources;
};

export type HeroV2BodyResources = {
  __typename?: 'HeroV2BodyResources';
  block: Array<HeroV2BodyResourcesBlock>;
  hyperlink: Array<HeroV2BodyResourcesHyperlink>;
  inline: Array<HeroV2BodyResourcesInline>;
};

export type HeroV2BodyResourcesBlock = ResourceLink & {
  __typename?: 'HeroV2BodyResourcesBlock';
  sys: ResourceSys;
};

export type HeroV2BodyResourcesHyperlink = ResourceLink & {
  __typename?: 'HeroV2BodyResourcesHyperlink';
  sys: ResourceSys;
};

export type HeroV2BodyResourcesInline = ResourceLink & {
  __typename?: 'HeroV2BodyResourcesInline';
  sys: ResourceSys;
};

export type HeroV2ButtonsCollection = {
  __typename?: 'HeroV2ButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeroV2ButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type HeroV2Collection = {
  __typename?: 'HeroV2Collection';
  items: Array<Maybe<HeroV2>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeroV2Filter = {
  AND?: InputMaybe<Array<InputMaybe<HeroV2Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeroV2Filter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColorSmallScreen?: InputMaybe<Scalars['String']['input']>;
  backgroundColorSmallScreen_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColorSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColorSmallScreen_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColorSmallScreen_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColorSmallScreen_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColorSmallScreen_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodySize?: InputMaybe<Scalars['String']['input']>;
  bodySize_contains?: InputMaybe<Scalars['String']['input']>;
  bodySize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodySize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodySize_not?: InputMaybe<Scalars['String']['input']>;
  bodySize_not_contains?: InputMaybe<Scalars['String']['input']>;
  bodySize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_exists?: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlign?: InputMaybe<Scalars['String']['input']>;
  contentAlign_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlign_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentAlign_not?: InputMaybe<Scalars['String']['input']>;
  contentAlign_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlign_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentPosition?: InputMaybe<Scalars['String']['input']>;
  contentPositionSmallScreen?: InputMaybe<Scalars['String']['input']>;
  contentPositionSmallScreen_contains?: InputMaybe<Scalars['String']['input']>;
  contentPositionSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentPositionSmallScreen_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentPositionSmallScreen_not?: InputMaybe<Scalars['String']['input']>;
  contentPositionSmallScreen_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentPositionSmallScreen_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentPosition_contains?: InputMaybe<Scalars['String']['input']>;
  contentPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentPosition_not?: InputMaybe<Scalars['String']['input']>;
  contentPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentSmallScreen?: InputMaybe<CfSmallScreenContentNestedFilter>;
  contentSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentWidth?: InputMaybe<Scalars['String']['input']>;
  contentWidth_contains?: InputMaybe<Scalars['String']['input']>;
  contentWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentWidth_not?: InputMaybe<Scalars['String']['input']>;
  contentWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  darkOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  darkOverlay_exists?: InputMaybe<Scalars['Boolean']['input']>;
  darkOverlay_not?: InputMaybe<Scalars['Boolean']['input']>;
  darkTextColor?: InputMaybe<Scalars['Boolean']['input']>;
  darkTextColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  darkTextColor_not?: InputMaybe<Scalars['Boolean']['input']>;
  disclaimer?: InputMaybe<CfDisclaimerV2NestedFilter>;
  disclaimer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  display_contains?: InputMaybe<Scalars['String']['input']>;
  display_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  display_not?: InputMaybe<Scalars['String']['input']>;
  display_not_contains?: InputMaybe<Scalars['String']['input']>;
  display_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryName?: InputMaybe<Scalars['String']['input']>;
  entryName_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryName_not?: InputMaybe<Scalars['String']['input']>;
  entryName_not_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowStyle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowStyle_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  focalPointImage?: InputMaybe<CfFocalPointImageNestedFilter>;
  focalPointImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingSize?: InputMaybe<Scalars['String']['input']>;
  headingSize_contains?: InputMaybe<Scalars['String']['input']>;
  headingSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingSize_not?: InputMaybe<Scalars['String']['input']>;
  headingSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  headingSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  heightStyle?: InputMaybe<Scalars['String']['input']>;
  heightStyle_contains?: InputMaybe<Scalars['String']['input']>;
  heightStyle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heightStyle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heightStyle_not?: InputMaybe<Scalars['String']['input']>;
  heightStyle_not_contains?: InputMaybe<Scalars['String']['input']>;
  heightStyle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAsset?: InputMaybe<CfImageAssetNestedFilter>;
  imageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaAspectRatioSmallScreen?: InputMaybe<Scalars['String']['input']>;
  mediaAspectRatioSmallScreen_contains?: InputMaybe<Scalars['String']['input']>;
  mediaAspectRatioSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaAspectRatioSmallScreen_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaAspectRatioSmallScreen_not?: InputMaybe<Scalars['String']['input']>;
  mediaAspectRatioSmallScreen_not_contains?: InputMaybe<Scalars['String']['input']>;
  mediaAspectRatioSmallScreen_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoHeadlineSize?: InputMaybe<Scalars['String']['input']>;
  promoHeadlineSize_contains?: InputMaybe<Scalars['String']['input']>;
  promoHeadlineSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  promoHeadlineSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoHeadlineSize_not?: InputMaybe<Scalars['String']['input']>;
  promoHeadlineSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  promoHeadlineSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoHeadline_contains?: InputMaybe<Scalars['String']['input']>;
  promoHeadline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  promoHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  templateWidth?: InputMaybe<Scalars['String']['input']>;
  templateWidth_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateWidth_not?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  termsConditions?: InputMaybe<CfTermsAndConditionsNestedFilter>;
  termsConditions_exists?: InputMaybe<Scalars['Boolean']['input']>;
  videoAsset?: InputMaybe<CfVideoAssetNestedFilter>;
  videoAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  video_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeroV2Heading = {
  __typename?: 'HeroV2Heading';
  json: Scalars['JSON']['output'];
  links: HeroV2HeadingLinks;
};

export type HeroV2HeadingAssets = {
  __typename?: 'HeroV2HeadingAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type HeroV2HeadingEntries = {
  __typename?: 'HeroV2HeadingEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type HeroV2HeadingLinks = {
  __typename?: 'HeroV2HeadingLinks';
  assets: HeroV2HeadingAssets;
  entries: HeroV2HeadingEntries;
  resources: HeroV2HeadingResources;
};

export type HeroV2HeadingResources = {
  __typename?: 'HeroV2HeadingResources';
  block: Array<HeroV2HeadingResourcesBlock>;
  hyperlink: Array<HeroV2HeadingResourcesHyperlink>;
  inline: Array<HeroV2HeadingResourcesInline>;
};

export type HeroV2HeadingResourcesBlock = ResourceLink & {
  __typename?: 'HeroV2HeadingResourcesBlock';
  sys: ResourceSys;
};

export type HeroV2HeadingResourcesHyperlink = ResourceLink & {
  __typename?: 'HeroV2HeadingResourcesHyperlink';
  sys: ResourceSys;
};

export type HeroV2HeadingResourcesInline = ResourceLink & {
  __typename?: 'HeroV2HeadingResourcesInline';
  sys: ResourceSys;
};

export type HeroV2LinkingCollections = {
  __typename?: 'HeroV2LinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  pageCollection?: Maybe<PageCollection>;
  segmentsContainerCollection?: Maybe<SegmentsContainerCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
};


export type HeroV2LinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type HeroV2LinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroV2LinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type HeroV2LinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroV2LinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type HeroV2LinkingCollectionsSegmentsContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroV2LinkingCollectionsSegmentsContainerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type HeroV2LinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroV2LinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type HeroV2LinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HeroV2LinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HeroV2LinkingCollectionsSegmentsContainerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeroV2LinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HeroV2Order =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type HeroV2PromoHeadline = {
  __typename?: 'HeroV2PromoHeadline';
  json: Scalars['JSON']['output'];
  links: HeroV2PromoHeadlineLinks;
};

export type HeroV2PromoHeadlineAssets = {
  __typename?: 'HeroV2PromoHeadlineAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type HeroV2PromoHeadlineEntries = {
  __typename?: 'HeroV2PromoHeadlineEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type HeroV2PromoHeadlineLinks = {
  __typename?: 'HeroV2PromoHeadlineLinks';
  assets: HeroV2PromoHeadlineAssets;
  entries: HeroV2PromoHeadlineEntries;
  resources: HeroV2PromoHeadlineResources;
};

export type HeroV2PromoHeadlineResources = {
  __typename?: 'HeroV2PromoHeadlineResources';
  block: Array<HeroV2PromoHeadlineResourcesBlock>;
  hyperlink: Array<HeroV2PromoHeadlineResourcesHyperlink>;
  inline: Array<HeroV2PromoHeadlineResourcesInline>;
};

export type HeroV2PromoHeadlineResourcesBlock = ResourceLink & {
  __typename?: 'HeroV2PromoHeadlineResourcesBlock';
  sys: ResourceSys;
};

export type HeroV2PromoHeadlineResourcesHyperlink = ResourceLink & {
  __typename?: 'HeroV2PromoHeadlineResourcesHyperlink';
  sys: ResourceSys;
};

export type HeroV2PromoHeadlineResourcesInline = ResourceLink & {
  __typename?: 'HeroV2PromoHeadlineResourcesInline';
  sys: ResourceSys;
};

/** Providing  a component to embed an iframe on the page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/iframe) */
export type Iframe = Entry & _Node & {
  __typename?: 'Iframe';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  height?: Maybe<Scalars['Int']['output']>;
  linkedFrom?: Maybe<IframeLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  rawHtml?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


/** Providing  a component to embed an iframe on the page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/iframe) */
export type IframeHeightArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Providing  a component to embed an iframe on the page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/iframe) */
export type IframeLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Providing  a component to embed an iframe on the page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/iframe) */
export type IframeNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Providing  a component to embed an iframe on the page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/iframe) */
export type IframeRawHtmlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Providing  a component to embed an iframe on the page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/iframe) */
export type IframeTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Providing  a component to embed an iframe on the page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/iframe) */
export type IframeUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type IframeCollection = {
  __typename?: 'IframeCollection';
  items: Array<Maybe<Iframe>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type IframeFilter = {
  AND?: InputMaybe<Array<InputMaybe<IframeFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<IframeFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  height?: InputMaybe<Scalars['Int']['input']>;
  height_exists?: InputMaybe<Scalars['Boolean']['input']>;
  height_gt?: InputMaybe<Scalars['Int']['input']>;
  height_gte?: InputMaybe<Scalars['Int']['input']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  height_lt?: InputMaybe<Scalars['Int']['input']>;
  height_lte?: InputMaybe<Scalars['Int']['input']>;
  height_not?: InputMaybe<Scalars['Int']['input']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rawHtml?: InputMaybe<Scalars['String']['input']>;
  rawHtml_contains?: InputMaybe<Scalars['String']['input']>;
  rawHtml_exists?: InputMaybe<Scalars['Boolean']['input']>;
  rawHtml_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rawHtml_not?: InputMaybe<Scalars['String']['input']>;
  rawHtml_not_contains?: InputMaybe<Scalars['String']['input']>;
  rawHtml_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type IframeLinkingCollections = {
  __typename?: 'IframeLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type IframeLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type IframeLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IframeLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type IframeLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type IframeOrder =
  | 'height_ASC'
  | 'height_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'url_ASC'
  | 'url_DESC';

export type Image = {
  __typename?: 'Image';
  data: Scalars['String']['output'];
  dataUrl: Scalars['String']['output'];
  mediaType: Scalars['String']['output'];
};

/** Content type used to display images with focal point using Brand Folder Image with separate images for Desktop and Mobile. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/imageAsset) */
export type ImageAsset = Entry & _Node & {
  __typename?: 'ImageAsset';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  desktopImage?: Maybe<Scalars['JSON']['output']>;
  linkedFrom?: Maybe<ImageAssetLinkingCollections>;
  mobileImage?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


/** Content type used to display images with focal point using Brand Folder Image with separate images for Desktop and Mobile. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/imageAsset) */
export type ImageAssetDesktopImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content type used to display images with focal point using Brand Folder Image with separate images for Desktop and Mobile. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/imageAsset) */
export type ImageAssetLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Content type used to display images with focal point using Brand Folder Image with separate images for Desktop and Mobile. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/imageAsset) */
export type ImageAssetMobileImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content type used to display images with focal point using Brand Folder Image with separate images for Desktop and Mobile. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/imageAsset) */
export type ImageAssetNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content type used to display images with focal point using Brand Folder Image with separate images for Desktop and Mobile. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/imageAsset) */
export type ImageAssetTagsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ImageAssetCollection = {
  __typename?: 'ImageAssetCollection';
  items: Array<Maybe<ImageAsset>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ImageAssetFilter = {
  AND?: InputMaybe<Array<InputMaybe<ImageAssetFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageAssetFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  desktopImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageAssetLinkingCollections = {
  __typename?: 'ImageAssetLinkingCollections';
  blogDetailsPageCollection?: Maybe<BlogDetailsPageCollection>;
  cardCollection?: Maybe<CardCollection>;
  categoryCollection?: Maybe<CategoryCollection>;
  columnsCollection?: Maybe<ColumnsCollection>;
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  googleMapTemplateCollection?: Maybe<GoogleMapTemplateCollection>;
  halfScreenCollection?: Maybe<HalfScreenCollection>;
  heroV2Collection?: Maybe<HeroV2Collection>;
  multiCardV2Collection?: Maybe<MultiCardV2Collection>;
  pageCollection?: Maybe<PageCollection>;
  patientReviewsV2Collection?: Maybe<PatientReviewsV2Collection>;
  providerDetailsPageCollection?: Maybe<ProviderDetailsPageCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceLineHeroCollection?: Maybe<ServiceLineHeroCollection>;
  singleMessageCollection?: Maybe<SingleMessageCollection>;
};


export type ImageAssetLinkingCollectionsBlogDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsBlogDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageAssetLinkingCollectionsCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageAssetLinkingCollectionsCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsCategoryCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageAssetLinkingCollectionsColumnsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsColumnsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageAssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageAssetLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageAssetLinkingCollectionsGoogleMapTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsGoogleMapTemplateCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageAssetLinkingCollectionsHalfScreenCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsHalfScreenCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageAssetLinkingCollectionsHeroV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsHeroV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageAssetLinkingCollectionsMultiCardV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsMultiCardV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageAssetLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageAssetLinkingCollectionsPatientReviewsV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsPatientReviewsV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageAssetLinkingCollectionsProviderDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsProviderDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageAssetLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageAssetLinkingCollectionsServiceLineHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsServiceLineHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageAssetLinkingCollectionsSingleMessageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsSingleMessageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageAssetLinkingCollectionsBlogDetailsPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ImageAssetLinkingCollectionsCardCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonIconPosition_ASC'
  | 'buttonIconPosition_DESC'
  | 'buttonIconSize_ASC'
  | 'buttonIconSize_DESC'
  | 'buttonIcon_ASC'
  | 'buttonIcon_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'buttonVariant_ASC'
  | 'buttonVariant_DESC'
  | 'cardIconAlignment_ASC'
  | 'cardIconAlignment_DESC'
  | 'cardIcon_ASC'
  | 'cardIcon_DESC'
  | 'cardTextAlignment_ASC'
  | 'cardTextAlignment_DESC'
  | 'eventType_ASC'
  | 'eventType_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRatio_ASC'
  | 'imageRatio_DESC'
  | 'imageUrl_ASC'
  | 'imageUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pdfDownloadTitle_ASC'
  | 'pdfDownloadTitle_DESC'
  | 'priority_ASC'
  | 'priority_DESC'
  | 'showBorder_ASC'
  | 'showBorder_DESC'
  | 'slot_ASC'
  | 'slot_DESC'
  | 'stepName_ASC'
  | 'stepName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tcText_ASC'
  | 'tcText_DESC'
  | 'tcUrl_ASC'
  | 'tcUrl_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ImageAssetLinkingCollectionsCategoryCollectionOrder =
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'link_ASC'
  | 'link_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ImageAssetLinkingCollectionsColumnsCollectionOrder =
  | 'allowEqualHeights_ASC'
  | 'allowEqualHeights_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'mobileDisplayAccordion_ASC'
  | 'mobileDisplayAccordion_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ImageAssetLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ImageAssetLinkingCollectionsGoogleMapTemplateCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'desktopZoom_ASC'
  | 'desktopZoom_DESC'
  | 'facilityBadgeLabel_ASC'
  | 'facilityBadgeLabel_DESC'
  | 'facilityBasePath_ASC'
  | 'facilityBasePath_DESC'
  | 'facilityButtonLabel_ASC'
  | 'facilityButtonLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'holidayHoursMessageText_ASC'
  | 'holidayHoursMessageText_DESC'
  | 'listTabIsHorizontalScrolling_ASC'
  | 'listTabIsHorizontalScrolling_DESC'
  | 'locationScheduleButtonUrl_ASC'
  | 'locationScheduleButtonUrl_DESC'
  | 'mobileZoom_ASC'
  | 'mobileZoom_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'searchRadius_ASC'
  | 'searchRadius_DESC'
  | 'searchResultLimit_ASC'
  | 'searchResultLimit_DESC'
  | 'service_ASC'
  | 'service_DESC'
  | 'setAsOfficeButtonText_ASC'
  | 'setAsOfficeButtonText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useCumulativeDesign_ASC'
  | 'useCumulativeDesign_DESC'
  | 'useModernDesign_ASC'
  | 'useModernDesign_DESC'
  | 'useUsaCountryMap_ASC'
  | 'useUsaCountryMap_DESC';

export type ImageAssetLinkingCollectionsHalfScreenCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC';

export type ImageAssetLinkingCollectionsHeroV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type ImageAssetLinkingCollectionsMultiCardV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'bigScreenBackground_ASC'
  | 'bigScreenBackground_DESC'
  | 'cardsAlignment_ASC'
  | 'cardsAlignment_DESC'
  | 'displayAsStepper_ASC'
  | 'displayAsStepper_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'enableMobileCarouselNavigation_ASC'
  | 'enableMobileCarouselNavigation_DESC'
  | 'enableResourceCardMode_ASC'
  | 'enableResourceCardMode_DESC'
  | 'eyebrowColor_ASC'
  | 'eyebrowColor_DESC'
  | 'eyebrowSx_ASC'
  | 'eyebrowSx_DESC'
  | 'eyebrowTextTransform_ASC'
  | 'eyebrowTextTransform_DESC'
  | 'fixBackgroundToBottom_ASC'
  | 'fixBackgroundToBottom_DESC'
  | 'forMobile_ASC'
  | 'forMobile_DESC'
  | 'headerSpacing_ASC'
  | 'headerSpacing_DESC'
  | 'lastRowCardsAlignment_ASC'
  | 'lastRowCardsAlignment_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'numberOfCardsInLineDesktop_ASC'
  | 'numberOfCardsInLineDesktop_DESC'
  | 'roundedImage_ASC'
  | 'roundedImage_DESC'
  | 'sectionEyebrow_ASC'
  | 'sectionEyebrow_DESC'
  | 'sectionInfoAlignment_ASC'
  | 'sectionInfoAlignment_DESC'
  | 'sectionTitleHtag_ASC'
  | 'sectionTitleHtag_DESC'
  | 'sectionTitle_ASC'
  | 'sectionTitle_DESC'
  | 'shouldDisplayCarouselOnDesktop_ASC'
  | 'shouldDisplayCarouselOnDesktop_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useCardMediaRoundedCorners_ASC'
  | 'useCardMediaRoundedCorners_DESC';

export type ImageAssetLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ImageAssetLinkingCollectionsPatientReviewsV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowLargeScreens_ASC'
  | 'eyebrowLargeScreens_DESC'
  | 'eyebrowSmallScreens_ASC'
  | 'eyebrowSmallScreens_DESC'
  | 'maxReviewsLargeScreens_ASC'
  | 'maxReviewsLargeScreens_DESC'
  | 'maxReviewsSmallScreens_ASC'
  | 'maxReviewsSmallScreens_DESC'
  | 'mode_ASC'
  | 'mode_DESC'
  | 'scoreIcon_ASC'
  | 'scoreIcon_DESC'
  | 'subtitleLargeScreens_ASC'
  | 'subtitleLargeScreens_DESC'
  | 'subtitleSmallScreens_ASC'
  | 'subtitleSmallScreens_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'titleLargeScreens_ASC'
  | 'titleLargeScreens_DESC'
  | 'titleSmallScreens_ASC'
  | 'titleSmallScreens_DESC'
  | 'trimThreshold_ASC'
  | 'trimThreshold_DESC';

export type ImageAssetLinkingCollectionsProviderDetailsPageCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ImageAssetLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ImageAssetLinkingCollectionsServiceLineHeroCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type ImageAssetLinkingCollectionsSingleMessageCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentFillVerticalSpace_ASC'
  | 'contentFillVerticalSpace_DESC'
  | 'displayTitleInline_ASC'
  | 'displayTitleInline_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isBannerImage_ASC'
  | 'isBannerImage_DESC'
  | 'isHeaderAboveSideImages_ASC'
  | 'isHeaderAboveSideImages_DESC'
  | 'isInlineLayout_ASC'
  | 'isInlineLayout_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showSubscriptionForm_ASC'
  | 'showSubscriptionForm_DESC'
  | 'subText_ASC'
  | 'subText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateHeight_ASC'
  | 'templateHeight_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleAlign_ASC'
  | 'titleAlign_DESC'
  | 'titleVariant_ASC'
  | 'titleVariant_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useRoundedCorners_ASC'
  | 'useRoundedCorners_DESC';

export type ImageAssetOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ImageFormat =
  /** AVIF image format. */
  | 'AVIF'
  /** JPG image format. */
  | 'JPG'
  /**
   * Progressive JPG format stores multiple passes of an image in progressively higher detail.
   *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
   *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
   *         early as possible to make the layout look as designed.
   */
  | 'JPG_PROGRESSIVE'
  /** PNG image format */
  | 'PNG'
  /**
   * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
   *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
   */
  | 'PNG8'
  /** WebP image format. */
  | 'WEBP';

export type ImageResizeFocus =
  /** Focus the resizing on the bottom. */
  | 'BOTTOM'
  /** Focus the resizing on the bottom left. */
  | 'BOTTOM_LEFT'
  /** Focus the resizing on the bottom right. */
  | 'BOTTOM_RIGHT'
  /** Focus the resizing on the center. */
  | 'CENTER'
  /** Focus the resizing on the largest face. */
  | 'FACE'
  /** Focus the resizing on the area containing all the faces. */
  | 'FACES'
  /** Focus the resizing on the left. */
  | 'LEFT'
  /** Focus the resizing on the right. */
  | 'RIGHT'
  /** Focus the resizing on the top. */
  | 'TOP'
  /** Focus the resizing on the top left. */
  | 'TOP_LEFT'
  /** Focus the resizing on the top right. */
  | 'TOP_RIGHT';

export type ImageResizeStrategy =
  /** Crops a part of the original image to fit into the specified dimensions. */
  | 'CROP'
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  | 'FILL'
  /** Resizes the image to fit into the specified dimensions. */
  | 'FIT'
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   *         Uses desired background color as padding color.
   */
  | 'PAD'
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  | 'SCALE'
  /** Creates a thumbnail from the image. */
  | 'THUMB';

export type ImageTransformOptions = {
  /**
   * Desired background color, used with corner radius or `PAD` resize strategy.
   *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
   */
  backgroundColor?: InputMaybe<Scalars['HexColor']['input']>;
  /**
   * Desired corner radius in pixels.
   *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
   *         Defaults to `0`. Uses desired background color as padding color,
   *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
   */
  cornerRadius?: InputMaybe<Scalars['Int']['input']>;
  /** Desired image format. Defaults to the original image format. */
  format?: InputMaybe<ImageFormat>;
  /** Desired height in pixels. Defaults to the original image height. */
  height?: InputMaybe<Scalars['Dimension']['input']>;
  /**
   * Desired quality of the image in percents.
   *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
   */
  quality?: InputMaybe<Scalars['Quality']['input']>;
  /** Desired resize focus area. Defaults to `CENTER`. */
  resizeFocus?: InputMaybe<ImageResizeFocus>;
  /** Desired resize strategy. Defaults to `FIT`. */
  resizeStrategy?: InputMaybe<ImageResizeStrategy>;
  /** Desired width in pixels. Defaults to the original image width. */
  width?: InputMaybe<Scalars['Dimension']['input']>;
};

export type IneligibilityReasonEnum =
  | 'HAS_SCHEDULED_VISIT'
  | 'INACTIVE_ACCOUNT'
  | 'NOT_CONSIDERED_AS_NEW_PATIENT';

/** List Insurance Providers by States with a Rich Text Introduction [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/insurance) */
export type Insurance = Entry & _Node & {
  __typename?: 'Insurance';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  intro?: Maybe<InsuranceIntro>;
  linkedFrom?: Maybe<InsuranceLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** List Insurance Providers by States with a Rich Text Introduction [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/insurance) */
export type InsuranceIntroArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** List Insurance Providers by States with a Rich Text Introduction [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/insurance) */
export type InsuranceLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** List Insurance Providers by States with a Rich Text Introduction [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/insurance) */
export type InsuranceNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** List Insurance Providers by States with a Rich Text Introduction [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/insurance) */
export type InsuranceTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type InsuranceCollection = {
  __typename?: 'InsuranceCollection';
  items: Array<Maybe<Insurance>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type InsuranceCompaniesFilterInput = {
  facilityBrand?: InputMaybe<FacilityBrand>;
  usStateCode?: InputMaybe<UsStateCode>;
};

export type InsuranceCompaniesList = {
  __typename?: 'InsuranceCompaniesList';
  items: Array<InsuranceCompany>;
  total: Scalars['Int']['output'];
};

export type InsuranceCompaniesNetwork = {
  __typename?: 'InsuranceCompaniesNetwork';
  name?: Maybe<Scalars['String']['output']>;
};

export type InsuranceCompaniesNetworkFilterInput = {
  facilityBrand?: InputMaybe<FacilityBrand>;
  usStateCode?: InputMaybe<UsStateCode>;
};

export type InsuranceCompaniesNetworkList = {
  __typename?: 'InsuranceCompaniesNetworkList';
  items: Array<InsuranceCompaniesNetwork>;
  total: Scalars['Int']['output'];
};

export type InsuranceCompany = {
  __typename?: 'InsuranceCompany';
  name?: Maybe<Scalars['String']['output']>;
};

export type InsuranceFilter = {
  AND?: InputMaybe<Array<InputMaybe<InsuranceFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<InsuranceFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  intro_contains?: InputMaybe<Scalars['String']['input']>;
  intro_exists?: InputMaybe<Scalars['Boolean']['input']>;
  intro_not_contains?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InsuranceIntro = {
  __typename?: 'InsuranceIntro';
  json: Scalars['JSON']['output'];
  links: InsuranceIntroLinks;
};

export type InsuranceIntroAssets = {
  __typename?: 'InsuranceIntroAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type InsuranceIntroEntries = {
  __typename?: 'InsuranceIntroEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type InsuranceIntroLinks = {
  __typename?: 'InsuranceIntroLinks';
  assets: InsuranceIntroAssets;
  entries: InsuranceIntroEntries;
  resources: InsuranceIntroResources;
};

export type InsuranceIntroResources = {
  __typename?: 'InsuranceIntroResources';
  block: Array<InsuranceIntroResourcesBlock>;
  hyperlink: Array<InsuranceIntroResourcesHyperlink>;
  inline: Array<InsuranceIntroResourcesInline>;
};

export type InsuranceIntroResourcesBlock = ResourceLink & {
  __typename?: 'InsuranceIntroResourcesBlock';
  sys: ResourceSys;
};

export type InsuranceIntroResourcesHyperlink = ResourceLink & {
  __typename?: 'InsuranceIntroResourcesHyperlink';
  sys: ResourceSys;
};

export type InsuranceIntroResourcesInline = ResourceLink & {
  __typename?: 'InsuranceIntroResourcesInline';
  sys: ResourceSys;
};

export type InsuranceLinkingCollections = {
  __typename?: 'InsuranceLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type InsuranceLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type InsuranceLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<InsuranceLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type InsuranceLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type InsuranceOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type Intervals = {
  __typename?: 'Intervals';
  endTime?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type InvalidFieldError = Error & {
  __typename?: 'InvalidFieldError';
  fieldName: Scalars['String']['output'];
  message: Scalars['String']['output'];
  validFormat?: Maybe<Scalars['String']['output']>;
};

/** Returned when provided answer type and expected answer type mismatch. */
export type InvalidQuestionnaireAnswerTypeError = Error & {
  __typename?: 'InvalidQuestionnaireAnswerTypeError';
  answeredQuestion: QuestionnaireQuestion;
  message: Scalars['String']['output'];
  providedAnswerType: Scalars['String']['output'];
};

export type InvalidRelationToGuarantorError = Error & {
  __typename?: 'InvalidRelationToGuarantorError';
  message: Scalars['String']['output'];
};

/** Allows one to forward a platform page to an external page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/linkForwarder) */
export type LinkForwarder = Entry & _Node & {
  __typename?: 'LinkForwarder';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<LinkForwarderLinkingCollections>;
  sys: Sys;
  url?: Maybe<Scalars['String']['output']>;
};


/** Allows one to forward a platform page to an external page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/linkForwarder) */
export type LinkForwarderLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Allows one to forward a platform page to an external page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/linkForwarder) */
export type LinkForwarderUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type LinkForwarderCollection = {
  __typename?: 'LinkForwarderCollection';
  items: Array<Maybe<LinkForwarder>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LinkForwarderFilter = {
  AND?: InputMaybe<Array<InputMaybe<LinkForwarderFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LinkForwarderFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LinkForwarderLinkingCollections = {
  __typename?: 'LinkForwarderLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type LinkForwarderLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type LinkForwarderLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LinkForwarderLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type LinkForwarderLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type LinkForwarderOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'url_ASC'
  | 'url_DESC';

/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitle = Entry & _Node & {
  __typename?: 'LocalizedServiceTitle';
  _id: Scalars['ID']['output'];
  callCenterLabel?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<ContentTypeRichText>;
  googleMapsBusinessQuery?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<LocalizedServiceTitleLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  officeHoursLabel?: Maybe<Scalars['String']['output']>;
  showAddress?: Maybe<Scalars['Boolean']['output']>;
  showHours?: Maybe<Scalars['Boolean']['output']>;
  showPhoneNumber?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  templateWidth?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleHtag?: Maybe<Scalars['String']['output']>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleCallCenterLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleGoogleMapsBusinessQueryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleOfficeHoursLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleShowAddressArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleShowHoursArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleShowPhoneNumberArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleTemplateWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type LocalizedServiceTitleCollection = {
  __typename?: 'LocalizedServiceTitleCollection';
  items: Array<Maybe<LocalizedServiceTitle>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LocalizedServiceTitleFilter = {
  AND?: InputMaybe<Array<InputMaybe<LocalizedServiceTitleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LocalizedServiceTitleFilter>>>;
  callCenterLabel?: InputMaybe<Scalars['String']['input']>;
  callCenterLabel_contains?: InputMaybe<Scalars['String']['input']>;
  callCenterLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  callCenterLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callCenterLabel_not?: InputMaybe<Scalars['String']['input']>;
  callCenterLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  callCenterLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<CfContentTypeRichTextNestedFilter>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  googleMapsBusinessQuery?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_contains?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_exists?: InputMaybe<Scalars['Boolean']['input']>;
  googleMapsBusinessQuery_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googleMapsBusinessQuery_not?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_not_contains?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeHoursLabel?: InputMaybe<Scalars['String']['input']>;
  officeHoursLabel_contains?: InputMaybe<Scalars['String']['input']>;
  officeHoursLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  officeHoursLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeHoursLabel_not?: InputMaybe<Scalars['String']['input']>;
  officeHoursLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  officeHoursLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAddress?: InputMaybe<Scalars['Boolean']['input']>;
  showAddress_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showAddress_not?: InputMaybe<Scalars['Boolean']['input']>;
  showHours?: InputMaybe<Scalars['Boolean']['input']>;
  showHours_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showHours_not?: InputMaybe<Scalars['Boolean']['input']>;
  showPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  showPhoneNumber_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showPhoneNumber_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  templateWidth?: InputMaybe<Scalars['String']['input']>;
  templateWidth_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateWidth_not?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LocalizedServiceTitleLinkingCollections = {
  __typename?: 'LocalizedServiceTitleLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type LocalizedServiceTitleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type LocalizedServiceTitleOrder =
  | 'callCenterLabel_ASC'
  | 'callCenterLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showAddress_ASC'
  | 'showAddress_DESC'
  | 'showHours_ASC'
  | 'showHours_DESC'
  | 'showPhoneNumber_ASC'
  | 'showPhoneNumber_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/marquee) */
export type Marquee = Entry & _Node & {
  __typename?: 'Marquee';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  facilitySegmentCollection?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<MarqueeLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  textList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  withAutoScrolling?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/marquee) */
export type MarqueeAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/marquee) */
export type MarqueeBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/marquee) */
export type MarqueeFacilitySegmentCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/marquee) */
export type MarqueeHeightArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/marquee) */
export type MarqueeIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/marquee) */
export type MarqueeLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/marquee) */
export type MarqueeNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/marquee) */
export type MarqueeTextListArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/marquee) */
export type MarqueeWithAutoScrollingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type MarqueeCollection = {
  __typename?: 'MarqueeCollection';
  items: Array<Maybe<Marquee>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MarqueeFilter = {
  AND?: InputMaybe<Array<InputMaybe<MarqueeFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MarqueeFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height?: InputMaybe<Scalars['String']['input']>;
  height_contains?: InputMaybe<Scalars['String']['input']>;
  height_exists?: InputMaybe<Scalars['Boolean']['input']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height_not?: InputMaybe<Scalars['String']['input']>;
  height_not_contains?: InputMaybe<Scalars['String']['input']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  textList_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textList_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textList_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textList_exists?: InputMaybe<Scalars['Boolean']['input']>;
  withAutoScrolling?: InputMaybe<Scalars['Boolean']['input']>;
  withAutoScrolling_exists?: InputMaybe<Scalars['Boolean']['input']>;
  withAutoScrolling_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarqueeLinkingCollections = {
  __typename?: 'MarqueeLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  pageCollection?: Maybe<PageCollection>;
  segmentsContainerCollection?: Maybe<SegmentsContainerCollection>;
};


export type MarqueeLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MarqueeLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MarqueeLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MarqueeLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MarqueeLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MarqueeLinkingCollectionsSegmentsContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MarqueeLinkingCollectionsSegmentsContainerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type MarqueeLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MarqueeLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MarqueeLinkingCollectionsSegmentsContainerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type MarqueeOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'height_ASC'
  | 'height_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'withAutoScrolling_ASC'
  | 'withAutoScrolling_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mediaSlider) */
export type MediaSlider = Entry & _Node & {
  __typename?: 'MediaSlider';
  _id: Scalars['ID']['output'];
  aspectRatio?: Maybe<Scalars['String']['output']>;
  badge?: Maybe<Badge>;
  contentfulMetadata: ContentfulMetadata;
  contentsCollection?: Maybe<MediaSliderContentsCollection>;
  linkedFrom?: Maybe<MediaSliderLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mediaSlider) */
export type MediaSliderAspectRatioArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mediaSlider) */
export type MediaSliderBadgeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BadgeFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mediaSlider) */
export type MediaSliderContentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MediaSliderContentsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mediaSlider) */
export type MediaSliderLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mediaSlider) */
export type MediaSliderNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type MediaSliderCollection = {
  __typename?: 'MediaSliderCollection';
  items: Array<Maybe<MediaSlider>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MediaSliderContentsCollection = {
  __typename?: 'MediaSliderContentsCollection';
  items: Array<Maybe<MediaSliderContentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MediaSliderContentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<MediaSliderContentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MediaSliderContentsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type MediaSliderContentsItem = FocalPointImage | Video;

export type MediaSliderFilter = {
  AND?: InputMaybe<Array<InputMaybe<MediaSliderFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MediaSliderFilter>>>;
  aspectRatio?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_contains?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  aspectRatio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aspectRatio_not?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_not_contains?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badge?: InputMaybe<CfBadgeNestedFilter>;
  badge_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  contents?: InputMaybe<CfcontentsMultiTypeNestedFilter>;
  contentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type MediaSliderLinkingCollections = {
  __typename?: 'MediaSliderLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
  productFeatureCollection?: Maybe<ProductFeatureCollection>;
};


export type MediaSliderLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MediaSliderLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MediaSliderLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MediaSliderLinkingCollectionsProductFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MediaSliderLinkingCollectionsProductFeatureCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type MediaSliderLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MediaSliderLinkingCollectionsProductFeatureCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'enableSliderControlsBackgroundGradient_ASC'
  | 'enableSliderControlsBackgroundGradient_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type MediaSliderOrder =
  | 'aspectRatio_ASC'
  | 'aspectRatio_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** A medical service belongs to a service line, e.g Injury, X-ray, Covid-19 etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/medicalService) */
export type MedicalService = Entry & _Node & {
  __typename?: 'MedicalService';
  _id: Scalars['ID']['output'];
  analyticsContext?: Maybe<AnalyticsContext>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<MedicalServiceDescription>;
  iconName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<MedicalServiceLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** A medical service belongs to a service line, e.g Injury, X-ray, Covid-19 etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/medicalService) */
export type MedicalServiceAnalyticsContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** A medical service belongs to a service line, e.g Injury, X-ray, Covid-19 etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/medicalService) */
export type MedicalServiceDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A medical service belongs to a service line, e.g Injury, X-ray, Covid-19 etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/medicalService) */
export type MedicalServiceIconNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A medical service belongs to a service line, e.g Injury, X-ray, Covid-19 etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/medicalService) */
export type MedicalServiceLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A medical service belongs to a service line, e.g Injury, X-ray, Covid-19 etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/medicalService) */
export type MedicalServiceNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A medical service belongs to a service line, e.g Injury, X-ray, Covid-19 etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/medicalService) */
export type MedicalServiceTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type MedicalServiceCollection = {
  __typename?: 'MedicalServiceCollection';
  items: Array<Maybe<MedicalService>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MedicalServiceDescription = {
  __typename?: 'MedicalServiceDescription';
  json: Scalars['JSON']['output'];
  links: MedicalServiceDescriptionLinks;
};

export type MedicalServiceDescriptionAssets = {
  __typename?: 'MedicalServiceDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type MedicalServiceDescriptionEntries = {
  __typename?: 'MedicalServiceDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type MedicalServiceDescriptionLinks = {
  __typename?: 'MedicalServiceDescriptionLinks';
  assets: MedicalServiceDescriptionAssets;
  entries: MedicalServiceDescriptionEntries;
  resources: MedicalServiceDescriptionResources;
};

export type MedicalServiceDescriptionResources = {
  __typename?: 'MedicalServiceDescriptionResources';
  block: Array<MedicalServiceDescriptionResourcesBlock>;
  hyperlink: Array<MedicalServiceDescriptionResourcesHyperlink>;
  inline: Array<MedicalServiceDescriptionResourcesInline>;
};

export type MedicalServiceDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'MedicalServiceDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type MedicalServiceDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'MedicalServiceDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type MedicalServiceDescriptionResourcesInline = ResourceLink & {
  __typename?: 'MedicalServiceDescriptionResourcesInline';
  sys: ResourceSys;
};

export type MedicalServiceFilter = {
  AND?: InputMaybe<Array<InputMaybe<MedicalServiceFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MedicalServiceFilter>>>;
  analyticsContext?: InputMaybe<CfAnalyticsContextNestedFilter>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconName?: InputMaybe<Scalars['String']['input']>;
  iconName_contains?: InputMaybe<Scalars['String']['input']>;
  iconName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconName_not?: InputMaybe<Scalars['String']['input']>;
  iconName_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MedicalServiceLinkingCollections = {
  __typename?: 'MedicalServiceLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  serviceLineHeroCollection?: Maybe<ServiceLineHeroCollection>;
};


export type MedicalServiceLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MedicalServiceLinkingCollectionsServiceLineHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MedicalServiceLinkingCollectionsServiceLineHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type MedicalServiceLinkingCollectionsServiceLineHeroCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type MedicalServiceOrder =
  | 'iconName_ASC'
  | 'iconName_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** MeetOurDoctors will be deprecated in the future. MeetOurStaff will take it's place. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaff = Entry & _Node & {
  __typename?: 'MeetOurStaff';
  _id: Scalars['ID']['output'];
  alignment?: Maybe<Scalars['String']['output']>;
  anchorId?: Maybe<Scalars['String']['output']>;
  contentMaxWidth?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<MeetOurStaffLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  providerIDs?: Maybe<Scalars['String']['output']>;
  sectionBackground?: Maybe<Scalars['String']['output']>;
  showDisabledSwiperArrows?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  withDesktopPaginationNavigation?: Maybe<Scalars['Boolean']['output']>;
  withMobileArrowsNavigation?: Maybe<Scalars['Boolean']['output']>;
};


/** MeetOurDoctors will be deprecated in the future. MeetOurStaff will take it's place. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** MeetOurDoctors will be deprecated in the future. MeetOurStaff will take it's place. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** MeetOurDoctors will be deprecated in the future. MeetOurStaff will take it's place. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffContentMaxWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** MeetOurDoctors will be deprecated in the future. MeetOurStaff will take it's place. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** MeetOurDoctors will be deprecated in the future. MeetOurStaff will take it's place. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** MeetOurDoctors will be deprecated in the future. MeetOurStaff will take it's place. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** MeetOurDoctors will be deprecated in the future. MeetOurStaff will take it's place. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffProviderIDsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** MeetOurDoctors will be deprecated in the future. MeetOurStaff will take it's place. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffSectionBackgroundArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** MeetOurDoctors will be deprecated in the future. MeetOurStaff will take it's place. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffShowDisabledSwiperArrowsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** MeetOurDoctors will be deprecated in the future. MeetOurStaff will take it's place. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** MeetOurDoctors will be deprecated in the future. MeetOurStaff will take it's place. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffWithDesktopPaginationNavigationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** MeetOurDoctors will be deprecated in the future. MeetOurStaff will take it's place. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffWithMobileArrowsNavigationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type MeetOurStaffCollection = {
  __typename?: 'MeetOurStaffCollection';
  items: Array<Maybe<MeetOurStaff>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MeetOurStaffFilter = {
  AND?: InputMaybe<Array<InputMaybe<MeetOurStaffFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MeetOurStaffFilter>>>;
  alignment?: InputMaybe<Scalars['String']['input']>;
  alignment_contains?: InputMaybe<Scalars['String']['input']>;
  alignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  alignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alignment_not?: InputMaybe<Scalars['String']['input']>;
  alignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  alignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentMaxWidth?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_contains?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentMaxWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentMaxWidth_not?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerIDs?: InputMaybe<Scalars['String']['input']>;
  providerIDs_contains?: InputMaybe<Scalars['String']['input']>;
  providerIDs_exists?: InputMaybe<Scalars['Boolean']['input']>;
  providerIDs_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerIDs_not?: InputMaybe<Scalars['String']['input']>;
  providerIDs_not_contains?: InputMaybe<Scalars['String']['input']>;
  providerIDs_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionBackground?: InputMaybe<Scalars['String']['input']>;
  sectionBackground_contains?: InputMaybe<Scalars['String']['input']>;
  sectionBackground_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionBackground_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionBackground_not?: InputMaybe<Scalars['String']['input']>;
  sectionBackground_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionBackground_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showDisabledSwiperArrows?: InputMaybe<Scalars['Boolean']['input']>;
  showDisabledSwiperArrows_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showDisabledSwiperArrows_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withDesktopPaginationNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  withDesktopPaginationNavigation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  withDesktopPaginationNavigation_not?: InputMaybe<Scalars['Boolean']['input']>;
  withMobileArrowsNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  withMobileArrowsNavigation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  withMobileArrowsNavigation_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MeetOurStaffLinkingCollections = {
  __typename?: 'MeetOurStaffLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  pageCollection?: Maybe<PageCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
};


export type MeetOurStaffLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MeetOurStaffLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MeetOurStaffLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MeetOurStaffLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MeetOurStaffLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MeetOurStaffLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MeetOurStaffLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type MeetOurStaffLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MeetOurStaffLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MeetOurStaffLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MeetOurStaffOrder =
  | 'alignment_ASC'
  | 'alignment_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'providerIDs_ASC'
  | 'providerIDs_DESC'
  | 'sectionBackground_ASC'
  | 'sectionBackground_DESC'
  | 'showDisabledSwiperArrows_ASC'
  | 'showDisabledSwiperArrows_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'withDesktopPaginationNavigation_ASC'
  | 'withDesktopPaginationNavigation_DESC'
  | 'withMobileArrowsNavigation_ASC'
  | 'withMobileArrowsNavigation_DESC';

/** Generic Mobile button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mobileButton) */
export type MobileButton = Entry & _Node & {
  __typename?: 'MobileButton';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  icon?: Maybe<Scalars['String']['output']>;
  iconPosition?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<MobileButtonLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  variant?: Maybe<Scalars['String']['output']>;
};


/** Generic Mobile button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mobileButton) */
export type MobileButtonIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Mobile button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mobileButton) */
export type MobileButtonIconPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Mobile button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mobileButton) */
export type MobileButtonLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Mobile button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mobileButton) */
export type MobileButtonLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Generic Mobile button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mobileButton) */
export type MobileButtonNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Mobile button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mobileButton) */
export type MobileButtonSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Mobile button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mobileButton) */
export type MobileButtonVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type MobileButtonCollection = {
  __typename?: 'MobileButtonCollection';
  items: Array<Maybe<MobileButton>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MobileButtonFilter = {
  AND?: InputMaybe<Array<InputMaybe<MobileButtonFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MobileButtonFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconPosition?: InputMaybe<Scalars['String']['input']>;
  iconPosition_contains?: InputMaybe<Scalars['String']['input']>;
  iconPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconPosition_not?: InputMaybe<Scalars['String']['input']>;
  iconPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size?: InputMaybe<Scalars['String']['input']>;
  size_contains?: InputMaybe<Scalars['String']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size_not?: InputMaybe<Scalars['String']['input']>;
  size_not_contains?: InputMaybe<Scalars['String']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MobileButtonLinkingCollections = {
  __typename?: 'MobileButtonLinkingCollections';
  buttonCollection?: Maybe<ButtonCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type MobileButtonLinkingCollectionsButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MobileButtonLinkingCollectionsButtonCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MobileButtonLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type MobileButtonLinkingCollectionsButtonCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type MobileButtonOrder =
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2 = Entry & _Node & {
  __typename?: 'MultiCardV2';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<ImageAsset>;
  bigScreenBackground?: Maybe<Scalars['Boolean']['output']>;
  buttonsCollection?: Maybe<MultiCardV2ButtonsCollection>;
  cardsAlignment?: Maybe<Scalars['String']['output']>;
  cardsCollection?: Maybe<MultiCardV2CardsCollection>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  descriptionRichText?: Maybe<MultiCardV2DescriptionRichText>;
  disablePaddingOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  display?: Maybe<Scalars['String']['output']>;
  displayAsStepper?: Maybe<Scalars['Boolean']['output']>;
  enableMobileCarouselNavigation?: Maybe<Scalars['Boolean']['output']>;
  enableResourceCardMode?: Maybe<Scalars['Boolean']['output']>;
  eyebrowColor?: Maybe<Scalars['String']['output']>;
  eyebrowSx?: Maybe<Scalars['String']['output']>;
  eyebrowTextTransform?: Maybe<Scalars['String']['output']>;
  facilitySegmentCollection?: Maybe<Scalars['String']['output']>;
  fixBackgroundToBottom?: Maybe<Scalars['Boolean']['output']>;
  forMobile?: Maybe<Scalars['String']['output']>;
  headerSpacing?: Maybe<Scalars['String']['output']>;
  lastRowCardsAlignment?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<MultiCardV2LinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  noResultsContent?: Maybe<MultiCardV2>;
  numberOfCardsInLineDesktop?: Maybe<Scalars['Int']['output']>;
  roundedImage?: Maybe<Scalars['Boolean']['output']>;
  sectionEyebrow?: Maybe<Scalars['String']['output']>;
  sectionInfoAlignment?: Maybe<Scalars['String']['output']>;
  sectionTitle?: Maybe<Scalars['String']['output']>;
  sectionTitleHtag?: Maybe<Scalars['String']['output']>;
  shouldDisplayCarouselOnDesktop?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  useCardMediaRoundedCorners?: Maybe<Scalars['Boolean']['output']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2AnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2BackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2BackgroundImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2BigScreenBackgroundArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2ButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2ButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2CardsAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2CardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2CardsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardFilter>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2DescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2DescriptionRichTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2DisablePaddingOnArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2DisplayArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2DisplayAsStepperArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2EnableMobileCarouselNavigationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2EnableResourceCardModeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2EyebrowColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2EyebrowSxArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2EyebrowTextTransformArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2FacilitySegmentCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2FixBackgroundToBottomArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2ForMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2HeaderSpacingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2LastRowCardsAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2LinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2NameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2NoResultsContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MultiCardV2Filter>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2NumberOfCardsInLineDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2RoundedImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2SectionEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2SectionInfoAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2SectionTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2SectionTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2ShouldDisplayCarouselOnDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2UseCardMediaRoundedCornersArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type MultiCardV2ButtonsCollection = {
  __typename?: 'MultiCardV2ButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MultiCardV2ButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type MultiCardV2CardsCollection = {
  __typename?: 'MultiCardV2CardsCollection';
  items: Array<Maybe<Card>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MultiCardV2CardsCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonIconPosition_ASC'
  | 'buttonIconPosition_DESC'
  | 'buttonIconSize_ASC'
  | 'buttonIconSize_DESC'
  | 'buttonIcon_ASC'
  | 'buttonIcon_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'buttonVariant_ASC'
  | 'buttonVariant_DESC'
  | 'cardIconAlignment_ASC'
  | 'cardIconAlignment_DESC'
  | 'cardIcon_ASC'
  | 'cardIcon_DESC'
  | 'cardTextAlignment_ASC'
  | 'cardTextAlignment_DESC'
  | 'eventType_ASC'
  | 'eventType_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRatio_ASC'
  | 'imageRatio_DESC'
  | 'imageUrl_ASC'
  | 'imageUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pdfDownloadTitle_ASC'
  | 'pdfDownloadTitle_DESC'
  | 'priority_ASC'
  | 'priority_DESC'
  | 'showBorder_ASC'
  | 'showBorder_DESC'
  | 'slot_ASC'
  | 'slot_DESC'
  | 'stepName_ASC'
  | 'stepName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tcText_ASC'
  | 'tcText_DESC'
  | 'tcUrl_ASC'
  | 'tcUrl_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MultiCardV2Collection = {
  __typename?: 'MultiCardV2Collection';
  items: Array<Maybe<MultiCardV2>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MultiCardV2DescriptionRichText = {
  __typename?: 'MultiCardV2DescriptionRichText';
  json: Scalars['JSON']['output'];
  links: MultiCardV2DescriptionRichTextLinks;
};

export type MultiCardV2DescriptionRichTextAssets = {
  __typename?: 'MultiCardV2DescriptionRichTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type MultiCardV2DescriptionRichTextEntries = {
  __typename?: 'MultiCardV2DescriptionRichTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type MultiCardV2DescriptionRichTextLinks = {
  __typename?: 'MultiCardV2DescriptionRichTextLinks';
  assets: MultiCardV2DescriptionRichTextAssets;
  entries: MultiCardV2DescriptionRichTextEntries;
  resources: MultiCardV2DescriptionRichTextResources;
};

export type MultiCardV2DescriptionRichTextResources = {
  __typename?: 'MultiCardV2DescriptionRichTextResources';
  block: Array<MultiCardV2DescriptionRichTextResourcesBlock>;
  hyperlink: Array<MultiCardV2DescriptionRichTextResourcesHyperlink>;
  inline: Array<MultiCardV2DescriptionRichTextResourcesInline>;
};

export type MultiCardV2DescriptionRichTextResourcesBlock = ResourceLink & {
  __typename?: 'MultiCardV2DescriptionRichTextResourcesBlock';
  sys: ResourceSys;
};

export type MultiCardV2DescriptionRichTextResourcesHyperlink = ResourceLink & {
  __typename?: 'MultiCardV2DescriptionRichTextResourcesHyperlink';
  sys: ResourceSys;
};

export type MultiCardV2DescriptionRichTextResourcesInline = ResourceLink & {
  __typename?: 'MultiCardV2DescriptionRichTextResourcesInline';
  sys: ResourceSys;
};

export type MultiCardV2Filter = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardV2Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardV2Filter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundImage?: InputMaybe<CfImageAssetNestedFilter>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bigScreenBackground?: InputMaybe<Scalars['Boolean']['input']>;
  bigScreenBackground_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bigScreenBackground_not?: InputMaybe<Scalars['Boolean']['input']>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cards?: InputMaybe<CfCardNestedFilter>;
  cardsAlignment?: InputMaybe<Scalars['String']['input']>;
  cardsAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  cardsAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardsAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardsAlignment_not?: InputMaybe<Scalars['String']['input']>;
  cardsAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardsAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionRichText_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionRichText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionRichText_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  displayAsStepper?: InputMaybe<Scalars['Boolean']['input']>;
  displayAsStepper_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayAsStepper_not?: InputMaybe<Scalars['Boolean']['input']>;
  display_contains?: InputMaybe<Scalars['String']['input']>;
  display_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  display_not?: InputMaybe<Scalars['String']['input']>;
  display_not_contains?: InputMaybe<Scalars['String']['input']>;
  display_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableMobileCarouselNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  enableMobileCarouselNavigation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableMobileCarouselNavigation_not?: InputMaybe<Scalars['Boolean']['input']>;
  enableResourceCardMode?: InputMaybe<Scalars['Boolean']['input']>;
  enableResourceCardMode_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableResourceCardMode_not?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowColor?: InputMaybe<Scalars['String']['input']>;
  eyebrowColor_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowColor_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowSx?: InputMaybe<Scalars['String']['input']>;
  eyebrowSx_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowSx_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowSx_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowSx_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowSx_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowSx_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowTextTransform?: InputMaybe<Scalars['String']['input']>;
  eyebrowTextTransform_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowTextTransform_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowTextTransform_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowTextTransform_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowTextTransform_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowTextTransform_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixBackgroundToBottom?: InputMaybe<Scalars['Boolean']['input']>;
  fixBackgroundToBottom_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fixBackgroundToBottom_not?: InputMaybe<Scalars['Boolean']['input']>;
  forMobile?: InputMaybe<Scalars['String']['input']>;
  forMobile_contains?: InputMaybe<Scalars['String']['input']>;
  forMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  forMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  forMobile_not?: InputMaybe<Scalars['String']['input']>;
  forMobile_not_contains?: InputMaybe<Scalars['String']['input']>;
  forMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerSpacing?: InputMaybe<Scalars['String']['input']>;
  headerSpacing_contains?: InputMaybe<Scalars['String']['input']>;
  headerSpacing_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerSpacing_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerSpacing_not?: InputMaybe<Scalars['String']['input']>;
  headerSpacing_not_contains?: InputMaybe<Scalars['String']['input']>;
  headerSpacing_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastRowCardsAlignment?: InputMaybe<Scalars['String']['input']>;
  lastRowCardsAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  lastRowCardsAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  lastRowCardsAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastRowCardsAlignment_not?: InputMaybe<Scalars['String']['input']>;
  lastRowCardsAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  lastRowCardsAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  noResultsContent?: InputMaybe<CfMultiCardV2NestedFilter>;
  noResultsContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfCardsInLineDesktop?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfCardsInLineDesktop_gt?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_gte?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  numberOfCardsInLineDesktop_lt?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_lte?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_not?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  roundedImage?: InputMaybe<Scalars['Boolean']['input']>;
  roundedImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  roundedImage_not?: InputMaybe<Scalars['Boolean']['input']>;
  sectionEyebrow?: InputMaybe<Scalars['String']['input']>;
  sectionEyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  sectionEyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionEyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionEyebrow_not?: InputMaybe<Scalars['String']['input']>;
  sectionEyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionEyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionInfoAlignment?: InputMaybe<Scalars['String']['input']>;
  sectionInfoAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  sectionInfoAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionInfoAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionInfoAlignment_not?: InputMaybe<Scalars['String']['input']>;
  sectionInfoAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionInfoAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  sectionTitleHtag?: InputMaybe<Scalars['String']['input']>;
  sectionTitleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionTitleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitleHtag_not?: InputMaybe<Scalars['String']['input']>;
  sectionTitleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle_not?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shouldDisplayCarouselOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  shouldDisplayCarouselOnDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shouldDisplayCarouselOnDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  useCardMediaRoundedCorners?: InputMaybe<Scalars['Boolean']['input']>;
  useCardMediaRoundedCorners_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useCardMediaRoundedCorners_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MultiCardV2LinkingCollections = {
  __typename?: 'MultiCardV2LinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  googleMapTemplateCollection?: Maybe<GoogleMapTemplateCollection>;
  multiCardV2Collection?: Maybe<MultiCardV2Collection>;
  pageCollection?: Maybe<PageCollection>;
  providerDetailsPageCollection?: Maybe<ProviderDetailsPageCollection>;
  segmentsContainerCollection?: Maybe<SegmentsContainerCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
};


export type MultiCardV2LinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MultiCardV2LinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MultiCardV2LinkingCollectionsGoogleMapTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsGoogleMapTemplateCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MultiCardV2LinkingCollectionsMultiCardV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsMultiCardV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MultiCardV2LinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MultiCardV2LinkingCollectionsProviderDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsProviderDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MultiCardV2LinkingCollectionsSegmentsContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsSegmentsContainerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MultiCardV2LinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type MultiCardV2LinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MultiCardV2LinkingCollectionsGoogleMapTemplateCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'desktopZoom_ASC'
  | 'desktopZoom_DESC'
  | 'facilityBadgeLabel_ASC'
  | 'facilityBadgeLabel_DESC'
  | 'facilityBasePath_ASC'
  | 'facilityBasePath_DESC'
  | 'facilityButtonLabel_ASC'
  | 'facilityButtonLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'holidayHoursMessageText_ASC'
  | 'holidayHoursMessageText_DESC'
  | 'listTabIsHorizontalScrolling_ASC'
  | 'listTabIsHorizontalScrolling_DESC'
  | 'locationScheduleButtonUrl_ASC'
  | 'locationScheduleButtonUrl_DESC'
  | 'mobileZoom_ASC'
  | 'mobileZoom_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'searchRadius_ASC'
  | 'searchRadius_DESC'
  | 'searchResultLimit_ASC'
  | 'searchResultLimit_DESC'
  | 'service_ASC'
  | 'service_DESC'
  | 'setAsOfficeButtonText_ASC'
  | 'setAsOfficeButtonText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useCumulativeDesign_ASC'
  | 'useCumulativeDesign_DESC'
  | 'useModernDesign_ASC'
  | 'useModernDesign_DESC'
  | 'useUsaCountryMap_ASC'
  | 'useUsaCountryMap_DESC';

export type MultiCardV2LinkingCollectionsMultiCardV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'bigScreenBackground_ASC'
  | 'bigScreenBackground_DESC'
  | 'cardsAlignment_ASC'
  | 'cardsAlignment_DESC'
  | 'displayAsStepper_ASC'
  | 'displayAsStepper_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'enableMobileCarouselNavigation_ASC'
  | 'enableMobileCarouselNavigation_DESC'
  | 'enableResourceCardMode_ASC'
  | 'enableResourceCardMode_DESC'
  | 'eyebrowColor_ASC'
  | 'eyebrowColor_DESC'
  | 'eyebrowSx_ASC'
  | 'eyebrowSx_DESC'
  | 'eyebrowTextTransform_ASC'
  | 'eyebrowTextTransform_DESC'
  | 'fixBackgroundToBottom_ASC'
  | 'fixBackgroundToBottom_DESC'
  | 'forMobile_ASC'
  | 'forMobile_DESC'
  | 'headerSpacing_ASC'
  | 'headerSpacing_DESC'
  | 'lastRowCardsAlignment_ASC'
  | 'lastRowCardsAlignment_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'numberOfCardsInLineDesktop_ASC'
  | 'numberOfCardsInLineDesktop_DESC'
  | 'roundedImage_ASC'
  | 'roundedImage_DESC'
  | 'sectionEyebrow_ASC'
  | 'sectionEyebrow_DESC'
  | 'sectionInfoAlignment_ASC'
  | 'sectionInfoAlignment_DESC'
  | 'sectionTitleHtag_ASC'
  | 'sectionTitleHtag_DESC'
  | 'sectionTitle_ASC'
  | 'sectionTitle_DESC'
  | 'shouldDisplayCarouselOnDesktop_ASC'
  | 'shouldDisplayCarouselOnDesktop_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useCardMediaRoundedCorners_ASC'
  | 'useCardMediaRoundedCorners_DESC';

export type MultiCardV2LinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MultiCardV2LinkingCollectionsProviderDetailsPageCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type MultiCardV2LinkingCollectionsSegmentsContainerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type MultiCardV2LinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MultiCardV2Order =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'bigScreenBackground_ASC'
  | 'bigScreenBackground_DESC'
  | 'cardsAlignment_ASC'
  | 'cardsAlignment_DESC'
  | 'displayAsStepper_ASC'
  | 'displayAsStepper_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'enableMobileCarouselNavigation_ASC'
  | 'enableMobileCarouselNavigation_DESC'
  | 'enableResourceCardMode_ASC'
  | 'enableResourceCardMode_DESC'
  | 'eyebrowColor_ASC'
  | 'eyebrowColor_DESC'
  | 'eyebrowSx_ASC'
  | 'eyebrowSx_DESC'
  | 'eyebrowTextTransform_ASC'
  | 'eyebrowTextTransform_DESC'
  | 'fixBackgroundToBottom_ASC'
  | 'fixBackgroundToBottom_DESC'
  | 'forMobile_ASC'
  | 'forMobile_DESC'
  | 'headerSpacing_ASC'
  | 'headerSpacing_DESC'
  | 'lastRowCardsAlignment_ASC'
  | 'lastRowCardsAlignment_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'numberOfCardsInLineDesktop_ASC'
  | 'numberOfCardsInLineDesktop_DESC'
  | 'roundedImage_ASC'
  | 'roundedImage_DESC'
  | 'sectionEyebrow_ASC'
  | 'sectionEyebrow_DESC'
  | 'sectionInfoAlignment_ASC'
  | 'sectionInfoAlignment_DESC'
  | 'sectionTitleHtag_ASC'
  | 'sectionTitleHtag_DESC'
  | 'sectionTitle_ASC'
  | 'sectionTitle_DESC'
  | 'shouldDisplayCarouselOnDesktop_ASC'
  | 'shouldDisplayCarouselOnDesktop_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useCardMediaRoundedCorners_ASC'
  | 'useCardMediaRoundedCorners_DESC';

export type MultiChoiceMultiAnswer = HasAnswerFormat & HasPredefinedAnswer & {
  __typename?: 'MultiChoiceMultiAnswer';
  answers?: Maybe<Array<PredefinedAnswer>>;
  format?: Maybe<QuestionnaireAnswerFormat>;
};

export type MultiChoiceSingleAnswer = HasAnswerFormat & HasPredefinedAnswer & {
  __typename?: 'MultiChoiceSingleAnswer';
  answers?: Maybe<Array<PredefinedAnswer>>;
  format?: Maybe<QuestionnaireAnswerFormat>;
};

export type MultiPredefinedQuestionnaireAnswerInput = {
  answerIds: Array<Scalars['NonEmptyString']['input']>;
};

/** Root mutation type. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Recaptcha protected */
  cancelTimeslotReservation?: Maybe<CancelTimeslotReservationPayload>;
  /** Recaptcha protected */
  createTimeslotReservation?: Maybe<CreateTimeslotReservationPayload>;
  me?: Maybe<UserMutation>;
  /** Scheduling visits only for "New patients". Recaptcha protected */
  scheduleNewPatientVisit?: Maybe<ScheduleNewPatientVisitPayload>;
};


/** Root mutation type. */
export type MutationCancelTimeslotReservationArgs = {
  input: CancelTimeslotReservationInput;
};


/** Root mutation type. */
export type MutationCreateTimeslotReservationArgs = {
  input: CreateTimeslotReservationInput;
};


/** Root mutation type. */
export type MutationScheduleNewPatientVisitArgs = {
  input: ScheduleNewPatientVisitInput;
};

export type NamedAttribute = {
  __typename?: 'NamedAttribute';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** A group of links supporting Internal and External URLs for Navigation purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationGroup) */
export type NavigationGroup = Entry & _Node & {
  __typename?: 'NavigationGroup';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  displayAsExpandedForMobileMenu?: Maybe<Scalars['Boolean']['output']>;
  groupLink?: Maybe<NavigationLink>;
  linkedFrom?: Maybe<NavigationGroupLinkingCollections>;
  linksCollection?: Maybe<NavigationGroupLinksCollection>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** A group of links supporting Internal and External URLs for Navigation purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationGroup) */
export type NavigationGroupDisplayAsExpandedForMobileMenuArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A group of links supporting Internal and External URLs for Navigation purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationGroup) */
export type NavigationGroupGroupLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


/** A group of links supporting Internal and External URLs for Navigation purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationGroup) */
export type NavigationGroupLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A group of links supporting Internal and External URLs for Navigation purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationGroup) */
export type NavigationGroupLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationGroupLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


/** A group of links supporting Internal and External URLs for Navigation purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationGroup) */
export type NavigationGroupNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type NavigationGroupCollection = {
  __typename?: 'NavigationGroupCollection';
  items: Array<Maybe<NavigationGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type NavigationGroupFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationGroupFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationGroupFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  displayAsExpandedForMobileMenu?: InputMaybe<Scalars['Boolean']['input']>;
  displayAsExpandedForMobileMenu_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayAsExpandedForMobileMenu_not?: InputMaybe<Scalars['Boolean']['input']>;
  groupLink?: InputMaybe<CfNavigationLinkNestedFilter>;
  groupLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  links?: InputMaybe<CfNavigationLinkNestedFilter>;
  linksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type NavigationGroupLinkingCollections = {
  __typename?: 'NavigationGroupLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  headerCollection?: Maybe<HeaderCollection>;
  headerSubNavCollection?: Maybe<HeaderSubNavCollection>;
};


export type NavigationGroupLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type NavigationGroupLinkingCollectionsHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationGroupLinkingCollectionsHeaderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type NavigationGroupLinkingCollectionsHeaderSubNavCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationGroupLinkingCollectionsHeaderSubNavCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationGroupLinkingCollectionsHeaderCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC';

export type NavigationGroupLinkingCollectionsHeaderSubNavCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type NavigationGroupLinksCollection = {
  __typename?: 'NavigationGroupLinksCollection';
  items: Array<Maybe<NavigationLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type NavigationGroupLinksCollectionOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type NavigationGroupOrder =
  | 'displayAsExpandedForMobileMenu_ASC'
  | 'displayAsExpandedForMobileMenu_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLink = Entry & _Node & {
  __typename?: 'NavigationLink';
  _id: Scalars['ID']['output'];
  analyticsContext?: Maybe<AnalyticsContext>;
  contentfulMetadata: ContentfulMetadata;
  externalUrl?: Maybe<Scalars['String']['output']>;
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  isLocalized?: Maybe<Scalars['Boolean']['output']>;
  linkIcon?: Maybe<Asset>;
  linkText?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<NavigationLinkLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  openInNewTab?: Maybe<Scalars['Boolean']['output']>;
  openInNewWindow?: Maybe<Scalars['Boolean']['output']>;
  pageData?: Maybe<NavigationLinkPageData>;
  sys: Sys;
};


/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLinkAnalyticsContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLinkExternalUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLinkIsInternalArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLinkIsLocalizedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLinkLinkIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLinkLinkTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLinkLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLinkNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLinkOpenInNewTabArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLinkOpenInNewWindowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLinkPageDataArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavigationLinkCollection = {
  __typename?: 'NavigationLinkCollection';
  items: Array<Maybe<NavigationLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type NavigationLinkFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationLinkFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationLinkFilter>>>;
  analyticsContext?: InputMaybe<CfAnalyticsContextNestedFilter>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  externalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  externalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalUrl_not?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  isInternal_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isInternal_not?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized_not?: InputMaybe<Scalars['Boolean']['input']>;
  linkIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  linkText_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText_not?: InputMaybe<Scalars['String']['input']>;
  linkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewTab_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewTab_not?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewWindow?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewWindow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewWindow_not?: InputMaybe<Scalars['Boolean']['input']>;
  pageData_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type NavigationLinkLinkingCollections = {
  __typename?: 'NavigationLinkLinkingCollections';
  adFooterCollection?: Maybe<AdFooterCollection>;
  buttonCollection?: Maybe<ButtonCollection>;
  entryCollection?: Maybe<EntryCollection>;
  footerNavigationGroupCollection?: Maybe<FooterNavigationGroupCollection>;
  headerCollection?: Maybe<HeaderCollection>;
  headerMainNavCollection?: Maybe<HeaderMainNavCollection>;
  navigationGroupCollection?: Maybe<NavigationGroupCollection>;
};


export type NavigationLinkLinkingCollectionsAdFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsAdFooterCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type NavigationLinkLinkingCollectionsButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsButtonCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type NavigationLinkLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type NavigationLinkLinkingCollectionsFooterNavigationGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsFooterNavigationGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type NavigationLinkLinkingCollectionsHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsHeaderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type NavigationLinkLinkingCollectionsHeaderMainNavCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsHeaderMainNavCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type NavigationLinkLinkingCollectionsNavigationGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsNavigationGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationLinkLinkingCollectionsAdFooterCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'contactNumber_ASC'
  | 'contactNumber_DESC'
  | 'copyright_ASC'
  | 'copyright_DESC'
  | 'isLightFooter_ASC'
  | 'isLightFooter_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useDesktopStickyFooter_ASC'
  | 'useDesktopStickyFooter_DESC'
  | 'useMobileStickyFooter_ASC'
  | 'useMobileStickyFooter_DESC';

export type NavigationLinkLinkingCollectionsButtonCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type NavigationLinkLinkingCollectionsFooterNavigationGroupCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'navigationGroupTitle_ASC'
  | 'navigationGroupTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type NavigationLinkLinkingCollectionsHeaderCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC';

export type NavigationLinkLinkingCollectionsHeaderMainNavCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type NavigationLinkLinkingCollectionsNavigationGroupCollectionOrder =
  | 'displayAsExpandedForMobileMenu_ASC'
  | 'displayAsExpandedForMobileMenu_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type NavigationLinkOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type NavigationLinkPageData = BlogDetailsPage | FacilityDetailsPage | Page | ServiceDetailsPage;

export type NearbyFacilitiesFilter = {
  patientDateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  service?: InputMaybe<FacilityService>;
  visitReason?: InputMaybe<GeneralVisitReasonType>;
  /** In miles */
  withinRadius: Scalars['Decimal']['input'];
};

export type NearbyFacilitiesInput = {
  take: Scalars['Int']['input'];
  withinRadiusInMiles: Scalars['Int']['input'];
};

export type NearbyFacilitiesList = {
  __typename?: 'NearbyFacilitiesList';
  hasMore: Scalars['Boolean']['output'];
  items: Array<NearbyFacility>;
  /** @deprecated Use hasMore field. Total can't be determined precisely. */
  total: Scalars['Int']['output'];
};

export type NearbyFacilitiesLocationFilter = {
  /** Brand defaults to 'AspenDental'. */
  brand?: InputMaybe<FacilityBrand>;
  latitude: Scalars['Decimal']['input'];
  longitude: Scalars['Decimal']['input'];
  patientDateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  visitReason?: InputMaybe<GeneralVisitReasonType>;
  /** In miles */
  withinRadius: Scalars['Decimal']['input'];
};

export type NearbyFacilitiesScheduleSlots = {
  __typename?: 'NearbyFacilitiesScheduleSlots';
  mainFacility: FacilityWithScheduleSlots;
  nearbyFacilities?: Maybe<Array<NearbyFacilityWithScheduleSlots>>;
};

export type NearbyFacilitiesScheduleSlotsFilterInput = {
  dateFrom: Scalars['Date']['input'];
  dateOfBirth: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  daysOfWeek?: InputMaybe<Array<DayOfWeek>>;
  firstName: Scalars['NonEmptyString']['input'];
  lastName: Scalars['NonEmptyString']['input'];
  mainFacilityCode: Scalars['String']['input'];
  nearbyFacilitiesInput?: InputMaybe<NearbyFacilitiesInput>;
  partOfDay?: InputMaybe<PartOfDay>;
  questionnaireAnswers?: InputMaybe<QuestionnaireAnswersInput>;
  /** Same value that is sent via x-session-id header. */
  visitAttemptId: Scalars['UUID']['input'];
  visitReason: GeneralVisitReasonType;
};

export type NearbyFacility = {
  __typename?: 'NearbyFacility';
  distanceInMiles: Scalars['Decimal']['output'];
  facility: Facility;
};

export type NearbyFacilityWithScheduleSlots = {
  __typename?: 'NearbyFacilityWithScheduleSlots';
  nearbyFacility: NearbyFacility;
  slots?: Maybe<ScheduleSlotsList>;
};

export type NearbyRescheduleFacilitiesFilter = {
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  daysOfWeek?: InputMaybe<Array<DayOfWeek>>;
  partOfDay?: InputMaybe<PartOfDay>;
  scheduledVisitId: Scalars['String']['input'];
  /** In miles */
  withinRadius: Scalars['Decimal']['input'];
};

export type NewGuarantorInput = {
  address: NewPatientAddressInput;
  dateOfBirth: Scalars['Date']['input'];
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  firstName: Scalars['NonEmptyString']['input'];
  lastName: Scalars['NonEmptyString']['input'];
  phone: PatientPhoneInput;
};

export type NewPatientAddressInput = {
  address: Scalars['String']['input'];
  city: NewPatientCityInput;
};

export type NewPatientCityInput = {
  existingCity?: InputMaybe<Scalars['CityUid']['input']>;
};

export type NewPatientEligibilityFilterInput = {
  eligibilities: Array<PatientEligibilityType>;
  patientEligibilityInformation: PatientEligibilityInformationInput;
};

export type NewPatientGuarantorInput = {
  otherPersonAsGuarantor?: InputMaybe<OtherPersonAsGuarantorInput>;
};

export type NewPatientInput = {
  address: NewPatientAddressInput;
  dateOfBirth: Scalars['Date']['input'];
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  firstName: Scalars['NonEmptyString']['input'];
  lastName: Scalars['NonEmptyString']['input'];
  patientsGuarantor?: InputMaybe<NewPatientGuarantorInput>;
  phone: PatientPhoneInput;
};

export type NewPatientRelationToGuarantor =
  | 'CHILD'
  | 'DISABLED_DEPENDENT'
  | 'OTHER_DEPENDENT';

export type NonConfirmablePastVisitError = Error & {
  __typename?: 'NonConfirmablePastVisitError';
  message: Scalars['String']['output'];
};

/** Returned when question id does not exist in questionnaire being answered. */
export type NonExistingQuestionnaireQuestionError = Error & {
  __typename?: 'NonExistingQuestionnaireQuestionError';
  message: Scalars['String']['output'];
  nonExistingQuestionId: Scalars['String']['output'];
};

export type NonExistingVisitError = Error & {
  __typename?: 'NonExistingVisitError';
  message: Scalars['String']['output'];
  nonExistingVisitId: Scalars['String']['output'];
};

export type NonReschedulableVisitError = Error & {
  __typename?: 'NonReschedulableVisitError';
  message: Scalars['String']['output'];
};

export type NotAvailableSlotError = Error & {
  __typename?: 'NotAvailableSlotError';
  message: Scalars['String']['output'];
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHero = Entry & _Node & {
  __typename?: 'OdpHero';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  appointmentDataSource?: Maybe<Scalars['String']['output']>;
  buttonsCollection?: Maybe<OdpHeroButtonsCollection>;
  callCenterLabel?: Maybe<Scalars['String']['output']>;
  contentSmallScreen?: Maybe<SmallScreenContent>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<ContentTypeRichText>;
  facilitySegmentCollection?: Maybe<Scalars['String']['output']>;
  googleMapsBusinessQuery?: Maybe<Scalars['String']['output']>;
  image?: Maybe<FocalPointImage>;
  linkedFrom?: Maybe<OdpHeroLinkingCollections>;
  mobileBrandBannerImagesCollection?: Maybe<OdpHeroMobileBrandBannerImagesCollection>;
  name?: Maybe<Scalars['String']['output']>;
  officeHoursLabel?: Maybe<Scalars['String']['output']>;
  promoTitle?: Maybe<Scalars['String']['output']>;
  secondaryImage?: Maybe<FocalPointImage>;
  showAddress?: Maybe<Scalars['Boolean']['output']>;
  showEmail?: Maybe<Scalars['Boolean']['output']>;
  showFax?: Maybe<Scalars['Boolean']['output']>;
  showHours?: Maybe<Scalars['Boolean']['output']>;
  showLocationStatusBadge?: Maybe<Scalars['Boolean']['output']>;
  showPhoneNumber?: Maybe<Scalars['Boolean']['output']>;
  showReviews?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  templateWidth?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleHtag?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroAppointmentDataSourceArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroCallCenterLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroContentSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SmallScreenContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroFacilitySegmentCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroGoogleMapsBusinessQueryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroMobileBrandBannerImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroMobileBrandBannerImagesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroOfficeHoursLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroPromoTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroSecondaryImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroShowAddressArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroShowEmailArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroShowFaxArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroShowHoursArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroShowLocationStatusBadgeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroShowPhoneNumberArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroShowReviewsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroTemplateWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type OdpHeroButtonsCollection = {
  __typename?: 'OdpHeroButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type OdpHeroButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type OdpHeroCollection = {
  __typename?: 'OdpHeroCollection';
  items: Array<Maybe<OdpHero>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type OdpHeroFilter = {
  AND?: InputMaybe<Array<InputMaybe<OdpHeroFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<OdpHeroFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appointmentDataSource?: InputMaybe<Scalars['String']['input']>;
  appointmentDataSource_contains?: InputMaybe<Scalars['String']['input']>;
  appointmentDataSource_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentDataSource_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appointmentDataSource_not?: InputMaybe<Scalars['String']['input']>;
  appointmentDataSource_not_contains?: InputMaybe<Scalars['String']['input']>;
  appointmentDataSource_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  callCenterLabel?: InputMaybe<Scalars['String']['input']>;
  callCenterLabel_contains?: InputMaybe<Scalars['String']['input']>;
  callCenterLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  callCenterLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callCenterLabel_not?: InputMaybe<Scalars['String']['input']>;
  callCenterLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  callCenterLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentSmallScreen?: InputMaybe<CfSmallScreenContentNestedFilter>;
  contentSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<CfContentTypeRichTextNestedFilter>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googleMapsBusinessQuery?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_contains?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_exists?: InputMaybe<Scalars['Boolean']['input']>;
  googleMapsBusinessQuery_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googleMapsBusinessQuery_not?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_not_contains?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image?: InputMaybe<CfFocalPointImageNestedFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileBrandBannerImages?: InputMaybe<CfFocalPointImageNestedFilter>;
  mobileBrandBannerImagesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeHoursLabel?: InputMaybe<Scalars['String']['input']>;
  officeHoursLabel_contains?: InputMaybe<Scalars['String']['input']>;
  officeHoursLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  officeHoursLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeHoursLabel_not?: InputMaybe<Scalars['String']['input']>;
  officeHoursLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  officeHoursLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoTitle?: InputMaybe<Scalars['String']['input']>;
  promoTitle_contains?: InputMaybe<Scalars['String']['input']>;
  promoTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  promoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoTitle_not?: InputMaybe<Scalars['String']['input']>;
  promoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  promoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  secondaryImage?: InputMaybe<CfFocalPointImageNestedFilter>;
  secondaryImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showAddress?: InputMaybe<Scalars['Boolean']['input']>;
  showAddress_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showAddress_not?: InputMaybe<Scalars['Boolean']['input']>;
  showEmail?: InputMaybe<Scalars['Boolean']['input']>;
  showEmail_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showEmail_not?: InputMaybe<Scalars['Boolean']['input']>;
  showFax?: InputMaybe<Scalars['Boolean']['input']>;
  showFax_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showFax_not?: InputMaybe<Scalars['Boolean']['input']>;
  showHours?: InputMaybe<Scalars['Boolean']['input']>;
  showHours_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showHours_not?: InputMaybe<Scalars['Boolean']['input']>;
  showLocationStatusBadge?: InputMaybe<Scalars['Boolean']['input']>;
  showLocationStatusBadge_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showLocationStatusBadge_not?: InputMaybe<Scalars['Boolean']['input']>;
  showPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  showPhoneNumber_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showPhoneNumber_not?: InputMaybe<Scalars['Boolean']['input']>;
  showReviews?: InputMaybe<Scalars['Boolean']['input']>;
  showReviews_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showReviews_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  templateWidth?: InputMaybe<Scalars['String']['input']>;
  templateWidth_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateWidth_not?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OdpHeroLinkingCollections = {
  __typename?: 'OdpHeroLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  pageCollection?: Maybe<PageCollection>;
  segmentsContainerCollection?: Maybe<SegmentsContainerCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
};


export type OdpHeroLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type OdpHeroLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type OdpHeroLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type OdpHeroLinkingCollectionsSegmentsContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroLinkingCollectionsSegmentsContainerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type OdpHeroLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type OdpHeroLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type OdpHeroLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type OdpHeroLinkingCollectionsSegmentsContainerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type OdpHeroLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type OdpHeroMobileBrandBannerImagesCollection = {
  __typename?: 'OdpHeroMobileBrandBannerImagesCollection';
  items: Array<Maybe<FocalPointImage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type OdpHeroMobileBrandBannerImagesCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type OdpHeroOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'appointmentDataSource_ASC'
  | 'appointmentDataSource_DESC'
  | 'callCenterLabel_ASC'
  | 'callCenterLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'promoTitle_ASC'
  | 'promoTitle_DESC'
  | 'showAddress_ASC'
  | 'showAddress_DESC'
  | 'showEmail_ASC'
  | 'showEmail_DESC'
  | 'showFax_ASC'
  | 'showFax_DESC'
  | 'showHours_ASC'
  | 'showHours_DESC'
  | 'showLocationStatusBadge_ASC'
  | 'showLocationStatusBadge_DESC'
  | 'showPhoneNumber_ASC'
  | 'showPhoneNumber_DESC'
  | 'showReviews_ASC'
  | 'showReviews_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type OtherPersonAsGuarantorInput = {
  guarantor: GuarantorInput;
  patientIs: NewPatientRelationToGuarantor;
};

/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type Page = Entry & _Node & {
  __typename?: 'Page';
  _id: Scalars['ID']['output'];
  analyticsContext?: Maybe<AnalyticsContext>;
  appName?: Maybe<Scalars['String']['output']>;
  breadcrumbTitle?: Maybe<Scalars['String']['output']>;
  breadcrumbsCollection?: Maybe<PageBreadcrumbsCollection>;
  buttonText?: Maybe<Scalars['String']['output']>;
  buttonUrl?: Maybe<Scalars['String']['output']>;
  canonical?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  contentsCollection?: Maybe<PageContentsCollection>;
  description?: Maybe<Scalars['String']['output']>;
  disableChatBot?: Maybe<Scalars['Boolean']['output']>;
  disableHeaderBottomAlertBanner?: Maybe<Scalars['Boolean']['output']>;
  disableHeaderTopAlertBanner?: Maybe<Scalars['Boolean']['output']>;
  disableStickyFooterOnDesktop?: Maybe<Scalars['Boolean']['output']>;
  disableStickyFooterOnMobile?: Maybe<Scalars['Boolean']['output']>;
  displayOnMobile?: Maybe<Scalars['Boolean']['output']>;
  hideScheduleButtonInHeader?: Maybe<Scalars['Boolean']['output']>;
  image?: Maybe<Asset>;
  indexed?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<PageLinkingCollections>;
  mobileBreadcrumbTitle?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<ImageAsset>;
  overrideSchedulingButtonUrl?: Maybe<Scalars['String']['output']>;
  pageTheme?: Maybe<Scalars['String']['output']>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  personalized?: Maybe<Scalars['Boolean']['output']>;
  personalizedPathPrefix?: Maybe<Scalars['String']['output']>;
  personalizedPathSuffix?: Maybe<Scalars['String']['output']>;
  redirectFrom?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sys: Sys;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageAnalyticsContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageAppNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageBreadcrumbTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageBreadcrumbsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageBreadcrumbsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageFilter>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageButtonUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageCanonicalArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageContentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageContentsFilter>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageDisableChatBotArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageDisableHeaderBottomAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageDisableHeaderTopAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageDisableStickyFooterOnDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageDisableStickyFooterOnMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageDisplayOnMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageHideScheduleButtonInHeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageIndexedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageMobileBreadcrumbTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageOgImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageOverrideSchedulingButtonUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PagePageThemeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PagePageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PagePathArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PagePersonalizedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PagePersonalizedPathPrefixArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PagePersonalizedPathSuffixArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageRedirectFromArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageTagsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type PageBreadcrumbsCollection = {
  __typename?: 'PageBreadcrumbsCollection';
  items: Array<Maybe<Page>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PageBreadcrumbsCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type PageCollection = {
  __typename?: 'PageCollection';
  items: Array<Maybe<Page>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PageContentsCollection = {
  __typename?: 'PageContentsCollection';
  items: Array<Maybe<PageContentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PageContentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageContentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageContentsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type PageContentsItem = Accordions | AgendaStepper | BirdEyeReviews | BlogList | CategoryPicker | CityLinks | Columns | ContentTypeRichText | DisclaimerV2 | GoogleMapTemplate | HalfScreen | HeaderNavMenu | HeroV2 | Iframe | Insurance | LinkForwarder | Marquee | MediaSlider | MeetOurStaff | MultiCardV2 | OdpHero | PatientReviewsV2 | ProductDisplay | ProductFeature | Questionnaire | QuickLinks | Quiz | Schema | SectionContent | SegmentsContainer | Service | ServiceLineHero | SingleMessage | SmileAssessmentForm | Spacer | StateLinks | Stepper | Table | Tabs | TermsAndConditions | TextBlockSeo | VideoCarousel;

export type PageFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageFilter>>>;
  analyticsContext?: InputMaybe<CfAnalyticsContextNestedFilter>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appName?: InputMaybe<Scalars['String']['input']>;
  appName_contains?: InputMaybe<Scalars['String']['input']>;
  appName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appName_not?: InputMaybe<Scalars['String']['input']>;
  appName_not_contains?: InputMaybe<Scalars['String']['input']>;
  appName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  breadcrumbTitle?: InputMaybe<Scalars['String']['input']>;
  breadcrumbTitle_contains?: InputMaybe<Scalars['String']['input']>;
  breadcrumbTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  breadcrumbTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  breadcrumbTitle_not?: InputMaybe<Scalars['String']['input']>;
  breadcrumbTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  breadcrumbTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  breadcrumbs?: InputMaybe<CfPageNestedFilter>;
  breadcrumbsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonical?: InputMaybe<Scalars['String']['input']>;
  canonical_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonical_not?: InputMaybe<Scalars['String']['input']>;
  canonical_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  contents?: InputMaybe<CfcontentsMultiTypeNestedFilter>;
  contentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disableChatBot?: InputMaybe<Scalars['Boolean']['input']>;
  disableChatBot_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableChatBot_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideScheduleButtonInHeader?: InputMaybe<Scalars['Boolean']['input']>;
  hideScheduleButtonInHeader_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideScheduleButtonInHeader_not?: InputMaybe<Scalars['Boolean']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_not?: InputMaybe<Scalars['Boolean']['input']>;
  mobileBreadcrumbTitle?: InputMaybe<Scalars['String']['input']>;
  mobileBreadcrumbTitle_contains?: InputMaybe<Scalars['String']['input']>;
  mobileBreadcrumbTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileBreadcrumbTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileBreadcrumbTitle_not?: InputMaybe<Scalars['String']['input']>;
  mobileBreadcrumbTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  mobileBreadcrumbTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImage?: InputMaybe<CfImageAssetNestedFilter>;
  ogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  overrideSchedulingButtonUrl?: InputMaybe<Scalars['String']['input']>;
  overrideSchedulingButtonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  overrideSchedulingButtonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  overrideSchedulingButtonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  overrideSchedulingButtonUrl_not?: InputMaybe<Scalars['String']['input']>;
  overrideSchedulingButtonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  overrideSchedulingButtonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTheme?: InputMaybe<Scalars['String']['input']>;
  pageTheme_contains?: InputMaybe<Scalars['String']['input']>;
  pageTheme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTheme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTheme_not?: InputMaybe<Scalars['String']['input']>;
  pageTheme_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageTheme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  pageTitle_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle_not?: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path?: InputMaybe<Scalars['String']['input']>;
  path_contains?: InputMaybe<Scalars['String']['input']>;
  path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_not?: InputMaybe<Scalars['String']['input']>;
  path_not_contains?: InputMaybe<Scalars['String']['input']>;
  path_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalized?: InputMaybe<Scalars['Boolean']['input']>;
  personalizedPathPrefix?: InputMaybe<Scalars['String']['input']>;
  personalizedPathPrefix_contains?: InputMaybe<Scalars['String']['input']>;
  personalizedPathPrefix_exists?: InputMaybe<Scalars['Boolean']['input']>;
  personalizedPathPrefix_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalizedPathPrefix_not?: InputMaybe<Scalars['String']['input']>;
  personalizedPathPrefix_not_contains?: InputMaybe<Scalars['String']['input']>;
  personalizedPathPrefix_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalizedPathSuffix?: InputMaybe<Scalars['String']['input']>;
  personalizedPathSuffix_contains?: InputMaybe<Scalars['String']['input']>;
  personalizedPathSuffix_exists?: InputMaybe<Scalars['Boolean']['input']>;
  personalizedPathSuffix_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalizedPathSuffix_not?: InputMaybe<Scalars['String']['input']>;
  personalizedPathSuffix_not_contains?: InputMaybe<Scalars['String']['input']>;
  personalizedPathSuffix_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalized_exists?: InputMaybe<Scalars['Boolean']['input']>;
  personalized_not?: InputMaybe<Scalars['Boolean']['input']>;
  redirectFrom_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  redirectFrom_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  redirectFrom_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  redirectFrom_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PageLinkingCollections = {
  __typename?: 'PageLinkingCollections';
  contentTileCollection?: Maybe<ContentTileCollection>;
  entryCollection?: Maybe<EntryCollection>;
  footerNavigationGroupCollection?: Maybe<FooterNavigationGroupCollection>;
  headerCollection?: Maybe<HeaderCollection>;
  navigationLinkCollection?: Maybe<NavigationLinkCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type PageLinkingCollectionsContentTileCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsContentTileCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type PageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type PageLinkingCollectionsFooterNavigationGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsFooterNavigationGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type PageLinkingCollectionsHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsHeaderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type PageLinkingCollectionsNavigationLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsNavigationLinkCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type PageLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type PageLinkingCollectionsContentTileCollectionOrder =
  | 'description_ASC'
  | 'description_DESC'
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type PageLinkingCollectionsFooterNavigationGroupCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'navigationGroupTitle_ASC'
  | 'navigationGroupTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type PageLinkingCollectionsHeaderCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC';

export type PageLinkingCollectionsNavigationLinkCollectionOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type PageLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type PageOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ParentQuestionTrigger = {
  __typename?: 'ParentQuestionTrigger';
  answerId: Scalars['String']['output'];
  questionId: Scalars['String']['output'];
};

export type PartOfDay =
  | 'AM'
  | 'PM';

export type PatientAddress = {
  __typename?: 'PatientAddress';
  addressLine?: Maybe<Scalars['String']['output']>;
  city?: Maybe<City>;
};

export type PatientAddressInput = {
  addressLine: Scalars['String']['input'];
  city: PatientCityInput;
};

export type PatientAddressTooLongError = Error & {
  __typename?: 'PatientAddressTooLongError';
  message: Scalars['String']['output'];
};

export type PatientAuthorizations = {
  __typename?: 'PatientAuthorizations';
  financialPoliciesAuthorization?: Maybe<Scalars['Boolean']['output']>;
  medicalHistoryObtainingAuthorization?: Maybe<Scalars['Boolean']['output']>;
  privacyPracticesAuthorization?: Maybe<Scalars['Boolean']['output']>;
  releaseOfInfoToInsurersAuthorization?: Maybe<Scalars['Boolean']['output']>;
  signature?: Maybe<Image>;
  thirdPartyInformationSharingAuthorization?: Maybe<ThirdPartyInformationSharingAuthorization>;
};

export type PatientCityInput = {
  city?: InputMaybe<CityInput>;
  cityUid?: InputMaybe<Scalars['CityUid']['input']>;
};

export type PatientContactDetails = {
  __typename?: 'PatientContactDetails';
  contactAddress: PatientAddress;
};

export type PatientContactDetailsInput = {
  contactAddress: PatientAddressInput;
};

export type PatientEligibility = {
  __typename?: 'PatientEligibility';
  eligible: Scalars['Boolean']['output'];
  ineligibilityReason?: Maybe<IneligibilityReasonEnum>;
  type: PatientEligibilityType;
};

export type PatientEligibilityInformationInput = {
  dateOfBirth: Scalars['Date']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type PatientEligibilityType =
  | 'SCHEDULE_AS_NEW_PATIENT';

export type PatientFreeTextAnswer = {
  __typename?: 'PatientFreeTextAnswer';
  question: QuestionnaireQuestion;
  text: Scalars['String']['output'];
};

export type PatientIdentifiers = {
  __typename?: 'PatientIdentifiers';
  accountId: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  patientCode: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  platform: Platform;
};

export type PatientInsurance = {
  __typename?: 'PatientInsurance';
  groupContractNumber?: Maybe<Scalars['String']['output']>;
  groupCovered?: Maybe<Scalars['String']['output']>;
  insuranceCompanyName?: Maybe<Scalars['String']['output']>;
  subscriberFirstName?: Maybe<Scalars['String']['output']>;
  subscriberId?: Maybe<Scalars['String']['output']>;
  subscriberLastName?: Maybe<Scalars['String']['output']>;
};

export type PatientMedicalHistory = {
  __typename?: 'PatientMedicalHistory';
  answers?: Maybe<Array<PatientQuestionnaireAnswer>>;
};

export type PatientPhone = {
  __typename?: 'PatientPhone';
  phoneNumber: Scalars['String']['output'];
  type: PatientPhoneType;
  useToConfirm: Scalars['Boolean']['output'];
};

export type PatientPhoneInput = {
  phoneNumber: Scalars['AspenPhoneNumberType']['input'];
  type: PatientPhoneType;
  useToConfirm: Scalars['Boolean']['input'];
};

export type PatientPhoneType =
  | 'CELL'
  | 'HOME'
  | 'OTHER'
  | 'WORK';

export type PatientPredefinedAnswer = {
  __typename?: 'PatientPredefinedAnswer';
  answerIds: Array<Scalars['String']['output']>;
  question: QuestionnaireQuestion;
};

export type PatientQuestionnaireAnswer = PatientFreeTextAnswer | PatientPredefinedAnswer;

export type PatientRelationToGuarantor =
  | 'CHILD'
  | 'DISABLED_DEPENDENT'
  | 'HUSBAND'
  | 'NOT_RELATED'
  | 'OTHER_DEPENDENT'
  | 'WIFE';

/** A single patient review as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewV2) */
export type PatientReviewV2 = Entry & _Node & {
  __typename?: 'PatientReviewV2';
  _id: Scalars['ID']['output'];
  avatar?: Maybe<Asset>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<PatientReviewV2LinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  subText1?: Maybe<Scalars['String']['output']>;
  subText2?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  text?: Maybe<Scalars['String']['output']>;
};


/** A single patient review as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewV2) */
export type PatientReviewV2AvatarArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A single patient review as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewV2) */
export type PatientReviewV2LinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A single patient review as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewV2) */
export type PatientReviewV2NameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A single patient review as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewV2) */
export type PatientReviewV2ScoreArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A single patient review as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewV2) */
export type PatientReviewV2SubText1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A single patient review as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewV2) */
export type PatientReviewV2SubText2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A single patient review as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewV2) */
export type PatientReviewV2TextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type PatientReviewV2Collection = {
  __typename?: 'PatientReviewV2Collection';
  items: Array<Maybe<PatientReviewV2>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PatientReviewV2Filter = {
  AND?: InputMaybe<Array<InputMaybe<PatientReviewV2Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<PatientReviewV2Filter>>>;
  avatar_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  score?: InputMaybe<Scalars['Int']['input']>;
  score_exists?: InputMaybe<Scalars['Boolean']['input']>;
  score_gt?: InputMaybe<Scalars['Int']['input']>;
  score_gte?: InputMaybe<Scalars['Int']['input']>;
  score_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  score_lt?: InputMaybe<Scalars['Int']['input']>;
  score_lte?: InputMaybe<Scalars['Int']['input']>;
  score_not?: InputMaybe<Scalars['Int']['input']>;
  score_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  subText1?: InputMaybe<Scalars['String']['input']>;
  subText1_contains?: InputMaybe<Scalars['String']['input']>;
  subText1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subText1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subText1_not?: InputMaybe<Scalars['String']['input']>;
  subText1_not_contains?: InputMaybe<Scalars['String']['input']>;
  subText1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subText2?: InputMaybe<Scalars['String']['input']>;
  subText2_contains?: InputMaybe<Scalars['String']['input']>;
  subText2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subText2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subText2_not?: InputMaybe<Scalars['String']['input']>;
  subText2_not_contains?: InputMaybe<Scalars['String']['input']>;
  subText2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not?: InputMaybe<Scalars['String']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PatientReviewV2LinkingCollections = {
  __typename?: 'PatientReviewV2LinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  patientReviewsV2Collection?: Maybe<PatientReviewsV2Collection>;
};


export type PatientReviewV2LinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type PatientReviewV2LinkingCollectionsPatientReviewsV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewV2LinkingCollectionsPatientReviewsV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type PatientReviewV2LinkingCollectionsPatientReviewsV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowLargeScreens_ASC'
  | 'eyebrowLargeScreens_DESC'
  | 'eyebrowSmallScreens_ASC'
  | 'eyebrowSmallScreens_DESC'
  | 'maxReviewsLargeScreens_ASC'
  | 'maxReviewsLargeScreens_DESC'
  | 'maxReviewsSmallScreens_ASC'
  | 'maxReviewsSmallScreens_DESC'
  | 'mode_ASC'
  | 'mode_DESC'
  | 'scoreIcon_ASC'
  | 'scoreIcon_DESC'
  | 'subtitleLargeScreens_ASC'
  | 'subtitleLargeScreens_DESC'
  | 'subtitleSmallScreens_ASC'
  | 'subtitleSmallScreens_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'titleLargeScreens_ASC'
  | 'titleLargeScreens_DESC'
  | 'titleSmallScreens_ASC'
  | 'titleSmallScreens_DESC'
  | 'trimThreshold_ASC'
  | 'trimThreshold_DESC';

export type PatientReviewV2Order =
  | 'name_ASC'
  | 'name_DESC'
  | 'score_ASC'
  | 'score_DESC'
  | 'subText1_ASC'
  | 'subText1_DESC'
  | 'subText2_ASC'
  | 'subText2_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2 = Entry & _Node & {
  __typename?: 'PatientReviewsV2';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  buttonsLargeScreensCollection?: Maybe<PatientReviewsV2ButtonsLargeScreensCollection>;
  buttonsSmallScreensCollection?: Maybe<PatientReviewsV2ButtonsSmallScreensCollection>;
  contentAlign?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  disablePaddingOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  entryName?: Maybe<Scalars['String']['output']>;
  eyebrowLargeScreens?: Maybe<Scalars['String']['output']>;
  eyebrowSmallScreens?: Maybe<Scalars['String']['output']>;
  imageLeftSide?: Maybe<ImageAsset>;
  linkedFrom?: Maybe<PatientReviewsV2LinkingCollections>;
  maxReviewsLargeScreens?: Maybe<Scalars['Int']['output']>;
  maxReviewsSmallScreens?: Maybe<Scalars['Int']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  reviewsCollection?: Maybe<PatientReviewsV2ReviewsCollection>;
  scoreIcon?: Maybe<Scalars['String']['output']>;
  subtitleLargeScreens?: Maybe<Scalars['String']['output']>;
  subtitleSmallScreens?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  templateWidth?: Maybe<Scalars['String']['output']>;
  titleHtag?: Maybe<Scalars['String']['output']>;
  titleLargeScreens?: Maybe<Scalars['String']['output']>;
  titleSmallScreens?: Maybe<Scalars['String']['output']>;
  trimThreshold?: Maybe<Scalars['Int']['output']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2AnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2BackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2ButtonsLargeScreensCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2ButtonsLargeScreensCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2ButtonsSmallScreensCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2ButtonsSmallScreensCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2ContentAlignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2DisablePaddingOnArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2EntryNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2EyebrowLargeScreensArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2EyebrowSmallScreensArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2ImageLeftSideArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2LinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2MaxReviewsLargeScreensArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2MaxReviewsSmallScreensArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2ModeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2ReviewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2ReviewsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PatientReviewV2Filter>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2ScoreIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2SubtitleLargeScreensArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2SubtitleSmallScreensArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2TemplateWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2TitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2TitleLargeScreensArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2TitleSmallScreensArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2TrimThresholdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type PatientReviewsV2ButtonsLargeScreensCollection = {
  __typename?: 'PatientReviewsV2ButtonsLargeScreensCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PatientReviewsV2ButtonsLargeScreensCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type PatientReviewsV2ButtonsSmallScreensCollection = {
  __typename?: 'PatientReviewsV2ButtonsSmallScreensCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PatientReviewsV2ButtonsSmallScreensCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type PatientReviewsV2Collection = {
  __typename?: 'PatientReviewsV2Collection';
  items: Array<Maybe<PatientReviewsV2>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PatientReviewsV2Filter = {
  AND?: InputMaybe<Array<InputMaybe<PatientReviewsV2Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<PatientReviewsV2Filter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonsLargeScreens?: InputMaybe<CfButtonNestedFilter>;
  buttonsLargeScreensCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonsSmallScreens?: InputMaybe<CfButtonNestedFilter>;
  buttonsSmallScreensCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlign?: InputMaybe<Scalars['String']['input']>;
  contentAlign_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlign_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentAlign_not?: InputMaybe<Scalars['String']['input']>;
  contentAlign_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlign_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName?: InputMaybe<Scalars['String']['input']>;
  entryName_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryName_not?: InputMaybe<Scalars['String']['input']>;
  entryName_not_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowLargeScreens?: InputMaybe<Scalars['String']['input']>;
  eyebrowLargeScreens_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowLargeScreens_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowLargeScreens_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowLargeScreens_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowLargeScreens_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowLargeScreens_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowSmallScreens?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreens_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreens_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowSmallScreens_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowSmallScreens_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreens_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreens_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageLeftSide?: InputMaybe<CfImageAssetNestedFilter>;
  imageLeftSide_exists?: InputMaybe<Scalars['Boolean']['input']>;
  maxReviewsLargeScreens?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsLargeScreens_exists?: InputMaybe<Scalars['Boolean']['input']>;
  maxReviewsLargeScreens_gt?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsLargeScreens_gte?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsLargeScreens_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  maxReviewsLargeScreens_lt?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsLargeScreens_lte?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsLargeScreens_not?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsLargeScreens_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  maxReviewsSmallScreens?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsSmallScreens_exists?: InputMaybe<Scalars['Boolean']['input']>;
  maxReviewsSmallScreens_gt?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsSmallScreens_gte?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsSmallScreens_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  maxReviewsSmallScreens_lt?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsSmallScreens_lte?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsSmallScreens_not?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsSmallScreens_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  mode?: InputMaybe<Scalars['String']['input']>;
  mode_contains?: InputMaybe<Scalars['String']['input']>;
  mode_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mode_not?: InputMaybe<Scalars['String']['input']>;
  mode_not_contains?: InputMaybe<Scalars['String']['input']>;
  mode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reviews?: InputMaybe<CfPatientReviewV2NestedFilter>;
  reviewsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  scoreIcon?: InputMaybe<Scalars['String']['input']>;
  scoreIcon_contains?: InputMaybe<Scalars['String']['input']>;
  scoreIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  scoreIcon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scoreIcon_not?: InputMaybe<Scalars['String']['input']>;
  scoreIcon_not_contains?: InputMaybe<Scalars['String']['input']>;
  scoreIcon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitleLargeScreens?: InputMaybe<Scalars['String']['input']>;
  subtitleLargeScreens_contains?: InputMaybe<Scalars['String']['input']>;
  subtitleLargeScreens_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subtitleLargeScreens_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitleLargeScreens_not?: InputMaybe<Scalars['String']['input']>;
  subtitleLargeScreens_not_contains?: InputMaybe<Scalars['String']['input']>;
  subtitleLargeScreens_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitleSmallScreens?: InputMaybe<Scalars['String']['input']>;
  subtitleSmallScreens_contains?: InputMaybe<Scalars['String']['input']>;
  subtitleSmallScreens_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subtitleSmallScreens_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitleSmallScreens_not?: InputMaybe<Scalars['String']['input']>;
  subtitleSmallScreens_not_contains?: InputMaybe<Scalars['String']['input']>;
  subtitleSmallScreens_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  templateWidth?: InputMaybe<Scalars['String']['input']>;
  templateWidth_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateWidth_not?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleLargeScreens?: InputMaybe<Scalars['String']['input']>;
  titleLargeScreens_contains?: InputMaybe<Scalars['String']['input']>;
  titleLargeScreens_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleLargeScreens_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleLargeScreens_not?: InputMaybe<Scalars['String']['input']>;
  titleLargeScreens_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleLargeScreens_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleSmallScreens?: InputMaybe<Scalars['String']['input']>;
  titleSmallScreens_contains?: InputMaybe<Scalars['String']['input']>;
  titleSmallScreens_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleSmallScreens_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleSmallScreens_not?: InputMaybe<Scalars['String']['input']>;
  titleSmallScreens_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleSmallScreens_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  trimThreshold?: InputMaybe<Scalars['Int']['input']>;
  trimThreshold_exists?: InputMaybe<Scalars['Boolean']['input']>;
  trimThreshold_gt?: InputMaybe<Scalars['Int']['input']>;
  trimThreshold_gte?: InputMaybe<Scalars['Int']['input']>;
  trimThreshold_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  trimThreshold_lt?: InputMaybe<Scalars['Int']['input']>;
  trimThreshold_lte?: InputMaybe<Scalars['Int']['input']>;
  trimThreshold_not?: InputMaybe<Scalars['Int']['input']>;
  trimThreshold_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type PatientReviewsV2LinkingCollections = {
  __typename?: 'PatientReviewsV2LinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  pageCollection?: Maybe<PageCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
};


export type PatientReviewsV2LinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type PatientReviewsV2LinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2LinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type PatientReviewsV2LinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2LinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type PatientReviewsV2LinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2LinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type PatientReviewsV2LinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type PatientReviewsV2LinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type PatientReviewsV2LinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type PatientReviewsV2Order =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowLargeScreens_ASC'
  | 'eyebrowLargeScreens_DESC'
  | 'eyebrowSmallScreens_ASC'
  | 'eyebrowSmallScreens_DESC'
  | 'maxReviewsLargeScreens_ASC'
  | 'maxReviewsLargeScreens_DESC'
  | 'maxReviewsSmallScreens_ASC'
  | 'maxReviewsSmallScreens_DESC'
  | 'mode_ASC'
  | 'mode_DESC'
  | 'scoreIcon_ASC'
  | 'scoreIcon_DESC'
  | 'subtitleLargeScreens_ASC'
  | 'subtitleLargeScreens_DESC'
  | 'subtitleSmallScreens_ASC'
  | 'subtitleSmallScreens_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'titleLargeScreens_ASC'
  | 'titleLargeScreens_DESC'
  | 'titleSmallScreens_ASC'
  | 'titleSmallScreens_DESC'
  | 'trimThreshold_ASC'
  | 'trimThreshold_DESC';

export type PatientReviewsV2ReviewsCollection = {
  __typename?: 'PatientReviewsV2ReviewsCollection';
  items: Array<Maybe<PatientReviewV2>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PatientReviewsV2ReviewsCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'score_ASC'
  | 'score_DESC'
  | 'subText1_ASC'
  | 'subText1_DESC'
  | 'subText2_ASC'
  | 'subText2_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type PatientType =
  | 'EXISTING_PATIENT'
  | 'NEW_PATIENT';

export type Period = {
  __typename?: 'Period';
  from?: Maybe<Scalars['DateTime']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
};

export type PeriodInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type PersonalInformation = {
  __typename?: 'PersonalInformation';
  address?: Maybe<PatientAddress>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  phones?: Maybe<Array<PatientPhone>>;
  sex?: Maybe<Sex>;
  ssnLast4?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Suffix>;
};

export type Platform =
  | 'P2'
  | 'P3';

export type PredefinedAnswer = {
  __typename?: 'PredefinedAnswer';
  answerId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
};

/** Returned when provided answers dont match the set of valid predefined answers. */
export type PredefinedQuestionnaireAnswerError = Error & {
  __typename?: 'PredefinedQuestionnaireAnswerError';
  answeredQuestion: QuestionnaireQuestion;
  invalidAnswersIds: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type ProcedurePrice = {
  __typename?: 'ProcedurePrice';
  description: Scalars['String']['output'];
  price: Scalars['Decimal']['output'];
  procedureCode: Scalars['String']['output'];
};

export type ProcedurePricesList = {
  __typename?: 'ProcedurePricesList';
  items: Array<ProcedurePrice>;
  total: Scalars['Int']['output'];
};

export type ProceduresPricesFilterInput = {
  procedureCodes: Array<Scalars['String']['input']>;
};

/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type Product = Entry & _Node & {
  __typename?: 'Product';
  _id: Scalars['ID']['output'];
  brand?: Maybe<Brand>;
  brandfolderImageAssetUrl?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  linkText?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ProductLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  procedures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subCategory?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductBrandArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandFilter>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductBrandfolderImageAssetUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductCategoryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductDisclaimerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductLinkTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductLinkUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductProceduresArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductSubCategoryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCollection = {
  __typename?: 'ProductCollection';
  items: Array<Maybe<Product>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplay = Entry & _Node & {
  __typename?: 'ProductDisplay';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ProductDisplayLinkingCollections>;
  productDisplayName?: Maybe<Scalars['String']['output']>;
  productListDescription?: Maybe<ProductDisplayProductListDescription>;
  productListTitle?: Maybe<Scalars['String']['output']>;
  productListTitleHtag?: Maybe<Scalars['String']['output']>;
  productsToDisplay?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  showLocalizedProductPrice?: Maybe<Scalars['Boolean']['output']>;
  showProductCategory?: Maybe<Scalars['Boolean']['output']>;
  showProductPriceBreakdown?: Maybe<Scalars['Boolean']['output']>;
  showProductSubCategory?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
};


/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplayAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplayLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplayProductDisplayNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplayProductListDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplayProductListTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplayProductListTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplayProductsToDisplayArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplayShowLocalizedProductPriceArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplayShowProductCategoryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplayShowProductPriceBreakdownArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplayShowProductSubCategoryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ProductDisplayCollection = {
  __typename?: 'ProductDisplayCollection';
  items: Array<Maybe<ProductDisplay>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProductDisplayFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductDisplayFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductDisplayFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  productDisplayName?: InputMaybe<Scalars['String']['input']>;
  productDisplayName_contains?: InputMaybe<Scalars['String']['input']>;
  productDisplayName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  productDisplayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productDisplayName_not?: InputMaybe<Scalars['String']['input']>;
  productDisplayName_not_contains?: InputMaybe<Scalars['String']['input']>;
  productDisplayName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productListDescription_contains?: InputMaybe<Scalars['String']['input']>;
  productListDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  productListDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  productListTitle?: InputMaybe<Scalars['String']['input']>;
  productListTitleHtag?: InputMaybe<Scalars['String']['input']>;
  productListTitleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  productListTitleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  productListTitleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productListTitleHtag_not?: InputMaybe<Scalars['String']['input']>;
  productListTitleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  productListTitleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productListTitle_contains?: InputMaybe<Scalars['String']['input']>;
  productListTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  productListTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productListTitle_not?: InputMaybe<Scalars['String']['input']>;
  productListTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  productListTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productsToDisplay_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productsToDisplay_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productsToDisplay_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productsToDisplay_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showLocalizedProductPrice?: InputMaybe<Scalars['Boolean']['input']>;
  showLocalizedProductPrice_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showLocalizedProductPrice_not?: InputMaybe<Scalars['Boolean']['input']>;
  showProductCategory?: InputMaybe<Scalars['Boolean']['input']>;
  showProductCategory_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showProductCategory_not?: InputMaybe<Scalars['Boolean']['input']>;
  showProductPriceBreakdown?: InputMaybe<Scalars['Boolean']['input']>;
  showProductPriceBreakdown_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showProductPriceBreakdown_not?: InputMaybe<Scalars['Boolean']['input']>;
  showProductSubCategory?: InputMaybe<Scalars['Boolean']['input']>;
  showProductSubCategory_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showProductSubCategory_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type ProductDisplayLinkingCollections = {
  __typename?: 'ProductDisplayLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  pageCollection?: Maybe<PageCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
};


export type ProductDisplayLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductDisplayLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductDisplayLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductDisplayLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductDisplayLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductDisplayLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductDisplayLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductDisplayLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ProductDisplayLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ProductDisplayLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ProductDisplayOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'productDisplayName_ASC'
  | 'productDisplayName_DESC'
  | 'productListTitleHtag_ASC'
  | 'productListTitleHtag_DESC'
  | 'productListTitle_ASC'
  | 'productListTitle_DESC'
  | 'showLocalizedProductPrice_ASC'
  | 'showLocalizedProductPrice_DESC'
  | 'showProductCategory_ASC'
  | 'showProductCategory_DESC'
  | 'showProductPriceBreakdown_ASC'
  | 'showProductPriceBreakdown_DESC'
  | 'showProductSubCategory_ASC'
  | 'showProductSubCategory_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ProductDisplayProductListDescription = {
  __typename?: 'ProductDisplayProductListDescription';
  json: Scalars['JSON']['output'];
  links: ProductDisplayProductListDescriptionLinks;
};

export type ProductDisplayProductListDescriptionAssets = {
  __typename?: 'ProductDisplayProductListDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ProductDisplayProductListDescriptionEntries = {
  __typename?: 'ProductDisplayProductListDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ProductDisplayProductListDescriptionLinks = {
  __typename?: 'ProductDisplayProductListDescriptionLinks';
  assets: ProductDisplayProductListDescriptionAssets;
  entries: ProductDisplayProductListDescriptionEntries;
  resources: ProductDisplayProductListDescriptionResources;
};

export type ProductDisplayProductListDescriptionResources = {
  __typename?: 'ProductDisplayProductListDescriptionResources';
  block: Array<ProductDisplayProductListDescriptionResourcesBlock>;
  hyperlink: Array<ProductDisplayProductListDescriptionResourcesHyperlink>;
  inline: Array<ProductDisplayProductListDescriptionResourcesInline>;
};

export type ProductDisplayProductListDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'ProductDisplayProductListDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type ProductDisplayProductListDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'ProductDisplayProductListDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type ProductDisplayProductListDescriptionResourcesInline = ResourceLink & {
  __typename?: 'ProductDisplayProductListDescriptionResourcesInline';
  sys: ResourceSys;
};

/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeature = Entry & _Node & {
  __typename?: 'ProductFeature';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  buttonsCollection?: Maybe<ProductFeatureButtonsCollection>;
  contentfulMetadata: ContentfulMetadata;
  descriptionButton?: Maybe<Button>;
  descriptionButtonsCollection?: Maybe<ProductFeatureDescriptionButtonsCollection>;
  descriptionListCollection?: Maybe<ProductFeatureDescriptionListCollection>;
  descriptionRichText?: Maybe<ContentTypeRichText>;
  disclaimer?: Maybe<DisclaimerV2>;
  enableSliderControlsBackgroundGradient?: Maybe<Scalars['Boolean']['output']>;
  headline?: Maybe<ContentSection>;
  linkedFrom?: Maybe<ProductFeatureLinkingCollections>;
  media?: Maybe<MediaSlider>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureDescriptionButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureDescriptionButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureDescriptionButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureDescriptionListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureDescriptionListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductFeatureDescriptionListItemFilter>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureDescriptionRichTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureDisclaimerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DisclaimerV2Filter>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureEnableSliderControlsBackgroundGradientArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentSectionFilter>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureMediaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MediaSliderFilter>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ProductFeatureButtonsCollection = {
  __typename?: 'ProductFeatureButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProductFeatureButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ProductFeatureCollection = {
  __typename?: 'ProductFeatureCollection';
  items: Array<Maybe<ProductFeature>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProductFeatureDescriptionButtonsCollection = {
  __typename?: 'ProductFeatureDescriptionButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProductFeatureDescriptionButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ProductFeatureDescriptionListCollection = {
  __typename?: 'ProductFeatureDescriptionListCollection';
  items: Array<Maybe<ProductFeatureDescriptionListItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProductFeatureDescriptionListCollectionOrder =
  | 'icon_ASC'
  | 'icon_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** A List Item for the Product Feature Description List Array [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeatureDescriptionListItem) */
export type ProductFeatureDescriptionListItem = Entry & _Node & {
  __typename?: 'ProductFeatureDescriptionListItem';
  _id: Scalars['ID']['output'];
  content?: Maybe<ContentTypeRichText>;
  contentfulMetadata: ContentfulMetadata;
  icon?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ProductFeatureDescriptionListItemLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** A List Item for the Product Feature Description List Array [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeatureDescriptionListItem) */
export type ProductFeatureDescriptionListItemContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** A List Item for the Product Feature Description List Array [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeatureDescriptionListItem) */
export type ProductFeatureDescriptionListItemIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A List Item for the Product Feature Description List Array [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeatureDescriptionListItem) */
export type ProductFeatureDescriptionListItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A List Item for the Product Feature Description List Array [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeatureDescriptionListItem) */
export type ProductFeatureDescriptionListItemNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ProductFeatureDescriptionListItemCollection = {
  __typename?: 'ProductFeatureDescriptionListItemCollection';
  items: Array<Maybe<ProductFeatureDescriptionListItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProductFeatureDescriptionListItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductFeatureDescriptionListItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductFeatureDescriptionListItemFilter>>>;
  content?: InputMaybe<CfContentTypeRichTextNestedFilter>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ProductFeatureDescriptionListItemLinkingCollections = {
  __typename?: 'ProductFeatureDescriptionListItemLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  productFeatureCollection?: Maybe<ProductFeatureCollection>;
};


export type ProductFeatureDescriptionListItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductFeatureDescriptionListItemLinkingCollectionsProductFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureDescriptionListItemLinkingCollectionsProductFeatureCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductFeatureDescriptionListItemLinkingCollectionsProductFeatureCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'enableSliderControlsBackgroundGradient_ASC'
  | 'enableSliderControlsBackgroundGradient_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ProductFeatureDescriptionListItemOrder =
  | 'icon_ASC'
  | 'icon_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ProductFeatureFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductFeatureFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductFeatureFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  descriptionButton?: InputMaybe<CfButtonNestedFilter>;
  descriptionButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionButtons?: InputMaybe<CfButtonNestedFilter>;
  descriptionButtonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionList?: InputMaybe<CfProductFeatureDescriptionListItemNestedFilter>;
  descriptionListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionRichText?: InputMaybe<CfContentTypeRichTextNestedFilter>;
  descriptionRichText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disclaimer?: InputMaybe<CfDisclaimerV2NestedFilter>;
  disclaimer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableSliderControlsBackgroundGradient?: InputMaybe<Scalars['Boolean']['input']>;
  enableSliderControlsBackgroundGradient_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableSliderControlsBackgroundGradient_not?: InputMaybe<Scalars['Boolean']['input']>;
  headline?: InputMaybe<CfContentSectionNestedFilter>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<CfMediaSliderNestedFilter>;
  media_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ProductFeatureLinkingCollections = {
  __typename?: 'ProductFeatureLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type ProductFeatureLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductFeatureLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductFeatureLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductFeatureLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ProductFeatureLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ProductFeatureOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'enableSliderControlsBackgroundGradient_ASC'
  | 'enableSliderControlsBackgroundGradient_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ProductFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductFilter>>>;
  brand?: InputMaybe<CfBrandNestedFilter>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brandfolderImageAssetUrl?: InputMaybe<Scalars['String']['input']>;
  brandfolderImageAssetUrl_contains?: InputMaybe<Scalars['String']['input']>;
  brandfolderImageAssetUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brandfolderImageAssetUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandfolderImageAssetUrl_not?: InputMaybe<Scalars['String']['input']>;
  brandfolderImageAssetUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  brandfolderImageAssetUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  category_contains?: InputMaybe<Scalars['String']['input']>;
  category_exists?: InputMaybe<Scalars['Boolean']['input']>;
  category_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_not?: InputMaybe<Scalars['String']['input']>;
  category_not_contains?: InputMaybe<Scalars['String']['input']>;
  category_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimer_contains?: InputMaybe<Scalars['String']['input']>;
  disclaimer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disclaimer_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disclaimer_not?: InputMaybe<Scalars['String']['input']>;
  disclaimer_not_contains?: InputMaybe<Scalars['String']['input']>;
  disclaimer_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  linkText_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText_not?: InputMaybe<Scalars['String']['input']>;
  linkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  linkUrl_contains?: InputMaybe<Scalars['String']['input']>;
  linkUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkUrl_not?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  procedures_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  procedures_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  procedures_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  procedures_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  subCategory_contains?: InputMaybe<Scalars['String']['input']>;
  subCategory_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subCategory_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subCategory_not?: InputMaybe<Scalars['String']['input']>;
  subCategory_not_contains?: InputMaybe<Scalars['String']['input']>;
  subCategory_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ProductLinkingCollections = {
  __typename?: 'ProductLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type ProductLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductOrder =
  | 'brandfolderImageAssetUrl_ASC'
  | 'brandfolderImageAssetUrl_DESC'
  | 'category_ASC'
  | 'category_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disclaimer_ASC'
  | 'disclaimer_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'linkUrl_ASC'
  | 'linkUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subCategory_ASC'
  | 'subCategory_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type Provider = {
  __typename?: 'Provider';
  active: Scalars['Boolean']['output'];
  associations?: Maybe<Array<Scalars['String']['output']>>;
  biography?: Maybe<Scalars['String']['output']>;
  certifications?: Maybe<Array<ProviderCertification>>;
  collegeCity?: Maybe<Scalars['String']['output']>;
  collegeName?: Maybe<Scalars['String']['output']>;
  collegeState?: Maybe<Scalars['String']['output']>;
  degreeName?: Maybe<Scalars['String']['output']>;
  educations?: Maybe<Array<ProviderEducation>>;
  employeeId: Scalars['String']['output'];
  employeeStatus?: Maybe<Scalars['String']['output']>;
  ethnicity?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  graduationDate?: Maybe<Scalars['DateTime']['output']>;
  hireDate?: Maybe<Scalars['DateTime']['output']>;
  languages?: Maybe<Array<Scalars['String']['output']>>;
  lastName?: Maybe<Scalars['String']['output']>;
  mainWorkerFunction?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  npi?: Maybe<Scalars['String']['output']>;
  providerLocations?: Maybe<Array<ProviderLocation>>;
  quote?: Maybe<Scalars['String']['output']>;
  socialNetworks?: Maybe<Array<SocialNetwork>>;
  stateLicense?: Maybe<Scalars['String']['output']>;
  workerType?: Maybe<Scalars['String']['output']>;
  yearsOfExperience?: Maybe<Scalars['Int']['output']>;
};

export type ProviderBrand =
  | 'ASPEN_DENTAL'
  | 'AZ_PET'
  | 'CLEAR_CHOICE';

export type ProviderCertification = {
  __typename?: 'ProviderCertification';
  certification?: Maybe<Scalars['String']['output']>;
  certificationCountry?: Maybe<Scalars['String']['output']>;
  certificationName?: Maybe<Scalars['String']['output']>;
  certifierOrIssuer?: Maybe<Scalars['String']['output']>;
  issuedDate?: Maybe<Scalars['DateTime']['output']>;
};

/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPage = Entry & _Node & {
  __typename?: 'ProviderDetailsPage';
  _id: Scalars['ID']['output'];
  appCollection?: Maybe<ProviderDetailsPageAppCollection>;
  brand?: Maybe<Brand>;
  contentfulMetadata: ContentfulMetadata;
  contentsCollection?: Maybe<ProviderDetailsPageContentsCollection>;
  linkedFrom?: Maybe<ProviderDetailsPageLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  npiId?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<ImageAsset>;
  secondaryContentsCollection?: Maybe<ProviderDetailsPageSecondaryContentsCollection>;
  sys: Sys;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPageAppCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPageBrandArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandFilter>;
};


/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPageContentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProviderDetailsPageContentsFilter>;
};


/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPageNpiIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPageOgImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPageSecondaryContentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProviderDetailsPageSecondaryContentsFilter>;
};


/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPageTagsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderDetailsPageAppCollection = {
  __typename?: 'ProviderDetailsPageAppCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProviderDetailsPageCollection = {
  __typename?: 'ProviderDetailsPageCollection';
  items: Array<Maybe<ProviderDetailsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProviderDetailsPageContentsCollection = {
  __typename?: 'ProviderDetailsPageContentsCollection';
  items: Array<Maybe<ProviderDetailsPageContentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProviderDetailsPageContentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProviderDetailsPageContentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProviderDetailsPageContentsFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ProviderDetailsPageContentsItem = Accordions | HalfScreen | MultiCardV2 | Service | SingleMessage | Spacer | VideoCarousel;

export type ProviderDetailsPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProviderDetailsPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProviderDetailsPageFilter>>>;
  appCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<CfBrandNestedFilter>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  contents?: InputMaybe<CfcontentsMultiTypeNestedFilter>;
  contentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  npiId?: InputMaybe<Scalars['String']['input']>;
  npiId_contains?: InputMaybe<Scalars['String']['input']>;
  npiId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  npiId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  npiId_not?: InputMaybe<Scalars['String']['input']>;
  npiId_not_contains?: InputMaybe<Scalars['String']['input']>;
  npiId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImage?: InputMaybe<CfImageAssetNestedFilter>;
  ogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryContents?: InputMaybe<CfsecondaryContentsMultiTypeNestedFilter>;
  secondaryContentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderDetailsPageLinkingCollections = {
  __typename?: 'ProviderDetailsPageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type ProviderDetailsPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ProviderDetailsPageOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ProviderDetailsPageSecondaryContentsCollection = {
  __typename?: 'ProviderDetailsPageSecondaryContentsCollection';
  items: Array<Maybe<ProviderDetailsPageSecondaryContentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProviderDetailsPageSecondaryContentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProviderDetailsPageSecondaryContentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProviderDetailsPageSecondaryContentsFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ProviderDetailsPageSecondaryContentsItem = Accordions | HalfScreen | MultiCardV2 | Service | SingleMessage | Spacer | VideoCarousel;

export type ProviderEducation = {
  __typename?: 'ProviderEducation';
  collegeName?: Maybe<Scalars['String']['output']>;
  collegeState?: Maybe<Scalars['String']['output']>;
  degreeName?: Maybe<Scalars['String']['output']>;
  graduationDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ProviderLocation = {
  __typename?: 'ProviderLocation';
  facility?: Maybe<Facility>;
  isMain: Scalars['Boolean']['output'];
  workerFunctions: Array<Scalars['String']['output']>;
};

export type ProvidersFilterInput = {
  brand?: InputMaybe<ProviderBrand>;
};

export type ProvidersList = {
  __typename?: 'ProvidersList';
  items: Array<Provider>;
  total: Scalars['Int']['output'];
};

/** Root query type. */
export type Query = {
  __typename?: 'Query';
  _node?: Maybe<_Node>;
  _nodes: Array<Maybe<_Node>>;
  accordions?: Maybe<Accordions>;
  accordionsCollection?: Maybe<AccordionsCollection>;
  adFooter?: Maybe<AdFooter>;
  adFooterCollection?: Maybe<AdFooterCollection>;
  agendaModal?: Maybe<AgendaModal>;
  agendaModalCollection?: Maybe<AgendaModalCollection>;
  agendaStepper?: Maybe<AgendaStepper>;
  agendaStepperCollection?: Maybe<AgendaStepperCollection>;
  allProviders?: Maybe<Array<Maybe<BffProvider>>>;
  analyticsContext?: Maybe<AnalyticsContext>;
  analyticsContextCollection?: Maybe<AnalyticsContextCollection>;
  app?: Maybe<App>;
  appCollection?: Maybe<AppCollection>;
  appointmentBookingPage?: Maybe<AppointmentBookingPage>;
  appointmentBookingPageCollection?: Maybe<AppointmentBookingPageCollection>;
  asset?: Maybe<Asset>;
  assetCollection?: Maybe<AssetCollection>;
  averageProcedurePrices?: Maybe<ProcedurePricesList>;
  badge?: Maybe<Badge>;
  badgeCollection?: Maybe<BadgeCollection>;
  banner?: Maybe<Banner>;
  bannerCollection?: Maybe<BannerCollection>;
  birdEyeReviews?: Maybe<BirdEyeReviews>;
  birdEyeReviewsCollection?: Maybe<BirdEyeReviewsCollection>;
  blogAuthor?: Maybe<BlogAuthor>;
  blogAuthorCollection?: Maybe<BlogAuthorCollection>;
  blogCategory?: Maybe<BlogCategory>;
  blogCategoryCollection?: Maybe<BlogCategoryCollection>;
  blogDetailsPage?: Maybe<BlogDetailsPage>;
  blogDetailsPageCollection?: Maybe<BlogDetailsPageCollection>;
  blogList?: Maybe<BlogList>;
  blogListCollection?: Maybe<BlogListCollection>;
  blogListPage?: Maybe<BlogListPage>;
  blogListPageCollection?: Maybe<BlogListPageCollection>;
  blogSubCategory?: Maybe<BlogSubCategory>;
  blogSubCategoryCollection?: Maybe<BlogSubCategoryCollection>;
  brand?: Maybe<Brand>;
  brandCollection?: Maybe<BrandCollection>;
  button?: Maybe<Button>;
  buttonCollection?: Maybe<ButtonCollection>;
  cacheStats?: Maybe<BffFileCacheStats>;
  callCenterHours: Array<WorkingHours>;
  card?: Maybe<Card>;
  cardCollection?: Maybe<CardCollection>;
  category?: Maybe<Category>;
  categoryCollection?: Maybe<CategoryCollection>;
  categoryPicker?: Maybe<CategoryPicker>;
  categoryPickerCollection?: Maybe<CategoryPickerCollection>;
  cities?: Maybe<CitiesList>;
  cityLinks?: Maybe<CityLinks>;
  cityLinksCollection?: Maybe<CityLinksCollection>;
  client?: Maybe<BffClientList>;
  columns?: Maybe<Columns>;
  columnsCollection?: Maybe<ColumnsCollection>;
  confirmationStep?: Maybe<ConfirmationStep>;
  confirmationStepCollection?: Maybe<ConfirmationStepCollection>;
  contentSection?: Maybe<ContentSection>;
  contentSectionCollection?: Maybe<ContentSectionCollection>;
  contentTile?: Maybe<ContentTile>;
  contentTileCollection?: Maybe<ContentTileCollection>;
  contentTypeRichText?: Maybe<ContentTypeRichText>;
  contentTypeRichTextCollection?: Maybe<ContentTypeRichTextCollection>;
  createBooking?: Maybe<BffSession>;
  disclaimerV2?: Maybe<DisclaimerV2>;
  disclaimerV2Collection?: Maybe<DisclaimerV2Collection>;
  entryCollection?: Maybe<EntryCollection>;
  error404?: Maybe<Error404>;
  error404Collection?: Maybe<Error404Collection>;
  facilities?: Maybe<FacilitiesList>;
  facilitiesByAddress?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesByState?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesByStateAndCity?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesByStateCityAndStreet?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesByStateCityAndZipcode?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesByZipcode?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesMobileByState?: Maybe<Array<Maybe<BffFacility>>>;
  facility?: Maybe<Facility>;
  facilityBrand?: Maybe<Array<Maybe<BffBrand>>>;
  facilityById?: Maybe<BffFacility>;
  facilityByLocation?: Maybe<Array<Maybe<BffFacility>>>;
  facilityCities?: Maybe<Array<Maybe<BffUsCity>>>;
  facilityCitiesByState?: Maybe<Array<Maybe<BffCity>>>;
  facilityCollection?: Maybe<BffFacilityCollection>;
  facilityDetailsPage?: Maybe<FacilityDetailsPage>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityPicById?: Maybe<Array<Maybe<BffDamAsset>>>;
  facilityStates?: Maybe<Array<Maybe<BffState>>>;
  featureFlags?: Maybe<FeatureFlags>;
  featureFlagsCollection?: Maybe<FeatureFlagsCollection>;
  focalPointImage?: Maybe<FocalPointImage>;
  focalPointImageCollection?: Maybe<FocalPointImageCollection>;
  footerNavigationGroup?: Maybe<FooterNavigationGroup>;
  footerNavigationGroupCollection?: Maybe<FooterNavigationGroupCollection>;
  formDropdownField?: Maybe<FormDropdownField>;
  formDropdownFieldCollection?: Maybe<FormDropdownFieldCollection>;
  formDropdownListItem?: Maybe<FormDropdownListItem>;
  formDropdownListItemCollection?: Maybe<FormDropdownListItemCollection>;
  formField?: Maybe<FormField>;
  formFieldCollection?: Maybe<FormFieldCollection>;
  getCenters?: Maybe<BffCenters>;
  getServices?: Maybe<BffServices>;
  getSlots?: Maybe<BffSlots>;
  googleMapTemplate?: Maybe<GoogleMapTemplate>;
  googleMapTemplateCollection?: Maybe<GoogleMapTemplateCollection>;
  halfScreen?: Maybe<HalfScreen>;
  halfScreenCollection?: Maybe<HalfScreenCollection>;
  header?: Maybe<Header>;
  headerCollection?: Maybe<HeaderCollection>;
  headerMainNav?: Maybe<HeaderMainNav>;
  headerMainNavCollection?: Maybe<HeaderMainNavCollection>;
  headerNavMenu?: Maybe<HeaderNavMenu>;
  headerNavMenuCollection?: Maybe<HeaderNavMenuCollection>;
  headerSubNav?: Maybe<HeaderSubNav>;
  headerSubNavCollection?: Maybe<HeaderSubNavCollection>;
  heroV2?: Maybe<HeroV2>;
  heroV2Collection?: Maybe<HeroV2Collection>;
  iframe?: Maybe<Iframe>;
  iframeCollection?: Maybe<IframeCollection>;
  imageAsset?: Maybe<ImageAsset>;
  imageAssetCollection?: Maybe<ImageAssetCollection>;
  insurance?: Maybe<Insurance>;
  insuranceCollection?: Maybe<InsuranceCollection>;
  insuranceCompanies?: Maybe<InsuranceCompaniesList>;
  insuranceNetworks?: Maybe<InsuranceCompaniesNetworkList>;
  linkForwarder?: Maybe<LinkForwarder>;
  linkForwarderCollection?: Maybe<LinkForwarderCollection>;
  localizedServiceTitle?: Maybe<LocalizedServiceTitle>;
  localizedServiceTitleCollection?: Maybe<LocalizedServiceTitleCollection>;
  marquee?: Maybe<Marquee>;
  marqueeCollection?: Maybe<MarqueeCollection>;
  me?: Maybe<User>;
  mediaSlider?: Maybe<MediaSlider>;
  mediaSliderCollection?: Maybe<MediaSliderCollection>;
  medicalHistoryQuestionnaire?: Maybe<Questionnaire>;
  medicalService?: Maybe<MedicalService>;
  medicalServiceCollection?: Maybe<MedicalServiceCollection>;
  meetOurStaff?: Maybe<MeetOurStaff>;
  meetOurStaffCollection?: Maybe<MeetOurStaffCollection>;
  mobileButton?: Maybe<MobileButton>;
  mobileButtonCollection?: Maybe<MobileButtonCollection>;
  multiCardV2?: Maybe<MultiCardV2>;
  multiCardV2Collection?: Maybe<MultiCardV2Collection>;
  navigationGroup?: Maybe<NavigationGroup>;
  navigationGroupCollection?: Maybe<NavigationGroupCollection>;
  navigationLink?: Maybe<NavigationLink>;
  navigationLinkCollection?: Maybe<NavigationLinkCollection>;
  nearbyFacilities?: Maybe<NearbyFacilitiesList>;
  nearbyFacilitiesScheduleSlots?: Maybe<NearbyFacilitiesScheduleSlots>;
  odpHero?: Maybe<OdpHero>;
  odpHeroCollection?: Maybe<OdpHeroCollection>;
  page?: Maybe<Page>;
  pageCollection?: Maybe<PageCollection>;
  /** Recaptcha protected */
  patientEligibilities?: Maybe<Array<PatientEligibility>>;
  patientReviewV2?: Maybe<PatientReviewV2>;
  patientReviewV2Collection?: Maybe<PatientReviewV2Collection>;
  patientReviewsV2?: Maybe<PatientReviewsV2>;
  patientReviewsV2Collection?: Maybe<PatientReviewsV2Collection>;
  product?: Maybe<Product>;
  productCollection?: Maybe<ProductCollection>;
  productDisplay?: Maybe<ProductDisplay>;
  productDisplayCollection?: Maybe<ProductDisplayCollection>;
  productFeature?: Maybe<ProductFeature>;
  productFeatureCollection?: Maybe<ProductFeatureCollection>;
  productFeatureDescriptionListItem?: Maybe<ProductFeatureDescriptionListItem>;
  productFeatureDescriptionListItemCollection?: Maybe<ProductFeatureDescriptionListItemCollection>;
  productsWithIds?: Maybe<Array<Maybe<BffProduct>>>;
  provider?: Maybe<Provider>;
  providerById?: Maybe<BffProvider>;
  providerCollection?: Maybe<BffProviderCollection>;
  providerDetailsPage?: Maybe<ProviderDetailsPage>;
  providerDetailsPageCollection?: Maybe<ProviderDetailsPageCollection>;
  providerPicById?: Maybe<Array<Maybe<BffDamAsset>>>;
  providerPicByNpi?: Maybe<Array<Maybe<BffDamAsset>>>;
  providers: ProvidersList;
  providersByIdList?: Maybe<Array<Maybe<BffProvider>>>;
  questionnaire?: Maybe<Questionnaire>;
  questionnaireCollection?: Maybe<QuestionnaireCollection>;
  quickLinks?: Maybe<QuickLinks>;
  quickLinksCollection?: Maybe<QuickLinksCollection>;
  quiz?: Maybe<Quiz>;
  quizCollection?: Maybe<QuizCollection>;
  reviewStep?: Maybe<ReviewStep>;
  reviewStepCollection?: Maybe<ReviewStepCollection>;
  reviews?: Maybe<BffReviews>;
  reviewsSelection?: Maybe<Array<Maybe<BffReview>>>;
  schema?: Maybe<Schema>;
  schemaCollection?: Maybe<SchemaCollection>;
  searchFacilities?: Maybe<FacilitiesList>;
  sectionContent?: Maybe<SectionContent>;
  sectionContentCollection?: Maybe<SectionContentCollection>;
  segmentsContainer?: Maybe<SegmentsContainer>;
  segmentsContainerCollection?: Maybe<SegmentsContainerCollection>;
  service?: Maybe<Service>;
  serviceCollection?: Maybe<ServiceCollection>;
  serviceDetailsPage?: Maybe<ServiceDetailsPage>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceLineHero?: Maybe<ServiceLineHero>;
  serviceLineHeroCollection?: Maybe<ServiceLineHeroCollection>;
  singleMessage?: Maybe<SingleMessage>;
  singleMessageCollection?: Maybe<SingleMessageCollection>;
  smallScreenContent?: Maybe<SmallScreenContent>;
  smallScreenContentCollection?: Maybe<SmallScreenContentCollection>;
  smileAssessmentForm?: Maybe<SmileAssessmentForm>;
  smileAssessmentFormCollection?: Maybe<SmileAssessmentFormCollection>;
  spacer?: Maybe<Spacer>;
  spacerCollection?: Maybe<SpacerCollection>;
  stateLinks?: Maybe<StateLinks>;
  stateLinksCollection?: Maybe<StateLinksCollection>;
  states?: Maybe<Array<Maybe<BffState>>>;
  statesByAbbreviation?: Maybe<BffState>;
  statesByName?: Maybe<BffState>;
  stepper?: Maybe<Stepper>;
  stepperCollection?: Maybe<StepperCollection>;
  successCard?: Maybe<SuccessCard>;
  successCardCollection?: Maybe<SuccessCardCollection>;
  tab?: Maybe<Tab>;
  tabCollection?: Maybe<TabCollection>;
  table?: Maybe<Table>;
  tableCollection?: Maybe<TableCollection>;
  tabs?: Maybe<Tabs>;
  tabsCollection?: Maybe<TabsCollection>;
  termsAndConditions?: Maybe<TermsAndConditions>;
  termsAndConditionsCollection?: Maybe<TermsAndConditionsCollection>;
  textBlockSeo?: Maybe<TextBlockSeo>;
  textBlockSeoCollection?: Maybe<TextBlockSeoCollection>;
  video?: Maybe<Video>;
  videoAsset?: Maybe<VideoAsset>;
  videoAssetCollection?: Maybe<VideoAssetCollection>;
  videoCarousel?: Maybe<VideoCarousel>;
  videoCarouselCollection?: Maybe<VideoCarouselCollection>;
  videoCollection?: Maybe<VideoCollection>;
  videoWithContent?: Maybe<VideoWithContent>;
  videoWithContentCollection?: Maybe<VideoWithContentCollection>;
  wellNowFacility?: Maybe<Facility>;
};


/** Root query type. */
export type Query_NodeArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type Query_NodesArgs = {
  ids: Array<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryAccordionsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryAccordionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccordionsFilter>;
};


/** Root query type. */
export type QueryAdFooterArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryAdFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AdFooterOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AdFooterFilter>;
};


/** Root query type. */
export type QueryAgendaModalArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryAgendaModalCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgendaModalOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AgendaModalFilter>;
};


/** Root query type. */
export type QueryAgendaStepperArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryAgendaStepperCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgendaStepperOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AgendaStepperFilter>;
};


/** Root query type. */
export type QueryAllProvidersArgs = {
  brand: BffBrandType;
};


/** Root query type. */
export type QueryAnalyticsContextArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryAnalyticsContextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** Root query type. */
export type QueryAppArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryAppCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AppFilter>;
};


/** Root query type. */
export type QueryAppointmentBookingPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryAppointmentBookingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppointmentBookingPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AppointmentBookingPageFilter>;
};


/** Root query type. */
export type QueryAssetArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetFilter>;
};


/** Root query type. */
export type QueryAverageProcedurePricesArgs = {
  filter?: InputMaybe<ProceduresPricesFilterInput>;
  skip?: Scalars['NonNegativeInt']['input'];
  take?: Scalars['NonNegativeInt']['input'];
};


/** Root query type. */
export type QueryBadgeArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryBadgeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BadgeOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BadgeFilter>;
};


/** Root query type. */
export type QueryBannerArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BannerOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BannerFilter>;
};


/** Root query type. */
export type QueryBirdEyeReviewsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryBirdEyeReviewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BirdEyeReviewsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BirdEyeReviewsFilter>;
};


/** Root query type. */
export type QueryBlogAuthorArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryBlogAuthorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogAuthorOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlogAuthorFilter>;
};


/** Root query type. */
export type QueryBlogCategoryArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryBlogCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogCategoryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlogCategoryFilter>;
};


/** Root query type. */
export type QueryBlogDetailsPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryBlogDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogDetailsPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlogDetailsPageFilter>;
};


/** Root query type. */
export type QueryBlogListArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryBlogListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlogListFilter>;
};


/** Root query type. */
export type QueryBlogListPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryBlogListPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlogListPageFilter>;
};


/** Root query type. */
export type QueryBlogSubCategoryArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryBlogSubCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogSubCategoryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlogSubCategoryFilter>;
};


/** Root query type. */
export type QueryBrandArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryBrandCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BrandFilter>;
};


/** Root query type. */
export type QueryButtonArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Root query type. */
export type QueryCardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardFilter>;
};


/** Root query type. */
export type QueryCategoryArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryFilter>;
};


/** Root query type. */
export type QueryCategoryPickerArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryCategoryPickerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryPickerFilter>;
};


/** Root query type. */
export type QueryCitiesArgs = {
  filter: CitiesFilterInput;
};


/** Root query type. */
export type QueryCityLinksArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryCityLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CityLinksOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CityLinksFilter>;
};


/** Root query type. */
export type QueryClientArgs = {
  brand: BffBrandType;
  phoneNumber: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


/** Root query type. */
export type QueryColumnsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryColumnsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ColumnsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ColumnsFilter>;
};


/** Root query type. */
export type QueryConfirmationStepArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryConfirmationStepCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ConfirmationStepOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConfirmationStepFilter>;
};


/** Root query type. */
export type QueryContentSectionArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryContentSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentSectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentSectionFilter>;
};


/** Root query type. */
export type QueryContentTileArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryContentTileCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTileOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTileFilter>;
};


/** Root query type. */
export type QueryContentTypeRichTextArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryContentTypeRichTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** Root query type. */
export type QueryCreateBookingArgs = {
  brand: BffBrandType;
  centerId: Scalars['String']['input'];
  date: Scalars['String']['input'];
  isDoubleBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOnlyCatalogEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId: Scalars['String']['input'];
};


/** Root query type. */
export type QueryDisclaimerV2Args = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryDisclaimerV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2Order>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DisclaimerV2Filter>;
};


/** Root query type. */
export type QueryEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EntryFilter>;
};


/** Root query type. */
export type QueryError404Args = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryError404CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Error404Order>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Error404Filter>;
};


/** Root query type. */
export type QueryFacilitiesArgs = {
  filter: FacilitiesFilterInput;
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


/** Root query type. */
export type QueryFacilitiesByAddressArgs = {
  address: Scalars['String']['input'];
  brand: BffBrandType;
  fetchAllIfNoResults?: InputMaybe<Scalars['Boolean']['input']>;
  maxItems?: InputMaybe<Scalars['Int']['input']>;
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
};


/** Root query type. */
export type QueryFacilitiesByStateArgs = {
  brand: BffBrandType;
  state: Scalars['String']['input'];
};


/** Root query type. */
export type QueryFacilitiesByStateAndCityArgs = {
  brand: BffBrandType;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


/** Root query type. */
export type QueryFacilitiesByStateCityAndStreetArgs = {
  brand: BffBrandType;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
};


/** Root query type. */
export type QueryFacilitiesByStateCityAndZipcodeArgs = {
  brand: BffBrandType;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};


/** Root query type. */
export type QueryFacilitiesByZipcodeArgs = {
  brand: BffBrandType;
  fetchAllIfNoResults?: InputMaybe<Scalars['Boolean']['input']>;
  maxItems?: InputMaybe<Scalars['Int']['input']>;
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
  zipCode: Scalars['String']['input'];
};


/** Root query type. */
export type QueryFacilitiesMobileByStateArgs = {
  brand: BffBrandType;
  state: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


/** Root query type. */
export type QueryFacilityArgs = {
  brand?: InputMaybe<FacilityBrand>;
  code: Scalars['String']['input'];
};


/** Root query type. */
export type QueryFacilityByIdArgs = {
  brand: BffBrandType;
  id: Scalars['String']['input'];
};


/** Root query type. */
export type QueryFacilityByLocationArgs = {
  brand: BffBrandType;
  fetchAllIfNoResults?: InputMaybe<Scalars['Boolean']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  maxItems?: InputMaybe<Scalars['Int']['input']>;
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
};


/** Root query type. */
export type QueryFacilityCitiesArgs = {
  brand: BffBrandType;
};


/** Root query type. */
export type QueryFacilityCitiesByStateArgs = {
  brand: BffBrandType;
  state: Scalars['String']['input'];
};


/** Root query type. */
export type QueryFacilityCollectionArgs = {
  brand: BffBrandType;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Root query type. */
export type QueryFacilityDetailsPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FacilityDetailsPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FacilityDetailsPageFilter>;
};


/** Root query type. */
export type QueryFacilityPicByIdArgs = {
  brand: BffBrandType;
  id: Scalars['String']['input'];
};


/** Root query type. */
export type QueryFacilityStatesArgs = {
  brand: BffBrandType;
};


/** Root query type. */
export type QueryFeatureFlagsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryFeatureFlagsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FeatureFlagsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FeatureFlagsFilter>;
};


/** Root query type. */
export type QueryFocalPointImageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryFocalPointImageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** Root query type. */
export type QueryFooterNavigationGroupArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryFooterNavigationGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FooterNavigationGroupOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FooterNavigationGroupFilter>;
};


/** Root query type. */
export type QueryFormDropdownFieldArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryFormDropdownFieldCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FormDropdownFieldOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormDropdownFieldFilter>;
};


/** Root query type. */
export type QueryFormDropdownListItemArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryFormDropdownListItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FormDropdownListItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormDropdownListItemFilter>;
};


/** Root query type. */
export type QueryFormFieldArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryFormFieldCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FormFieldOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormFieldFilter>;
};


/** Root query type. */
export type QueryGetCentersArgs = {
  brand: BffBrandType;
  catalogEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryGetServicesArgs = {
  brand: BffBrandType;
  catalogEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  centerId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** Root query type. */
export type QueryGetSlotsArgs = {
  bookingId: Scalars['String']['input'];
  brand: BffBrandType;
  checkFutureDayAvailablity?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryGoogleMapTemplateArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryGoogleMapTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<GoogleMapTemplateOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GoogleMapTemplateFilter>;
};


/** Root query type. */
export type QueryHalfScreenArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryHalfScreenCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HalfScreenFilter>;
};


/** Root query type. */
export type QueryHeaderArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeaderFilter>;
};


/** Root query type. */
export type QueryHeaderMainNavArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryHeaderMainNavCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderMainNavOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeaderMainNavFilter>;
};


/** Root query type. */
export type QueryHeaderNavMenuArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryHeaderNavMenuCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderNavMenuOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeaderNavMenuFilter>;
};


/** Root query type. */
export type QueryHeaderSubNavArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryHeaderSubNavCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderSubNavOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeaderSubNavFilter>;
};


/** Root query type. */
export type QueryHeroV2Args = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryHeroV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroV2Order>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroV2Filter>;
};


/** Root query type. */
export type QueryIframeArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryIframeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IframeOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IframeFilter>;
};


/** Root query type. */
export type QueryImageAssetArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryImageAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** Root query type. */
export type QueryInsuranceArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryInsuranceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<InsuranceOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InsuranceFilter>;
};


/** Root query type. */
export type QueryInsuranceCompaniesArgs = {
  filter: InsuranceCompaniesFilterInput;
};


/** Root query type. */
export type QueryInsuranceNetworksArgs = {
  filter: InsuranceCompaniesNetworkFilterInput;
};


/** Root query type. */
export type QueryLinkForwarderArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryLinkForwarderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LinkForwarderOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkForwarderFilter>;
};


/** Root query type. */
export type QueryLocalizedServiceTitleArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryLocalizedServiceTitleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LocalizedServiceTitleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LocalizedServiceTitleFilter>;
};


/** Root query type. */
export type QueryMarqueeArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryMarqueeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MarqueeOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MarqueeFilter>;
};


/** Root query type. */
export type QueryMediaSliderArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryMediaSliderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MediaSliderOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MediaSliderFilter>;
};


/** Root query type. */
export type QueryMedicalServiceArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryMedicalServiceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MedicalServiceOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MedicalServiceFilter>;
};


/** Root query type. */
export type QueryMeetOurStaffArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryMeetOurStaffCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MeetOurStaffOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MeetOurStaffFilter>;
};


/** Root query type. */
export type QueryMobileButtonArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryMobileButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MobileButtonOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MobileButtonFilter>;
};


/** Root query type. */
export type QueryMultiCardV2Args = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryMultiCardV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2Order>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MultiCardV2Filter>;
};


/** Root query type. */
export type QueryNavigationGroupArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryNavigationGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationGroupOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NavigationGroupFilter>;
};


/** Root query type. */
export type QueryNavigationLinkArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryNavigationLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


/** Root query type. */
export type QueryNearbyFacilitiesArgs = {
  filter: NearbyFacilitiesLocationFilter;
  skip?: Scalars['NonNegativeInt']['input'];
  take?: Scalars['NonNegativeInt']['input'];
};


/** Root query type. */
export type QueryNearbyFacilitiesScheduleSlotsArgs = {
  filter: NearbyFacilitiesScheduleSlotsFilterInput;
};


/** Root query type. */
export type QueryOdpHeroArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryOdpHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OdpHeroFilter>;
};


/** Root query type. */
export type QueryPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageFilter>;
};


/** Root query type. */
export type QueryPatientEligibilitiesArgs = {
  input: NewPatientEligibilityFilterInput;
};


/** Root query type. */
export type QueryPatientReviewV2Args = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryPatientReviewV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewV2Order>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PatientReviewV2Filter>;
};


/** Root query type. */
export type QueryPatientReviewsV2Args = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryPatientReviewsV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2Order>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PatientReviewsV2Filter>;
};


/** Root query type. */
export type QueryProductArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryProductCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductFilter>;
};


/** Root query type. */
export type QueryProductDisplayArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryProductDisplayCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductDisplayOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductDisplayFilter>;
};


/** Root query type. */
export type QueryProductFeatureArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryProductFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductFeatureFilter>;
};


/** Root query type. */
export type QueryProductFeatureDescriptionListItemArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryProductFeatureDescriptionListItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureDescriptionListItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductFeatureDescriptionListItemFilter>;
};


/** Root query type. */
export type QueryProductsWithIdsArgs = {
  brand: BffBrandType;
  facilityCode: Scalars['String']['input'];
  idList: Array<InputMaybe<Scalars['String']['input']>>;
};


/** Root query type. */
export type QueryProviderArgs = {
  npi: Scalars['NonEmptyString']['input'];
};


/** Root query type. */
export type QueryProviderByIdArgs = {
  brand: BffBrandType;
  id: Scalars['String']['input'];
};


/** Root query type. */
export type QueryProviderCollectionArgs = {
  brand: BffBrandType;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Root query type. */
export type QueryProviderDetailsPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryProviderDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProviderDetailsPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProviderDetailsPageFilter>;
};


/** Root query type. */
export type QueryProviderPicByIdArgs = {
  brand: BffBrandType;
  id: Scalars['String']['input'];
};


/** Root query type. */
export type QueryProviderPicByNpiArgs = {
  brand: BffBrandType;
  npi: Scalars['String']['input'];
};


/** Root query type. */
export type QueryProvidersArgs = {
  filter: ProvidersFilterInput;
  skip: Scalars['NonNegativeInt']['input'];
  take: Scalars['NonNegativeInt']['input'];
};


/** Root query type. */
export type QueryProvidersByIdListArgs = {
  brand: BffBrandType;
  idList: Array<InputMaybe<Scalars['String']['input']>>;
};


/** Root query type. */
export type QueryQuestionnaireArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<QuestionnaireOptionsInput>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  questionnaireId: Scalars['String']['input'];
};


/** Root query type. */
export type QueryQuestionnaireCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuestionnaireOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuestionnaireFilter>;
};


/** Root query type. */
export type QueryQuickLinksArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryQuickLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuickLinksOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuickLinksFilter>;
};


/** Root query type. */
export type QueryQuizArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryQuizCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuizOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuizFilter>;
};


/** Root query type. */
export type QueryReviewStepArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryReviewStepCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReviewStepOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReviewStepFilter>;
};


/** Root query type. */
export type QueryReviewsArgs = {
  brand: BffBrandType;
  facilityCode: Scalars['String']['input'];
};


/** Root query type. */
export type QueryReviewsSelectionArgs = {
  brand: BffBrandType;
  facilityCode: Scalars['String']['input'];
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** Root query type. */
export type QuerySchemaArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QuerySchemaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SchemaFilter>;
};


/** Root query type. */
export type QuerySearchFacilitiesArgs = {
  filter: SearchFacilitiesFilterInput;
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


/** Root query type. */
export type QuerySectionContentArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QuerySectionContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SectionContentOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SectionContentFilter>;
};


/** Root query type. */
export type QuerySegmentsContainerArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QuerySegmentsContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SegmentsContainerOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SegmentsContainerFilter>;
};


/** Root query type. */
export type QueryServiceArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryServiceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ServiceFilter>;
};


/** Root query type. */
export type QueryServiceDetailsPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceDetailsPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ServiceDetailsPageFilter>;
};


/** Root query type. */
export type QueryServiceLineHeroArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryServiceLineHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ServiceLineHeroFilter>;
};


/** Root query type. */
export type QuerySingleMessageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QuerySingleMessageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SingleMessageFilter>;
};


/** Root query type. */
export type QuerySmallScreenContentArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QuerySmallScreenContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmallScreenContentOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SmallScreenContentFilter>;
};


/** Root query type. */
export type QuerySmileAssessmentFormArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QuerySmileAssessmentFormCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmileAssessmentFormOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SmileAssessmentFormFilter>;
};


/** Root query type. */
export type QuerySpacerArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QuerySpacerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SpacerOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SpacerFilter>;
};


/** Root query type. */
export type QueryStateLinksArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryStateLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StateLinksOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StateLinksFilter>;
};


/** Root query type. */
export type QueryStatesByAbbreviationArgs = {
  abbreviation: Scalars['String']['input'];
};


/** Root query type. */
export type QueryStatesByNameArgs = {
  name: Scalars['String']['input'];
};


/** Root query type. */
export type QueryStepperArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryStepperCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StepperOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StepperFilter>;
};


/** Root query type. */
export type QuerySuccessCardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QuerySuccessCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SuccessCardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SuccessCardFilter>;
};


/** Root query type. */
export type QueryTabArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryTabCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TabFilter>;
};


/** Root query type. */
export type QueryTableArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryTableCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TableOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TableFilter>;
};


/** Root query type. */
export type QueryTabsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryTabsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TabsFilter>;
};


/** Root query type. */
export type QueryTermsAndConditionsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryTermsAndConditionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TermsAndConditionsFilter>;
};


/** Root query type. */
export type QueryTextBlockSeoArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryTextBlockSeoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TextBlockSeoOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TextBlockSeoFilter>;
};


/** Root query type. */
export type QueryVideoArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryVideoAssetArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryVideoAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoAssetOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoAssetFilter>;
};


/** Root query type. */
export type QueryVideoCarouselArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryVideoCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoCarouselOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoCarouselFilter>;
};


/** Root query type. */
export type QueryVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoFilter>;
};


/** Root query type. */
export type QueryVideoWithContentArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type. */
export type QueryVideoWithContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoWithContentOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoWithContentFilter>;
};


/** Root query type. */
export type QueryWellNowFacilityArgs = {
  code: Scalars['String']['input'];
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type Questionnaire = Entry & _Node & {
  __typename?: 'Questionnaire';
  _id: Scalars['ID']['output'];
  buttonText?: Maybe<Scalars['String']['output']>;
  buttonUrl?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  defaultErrorMessage?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  formCollection?: Maybe<QuestionnaireFormCollection>;
  image?: Maybe<FocalPointImage>;
  linkedFrom?: Maybe<QuestionnaireLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Array<QuestionnaireQuestion>>;
  subTitle?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireButtonUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireDefaultErrorMessageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireFormCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuestionnaireFormFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireSubTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionnaireAnswer = FreeTextAnswer | MultiChoiceMultiAnswer | MultiChoiceSingleAnswer | YesNoAnswer;

export type QuestionnaireAnswerFormat =
  | 'CHECK_BOX_LIST'
  | 'CHECK_BOX_LIST_NONE'
  | 'DATE'
  | 'DROPDOWN'
  | 'HEIGHT'
  | 'MULTI_SELECT'
  | 'PHONE'
  | 'RADIO_BUTTON'
  | 'TEXT_AREA'
  | 'TEXT_BOX'
  | 'WEIGHT';

export type QuestionnaireAnswerInput = {
  freeTextAnswer?: InputMaybe<FreeTextQuestionnaireAnswerInput>;
  multiAnswer?: InputMaybe<MultiPredefinedQuestionnaireAnswerInput>;
  singleAnswer?: InputMaybe<SinglePredefinedQuestionnaireAnswerInput>;
};

/** Returned when questions requiring answer are not answered. */
export type QuestionnaireAnswerRequiredError = Error & {
  __typename?: 'QuestionnaireAnswerRequiredError';
  message: Scalars['String']['output'];
  requiredQuestions: Array<QuestionnaireQuestion>;
};

export type QuestionnaireAnswersInput = {
  answers: Array<AnsweredQuestionnaireQuestionInput>;
  questionnaireId: Scalars['NonEmptyString']['input'];
};

export type QuestionnaireCollection = {
  __typename?: 'QuestionnaireCollection';
  items: Array<Maybe<Questionnaire>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type QuestionnaireFilter = {
  AND?: InputMaybe<Array<InputMaybe<QuestionnaireFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<QuestionnaireFilter>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  defaultErrorMessage?: InputMaybe<Scalars['String']['input']>;
  defaultErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  defaultErrorMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  defaultErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  defaultErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  defaultErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  defaultErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  form?: InputMaybe<CfformMultiTypeNestedFilter>;
  formCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<CfFocalPointImageNestedFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  subTitle_contains?: InputMaybe<Scalars['String']['input']>;
  subTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subTitle_not?: InputMaybe<Scalars['String']['input']>;
  subTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  subTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not?: InputMaybe<Scalars['String']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuestionnaireFormCollection = {
  __typename?: 'QuestionnaireFormCollection';
  items: Array<Maybe<QuestionnaireFormItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type QuestionnaireFormFilter = {
  AND?: InputMaybe<Array<InputMaybe<QuestionnaireFormFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<QuestionnaireFormFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuestionnaireFormItem = FormDropdownField | FormField | SectionContent;

export type QuestionnaireLinkingCollections = {
  __typename?: 'QuestionnaireLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
  smileAssessmentFormCollection?: Maybe<SmileAssessmentFormCollection>;
};


export type QuestionnaireLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QuestionnaireLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuestionnaireLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QuestionnaireLinkingCollectionsSmileAssessmentFormCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuestionnaireLinkingCollectionsSmileAssessmentFormCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionnaireLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type QuestionnaireLinkingCollectionsSmileAssessmentFormCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type QuestionnaireOptionsInput = {
  language?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type QuestionnaireOrder =
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'defaultErrorMessage_ASC'
  | 'defaultErrorMessage_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subTitle_ASC'
  | 'subTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'text_ASC'
  | 'text_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type QuestionnaireQuestion = {
  __typename?: 'QuestionnaireQuestion';
  answer: QuestionnaireAnswer;
  answerRequired: Scalars['Boolean']['output'];
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  questionId: Scalars['String']['output'];
  sectionType?: Maybe<Scalars['String']['output']>;
  triggers?: Maybe<Array<ParentQuestionTrigger>>;
};

/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinks = Entry & _Node & {
  __typename?: 'QuickLinks';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  body?: Maybe<QuickLinksBody>;
  buttonsCollection?: Maybe<QuickLinksButtonsCollection>;
  contentfulMetadata: ContentfulMetadata;
  disablePaddingOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  displayAsTitles?: Maybe<Scalars['Boolean']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  eyebrowStyle?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<QuickLinksHeading>;
  linkedFrom?: Maybe<QuickLinksLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  quickLinksCollection?: Maybe<QuickLinksQuickLinksCollection>;
  sys: Sys;
  templateSize?: Maybe<Scalars['String']['output']>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksBodyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuickLinksButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksDisablePaddingOnArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksDisplayAsTitlesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksEyebrowStyleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksQuickLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuickLinksQuickLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksTemplateSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type QuickLinksBody = {
  __typename?: 'QuickLinksBody';
  json: Scalars['JSON']['output'];
  links: QuickLinksBodyLinks;
};

export type QuickLinksBodyAssets = {
  __typename?: 'QuickLinksBodyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type QuickLinksBodyEntries = {
  __typename?: 'QuickLinksBodyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type QuickLinksBodyLinks = {
  __typename?: 'QuickLinksBodyLinks';
  assets: QuickLinksBodyAssets;
  entries: QuickLinksBodyEntries;
  resources: QuickLinksBodyResources;
};

export type QuickLinksBodyResources = {
  __typename?: 'QuickLinksBodyResources';
  block: Array<QuickLinksBodyResourcesBlock>;
  hyperlink: Array<QuickLinksBodyResourcesHyperlink>;
  inline: Array<QuickLinksBodyResourcesInline>;
};

export type QuickLinksBodyResourcesBlock = ResourceLink & {
  __typename?: 'QuickLinksBodyResourcesBlock';
  sys: ResourceSys;
};

export type QuickLinksBodyResourcesHyperlink = ResourceLink & {
  __typename?: 'QuickLinksBodyResourcesHyperlink';
  sys: ResourceSys;
};

export type QuickLinksBodyResourcesInline = ResourceLink & {
  __typename?: 'QuickLinksBodyResourcesInline';
  sys: ResourceSys;
};

export type QuickLinksButtonsCollection = {
  __typename?: 'QuickLinksButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type QuickLinksButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type QuickLinksCollection = {
  __typename?: 'QuickLinksCollection';
  items: Array<Maybe<QuickLinks>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type QuickLinksFilter = {
  AND?: InputMaybe<Array<InputMaybe<QuickLinksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<QuickLinksFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_exists?: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayAsTitles?: InputMaybe<Scalars['Boolean']['input']>;
  displayAsTitles_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayAsTitles_not?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowStyle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowStyle_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quickLinks?: InputMaybe<CfButtonNestedFilter>;
  quickLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  templateSize?: InputMaybe<Scalars['String']['input']>;
  templateSize_contains?: InputMaybe<Scalars['String']['input']>;
  templateSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateSize_not?: InputMaybe<Scalars['String']['input']>;
  templateSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuickLinksHeading = {
  __typename?: 'QuickLinksHeading';
  json: Scalars['JSON']['output'];
  links: QuickLinksHeadingLinks;
};

export type QuickLinksHeadingAssets = {
  __typename?: 'QuickLinksHeadingAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type QuickLinksHeadingEntries = {
  __typename?: 'QuickLinksHeadingEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type QuickLinksHeadingLinks = {
  __typename?: 'QuickLinksHeadingLinks';
  assets: QuickLinksHeadingAssets;
  entries: QuickLinksHeadingEntries;
  resources: QuickLinksHeadingResources;
};

export type QuickLinksHeadingResources = {
  __typename?: 'QuickLinksHeadingResources';
  block: Array<QuickLinksHeadingResourcesBlock>;
  hyperlink: Array<QuickLinksHeadingResourcesHyperlink>;
  inline: Array<QuickLinksHeadingResourcesInline>;
};

export type QuickLinksHeadingResourcesBlock = ResourceLink & {
  __typename?: 'QuickLinksHeadingResourcesBlock';
  sys: ResourceSys;
};

export type QuickLinksHeadingResourcesHyperlink = ResourceLink & {
  __typename?: 'QuickLinksHeadingResourcesHyperlink';
  sys: ResourceSys;
};

export type QuickLinksHeadingResourcesInline = ResourceLink & {
  __typename?: 'QuickLinksHeadingResourcesInline';
  sys: ResourceSys;
};

export type QuickLinksLinkingCollections = {
  __typename?: 'QuickLinksLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  pageCollection?: Maybe<PageCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
};


export type QuickLinksLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QuickLinksLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuickLinksLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QuickLinksLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuickLinksLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QuickLinksLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuickLinksLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type QuickLinksLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type QuickLinksLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type QuickLinksLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type QuickLinksOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'displayAsTitles_ASC'
  | 'displayAsTitles_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC';

export type QuickLinksQuickLinksCollection = {
  __typename?: 'QuickLinksQuickLinksCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type QuickLinksQuickLinksCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

/** Content model used to get the questions and other data for the Quiz displayed in Aspen Dental, ClearChoice etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quiz) */
export type Quiz = Entry & _Node & {
  __typename?: 'Quiz';
  _id: Scalars['ID']['output'];
  brand?: Maybe<Brand>;
  clearChoicePoorCreditRedirectPath?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  formBuilderConfig?: Maybe<Scalars['JSON']['output']>;
  isFormBuilder?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<QuizLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  quizFormData?: Maybe<Scalars['JSON']['output']>;
  quizType?: Maybe<Scalars['String']['output']>;
  submitEndpointUrl?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** Content model used to get the questions and other data for the Quiz displayed in Aspen Dental, ClearChoice etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quiz) */
export type QuizBrandArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandFilter>;
};


/** Content model used to get the questions and other data for the Quiz displayed in Aspen Dental, ClearChoice etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quiz) */
export type QuizClearChoicePoorCreditRedirectPathArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content model used to get the questions and other data for the Quiz displayed in Aspen Dental, ClearChoice etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quiz) */
export type QuizFormBuilderConfigArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content model used to get the questions and other data for the Quiz displayed in Aspen Dental, ClearChoice etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quiz) */
export type QuizIsFormBuilderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content model used to get the questions and other data for the Quiz displayed in Aspen Dental, ClearChoice etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quiz) */
export type QuizLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Content model used to get the questions and other data for the Quiz displayed in Aspen Dental, ClearChoice etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quiz) */
export type QuizNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content model used to get the questions and other data for the Quiz displayed in Aspen Dental, ClearChoice etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quiz) */
export type QuizQuizFormDataArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content model used to get the questions and other data for the Quiz displayed in Aspen Dental, ClearChoice etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quiz) */
export type QuizQuizTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content model used to get the questions and other data for the Quiz displayed in Aspen Dental, ClearChoice etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quiz) */
export type QuizSubmitEndpointUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type QuizCollection = {
  __typename?: 'QuizCollection';
  items: Array<Maybe<Quiz>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type QuizFilter = {
  AND?: InputMaybe<Array<InputMaybe<QuizFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<QuizFilter>>>;
  brand?: InputMaybe<CfBrandNestedFilter>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  clearChoicePoorCreditRedirectPath?: InputMaybe<Scalars['String']['input']>;
  clearChoicePoorCreditRedirectPath_contains?: InputMaybe<Scalars['String']['input']>;
  clearChoicePoorCreditRedirectPath_exists?: InputMaybe<Scalars['Boolean']['input']>;
  clearChoicePoorCreditRedirectPath_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clearChoicePoorCreditRedirectPath_not?: InputMaybe<Scalars['String']['input']>;
  clearChoicePoorCreditRedirectPath_not_contains?: InputMaybe<Scalars['String']['input']>;
  clearChoicePoorCreditRedirectPath_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  formBuilderConfig_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isFormBuilder?: InputMaybe<Scalars['Boolean']['input']>;
  isFormBuilder_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isFormBuilder_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quizFormData_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quizType?: InputMaybe<Scalars['String']['input']>;
  quizType_contains?: InputMaybe<Scalars['String']['input']>;
  quizType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quizType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quizType_not?: InputMaybe<Scalars['String']['input']>;
  quizType_not_contains?: InputMaybe<Scalars['String']['input']>;
  quizType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submitEndpointUrl?: InputMaybe<Scalars['String']['input']>;
  submitEndpointUrl_contains?: InputMaybe<Scalars['String']['input']>;
  submitEndpointUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  submitEndpointUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submitEndpointUrl_not?: InputMaybe<Scalars['String']['input']>;
  submitEndpointUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  submitEndpointUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type QuizLinkingCollections = {
  __typename?: 'QuizLinkingCollections';
  buttonCollection?: Maybe<ButtonCollection>;
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type QuizLinkingCollectionsButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuizLinkingCollectionsButtonCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuizLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QuizLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuizLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type QuizLinkingCollectionsButtonCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type QuizLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type QuizLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type QuizOrder =
  | 'clearChoicePoorCreditRedirectPath_ASC'
  | 'clearChoicePoorCreditRedirectPath_DESC'
  | 'isFormBuilder_ASC'
  | 'isFormBuilder_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizType_ASC'
  | 'quizType_DESC'
  | 'submitEndpointUrl_ASC'
  | 'submitEndpointUrl_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type RescheduleSlot = {
  __typename?: 'RescheduleSlot';
  timeslot: Scalars['DateTime']['output'];
  timeslotUid: Scalars['String']['output'];
};

export type RescheduleSlotsFilter = {
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  daysOfWeek?: InputMaybe<Array<DayOfWeek>>;
  partOfDay?: InputMaybe<PartOfDay>;
  scheduledVisitId: Scalars['String']['input'];
};

export type RescheduleSlotsFilterInput = {
  daysOfWeek?: InputMaybe<Array<DayOfWeek>>;
  mainFacilityCodeOverride?: InputMaybe<Scalars['String']['input']>;
  nearbyFacilities?: InputMaybe<NearbyFacilitiesInput>;
  partOfDay?: InputMaybe<PartOfDay>;
  sessionUuid?: InputMaybe<Scalars['UUID']['input']>;
  visitUid: Scalars['String']['input'];
};

export type RescheduleSlotsList = {
  __typename?: 'RescheduleSlotsList';
  items: Array<RescheduleSlot>;
  total: Scalars['Int']['output'];
};

export type RescheduleVisitError = NonExistingVisitError | NonReschedulableVisitError | NotAvailableSlotError | TemporaryUnavailableError;

export type RescheduleVisitInput = {
  timeslotUid: Scalars['String']['input'];
  visitId: Scalars['String']['input'];
};

export type RescheduleVisitPayload = {
  __typename?: 'RescheduleVisitPayload';
  errors?: Maybe<Array<RescheduleVisitError>>;
  rescheduledVisit?: Maybe<RescheduledVisit>;
};

export type RescheduleVisitPayloadV2 = {
  __typename?: 'RescheduleVisitPayloadV2';
  errors?: Maybe<Array<RescheduleVisitError>>;
  rescheduledVisit?: Maybe<RescheduledVisitV2>;
};

export type RescheduleVisitV2Input = {
  timeslotUid: Scalars['String']['input'];
  visitUid: Scalars['String']['input'];
};

export type RescheduledVisit = {
  __typename?: 'RescheduledVisit';
  facilityCode: Scalars['String']['output'];
  timeslot: Scalars['DateTime']['output'];
  visitId: Scalars['String']['output'];
};

export type RescheduledVisitV2 = {
  __typename?: 'RescheduledVisitV2';
  facilityCode: Scalars['String']['output'];
  timeslot: Scalars['DateTime']['output'];
  visitUid: Scalars['String']['output'];
};

export type ResourceLink = {
  sys: ResourceSys;
};

export type ResourceSys = {
  __typename?: 'ResourceSys';
  linkType: Scalars['String']['output'];
  urn: Scalars['String']['output'];
};

export type Review = {
  __typename?: 'Review';
  comments?: Maybe<Scalars['String']['output']>;
  rating: Scalars['Decimal']['output'];
  reviewId: Scalars['String']['output'];
  reviewTimestamp?: Maybe<Scalars['DateTime']['output']>;
  reviewer?: Maybe<Reviewer>;
  source?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ReviewRating = {
  __typename?: 'ReviewRating';
  rating: Scalars['Int']['output'];
  reviewCount: Scalars['Int']['output'];
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/reviewStep) */
export type ReviewStep = Entry & _Node & {
  __typename?: 'ReviewStep';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ReviewStepLinkingCollections>;
  reviewCardsCollection?: Maybe<ReviewStepReviewCardsCollection>;
  reviewStepName?: Maybe<Scalars['String']['output']>;
  stepNumber?: Maybe<Scalars['Int']['output']>;
  stepSubtitle?: Maybe<Scalars['String']['output']>;
  stepTitle?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/reviewStep) */
export type ReviewStepLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/reviewStep) */
export type ReviewStepReviewCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/reviewStep) */
export type ReviewStepReviewStepNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/reviewStep) */
export type ReviewStepStepNumberArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/reviewStep) */
export type ReviewStepStepSubtitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/reviewStep) */
export type ReviewStepStepTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ReviewStepCollection = {
  __typename?: 'ReviewStepCollection';
  items: Array<Maybe<ReviewStep>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ReviewStepFilter = {
  AND?: InputMaybe<Array<InputMaybe<ReviewStepFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ReviewStepFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  reviewCardsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  reviewStepName?: InputMaybe<Scalars['String']['input']>;
  reviewStepName_contains?: InputMaybe<Scalars['String']['input']>;
  reviewStepName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  reviewStepName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reviewStepName_not?: InputMaybe<Scalars['String']['input']>;
  reviewStepName_not_contains?: InputMaybe<Scalars['String']['input']>;
  reviewStepName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepNumber?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stepNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  stepNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_not?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  stepSubtitle?: InputMaybe<Scalars['String']['input']>;
  stepSubtitle_contains?: InputMaybe<Scalars['String']['input']>;
  stepSubtitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stepSubtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepSubtitle_not?: InputMaybe<Scalars['String']['input']>;
  stepSubtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  stepSubtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepTitle?: InputMaybe<Scalars['String']['input']>;
  stepTitle_contains?: InputMaybe<Scalars['String']['input']>;
  stepTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stepTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepTitle_not?: InputMaybe<Scalars['String']['input']>;
  stepTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  stepTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ReviewStepLinkingCollections = {
  __typename?: 'ReviewStepLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  stepperCollection?: Maybe<StepperCollection>;
};


export type ReviewStepLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ReviewStepLinkingCollectionsStepperCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReviewStepLinkingCollectionsStepperCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ReviewStepLinkingCollectionsStepperCollectionOrder =
  | 'confirmButtonText_ASC'
  | 'confirmButtonText_DESC'
  | 'continueButtonText_ASC'
  | 'continueButtonText_DESC'
  | 'headingScheduledText_ASC'
  | 'headingScheduledText_DESC'
  | 'headingText_ASC'
  | 'headingText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'needAssistanceText_ASC'
  | 'needAssistanceText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ReviewStepOrder =
  | 'reviewStepName_ASC'
  | 'reviewStepName_DESC'
  | 'stepNumber_ASC'
  | 'stepNumber_DESC'
  | 'stepSubtitle_ASC'
  | 'stepSubtitle_DESC'
  | 'stepTitle_ASC'
  | 'stepTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ReviewStepReviewCardsCollection = {
  __typename?: 'ReviewStepReviewCardsCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ReviewWithSummary = {
  __typename?: 'ReviewWithSummary';
  averageRating?: Maybe<Scalars['Decimal']['output']>;
  businessId?: Maybe<Scalars['String']['output']>;
  ratings?: Maybe<Array<ReviewRating>>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
  reviews?: Maybe<Array<Review>>;
};

export type Reviewer = {
  __typename?: 'Reviewer';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type ScheduleNewPatientVisitError = GuarantorRequiredError | InvalidRelationToGuarantorError | SchedulingPartiallySucceededError | TimeslotNotAvailableError | UnderageGuarantorError | UnderagePatientForFacilityError | UnderagePatientForVisitReasonError;

export type ScheduleNewPatientVisitInput = {
  hasInsurance: Scalars['Boolean']['input'];
  patient: ScheduleNewPatientVisitPatientInput;
  questionnaireAnswers?: InputMaybe<QuestionnaireAnswersInput>;
  scheduleSlotUid: Scalars['String']['input'];
  visitAttemptId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ScheduleNewPatientVisitPatientInput = {
  nonExistingNewPatient?: InputMaybe<NewPatientInput>;
};

export type ScheduleNewPatientVisitPayload = {
  __typename?: 'ScheduleNewPatientVisitPayload';
  errors?: Maybe<Array<ScheduleNewPatientVisitError>>;
  result?: Maybe<ScheduledNewPatientVisit>;
};

export type ScheduleSlot = {
  __typename?: 'ScheduleSlot';
  nationalPatientTier?: Maybe<Scalars['Int']['output']>;
  patientTier?: Maybe<Scalars['Int']['output']>;
  patientValue?: Maybe<Scalars['Decimal']['output']>;
  timeslot: Scalars['DateTime']['output'];
  timeslotUid: Scalars['String']['output'];
};

export type ScheduleSlotsList = {
  __typename?: 'ScheduleSlotsList';
  items: Array<ScheduleSlot>;
  total: Scalars['Int']['output'];
};

export type ScheduledNewPatientVisit = {
  __typename?: 'ScheduledNewPatientVisit';
  accountNumber: Scalars['String']['output'];
  facilityCode: Scalars['String']['output'];
  timeslotUid: Scalars['String']['output'];
  visitId: Scalars['String']['output'];
};

export type ScheduledVisit = {
  __typename?: 'ScheduledVisit';
  canBeCanceled?: Maybe<Scalars['Boolean']['output']>;
  canBeRescheduled?: Maybe<Scalars['Boolean']['output']>;
  classDescription?: Maybe<Scalars['String']['output']>;
  /** Visit duration in minutes. */
  duration?: Maybe<Scalars['Int']['output']>;
  facility?: Maybe<Facility>;
  isConfirmed: Scalars['Boolean']['output'];
  isMissed: Scalars['Boolean']['output'];
  schedulability?: Maybe<VisitSchedulability>;
  scheduledDateTime?: Maybe<Scalars['DateTime']['output']>;
  visitId: Scalars['String']['output'];
  visitIdentifier: VisitIdentifier;
  visitNumber: Scalars['String']['output'];
};

export type ScheduledVisitList = {
  __typename?: 'ScheduledVisitList';
  items: Array<ScheduledVisit>;
  total: Scalars['Int']['output'];
};

export type SchedulingPartiallySucceededError = Error & {
  __typename?: 'SchedulingPartiallySucceededError';
  message: Scalars['String']['output'];
  patient: PatientIdentifiers;
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/schema) */
export type Schema = Entry & _Node & {
  __typename?: 'Schema';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<SchemaLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  schema?: Maybe<Scalars['JSON']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/schema) */
export type SchemaLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/schema) */
export type SchemaNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/schema) */
export type SchemaSchemaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type SchemaCollection = {
  __typename?: 'SchemaCollection';
  items: Array<Maybe<Schema>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SchemaFilter = {
  AND?: InputMaybe<Array<InputMaybe<SchemaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SchemaFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schema_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type SchemaLinkingCollections = {
  __typename?: 'SchemaLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  pageCollection?: Maybe<PageCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
};


export type SchemaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SchemaLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SchemaLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SchemaLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type SchemaLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SchemaLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SchemaLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SchemaOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type SearchFacilitiesFilterInput = {
  brand?: InputMaybe<FacilityBrand>;
  term: Scalars['String']['input'];
};

/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContent = Entry & _Node & {
  __typename?: 'SectionContent';
  _id: Scalars['ID']['output'];
  aditionalReferencesCollection?: Maybe<SectionContentAditionalReferencesCollection>;
  buttonText?: Maybe<Scalars['String']['output']>;
  buttonUrl?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  image?: Maybe<FocalPointImage>;
  imageShape?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<SectionContentLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  richTextContent?: Maybe<SectionContentRichTextContent>;
  subTitle?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentAditionalReferencesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentButtonUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentImageShapeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentOrientationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentRichTextContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentSubTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type SectionContentAditionalReferencesCollection = {
  __typename?: 'SectionContentAditionalReferencesCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SectionContentCollection = {
  __typename?: 'SectionContentCollection';
  items: Array<Maybe<SectionContent>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SectionContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<SectionContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SectionContentFilter>>>;
  aditionalReferencesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image?: InputMaybe<CfFocalPointImageNestedFilter>;
  imageShape?: InputMaybe<Scalars['String']['input']>;
  imageShape_contains?: InputMaybe<Scalars['String']['input']>;
  imageShape_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageShape_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageShape_not?: InputMaybe<Scalars['String']['input']>;
  imageShape_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageShape_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orientation?: InputMaybe<Scalars['String']['input']>;
  orientation_contains?: InputMaybe<Scalars['String']['input']>;
  orientation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  orientation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orientation_not?: InputMaybe<Scalars['String']['input']>;
  orientation_not_contains?: InputMaybe<Scalars['String']['input']>;
  orientation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  richTextContent_contains?: InputMaybe<Scalars['String']['input']>;
  richTextContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  richTextContent_not_contains?: InputMaybe<Scalars['String']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  subTitle_contains?: InputMaybe<Scalars['String']['input']>;
  subTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subTitle_not?: InputMaybe<Scalars['String']['input']>;
  subTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  subTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SectionContentLinkingCollections = {
  __typename?: 'SectionContentLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
  questionnaireCollection?: Maybe<QuestionnaireCollection>;
};


export type SectionContentLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SectionContentLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SectionContentLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SectionContentLinkingCollectionsQuestionnaireCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SectionContentLinkingCollectionsQuestionnaireCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type SectionContentLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SectionContentLinkingCollectionsQuestionnaireCollectionOrder =
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'defaultErrorMessage_ASC'
  | 'defaultErrorMessage_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subTitle_ASC'
  | 'subTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'text_ASC'
  | 'text_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SectionContentOrder =
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageShape_ASC'
  | 'imageShape_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'orientation_ASC'
  | 'orientation_DESC'
  | 'subTitle_ASC'
  | 'subTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type SectionContentRichTextContent = {
  __typename?: 'SectionContentRichTextContent';
  json: Scalars['JSON']['output'];
  links: SectionContentRichTextContentLinks;
};

export type SectionContentRichTextContentAssets = {
  __typename?: 'SectionContentRichTextContentAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SectionContentRichTextContentEntries = {
  __typename?: 'SectionContentRichTextContentEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SectionContentRichTextContentLinks = {
  __typename?: 'SectionContentRichTextContentLinks';
  assets: SectionContentRichTextContentAssets;
  entries: SectionContentRichTextContentEntries;
  resources: SectionContentRichTextContentResources;
};

export type SectionContentRichTextContentResources = {
  __typename?: 'SectionContentRichTextContentResources';
  block: Array<SectionContentRichTextContentResourcesBlock>;
  hyperlink: Array<SectionContentRichTextContentResourcesHyperlink>;
  inline: Array<SectionContentRichTextContentResourcesInline>;
};

export type SectionContentRichTextContentResourcesBlock = ResourceLink & {
  __typename?: 'SectionContentRichTextContentResourcesBlock';
  sys: ResourceSys;
};

export type SectionContentRichTextContentResourcesHyperlink = ResourceLink & {
  __typename?: 'SectionContentRichTextContentResourcesHyperlink';
  sys: ResourceSys;
};

export type SectionContentRichTextContentResourcesInline = ResourceLink & {
  __typename?: 'SectionContentRichTextContentResourcesInline';
  sys: ResourceSys;
};

/** HeroV2, Service and HalfScreen are supported, but do not combine different templates in one SegmentsContainer [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/segmentsContainer) */
export type SegmentsContainer = Entry & _Node & {
  __typename?: 'SegmentsContainer';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  contentsCollection?: Maybe<SegmentsContainerContentsCollection>;
  entryName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<SegmentsContainerLinkingCollections>;
  sys: Sys;
};


/** HeroV2, Service and HalfScreen are supported, but do not combine different templates in one SegmentsContainer [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/segmentsContainer) */
export type SegmentsContainerAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** HeroV2, Service and HalfScreen are supported, but do not combine different templates in one SegmentsContainer [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/segmentsContainer) */
export type SegmentsContainerContentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SegmentsContainerContentsFilter>;
};


/** HeroV2, Service and HalfScreen are supported, but do not combine different templates in one SegmentsContainer [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/segmentsContainer) */
export type SegmentsContainerEntryNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** HeroV2, Service and HalfScreen are supported, but do not combine different templates in one SegmentsContainer [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/segmentsContainer) */
export type SegmentsContainerLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SegmentsContainerCollection = {
  __typename?: 'SegmentsContainerCollection';
  items: Array<Maybe<SegmentsContainer>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SegmentsContainerContentsCollection = {
  __typename?: 'SegmentsContainerContentsCollection';
  items: Array<Maybe<SegmentsContainerContentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SegmentsContainerContentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<SegmentsContainerContentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SegmentsContainerContentsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type SegmentsContainerContentsItem = ContentTypeRichText | DisclaimerV2 | HalfScreen | HeroV2 | Marquee | MultiCardV2 | OdpHero | ServiceLineHero | SingleMessage;

export type SegmentsContainerFilter = {
  AND?: InputMaybe<Array<InputMaybe<SegmentsContainerFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SegmentsContainerFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  contents?: InputMaybe<CfcontentsMultiTypeNestedFilter>;
  contentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName?: InputMaybe<Scalars['String']['input']>;
  entryName_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryName_not?: InputMaybe<Scalars['String']['input']>;
  entryName_not_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type SegmentsContainerLinkingCollections = {
  __typename?: 'SegmentsContainerLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  pageCollection?: Maybe<PageCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
};


export type SegmentsContainerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SegmentsContainerLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SegmentsContainerLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SegmentsContainerLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SegmentsContainerLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SegmentsContainerLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SegmentsContainerLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type SegmentsContainerLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SegmentsContainerLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SegmentsContainerLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SegmentsContainerOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type Service = Entry & _Node & {
  __typename?: 'Service';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  brands?: Maybe<Array<FacilityServiceBrand>>;
  buttonText?: Maybe<Scalars['String']['output']>;
  buttonType?: Maybe<Scalars['String']['output']>;
  buttonUrl?: Maybe<Scalars['String']['output']>;
  buttonsCollection?: Maybe<ServiceButtonsCollection>;
  centerAlign?: Maybe<Scalars['Boolean']['output']>;
  contained?: Maybe<Scalars['Boolean']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  facilitySegmentCollection?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Asset>;
  imageLayout?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ServiceLinkingCollections>;
  mediaType?: Maybe<Scalars['String']['output']>;
  mobileImage?: Maybe<Asset>;
  name?: Maybe<Scalars['String']['output']>;
  richTextDescription?: Maybe<ServiceRichTextDescription>;
  sys: Sys;
  tc?: Maybe<TermsAndConditions>;
  title?: Maybe<Scalars['String']['output']>;
  titleHtag?: Maybe<Scalars['String']['output']>;
  type: FacilityServiceType;
  video?: Maybe<Asset>;
  videoImage?: Maybe<Asset>;
  youTubeVideoId?: Maybe<Scalars['String']['output']>;
  youTubeVideoImage?: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceButtonTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceButtonUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceCenterAlignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceContainedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceDirectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceFacilitySegmentCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceImageLayoutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceMediaTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceMobileImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceRichTextDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceTcArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TermsAndConditionsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceVideoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceVideoImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceYouTubeVideoIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceYouTubeVideoImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceButtonsCollection = {
  __typename?: 'ServiceButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ServiceButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ServiceCollection = {
  __typename?: 'ServiceCollection';
  items: Array<Maybe<Service>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPage = Entry & _Node & {
  __typename?: 'ServiceDetailsPage';
  _id: Scalars['ID']['output'];
  analyticsContext?: Maybe<AnalyticsContext>;
  appName?: Maybe<Scalars['String']['output']>;
  canonical?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  contentsCollection?: Maybe<ServiceDetailsPageContentsCollection>;
  description?: Maybe<Scalars['String']['output']>;
  disableHeaderBottomAlertBanner?: Maybe<Scalars['Boolean']['output']>;
  disableHeaderTopAlertBanner?: Maybe<Scalars['Boolean']['output']>;
  disableStickyFooterOnDesktop?: Maybe<Scalars['Boolean']['output']>;
  disableStickyFooterOnMobile?: Maybe<Scalars['Boolean']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  indexed?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<ServiceDetailsPageLinkingCollections>;
  moreTextSeo?: Maybe<ServiceDetailsPageMoreTextSeo>;
  name?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<ImageAsset>;
  path?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  textSeo?: Maybe<ServiceDetailsPageTextSeo>;
  title?: Maybe<Scalars['String']['output']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageAnalyticsContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageAppNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageCanonicalArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageContentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ServiceDetailsPageContentsFilter>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageDisableHeaderBottomAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageDisableHeaderTopAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageDisableStickyFooterOnDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageDisableStickyFooterOnMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageFacilityIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageIndexedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageMoreTextSeoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageOgImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPagePathArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageTagsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageTextSeoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceDetailsPageCollection = {
  __typename?: 'ServiceDetailsPageCollection';
  items: Array<Maybe<ServiceDetailsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ServiceDetailsPageContentsCollection = {
  __typename?: 'ServiceDetailsPageContentsCollection';
  items: Array<Maybe<ServiceDetailsPageContentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ServiceDetailsPageContentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<ServiceDetailsPageContentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ServiceDetailsPageContentsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type ServiceDetailsPageContentsItem = Accordions | BirdEyeReviews | BlogList | CategoryPicker | Columns | ContentTypeRichText | DisclaimerV2 | GoogleMapTemplate | HalfScreen | HeroV2 | MeetOurStaff | MultiCardV2 | OdpHero | PatientReviewsV2 | ProductDisplay | QuickLinks | Schema | SegmentsContainer | ServiceLineHero | SingleMessage | Spacer;

export type ServiceDetailsPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<ServiceDetailsPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ServiceDetailsPageFilter>>>;
  analyticsContext?: InputMaybe<CfAnalyticsContextNestedFilter>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appName?: InputMaybe<Scalars['String']['input']>;
  appName_contains?: InputMaybe<Scalars['String']['input']>;
  appName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appName_not?: InputMaybe<Scalars['String']['input']>;
  appName_not_contains?: InputMaybe<Scalars['String']['input']>;
  appName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonical?: InputMaybe<Scalars['String']['input']>;
  canonical_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonical_not?: InputMaybe<Scalars['String']['input']>;
  canonical_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  contents?: InputMaybe<CfcontentsMultiTypeNestedFilter>;
  contentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disableHeaderBottomAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  facilityId_contains?: InputMaybe<Scalars['String']['input']>;
  facilityId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilityId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityId_not?: InputMaybe<Scalars['String']['input']>;
  facilityId_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilityId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  indexed?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_not?: InputMaybe<Scalars['Boolean']['input']>;
  moreTextSeo_contains?: InputMaybe<Scalars['String']['input']>;
  moreTextSeo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  moreTextSeo_not_contains?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImage?: InputMaybe<CfImageAssetNestedFilter>;
  ogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  path_contains?: InputMaybe<Scalars['String']['input']>;
  path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_not?: InputMaybe<Scalars['String']['input']>;
  path_not_contains?: InputMaybe<Scalars['String']['input']>;
  path_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textSeo_contains?: InputMaybe<Scalars['String']['input']>;
  textSeo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textSeo_not_contains?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ServiceDetailsPageLinkingCollections = {
  __typename?: 'ServiceDetailsPageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  navigationLinkCollection?: Maybe<NavigationLinkCollection>;
};


export type ServiceDetailsPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ServiceDetailsPageLinkingCollectionsNavigationLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceDetailsPageLinkingCollectionsNavigationLinkCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceDetailsPageLinkingCollectionsNavigationLinkCollectionOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ServiceDetailsPageMoreTextSeo = {
  __typename?: 'ServiceDetailsPageMoreTextSeo';
  json: Scalars['JSON']['output'];
  links: ServiceDetailsPageMoreTextSeoLinks;
};

export type ServiceDetailsPageMoreTextSeoAssets = {
  __typename?: 'ServiceDetailsPageMoreTextSeoAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ServiceDetailsPageMoreTextSeoEntries = {
  __typename?: 'ServiceDetailsPageMoreTextSeoEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ServiceDetailsPageMoreTextSeoLinks = {
  __typename?: 'ServiceDetailsPageMoreTextSeoLinks';
  assets: ServiceDetailsPageMoreTextSeoAssets;
  entries: ServiceDetailsPageMoreTextSeoEntries;
  resources: ServiceDetailsPageMoreTextSeoResources;
};

export type ServiceDetailsPageMoreTextSeoResources = {
  __typename?: 'ServiceDetailsPageMoreTextSeoResources';
  block: Array<ServiceDetailsPageMoreTextSeoResourcesBlock>;
  hyperlink: Array<ServiceDetailsPageMoreTextSeoResourcesHyperlink>;
  inline: Array<ServiceDetailsPageMoreTextSeoResourcesInline>;
};

export type ServiceDetailsPageMoreTextSeoResourcesBlock = ResourceLink & {
  __typename?: 'ServiceDetailsPageMoreTextSeoResourcesBlock';
  sys: ResourceSys;
};

export type ServiceDetailsPageMoreTextSeoResourcesHyperlink = ResourceLink & {
  __typename?: 'ServiceDetailsPageMoreTextSeoResourcesHyperlink';
  sys: ResourceSys;
};

export type ServiceDetailsPageMoreTextSeoResourcesInline = ResourceLink & {
  __typename?: 'ServiceDetailsPageMoreTextSeoResourcesInline';
  sys: ResourceSys;
};

export type ServiceDetailsPageOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceDetailsPageTextSeo = {
  __typename?: 'ServiceDetailsPageTextSeo';
  json: Scalars['JSON']['output'];
  links: ServiceDetailsPageTextSeoLinks;
};

export type ServiceDetailsPageTextSeoAssets = {
  __typename?: 'ServiceDetailsPageTextSeoAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ServiceDetailsPageTextSeoEntries = {
  __typename?: 'ServiceDetailsPageTextSeoEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ServiceDetailsPageTextSeoLinks = {
  __typename?: 'ServiceDetailsPageTextSeoLinks';
  assets: ServiceDetailsPageTextSeoAssets;
  entries: ServiceDetailsPageTextSeoEntries;
  resources: ServiceDetailsPageTextSeoResources;
};

export type ServiceDetailsPageTextSeoResources = {
  __typename?: 'ServiceDetailsPageTextSeoResources';
  block: Array<ServiceDetailsPageTextSeoResourcesBlock>;
  hyperlink: Array<ServiceDetailsPageTextSeoResourcesHyperlink>;
  inline: Array<ServiceDetailsPageTextSeoResourcesInline>;
};

export type ServiceDetailsPageTextSeoResourcesBlock = ResourceLink & {
  __typename?: 'ServiceDetailsPageTextSeoResourcesBlock';
  sys: ResourceSys;
};

export type ServiceDetailsPageTextSeoResourcesHyperlink = ResourceLink & {
  __typename?: 'ServiceDetailsPageTextSeoResourcesHyperlink';
  sys: ResourceSys;
};

export type ServiceDetailsPageTextSeoResourcesInline = ResourceLink & {
  __typename?: 'ServiceDetailsPageTextSeoResourcesInline';
  sys: ResourceSys;
};

export type ServiceFilter = {
  AND?: InputMaybe<Array<InputMaybe<ServiceFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ServiceFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonType?: InputMaybe<Scalars['String']['input']>;
  buttonType_contains?: InputMaybe<Scalars['String']['input']>;
  buttonType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonType_not?: InputMaybe<Scalars['String']['input']>;
  buttonType_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign_not?: InputMaybe<Scalars['Boolean']['input']>;
  contained?: InputMaybe<Scalars['Boolean']['input']>;
  contained_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contained_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  direction?: InputMaybe<Scalars['String']['input']>;
  direction_contains?: InputMaybe<Scalars['String']['input']>;
  direction_exists?: InputMaybe<Scalars['Boolean']['input']>;
  direction_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  direction_not?: InputMaybe<Scalars['String']['input']>;
  direction_not_contains?: InputMaybe<Scalars['String']['input']>;
  direction_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageLayout?: InputMaybe<Scalars['String']['input']>;
  imageLayout_contains?: InputMaybe<Scalars['String']['input']>;
  imageLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageLayout_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageLayout_not?: InputMaybe<Scalars['String']['input']>;
  imageLayout_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageLayout_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  mediaType_contains?: InputMaybe<Scalars['String']['input']>;
  mediaType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaType_not?: InputMaybe<Scalars['String']['input']>;
  mediaType_not_contains?: InputMaybe<Scalars['String']['input']>;
  mediaType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  richTextDescription_contains?: InputMaybe<Scalars['String']['input']>;
  richTextDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  richTextDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  tc?: InputMaybe<CfTermsAndConditionsNestedFilter>;
  tc_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  video_exists?: InputMaybe<Scalars['Boolean']['input']>;
  youTubeVideoId?: InputMaybe<Scalars['String']['input']>;
  youTubeVideoId_contains?: InputMaybe<Scalars['String']['input']>;
  youTubeVideoId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  youTubeVideoId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youTubeVideoId_not?: InputMaybe<Scalars['String']['input']>;
  youTubeVideoId_not_contains?: InputMaybe<Scalars['String']['input']>;
  youTubeVideoId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youTubeVideoImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHero = Entry & _Node & {
  __typename?: 'ServiceLineHero';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  backgroundColorMobile?: Maybe<Scalars['String']['output']>;
  bodyCopy?: Maybe<ServiceLineHeroBodyCopy>;
  buttonCollection?: Maybe<ServiceLineHeroButtonCollection>;
  contentAlign?: Maybe<Scalars['String']['output']>;
  contentListCollection?: Maybe<ServiceLineHeroContentListCollection>;
  contentfulMetadata: ContentfulMetadata;
  disablePaddingOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  displayOfficeHoursInModal?: Maybe<Scalars['Boolean']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  eyebrowHtag?: Maybe<Scalars['String']['output']>;
  facilitySegmentCollection?: Maybe<Scalars['String']['output']>;
  focalPointImage?: Maybe<FocalPointImage>;
  googleMapsBusinessQuery?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<ServiceLineHeroHeadline>;
  hideHeroOnMobile?: Maybe<Scalars['Boolean']['output']>;
  imageAsset?: Maybe<ImageAsset>;
  imageWithBorderRadius?: Maybe<Scalars['Boolean']['output']>;
  imgDisplaysFirstOnDesktop?: Maybe<Scalars['Boolean']['output']>;
  imgDisplaysFirstOnMobile?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<ServiceLineHeroLinkingCollections>;
  mediaRoundedCornerSize?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  servicesCollection?: Maybe<ServiceLineHeroServicesCollection>;
  showOfficeDetails?: Maybe<Scalars['Boolean']['output']>;
  subHeadline?: Maybe<ServiceLineHeroSubHeadline>;
  sys: Sys;
  templateWidth?: Maybe<Scalars['String']['output']>;
  termsConditions?: Maybe<TermsAndConditions>;
  videoAsset?: Maybe<VideoAsset>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroBackgroundColorMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroBodyCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroButtonCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroContentAlignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroContentListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ServiceLineHeroContentListFilter>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroDisablePaddingOnArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroDisplayOfficeHoursInModalArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroEyebrowHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroFacilitySegmentCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroFocalPointImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroGoogleMapsBusinessQueryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroHideHeroOnMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroImageAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroImageWithBorderRadiusArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroImgDisplaysFirstOnDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroImgDisplaysFirstOnMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroMediaRoundedCornerSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroServicesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroServicesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MedicalServiceFilter>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroShowOfficeDetailsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroSubHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroTemplateWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroTermsConditionsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TermsAndConditionsFilter>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroVideoAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoAssetFilter>;
};

export type ServiceLineHeroBodyCopy = {
  __typename?: 'ServiceLineHeroBodyCopy';
  json: Scalars['JSON']['output'];
  links: ServiceLineHeroBodyCopyLinks;
};

export type ServiceLineHeroBodyCopyAssets = {
  __typename?: 'ServiceLineHeroBodyCopyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ServiceLineHeroBodyCopyEntries = {
  __typename?: 'ServiceLineHeroBodyCopyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ServiceLineHeroBodyCopyLinks = {
  __typename?: 'ServiceLineHeroBodyCopyLinks';
  assets: ServiceLineHeroBodyCopyAssets;
  entries: ServiceLineHeroBodyCopyEntries;
  resources: ServiceLineHeroBodyCopyResources;
};

export type ServiceLineHeroBodyCopyResources = {
  __typename?: 'ServiceLineHeroBodyCopyResources';
  block: Array<ServiceLineHeroBodyCopyResourcesBlock>;
  hyperlink: Array<ServiceLineHeroBodyCopyResourcesHyperlink>;
  inline: Array<ServiceLineHeroBodyCopyResourcesInline>;
};

export type ServiceLineHeroBodyCopyResourcesBlock = ResourceLink & {
  __typename?: 'ServiceLineHeroBodyCopyResourcesBlock';
  sys: ResourceSys;
};

export type ServiceLineHeroBodyCopyResourcesHyperlink = ResourceLink & {
  __typename?: 'ServiceLineHeroBodyCopyResourcesHyperlink';
  sys: ResourceSys;
};

export type ServiceLineHeroBodyCopyResourcesInline = ResourceLink & {
  __typename?: 'ServiceLineHeroBodyCopyResourcesInline';
  sys: ResourceSys;
};

export type ServiceLineHeroButtonCollection = {
  __typename?: 'ServiceLineHeroButtonCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ServiceLineHeroButtonCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ServiceLineHeroCollection = {
  __typename?: 'ServiceLineHeroCollection';
  items: Array<Maybe<ServiceLineHero>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ServiceLineHeroContentListCollection = {
  __typename?: 'ServiceLineHeroContentListCollection';
  items: Array<Maybe<ServiceLineHeroContentListItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ServiceLineHeroContentListFilter = {
  AND?: InputMaybe<Array<InputMaybe<ServiceLineHeroContentListFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ServiceLineHeroContentListFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ServiceLineHeroContentListItem = Accordions | ContentTypeRichText | SingleMessage | Table;

export type ServiceLineHeroFilter = {
  AND?: InputMaybe<Array<InputMaybe<ServiceLineHeroFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ServiceLineHeroFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColorMobile?: InputMaybe<Scalars['String']['input']>;
  backgroundColorMobile_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColorMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColorMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColorMobile_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColorMobile_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColorMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_contains?: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
  button?: InputMaybe<CfButtonNestedFilter>;
  buttonCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlign?: InputMaybe<Scalars['String']['input']>;
  contentAlign_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlign_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentAlign_not?: InputMaybe<Scalars['String']['input']>;
  contentAlign_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlign_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentList?: InputMaybe<CfcontentListMultiTypeNestedFilter>;
  contentListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayOfficeHoursInModal?: InputMaybe<Scalars['Boolean']['input']>;
  displayOfficeHoursInModal_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayOfficeHoursInModal_not?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowHtag_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  focalPointImage?: InputMaybe<CfFocalPointImageNestedFilter>;
  focalPointImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  googleMapsBusinessQuery?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_contains?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_exists?: InputMaybe<Scalars['Boolean']['input']>;
  googleMapsBusinessQuery_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googleMapsBusinessQuery_not?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_not_contains?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  hideHeroOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeroOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeroOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  imageAsset?: InputMaybe<CfImageAssetNestedFilter>;
  imageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageWithBorderRadius?: InputMaybe<Scalars['Boolean']['input']>;
  imageWithBorderRadius_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageWithBorderRadius_not?: InputMaybe<Scalars['Boolean']['input']>;
  imgDisplaysFirstOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  imgDisplaysFirstOnDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imgDisplaysFirstOnDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  imgDisplaysFirstOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  imgDisplaysFirstOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imgDisplaysFirstOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  mediaRoundedCornerSize?: InputMaybe<Scalars['String']['input']>;
  mediaRoundedCornerSize_contains?: InputMaybe<Scalars['String']['input']>;
  mediaRoundedCornerSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaRoundedCornerSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaRoundedCornerSize_not?: InputMaybe<Scalars['String']['input']>;
  mediaRoundedCornerSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  mediaRoundedCornerSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  services?: InputMaybe<CfMedicalServiceNestedFilter>;
  servicesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showOfficeDetails?: InputMaybe<Scalars['Boolean']['input']>;
  showOfficeDetails_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showOfficeDetails_not?: InputMaybe<Scalars['Boolean']['input']>;
  subHeadline_contains?: InputMaybe<Scalars['String']['input']>;
  subHeadline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  templateWidth?: InputMaybe<Scalars['String']['input']>;
  templateWidth_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateWidth_not?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  termsConditions?: InputMaybe<CfTermsAndConditionsNestedFilter>;
  termsConditions_exists?: InputMaybe<Scalars['Boolean']['input']>;
  videoAsset?: InputMaybe<CfVideoAssetNestedFilter>;
  videoAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceLineHeroHeadline = {
  __typename?: 'ServiceLineHeroHeadline';
  json: Scalars['JSON']['output'];
  links: ServiceLineHeroHeadlineLinks;
};

export type ServiceLineHeroHeadlineAssets = {
  __typename?: 'ServiceLineHeroHeadlineAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ServiceLineHeroHeadlineEntries = {
  __typename?: 'ServiceLineHeroHeadlineEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ServiceLineHeroHeadlineLinks = {
  __typename?: 'ServiceLineHeroHeadlineLinks';
  assets: ServiceLineHeroHeadlineAssets;
  entries: ServiceLineHeroHeadlineEntries;
  resources: ServiceLineHeroHeadlineResources;
};

export type ServiceLineHeroHeadlineResources = {
  __typename?: 'ServiceLineHeroHeadlineResources';
  block: Array<ServiceLineHeroHeadlineResourcesBlock>;
  hyperlink: Array<ServiceLineHeroHeadlineResourcesHyperlink>;
  inline: Array<ServiceLineHeroHeadlineResourcesInline>;
};

export type ServiceLineHeroHeadlineResourcesBlock = ResourceLink & {
  __typename?: 'ServiceLineHeroHeadlineResourcesBlock';
  sys: ResourceSys;
};

export type ServiceLineHeroHeadlineResourcesHyperlink = ResourceLink & {
  __typename?: 'ServiceLineHeroHeadlineResourcesHyperlink';
  sys: ResourceSys;
};

export type ServiceLineHeroHeadlineResourcesInline = ResourceLink & {
  __typename?: 'ServiceLineHeroHeadlineResourcesInline';
  sys: ResourceSys;
};

export type ServiceLineHeroLinkingCollections = {
  __typename?: 'ServiceLineHeroLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  pageCollection?: Maybe<PageCollection>;
  segmentsContainerCollection?: Maybe<SegmentsContainerCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
};


export type ServiceLineHeroLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ServiceLineHeroLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ServiceLineHeroLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ServiceLineHeroLinkingCollectionsSegmentsContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroLinkingCollectionsSegmentsContainerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ServiceLineHeroLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceLineHeroLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceLineHeroLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceLineHeroLinkingCollectionsSegmentsContainerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ServiceLineHeroLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceLineHeroOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type ServiceLineHeroServicesCollection = {
  __typename?: 'ServiceLineHeroServicesCollection';
  items: Array<Maybe<MedicalService>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ServiceLineHeroServicesCollectionOrder =
  | 'iconName_ASC'
  | 'iconName_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceLineHeroSubHeadline = {
  __typename?: 'ServiceLineHeroSubHeadline';
  json: Scalars['JSON']['output'];
  links: ServiceLineHeroSubHeadlineLinks;
};

export type ServiceLineHeroSubHeadlineAssets = {
  __typename?: 'ServiceLineHeroSubHeadlineAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ServiceLineHeroSubHeadlineEntries = {
  __typename?: 'ServiceLineHeroSubHeadlineEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ServiceLineHeroSubHeadlineLinks = {
  __typename?: 'ServiceLineHeroSubHeadlineLinks';
  assets: ServiceLineHeroSubHeadlineAssets;
  entries: ServiceLineHeroSubHeadlineEntries;
  resources: ServiceLineHeroSubHeadlineResources;
};

export type ServiceLineHeroSubHeadlineResources = {
  __typename?: 'ServiceLineHeroSubHeadlineResources';
  block: Array<ServiceLineHeroSubHeadlineResourcesBlock>;
  hyperlink: Array<ServiceLineHeroSubHeadlineResourcesHyperlink>;
  inline: Array<ServiceLineHeroSubHeadlineResourcesInline>;
};

export type ServiceLineHeroSubHeadlineResourcesBlock = ResourceLink & {
  __typename?: 'ServiceLineHeroSubHeadlineResourcesBlock';
  sys: ResourceSys;
};

export type ServiceLineHeroSubHeadlineResourcesHyperlink = ResourceLink & {
  __typename?: 'ServiceLineHeroSubHeadlineResourcesHyperlink';
  sys: ResourceSys;
};

export type ServiceLineHeroSubHeadlineResourcesInline = ResourceLink & {
  __typename?: 'ServiceLineHeroSubHeadlineResourcesInline';
  sys: ResourceSys;
};

export type ServiceLinkingCollections = {
  __typename?: 'ServiceLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
  providerDetailsPageCollection?: Maybe<ProviderDetailsPageCollection>;
};


export type ServiceLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ServiceLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ServiceLinkingCollectionsProviderDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLinkingCollectionsProviderDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceLinkingCollectionsProviderDetailsPageCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ServiceOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'direction_ASC'
  | 'direction_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageLayout_ASC'
  | 'imageLayout_DESC'
  | 'mediaType_ASC'
  | 'mediaType_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'youTubeVideoId_ASC'
  | 'youTubeVideoId_DESC';

export type ServiceRichTextDescription = {
  __typename?: 'ServiceRichTextDescription';
  json: Scalars['JSON']['output'];
  links: ServiceRichTextDescriptionLinks;
};

export type ServiceRichTextDescriptionAssets = {
  __typename?: 'ServiceRichTextDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ServiceRichTextDescriptionEntries = {
  __typename?: 'ServiceRichTextDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ServiceRichTextDescriptionLinks = {
  __typename?: 'ServiceRichTextDescriptionLinks';
  assets: ServiceRichTextDescriptionAssets;
  entries: ServiceRichTextDescriptionEntries;
  resources: ServiceRichTextDescriptionResources;
};

export type ServiceRichTextDescriptionResources = {
  __typename?: 'ServiceRichTextDescriptionResources';
  block: Array<ServiceRichTextDescriptionResourcesBlock>;
  hyperlink: Array<ServiceRichTextDescriptionResourcesHyperlink>;
  inline: Array<ServiceRichTextDescriptionResourcesInline>;
};

export type ServiceRichTextDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'ServiceRichTextDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type ServiceRichTextDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'ServiceRichTextDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type ServiceRichTextDescriptionResourcesInline = ResourceLink & {
  __typename?: 'ServiceRichTextDescriptionResourcesInline';
  sys: ResourceSys;
};

export type Sex =
  | 'FEMALE'
  | 'MALE'
  | 'OTHER'
  | 'UNSPECIFIED';

/** Returned when child question is answered but parent is either missing or trigger answer id is mismatching. */
export type ShouldNotBeAnsweredQuestionnaireAnswerError = Error & {
  __typename?: 'ShouldNotBeAnsweredQuestionnaireAnswerError';
  answeredQuestion: QuestionnaireQuestion;
  message: Scalars['String']['output'];
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessage = Entry & _Node & {
  __typename?: 'SingleMessage';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  buttonSize?: Maybe<Scalars['String']['output']>;
  buttonText?: Maybe<Scalars['String']['output']>;
  buttonType?: Maybe<Scalars['String']['output']>;
  buttonUrl?: Maybe<Scalars['String']['output']>;
  buttonsCollection?: Maybe<SingleMessageButtonsCollection>;
  content?: Maybe<SingleMessageContent>;
  contentAlign?: Maybe<Scalars['String']['output']>;
  contentFillVerticalSpace?: Maybe<Scalars['Boolean']['output']>;
  contentSmallScreen?: Maybe<SmallScreenContent>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  disablePaddingOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  display?: Maybe<Scalars['String']['output']>;
  displayTitleInline?: Maybe<Scalars['Boolean']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  facilitySegmentCollection?: Maybe<Scalars['String']['output']>;
  focalPointImage?: Maybe<FocalPointImage>;
  fullWidth?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  iconSize?: Maybe<Scalars['String']['output']>;
  imageAsset?: Maybe<ImageAsset>;
  imageLeftSide?: Maybe<ImageAsset>;
  imageRightSide?: Maybe<ImageAsset>;
  isBannerImage?: Maybe<Scalars['Boolean']['output']>;
  isHeaderAboveSideImages?: Maybe<Scalars['Boolean']['output']>;
  isInlineLayout?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<SingleMessageLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  showSubscriptionForm?: Maybe<Scalars['Boolean']['output']>;
  subText?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  tc?: Maybe<TermsAndConditions>;
  templateHeight?: Maybe<Scalars['String']['output']>;
  templateWidth?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleAlign?: Maybe<Scalars['String']['output']>;
  titleVariant?: Maybe<Scalars['String']['output']>;
  useRoundedCorners?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageButtonSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageButtonTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageButtonUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageContentAlignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageContentFillVerticalSpaceArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageContentSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SmallScreenContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageDisablePaddingOnArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageDisplayArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageDisplayTitleInlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageFacilitySegmentCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageFocalPointImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageFullWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageIconSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageImageAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageImageLeftSideArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageImageRightSideArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageIsBannerImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageIsHeaderAboveSideImagesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageIsInlineLayoutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageShowSubscriptionFormArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageSubTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageTcArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TermsAndConditionsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageTemplateHeightArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageTemplateWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageTitleAlignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageTitleVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageUseRoundedCornersArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type SingleMessageButtonsCollection = {
  __typename?: 'SingleMessageButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SingleMessageButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type SingleMessageCollection = {
  __typename?: 'SingleMessageCollection';
  items: Array<Maybe<SingleMessage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SingleMessageContent = {
  __typename?: 'SingleMessageContent';
  json: Scalars['JSON']['output'];
  links: SingleMessageContentLinks;
};

export type SingleMessageContentAssets = {
  __typename?: 'SingleMessageContentAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SingleMessageContentEntries = {
  __typename?: 'SingleMessageContentEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SingleMessageContentLinks = {
  __typename?: 'SingleMessageContentLinks';
  assets: SingleMessageContentAssets;
  entries: SingleMessageContentEntries;
  resources: SingleMessageContentResources;
};

export type SingleMessageContentResources = {
  __typename?: 'SingleMessageContentResources';
  block: Array<SingleMessageContentResourcesBlock>;
  hyperlink: Array<SingleMessageContentResourcesHyperlink>;
  inline: Array<SingleMessageContentResourcesInline>;
};

export type SingleMessageContentResourcesBlock = ResourceLink & {
  __typename?: 'SingleMessageContentResourcesBlock';
  sys: ResourceSys;
};

export type SingleMessageContentResourcesHyperlink = ResourceLink & {
  __typename?: 'SingleMessageContentResourcesHyperlink';
  sys: ResourceSys;
};

export type SingleMessageContentResourcesInline = ResourceLink & {
  __typename?: 'SingleMessageContentResourcesInline';
  sys: ResourceSys;
};

export type SingleMessageFilter = {
  AND?: InputMaybe<Array<InputMaybe<SingleMessageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SingleMessageFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonSize?: InputMaybe<Scalars['String']['input']>;
  buttonSize_contains?: InputMaybe<Scalars['String']['input']>;
  buttonSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonSize_not?: InputMaybe<Scalars['String']['input']>;
  buttonSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonType?: InputMaybe<Scalars['String']['input']>;
  buttonType_contains?: InputMaybe<Scalars['String']['input']>;
  buttonType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonType_not?: InputMaybe<Scalars['String']['input']>;
  buttonType_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlign?: InputMaybe<Scalars['String']['input']>;
  contentAlign_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlign_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentAlign_not?: InputMaybe<Scalars['String']['input']>;
  contentAlign_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlign_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFillVerticalSpace?: InputMaybe<Scalars['Boolean']['input']>;
  contentFillVerticalSpace_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentFillVerticalSpace_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentSmallScreen?: InputMaybe<CfSmallScreenContentNestedFilter>;
  contentSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_contains?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  displayTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  displayTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  display_contains?: InputMaybe<Scalars['String']['input']>;
  display_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  display_not?: InputMaybe<Scalars['String']['input']>;
  display_not_contains?: InputMaybe<Scalars['String']['input']>;
  display_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  focalPointImage?: InputMaybe<CfFocalPointImageNestedFilter>;
  focalPointImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconSize?: InputMaybe<Scalars['String']['input']>;
  iconSize_contains?: InputMaybe<Scalars['String']['input']>;
  iconSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconSize_not?: InputMaybe<Scalars['String']['input']>;
  iconSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAsset?: InputMaybe<CfImageAssetNestedFilter>;
  imageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageLeftSide?: InputMaybe<CfImageAssetNestedFilter>;
  imageLeftSide_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageRightSide?: InputMaybe<CfImageAssetNestedFilter>;
  imageRightSide_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isBannerImage?: InputMaybe<Scalars['Boolean']['input']>;
  isBannerImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isBannerImage_not?: InputMaybe<Scalars['Boolean']['input']>;
  isHeaderAboveSideImages?: InputMaybe<Scalars['Boolean']['input']>;
  isHeaderAboveSideImages_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isHeaderAboveSideImages_not?: InputMaybe<Scalars['Boolean']['input']>;
  isInlineLayout?: InputMaybe<Scalars['Boolean']['input']>;
  isInlineLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isInlineLayout_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showSubscriptionForm?: InputMaybe<Scalars['Boolean']['input']>;
  showSubscriptionForm_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showSubscriptionForm_not?: InputMaybe<Scalars['Boolean']['input']>;
  subText?: InputMaybe<Scalars['String']['input']>;
  subText_contains?: InputMaybe<Scalars['String']['input']>;
  subText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subText_not?: InputMaybe<Scalars['String']['input']>;
  subText_not_contains?: InputMaybe<Scalars['String']['input']>;
  subText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tc?: InputMaybe<CfTermsAndConditionsNestedFilter>;
  tc_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateHeight?: InputMaybe<Scalars['String']['input']>;
  templateHeight_contains?: InputMaybe<Scalars['String']['input']>;
  templateHeight_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateHeight_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateHeight_not?: InputMaybe<Scalars['String']['input']>;
  templateHeight_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateHeight_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateWidth?: InputMaybe<Scalars['String']['input']>;
  templateWidth_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateWidth_not?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleAlign?: InputMaybe<Scalars['String']['input']>;
  titleAlign_contains?: InputMaybe<Scalars['String']['input']>;
  titleAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleAlign_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleAlign_not?: InputMaybe<Scalars['String']['input']>;
  titleAlign_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleAlign_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleVariant?: InputMaybe<Scalars['String']['input']>;
  titleVariant_contains?: InputMaybe<Scalars['String']['input']>;
  titleVariant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleVariant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleVariant_not?: InputMaybe<Scalars['String']['input']>;
  titleVariant_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  useRoundedCorners?: InputMaybe<Scalars['Boolean']['input']>;
  useRoundedCorners_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useRoundedCorners_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SingleMessageLinkingCollections = {
  __typename?: 'SingleMessageLinkingCollections';
  appointmentBookingPageCollection?: Maybe<AppointmentBookingPageCollection>;
  blogDetailsPageCollection?: Maybe<BlogDetailsPageCollection>;
  blogListPageCollection?: Maybe<BlogListPageCollection>;
  columnsCollection?: Maybe<ColumnsCollection>;
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  pageCollection?: Maybe<PageCollection>;
  providerDetailsPageCollection?: Maybe<ProviderDetailsPageCollection>;
  segmentsContainerCollection?: Maybe<SegmentsContainerCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceLineHeroCollection?: Maybe<ServiceLineHeroCollection>;
};


export type SingleMessageLinkingCollectionsAppointmentBookingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsAppointmentBookingPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SingleMessageLinkingCollectionsBlogDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsBlogDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SingleMessageLinkingCollectionsBlogListPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsBlogListPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SingleMessageLinkingCollectionsColumnsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsColumnsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SingleMessageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SingleMessageLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SingleMessageLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SingleMessageLinkingCollectionsProviderDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsProviderDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SingleMessageLinkingCollectionsSegmentsContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsSegmentsContainerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SingleMessageLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SingleMessageLinkingCollectionsServiceLineHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsServiceLineHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type SingleMessageLinkingCollectionsAppointmentBookingPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SingleMessageLinkingCollectionsBlogDetailsPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SingleMessageLinkingCollectionsBlogListPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'shouldDisplayCategoryFilterChips_ASC'
  | 'shouldDisplayCategoryFilterChips_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SingleMessageLinkingCollectionsColumnsCollectionOrder =
  | 'allowEqualHeights_ASC'
  | 'allowEqualHeights_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'mobileDisplayAccordion_ASC'
  | 'mobileDisplayAccordion_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SingleMessageLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SingleMessageLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SingleMessageLinkingCollectionsProviderDetailsPageCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type SingleMessageLinkingCollectionsSegmentsContainerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type SingleMessageLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SingleMessageLinkingCollectionsServiceLineHeroCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type SingleMessageOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentFillVerticalSpace_ASC'
  | 'contentFillVerticalSpace_DESC'
  | 'displayTitleInline_ASC'
  | 'displayTitleInline_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isBannerImage_ASC'
  | 'isBannerImage_DESC'
  | 'isHeaderAboveSideImages_ASC'
  | 'isHeaderAboveSideImages_DESC'
  | 'isInlineLayout_ASC'
  | 'isInlineLayout_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showSubscriptionForm_ASC'
  | 'showSubscriptionForm_DESC'
  | 'subText_ASC'
  | 'subText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateHeight_ASC'
  | 'templateHeight_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleAlign_ASC'
  | 'titleAlign_DESC'
  | 'titleVariant_ASC'
  | 'titleVariant_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useRoundedCorners_ASC'
  | 'useRoundedCorners_DESC';

export type SinglePredefinedQuestionnaireAnswerInput = {
  answerId: Scalars['NonEmptyString']['input'];
};

/** Component for small screen content fields. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smallScreenContent) */
export type SmallScreenContent = Entry & _Node & {
  __typename?: 'SmallScreenContent';
  _id: Scalars['ID']['output'];
  bodySmallScreen?: Maybe<SmallScreenContentBodySmallScreen>;
  contentfulMetadata: ContentfulMetadata;
  controllableVideo?: Maybe<Video>;
  entryName?: Maybe<Scalars['String']['output']>;
  eyebrowSmallScreen?: Maybe<Scalars['String']['output']>;
  focalPointImageSmallScreen?: Maybe<FocalPointImage>;
  headingSmallScreen?: Maybe<SmallScreenContentHeadingSmallScreen>;
  imageSmallScreen?: Maybe<Asset>;
  linkedFrom?: Maybe<SmallScreenContentLinkingCollections>;
  mediaFirst?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  videoSmallScreen?: Maybe<Asset>;
};


/** Component for small screen content fields. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smallScreenContent) */
export type SmallScreenContentBodySmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Component for small screen content fields. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smallScreenContent) */
export type SmallScreenContentControllableVideoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoFilter>;
};


/** Component for small screen content fields. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smallScreenContent) */
export type SmallScreenContentEntryNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Component for small screen content fields. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smallScreenContent) */
export type SmallScreenContentEyebrowSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Component for small screen content fields. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smallScreenContent) */
export type SmallScreenContentFocalPointImageSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** Component for small screen content fields. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smallScreenContent) */
export type SmallScreenContentHeadingSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Component for small screen content fields. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smallScreenContent) */
export type SmallScreenContentImageSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Component for small screen content fields. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smallScreenContent) */
export type SmallScreenContentLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Component for small screen content fields. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smallScreenContent) */
export type SmallScreenContentMediaFirstArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Component for small screen content fields. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smallScreenContent) */
export type SmallScreenContentVideoSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SmallScreenContentBodySmallScreen = {
  __typename?: 'SmallScreenContentBodySmallScreen';
  json: Scalars['JSON']['output'];
  links: SmallScreenContentBodySmallScreenLinks;
};

export type SmallScreenContentBodySmallScreenAssets = {
  __typename?: 'SmallScreenContentBodySmallScreenAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SmallScreenContentBodySmallScreenEntries = {
  __typename?: 'SmallScreenContentBodySmallScreenEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SmallScreenContentBodySmallScreenLinks = {
  __typename?: 'SmallScreenContentBodySmallScreenLinks';
  assets: SmallScreenContentBodySmallScreenAssets;
  entries: SmallScreenContentBodySmallScreenEntries;
  resources: SmallScreenContentBodySmallScreenResources;
};

export type SmallScreenContentBodySmallScreenResources = {
  __typename?: 'SmallScreenContentBodySmallScreenResources';
  block: Array<SmallScreenContentBodySmallScreenResourcesBlock>;
  hyperlink: Array<SmallScreenContentBodySmallScreenResourcesHyperlink>;
  inline: Array<SmallScreenContentBodySmallScreenResourcesInline>;
};

export type SmallScreenContentBodySmallScreenResourcesBlock = ResourceLink & {
  __typename?: 'SmallScreenContentBodySmallScreenResourcesBlock';
  sys: ResourceSys;
};

export type SmallScreenContentBodySmallScreenResourcesHyperlink = ResourceLink & {
  __typename?: 'SmallScreenContentBodySmallScreenResourcesHyperlink';
  sys: ResourceSys;
};

export type SmallScreenContentBodySmallScreenResourcesInline = ResourceLink & {
  __typename?: 'SmallScreenContentBodySmallScreenResourcesInline';
  sys: ResourceSys;
};

export type SmallScreenContentCollection = {
  __typename?: 'SmallScreenContentCollection';
  items: Array<Maybe<SmallScreenContent>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SmallScreenContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<SmallScreenContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SmallScreenContentFilter>>>;
  bodySmallScreen_contains?: InputMaybe<Scalars['String']['input']>;
  bodySmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodySmallScreen_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  controllableVideo?: InputMaybe<CfVideoNestedFilter>;
  controllableVideo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName?: InputMaybe<Scalars['String']['input']>;
  entryName_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryName_not?: InputMaybe<Scalars['String']['input']>;
  entryName_not_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowSmallScreen?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreen_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowSmallScreen_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowSmallScreen_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreen_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreen_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  focalPointImageSmallScreen?: InputMaybe<CfFocalPointImageNestedFilter>;
  focalPointImageSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingSmallScreen_contains?: InputMaybe<Scalars['String']['input']>;
  headingSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingSmallScreen_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaFirst?: InputMaybe<Scalars['Boolean']['input']>;
  mediaFirst_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaFirst_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  videoSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SmallScreenContentHeadingSmallScreen = {
  __typename?: 'SmallScreenContentHeadingSmallScreen';
  json: Scalars['JSON']['output'];
  links: SmallScreenContentHeadingSmallScreenLinks;
};

export type SmallScreenContentHeadingSmallScreenAssets = {
  __typename?: 'SmallScreenContentHeadingSmallScreenAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SmallScreenContentHeadingSmallScreenEntries = {
  __typename?: 'SmallScreenContentHeadingSmallScreenEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SmallScreenContentHeadingSmallScreenLinks = {
  __typename?: 'SmallScreenContentHeadingSmallScreenLinks';
  assets: SmallScreenContentHeadingSmallScreenAssets;
  entries: SmallScreenContentHeadingSmallScreenEntries;
  resources: SmallScreenContentHeadingSmallScreenResources;
};

export type SmallScreenContentHeadingSmallScreenResources = {
  __typename?: 'SmallScreenContentHeadingSmallScreenResources';
  block: Array<SmallScreenContentHeadingSmallScreenResourcesBlock>;
  hyperlink: Array<SmallScreenContentHeadingSmallScreenResourcesHyperlink>;
  inline: Array<SmallScreenContentHeadingSmallScreenResourcesInline>;
};

export type SmallScreenContentHeadingSmallScreenResourcesBlock = ResourceLink & {
  __typename?: 'SmallScreenContentHeadingSmallScreenResourcesBlock';
  sys: ResourceSys;
};

export type SmallScreenContentHeadingSmallScreenResourcesHyperlink = ResourceLink & {
  __typename?: 'SmallScreenContentHeadingSmallScreenResourcesHyperlink';
  sys: ResourceSys;
};

export type SmallScreenContentHeadingSmallScreenResourcesInline = ResourceLink & {
  __typename?: 'SmallScreenContentHeadingSmallScreenResourcesInline';
  sys: ResourceSys;
};

export type SmallScreenContentLinkingCollections = {
  __typename?: 'SmallScreenContentLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  halfScreenCollection?: Maybe<HalfScreenCollection>;
  heroV2Collection?: Maybe<HeroV2Collection>;
  odpHeroCollection?: Maybe<OdpHeroCollection>;
  singleMessageCollection?: Maybe<SingleMessageCollection>;
};


export type SmallScreenContentLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SmallScreenContentLinkingCollectionsHalfScreenCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmallScreenContentLinkingCollectionsHalfScreenCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SmallScreenContentLinkingCollectionsHeroV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmallScreenContentLinkingCollectionsHeroV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SmallScreenContentLinkingCollectionsOdpHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmallScreenContentLinkingCollectionsOdpHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SmallScreenContentLinkingCollectionsSingleMessageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmallScreenContentLinkingCollectionsSingleMessageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type SmallScreenContentLinkingCollectionsHalfScreenCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC';

export type SmallScreenContentLinkingCollectionsHeroV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type SmallScreenContentLinkingCollectionsOdpHeroCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'appointmentDataSource_ASC'
  | 'appointmentDataSource_DESC'
  | 'callCenterLabel_ASC'
  | 'callCenterLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'promoTitle_ASC'
  | 'promoTitle_DESC'
  | 'showAddress_ASC'
  | 'showAddress_DESC'
  | 'showEmail_ASC'
  | 'showEmail_DESC'
  | 'showFax_ASC'
  | 'showFax_DESC'
  | 'showHours_ASC'
  | 'showHours_DESC'
  | 'showLocationStatusBadge_ASC'
  | 'showLocationStatusBadge_DESC'
  | 'showPhoneNumber_ASC'
  | 'showPhoneNumber_DESC'
  | 'showReviews_ASC'
  | 'showReviews_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SmallScreenContentLinkingCollectionsSingleMessageCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentFillVerticalSpace_ASC'
  | 'contentFillVerticalSpace_DESC'
  | 'displayTitleInline_ASC'
  | 'displayTitleInline_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isBannerImage_ASC'
  | 'isBannerImage_DESC'
  | 'isHeaderAboveSideImages_ASC'
  | 'isHeaderAboveSideImages_DESC'
  | 'isInlineLayout_ASC'
  | 'isInlineLayout_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showSubscriptionForm_ASC'
  | 'showSubscriptionForm_DESC'
  | 'subText_ASC'
  | 'subText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateHeight_ASC'
  | 'templateHeight_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleAlign_ASC'
  | 'titleAlign_DESC'
  | 'titleVariant_ASC'
  | 'titleVariant_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useRoundedCorners_ASC'
  | 'useRoundedCorners_DESC';

export type SmallScreenContentOrder =
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowSmallScreen_ASC'
  | 'eyebrowSmallScreen_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smileAssessmentForm) */
export type SmileAssessmentForm = Entry & _Node & {
  __typename?: 'SmileAssessmentForm';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  formContent?: Maybe<Questionnaire>;
  linkedFrom?: Maybe<SmileAssessmentFormLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smileAssessmentForm) */
export type SmileAssessmentFormFormContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuestionnaireFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smileAssessmentForm) */
export type SmileAssessmentFormLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smileAssessmentForm) */
export type SmileAssessmentFormNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type SmileAssessmentFormCollection = {
  __typename?: 'SmileAssessmentFormCollection';
  items: Array<Maybe<SmileAssessmentForm>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SmileAssessmentFormFilter = {
  AND?: InputMaybe<Array<InputMaybe<SmileAssessmentFormFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SmileAssessmentFormFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  formContent?: InputMaybe<CfQuestionnaireNestedFilter>;
  formContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type SmileAssessmentFormLinkingCollections = {
  __typename?: 'SmileAssessmentFormLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type SmileAssessmentFormLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SmileAssessmentFormLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmileAssessmentFormLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type SmileAssessmentFormLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SmileAssessmentFormOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type SocialNetwork = {
  __typename?: 'SocialNetwork';
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** A spacer component to create empty spaces between other templates and to serve as anchor to scroll to [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/spacer) */
export type Spacer = Entry & _Node & {
  __typename?: 'Spacer';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<SpacerLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** A spacer component to create empty spaces between other templates and to serve as anchor to scroll to [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/spacer) */
export type SpacerAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A spacer component to create empty spaces between other templates and to serve as anchor to scroll to [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/spacer) */
export type SpacerColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A spacer component to create empty spaces between other templates and to serve as anchor to scroll to [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/spacer) */
export type SpacerLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A spacer component to create empty spaces between other templates and to serve as anchor to scroll to [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/spacer) */
export type SpacerNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A spacer component to create empty spaces between other templates and to serve as anchor to scroll to [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/spacer) */
export type SpacerSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type SpacerCollection = {
  __typename?: 'SpacerCollection';
  items: Array<Maybe<Spacer>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SpacerFilter = {
  AND?: InputMaybe<Array<InputMaybe<SpacerFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SpacerFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  color?: InputMaybe<Scalars['String']['input']>;
  color_contains?: InputMaybe<Scalars['String']['input']>;
  color_exists?: InputMaybe<Scalars['Boolean']['input']>;
  color_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  color_not?: InputMaybe<Scalars['String']['input']>;
  color_not_contains?: InputMaybe<Scalars['String']['input']>;
  color_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size?: InputMaybe<Scalars['String']['input']>;
  size_contains?: InputMaybe<Scalars['String']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size_not?: InputMaybe<Scalars['String']['input']>;
  size_not_contains?: InputMaybe<Scalars['String']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type SpacerLinkingCollections = {
  __typename?: 'SpacerLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  pageCollection?: Maybe<PageCollection>;
  providerDetailsPageCollection?: Maybe<ProviderDetailsPageCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
};


export type SpacerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SpacerLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SpacerLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SpacerLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SpacerLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SpacerLinkingCollectionsProviderDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SpacerLinkingCollectionsProviderDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SpacerLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SpacerLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type SpacerLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SpacerLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SpacerLinkingCollectionsProviderDetailsPageCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type SpacerLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SpacerOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'color_ASC'
  | 'color_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** A container component for state links (ODP) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stateLinks) */
export type StateLinks = Entry & _Node & {
  __typename?: 'StateLinks';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<StateLinksLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sectionTitle?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** A container component for state links (ODP) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stateLinks) */
export type StateLinksLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A container component for state links (ODP) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stateLinks) */
export type StateLinksNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A container component for state links (ODP) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stateLinks) */
export type StateLinksSectionTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type StateLinksCollection = {
  __typename?: 'StateLinksCollection';
  items: Array<Maybe<StateLinks>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type StateLinksFilter = {
  AND?: InputMaybe<Array<InputMaybe<StateLinksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<StateLinksFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle_not?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type StateLinksLinkingCollections = {
  __typename?: 'StateLinksLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type StateLinksLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type StateLinksLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StateLinksLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type StateLinksLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type StateLinksOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sectionTitle_ASC'
  | 'sectionTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** NOTE: only for Scheduling, not ready for general consumption [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stepper) */
export type Stepper = Entry & _Node & {
  __typename?: 'Stepper';
  _id: Scalars['ID']['output'];
  confirmButtonText?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  continueButtonText?: Maybe<Scalars['String']['output']>;
  headingScheduledText?: Maybe<Scalars['String']['output']>;
  headingText?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<StepperLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  needAssistanceText?: Maybe<Scalars['String']['output']>;
  stepLabels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  stepsCollection?: Maybe<StepperStepsCollection>;
  sys: Sys;
};


/** NOTE: only for Scheduling, not ready for general consumption [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stepper) */
export type StepperConfirmButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** NOTE: only for Scheduling, not ready for general consumption [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stepper) */
export type StepperContinueButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** NOTE: only for Scheduling, not ready for general consumption [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stepper) */
export type StepperHeadingScheduledTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** NOTE: only for Scheduling, not ready for general consumption [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stepper) */
export type StepperHeadingTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** NOTE: only for Scheduling, not ready for general consumption [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stepper) */
export type StepperLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** NOTE: only for Scheduling, not ready for general consumption [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stepper) */
export type StepperNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** NOTE: only for Scheduling, not ready for general consumption [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stepper) */
export type StepperNeedAssistanceTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** NOTE: only for Scheduling, not ready for general consumption [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stepper) */
export type StepperStepLabelsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** NOTE: only for Scheduling, not ready for general consumption [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stepper) */
export type StepperStepsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StepperStepsFilter>;
};

export type StepperCollection = {
  __typename?: 'StepperCollection';
  items: Array<Maybe<Stepper>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type StepperFilter = {
  AND?: InputMaybe<Array<InputMaybe<StepperFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<StepperFilter>>>;
  confirmButtonText?: InputMaybe<Scalars['String']['input']>;
  confirmButtonText_contains?: InputMaybe<Scalars['String']['input']>;
  confirmButtonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  confirmButtonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmButtonText_not?: InputMaybe<Scalars['String']['input']>;
  confirmButtonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  confirmButtonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  continueButtonText?: InputMaybe<Scalars['String']['input']>;
  continueButtonText_contains?: InputMaybe<Scalars['String']['input']>;
  continueButtonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  continueButtonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  continueButtonText_not?: InputMaybe<Scalars['String']['input']>;
  continueButtonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  continueButtonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingScheduledText?: InputMaybe<Scalars['String']['input']>;
  headingScheduledText_contains?: InputMaybe<Scalars['String']['input']>;
  headingScheduledText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingScheduledText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingScheduledText_not?: InputMaybe<Scalars['String']['input']>;
  headingScheduledText_not_contains?: InputMaybe<Scalars['String']['input']>;
  headingScheduledText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  headingText_contains?: InputMaybe<Scalars['String']['input']>;
  headingText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingText_not?: InputMaybe<Scalars['String']['input']>;
  headingText_not_contains?: InputMaybe<Scalars['String']['input']>;
  headingText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  needAssistanceText?: InputMaybe<Scalars['String']['input']>;
  needAssistanceText_contains?: InputMaybe<Scalars['String']['input']>;
  needAssistanceText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  needAssistanceText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  needAssistanceText_not?: InputMaybe<Scalars['String']['input']>;
  needAssistanceText_not_contains?: InputMaybe<Scalars['String']['input']>;
  needAssistanceText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepLabels_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepLabels_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepLabels_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepLabels_exists?: InputMaybe<Scalars['Boolean']['input']>;
  steps?: InputMaybe<CfstepsMultiTypeNestedFilter>;
  stepsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type StepperLinkingCollections = {
  __typename?: 'StepperLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
  stepperCollection?: Maybe<StepperCollection>;
};


export type StepperLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type StepperLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StepperLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type StepperLinkingCollectionsStepperCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StepperLinkingCollectionsStepperCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type StepperLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type StepperLinkingCollectionsStepperCollectionOrder =
  | 'confirmButtonText_ASC'
  | 'confirmButtonText_DESC'
  | 'continueButtonText_ASC'
  | 'continueButtonText_DESC'
  | 'headingScheduledText_ASC'
  | 'headingScheduledText_DESC'
  | 'headingText_ASC'
  | 'headingText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'needAssistanceText_ASC'
  | 'needAssistanceText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type StepperOrder =
  | 'confirmButtonText_ASC'
  | 'confirmButtonText_DESC'
  | 'continueButtonText_ASC'
  | 'continueButtonText_DESC'
  | 'headingScheduledText_ASC'
  | 'headingScheduledText_DESC'
  | 'headingText_ASC'
  | 'headingText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'needAssistanceText_ASC'
  | 'needAssistanceText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type StepperStepsCollection = {
  __typename?: 'StepperStepsCollection';
  items: Array<Maybe<StepperStepsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type StepperStepsFilter = {
  AND?: InputMaybe<Array<InputMaybe<StepperStepsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<StepperStepsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type StepperStepsItem = ConfirmationStep | ReviewStep | Stepper;

/** A card that is displayed at the bottom of the confirmation page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/successCard) */
export type SuccessCard = Entry & _Node & {
  __typename?: 'SuccessCard';
  _id: Scalars['ID']['output'];
  buttonLink?: Maybe<Scalars['String']['output']>;
  buttonText?: Maybe<Scalars['String']['output']>;
  cardImage?: Maybe<Asset>;
  contentfulMetadata: ContentfulMetadata;
  descriptionText?: Maybe<Scalars['String']['output']>;
  imageAltText?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<SuccessCardLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  titleText?: Maybe<Scalars['String']['output']>;
};


/** A card that is displayed at the bottom of the confirmation page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/successCard) */
export type SuccessCardButtonLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A card that is displayed at the bottom of the confirmation page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/successCard) */
export type SuccessCardButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A card that is displayed at the bottom of the confirmation page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/successCard) */
export type SuccessCardCardImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A card that is displayed at the bottom of the confirmation page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/successCard) */
export type SuccessCardDescriptionTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A card that is displayed at the bottom of the confirmation page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/successCard) */
export type SuccessCardImageAltTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A card that is displayed at the bottom of the confirmation page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/successCard) */
export type SuccessCardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A card that is displayed at the bottom of the confirmation page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/successCard) */
export type SuccessCardNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** A card that is displayed at the bottom of the confirmation page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/successCard) */
export type SuccessCardTitleTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type SuccessCardCollection = {
  __typename?: 'SuccessCardCollection';
  items: Array<Maybe<SuccessCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SuccessCardFilter = {
  AND?: InputMaybe<Array<InputMaybe<SuccessCardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SuccessCardFilter>>>;
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonLink_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLink_not?: InputMaybe<Scalars['String']['input']>;
  buttonLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  descriptionText?: InputMaybe<Scalars['String']['input']>;
  descriptionText_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionText_not?: InputMaybe<Scalars['String']['input']>;
  descriptionText_not_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAltText?: InputMaybe<Scalars['String']['input']>;
  imageAltText_contains?: InputMaybe<Scalars['String']['input']>;
  imageAltText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageAltText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAltText_not?: InputMaybe<Scalars['String']['input']>;
  imageAltText_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageAltText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  titleText?: InputMaybe<Scalars['String']['input']>;
  titleText_contains?: InputMaybe<Scalars['String']['input']>;
  titleText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleText_not?: InputMaybe<Scalars['String']['input']>;
  titleText_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SuccessCardLinkingCollections = {
  __typename?: 'SuccessCardLinkingCollections';
  confirmationStepCollection?: Maybe<ConfirmationStepCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type SuccessCardLinkingCollectionsConfirmationStepCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SuccessCardLinkingCollectionsConfirmationStepCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SuccessCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type SuccessCardLinkingCollectionsConfirmationStepCollectionOrder =
  | 'accountNumberText_ASC'
  | 'accountNumberText_DESC'
  | 'cardInfoText_ASC'
  | 'cardInfoText_DESC'
  | 'confirmationPageName_ASC'
  | 'confirmationPageName_DESC'
  | 'copyTextButtonText_ASC'
  | 'copyTextButtonText_DESC'
  | 'stepNumber_ASC'
  | 'stepNumber_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type SuccessCardOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'imageAltText_ASC'
  | 'imageAltText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleText_ASC'
  | 'titleText_DESC';

export type Suffix =
  | 'DDS'
  | 'DMD'
  | 'ESQ'
  | 'II'
  | 'III'
  | 'IV'
  | 'JR'
  | 'MD'
  | 'SR'
  | 'V';

export type Sys = {
  __typename?: 'Sys';
  environmentId: Scalars['String']['output'];
  firstPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  /** The locale that was requested. */
  locale?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedVersion?: Maybe<Scalars['Int']['output']>;
  spaceId: Scalars['String']['output'];
};

export type SysFilter = {
  firstPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  firstPublishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  firstPublishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedVersion?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publishedVersion_gt?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_gte?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  publishedVersion_lt?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_lte?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_not?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tab) */
export type Tab = Entry & _Node & {
  __typename?: 'Tab';
  _id: Scalars['ID']['output'];
  content?: Maybe<Accordions>;
  contentfulMetadata: ContentfulMetadata;
  jumplinkName?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<TabLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tab) */
export type TabContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AccordionsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tab) */
export type TabJumplinkNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tab) */
export type TabLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tab) */
export type TabLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tab) */
export type TabNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type TabCollection = {
  __typename?: 'TabCollection';
  items: Array<Maybe<Tab>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TabFilter = {
  AND?: InputMaybe<Array<InputMaybe<TabFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TabFilter>>>;
  content?: InputMaybe<CfAccordionsNestedFilter>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  jumplinkName?: InputMaybe<Scalars['String']['input']>;
  jumplinkName_contains?: InputMaybe<Scalars['String']['input']>;
  jumplinkName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  jumplinkName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jumplinkName_not?: InputMaybe<Scalars['String']['input']>;
  jumplinkName_not_contains?: InputMaybe<Scalars['String']['input']>;
  jumplinkName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type TabLinkingCollections = {
  __typename?: 'TabLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  tabsCollection?: Maybe<TabsCollection>;
};


export type TabLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TabLinkingCollectionsTabsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabLinkingCollectionsTabsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type TabLinkingCollectionsTabsCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'jumplinkTabs_ASC'
  | 'jumplinkTabs_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tabRowVariant_ASC'
  | 'tabRowVariant_DESC'
  | 'tabsSize_ASC'
  | 'tabsSize_DESC'
  | 'withContentInnerGap_ASC'
  | 'withContentInnerGap_DESC';

export type TabOrder =
  | 'jumplinkName_ASC'
  | 'jumplinkName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type Table = Entry & _Node & {
  __typename?: 'Table';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  border?: Maybe<Scalars['Boolean']['output']>;
  contentfulMetadata: ContentfulMetadata;
  descriptionRichText?: Maybe<TableDescriptionRichText>;
  firstColumnSticky?: Maybe<Scalars['Boolean']['output']>;
  fontSize?: Maybe<Scalars['String']['output']>;
  footnote?: Maybe<TableFootnote>;
  linkedFrom?: Maybe<TableLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  tableContent?: Maybe<TableTableContent>;
  tableJsonData?: Maybe<Scalars['JSON']['output']>;
  tableJsonDataMobile?: Maybe<Scalars['JSON']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleHtag?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableBorderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableDescriptionRichTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableFirstColumnStickyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableFontSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableFootnoteArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableTableContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableTableJsonDataArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableTableJsonDataMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type TableCollection = {
  __typename?: 'TableCollection';
  items: Array<Maybe<Table>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TableDescriptionRichText = {
  __typename?: 'TableDescriptionRichText';
  json: Scalars['JSON']['output'];
  links: TableDescriptionRichTextLinks;
};

export type TableDescriptionRichTextAssets = {
  __typename?: 'TableDescriptionRichTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TableDescriptionRichTextEntries = {
  __typename?: 'TableDescriptionRichTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TableDescriptionRichTextLinks = {
  __typename?: 'TableDescriptionRichTextLinks';
  assets: TableDescriptionRichTextAssets;
  entries: TableDescriptionRichTextEntries;
  resources: TableDescriptionRichTextResources;
};

export type TableDescriptionRichTextResources = {
  __typename?: 'TableDescriptionRichTextResources';
  block: Array<TableDescriptionRichTextResourcesBlock>;
  hyperlink: Array<TableDescriptionRichTextResourcesHyperlink>;
  inline: Array<TableDescriptionRichTextResourcesInline>;
};

export type TableDescriptionRichTextResourcesBlock = ResourceLink & {
  __typename?: 'TableDescriptionRichTextResourcesBlock';
  sys: ResourceSys;
};

export type TableDescriptionRichTextResourcesHyperlink = ResourceLink & {
  __typename?: 'TableDescriptionRichTextResourcesHyperlink';
  sys: ResourceSys;
};

export type TableDescriptionRichTextResourcesInline = ResourceLink & {
  __typename?: 'TableDescriptionRichTextResourcesInline';
  sys: ResourceSys;
};

export type TableFilter = {
  AND?: InputMaybe<Array<InputMaybe<TableFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TableFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  border?: InputMaybe<Scalars['Boolean']['input']>;
  border_exists?: InputMaybe<Scalars['Boolean']['input']>;
  border_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  descriptionRichText_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionRichText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionRichText_not_contains?: InputMaybe<Scalars['String']['input']>;
  firstColumnSticky?: InputMaybe<Scalars['Boolean']['input']>;
  firstColumnSticky_exists?: InputMaybe<Scalars['Boolean']['input']>;
  firstColumnSticky_not?: InputMaybe<Scalars['Boolean']['input']>;
  fontSize?: InputMaybe<Scalars['String']['input']>;
  fontSize_contains?: InputMaybe<Scalars['String']['input']>;
  fontSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fontSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fontSize_not?: InputMaybe<Scalars['String']['input']>;
  fontSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  fontSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  footnote_contains?: InputMaybe<Scalars['String']['input']>;
  footnote_exists?: InputMaybe<Scalars['Boolean']['input']>;
  footnote_not_contains?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tableContent_contains?: InputMaybe<Scalars['String']['input']>;
  tableContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tableContent_not_contains?: InputMaybe<Scalars['String']['input']>;
  tableJsonDataMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tableJsonData_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TableFootnote = {
  __typename?: 'TableFootnote';
  json: Scalars['JSON']['output'];
  links: TableFootnoteLinks;
};

export type TableFootnoteAssets = {
  __typename?: 'TableFootnoteAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TableFootnoteEntries = {
  __typename?: 'TableFootnoteEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TableFootnoteLinks = {
  __typename?: 'TableFootnoteLinks';
  assets: TableFootnoteAssets;
  entries: TableFootnoteEntries;
  resources: TableFootnoteResources;
};

export type TableFootnoteResources = {
  __typename?: 'TableFootnoteResources';
  block: Array<TableFootnoteResourcesBlock>;
  hyperlink: Array<TableFootnoteResourcesHyperlink>;
  inline: Array<TableFootnoteResourcesInline>;
};

export type TableFootnoteResourcesBlock = ResourceLink & {
  __typename?: 'TableFootnoteResourcesBlock';
  sys: ResourceSys;
};

export type TableFootnoteResourcesHyperlink = ResourceLink & {
  __typename?: 'TableFootnoteResourcesHyperlink';
  sys: ResourceSys;
};

export type TableFootnoteResourcesInline = ResourceLink & {
  __typename?: 'TableFootnoteResourcesInline';
  sys: ResourceSys;
};

export type TableLinkingCollections = {
  __typename?: 'TableLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
  serviceLineHeroCollection?: Maybe<ServiceLineHeroCollection>;
};


export type TableLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TableLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TableLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TableLinkingCollectionsServiceLineHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TableLinkingCollectionsServiceLineHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type TableLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type TableLinkingCollectionsServiceLineHeroCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type TableOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'border_ASC'
  | 'border_DESC'
  | 'firstColumnSticky_ASC'
  | 'firstColumnSticky_DESC'
  | 'fontSize_ASC'
  | 'fontSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type TableTableContent = {
  __typename?: 'TableTableContent';
  json: Scalars['JSON']['output'];
  links: TableTableContentLinks;
};

export type TableTableContentAssets = {
  __typename?: 'TableTableContentAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TableTableContentEntries = {
  __typename?: 'TableTableContentEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TableTableContentLinks = {
  __typename?: 'TableTableContentLinks';
  assets: TableTableContentAssets;
  entries: TableTableContentEntries;
  resources: TableTableContentResources;
};

export type TableTableContentResources = {
  __typename?: 'TableTableContentResources';
  block: Array<TableTableContentResourcesBlock>;
  hyperlink: Array<TableTableContentResourcesHyperlink>;
  inline: Array<TableTableContentResourcesInline>;
};

export type TableTableContentResourcesBlock = ResourceLink & {
  __typename?: 'TableTableContentResourcesBlock';
  sys: ResourceSys;
};

export type TableTableContentResourcesHyperlink = ResourceLink & {
  __typename?: 'TableTableContentResourcesHyperlink';
  sys: ResourceSys;
};

export type TableTableContentResourcesInline = ResourceLink & {
  __typename?: 'TableTableContentResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tabs) */
export type Tabs = Entry & _Node & {
  __typename?: 'Tabs';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  jumplinkTabs?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<TabsLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  tabRowVariant?: Maybe<Scalars['String']['output']>;
  tabsCollection?: Maybe<TabsTabsCollection>;
  tabsSize?: Maybe<Scalars['String']['output']>;
  withContentInnerGap?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tabs) */
export type TabsAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tabs) */
export type TabsBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tabs) */
export type TabsJumplinkTabsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tabs) */
export type TabsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tabs) */
export type TabsNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tabs) */
export type TabsTabRowVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tabs) */
export type TabsTabsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabsTabsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TabFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tabs) */
export type TabsTabsSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tabs) */
export type TabsWithContentInnerGapArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type TabsCollection = {
  __typename?: 'TabsCollection';
  items: Array<Maybe<Tabs>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TabsFilter = {
  AND?: InputMaybe<Array<InputMaybe<TabsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TabsFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  jumplinkTabs?: InputMaybe<Scalars['Boolean']['input']>;
  jumplinkTabs_exists?: InputMaybe<Scalars['Boolean']['input']>;
  jumplinkTabs_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tabRowVariant?: InputMaybe<Scalars['String']['input']>;
  tabRowVariant_contains?: InputMaybe<Scalars['String']['input']>;
  tabRowVariant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabRowVariant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tabRowVariant_not?: InputMaybe<Scalars['String']['input']>;
  tabRowVariant_not_contains?: InputMaybe<Scalars['String']['input']>;
  tabRowVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tabs?: InputMaybe<CfTabNestedFilter>;
  tabsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabsSize?: InputMaybe<Scalars['String']['input']>;
  tabsSize_contains?: InputMaybe<Scalars['String']['input']>;
  tabsSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabsSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tabsSize_not?: InputMaybe<Scalars['String']['input']>;
  tabsSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  tabsSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withContentInnerGap?: InputMaybe<Scalars['Boolean']['input']>;
  withContentInnerGap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  withContentInnerGap_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TabsLinkingCollections = {
  __typename?: 'TabsLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  googleMapTemplateCollection?: Maybe<GoogleMapTemplateCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type TabsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TabsLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabsLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TabsLinkingCollectionsGoogleMapTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabsLinkingCollectionsGoogleMapTemplateCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TabsLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabsLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type TabsLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type TabsLinkingCollectionsGoogleMapTemplateCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'desktopZoom_ASC'
  | 'desktopZoom_DESC'
  | 'facilityBadgeLabel_ASC'
  | 'facilityBadgeLabel_DESC'
  | 'facilityBasePath_ASC'
  | 'facilityBasePath_DESC'
  | 'facilityButtonLabel_ASC'
  | 'facilityButtonLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'holidayHoursMessageText_ASC'
  | 'holidayHoursMessageText_DESC'
  | 'listTabIsHorizontalScrolling_ASC'
  | 'listTabIsHorizontalScrolling_DESC'
  | 'locationScheduleButtonUrl_ASC'
  | 'locationScheduleButtonUrl_DESC'
  | 'mobileZoom_ASC'
  | 'mobileZoom_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'searchRadius_ASC'
  | 'searchRadius_DESC'
  | 'searchResultLimit_ASC'
  | 'searchResultLimit_DESC'
  | 'service_ASC'
  | 'service_DESC'
  | 'setAsOfficeButtonText_ASC'
  | 'setAsOfficeButtonText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useCumulativeDesign_ASC'
  | 'useCumulativeDesign_DESC'
  | 'useModernDesign_ASC'
  | 'useModernDesign_DESC'
  | 'useUsaCountryMap_ASC'
  | 'useUsaCountryMap_DESC';

export type TabsLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type TabsOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'jumplinkTabs_ASC'
  | 'jumplinkTabs_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tabRowVariant_ASC'
  | 'tabRowVariant_DESC'
  | 'tabsSize_ASC'
  | 'tabsSize_DESC'
  | 'withContentInnerGap_ASC'
  | 'withContentInnerGap_DESC';

export type TabsTabsCollection = {
  __typename?: 'TabsTabsCollection';
  items: Array<Maybe<Tab>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TabsTabsCollectionOrder =
  | 'jumplinkName_ASC'
  | 'jumplinkName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/**
 * Represents a taxonomy concept entity for finding and organizing content easily.
 *         Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-concepts
 */
export type TaxonomyConcept = {
  __typename?: 'TaxonomyConcept';
  id?: Maybe<Scalars['String']['output']>;
};

export type TemporaryUnavailableError = Error & {
  __typename?: 'TemporaryUnavailableError';
  message: Scalars['String']['output'];
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/termsAndConditions) */
export type TermsAndConditions = Entry & _Node & {
  __typename?: 'TermsAndConditions';
  _id: Scalars['ID']['output'];
  content?: Maybe<TermsAndConditionsContent>;
  contentfulMetadata: ContentfulMetadata;
  headlineText?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<TermsAndConditionsLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  showTcTextAs?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  tcLink?: Maybe<Scalars['String']['output']>;
  tcText?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/termsAndConditions) */
export type TermsAndConditionsContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/termsAndConditions) */
export type TermsAndConditionsHeadlineTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/termsAndConditions) */
export type TermsAndConditionsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/termsAndConditions) */
export type TermsAndConditionsNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/termsAndConditions) */
export type TermsAndConditionsShowTcTextAsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/termsAndConditions) */
export type TermsAndConditionsTcLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/termsAndConditions) */
export type TermsAndConditionsTcTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type TermsAndConditionsCollection = {
  __typename?: 'TermsAndConditionsCollection';
  items: Array<Maybe<TermsAndConditions>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TermsAndConditionsContent = {
  __typename?: 'TermsAndConditionsContent';
  json: Scalars['JSON']['output'];
  links: TermsAndConditionsContentLinks;
};

export type TermsAndConditionsContentAssets = {
  __typename?: 'TermsAndConditionsContentAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TermsAndConditionsContentEntries = {
  __typename?: 'TermsAndConditionsContentEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TermsAndConditionsContentLinks = {
  __typename?: 'TermsAndConditionsContentLinks';
  assets: TermsAndConditionsContentAssets;
  entries: TermsAndConditionsContentEntries;
  resources: TermsAndConditionsContentResources;
};

export type TermsAndConditionsContentResources = {
  __typename?: 'TermsAndConditionsContentResources';
  block: Array<TermsAndConditionsContentResourcesBlock>;
  hyperlink: Array<TermsAndConditionsContentResourcesHyperlink>;
  inline: Array<TermsAndConditionsContentResourcesInline>;
};

export type TermsAndConditionsContentResourcesBlock = ResourceLink & {
  __typename?: 'TermsAndConditionsContentResourcesBlock';
  sys: ResourceSys;
};

export type TermsAndConditionsContentResourcesHyperlink = ResourceLink & {
  __typename?: 'TermsAndConditionsContentResourcesHyperlink';
  sys: ResourceSys;
};

export type TermsAndConditionsContentResourcesInline = ResourceLink & {
  __typename?: 'TermsAndConditionsContentResourcesInline';
  sys: ResourceSys;
};

export type TermsAndConditionsFilter = {
  AND?: InputMaybe<Array<InputMaybe<TermsAndConditionsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TermsAndConditionsFilter>>>;
  content_contains?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headlineText?: InputMaybe<Scalars['String']['input']>;
  headlineText_contains?: InputMaybe<Scalars['String']['input']>;
  headlineText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headlineText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headlineText_not?: InputMaybe<Scalars['String']['input']>;
  headlineText_not_contains?: InputMaybe<Scalars['String']['input']>;
  headlineText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showTcTextAs?: InputMaybe<Scalars['Boolean']['input']>;
  showTcTextAs_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTcTextAs_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  tcLink?: InputMaybe<Scalars['String']['input']>;
  tcLink_contains?: InputMaybe<Scalars['String']['input']>;
  tcLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tcLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcLink_not?: InputMaybe<Scalars['String']['input']>;
  tcLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  tcLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcText?: InputMaybe<Scalars['String']['input']>;
  tcText_contains?: InputMaybe<Scalars['String']['input']>;
  tcText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tcText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcText_not?: InputMaybe<Scalars['String']['input']>;
  tcText_not_contains?: InputMaybe<Scalars['String']['input']>;
  tcText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TermsAndConditionsLinkingCollections = {
  __typename?: 'TermsAndConditionsLinkingCollections';
  cardCollection?: Maybe<CardCollection>;
  entryCollection?: Maybe<EntryCollection>;
  halfScreenCollection?: Maybe<HalfScreenCollection>;
  heroV2Collection?: Maybe<HeroV2Collection>;
  pageCollection?: Maybe<PageCollection>;
  serviceCollection?: Maybe<ServiceCollection>;
  serviceLineHeroCollection?: Maybe<ServiceLineHeroCollection>;
  singleMessageCollection?: Maybe<SingleMessageCollection>;
};


export type TermsAndConditionsLinkingCollectionsCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TermsAndConditionsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TermsAndConditionsLinkingCollectionsHalfScreenCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsHalfScreenCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TermsAndConditionsLinkingCollectionsHeroV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsHeroV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TermsAndConditionsLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TermsAndConditionsLinkingCollectionsServiceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsServiceCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TermsAndConditionsLinkingCollectionsServiceLineHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsServiceLineHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TermsAndConditionsLinkingCollectionsSingleMessageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsSingleMessageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type TermsAndConditionsLinkingCollectionsCardCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonIconPosition_ASC'
  | 'buttonIconPosition_DESC'
  | 'buttonIconSize_ASC'
  | 'buttonIconSize_DESC'
  | 'buttonIcon_ASC'
  | 'buttonIcon_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'buttonVariant_ASC'
  | 'buttonVariant_DESC'
  | 'cardIconAlignment_ASC'
  | 'cardIconAlignment_DESC'
  | 'cardIcon_ASC'
  | 'cardIcon_DESC'
  | 'cardTextAlignment_ASC'
  | 'cardTextAlignment_DESC'
  | 'eventType_ASC'
  | 'eventType_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRatio_ASC'
  | 'imageRatio_DESC'
  | 'imageUrl_ASC'
  | 'imageUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pdfDownloadTitle_ASC'
  | 'pdfDownloadTitle_DESC'
  | 'priority_ASC'
  | 'priority_DESC'
  | 'showBorder_ASC'
  | 'showBorder_DESC'
  | 'slot_ASC'
  | 'slot_DESC'
  | 'stepName_ASC'
  | 'stepName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tcText_ASC'
  | 'tcText_DESC'
  | 'tcUrl_ASC'
  | 'tcUrl_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type TermsAndConditionsLinkingCollectionsHalfScreenCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC';

export type TermsAndConditionsLinkingCollectionsHeroV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type TermsAndConditionsLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type TermsAndConditionsLinkingCollectionsServiceCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'direction_ASC'
  | 'direction_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageLayout_ASC'
  | 'imageLayout_DESC'
  | 'mediaType_ASC'
  | 'mediaType_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'youTubeVideoId_ASC'
  | 'youTubeVideoId_DESC';

export type TermsAndConditionsLinkingCollectionsServiceLineHeroCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type TermsAndConditionsLinkingCollectionsSingleMessageCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentFillVerticalSpace_ASC'
  | 'contentFillVerticalSpace_DESC'
  | 'displayTitleInline_ASC'
  | 'displayTitleInline_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isBannerImage_ASC'
  | 'isBannerImage_DESC'
  | 'isHeaderAboveSideImages_ASC'
  | 'isHeaderAboveSideImages_DESC'
  | 'isInlineLayout_ASC'
  | 'isInlineLayout_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showSubscriptionForm_ASC'
  | 'showSubscriptionForm_DESC'
  | 'subText_ASC'
  | 'subText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateHeight_ASC'
  | 'templateHeight_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleAlign_ASC'
  | 'titleAlign_DESC'
  | 'titleVariant_ASC'
  | 'titleVariant_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useRoundedCorners_ASC'
  | 'useRoundedCorners_DESC';

export type TermsAndConditionsOrder =
  | 'headlineText_ASC'
  | 'headlineText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showTcTextAs_ASC'
  | 'showTcTextAs_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tcLink_ASC'
  | 'tcLink_DESC'
  | 'tcText_ASC'
  | 'tcText_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/textBlockSeo) */
export type TextBlockSeo = Entry & _Node & {
  __typename?: 'TextBlockSeo';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  content?: Maybe<TextBlockSeoContent>;
  contentfulMetadata: ContentfulMetadata;
  disablePaddingOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  facilityFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  linkedFrom?: Maybe<TextBlockSeoLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/textBlockSeo) */
export type TextBlockSeoAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/textBlockSeo) */
export type TextBlockSeoBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/textBlockSeo) */
export type TextBlockSeoContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/textBlockSeo) */
export type TextBlockSeoDisablePaddingOnArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/textBlockSeo) */
export type TextBlockSeoFacilityFieldsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/textBlockSeo) */
export type TextBlockSeoLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/textBlockSeo) */
export type TextBlockSeoNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type TextBlockSeoCollection = {
  __typename?: 'TextBlockSeoCollection';
  items: Array<Maybe<TextBlockSeo>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TextBlockSeoContent = {
  __typename?: 'TextBlockSeoContent';
  json: Scalars['JSON']['output'];
  links: TextBlockSeoContentLinks;
};

export type TextBlockSeoContentAssets = {
  __typename?: 'TextBlockSeoContentAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TextBlockSeoContentEntries = {
  __typename?: 'TextBlockSeoContentEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TextBlockSeoContentLinks = {
  __typename?: 'TextBlockSeoContentLinks';
  assets: TextBlockSeoContentAssets;
  entries: TextBlockSeoContentEntries;
  resources: TextBlockSeoContentResources;
};

export type TextBlockSeoContentResources = {
  __typename?: 'TextBlockSeoContentResources';
  block: Array<TextBlockSeoContentResourcesBlock>;
  hyperlink: Array<TextBlockSeoContentResourcesHyperlink>;
  inline: Array<TextBlockSeoContentResourcesInline>;
};

export type TextBlockSeoContentResourcesBlock = ResourceLink & {
  __typename?: 'TextBlockSeoContentResourcesBlock';
  sys: ResourceSys;
};

export type TextBlockSeoContentResourcesHyperlink = ResourceLink & {
  __typename?: 'TextBlockSeoContentResourcesHyperlink';
  sys: ResourceSys;
};

export type TextBlockSeoContentResourcesInline = ResourceLink & {
  __typename?: 'TextBlockSeoContentResourcesInline';
  sys: ResourceSys;
};

export type TextBlockSeoFilter = {
  AND?: InputMaybe<Array<InputMaybe<TextBlockSeoFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TextBlockSeoFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content_contains?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilityFields_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityFields_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityFields_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityFields_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type TextBlockSeoLinkingCollections = {
  __typename?: 'TextBlockSeoLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type TextBlockSeoLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TextBlockSeoLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TextBlockSeoLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type TextBlockSeoLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type TextBlockSeoOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ThirdPartyInformationSharingAuthorization = {
  __typename?: 'ThirdPartyInformationSharingAuthorization';
  fullName?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Period>;
  relation?: Maybe<Scalars['String']['output']>;
};

export type ThirdPartyInformationSharingAuthorizationInput = {
  fullName: Scalars['NonEmptyString']['input'];
  period?: InputMaybe<PeriodInput>;
  relation: Scalars['NonEmptyString']['input'];
};

export type TimeslotAlreadyReservedError = Error & {
  __typename?: 'TimeslotAlreadyReservedError';
  message: Scalars['String']['output'];
};

export type TimeslotNotAvailableError = Error & {
  __typename?: 'TimeslotNotAvailableError';
  message: Scalars['String']['output'];
};

export type Token = {
  __typename?: 'Token';
  access_token?: Maybe<Scalars['String']['output']>;
};

export type UnderageGuarantorError = Error & {
  __typename?: 'UnderageGuarantorError';
  message: Scalars['String']['output'];
};

export type UnderagePatientForFacilityError = Error & {
  __typename?: 'UnderagePatientForFacilityError';
  facilityCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
  minimalPatientAge: Scalars['Int']['output'];
  patientDateOfBirth: Scalars['Date']['output'];
};

export type UnderagePatientForVisitReasonError = Error & {
  __typename?: 'UnderagePatientForVisitReasonError';
  message: Scalars['String']['output'];
  minimalAge?: Maybe<Scalars['Int']['output']>;
  standardTreatmentPlan?: Maybe<Scalars['String']['output']>;
};

export type UnscheduledVisit = {
  __typename?: 'UnscheduledVisit';
  appointmentClassCode?: Maybe<Scalars['String']['output']>;
  appointmentClassDescription?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  facility?: Maybe<Facility>;
  visitIdentifier: VisitIdentifier;
};

export type UnscheduledVisitList = {
  __typename?: 'UnscheduledVisitList';
  items: Array<UnscheduledVisit>;
};

export type UpdateMedicalHistoryError = InvalidQuestionnaireAnswerTypeError | NonExistingQuestionnaireQuestionError | PredefinedQuestionnaireAnswerError | QuestionnaireAnswerRequiredError | ShouldNotBeAnsweredQuestionnaireAnswerError;

export type UpdateMedicalHistoryInput = {
  answers: Array<AnsweredQuestionnaireQuestionInput>;
  signature: Scalars['NonEmptyString']['input'];
};

export type UpdateMedicalHistoryPayload = {
  __typename?: 'UpdateMedicalHistoryPayload';
  errors?: Maybe<Array<UpdateMedicalHistoryError>>;
  result?: Maybe<PatientMedicalHistory>;
};

export type UpdatePatientContactDetails = {
  __typename?: 'UpdatePatientContactDetails';
  errors?: Maybe<Array<UpdatePatientContactDetailsError>>;
  result?: Maybe<PatientContactDetails>;
};

export type UpdatePatientContactDetailsError = PatientAddressTooLongError | ZipCodeCityStateError;

export type UsStateCode =
  | 'AK'
  | 'AL'
  | 'AR'
  | 'AS'
  | 'AZ'
  | 'CA'
  | 'CO'
  | 'CT'
  | 'DC'
  | 'DE'
  | 'FL'
  | 'GA'
  | 'GU'
  | 'HI'
  | 'IA'
  | 'ID'
  | 'IL'
  | 'IN'
  | 'KS'
  | 'KY'
  | 'LA'
  | 'MA'
  | 'MD'
  | 'ME'
  | 'MI'
  | 'MN'
  | 'MO'
  | 'MP'
  | 'MS'
  | 'MT'
  | 'NC'
  | 'ND'
  | 'NE'
  | 'NH'
  | 'NJ'
  | 'NM'
  | 'NV'
  | 'NY'
  | 'OH'
  | 'OK'
  | 'OR'
  | 'PA'
  | 'PR'
  | 'RI'
  | 'SC'
  | 'SD'
  | 'TN'
  | 'TT'
  | 'TX'
  | 'UT'
  | 'VA'
  | 'VI'
  | 'VT'
  | 'WA'
  | 'WI'
  | 'WV'
  | 'WY';

/** User context */
export type User = {
  __typename?: 'User';
  /** Get Patient Account details */
  account?: Maybe<Account>;
  /** Completed visits ordered by date descending. */
  completedVisits?: Maybe<CompletedVisitsList>;
  currentMedicalHistory?: Maybe<PatientMedicalHistory>;
  guarantor?: Maybe<Guarantor>;
  patientAuthorizations?: Maybe<PatientAuthorizations>;
  patientInsurances?: Maybe<Array<PatientInsurance>>;
  patientType?: Maybe<PatientType>;
  personalInformation?: Maybe<PersonalInformation>;
  rescheduleSlots?: Maybe<NearbyFacilitiesScheduleSlots>;
  /** Scheduled visit by id. */
  scheduledVisit?: Maybe<ScheduledVisit>;
  /** Scheduled visits ordered by date ascending. */
  scheduledVisits?: Maybe<ScheduledVisitList>;
  unscheduledVisits?: Maybe<UnscheduledVisitList>;
};


/** User context */
export type UserCompletedVisitsArgs = {
  skip?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  take?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


/** User context */
export type UserRescheduleSlotsArgs = {
  filter: RescheduleSlotsFilterInput;
};


/** User context */
export type UserScheduledVisitArgs = {
  visitId: Scalars['String']['input'];
};


/** User context */
export type UserScheduledVisitsArgs = {
  skip?: Scalars['NonNegativeInt']['input'];
  take?: Scalars['NonNegativeInt']['input'];
};

/** Mutations for user */
export type UserMutation = {
  __typename?: 'UserMutation';
  addPatientAuthorization?: Maybe<AddPatientAuthorizationPayload>;
  cancelVisit?: Maybe<CancelVisitPayload>;
  confirmVisit?: Maybe<ConfirmPatientVisitPayload>;
  rescheduleVisit?: Maybe<RescheduleVisitPayload>;
  rescheduleVisitV2?: Maybe<RescheduleVisitPayloadV2>;
  updateMedicalHistory?: Maybe<UpdateMedicalHistoryPayload>;
  updatePatientContactDetails?: Maybe<UpdatePatientContactDetails>;
};


/** Mutations for user */
export type UserMutationAddPatientAuthorizationArgs = {
  input: AddPatientAuthorizationInput;
};


/** Mutations for user */
export type UserMutationCancelVisitArgs = {
  input: CancelVisitInput;
};


/** Mutations for user */
export type UserMutationConfirmVisitArgs = {
  input: ConfirmPatientVisitInput;
};


/** Mutations for user */
export type UserMutationRescheduleVisitArgs = {
  input: RescheduleVisitInput;
};


/** Mutations for user */
export type UserMutationRescheduleVisitV2Args = {
  input: RescheduleVisitV2Input;
};


/** Mutations for user */
export type UserMutationUpdateMedicalHistoryArgs = {
  input: UpdateMedicalHistoryInput;
};


/** Mutations for user */
export type UserMutationUpdatePatientContactDetailsArgs = {
  input: PatientContactDetailsInput;
};

/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type Video = Entry & _Node & {
  __typename?: 'Video';
  _id: Scalars['ID']['output'];
  adjustedWidth?: Maybe<Scalars['Int']['output']>;
  autoPlay?: Maybe<Scalars['Boolean']['output']>;
  contentfulMetadata: ContentfulMetadata;
  hlsVideoStreamLink?: Maybe<Scalars['String']['output']>;
  isLooped?: Maybe<Scalars['Boolean']['output']>;
  isMuted?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<VideoLinkingCollections>;
  media?: Maybe<Asset>;
  name?: Maybe<Scalars['String']['output']>;
  posterMedia?: Maybe<Asset>;
  posterUrl?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  useOriginalVideoSize?: Maybe<Scalars['Boolean']['output']>;
  videoSource?: Maybe<Scalars['String']['output']>;
  youtubeId?: Maybe<Scalars['String']['output']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoAdjustedWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoAutoPlayArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoHlsVideoStreamLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoIsLoopedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoIsMutedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoMediaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoPosterMediaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoPosterUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoUseOriginalVideoSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoVideoSourceArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoYoutubeIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

/** Content type used to display video using Video content type with separate video selection for Desktop and Mobile. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoAsset) */
export type VideoAsset = Entry & _Node & {
  __typename?: 'VideoAsset';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  desktopVideo?: Maybe<Video>;
  linkedFrom?: Maybe<VideoAssetLinkingCollections>;
  mobileVideo?: Maybe<Video>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


/** Content type used to display video using Video content type with separate video selection for Desktop and Mobile. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoAsset) */
export type VideoAssetDesktopVideoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoFilter>;
};


/** Content type used to display video using Video content type with separate video selection for Desktop and Mobile. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoAsset) */
export type VideoAssetLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Content type used to display video using Video content type with separate video selection for Desktop and Mobile. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoAsset) */
export type VideoAssetMobileVideoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoFilter>;
};


/** Content type used to display video using Video content type with separate video selection for Desktop and Mobile. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoAsset) */
export type VideoAssetNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Content type used to display video using Video content type with separate video selection for Desktop and Mobile. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoAsset) */
export type VideoAssetTagsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type VideoAssetCollection = {
  __typename?: 'VideoAssetCollection';
  items: Array<Maybe<VideoAsset>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VideoAssetFilter = {
  AND?: InputMaybe<Array<InputMaybe<VideoAssetFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<VideoAssetFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  desktopVideo?: InputMaybe<CfVideoNestedFilter>;
  desktopVideo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileVideo?: InputMaybe<CfVideoNestedFilter>;
  mobileVideo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoAssetLinkingCollections = {
  __typename?: 'VideoAssetLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  halfScreenCollection?: Maybe<HalfScreenCollection>;
  heroV2Collection?: Maybe<HeroV2Collection>;
  serviceLineHeroCollection?: Maybe<ServiceLineHeroCollection>;
  videoWithContentCollection?: Maybe<VideoWithContentCollection>;
};


export type VideoAssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoAssetLinkingCollectionsHalfScreenCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoAssetLinkingCollectionsHalfScreenCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoAssetLinkingCollectionsHeroV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoAssetLinkingCollectionsHeroV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoAssetLinkingCollectionsServiceLineHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoAssetLinkingCollectionsServiceLineHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoAssetLinkingCollectionsVideoWithContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoAssetLinkingCollectionsVideoWithContentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoAssetLinkingCollectionsHalfScreenCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC';

export type VideoAssetLinkingCollectionsHeroV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type VideoAssetLinkingCollectionsServiceLineHeroCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type VideoAssetLinkingCollectionsVideoWithContentCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoAssetOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** Used for displaying horizontal scrollable videos [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoCarousel) */
export type VideoCarousel = Entry & _Node & {
  __typename?: 'VideoCarousel';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  buttonsCollection?: Maybe<VideoCarouselButtonsCollection>;
  contentfulMetadata: ContentfulMetadata;
  desktopVideosAspectRatio?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<VideoCarouselLinkingCollections>;
  mobileVideosAspectRatio?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  topFields?: Maybe<ContentSection>;
  videosCollection?: Maybe<VideoCarouselVideosCollection>;
};


/** Used for displaying horizontal scrollable videos [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoCarousel) */
export type VideoCarouselAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for displaying horizontal scrollable videos [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoCarousel) */
export type VideoCarouselBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for displaying horizontal scrollable videos [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoCarousel) */
export type VideoCarouselButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoCarouselButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Used for displaying horizontal scrollable videos [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoCarousel) */
export type VideoCarouselDesktopVideosAspectRatioArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for displaying horizontal scrollable videos [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoCarousel) */
export type VideoCarouselLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Used for displaying horizontal scrollable videos [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoCarousel) */
export type VideoCarouselMobileVideosAspectRatioArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for displaying horizontal scrollable videos [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoCarousel) */
export type VideoCarouselNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Used for displaying horizontal scrollable videos [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoCarousel) */
export type VideoCarouselTopFieldsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentSectionFilter>;
};


/** Used for displaying horizontal scrollable videos [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoCarousel) */
export type VideoCarouselVideosCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoCarouselVideosCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VideoWithContentFilter>;
};

export type VideoCarouselButtonsCollection = {
  __typename?: 'VideoCarouselButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VideoCarouselButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type VideoCarouselCollection = {
  __typename?: 'VideoCarouselCollection';
  items: Array<Maybe<VideoCarousel>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VideoCarouselFilter = {
  AND?: InputMaybe<Array<InputMaybe<VideoCarouselFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<VideoCarouselFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  desktopVideosAspectRatio?: InputMaybe<Scalars['String']['input']>;
  desktopVideosAspectRatio_contains?: InputMaybe<Scalars['String']['input']>;
  desktopVideosAspectRatio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  desktopVideosAspectRatio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  desktopVideosAspectRatio_not?: InputMaybe<Scalars['String']['input']>;
  desktopVideosAspectRatio_not_contains?: InputMaybe<Scalars['String']['input']>;
  desktopVideosAspectRatio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileVideosAspectRatio?: InputMaybe<Scalars['String']['input']>;
  mobileVideosAspectRatio_contains?: InputMaybe<Scalars['String']['input']>;
  mobileVideosAspectRatio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileVideosAspectRatio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileVideosAspectRatio_not?: InputMaybe<Scalars['String']['input']>;
  mobileVideosAspectRatio_not_contains?: InputMaybe<Scalars['String']['input']>;
  mobileVideosAspectRatio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  topFields?: InputMaybe<CfContentSectionNestedFilter>;
  topFields_exists?: InputMaybe<Scalars['Boolean']['input']>;
  videos?: InputMaybe<CfVideoWithContentNestedFilter>;
  videosCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoCarouselLinkingCollections = {
  __typename?: 'VideoCarouselLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
  providerDetailsPageCollection?: Maybe<ProviderDetailsPageCollection>;
};


export type VideoCarouselLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoCarouselLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoCarouselLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoCarouselLinkingCollectionsProviderDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoCarouselLinkingCollectionsProviderDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoCarouselLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'overrideSchedulingButtonUrl_ASC'
  | 'overrideSchedulingButtonUrl_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type VideoCarouselLinkingCollectionsProviderDetailsPageCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoCarouselOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'desktopVideosAspectRatio_ASC'
  | 'desktopVideosAspectRatio_DESC'
  | 'mobileVideosAspectRatio_ASC'
  | 'mobileVideosAspectRatio_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoCarouselVideosCollection = {
  __typename?: 'VideoCarouselVideosCollection';
  items: Array<Maybe<VideoWithContent>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VideoCarouselVideosCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoCollection = {
  __typename?: 'VideoCollection';
  items: Array<Maybe<Video>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VideoFilter = {
  AND?: InputMaybe<Array<InputMaybe<VideoFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<VideoFilter>>>;
  adjustedWidth?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  adjustedWidth_gt?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_gte?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  adjustedWidth_lt?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_lte?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_not?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  autoPlay?: InputMaybe<Scalars['Boolean']['input']>;
  autoPlay_exists?: InputMaybe<Scalars['Boolean']['input']>;
  autoPlay_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  hlsVideoStreamLink?: InputMaybe<Scalars['String']['input']>;
  hlsVideoStreamLink_contains?: InputMaybe<Scalars['String']['input']>;
  hlsVideoStreamLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hlsVideoStreamLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hlsVideoStreamLink_not?: InputMaybe<Scalars['String']['input']>;
  hlsVideoStreamLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  hlsVideoStreamLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isLooped?: InputMaybe<Scalars['Boolean']['input']>;
  isLooped_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLooped_not?: InputMaybe<Scalars['Boolean']['input']>;
  isMuted?: InputMaybe<Scalars['Boolean']['input']>;
  isMuted_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isMuted_not?: InputMaybe<Scalars['Boolean']['input']>;
  media_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  posterMedia_exists?: InputMaybe<Scalars['Boolean']['input']>;
  posterUrl?: InputMaybe<Scalars['String']['input']>;
  posterUrl_contains?: InputMaybe<Scalars['String']['input']>;
  posterUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  posterUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  posterUrl_not?: InputMaybe<Scalars['String']['input']>;
  posterUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  posterUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  useOriginalVideoSize?: InputMaybe<Scalars['Boolean']['input']>;
  useOriginalVideoSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useOriginalVideoSize_not?: InputMaybe<Scalars['Boolean']['input']>;
  videoSource?: InputMaybe<Scalars['String']['input']>;
  videoSource_contains?: InputMaybe<Scalars['String']['input']>;
  videoSource_exists?: InputMaybe<Scalars['Boolean']['input']>;
  videoSource_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoSource_not?: InputMaybe<Scalars['String']['input']>;
  videoSource_not_contains?: InputMaybe<Scalars['String']['input']>;
  videoSource_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youtubeId?: InputMaybe<Scalars['String']['input']>;
  youtubeId_contains?: InputMaybe<Scalars['String']['input']>;
  youtubeId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  youtubeId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youtubeId_not?: InputMaybe<Scalars['String']['input']>;
  youtubeId_not_contains?: InputMaybe<Scalars['String']['input']>;
  youtubeId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type VideoLinkingCollections = {
  __typename?: 'VideoLinkingCollections';
  birdEyeReviewsCollection?: Maybe<BirdEyeReviewsCollection>;
  entryCollection?: Maybe<EntryCollection>;
  halfScreenCollection?: Maybe<HalfScreenCollection>;
  mediaSliderCollection?: Maybe<MediaSliderCollection>;
  smallScreenContentCollection?: Maybe<SmallScreenContentCollection>;
  videoAssetCollection?: Maybe<VideoAssetCollection>;
};


export type VideoLinkingCollectionsBirdEyeReviewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsBirdEyeReviewsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoLinkingCollectionsHalfScreenCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsHalfScreenCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoLinkingCollectionsMediaSliderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsMediaSliderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoLinkingCollectionsSmallScreenContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsSmallScreenContentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoLinkingCollectionsVideoAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsVideoAssetCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoLinkingCollectionsBirdEyeReviewsCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'filteredReviewsMinRating_ASC'
  | 'filteredReviewsMinRating_DESC'
  | 'filteredReviewsTitle_ASC'
  | 'filteredReviewsTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type VideoLinkingCollectionsHalfScreenCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC';

export type VideoLinkingCollectionsMediaSliderCollectionOrder =
  | 'aspectRatio_ASC'
  | 'aspectRatio_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoLinkingCollectionsSmallScreenContentCollectionOrder =
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowSmallScreen_ASC'
  | 'eyebrowSmallScreen_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoLinkingCollectionsVideoAssetCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoOrder =
  | 'adjustedWidth_ASC'
  | 'adjustedWidth_DESC'
  | 'autoPlay_ASC'
  | 'autoPlay_DESC'
  | 'hlsVideoStreamLink_ASC'
  | 'hlsVideoStreamLink_DESC'
  | 'isLooped_ASC'
  | 'isLooped_DESC'
  | 'isMuted_ASC'
  | 'isMuted_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'posterUrl_ASC'
  | 'posterUrl_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useOriginalVideoSize_ASC'
  | 'useOriginalVideoSize_DESC'
  | 'videoSource_ASC'
  | 'videoSource_DESC'
  | 'youtubeId_ASC'
  | 'youtubeId_DESC';

/** Use this to render video with some eyebrow, title and description like a card [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoWithContent) */
export type VideoWithContent = Entry & _Node & {
  __typename?: 'VideoWithContent';
  _id: Scalars['ID']['output'];
  buttonsCollection?: Maybe<VideoWithContentButtonsCollection>;
  content?: Maybe<ContentSection>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<VideoWithContentLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  video?: Maybe<VideoAsset>;
};


/** Use this to render video with some eyebrow, title and description like a card [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoWithContent) */
export type VideoWithContentButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoWithContentButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Use this to render video with some eyebrow, title and description like a card [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoWithContent) */
export type VideoWithContentContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentSectionFilter>;
};


/** Use this to render video with some eyebrow, title and description like a card [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoWithContent) */
export type VideoWithContentLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Use this to render video with some eyebrow, title and description like a card [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoWithContent) */
export type VideoWithContentNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


/** Use this to render video with some eyebrow, title and description like a card [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoWithContent) */
export type VideoWithContentVideoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoAssetFilter>;
};

export type VideoWithContentButtonsCollection = {
  __typename?: 'VideoWithContentButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VideoWithContentButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type VideoWithContentCollection = {
  __typename?: 'VideoWithContentCollection';
  items: Array<Maybe<VideoWithContent>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VideoWithContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<VideoWithContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<VideoWithContentFilter>>>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<CfContentSectionNestedFilter>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  video?: InputMaybe<CfVideoAssetNestedFilter>;
  video_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoWithContentLinkingCollections = {
  __typename?: 'VideoWithContentLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  videoCarouselCollection?: Maybe<VideoCarouselCollection>;
};


export type VideoWithContentLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type VideoWithContentLinkingCollectionsVideoCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoWithContentLinkingCollectionsVideoCarouselCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoWithContentLinkingCollectionsVideoCarouselCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'desktopVideosAspectRatio_ASC'
  | 'desktopVideosAspectRatio_DESC'
  | 'mobileVideosAspectRatio_ASC'
  | 'mobileVideosAspectRatio_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoWithContentOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VisitIdentifier = {
  __typename?: 'VisitIdentifier';
  patientId: Scalars['Long']['output'];
  patientTreatmentPlanId: Scalars['Long']['output'];
  visitNumber: Scalars['Decimal']['output'];
  visitUid: Scalars['String']['output'];
};

export type VisitNotCancelableError = Error & {
  __typename?: 'VisitNotCancelableError';
  message: Scalars['String']['output'];
};

export type VisitSchedulability = {
  __typename?: 'VisitSchedulability';
  canBeCanceled: Scalars['Boolean']['output'];
  canBeConfirmed: Scalars['Boolean']['output'];
  canBeRescheduled: Scalars['Boolean']['output'];
};

export type WorkingHours = {
  __typename?: 'WorkingHours';
  day: Scalars['String']['output'];
  intervals: Array<Intervals>;
};

export type YesNoAnswer = HasAnswerFormat & HasPredefinedAnswer & {
  __typename?: 'YesNoAnswer';
  answers?: Maybe<Array<PredefinedAnswer>>;
  format?: Maybe<QuestionnaireAnswerFormat>;
};

export type ZipCodeCityStateError = Error & {
  __typename?: 'ZipCodeCityStateError';
  message: Scalars['String']['output'];
};

export type _Node = {
  _id: Scalars['ID']['output'];
};

export type CfAccordionsNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfAccordionsNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfAccordionsNestedFilter>>>;
  accordionsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  accordionsContentSectionsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  accordionsHeading?: InputMaybe<Scalars['String']['input']>;
  accordionsHeading_contains?: InputMaybe<Scalars['String']['input']>;
  accordionsHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  accordionsHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  accordionsHeading_not?: InputMaybe<Scalars['String']['input']>;
  accordionsHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  accordionsHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonCollectionAlignment?: InputMaybe<Scalars['String']['input']>;
  buttonCollectionAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  buttonCollectionAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonCollectionAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonCollectionAlignment_not?: InputMaybe<Scalars['String']['input']>;
  buttonCollectionAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonCollectionAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionAlignment?: InputMaybe<Scalars['String']['input']>;
  descriptionAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionAlignment_not?: InputMaybe<Scalars['String']['input']>;
  descriptionAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionRichText_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionRichText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionRichText_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  expandIconPosition?: InputMaybe<Scalars['String']['input']>;
  expandIconPosition_contains?: InputMaybe<Scalars['String']['input']>;
  expandIconPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  expandIconPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  expandIconPosition_not?: InputMaybe<Scalars['String']['input']>;
  expandIconPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  expandIconPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  expandIconType?: InputMaybe<Scalars['String']['input']>;
  expandIconType_contains?: InputMaybe<Scalars['String']['input']>;
  expandIconType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  expandIconType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  expandIconType_not?: InputMaybe<Scalars['String']['input']>;
  expandIconType_not_contains?: InputMaybe<Scalars['String']['input']>;
  expandIconType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  imagePositionRight?: InputMaybe<Scalars['Boolean']['input']>;
  imagePositionRight_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imagePositionRight_not?: InputMaybe<Scalars['Boolean']['input']>;
  imageRoundedCorner?: InputMaybe<Scalars['String']['input']>;
  imageRoundedCorner_contains?: InputMaybe<Scalars['String']['input']>;
  imageRoundedCorner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageRoundedCorner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageRoundedCorner_not?: InputMaybe<Scalars['String']['input']>;
  imageRoundedCorner_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageRoundedCorner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roundedCornersSize?: InputMaybe<Scalars['String']['input']>;
  roundedCornersSize_contains?: InputMaybe<Scalars['String']['input']>;
  roundedCornersSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  roundedCornersSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roundedCornersSize_not?: InputMaybe<Scalars['String']['input']>;
  roundedCornersSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  roundedCornersSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleAlignment?: InputMaybe<Scalars['String']['input']>;
  titleAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  titleAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleAlignment_not?: InputMaybe<Scalars['String']['input']>;
  titleAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColor?: InputMaybe<Scalars['String']['input']>;
  titleColor_contains?: InputMaybe<Scalars['String']['input']>;
  titleColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColor_not?: InputMaybe<Scalars['String']['input']>;
  titleColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withInnerGap?: InputMaybe<Scalars['Boolean']['input']>;
  withInnerGap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  withInnerGap_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfAdFooterNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfAdFooterNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfAdFooterNestedFilter>>>;
  about_contains?: InputMaybe<Scalars['String']['input']>;
  about_exists?: InputMaybe<Scalars['Boolean']['input']>;
  about_not_contains?: InputMaybe<Scalars['String']['input']>;
  bookNowButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName?: InputMaybe<Scalars['String']['input']>;
  componentName_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentName_not?: InputMaybe<Scalars['String']['input']>;
  componentName_not_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  contactNumber_contains?: InputMaybe<Scalars['String']['input']>;
  contactNumber_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contactNumber_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactNumber_not?: InputMaybe<Scalars['String']['input']>;
  contactNumber_not_contains?: InputMaybe<Scalars['String']['input']>;
  contactNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copyright?: InputMaybe<Scalars['String']['input']>;
  copyright_contains?: InputMaybe<Scalars['String']['input']>;
  copyright_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copyright_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  copyright_not?: InputMaybe<Scalars['String']['input']>;
  copyright_not_contains?: InputMaybe<Scalars['String']['input']>;
  copyright_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disclaimer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  exclusivelyAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  footerPolicyGroupCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLightFooter?: InputMaybe<Scalars['Boolean']['input']>;
  isLightFooter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLightFooter_not?: InputMaybe<Scalars['Boolean']['input']>;
  logo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  navigationGroupsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialNetworksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stickyFooterButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stickyFooterButtonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stickyFooterScheduleButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  useDesktopStickyFooter?: InputMaybe<Scalars['Boolean']['input']>;
  useDesktopStickyFooter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useDesktopStickyFooter_not?: InputMaybe<Scalars['Boolean']['input']>;
  useMobileStickyFooter?: InputMaybe<Scalars['Boolean']['input']>;
  useMobileStickyFooter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useMobileStickyFooter_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfAgendaModalNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfAgendaModalNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfAgendaModalNestedFilter>>>;
  bodyText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headlineHeading?: InputMaybe<Scalars['String']['input']>;
  headlineHeading_contains?: InputMaybe<Scalars['String']['input']>;
  headlineHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headlineHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headlineHeading_not?: InputMaybe<Scalars['String']['input']>;
  headlineHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  headlineHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headlineText?: InputMaybe<Scalars['String']['input']>;
  headlineText_contains?: InputMaybe<Scalars['String']['input']>;
  headlineText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headlineText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headlineText_not?: InputMaybe<Scalars['String']['input']>;
  headlineText_not_contains?: InputMaybe<Scalars['String']['input']>;
  headlineText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modalName?: InputMaybe<Scalars['String']['input']>;
  modalName_contains?: InputMaybe<Scalars['String']['input']>;
  modalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modalName_not?: InputMaybe<Scalars['String']['input']>;
  modalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  modalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfAnalyticsContextNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfAnalyticsContextNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfAnalyticsContextNestedFilter>>>;
  appointmentSelectedFacilityId?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityId_contains?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentSelectedFacilityId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appointmentSelectedFacilityId_not?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityId_not_contains?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appointmentSelectedFacilityName?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityName_contains?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentSelectedFacilityName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appointmentSelectedFacilityName_not?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityName_not_contains?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  brand_contains?: InputMaybe<Scalars['String']['input']>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brand_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brand_not?: InputMaybe<Scalars['String']['input']>;
  brand_not_contains?: InputMaybe<Scalars['String']['input']>;
  brand_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickName?: InputMaybe<Scalars['String']['input']>;
  clickName_contains?: InputMaybe<Scalars['String']['input']>;
  clickName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  clickName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickName_not?: InputMaybe<Scalars['String']['input']>;
  clickName_not_contains?: InputMaybe<Scalars['String']['input']>;
  clickName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickPosition?: InputMaybe<Scalars['String']['input']>;
  clickPosition_contains?: InputMaybe<Scalars['String']['input']>;
  clickPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  clickPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickPosition_not?: InputMaybe<Scalars['String']['input']>;
  clickPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  clickPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickType?: InputMaybe<Scalars['String']['input']>;
  clickType_contains?: InputMaybe<Scalars['String']['input']>;
  clickType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  clickType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickType_not?: InputMaybe<Scalars['String']['input']>;
  clickType_not_contains?: InputMaybe<Scalars['String']['input']>;
  clickType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentName?: InputMaybe<Scalars['String']['input']>;
  componentName_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentName_not?: InputMaybe<Scalars['String']['input']>;
  componentName_not_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  errorDetails?: InputMaybe<Scalars['String']['input']>;
  errorDetails_contains?: InputMaybe<Scalars['String']['input']>;
  errorDetails_exists?: InputMaybe<Scalars['Boolean']['input']>;
  errorDetails_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorDetails_not?: InputMaybe<Scalars['String']['input']>;
  errorDetails_not_contains?: InputMaybe<Scalars['String']['input']>;
  errorDetails_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorStatus?: InputMaybe<Scalars['String']['input']>;
  errorStatus_contains?: InputMaybe<Scalars['String']['input']>;
  errorStatus_exists?: InputMaybe<Scalars['Boolean']['input']>;
  errorStatus_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorStatus_not?: InputMaybe<Scalars['String']['input']>;
  errorStatus_not_contains?: InputMaybe<Scalars['String']['input']>;
  errorStatus_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorType?: InputMaybe<Scalars['String']['input']>;
  errorType_contains?: InputMaybe<Scalars['String']['input']>;
  errorType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  errorType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorType_not?: InputMaybe<Scalars['String']['input']>;
  errorType_not_contains?: InputMaybe<Scalars['String']['input']>;
  errorType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  event?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  eventName_contains?: InputMaybe<Scalars['String']['input']>;
  eventName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eventName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventName_not?: InputMaybe<Scalars['String']['input']>;
  eventName_not_contains?: InputMaybe<Scalars['String']['input']>;
  eventName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  event_contains?: InputMaybe<Scalars['String']['input']>;
  event_exists?: InputMaybe<Scalars['Boolean']['input']>;
  event_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  event_not?: InputMaybe<Scalars['String']['input']>;
  event_not_contains?: InputMaybe<Scalars['String']['input']>;
  event_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  linkText_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText_not?: InputMaybe<Scalars['String']['input']>;
  linkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  linkUrl_contains?: InputMaybe<Scalars['String']['input']>;
  linkUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkUrl_not?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationType?: InputMaybe<Scalars['String']['input']>;
  navigationType_contains?: InputMaybe<Scalars['String']['input']>;
  navigationType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  navigationType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationType_not?: InputMaybe<Scalars['String']['input']>;
  navigationType_not_contains?: InputMaybe<Scalars['String']['input']>;
  navigationType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageName?: InputMaybe<Scalars['String']['input']>;
  pageName_contains?: InputMaybe<Scalars['String']['input']>;
  pageName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageName_not?: InputMaybe<Scalars['String']['input']>;
  pageName_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageUrl?: InputMaybe<Scalars['String']['input']>;
  pageUrl_contains?: InputMaybe<Scalars['String']['input']>;
  pageUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageUrl_not?: InputMaybe<Scalars['String']['input']>;
  pageUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteSection?: InputMaybe<Scalars['String']['input']>;
  siteSection_contains?: InputMaybe<Scalars['String']['input']>;
  siteSection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  siteSection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteSection_not?: InputMaybe<Scalars['String']['input']>;
  siteSection_not_contains?: InputMaybe<Scalars['String']['input']>;
  siteSection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialMediaName?: InputMaybe<Scalars['String']['input']>;
  socialMediaName_contains?: InputMaybe<Scalars['String']['input']>;
  socialMediaName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialMediaName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialMediaName_not?: InputMaybe<Scalars['String']['input']>;
  socialMediaName_not_contains?: InputMaybe<Scalars['String']['input']>;
  socialMediaName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  virtualPageTitle?: InputMaybe<Scalars['String']['input']>;
  virtualPageTitle_contains?: InputMaybe<Scalars['String']['input']>;
  virtualPageTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  virtualPageTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  virtualPageTitle_not?: InputMaybe<Scalars['String']['input']>;
  virtualPageTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  virtualPageTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  virtualPageUrl?: InputMaybe<Scalars['String']['input']>;
  virtualPageUrl_contains?: InputMaybe<Scalars['String']['input']>;
  virtualPageUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  virtualPageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  virtualPageUrl_not?: InputMaybe<Scalars['String']['input']>;
  virtualPageUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  virtualPageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfBadgeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBadgeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBadgeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfBannerNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBannerNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBannerNestedFilter>>>;
  alertMessagesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  mobileAlertMessagesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfBlogAuthorNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBlogAuthorNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBlogAuthorNestedFilter>>>;
  authorBioSummary_contains?: InputMaybe<Scalars['String']['input']>;
  authorBioSummary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  authorBioSummary_not_contains?: InputMaybe<Scalars['String']['input']>;
  bioSummary?: InputMaybe<Scalars['String']['input']>;
  bioSummary_contains?: InputMaybe<Scalars['String']['input']>;
  bioSummary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bioSummary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bioSummary_not?: InputMaybe<Scalars['String']['input']>;
  bioSummary_not_contains?: InputMaybe<Scalars['String']['input']>;
  bioSummary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfBlogCategoryNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBlogCategoryNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBlogCategoryNestedFilter>>>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfBlogDetailsPageNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBlogDetailsPageNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBlogDetailsPageNestedFilter>>>;
  additionalContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  author_exists?: InputMaybe<Scalars['Boolean']['input']>;
  blogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical?: InputMaybe<Scalars['String']['input']>;
  canonical_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonical_not?: InputMaybe<Scalars['String']['input']>;
  canonical_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  date_exists?: InputMaybe<Scalars['Boolean']['input']>;
  date_gt?: InputMaybe<Scalars['DateTime']['input']>;
  date_gte?: InputMaybe<Scalars['DateTime']['input']>;
  date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt?: InputMaybe<Scalars['DateTime']['input']>;
  date_lte?: InputMaybe<Scalars['DateTime']['input']>;
  date_not?: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  disableHeaderBottomAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  heroBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  heroBackgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  heroBackgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroBackgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroBackgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  heroBackgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  heroBackgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroButtonCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroContentTitle_contains?: InputMaybe<Scalars['String']['input']>;
  heroContentTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroContentTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_not?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageDesignType?: InputMaybe<Scalars['String']['input']>;
  pageDesignType_contains?: InputMaybe<Scalars['String']['input']>;
  pageDesignType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageDesignType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageDesignType_not?: InputMaybe<Scalars['String']['input']>;
  pageDesignType_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageDesignType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path?: InputMaybe<Scalars['String']['input']>;
  path_contains?: InputMaybe<Scalars['String']['input']>;
  path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_not?: InputMaybe<Scalars['String']['input']>;
  path_not_contains?: InputMaybe<Scalars['String']['input']>;
  path_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedBlogsContentSection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  reviewer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subCategory_exists?: InputMaybe<Scalars['Boolean']['input']>;
  summary_contains?: InputMaybe<Scalars['String']['input']>;
  summary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  summary_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
  theme_contains?: InputMaybe<Scalars['String']['input']>;
  theme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  theme_not?: InputMaybe<Scalars['String']['input']>;
  theme_not_contains?: InputMaybe<Scalars['String']['input']>;
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeToRead?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_exists?: InputMaybe<Scalars['Boolean']['input']>;
  timeToRead_gt?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_gte?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeToRead_lt?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_lte?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_not?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfBlogListNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBlogListNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBlogListNestedFilter>>>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLabel_not?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardDesignType?: InputMaybe<Scalars['String']['input']>;
  cardDesignType_contains?: InputMaybe<Scalars['String']['input']>;
  cardDesignType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardDesignType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardDesignType_not?: InputMaybe<Scalars['String']['input']>;
  cardDesignType_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardDesignType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  countAcrossDesktop?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  countAcrossDesktop_gt?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_gte?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  countAcrossDesktop_lt?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_lte?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_not?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  countAcrossMobile?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  countAcrossMobile_gt?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_gte?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  countAcrossMobile_lt?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_lte?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_not?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  displayType?: InputMaybe<Scalars['String']['input']>;
  displayType_contains?: InputMaybe<Scalars['String']['input']>;
  displayType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayType_not?: InputMaybe<Scalars['String']['input']>;
  displayType_not_contains?: InputMaybe<Scalars['String']['input']>;
  displayType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featuredBlogsListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasPagination?: InputMaybe<Scalars['Boolean']['input']>;
  hasPagination_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasPagination_not?: InputMaybe<Scalars['Boolean']['input']>;
  heroBlogsListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  loadMoreButtonLabel?: InputMaybe<Scalars['String']['input']>;
  loadMoreButtonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  loadMoreButtonLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  loadMoreButtonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  loadMoreButtonLabel_not?: InputMaybe<Scalars['String']['input']>;
  loadMoreButtonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  loadMoreButtonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subCategory_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  tagsFilter_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagsFilter_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagsFilter_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagsFilter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfBlogSubCategoryNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBlogSubCategoryNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBlogSubCategoryNestedFilter>>>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfBrandNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBrandNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBrandNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfButtonNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfButtonNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfButtonNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonLink_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLink_not?: InputMaybe<Scalars['String']['input']>;
  buttonLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconPosition?: InputMaybe<Scalars['String']['input']>;
  iconPosition_contains?: InputMaybe<Scalars['String']['input']>;
  iconPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconPosition_not?: InputMaybe<Scalars['String']['input']>;
  iconPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconSize?: InputMaybe<Scalars['String']['input']>;
  iconSize_contains?: InputMaybe<Scalars['String']['input']>;
  iconSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconSize_not?: InputMaybe<Scalars['String']['input']>;
  iconSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationDetails_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quizDetails_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quizSelector?: InputMaybe<Scalars['String']['input']>;
  quizSelector_contains?: InputMaybe<Scalars['String']['input']>;
  quizSelector_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quizSelector_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quizSelector_not?: InputMaybe<Scalars['String']['input']>;
  quizSelector_not_contains?: InputMaybe<Scalars['String']['input']>;
  quizSelector_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size?: InputMaybe<Scalars['String']['input']>;
  size_contains?: InputMaybe<Scalars['String']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size_not?: InputMaybe<Scalars['String']['input']>;
  size_not_contains?: InputMaybe<Scalars['String']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCardNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCardNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCardNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIcon?: InputMaybe<Scalars['String']['input']>;
  buttonIconPosition?: InputMaybe<Scalars['String']['input']>;
  buttonIconPosition_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIconPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonIconPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIconPosition_not?: InputMaybe<Scalars['String']['input']>;
  buttonIconPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIconPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIconSize?: InputMaybe<Scalars['String']['input']>;
  buttonIconSize_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIconSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonIconSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIconSize_not?: InputMaybe<Scalars['String']['input']>;
  buttonIconSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIconSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIcon_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonIcon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIcon_not?: InputMaybe<Scalars['String']['input']>;
  buttonIcon_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIcon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonSize?: InputMaybe<Scalars['String']['input']>;
  buttonSize_contains?: InputMaybe<Scalars['String']['input']>;
  buttonSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonSize_not?: InputMaybe<Scalars['String']['input']>;
  buttonSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonVariant?: InputMaybe<Scalars['String']['input']>;
  buttonVariant_contains?: InputMaybe<Scalars['String']['input']>;
  buttonVariant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonVariant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonVariant_not?: InputMaybe<Scalars['String']['input']>;
  buttonVariant_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardIcon?: InputMaybe<Scalars['String']['input']>;
  cardIconAlignment?: InputMaybe<Scalars['String']['input']>;
  cardIconAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  cardIconAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardIconAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardIconAlignment_not?: InputMaybe<Scalars['String']['input']>;
  cardIconAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardIconAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardIcon_contains?: InputMaybe<Scalars['String']['input']>;
  cardIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardIcon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardIcon_not?: InputMaybe<Scalars['String']['input']>;
  cardIcon_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardIcon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardTextAlignment?: InputMaybe<Scalars['String']['input']>;
  cardTextAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  cardTextAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardTextAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardTextAlignment_not?: InputMaybe<Scalars['String']['input']>;
  cardTextAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardTextAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  eventType_contains?: InputMaybe<Scalars['String']['input']>;
  eventType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eventType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventType_not?: InputMaybe<Scalars['String']['input']>;
  eventType_not_contains?: InputMaybe<Scalars['String']['input']>;
  eventType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  focalPointImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageRatio?: InputMaybe<Scalars['String']['input']>;
  imageRatio_contains?: InputMaybe<Scalars['String']['input']>;
  imageRatio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageRatio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageRatio_not?: InputMaybe<Scalars['String']['input']>;
  imageRatio_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageRatio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  imageUrl_contains?: InputMaybe<Scalars['String']['input']>;
  imageUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageUrl_not?: InputMaybe<Scalars['String']['input']>;
  imageUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdfDownloadTitle?: InputMaybe<Scalars['String']['input']>;
  pdfDownloadTitle_contains?: InputMaybe<Scalars['String']['input']>;
  pdfDownloadTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pdfDownloadTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdfDownloadTitle_not?: InputMaybe<Scalars['String']['input']>;
  pdfDownloadTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  pdfDownloadTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdfFileLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  priority_exists?: InputMaybe<Scalars['Boolean']['input']>;
  priority_gt?: InputMaybe<Scalars['Int']['input']>;
  priority_gte?: InputMaybe<Scalars['Int']['input']>;
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  priority_lt?: InputMaybe<Scalars['Int']['input']>;
  priority_lte?: InputMaybe<Scalars['Int']['input']>;
  priority_not?: InputMaybe<Scalars['Int']['input']>;
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  richTextDescription_contains?: InputMaybe<Scalars['String']['input']>;
  richTextDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  richTextDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  showBorder?: InputMaybe<Scalars['Boolean']['input']>;
  showBorder_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showBorder_not?: InputMaybe<Scalars['Boolean']['input']>;
  slot?: InputMaybe<Scalars['Int']['input']>;
  slot_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slot_gt?: InputMaybe<Scalars['Int']['input']>;
  slot_gte?: InputMaybe<Scalars['Int']['input']>;
  slot_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  slot_lt?: InputMaybe<Scalars['Int']['input']>;
  slot_lte?: InputMaybe<Scalars['Int']['input']>;
  slot_not?: InputMaybe<Scalars['Int']['input']>;
  slot_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  stepName?: InputMaybe<Scalars['String']['input']>;
  stepName_contains?: InputMaybe<Scalars['String']['input']>;
  stepName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stepName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepName_not?: InputMaybe<Scalars['String']['input']>;
  stepName_not_contains?: InputMaybe<Scalars['String']['input']>;
  stepName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tcText?: InputMaybe<Scalars['String']['input']>;
  tcText_contains?: InputMaybe<Scalars['String']['input']>;
  tcText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tcText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcText_not?: InputMaybe<Scalars['String']['input']>;
  tcText_not_contains?: InputMaybe<Scalars['String']['input']>;
  tcText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcUrl?: InputMaybe<Scalars['String']['input']>;
  tcUrl_contains?: InputMaybe<Scalars['String']['input']>;
  tcUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tcUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcUrl_not?: InputMaybe<Scalars['String']['input']>;
  tcUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  tcUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tc_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCategoryNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCategoryNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCategoryNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized_not?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  link_contains?: InputMaybe<Scalars['String']['input']>;
  link_exists?: InputMaybe<Scalars['Boolean']['input']>;
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  link_not?: InputMaybe<Scalars['String']['input']>;
  link_not_contains?: InputMaybe<Scalars['String']['input']>;
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCategoryPickerNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCategoryPickerNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCategoryPickerNestedFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  categoriesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrowHeading?: InputMaybe<Scalars['String']['input']>;
  eyebrowHeading_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowHeading_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileThreshold?: InputMaybe<Scalars['Int']['input']>;
  mobileThreshold_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileThreshold_gt?: InputMaybe<Scalars['Int']['input']>;
  mobileThreshold_gte?: InputMaybe<Scalars['Int']['input']>;
  mobileThreshold_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  mobileThreshold_lt?: InputMaybe<Scalars['Int']['input']>;
  mobileThreshold_lte?: InputMaybe<Scalars['Int']['input']>;
  mobileThreshold_not?: InputMaybe<Scalars['Int']['input']>;
  mobileThreshold_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  setTwoRows?: InputMaybe<Scalars['Boolean']['input']>;
  setTwoRows_exists?: InputMaybe<Scalars['Boolean']['input']>;
  setTwoRows_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHeading?: InputMaybe<Scalars['String']['input']>;
  titleHeading_contains?: InputMaybe<Scalars['String']['input']>;
  titleHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHeading_not?: InputMaybe<Scalars['String']['input']>;
  titleHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transparentCategories?: InputMaybe<Scalars['Boolean']['input']>;
  transparentCategories_exists?: InputMaybe<Scalars['Boolean']['input']>;
  transparentCategories_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfContentSectionNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfContentSectionNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfContentSectionNestedFilter>>>;
  alignment?: InputMaybe<Scalars['String']['input']>;
  alignment_contains?: InputMaybe<Scalars['String']['input']>;
  alignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  alignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alignment_not?: InputMaybe<Scalars['String']['input']>;
  alignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  alignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowHtag_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleIcon?: InputMaybe<Scalars['String']['input']>;
  titleIcon_contains?: InputMaybe<Scalars['String']['input']>;
  titleIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleIcon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleIcon_not?: InputMaybe<Scalars['String']['input']>;
  titleIcon_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleIcon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfContentTileNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfContentTileNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfContentTileNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  externalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  externalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalUrl_not?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalPage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfContentTypeRichTextNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfContentTypeRichTextNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfContentTypeRichTextNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign_not?: InputMaybe<Scalars['Boolean']['input']>;
  contained?: InputMaybe<Scalars['Boolean']['input']>;
  contained_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contained_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentMaxWidth?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_contains?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentMaxWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentMaxWidth_not?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content_contains?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  secondaryContent_contains?: InputMaybe<Scalars['String']['input']>;
  secondaryContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryContent_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHeading?: InputMaybe<Scalars['String']['input']>;
  titleHeading_contains?: InputMaybe<Scalars['String']['input']>;
  titleHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHeading_not?: InputMaybe<Scalars['String']['input']>;
  titleHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleIcon?: InputMaybe<Scalars['String']['input']>;
  titleIcon_contains?: InputMaybe<Scalars['String']['input']>;
  titleIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleIcon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleIcon_not?: InputMaybe<Scalars['String']['input']>;
  titleIcon_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleIcon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfDisclaimerV2NestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfDisclaimerV2NestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfDisclaimerV2NestedFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disclaimer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName?: InputMaybe<Scalars['String']['input']>;
  entryName_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryName_not?: InputMaybe<Scalars['String']['input']>;
  entryName_not_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size?: InputMaybe<Scalars['String']['input']>;
  size_contains?: InputMaybe<Scalars['String']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size_not?: InputMaybe<Scalars['String']['input']>;
  size_not_contains?: InputMaybe<Scalars['String']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  templateWidth?: InputMaybe<Scalars['String']['input']>;
  templateWidth_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateWidth_not?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfError404NestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfError404NestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfError404NestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImageMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_exists?: InputMaybe<Scalars['Boolean']['input']>;
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_not?: InputMaybe<Scalars['String']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLabel_not?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  darkTextColor?: InputMaybe<Scalars['Boolean']['input']>;
  darkTextColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  darkTextColor_not?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not?: InputMaybe<Scalars['String']['input']>;
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  subtitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfFeatureFlagsNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfFeatureFlagsNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfFeatureFlagsNestedFilter>>>;
  ameliaChat_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ameliaChat_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ameliaChat_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ameliaChat_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  continentalUsMapFallbackThreshold?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_exists?: InputMaybe<Scalars['Boolean']['input']>;
  continentalUsMapFallbackThreshold_gt?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_gte?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  continentalUsMapFallbackThreshold_lt?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_lte?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_not?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  defaultToCdn?: InputMaybe<Scalars['Boolean']['input']>;
  defaultToCdn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  defaultToCdn_not?: InputMaybe<Scalars['Boolean']['input']>;
  doNotIndexWholeSite?: InputMaybe<Scalars['Boolean']['input']>;
  doNotIndexWholeSite_exists?: InputMaybe<Scalars['Boolean']['input']>;
  doNotIndexWholeSite_not?: InputMaybe<Scalars['Boolean']['input']>;
  enableFacilityContextInSsr?: InputMaybe<Scalars['Boolean']['input']>;
  enableFacilityContextInSsr_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableFacilityContextInSsr_not?: InputMaybe<Scalars['Boolean']['input']>;
  enableFluidTypography?: InputMaybe<Scalars['Boolean']['input']>;
  enableFluidTypography_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableFluidTypography_not?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalNavigation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalNavigation_not?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalPhase2?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalPhase2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalPhase2_not?: InputMaybe<Scalars['Boolean']['input']>;
  enableProvidersSitemap?: InputMaybe<Scalars['Boolean']['input']>;
  enableProvidersSitemap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableProvidersSitemap_not?: InputMaybe<Scalars['Boolean']['input']>;
  enablePtcSlotFilter?: InputMaybe<Scalars['Boolean']['input']>;
  enablePtcSlotFilter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enablePtcSlotFilter_not?: InputMaybe<Scalars['Boolean']['input']>;
  enforceContinentalUsZoom?: InputMaybe<Scalars['Boolean']['input']>;
  enforceContinentalUsZoom_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enforceContinentalUsZoom_not?: InputMaybe<Scalars['Boolean']['input']>;
  featureList_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureList_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureList_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureList_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fetchAllLocationsOnEmptyResults?: InputMaybe<Scalars['Boolean']['input']>;
  fetchAllLocationsOnEmptyResults_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fetchAllLocationsOnEmptyResults_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderFacilityLocator?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderFacilityLocator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderFacilityLocator_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderSchedulingButton?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderSchedulingButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderSchedulingButton_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideOdpHeaderLinks?: InputMaybe<Scalars['Boolean']['input']>;
  hideOdpHeaderLinks_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideOdpHeaderLinks_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideProviderWithNoImage?: InputMaybe<Scalars['Boolean']['input']>;
  hideProviderWithNoImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideProviderWithNoImage_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideSearchWithLocationCards?: InputMaybe<Scalars['Boolean']['input']>;
  hideSearchWithLocationCards_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideSearchWithLocationCards_not?: InputMaybe<Scalars['Boolean']['input']>;
  loadFacilityReviewsFromBeffe?: InputMaybe<Scalars['Boolean']['input']>;
  loadFacilityReviewsFromBeffe_exists?: InputMaybe<Scalars['Boolean']['input']>;
  loadFacilityReviewsFromBeffe_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onPageScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  onPageSchedulingLocations_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onPageSchedulingLocations_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onPageSchedulingLocations_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onPageSchedulingLocations_exists?: InputMaybe<Scalars['Boolean']['input']>;
  onPageScheduling_exists?: InputMaybe<Scalars['Boolean']['input']>;
  onPageScheduling_not?: InputMaybe<Scalars['Boolean']['input']>;
  providerHeroTheme?: InputMaybe<Scalars['String']['input']>;
  providerHeroTheme_contains?: InputMaybe<Scalars['String']['input']>;
  providerHeroTheme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  providerHeroTheme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerHeroTheme_not?: InputMaybe<Scalars['String']['input']>;
  providerHeroTheme_not_contains?: InputMaybe<Scalars['String']['input']>;
  providerHeroTheme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  salesForceEvergageScript?: InputMaybe<Scalars['String']['input']>;
  salesForceEvergageScript_contains?: InputMaybe<Scalars['String']['input']>;
  salesForceEvergageScript_exists?: InputMaybe<Scalars['Boolean']['input']>;
  salesForceEvergageScript_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  salesForceEvergageScript_not?: InputMaybe<Scalars['String']['input']>;
  salesForceEvergageScript_not_contains?: InputMaybe<Scalars['String']['input']>;
  salesForceEvergageScript_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showHeaderNavigationMenu?: InputMaybe<Scalars['Boolean']['input']>;
  showHeaderNavigationMenu_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showHeaderNavigationMenu_not?: InputMaybe<Scalars['Boolean']['input']>;
  showHeaderWithLocationNav?: InputMaybe<Scalars['Boolean']['input']>;
  showHeaderWithLocationNav_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showHeaderWithLocationNav_not?: InputMaybe<Scalars['Boolean']['input']>;
  showMobileHeaderLocationBar?: InputMaybe<Scalars['Boolean']['input']>;
  showMobileHeaderLocationBar_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showMobileHeaderLocationBar_not?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageCtaInMeetOurStaff?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageCtaInMeetOurStaff_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageCtaInMeetOurStaff_not?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageInsuranceInfo?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageInsuranceInfo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageInsuranceInfo_not?: InputMaybe<Scalars['Boolean']['input']>;
  showReadMoreForBioInMeetOurStaff?: InputMaybe<Scalars['Boolean']['input']>;
  showReadMoreForBioInMeetOurStaff_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showReadMoreForBioInMeetOurStaff_not?: InputMaybe<Scalars['Boolean']['input']>;
  showSetOfficeButtonInGoogleMapsCards?: InputMaybe<Scalars['Boolean']['input']>;
  showSetOfficeButtonInGoogleMapsCards_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showSetOfficeButtonInGoogleMapsCards_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  transitionallyUseBeffe?: InputMaybe<Scalars['Boolean']['input']>;
  transitionallyUseBeffe_exists?: InputMaybe<Scalars['Boolean']['input']>;
  transitionallyUseBeffe_not?: InputMaybe<Scalars['Boolean']['input']>;
  useFacilityBeffeDataSource?: InputMaybe<Scalars['Boolean']['input']>;
  useFacilityBeffeDataSource_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useFacilityBeffeDataSource_not?: InputMaybe<Scalars['Boolean']['input']>;
  useFilterForOdpDetailsContent?: InputMaybe<Scalars['Boolean']['input']>;
  useFilterForOdpDetailsContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useFilterForOdpDetailsContent_not?: InputMaybe<Scalars['Boolean']['input']>;
  useGoogleMapAutocompleteSearch?: InputMaybe<Scalars['Boolean']['input']>;
  useGoogleMapAutocompleteSearch_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useGoogleMapAutocompleteSearch_not?: InputMaybe<Scalars['Boolean']['input']>;
  useInlineOneTrust?: InputMaybe<Scalars['Boolean']['input']>;
  useInlineOneTrust_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useInlineOneTrust_not?: InputMaybe<Scalars['Boolean']['input']>;
  useSessionStorageFacilityCode?: InputMaybe<Scalars['Boolean']['input']>;
  useSessionStorageFacilityCode_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useSessionStorageFacilityCode_not?: InputMaybe<Scalars['Boolean']['input']>;
  useSimpleFindOfficeLink?: InputMaybe<Scalars['Boolean']['input']>;
  useSimpleFindOfficeLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useSimpleFindOfficeLink_not?: InputMaybe<Scalars['Boolean']['input']>;
  withLeadingProviderAssociations?: InputMaybe<Scalars['Boolean']['input']>;
  withLeadingProviderAssociations_exists?: InputMaybe<Scalars['Boolean']['input']>;
  withLeadingProviderAssociations_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfFocalPointImageNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfFocalPointImageNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfFocalPointImageNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  focalPoint_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfFooterNavigationGroupNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfFooterNavigationGroupNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfFooterNavigationGroupNestedFilter>>>;
  componentName?: InputMaybe<Scalars['String']['input']>;
  componentName_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentName_not?: InputMaybe<Scalars['String']['input']>;
  componentName_not_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  navigationGroupLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  navigationGroupTitle?: InputMaybe<Scalars['String']['input']>;
  navigationGroupTitle_contains?: InputMaybe<Scalars['String']['input']>;
  navigationGroupTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  navigationGroupTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationGroupTitle_not?: InputMaybe<Scalars['String']['input']>;
  navigationGroupTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  navigationGroupTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationLinksForGroupCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfFormDropdownListItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfFormDropdownListItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfFormDropdownListItemNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  divider?: InputMaybe<Scalars['Boolean']['input']>;
  divider_exists?: InputMaybe<Scalars['Boolean']['input']>;
  divider_not?: InputMaybe<Scalars['Boolean']['input']>;
  iconBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  iconBoolean_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconBoolean_not?: InputMaybe<Scalars['Boolean']['input']>;
  iconName?: InputMaybe<Scalars['String']['input']>;
  iconName_contains?: InputMaybe<Scalars['String']['input']>;
  iconName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconName_not?: InputMaybe<Scalars['String']['input']>;
  iconName_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  itemText?: InputMaybe<Scalars['String']['input']>;
  itemText_contains?: InputMaybe<Scalars['String']['input']>;
  itemText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  itemText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  itemText_not?: InputMaybe<Scalars['String']['input']>;
  itemText_not_contains?: InputMaybe<Scalars['String']['input']>;
  itemText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfGoogleMapTemplateNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfGoogleMapTemplateNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfGoogleMapTemplateNestedFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableServicesTabs_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  defaultImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  desktopZoom?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_exists?: InputMaybe<Scalars['Boolean']['input']>;
  desktopZoom_gt?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_gte?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  desktopZoom_lt?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_lte?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_not?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  facilityBadgeLabel?: InputMaybe<Scalars['String']['input']>;
  facilityBadgeLabel_contains?: InputMaybe<Scalars['String']['input']>;
  facilityBadgeLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilityBadgeLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityBadgeLabel_not?: InputMaybe<Scalars['String']['input']>;
  facilityBadgeLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilityBadgeLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityBasePath?: InputMaybe<Scalars['String']['input']>;
  facilityBasePath_contains?: InputMaybe<Scalars['String']['input']>;
  facilityBasePath_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilityBasePath_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityBasePath_not?: InputMaybe<Scalars['String']['input']>;
  facilityBasePath_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilityBasePath_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityButtonLabel?: InputMaybe<Scalars['String']['input']>;
  facilityButtonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  facilityButtonLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilityButtonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityButtonLabel_not?: InputMaybe<Scalars['String']['input']>;
  facilityButtonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilityButtonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googleMapsBusinessQuery?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_contains?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_exists?: InputMaybe<Scalars['Boolean']['input']>;
  googleMapsBusinessQuery_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googleMapsBusinessQuery_not?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_not_contains?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  holidayHoursMessageText?: InputMaybe<Scalars['String']['input']>;
  holidayHoursMessageText_contains?: InputMaybe<Scalars['String']['input']>;
  holidayHoursMessageText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  holidayHoursMessageText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  holidayHoursMessageText_not?: InputMaybe<Scalars['String']['input']>;
  holidayHoursMessageText_not_contains?: InputMaybe<Scalars['String']['input']>;
  holidayHoursMessageText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listTabIsHorizontalScrolling?: InputMaybe<Scalars['Boolean']['input']>;
  listTabIsHorizontalScrolling_exists?: InputMaybe<Scalars['Boolean']['input']>;
  listTabIsHorizontalScrolling_not?: InputMaybe<Scalars['Boolean']['input']>;
  locationScheduleButtonUrl?: InputMaybe<Scalars['String']['input']>;
  locationScheduleButtonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  locationScheduleButtonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  locationScheduleButtonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationScheduleButtonUrl_not?: InputMaybe<Scalars['String']['input']>;
  locationScheduleButtonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  locationScheduleButtonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileZoom?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileZoom_gt?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_gte?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  mobileZoom_lt?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_lte?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_not?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  noResultsContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  noResultsFoundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  noResultsFoundMessage_contains?: InputMaybe<Scalars['String']['input']>;
  noResultsFoundMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  noResultsFoundMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  officeDetailsButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchRadius?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchRadius_gt?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_gte?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  searchRadius_lt?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_lte?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_not?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  searchResultLimit?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchResultLimit_gt?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_gte?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  searchResultLimit_lt?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_lte?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_not?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  selectedImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  service_contains?: InputMaybe<Scalars['String']['input']>;
  service_exists?: InputMaybe<Scalars['Boolean']['input']>;
  service_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  service_not?: InputMaybe<Scalars['String']['input']>;
  service_not_contains?: InputMaybe<Scalars['String']['input']>;
  service_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  setAsOfficeButtonText?: InputMaybe<Scalars['String']['input']>;
  setAsOfficeButtonText_contains?: InputMaybe<Scalars['String']['input']>;
  setAsOfficeButtonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  setAsOfficeButtonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  setAsOfficeButtonText_not?: InputMaybe<Scalars['String']['input']>;
  setAsOfficeButtonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  setAsOfficeButtonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  singleComingSoonMessage_contains?: InputMaybe<Scalars['String']['input']>;
  singleComingSoonMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  singleComingSoonMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  useCumulativeDesign?: InputMaybe<Scalars['Boolean']['input']>;
  useCumulativeDesign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useCumulativeDesign_not?: InputMaybe<Scalars['Boolean']['input']>;
  useModernDesign?: InputMaybe<Scalars['Boolean']['input']>;
  useModernDesign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useModernDesign_not?: InputMaybe<Scalars['Boolean']['input']>;
  useUsaCountryMap?: InputMaybe<Scalars['Boolean']['input']>;
  useUsaCountryMap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useUsaCountryMap_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfHeaderMainNavNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfHeaderMainNavNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfHeaderMainNavNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headerMainNavLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerSubNavMenu_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfHeaderNavMenuNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfHeaderNavMenuNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfHeaderNavMenuNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headerMainNavLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfHeaderNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfHeaderNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfHeaderNestedFilter>>>;
  bookNowButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bottomAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName?: InputMaybe<Scalars['String']['input']>;
  componentName_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentName_not?: InputMaybe<Scalars['String']['input']>;
  componentName_not_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  darkHeader?: InputMaybe<Scalars['Boolean']['input']>;
  darkHeader_exists?: InputMaybe<Scalars['Boolean']['input']>;
  darkHeader_not?: InputMaybe<Scalars['Boolean']['input']>;
  googleMapsForLocationCards_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideFullSiteSearch?: InputMaybe<Scalars['Boolean']['input']>;
  hideFullSiteSearch_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideFullSiteSearch_not?: InputMaybe<Scalars['Boolean']['input']>;
  locationBarFindOfficeUrl?: InputMaybe<Scalars['String']['input']>;
  locationBarFindOfficeUrl_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarFindOfficeUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  locationBarFindOfficeUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationBarFindOfficeUrl_not?: InputMaybe<Scalars['String']['input']>;
  locationBarFindOfficeUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarFindOfficeUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationBarWithOfficeTitle?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOfficeTitle_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOfficeTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  locationBarWithOfficeTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationBarWithOfficeTitle_not?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOfficeTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOfficeTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationBarWithOutOfficeTitle?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOutOfficeTitle_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOutOfficeTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  locationBarWithOutOfficeTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationBarWithOutOfficeTitle_not?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOutOfficeTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOutOfficeTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationNavigationLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  myAccountLabel?: InputMaybe<Scalars['String']['input']>;
  myAccountLabel_contains?: InputMaybe<Scalars['String']['input']>;
  myAccountLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  myAccountLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  myAccountLabel_not?: InputMaybe<Scalars['String']['input']>;
  myAccountLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  myAccountLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  navigationMenu_exists?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber_exists?: InputMaybe<Scalars['Boolean']['input']>;
  profileLinkUrl?: InputMaybe<Scalars['String']['input']>;
  profileLinkUrl_contains?: InputMaybe<Scalars['String']['input']>;
  profileLinkUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  profileLinkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profileLinkUrl_not?: InputMaybe<Scalars['String']['input']>;
  profileLinkUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  profileLinkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonText?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonTextMobile?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonTextMobile_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonTextMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingButtonTextMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonTextMobile_not?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonTextMobile_not_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonTextMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonText_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingButtonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonText_not?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonUrl?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrlMobile?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrlMobile_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrlMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingButtonUrlMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonUrlMobile_not?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrlMobile_not_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrlMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingButtonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonUrl_not?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingNavigationLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryNavigationLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showSecondaryNavInMobileToolbar?: InputMaybe<Scalars['Boolean']['input']>;
  showSecondaryNavInMobileToolbar_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showSecondaryNavInMobileToolbar_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  topAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  topNavigationLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useHeaderLocationCards?: InputMaybe<Scalars['Boolean']['input']>;
  useHeaderLocationCards_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useHeaderLocationCards_not?: InputMaybe<Scalars['Boolean']['input']>;
  useNewLayout?: InputMaybe<Scalars['Boolean']['input']>;
  useNewLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useNewLayout_not?: InputMaybe<Scalars['Boolean']['input']>;
  usePopupScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  usePopupScheduling_exists?: InputMaybe<Scalars['Boolean']['input']>;
  usePopupScheduling_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfHeaderSubNavNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfHeaderSubNavNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfHeaderSubNavNestedFilter>>>;
  contentTilesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headerSubNavGroupsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfImageAssetNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfImageAssetNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfImageAssetNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  desktopImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfMediaSliderNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfMediaSliderNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfMediaSliderNestedFilter>>>;
  aspectRatio?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_contains?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  aspectRatio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aspectRatio_not?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_not_contains?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badge_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  contentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfMedicalServiceNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfMedicalServiceNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfMedicalServiceNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconName?: InputMaybe<Scalars['String']['input']>;
  iconName_contains?: InputMaybe<Scalars['String']['input']>;
  iconName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconName_not?: InputMaybe<Scalars['String']['input']>;
  iconName_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfMobileButtonNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfMobileButtonNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfMobileButtonNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconPosition?: InputMaybe<Scalars['String']['input']>;
  iconPosition_contains?: InputMaybe<Scalars['String']['input']>;
  iconPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconPosition_not?: InputMaybe<Scalars['String']['input']>;
  iconPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size?: InputMaybe<Scalars['String']['input']>;
  size_contains?: InputMaybe<Scalars['String']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size_not?: InputMaybe<Scalars['String']['input']>;
  size_not_contains?: InputMaybe<Scalars['String']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfMultiCardV2NestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfMultiCardV2NestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfMultiCardV2NestedFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bigScreenBackground?: InputMaybe<Scalars['Boolean']['input']>;
  bigScreenBackground_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bigScreenBackground_not?: InputMaybe<Scalars['Boolean']['input']>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardsAlignment?: InputMaybe<Scalars['String']['input']>;
  cardsAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  cardsAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardsAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardsAlignment_not?: InputMaybe<Scalars['String']['input']>;
  cardsAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardsAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionRichText_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionRichText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionRichText_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  displayAsStepper?: InputMaybe<Scalars['Boolean']['input']>;
  displayAsStepper_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayAsStepper_not?: InputMaybe<Scalars['Boolean']['input']>;
  display_contains?: InputMaybe<Scalars['String']['input']>;
  display_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  display_not?: InputMaybe<Scalars['String']['input']>;
  display_not_contains?: InputMaybe<Scalars['String']['input']>;
  display_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableMobileCarouselNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  enableMobileCarouselNavigation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableMobileCarouselNavigation_not?: InputMaybe<Scalars['Boolean']['input']>;
  enableResourceCardMode?: InputMaybe<Scalars['Boolean']['input']>;
  enableResourceCardMode_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableResourceCardMode_not?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowColor?: InputMaybe<Scalars['String']['input']>;
  eyebrowColor_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowColor_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowSx?: InputMaybe<Scalars['String']['input']>;
  eyebrowSx_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowSx_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowSx_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowSx_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowSx_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowSx_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowTextTransform?: InputMaybe<Scalars['String']['input']>;
  eyebrowTextTransform_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowTextTransform_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowTextTransform_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowTextTransform_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowTextTransform_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowTextTransform_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixBackgroundToBottom?: InputMaybe<Scalars['Boolean']['input']>;
  fixBackgroundToBottom_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fixBackgroundToBottom_not?: InputMaybe<Scalars['Boolean']['input']>;
  forMobile?: InputMaybe<Scalars['String']['input']>;
  forMobile_contains?: InputMaybe<Scalars['String']['input']>;
  forMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  forMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  forMobile_not?: InputMaybe<Scalars['String']['input']>;
  forMobile_not_contains?: InputMaybe<Scalars['String']['input']>;
  forMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerSpacing?: InputMaybe<Scalars['String']['input']>;
  headerSpacing_contains?: InputMaybe<Scalars['String']['input']>;
  headerSpacing_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerSpacing_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerSpacing_not?: InputMaybe<Scalars['String']['input']>;
  headerSpacing_not_contains?: InputMaybe<Scalars['String']['input']>;
  headerSpacing_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastRowCardsAlignment?: InputMaybe<Scalars['String']['input']>;
  lastRowCardsAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  lastRowCardsAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  lastRowCardsAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastRowCardsAlignment_not?: InputMaybe<Scalars['String']['input']>;
  lastRowCardsAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  lastRowCardsAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  noResultsContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfCardsInLineDesktop?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfCardsInLineDesktop_gt?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_gte?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  numberOfCardsInLineDesktop_lt?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_lte?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_not?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  roundedImage?: InputMaybe<Scalars['Boolean']['input']>;
  roundedImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  roundedImage_not?: InputMaybe<Scalars['Boolean']['input']>;
  sectionEyebrow?: InputMaybe<Scalars['String']['input']>;
  sectionEyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  sectionEyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionEyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionEyebrow_not?: InputMaybe<Scalars['String']['input']>;
  sectionEyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionEyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionInfoAlignment?: InputMaybe<Scalars['String']['input']>;
  sectionInfoAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  sectionInfoAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionInfoAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionInfoAlignment_not?: InputMaybe<Scalars['String']['input']>;
  sectionInfoAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionInfoAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  sectionTitleHtag?: InputMaybe<Scalars['String']['input']>;
  sectionTitleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionTitleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitleHtag_not?: InputMaybe<Scalars['String']['input']>;
  sectionTitleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle_not?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shouldDisplayCarouselOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  shouldDisplayCarouselOnDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shouldDisplayCarouselOnDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  useCardMediaRoundedCorners?: InputMaybe<Scalars['Boolean']['input']>;
  useCardMediaRoundedCorners_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useCardMediaRoundedCorners_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfNavigationGroupNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfNavigationGroupNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfNavigationGroupNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  displayAsExpandedForMobileMenu?: InputMaybe<Scalars['Boolean']['input']>;
  displayAsExpandedForMobileMenu_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayAsExpandedForMobileMenu_not?: InputMaybe<Scalars['Boolean']['input']>;
  groupLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfNavigationLinkNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfNavigationLinkNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfNavigationLinkNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  externalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  externalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalUrl_not?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  isInternal_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isInternal_not?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized_not?: InputMaybe<Scalars['Boolean']['input']>;
  linkIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  linkText_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText_not?: InputMaybe<Scalars['String']['input']>;
  linkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewTab_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewTab_not?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewWindow?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewWindow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewWindow_not?: InputMaybe<Scalars['Boolean']['input']>;
  pageData_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfPageNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPageNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPageNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appName?: InputMaybe<Scalars['String']['input']>;
  appName_contains?: InputMaybe<Scalars['String']['input']>;
  appName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appName_not?: InputMaybe<Scalars['String']['input']>;
  appName_not_contains?: InputMaybe<Scalars['String']['input']>;
  appName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  breadcrumbTitle?: InputMaybe<Scalars['String']['input']>;
  breadcrumbTitle_contains?: InputMaybe<Scalars['String']['input']>;
  breadcrumbTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  breadcrumbTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  breadcrumbTitle_not?: InputMaybe<Scalars['String']['input']>;
  breadcrumbTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  breadcrumbTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  breadcrumbsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonical?: InputMaybe<Scalars['String']['input']>;
  canonical_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonical_not?: InputMaybe<Scalars['String']['input']>;
  canonical_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  contentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disableChatBot?: InputMaybe<Scalars['Boolean']['input']>;
  disableChatBot_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableChatBot_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideScheduleButtonInHeader?: InputMaybe<Scalars['Boolean']['input']>;
  hideScheduleButtonInHeader_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideScheduleButtonInHeader_not?: InputMaybe<Scalars['Boolean']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_not?: InputMaybe<Scalars['Boolean']['input']>;
  mobileBreadcrumbTitle?: InputMaybe<Scalars['String']['input']>;
  mobileBreadcrumbTitle_contains?: InputMaybe<Scalars['String']['input']>;
  mobileBreadcrumbTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileBreadcrumbTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileBreadcrumbTitle_not?: InputMaybe<Scalars['String']['input']>;
  mobileBreadcrumbTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  mobileBreadcrumbTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  overrideSchedulingButtonUrl?: InputMaybe<Scalars['String']['input']>;
  overrideSchedulingButtonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  overrideSchedulingButtonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  overrideSchedulingButtonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  overrideSchedulingButtonUrl_not?: InputMaybe<Scalars['String']['input']>;
  overrideSchedulingButtonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  overrideSchedulingButtonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTheme?: InputMaybe<Scalars['String']['input']>;
  pageTheme_contains?: InputMaybe<Scalars['String']['input']>;
  pageTheme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTheme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTheme_not?: InputMaybe<Scalars['String']['input']>;
  pageTheme_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageTheme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  pageTitle_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle_not?: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path?: InputMaybe<Scalars['String']['input']>;
  path_contains?: InputMaybe<Scalars['String']['input']>;
  path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_not?: InputMaybe<Scalars['String']['input']>;
  path_not_contains?: InputMaybe<Scalars['String']['input']>;
  path_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalized?: InputMaybe<Scalars['Boolean']['input']>;
  personalizedPathPrefix?: InputMaybe<Scalars['String']['input']>;
  personalizedPathPrefix_contains?: InputMaybe<Scalars['String']['input']>;
  personalizedPathPrefix_exists?: InputMaybe<Scalars['Boolean']['input']>;
  personalizedPathPrefix_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalizedPathPrefix_not?: InputMaybe<Scalars['String']['input']>;
  personalizedPathPrefix_not_contains?: InputMaybe<Scalars['String']['input']>;
  personalizedPathPrefix_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalizedPathSuffix?: InputMaybe<Scalars['String']['input']>;
  personalizedPathSuffix_contains?: InputMaybe<Scalars['String']['input']>;
  personalizedPathSuffix_exists?: InputMaybe<Scalars['Boolean']['input']>;
  personalizedPathSuffix_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalizedPathSuffix_not?: InputMaybe<Scalars['String']['input']>;
  personalizedPathSuffix_not_contains?: InputMaybe<Scalars['String']['input']>;
  personalizedPathSuffix_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalized_exists?: InputMaybe<Scalars['Boolean']['input']>;
  personalized_not?: InputMaybe<Scalars['Boolean']['input']>;
  redirectFrom_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  redirectFrom_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  redirectFrom_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  redirectFrom_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfPatientReviewV2NestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPatientReviewV2NestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPatientReviewV2NestedFilter>>>;
  avatar_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  score?: InputMaybe<Scalars['Int']['input']>;
  score_exists?: InputMaybe<Scalars['Boolean']['input']>;
  score_gt?: InputMaybe<Scalars['Int']['input']>;
  score_gte?: InputMaybe<Scalars['Int']['input']>;
  score_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  score_lt?: InputMaybe<Scalars['Int']['input']>;
  score_lte?: InputMaybe<Scalars['Int']['input']>;
  score_not?: InputMaybe<Scalars['Int']['input']>;
  score_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  subText1?: InputMaybe<Scalars['String']['input']>;
  subText1_contains?: InputMaybe<Scalars['String']['input']>;
  subText1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subText1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subText1_not?: InputMaybe<Scalars['String']['input']>;
  subText1_not_contains?: InputMaybe<Scalars['String']['input']>;
  subText1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subText2?: InputMaybe<Scalars['String']['input']>;
  subText2_contains?: InputMaybe<Scalars['String']['input']>;
  subText2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subText2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subText2_not?: InputMaybe<Scalars['String']['input']>;
  subText2_not_contains?: InputMaybe<Scalars['String']['input']>;
  subText2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not?: InputMaybe<Scalars['String']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfProductFeatureDescriptionListItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfProductFeatureDescriptionListItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfProductFeatureDescriptionListItemNestedFilter>>>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfQuestionnaireNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfQuestionnaireNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfQuestionnaireNestedFilter>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  defaultErrorMessage?: InputMaybe<Scalars['String']['input']>;
  defaultErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  defaultErrorMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  defaultErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  defaultErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  defaultErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  defaultErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  subTitle_contains?: InputMaybe<Scalars['String']['input']>;
  subTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subTitle_not?: InputMaybe<Scalars['String']['input']>;
  subTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  subTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not?: InputMaybe<Scalars['String']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfQuizNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfQuizNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfQuizNestedFilter>>>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  clearChoicePoorCreditRedirectPath?: InputMaybe<Scalars['String']['input']>;
  clearChoicePoorCreditRedirectPath_contains?: InputMaybe<Scalars['String']['input']>;
  clearChoicePoorCreditRedirectPath_exists?: InputMaybe<Scalars['Boolean']['input']>;
  clearChoicePoorCreditRedirectPath_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clearChoicePoorCreditRedirectPath_not?: InputMaybe<Scalars['String']['input']>;
  clearChoicePoorCreditRedirectPath_not_contains?: InputMaybe<Scalars['String']['input']>;
  clearChoicePoorCreditRedirectPath_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  formBuilderConfig_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isFormBuilder?: InputMaybe<Scalars['Boolean']['input']>;
  isFormBuilder_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isFormBuilder_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quizFormData_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quizType?: InputMaybe<Scalars['String']['input']>;
  quizType_contains?: InputMaybe<Scalars['String']['input']>;
  quizType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quizType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quizType_not?: InputMaybe<Scalars['String']['input']>;
  quizType_not_contains?: InputMaybe<Scalars['String']['input']>;
  quizType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submitEndpointUrl?: InputMaybe<Scalars['String']['input']>;
  submitEndpointUrl_contains?: InputMaybe<Scalars['String']['input']>;
  submitEndpointUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  submitEndpointUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submitEndpointUrl_not?: InputMaybe<Scalars['String']['input']>;
  submitEndpointUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  submitEndpointUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfSingleMessageNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfSingleMessageNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfSingleMessageNestedFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonSize?: InputMaybe<Scalars['String']['input']>;
  buttonSize_contains?: InputMaybe<Scalars['String']['input']>;
  buttonSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonSize_not?: InputMaybe<Scalars['String']['input']>;
  buttonSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonType?: InputMaybe<Scalars['String']['input']>;
  buttonType_contains?: InputMaybe<Scalars['String']['input']>;
  buttonType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonType_not?: InputMaybe<Scalars['String']['input']>;
  buttonType_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlign?: InputMaybe<Scalars['String']['input']>;
  contentAlign_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlign_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentAlign_not?: InputMaybe<Scalars['String']['input']>;
  contentAlign_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlign_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFillVerticalSpace?: InputMaybe<Scalars['Boolean']['input']>;
  contentFillVerticalSpace_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentFillVerticalSpace_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_contains?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  displayTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  displayTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  display_contains?: InputMaybe<Scalars['String']['input']>;
  display_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  display_not?: InputMaybe<Scalars['String']['input']>;
  display_not_contains?: InputMaybe<Scalars['String']['input']>;
  display_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  focalPointImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconSize?: InputMaybe<Scalars['String']['input']>;
  iconSize_contains?: InputMaybe<Scalars['String']['input']>;
  iconSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconSize_not?: InputMaybe<Scalars['String']['input']>;
  iconSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageLeftSide_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageRightSide_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isBannerImage?: InputMaybe<Scalars['Boolean']['input']>;
  isBannerImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isBannerImage_not?: InputMaybe<Scalars['Boolean']['input']>;
  isHeaderAboveSideImages?: InputMaybe<Scalars['Boolean']['input']>;
  isHeaderAboveSideImages_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isHeaderAboveSideImages_not?: InputMaybe<Scalars['Boolean']['input']>;
  isInlineLayout?: InputMaybe<Scalars['Boolean']['input']>;
  isInlineLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isInlineLayout_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showSubscriptionForm?: InputMaybe<Scalars['Boolean']['input']>;
  showSubscriptionForm_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showSubscriptionForm_not?: InputMaybe<Scalars['Boolean']['input']>;
  subText?: InputMaybe<Scalars['String']['input']>;
  subText_contains?: InputMaybe<Scalars['String']['input']>;
  subText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subText_not?: InputMaybe<Scalars['String']['input']>;
  subText_not_contains?: InputMaybe<Scalars['String']['input']>;
  subText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tc_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateHeight?: InputMaybe<Scalars['String']['input']>;
  templateHeight_contains?: InputMaybe<Scalars['String']['input']>;
  templateHeight_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateHeight_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateHeight_not?: InputMaybe<Scalars['String']['input']>;
  templateHeight_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateHeight_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateWidth?: InputMaybe<Scalars['String']['input']>;
  templateWidth_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateWidth_not?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleAlign?: InputMaybe<Scalars['String']['input']>;
  titleAlign_contains?: InputMaybe<Scalars['String']['input']>;
  titleAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleAlign_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleAlign_not?: InputMaybe<Scalars['String']['input']>;
  titleAlign_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleAlign_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleVariant?: InputMaybe<Scalars['String']['input']>;
  titleVariant_contains?: InputMaybe<Scalars['String']['input']>;
  titleVariant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleVariant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleVariant_not?: InputMaybe<Scalars['String']['input']>;
  titleVariant_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  useRoundedCorners?: InputMaybe<Scalars['Boolean']['input']>;
  useRoundedCorners_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useRoundedCorners_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfSmallScreenContentNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfSmallScreenContentNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfSmallScreenContentNestedFilter>>>;
  bodySmallScreen_contains?: InputMaybe<Scalars['String']['input']>;
  bodySmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodySmallScreen_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  controllableVideo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName?: InputMaybe<Scalars['String']['input']>;
  entryName_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryName_not?: InputMaybe<Scalars['String']['input']>;
  entryName_not_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowSmallScreen?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreen_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowSmallScreen_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowSmallScreen_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreen_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreen_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  focalPointImageSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingSmallScreen_contains?: InputMaybe<Scalars['String']['input']>;
  headingSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingSmallScreen_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaFirst?: InputMaybe<Scalars['Boolean']['input']>;
  mediaFirst_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaFirst_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  videoSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfSuccessCardNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfSuccessCardNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfSuccessCardNestedFilter>>>;
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonLink_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLink_not?: InputMaybe<Scalars['String']['input']>;
  buttonLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  descriptionText?: InputMaybe<Scalars['String']['input']>;
  descriptionText_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionText_not?: InputMaybe<Scalars['String']['input']>;
  descriptionText_not_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAltText?: InputMaybe<Scalars['String']['input']>;
  imageAltText_contains?: InputMaybe<Scalars['String']['input']>;
  imageAltText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageAltText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAltText_not?: InputMaybe<Scalars['String']['input']>;
  imageAltText_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageAltText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  titleText?: InputMaybe<Scalars['String']['input']>;
  titleText_contains?: InputMaybe<Scalars['String']['input']>;
  titleText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleText_not?: InputMaybe<Scalars['String']['input']>;
  titleText_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfTabNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfTabNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfTabNestedFilter>>>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  jumplinkName?: InputMaybe<Scalars['String']['input']>;
  jumplinkName_contains?: InputMaybe<Scalars['String']['input']>;
  jumplinkName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  jumplinkName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jumplinkName_not?: InputMaybe<Scalars['String']['input']>;
  jumplinkName_not_contains?: InputMaybe<Scalars['String']['input']>;
  jumplinkName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfTabsNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfTabsNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfTabsNestedFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  jumplinkTabs?: InputMaybe<Scalars['Boolean']['input']>;
  jumplinkTabs_exists?: InputMaybe<Scalars['Boolean']['input']>;
  jumplinkTabs_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tabRowVariant?: InputMaybe<Scalars['String']['input']>;
  tabRowVariant_contains?: InputMaybe<Scalars['String']['input']>;
  tabRowVariant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabRowVariant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tabRowVariant_not?: InputMaybe<Scalars['String']['input']>;
  tabRowVariant_not_contains?: InputMaybe<Scalars['String']['input']>;
  tabRowVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tabsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabsSize?: InputMaybe<Scalars['String']['input']>;
  tabsSize_contains?: InputMaybe<Scalars['String']['input']>;
  tabsSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabsSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tabsSize_not?: InputMaybe<Scalars['String']['input']>;
  tabsSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  tabsSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withContentInnerGap?: InputMaybe<Scalars['Boolean']['input']>;
  withContentInnerGap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  withContentInnerGap_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfTermsAndConditionsNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfTermsAndConditionsNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfTermsAndConditionsNestedFilter>>>;
  content_contains?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headlineText?: InputMaybe<Scalars['String']['input']>;
  headlineText_contains?: InputMaybe<Scalars['String']['input']>;
  headlineText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headlineText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headlineText_not?: InputMaybe<Scalars['String']['input']>;
  headlineText_not_contains?: InputMaybe<Scalars['String']['input']>;
  headlineText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showTcTextAs?: InputMaybe<Scalars['Boolean']['input']>;
  showTcTextAs_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTcTextAs_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  tcLink?: InputMaybe<Scalars['String']['input']>;
  tcLink_contains?: InputMaybe<Scalars['String']['input']>;
  tcLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tcLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcLink_not?: InputMaybe<Scalars['String']['input']>;
  tcLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  tcLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcText?: InputMaybe<Scalars['String']['input']>;
  tcText_contains?: InputMaybe<Scalars['String']['input']>;
  tcText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tcText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcText_not?: InputMaybe<Scalars['String']['input']>;
  tcText_not_contains?: InputMaybe<Scalars['String']['input']>;
  tcText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfVideoAssetNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfVideoAssetNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfVideoAssetNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  desktopVideo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileVideo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfVideoNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfVideoNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfVideoNestedFilter>>>;
  adjustedWidth?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  adjustedWidth_gt?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_gte?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  adjustedWidth_lt?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_lte?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_not?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  autoPlay?: InputMaybe<Scalars['Boolean']['input']>;
  autoPlay_exists?: InputMaybe<Scalars['Boolean']['input']>;
  autoPlay_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  hlsVideoStreamLink?: InputMaybe<Scalars['String']['input']>;
  hlsVideoStreamLink_contains?: InputMaybe<Scalars['String']['input']>;
  hlsVideoStreamLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hlsVideoStreamLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hlsVideoStreamLink_not?: InputMaybe<Scalars['String']['input']>;
  hlsVideoStreamLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  hlsVideoStreamLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isLooped?: InputMaybe<Scalars['Boolean']['input']>;
  isLooped_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLooped_not?: InputMaybe<Scalars['Boolean']['input']>;
  isMuted?: InputMaybe<Scalars['Boolean']['input']>;
  isMuted_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isMuted_not?: InputMaybe<Scalars['Boolean']['input']>;
  media_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  posterMedia_exists?: InputMaybe<Scalars['Boolean']['input']>;
  posterUrl?: InputMaybe<Scalars['String']['input']>;
  posterUrl_contains?: InputMaybe<Scalars['String']['input']>;
  posterUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  posterUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  posterUrl_not?: InputMaybe<Scalars['String']['input']>;
  posterUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  posterUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  useOriginalVideoSize?: InputMaybe<Scalars['Boolean']['input']>;
  useOriginalVideoSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useOriginalVideoSize_not?: InputMaybe<Scalars['Boolean']['input']>;
  videoSource?: InputMaybe<Scalars['String']['input']>;
  videoSource_contains?: InputMaybe<Scalars['String']['input']>;
  videoSource_exists?: InputMaybe<Scalars['Boolean']['input']>;
  videoSource_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoSource_not?: InputMaybe<Scalars['String']['input']>;
  videoSource_not_contains?: InputMaybe<Scalars['String']['input']>;
  videoSource_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youtubeId?: InputMaybe<Scalars['String']['input']>;
  youtubeId_contains?: InputMaybe<Scalars['String']['input']>;
  youtubeId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  youtubeId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youtubeId_not?: InputMaybe<Scalars['String']['input']>;
  youtubeId_not_contains?: InputMaybe<Scalars['String']['input']>;
  youtubeId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfVideoWithContentNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfVideoWithContentNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfVideoWithContentNestedFilter>>>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  video_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfaccordionsMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfaccordionsMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfaccordionsMultiTypeNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfadditionalContentMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfadditionalContentMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfadditionalContentMultiTypeNestedFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfcolumnsMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfcolumnsMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfcolumnsMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfcontentListMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfcontentListMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfcontentListMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfcontentsMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfcontentsMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfcontentsMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type CfformMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfformMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfformMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CflocationNavigationLinksMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CflocationNavigationLinksMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CflocationNavigationLinksMultiTypeNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfmediaContentMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfmediaContentMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfmediaContentMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfnavigationLinksForGroupMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfnavigationLinksForGroupMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfnavigationLinksForGroupMultiTypeNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfnavigationLinksMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfnavigationLinksMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfnavigationLinksMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type CfsecondaryContentsMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfsecondaryContentsMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfsecondaryContentsMultiTypeNestedFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfsecondaryNavigationLinksMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfsecondaryNavigationLinksMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfsecondaryNavigationLinksMultiTypeNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfstepsMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfstepsMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfstepsMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type CftopNavigationLinksMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CftopNavigationLinksMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CftopNavigationLinksMultiTypeNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type AccordionFragment = (
  { __typename?: 'Accordions', title?: string | null, titleHtag?: string | null, titleColor?: string | null, centerAlign?: boolean | null, fullWidth?: boolean | null, disablePaddingOn?: Array<string | null> | null, imagePositionRight?: boolean | null, imageRoundedCorner?: string | null, titleAlignment?: string | null, descriptionAlignment?: string | null, backgroundColor?: string | null, expandIconType?: string | null, expandIconPosition?: string | null, roundedCornersSize?: string | null, withInnerGap?: boolean | null, anchorId?: string | null, descriptionRichText?: { __typename?: 'AccordionsDescriptionRichText', json: any } | null, image?: (
    { __typename?: 'FocalPointImage' }
    & FocalPointImageFragment
  ) | null, backgroundImage?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, accordionsCollection?: { __typename?: 'AccordionsAccordionsCollection', items: Array<(
      { __typename?: 'AgendaStepper' }
      & Meta_AgendaStepper_Fragment
    ) | (
      { __typename?: 'ContentTypeRichText' }
      & RichTextFragment
    ) | null> } | null, buttonsCollection?: { __typename?: 'AccordionsButtonsCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null }
  & Meta_Accordions_Fragment
);

export type AgendaModalFragment = (
  { __typename?: 'AgendaModal', headlineText?: string | null, headlineHeading?: string | null, icon?: string | null, bodyText?: (
    { __typename?: 'ContentTypeRichText' }
    & RichTextFragment
  ) | null }
  & Meta_AgendaModal_Fragment
);

export type AnalyticsFragment = { __typename?: 'AnalyticsContext', brand?: string | null, event?: string | null, pageUrl?: string | null, pageName?: string | null, linkUrl?: string | null, linkText?: string | null, clickName?: string | null, clickPosition?: string | null, siteSection?: string | null, virtualPageUrl?: string | null, virtualPageTitle?: string | null, appointmentSelectedFacilityId?: string | null, appointmentSelectedFacilityName?: string | null };

export type BannerFragment = (
  { __typename?: 'Banner', variant?: string | null, alertMessagesCollection?: { __typename?: 'BannerAlertMessagesCollection', items: Array<{ __typename: 'ContentTypeRichText', backgroundColor?: string | null, content?: { __typename?: 'ContentTypeRichTextContent', json: any } | null } | null> } | null, mobileAlertMessagesCollection?: { __typename?: 'BannerMobileAlertMessagesCollection', items: Array<{ __typename: 'ContentTypeRichText', backgroundColor?: string | null, content?: { __typename?: 'ContentTypeRichTextContent', json: any } | null } | null> } | null }
  & Meta_Banner_Fragment
);

export type BlogAuthorFragment = (
  { __typename?: 'BlogAuthor', title?: string | null, name?: string | null, image?: any | null, authorBioSummary?: (
    { __typename?: 'BlogAuthorAuthorBioSummary' }
    & BlogAuthorAuthorBioSummaryFragment
  ) | null }
  & Meta_BlogAuthor_Fragment
);

export type BlogAuthorAuthorBioSummaryAssetsFragment = { __typename?: 'BlogAuthorAuthorBioSummaryAssets', block: Array<(
    { __typename?: 'Asset', contentType?: string | null, url?: string | null, description?: string | null, fileName?: string | null }
    & LinkMetaFragment
  ) | null>, hyperlink: Array<(
    { __typename?: 'Asset', contentType?: string | null, url?: string | null, description?: string | null, fileName?: string | null }
    & LinkMetaFragment
  ) | null> };

export type BlogAuthorAuthorBioSummaryEntriesFragment = { __typename?: 'BlogAuthorAuthorBioSummaryEntries', inline: Array<(
    { __typename?: 'Accordions' }
    & EnrichedMeta_Accordions_Fragment
  ) | (
    { __typename?: 'AdFooter' }
    & EnrichedMeta_AdFooter_Fragment
  ) | (
    { __typename?: 'AgendaModal' }
    & EnrichedMeta_AgendaModal_Fragment
  ) | (
    { __typename?: 'AgendaStepper' }
    & EnrichedMeta_AgendaStepper_Fragment
  ) | (
    { __typename?: 'AnalyticsContext' }
    & EnrichedMeta_AnalyticsContext_Fragment
  ) | (
    { __typename?: 'App' }
    & EnrichedMeta_App_Fragment
  ) | (
    { __typename?: 'AppointmentBookingPage' }
    & EnrichedMeta_AppointmentBookingPage_Fragment
  ) | (
    { __typename?: 'Badge' }
    & EnrichedMeta_Badge_Fragment
  ) | (
    { __typename?: 'Banner' }
    & EnrichedMeta_Banner_Fragment
  ) | (
    { __typename?: 'BirdEyeReviews' }
    & EnrichedMeta_BirdEyeReviews_Fragment
  ) | (
    { __typename?: 'BlogAuthor' }
    & EnrichedMeta_BlogAuthor_Fragment
  ) | (
    { __typename?: 'BlogCategory' }
    & EnrichedMeta_BlogCategory_Fragment
  ) | (
    { __typename?: 'BlogDetailsPage' }
    & EnrichedMeta_BlogDetailsPage_Fragment
  ) | (
    { __typename?: 'BlogList' }
    & EnrichedMeta_BlogList_Fragment
  ) | (
    { __typename?: 'BlogListPage' }
    & EnrichedMeta_BlogListPage_Fragment
  ) | (
    { __typename?: 'BlogSubCategory' }
    & EnrichedMeta_BlogSubCategory_Fragment
  ) | (
    { __typename?: 'Brand' }
    & EnrichedMeta_Brand_Fragment
  ) | (
    { __typename?: 'Button' }
    & EnrichedMeta_Button_Fragment
  ) | (
    { __typename?: 'Card' }
    & EnrichedMeta_Card_Fragment
  ) | (
    { __typename?: 'Category' }
    & EnrichedMeta_Category_Fragment
  ) | (
    { __typename?: 'CategoryPicker' }
    & EnrichedMeta_CategoryPicker_Fragment
  ) | (
    { __typename?: 'CityLinks' }
    & EnrichedMeta_CityLinks_Fragment
  ) | (
    { __typename?: 'Columns' }
    & EnrichedMeta_Columns_Fragment
  ) | (
    { __typename?: 'ConfirmationStep' }
    & EnrichedMeta_ConfirmationStep_Fragment
  ) | (
    { __typename?: 'ContentSection' }
    & EnrichedMeta_ContentSection_Fragment
  ) | (
    { __typename?: 'ContentTile' }
    & EnrichedMeta_ContentTile_Fragment
  ) | (
    { __typename?: 'ContentTypeRichText' }
    & EnrichedMeta_ContentTypeRichText_Fragment
  ) | (
    { __typename?: 'DisclaimerV2' }
    & EnrichedMeta_DisclaimerV2_Fragment
  ) | (
    { __typename?: 'Error404' }
    & EnrichedMeta_Error404_Fragment
  ) | (
    { __typename?: 'FacilityDetailsPage' }
    & EnrichedMeta_FacilityDetailsPage_Fragment
  ) | (
    { __typename?: 'FeatureFlags' }
    & EnrichedMeta_FeatureFlags_Fragment
  ) | (
    { __typename?: 'FocalPointImage' }
    & EnrichedMeta_FocalPointImage_Fragment
  ) | (
    { __typename?: 'FooterNavigationGroup' }
    & EnrichedMeta_FooterNavigationGroup_Fragment
  ) | (
    { __typename?: 'FormDropdownField' }
    & EnrichedMeta_FormDropdownField_Fragment
  ) | (
    { __typename?: 'FormDropdownListItem' }
    & EnrichedMeta_FormDropdownListItem_Fragment
  ) | (
    { __typename?: 'FormField' }
    & EnrichedMeta_FormField_Fragment
  ) | (
    { __typename?: 'GoogleMapTemplate' }
    & EnrichedMeta_GoogleMapTemplate_Fragment
  ) | (
    { __typename?: 'HalfScreen' }
    & EnrichedMeta_HalfScreen_Fragment
  ) | (
    { __typename?: 'Header' }
    & EnrichedMeta_Header_Fragment
  ) | (
    { __typename?: 'HeaderMainNav' }
    & EnrichedMeta_HeaderMainNav_Fragment
  ) | (
    { __typename?: 'HeaderNavMenu' }
    & EnrichedMeta_HeaderNavMenu_Fragment
  ) | (
    { __typename?: 'HeaderSubNav' }
    & EnrichedMeta_HeaderSubNav_Fragment
  ) | (
    { __typename?: 'HeroV2' }
    & EnrichedMeta_HeroV2_Fragment
  ) | (
    { __typename?: 'Iframe' }
    & EnrichedMeta_Iframe_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & EnrichedMeta_ImageAsset_Fragment
  ) | (
    { __typename?: 'Insurance' }
    & EnrichedMeta_Insurance_Fragment
  ) | (
    { __typename?: 'LinkForwarder' }
    & EnrichedMeta_LinkForwarder_Fragment
  ) | (
    { __typename?: 'LocalizedServiceTitle' }
    & EnrichedMeta_LocalizedServiceTitle_Fragment
  ) | (
    { __typename?: 'Marquee' }
    & EnrichedMeta_Marquee_Fragment
  ) | (
    { __typename?: 'MediaSlider' }
    & EnrichedMeta_MediaSlider_Fragment
  ) | (
    { __typename?: 'MedicalService' }
    & EnrichedMeta_MedicalService_Fragment
  ) | (
    { __typename?: 'MeetOurStaff' }
    & EnrichedMeta_MeetOurStaff_Fragment
  ) | (
    { __typename?: 'MobileButton' }
    & EnrichedMeta_MobileButton_Fragment
  ) | (
    { __typename?: 'MultiCardV2' }
    & EnrichedMeta_MultiCardV2_Fragment
  ) | (
    { __typename?: 'NavigationGroup' }
    & EnrichedMeta_NavigationGroup_Fragment
  ) | (
    { __typename?: 'NavigationLink' }
    & EnrichedMeta_NavigationLink_Fragment
  ) | (
    { __typename?: 'OdpHero' }
    & EnrichedMeta_OdpHero_Fragment
  ) | (
    { __typename?: 'Page' }
    & EnrichedMeta_Page_Fragment
    & BasePageFragment
  ) | (
    { __typename?: 'PatientReviewV2' }
    & EnrichedMeta_PatientReviewV2_Fragment
  ) | (
    { __typename?: 'PatientReviewsV2' }
    & EnrichedMeta_PatientReviewsV2_Fragment
  ) | (
    { __typename?: 'Product' }
    & EnrichedMeta_Product_Fragment
  ) | (
    { __typename?: 'ProductDisplay' }
    & EnrichedMeta_ProductDisplay_Fragment
  ) | (
    { __typename?: 'ProductFeature' }
    & EnrichedMeta_ProductFeature_Fragment
  ) | (
    { __typename?: 'ProductFeatureDescriptionListItem' }
    & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
  ) | (
    { __typename?: 'ProviderDetailsPage' }
    & EnrichedMeta_ProviderDetailsPage_Fragment
  ) | (
    { __typename?: 'Questionnaire' }
    & EnrichedMeta_Questionnaire_Fragment
  ) | (
    { __typename?: 'QuickLinks' }
    & EnrichedMeta_QuickLinks_Fragment
  ) | (
    { __typename?: 'Quiz' }
    & EnrichedMeta_Quiz_Fragment
  ) | (
    { __typename?: 'ReviewStep' }
    & EnrichedMeta_ReviewStep_Fragment
  ) | (
    { __typename?: 'Schema' }
    & EnrichedMeta_Schema_Fragment
  ) | (
    { __typename?: 'SectionContent' }
    & EnrichedMeta_SectionContent_Fragment
  ) | (
    { __typename?: 'SegmentsContainer' }
    & EnrichedMeta_SegmentsContainer_Fragment
  ) | (
    { __typename?: 'Service' }
    & EnrichedMeta_Service_Fragment
  ) | (
    { __typename?: 'ServiceDetailsPage' }
    & EnrichedMeta_ServiceDetailsPage_Fragment
  ) | (
    { __typename?: 'ServiceLineHero' }
    & EnrichedMeta_ServiceLineHero_Fragment
  ) | (
    { __typename?: 'SingleMessage' }
    & EnrichedMeta_SingleMessage_Fragment
  ) | (
    { __typename?: 'SmallScreenContent' }
    & EnrichedMeta_SmallScreenContent_Fragment
  ) | (
    { __typename?: 'SmileAssessmentForm' }
    & EnrichedMeta_SmileAssessmentForm_Fragment
  ) | (
    { __typename?: 'Spacer' }
    & EnrichedMeta_Spacer_Fragment
  ) | (
    { __typename?: 'StateLinks' }
    & EnrichedMeta_StateLinks_Fragment
  ) | (
    { __typename?: 'Stepper' }
    & EnrichedMeta_Stepper_Fragment
  ) | (
    { __typename?: 'SuccessCard' }
    & EnrichedMeta_SuccessCard_Fragment
  ) | (
    { __typename?: 'Tab' }
    & EnrichedMeta_Tab_Fragment
  ) | (
    { __typename?: 'Table' }
    & EnrichedMeta_Table_Fragment
  ) | (
    { __typename?: 'Tabs' }
    & EnrichedMeta_Tabs_Fragment
  ) | (
    { __typename?: 'TermsAndConditions' }
    & EnrichedMeta_TermsAndConditions_Fragment
  ) | (
    { __typename?: 'TextBlockSeo' }
    & EnrichedMeta_TextBlockSeo_Fragment
  ) | (
    { __typename?: 'Video' }
    & EnrichedMeta_Video_Fragment
  ) | (
    { __typename?: 'VideoAsset' }
    & EnrichedMeta_VideoAsset_Fragment
  ) | (
    { __typename?: 'VideoCarousel' }
    & EnrichedMeta_VideoCarousel_Fragment
  ) | (
    { __typename?: 'VideoWithContent' }
    & EnrichedMeta_VideoWithContent_Fragment
  ) | null>, block: Array<(
    { __typename?: 'Accordions' }
    & EnrichedMeta_Accordions_Fragment
  ) | (
    { __typename?: 'AdFooter' }
    & EnrichedMeta_AdFooter_Fragment
  ) | (
    { __typename?: 'AgendaModal' }
    & EnrichedMeta_AgendaModal_Fragment
  ) | (
    { __typename?: 'AgendaStepper' }
    & EnrichedMeta_AgendaStepper_Fragment
  ) | (
    { __typename?: 'AnalyticsContext' }
    & EnrichedMeta_AnalyticsContext_Fragment
  ) | (
    { __typename?: 'App' }
    & EnrichedMeta_App_Fragment
  ) | (
    { __typename?: 'AppointmentBookingPage' }
    & EnrichedMeta_AppointmentBookingPage_Fragment
  ) | (
    { __typename?: 'Badge' }
    & EnrichedMeta_Badge_Fragment
  ) | (
    { __typename?: 'Banner' }
    & EnrichedMeta_Banner_Fragment
  ) | (
    { __typename?: 'BirdEyeReviews' }
    & EnrichedMeta_BirdEyeReviews_Fragment
  ) | (
    { __typename?: 'BlogAuthor' }
    & EnrichedMeta_BlogAuthor_Fragment
  ) | (
    { __typename?: 'BlogCategory' }
    & EnrichedMeta_BlogCategory_Fragment
  ) | (
    { __typename?: 'BlogDetailsPage' }
    & EnrichedMeta_BlogDetailsPage_Fragment
  ) | (
    { __typename?: 'BlogList' }
    & EnrichedMeta_BlogList_Fragment
  ) | (
    { __typename?: 'BlogListPage' }
    & EnrichedMeta_BlogListPage_Fragment
  ) | (
    { __typename?: 'BlogSubCategory' }
    & EnrichedMeta_BlogSubCategory_Fragment
  ) | (
    { __typename?: 'Brand' }
    & EnrichedMeta_Brand_Fragment
  ) | (
    { __typename?: 'Button' }
    & EnrichedMeta_Button_Fragment
  ) | (
    { __typename?: 'Card' }
    & EnrichedMeta_Card_Fragment
  ) | (
    { __typename?: 'Category' }
    & EnrichedMeta_Category_Fragment
  ) | (
    { __typename?: 'CategoryPicker' }
    & EnrichedMeta_CategoryPicker_Fragment
  ) | (
    { __typename?: 'CityLinks' }
    & EnrichedMeta_CityLinks_Fragment
  ) | (
    { __typename?: 'Columns' }
    & EnrichedMeta_Columns_Fragment
  ) | (
    { __typename?: 'ConfirmationStep' }
    & EnrichedMeta_ConfirmationStep_Fragment
  ) | (
    { __typename?: 'ContentSection' }
    & EnrichedMeta_ContentSection_Fragment
  ) | (
    { __typename?: 'ContentTile' }
    & EnrichedMeta_ContentTile_Fragment
  ) | (
    { __typename?: 'ContentTypeRichText' }
    & EnrichedMeta_ContentTypeRichText_Fragment
  ) | (
    { __typename?: 'DisclaimerV2' }
    & EnrichedMeta_DisclaimerV2_Fragment
  ) | (
    { __typename?: 'Error404' }
    & EnrichedMeta_Error404_Fragment
  ) | (
    { __typename?: 'FacilityDetailsPage' }
    & EnrichedMeta_FacilityDetailsPage_Fragment
  ) | (
    { __typename?: 'FeatureFlags' }
    & EnrichedMeta_FeatureFlags_Fragment
  ) | (
    { __typename?: 'FocalPointImage' }
    & EnrichedMeta_FocalPointImage_Fragment
  ) | (
    { __typename?: 'FooterNavigationGroup' }
    & EnrichedMeta_FooterNavigationGroup_Fragment
  ) | (
    { __typename?: 'FormDropdownField' }
    & EnrichedMeta_FormDropdownField_Fragment
  ) | (
    { __typename?: 'FormDropdownListItem' }
    & EnrichedMeta_FormDropdownListItem_Fragment
  ) | (
    { __typename?: 'FormField' }
    & EnrichedMeta_FormField_Fragment
  ) | (
    { __typename?: 'GoogleMapTemplate' }
    & EnrichedMeta_GoogleMapTemplate_Fragment
  ) | (
    { __typename?: 'HalfScreen' }
    & EnrichedMeta_HalfScreen_Fragment
  ) | (
    { __typename?: 'Header' }
    & EnrichedMeta_Header_Fragment
  ) | (
    { __typename?: 'HeaderMainNav' }
    & EnrichedMeta_HeaderMainNav_Fragment
  ) | (
    { __typename?: 'HeaderNavMenu' }
    & EnrichedMeta_HeaderNavMenu_Fragment
  ) | (
    { __typename?: 'HeaderSubNav' }
    & EnrichedMeta_HeaderSubNav_Fragment
  ) | (
    { __typename?: 'HeroV2' }
    & EnrichedMeta_HeroV2_Fragment
  ) | (
    { __typename?: 'Iframe' }
    & EnrichedMeta_Iframe_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & EnrichedMeta_ImageAsset_Fragment
  ) | (
    { __typename?: 'Insurance' }
    & EnrichedMeta_Insurance_Fragment
  ) | (
    { __typename?: 'LinkForwarder' }
    & EnrichedMeta_LinkForwarder_Fragment
  ) | (
    { __typename?: 'LocalizedServiceTitle' }
    & EnrichedMeta_LocalizedServiceTitle_Fragment
  ) | (
    { __typename?: 'Marquee' }
    & EnrichedMeta_Marquee_Fragment
  ) | (
    { __typename?: 'MediaSlider' }
    & EnrichedMeta_MediaSlider_Fragment
  ) | (
    { __typename?: 'MedicalService' }
    & EnrichedMeta_MedicalService_Fragment
  ) | (
    { __typename?: 'MeetOurStaff' }
    & EnrichedMeta_MeetOurStaff_Fragment
  ) | (
    { __typename?: 'MobileButton' }
    & EnrichedMeta_MobileButton_Fragment
  ) | (
    { __typename?: 'MultiCardV2' }
    & EnrichedMeta_MultiCardV2_Fragment
  ) | (
    { __typename?: 'NavigationGroup' }
    & EnrichedMeta_NavigationGroup_Fragment
  ) | (
    { __typename?: 'NavigationLink' }
    & EnrichedMeta_NavigationLink_Fragment
  ) | (
    { __typename?: 'OdpHero' }
    & EnrichedMeta_OdpHero_Fragment
  ) | (
    { __typename?: 'Page' }
    & EnrichedMeta_Page_Fragment
    & BasePageFragment
  ) | (
    { __typename?: 'PatientReviewV2' }
    & EnrichedMeta_PatientReviewV2_Fragment
  ) | (
    { __typename?: 'PatientReviewsV2' }
    & EnrichedMeta_PatientReviewsV2_Fragment
  ) | (
    { __typename?: 'Product' }
    & EnrichedMeta_Product_Fragment
  ) | (
    { __typename?: 'ProductDisplay' }
    & EnrichedMeta_ProductDisplay_Fragment
  ) | (
    { __typename?: 'ProductFeature' }
    & EnrichedMeta_ProductFeature_Fragment
  ) | (
    { __typename?: 'ProductFeatureDescriptionListItem' }
    & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
  ) | (
    { __typename?: 'ProviderDetailsPage' }
    & EnrichedMeta_ProviderDetailsPage_Fragment
  ) | (
    { __typename?: 'Questionnaire' }
    & EnrichedMeta_Questionnaire_Fragment
  ) | (
    { __typename?: 'QuickLinks' }
    & EnrichedMeta_QuickLinks_Fragment
  ) | (
    { __typename?: 'Quiz' }
    & EnrichedMeta_Quiz_Fragment
  ) | (
    { __typename?: 'ReviewStep' }
    & EnrichedMeta_ReviewStep_Fragment
  ) | (
    { __typename?: 'Schema' }
    & EnrichedMeta_Schema_Fragment
  ) | (
    { __typename?: 'SectionContent' }
    & EnrichedMeta_SectionContent_Fragment
  ) | (
    { __typename?: 'SegmentsContainer' }
    & EnrichedMeta_SegmentsContainer_Fragment
  ) | (
    { __typename?: 'Service' }
    & EnrichedMeta_Service_Fragment
  ) | (
    { __typename?: 'ServiceDetailsPage' }
    & EnrichedMeta_ServiceDetailsPage_Fragment
  ) | (
    { __typename?: 'ServiceLineHero' }
    & EnrichedMeta_ServiceLineHero_Fragment
  ) | (
    { __typename?: 'SingleMessage' }
    & EnrichedMeta_SingleMessage_Fragment
  ) | (
    { __typename?: 'SmallScreenContent' }
    & EnrichedMeta_SmallScreenContent_Fragment
  ) | (
    { __typename?: 'SmileAssessmentForm' }
    & EnrichedMeta_SmileAssessmentForm_Fragment
  ) | (
    { __typename?: 'Spacer' }
    & EnrichedMeta_Spacer_Fragment
  ) | (
    { __typename?: 'StateLinks' }
    & EnrichedMeta_StateLinks_Fragment
  ) | (
    { __typename?: 'Stepper' }
    & EnrichedMeta_Stepper_Fragment
  ) | (
    { __typename?: 'SuccessCard' }
    & EnrichedMeta_SuccessCard_Fragment
  ) | (
    { __typename?: 'Tab' }
    & EnrichedMeta_Tab_Fragment
  ) | (
    { __typename?: 'Table' }
    & EnrichedMeta_Table_Fragment
  ) | (
    { __typename?: 'Tabs' }
    & EnrichedMeta_Tabs_Fragment
  ) | (
    { __typename?: 'TermsAndConditions' }
    & EnrichedMeta_TermsAndConditions_Fragment
  ) | (
    { __typename?: 'TextBlockSeo' }
    & EnrichedMeta_TextBlockSeo_Fragment
  ) | (
    { __typename?: 'Video' }
    & EnrichedMeta_Video_Fragment
  ) | (
    { __typename?: 'VideoAsset' }
    & EnrichedMeta_VideoAsset_Fragment
  ) | (
    { __typename?: 'VideoCarousel' }
    & EnrichedMeta_VideoCarousel_Fragment
  ) | (
    { __typename?: 'VideoWithContent' }
    & EnrichedMeta_VideoWithContent_Fragment
  ) | null>, hyperlink: Array<(
    { __typename?: 'Accordions' }
    & EnrichedMeta_Accordions_Fragment
  ) | (
    { __typename?: 'AdFooter' }
    & EnrichedMeta_AdFooter_Fragment
  ) | (
    { __typename?: 'AgendaModal' }
    & EnrichedMeta_AgendaModal_Fragment
  ) | (
    { __typename?: 'AgendaStepper' }
    & EnrichedMeta_AgendaStepper_Fragment
  ) | (
    { __typename?: 'AnalyticsContext' }
    & EnrichedMeta_AnalyticsContext_Fragment
  ) | (
    { __typename?: 'App' }
    & EnrichedMeta_App_Fragment
  ) | (
    { __typename?: 'AppointmentBookingPage' }
    & EnrichedMeta_AppointmentBookingPage_Fragment
  ) | (
    { __typename?: 'Badge' }
    & EnrichedMeta_Badge_Fragment
  ) | (
    { __typename?: 'Banner' }
    & EnrichedMeta_Banner_Fragment
  ) | (
    { __typename?: 'BirdEyeReviews' }
    & EnrichedMeta_BirdEyeReviews_Fragment
  ) | (
    { __typename?: 'BlogAuthor' }
    & EnrichedMeta_BlogAuthor_Fragment
  ) | (
    { __typename?: 'BlogCategory' }
    & EnrichedMeta_BlogCategory_Fragment
  ) | (
    { __typename?: 'BlogDetailsPage' }
    & EnrichedMeta_BlogDetailsPage_Fragment
  ) | (
    { __typename?: 'BlogList' }
    & EnrichedMeta_BlogList_Fragment
  ) | (
    { __typename?: 'BlogListPage' }
    & EnrichedMeta_BlogListPage_Fragment
  ) | (
    { __typename?: 'BlogSubCategory' }
    & EnrichedMeta_BlogSubCategory_Fragment
  ) | (
    { __typename?: 'Brand' }
    & EnrichedMeta_Brand_Fragment
  ) | (
    { __typename?: 'Button' }
    & EnrichedMeta_Button_Fragment
  ) | (
    { __typename?: 'Card' }
    & EnrichedMeta_Card_Fragment
  ) | (
    { __typename?: 'Category' }
    & EnrichedMeta_Category_Fragment
  ) | (
    { __typename?: 'CategoryPicker' }
    & EnrichedMeta_CategoryPicker_Fragment
  ) | (
    { __typename?: 'CityLinks' }
    & EnrichedMeta_CityLinks_Fragment
  ) | (
    { __typename?: 'Columns' }
    & EnrichedMeta_Columns_Fragment
  ) | (
    { __typename?: 'ConfirmationStep' }
    & EnrichedMeta_ConfirmationStep_Fragment
  ) | (
    { __typename?: 'ContentSection' }
    & EnrichedMeta_ContentSection_Fragment
  ) | (
    { __typename?: 'ContentTile' }
    & EnrichedMeta_ContentTile_Fragment
  ) | (
    { __typename?: 'ContentTypeRichText' }
    & EnrichedMeta_ContentTypeRichText_Fragment
  ) | (
    { __typename?: 'DisclaimerV2' }
    & EnrichedMeta_DisclaimerV2_Fragment
  ) | (
    { __typename?: 'Error404' }
    & EnrichedMeta_Error404_Fragment
  ) | (
    { __typename?: 'FacilityDetailsPage' }
    & EnrichedMeta_FacilityDetailsPage_Fragment
  ) | (
    { __typename?: 'FeatureFlags' }
    & EnrichedMeta_FeatureFlags_Fragment
  ) | (
    { __typename?: 'FocalPointImage' }
    & EnrichedMeta_FocalPointImage_Fragment
  ) | (
    { __typename?: 'FooterNavigationGroup' }
    & EnrichedMeta_FooterNavigationGroup_Fragment
  ) | (
    { __typename?: 'FormDropdownField' }
    & EnrichedMeta_FormDropdownField_Fragment
  ) | (
    { __typename?: 'FormDropdownListItem' }
    & EnrichedMeta_FormDropdownListItem_Fragment
  ) | (
    { __typename?: 'FormField' }
    & EnrichedMeta_FormField_Fragment
  ) | (
    { __typename?: 'GoogleMapTemplate' }
    & EnrichedMeta_GoogleMapTemplate_Fragment
  ) | (
    { __typename?: 'HalfScreen' }
    & EnrichedMeta_HalfScreen_Fragment
  ) | (
    { __typename?: 'Header' }
    & EnrichedMeta_Header_Fragment
  ) | (
    { __typename?: 'HeaderMainNav' }
    & EnrichedMeta_HeaderMainNav_Fragment
  ) | (
    { __typename?: 'HeaderNavMenu' }
    & EnrichedMeta_HeaderNavMenu_Fragment
  ) | (
    { __typename?: 'HeaderSubNav' }
    & EnrichedMeta_HeaderSubNav_Fragment
  ) | (
    { __typename?: 'HeroV2' }
    & EnrichedMeta_HeroV2_Fragment
  ) | (
    { __typename?: 'Iframe' }
    & EnrichedMeta_Iframe_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & EnrichedMeta_ImageAsset_Fragment
  ) | (
    { __typename?: 'Insurance' }
    & EnrichedMeta_Insurance_Fragment
  ) | (
    { __typename?: 'LinkForwarder' }
    & EnrichedMeta_LinkForwarder_Fragment
  ) | (
    { __typename?: 'LocalizedServiceTitle' }
    & EnrichedMeta_LocalizedServiceTitle_Fragment
  ) | (
    { __typename?: 'Marquee' }
    & EnrichedMeta_Marquee_Fragment
  ) | (
    { __typename?: 'MediaSlider' }
    & EnrichedMeta_MediaSlider_Fragment
  ) | (
    { __typename?: 'MedicalService' }
    & EnrichedMeta_MedicalService_Fragment
  ) | (
    { __typename?: 'MeetOurStaff' }
    & EnrichedMeta_MeetOurStaff_Fragment
  ) | (
    { __typename?: 'MobileButton' }
    & EnrichedMeta_MobileButton_Fragment
  ) | (
    { __typename?: 'MultiCardV2' }
    & EnrichedMeta_MultiCardV2_Fragment
  ) | (
    { __typename?: 'NavigationGroup' }
    & EnrichedMeta_NavigationGroup_Fragment
  ) | (
    { __typename?: 'NavigationLink' }
    & EnrichedMeta_NavigationLink_Fragment
  ) | (
    { __typename?: 'OdpHero' }
    & EnrichedMeta_OdpHero_Fragment
  ) | (
    { __typename?: 'Page' }
    & EnrichedMeta_Page_Fragment
    & BasePageFragment
  ) | (
    { __typename?: 'PatientReviewV2' }
    & EnrichedMeta_PatientReviewV2_Fragment
  ) | (
    { __typename?: 'PatientReviewsV2' }
    & EnrichedMeta_PatientReviewsV2_Fragment
  ) | (
    { __typename?: 'Product' }
    & EnrichedMeta_Product_Fragment
  ) | (
    { __typename?: 'ProductDisplay' }
    & EnrichedMeta_ProductDisplay_Fragment
  ) | (
    { __typename?: 'ProductFeature' }
    & EnrichedMeta_ProductFeature_Fragment
  ) | (
    { __typename?: 'ProductFeatureDescriptionListItem' }
    & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
  ) | (
    { __typename?: 'ProviderDetailsPage' }
    & EnrichedMeta_ProviderDetailsPage_Fragment
  ) | (
    { __typename?: 'Questionnaire' }
    & EnrichedMeta_Questionnaire_Fragment
  ) | (
    { __typename?: 'QuickLinks' }
    & EnrichedMeta_QuickLinks_Fragment
  ) | (
    { __typename?: 'Quiz' }
    & EnrichedMeta_Quiz_Fragment
  ) | (
    { __typename?: 'ReviewStep' }
    & EnrichedMeta_ReviewStep_Fragment
  ) | (
    { __typename?: 'Schema' }
    & EnrichedMeta_Schema_Fragment
  ) | (
    { __typename?: 'SectionContent' }
    & EnrichedMeta_SectionContent_Fragment
  ) | (
    { __typename?: 'SegmentsContainer' }
    & EnrichedMeta_SegmentsContainer_Fragment
  ) | (
    { __typename?: 'Service' }
    & EnrichedMeta_Service_Fragment
  ) | (
    { __typename?: 'ServiceDetailsPage' }
    & EnrichedMeta_ServiceDetailsPage_Fragment
  ) | (
    { __typename?: 'ServiceLineHero' }
    & EnrichedMeta_ServiceLineHero_Fragment
  ) | (
    { __typename?: 'SingleMessage' }
    & EnrichedMeta_SingleMessage_Fragment
  ) | (
    { __typename?: 'SmallScreenContent' }
    & EnrichedMeta_SmallScreenContent_Fragment
  ) | (
    { __typename?: 'SmileAssessmentForm' }
    & EnrichedMeta_SmileAssessmentForm_Fragment
  ) | (
    { __typename?: 'Spacer' }
    & EnrichedMeta_Spacer_Fragment
  ) | (
    { __typename?: 'StateLinks' }
    & EnrichedMeta_StateLinks_Fragment
  ) | (
    { __typename?: 'Stepper' }
    & EnrichedMeta_Stepper_Fragment
  ) | (
    { __typename?: 'SuccessCard' }
    & EnrichedMeta_SuccessCard_Fragment
  ) | (
    { __typename?: 'Tab' }
    & EnrichedMeta_Tab_Fragment
  ) | (
    { __typename?: 'Table' }
    & EnrichedMeta_Table_Fragment
  ) | (
    { __typename?: 'Tabs' }
    & EnrichedMeta_Tabs_Fragment
  ) | (
    { __typename?: 'TermsAndConditions' }
    & EnrichedMeta_TermsAndConditions_Fragment
  ) | (
    { __typename?: 'TextBlockSeo' }
    & EnrichedMeta_TextBlockSeo_Fragment
  ) | (
    { __typename?: 'Video' }
    & EnrichedMeta_Video_Fragment
  ) | (
    { __typename?: 'VideoAsset' }
    & EnrichedMeta_VideoAsset_Fragment
  ) | (
    { __typename?: 'VideoCarousel' }
    & EnrichedMeta_VideoCarousel_Fragment
  ) | (
    { __typename?: 'VideoWithContent' }
    & EnrichedMeta_VideoWithContent_Fragment
  ) | null> };

export type BlogAuthorAuthorBioSummaryResourcesFragment = { __typename?: 'BlogAuthorAuthorBioSummaryResources', block: Array<(
    { __typename?: 'BlogAuthorAuthorBioSummaryResourcesBlock' }
    & ResourceMeta_BlogAuthorAuthorBioSummaryResourcesBlock_Fragment
  )>, inline: Array<(
    { __typename?: 'BlogAuthorAuthorBioSummaryResourcesInline' }
    & ResourceMeta_BlogAuthorAuthorBioSummaryResourcesInline_Fragment
  )>, hyperlink: Array<(
    { __typename?: 'BlogAuthorAuthorBioSummaryResourcesHyperlink' }
    & ResourceMeta_BlogAuthorAuthorBioSummaryResourcesHyperlink_Fragment
  )> };

export type BlogAuthorAuthorBioSummaryFragment = { __typename?: 'BlogAuthorAuthorBioSummary', json: any, links: { __typename?: 'BlogAuthorAuthorBioSummaryLinks', assets: (
      { __typename?: 'BlogAuthorAuthorBioSummaryAssets' }
      & BlogAuthorAuthorBioSummaryAssetsFragment
    ), entries: (
      { __typename?: 'BlogAuthorAuthorBioSummaryEntries' }
      & BlogAuthorAuthorBioSummaryEntriesFragment
    ), resources: (
      { __typename?: 'BlogAuthorAuthorBioSummaryResources' }
      & BlogAuthorAuthorBioSummaryResourcesFragment
    ) } };

export type BlogCategoryFragment = (
  { __typename?: 'BlogCategory', name?: string | null, slug?: string | null }
  & Meta_BlogCategory_Fragment
);

export type BlogDetailsPageFragment = (
  { __typename?: 'BlogDetailsPage', name?: string | null, path?: string | null, metaTitle?: string | null, metaDescription?: string | null, canonical?: string | null, indexed?: boolean | null, pageDesignType?: string | null, heroBackgroundColor?: string | null, date?: any | null, title?: string | null, blogImage?: any | null, timeToRead?: number | null, disableStickyFooterOnDesktop?: boolean | null, disableStickyFooterOnMobile?: boolean | null, disableHeaderTopAlertBanner?: boolean | null, disableHeaderBottomAlertBanner?: boolean | null, brand?: (
    { __typename?: 'Brand' }
    & BrandFragment
  ) | null, summary?: (
    { __typename?: 'BlogDetailsPageSummary' }
    & BlogDetailsPageSummaryFragment
  ) | null, category?: (
    { __typename?: 'BlogCategory' }
    & BlogCategoryFragment
  ) | null, subCategory?: (
    { __typename?: 'BlogSubCategory' }
    & BlogSubCategoryFragment
  ) | null, text?: (
    { __typename?: 'BlogDetailsPageText' }
    & BlogDetailsPageTextFragment
  ) | null, author?: (
    { __typename?: 'BlogAuthor' }
    & BlogAuthorFragment
  ) | null, reviewer?: (
    { __typename?: 'BlogAuthor' }
    & BlogAuthorFragment
  ) | null, imageAsset?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null, heroContentTitle?: { __typename?: 'BlogDetailsPageHeroContentTitle', json: any } | null, heroContentCollection?: { __typename?: 'BlogDetailsPageHeroContentCollection', items: Array<(
      { __typename?: 'ContentTypeRichText' }
      & RichTextFragment
    ) | null> } | null, heroButtonCollection?: { __typename?: 'BlogDetailsPageHeroButtonCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null, relatedBlogsContentSection?: (
    { __typename?: 'ContentSection' }
    & ContentSectionFragment
  ) | null, additionalContentCollection?: { __typename?: 'BlogDetailsPageAdditionalContentCollection', items: Array<(
      { __typename?: 'Accordions' }
      & AccordionFragment
    ) | (
      { __typename?: 'SingleMessage' }
      & SingleMessageFragment
    ) | null> } | null }
  & Meta_BlogDetailsPage_Fragment
);

export type BlogDetailsPageBaseFragment = (
  { __typename?: 'BlogDetailsPage', path?: string | null }
  & Meta_BlogDetailsPage_Fragment
);

export type HeroBlogDetailsPageListFragment = (
  { __typename?: 'BlogDetailsPage', title?: string | null, path?: string | null, blogImage?: any | null, summary?: { __typename?: 'BlogDetailsPageSummary', json: any } | null, imageAsset?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null }
  & Meta_BlogDetailsPage_Fragment
);

export type FeaturedBlogDetailsPageListFragment = (
  { __typename?: 'BlogDetailsPage', title?: string | null, date?: any | null, path?: string | null, timeToRead?: number | null, blogImage?: any | null, summary?: { __typename?: 'BlogDetailsPageSummary', json: any } | null, imageAsset?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null, category?: (
    { __typename?: 'BlogCategory' }
    & BlogCategoryFragment
  ) | null, subCategory?: (
    { __typename?: 'BlogSubCategory' }
    & BlogSubCategoryFragment
  ) | null }
  & Meta_BlogDetailsPage_Fragment
);

export type BlogDetailsPageSummaryAssetsFragment = { __typename?: 'BlogDetailsPageSummaryAssets', block: Array<(
    { __typename?: 'Asset', contentType?: string | null, url?: string | null, description?: string | null, fileName?: string | null }
    & LinkMetaFragment
  ) | null>, hyperlink: Array<(
    { __typename?: 'Asset', contentType?: string | null, url?: string | null, description?: string | null, fileName?: string | null }
    & LinkMetaFragment
  ) | null> };

export type BlogDetailsPageSummaryEntriesFragment = { __typename?: 'BlogDetailsPageSummaryEntries', inline: Array<(
    { __typename?: 'Accordions' }
    & EnrichedMeta_Accordions_Fragment
  ) | (
    { __typename?: 'AdFooter' }
    & EnrichedMeta_AdFooter_Fragment
  ) | (
    { __typename?: 'AgendaModal' }
    & EnrichedMeta_AgendaModal_Fragment
  ) | (
    { __typename?: 'AgendaStepper' }
    & EnrichedMeta_AgendaStepper_Fragment
  ) | (
    { __typename?: 'AnalyticsContext' }
    & EnrichedMeta_AnalyticsContext_Fragment
  ) | (
    { __typename?: 'App' }
    & EnrichedMeta_App_Fragment
  ) | (
    { __typename?: 'AppointmentBookingPage' }
    & EnrichedMeta_AppointmentBookingPage_Fragment
  ) | (
    { __typename?: 'Badge' }
    & EnrichedMeta_Badge_Fragment
  ) | (
    { __typename?: 'Banner' }
    & EnrichedMeta_Banner_Fragment
  ) | (
    { __typename?: 'BirdEyeReviews' }
    & EnrichedMeta_BirdEyeReviews_Fragment
  ) | (
    { __typename?: 'BlogAuthor' }
    & EnrichedMeta_BlogAuthor_Fragment
  ) | (
    { __typename?: 'BlogCategory' }
    & EnrichedMeta_BlogCategory_Fragment
  ) | (
    { __typename?: 'BlogDetailsPage' }
    & EnrichedMeta_BlogDetailsPage_Fragment
  ) | (
    { __typename?: 'BlogList' }
    & EnrichedMeta_BlogList_Fragment
  ) | (
    { __typename?: 'BlogListPage' }
    & EnrichedMeta_BlogListPage_Fragment
  ) | (
    { __typename?: 'BlogSubCategory' }
    & EnrichedMeta_BlogSubCategory_Fragment
  ) | (
    { __typename?: 'Brand' }
    & EnrichedMeta_Brand_Fragment
  ) | (
    { __typename?: 'Button' }
    & EnrichedMeta_Button_Fragment
  ) | (
    { __typename?: 'Card' }
    & EnrichedMeta_Card_Fragment
  ) | (
    { __typename?: 'Category' }
    & EnrichedMeta_Category_Fragment
  ) | (
    { __typename?: 'CategoryPicker' }
    & EnrichedMeta_CategoryPicker_Fragment
  ) | (
    { __typename?: 'CityLinks' }
    & EnrichedMeta_CityLinks_Fragment
  ) | (
    { __typename?: 'Columns' }
    & EnrichedMeta_Columns_Fragment
  ) | (
    { __typename?: 'ConfirmationStep' }
    & EnrichedMeta_ConfirmationStep_Fragment
  ) | (
    { __typename?: 'ContentSection' }
    & EnrichedMeta_ContentSection_Fragment
  ) | (
    { __typename?: 'ContentTile' }
    & EnrichedMeta_ContentTile_Fragment
  ) | (
    { __typename?: 'ContentTypeRichText' }
    & EnrichedMeta_ContentTypeRichText_Fragment
  ) | (
    { __typename?: 'DisclaimerV2' }
    & EnrichedMeta_DisclaimerV2_Fragment
  ) | (
    { __typename?: 'Error404' }
    & EnrichedMeta_Error404_Fragment
  ) | (
    { __typename?: 'FacilityDetailsPage' }
    & EnrichedMeta_FacilityDetailsPage_Fragment
  ) | (
    { __typename?: 'FeatureFlags' }
    & EnrichedMeta_FeatureFlags_Fragment
  ) | (
    { __typename?: 'FocalPointImage' }
    & EnrichedMeta_FocalPointImage_Fragment
  ) | (
    { __typename?: 'FooterNavigationGroup' }
    & EnrichedMeta_FooterNavigationGroup_Fragment
  ) | (
    { __typename?: 'FormDropdownField' }
    & EnrichedMeta_FormDropdownField_Fragment
  ) | (
    { __typename?: 'FormDropdownListItem' }
    & EnrichedMeta_FormDropdownListItem_Fragment
  ) | (
    { __typename?: 'FormField' }
    & EnrichedMeta_FormField_Fragment
  ) | (
    { __typename?: 'GoogleMapTemplate' }
    & EnrichedMeta_GoogleMapTemplate_Fragment
  ) | (
    { __typename?: 'HalfScreen' }
    & EnrichedMeta_HalfScreen_Fragment
  ) | (
    { __typename?: 'Header' }
    & EnrichedMeta_Header_Fragment
  ) | (
    { __typename?: 'HeaderMainNav' }
    & EnrichedMeta_HeaderMainNav_Fragment
  ) | (
    { __typename?: 'HeaderNavMenu' }
    & EnrichedMeta_HeaderNavMenu_Fragment
  ) | (
    { __typename?: 'HeaderSubNav' }
    & EnrichedMeta_HeaderSubNav_Fragment
  ) | (
    { __typename?: 'HeroV2' }
    & EnrichedMeta_HeroV2_Fragment
  ) | (
    { __typename?: 'Iframe' }
    & EnrichedMeta_Iframe_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & EnrichedMeta_ImageAsset_Fragment
  ) | (
    { __typename?: 'Insurance' }
    & EnrichedMeta_Insurance_Fragment
  ) | (
    { __typename?: 'LinkForwarder' }
    & EnrichedMeta_LinkForwarder_Fragment
  ) | (
    { __typename?: 'LocalizedServiceTitle' }
    & EnrichedMeta_LocalizedServiceTitle_Fragment
  ) | (
    { __typename?: 'Marquee' }
    & EnrichedMeta_Marquee_Fragment
  ) | (
    { __typename?: 'MediaSlider' }
    & EnrichedMeta_MediaSlider_Fragment
  ) | (
    { __typename?: 'MedicalService' }
    & EnrichedMeta_MedicalService_Fragment
  ) | (
    { __typename?: 'MeetOurStaff' }
    & EnrichedMeta_MeetOurStaff_Fragment
  ) | (
    { __typename?: 'MobileButton' }
    & EnrichedMeta_MobileButton_Fragment
  ) | (
    { __typename?: 'MultiCardV2' }
    & EnrichedMeta_MultiCardV2_Fragment
  ) | (
    { __typename?: 'NavigationGroup' }
    & EnrichedMeta_NavigationGroup_Fragment
  ) | (
    { __typename?: 'NavigationLink' }
    & EnrichedMeta_NavigationLink_Fragment
  ) | (
    { __typename?: 'OdpHero' }
    & EnrichedMeta_OdpHero_Fragment
  ) | (
    { __typename?: 'Page' }
    & EnrichedMeta_Page_Fragment
    & BasePageFragment
  ) | (
    { __typename?: 'PatientReviewV2' }
    & EnrichedMeta_PatientReviewV2_Fragment
  ) | (
    { __typename?: 'PatientReviewsV2' }
    & EnrichedMeta_PatientReviewsV2_Fragment
  ) | (
    { __typename?: 'Product' }
    & EnrichedMeta_Product_Fragment
  ) | (
    { __typename?: 'ProductDisplay' }
    & EnrichedMeta_ProductDisplay_Fragment
  ) | (
    { __typename?: 'ProductFeature' }
    & EnrichedMeta_ProductFeature_Fragment
  ) | (
    { __typename?: 'ProductFeatureDescriptionListItem' }
    & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
  ) | (
    { __typename?: 'ProviderDetailsPage' }
    & EnrichedMeta_ProviderDetailsPage_Fragment
  ) | (
    { __typename?: 'Questionnaire' }
    & EnrichedMeta_Questionnaire_Fragment
  ) | (
    { __typename?: 'QuickLinks' }
    & EnrichedMeta_QuickLinks_Fragment
  ) | (
    { __typename?: 'Quiz' }
    & EnrichedMeta_Quiz_Fragment
  ) | (
    { __typename?: 'ReviewStep' }
    & EnrichedMeta_ReviewStep_Fragment
  ) | (
    { __typename?: 'Schema' }
    & EnrichedMeta_Schema_Fragment
  ) | (
    { __typename?: 'SectionContent' }
    & EnrichedMeta_SectionContent_Fragment
  ) | (
    { __typename?: 'SegmentsContainer' }
    & EnrichedMeta_SegmentsContainer_Fragment
  ) | (
    { __typename?: 'Service' }
    & EnrichedMeta_Service_Fragment
  ) | (
    { __typename?: 'ServiceDetailsPage' }
    & EnrichedMeta_ServiceDetailsPage_Fragment
  ) | (
    { __typename?: 'ServiceLineHero' }
    & EnrichedMeta_ServiceLineHero_Fragment
  ) | (
    { __typename?: 'SingleMessage' }
    & EnrichedMeta_SingleMessage_Fragment
  ) | (
    { __typename?: 'SmallScreenContent' }
    & EnrichedMeta_SmallScreenContent_Fragment
  ) | (
    { __typename?: 'SmileAssessmentForm' }
    & EnrichedMeta_SmileAssessmentForm_Fragment
  ) | (
    { __typename?: 'Spacer' }
    & EnrichedMeta_Spacer_Fragment
  ) | (
    { __typename?: 'StateLinks' }
    & EnrichedMeta_StateLinks_Fragment
  ) | (
    { __typename?: 'Stepper' }
    & EnrichedMeta_Stepper_Fragment
  ) | (
    { __typename?: 'SuccessCard' }
    & EnrichedMeta_SuccessCard_Fragment
  ) | (
    { __typename?: 'Tab' }
    & EnrichedMeta_Tab_Fragment
  ) | (
    { __typename?: 'Table' }
    & EnrichedMeta_Table_Fragment
  ) | (
    { __typename?: 'Tabs' }
    & EnrichedMeta_Tabs_Fragment
  ) | (
    { __typename?: 'TermsAndConditions' }
    & EnrichedMeta_TermsAndConditions_Fragment
  ) | (
    { __typename?: 'TextBlockSeo' }
    & EnrichedMeta_TextBlockSeo_Fragment
  ) | (
    { __typename?: 'Video' }
    & EnrichedMeta_Video_Fragment
  ) | (
    { __typename?: 'VideoAsset' }
    & EnrichedMeta_VideoAsset_Fragment
  ) | (
    { __typename?: 'VideoCarousel' }
    & EnrichedMeta_VideoCarousel_Fragment
  ) | (
    { __typename?: 'VideoWithContent' }
    & EnrichedMeta_VideoWithContent_Fragment
  ) | null>, block: Array<(
    { __typename?: 'Accordions' }
    & EnrichedMeta_Accordions_Fragment
  ) | (
    { __typename?: 'AdFooter' }
    & EnrichedMeta_AdFooter_Fragment
  ) | (
    { __typename?: 'AgendaModal' }
    & EnrichedMeta_AgendaModal_Fragment
  ) | (
    { __typename?: 'AgendaStepper' }
    & EnrichedMeta_AgendaStepper_Fragment
  ) | (
    { __typename?: 'AnalyticsContext' }
    & EnrichedMeta_AnalyticsContext_Fragment
  ) | (
    { __typename?: 'App' }
    & EnrichedMeta_App_Fragment
  ) | (
    { __typename?: 'AppointmentBookingPage' }
    & EnrichedMeta_AppointmentBookingPage_Fragment
  ) | (
    { __typename?: 'Badge' }
    & EnrichedMeta_Badge_Fragment
  ) | (
    { __typename?: 'Banner' }
    & EnrichedMeta_Banner_Fragment
  ) | (
    { __typename?: 'BirdEyeReviews' }
    & EnrichedMeta_BirdEyeReviews_Fragment
  ) | (
    { __typename?: 'BlogAuthor' }
    & EnrichedMeta_BlogAuthor_Fragment
  ) | (
    { __typename?: 'BlogCategory' }
    & EnrichedMeta_BlogCategory_Fragment
  ) | (
    { __typename?: 'BlogDetailsPage' }
    & EnrichedMeta_BlogDetailsPage_Fragment
  ) | (
    { __typename?: 'BlogList' }
    & EnrichedMeta_BlogList_Fragment
  ) | (
    { __typename?: 'BlogListPage' }
    & EnrichedMeta_BlogListPage_Fragment
  ) | (
    { __typename?: 'BlogSubCategory' }
    & EnrichedMeta_BlogSubCategory_Fragment
  ) | (
    { __typename?: 'Brand' }
    & EnrichedMeta_Brand_Fragment
  ) | (
    { __typename?: 'Button' }
    & EnrichedMeta_Button_Fragment
  ) | (
    { __typename?: 'Card' }
    & EnrichedMeta_Card_Fragment
  ) | (
    { __typename?: 'Category' }
    & EnrichedMeta_Category_Fragment
  ) | (
    { __typename?: 'CategoryPicker' }
    & EnrichedMeta_CategoryPicker_Fragment
  ) | (
    { __typename?: 'CityLinks' }
    & EnrichedMeta_CityLinks_Fragment
  ) | (
    { __typename?: 'Columns' }
    & EnrichedMeta_Columns_Fragment
  ) | (
    { __typename?: 'ConfirmationStep' }
    & EnrichedMeta_ConfirmationStep_Fragment
  ) | (
    { __typename?: 'ContentSection' }
    & EnrichedMeta_ContentSection_Fragment
  ) | (
    { __typename?: 'ContentTile' }
    & EnrichedMeta_ContentTile_Fragment
  ) | (
    { __typename?: 'ContentTypeRichText' }
    & EnrichedMeta_ContentTypeRichText_Fragment
  ) | (
    { __typename?: 'DisclaimerV2' }
    & EnrichedMeta_DisclaimerV2_Fragment
  ) | (
    { __typename?: 'Error404' }
    & EnrichedMeta_Error404_Fragment
  ) | (
    { __typename?: 'FacilityDetailsPage' }
    & EnrichedMeta_FacilityDetailsPage_Fragment
  ) | (
    { __typename?: 'FeatureFlags' }
    & EnrichedMeta_FeatureFlags_Fragment
  ) | (
    { __typename?: 'FocalPointImage' }
    & EnrichedMeta_FocalPointImage_Fragment
  ) | (
    { __typename?: 'FooterNavigationGroup' }
    & EnrichedMeta_FooterNavigationGroup_Fragment
  ) | (
    { __typename?: 'FormDropdownField' }
    & EnrichedMeta_FormDropdownField_Fragment
  ) | (
    { __typename?: 'FormDropdownListItem' }
    & EnrichedMeta_FormDropdownListItem_Fragment
  ) | (
    { __typename?: 'FormField' }
    & EnrichedMeta_FormField_Fragment
  ) | (
    { __typename?: 'GoogleMapTemplate' }
    & EnrichedMeta_GoogleMapTemplate_Fragment
  ) | (
    { __typename?: 'HalfScreen' }
    & EnrichedMeta_HalfScreen_Fragment
  ) | (
    { __typename?: 'Header' }
    & EnrichedMeta_Header_Fragment
  ) | (
    { __typename?: 'HeaderMainNav' }
    & EnrichedMeta_HeaderMainNav_Fragment
  ) | (
    { __typename?: 'HeaderNavMenu' }
    & EnrichedMeta_HeaderNavMenu_Fragment
  ) | (
    { __typename?: 'HeaderSubNav' }
    & EnrichedMeta_HeaderSubNav_Fragment
  ) | (
    { __typename?: 'HeroV2' }
    & EnrichedMeta_HeroV2_Fragment
  ) | (
    { __typename?: 'Iframe' }
    & EnrichedMeta_Iframe_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & EnrichedMeta_ImageAsset_Fragment
  ) | (
    { __typename?: 'Insurance' }
    & EnrichedMeta_Insurance_Fragment
  ) | (
    { __typename?: 'LinkForwarder' }
    & EnrichedMeta_LinkForwarder_Fragment
  ) | (
    { __typename?: 'LocalizedServiceTitle' }
    & EnrichedMeta_LocalizedServiceTitle_Fragment
  ) | (
    { __typename?: 'Marquee' }
    & EnrichedMeta_Marquee_Fragment
  ) | (
    { __typename?: 'MediaSlider' }
    & EnrichedMeta_MediaSlider_Fragment
  ) | (
    { __typename?: 'MedicalService' }
    & EnrichedMeta_MedicalService_Fragment
  ) | (
    { __typename?: 'MeetOurStaff' }
    & EnrichedMeta_MeetOurStaff_Fragment
  ) | (
    { __typename?: 'MobileButton' }
    & EnrichedMeta_MobileButton_Fragment
  ) | (
    { __typename?: 'MultiCardV2' }
    & EnrichedMeta_MultiCardV2_Fragment
  ) | (
    { __typename?: 'NavigationGroup' }
    & EnrichedMeta_NavigationGroup_Fragment
  ) | (
    { __typename?: 'NavigationLink' }
    & EnrichedMeta_NavigationLink_Fragment
  ) | (
    { __typename?: 'OdpHero' }
    & EnrichedMeta_OdpHero_Fragment
  ) | (
    { __typename?: 'Page' }
    & EnrichedMeta_Page_Fragment
    & BasePageFragment
  ) | (
    { __typename?: 'PatientReviewV2' }
    & EnrichedMeta_PatientReviewV2_Fragment
  ) | (
    { __typename?: 'PatientReviewsV2' }
    & EnrichedMeta_PatientReviewsV2_Fragment
  ) | (
    { __typename?: 'Product' }
    & EnrichedMeta_Product_Fragment
  ) | (
    { __typename?: 'ProductDisplay' }
    & EnrichedMeta_ProductDisplay_Fragment
  ) | (
    { __typename?: 'ProductFeature' }
    & EnrichedMeta_ProductFeature_Fragment
  ) | (
    { __typename?: 'ProductFeatureDescriptionListItem' }
    & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
  ) | (
    { __typename?: 'ProviderDetailsPage' }
    & EnrichedMeta_ProviderDetailsPage_Fragment
  ) | (
    { __typename?: 'Questionnaire' }
    & EnrichedMeta_Questionnaire_Fragment
  ) | (
    { __typename?: 'QuickLinks' }
    & EnrichedMeta_QuickLinks_Fragment
  ) | (
    { __typename?: 'Quiz' }
    & EnrichedMeta_Quiz_Fragment
  ) | (
    { __typename?: 'ReviewStep' }
    & EnrichedMeta_ReviewStep_Fragment
  ) | (
    { __typename?: 'Schema' }
    & EnrichedMeta_Schema_Fragment
  ) | (
    { __typename?: 'SectionContent' }
    & EnrichedMeta_SectionContent_Fragment
  ) | (
    { __typename?: 'SegmentsContainer' }
    & EnrichedMeta_SegmentsContainer_Fragment
  ) | (
    { __typename?: 'Service' }
    & EnrichedMeta_Service_Fragment
  ) | (
    { __typename?: 'ServiceDetailsPage' }
    & EnrichedMeta_ServiceDetailsPage_Fragment
  ) | (
    { __typename?: 'ServiceLineHero' }
    & EnrichedMeta_ServiceLineHero_Fragment
  ) | (
    { __typename?: 'SingleMessage' }
    & EnrichedMeta_SingleMessage_Fragment
  ) | (
    { __typename?: 'SmallScreenContent' }
    & EnrichedMeta_SmallScreenContent_Fragment
  ) | (
    { __typename?: 'SmileAssessmentForm' }
    & EnrichedMeta_SmileAssessmentForm_Fragment
  ) | (
    { __typename?: 'Spacer' }
    & EnrichedMeta_Spacer_Fragment
  ) | (
    { __typename?: 'StateLinks' }
    & EnrichedMeta_StateLinks_Fragment
  ) | (
    { __typename?: 'Stepper' }
    & EnrichedMeta_Stepper_Fragment
  ) | (
    { __typename?: 'SuccessCard' }
    & EnrichedMeta_SuccessCard_Fragment
  ) | (
    { __typename?: 'Tab' }
    & EnrichedMeta_Tab_Fragment
  ) | (
    { __typename?: 'Table' }
    & EnrichedMeta_Table_Fragment
  ) | (
    { __typename?: 'Tabs' }
    & EnrichedMeta_Tabs_Fragment
  ) | (
    { __typename?: 'TermsAndConditions' }
    & EnrichedMeta_TermsAndConditions_Fragment
  ) | (
    { __typename?: 'TextBlockSeo' }
    & EnrichedMeta_TextBlockSeo_Fragment
  ) | (
    { __typename?: 'Video' }
    & EnrichedMeta_Video_Fragment
  ) | (
    { __typename?: 'VideoAsset' }
    & EnrichedMeta_VideoAsset_Fragment
  ) | (
    { __typename?: 'VideoCarousel' }
    & EnrichedMeta_VideoCarousel_Fragment
  ) | (
    { __typename?: 'VideoWithContent' }
    & EnrichedMeta_VideoWithContent_Fragment
  ) | null>, hyperlink: Array<(
    { __typename?: 'Accordions' }
    & EnrichedMeta_Accordions_Fragment
  ) | (
    { __typename?: 'AdFooter' }
    & EnrichedMeta_AdFooter_Fragment
  ) | (
    { __typename?: 'AgendaModal' }
    & EnrichedMeta_AgendaModal_Fragment
  ) | (
    { __typename?: 'AgendaStepper' }
    & EnrichedMeta_AgendaStepper_Fragment
  ) | (
    { __typename?: 'AnalyticsContext' }
    & EnrichedMeta_AnalyticsContext_Fragment
  ) | (
    { __typename?: 'App' }
    & EnrichedMeta_App_Fragment
  ) | (
    { __typename?: 'AppointmentBookingPage' }
    & EnrichedMeta_AppointmentBookingPage_Fragment
  ) | (
    { __typename?: 'Badge' }
    & EnrichedMeta_Badge_Fragment
  ) | (
    { __typename?: 'Banner' }
    & EnrichedMeta_Banner_Fragment
  ) | (
    { __typename?: 'BirdEyeReviews' }
    & EnrichedMeta_BirdEyeReviews_Fragment
  ) | (
    { __typename?: 'BlogAuthor' }
    & EnrichedMeta_BlogAuthor_Fragment
  ) | (
    { __typename?: 'BlogCategory' }
    & EnrichedMeta_BlogCategory_Fragment
  ) | (
    { __typename?: 'BlogDetailsPage' }
    & EnrichedMeta_BlogDetailsPage_Fragment
  ) | (
    { __typename?: 'BlogList' }
    & EnrichedMeta_BlogList_Fragment
  ) | (
    { __typename?: 'BlogListPage' }
    & EnrichedMeta_BlogListPage_Fragment
  ) | (
    { __typename?: 'BlogSubCategory' }
    & EnrichedMeta_BlogSubCategory_Fragment
  ) | (
    { __typename?: 'Brand' }
    & EnrichedMeta_Brand_Fragment
  ) | (
    { __typename?: 'Button' }
    & EnrichedMeta_Button_Fragment
  ) | (
    { __typename?: 'Card' }
    & EnrichedMeta_Card_Fragment
  ) | (
    { __typename?: 'Category' }
    & EnrichedMeta_Category_Fragment
  ) | (
    { __typename?: 'CategoryPicker' }
    & EnrichedMeta_CategoryPicker_Fragment
  ) | (
    { __typename?: 'CityLinks' }
    & EnrichedMeta_CityLinks_Fragment
  ) | (
    { __typename?: 'Columns' }
    & EnrichedMeta_Columns_Fragment
  ) | (
    { __typename?: 'ConfirmationStep' }
    & EnrichedMeta_ConfirmationStep_Fragment
  ) | (
    { __typename?: 'ContentSection' }
    & EnrichedMeta_ContentSection_Fragment
  ) | (
    { __typename?: 'ContentTile' }
    & EnrichedMeta_ContentTile_Fragment
  ) | (
    { __typename?: 'ContentTypeRichText' }
    & EnrichedMeta_ContentTypeRichText_Fragment
  ) | (
    { __typename?: 'DisclaimerV2' }
    & EnrichedMeta_DisclaimerV2_Fragment
  ) | (
    { __typename?: 'Error404' }
    & EnrichedMeta_Error404_Fragment
  ) | (
    { __typename?: 'FacilityDetailsPage' }
    & EnrichedMeta_FacilityDetailsPage_Fragment
  ) | (
    { __typename?: 'FeatureFlags' }
    & EnrichedMeta_FeatureFlags_Fragment
  ) | (
    { __typename?: 'FocalPointImage' }
    & EnrichedMeta_FocalPointImage_Fragment
  ) | (
    { __typename?: 'FooterNavigationGroup' }
    & EnrichedMeta_FooterNavigationGroup_Fragment
  ) | (
    { __typename?: 'FormDropdownField' }
    & EnrichedMeta_FormDropdownField_Fragment
  ) | (
    { __typename?: 'FormDropdownListItem' }
    & EnrichedMeta_FormDropdownListItem_Fragment
  ) | (
    { __typename?: 'FormField' }
    & EnrichedMeta_FormField_Fragment
  ) | (
    { __typename?: 'GoogleMapTemplate' }
    & EnrichedMeta_GoogleMapTemplate_Fragment
  ) | (
    { __typename?: 'HalfScreen' }
    & EnrichedMeta_HalfScreen_Fragment
  ) | (
    { __typename?: 'Header' }
    & EnrichedMeta_Header_Fragment
  ) | (
    { __typename?: 'HeaderMainNav' }
    & EnrichedMeta_HeaderMainNav_Fragment
  ) | (
    { __typename?: 'HeaderNavMenu' }
    & EnrichedMeta_HeaderNavMenu_Fragment
  ) | (
    { __typename?: 'HeaderSubNav' }
    & EnrichedMeta_HeaderSubNav_Fragment
  ) | (
    { __typename?: 'HeroV2' }
    & EnrichedMeta_HeroV2_Fragment
  ) | (
    { __typename?: 'Iframe' }
    & EnrichedMeta_Iframe_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & EnrichedMeta_ImageAsset_Fragment
  ) | (
    { __typename?: 'Insurance' }
    & EnrichedMeta_Insurance_Fragment
  ) | (
    { __typename?: 'LinkForwarder' }
    & EnrichedMeta_LinkForwarder_Fragment
  ) | (
    { __typename?: 'LocalizedServiceTitle' }
    & EnrichedMeta_LocalizedServiceTitle_Fragment
  ) | (
    { __typename?: 'Marquee' }
    & EnrichedMeta_Marquee_Fragment
  ) | (
    { __typename?: 'MediaSlider' }
    & EnrichedMeta_MediaSlider_Fragment
  ) | (
    { __typename?: 'MedicalService' }
    & EnrichedMeta_MedicalService_Fragment
  ) | (
    { __typename?: 'MeetOurStaff' }
    & EnrichedMeta_MeetOurStaff_Fragment
  ) | (
    { __typename?: 'MobileButton' }
    & EnrichedMeta_MobileButton_Fragment
  ) | (
    { __typename?: 'MultiCardV2' }
    & EnrichedMeta_MultiCardV2_Fragment
  ) | (
    { __typename?: 'NavigationGroup' }
    & EnrichedMeta_NavigationGroup_Fragment
  ) | (
    { __typename?: 'NavigationLink' }
    & EnrichedMeta_NavigationLink_Fragment
  ) | (
    { __typename?: 'OdpHero' }
    & EnrichedMeta_OdpHero_Fragment
  ) | (
    { __typename?: 'Page' }
    & EnrichedMeta_Page_Fragment
    & BasePageFragment
  ) | (
    { __typename?: 'PatientReviewV2' }
    & EnrichedMeta_PatientReviewV2_Fragment
  ) | (
    { __typename?: 'PatientReviewsV2' }
    & EnrichedMeta_PatientReviewsV2_Fragment
  ) | (
    { __typename?: 'Product' }
    & EnrichedMeta_Product_Fragment
  ) | (
    { __typename?: 'ProductDisplay' }
    & EnrichedMeta_ProductDisplay_Fragment
  ) | (
    { __typename?: 'ProductFeature' }
    & EnrichedMeta_ProductFeature_Fragment
  ) | (
    { __typename?: 'ProductFeatureDescriptionListItem' }
    & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
  ) | (
    { __typename?: 'ProviderDetailsPage' }
    & EnrichedMeta_ProviderDetailsPage_Fragment
  ) | (
    { __typename?: 'Questionnaire' }
    & EnrichedMeta_Questionnaire_Fragment
  ) | (
    { __typename?: 'QuickLinks' }
    & EnrichedMeta_QuickLinks_Fragment
  ) | (
    { __typename?: 'Quiz' }
    & EnrichedMeta_Quiz_Fragment
  ) | (
    { __typename?: 'ReviewStep' }
    & EnrichedMeta_ReviewStep_Fragment
  ) | (
    { __typename?: 'Schema' }
    & EnrichedMeta_Schema_Fragment
  ) | (
    { __typename?: 'SectionContent' }
    & EnrichedMeta_SectionContent_Fragment
  ) | (
    { __typename?: 'SegmentsContainer' }
    & EnrichedMeta_SegmentsContainer_Fragment
  ) | (
    { __typename?: 'Service' }
    & EnrichedMeta_Service_Fragment
  ) | (
    { __typename?: 'ServiceDetailsPage' }
    & EnrichedMeta_ServiceDetailsPage_Fragment
  ) | (
    { __typename?: 'ServiceLineHero' }
    & EnrichedMeta_ServiceLineHero_Fragment
  ) | (
    { __typename?: 'SingleMessage' }
    & EnrichedMeta_SingleMessage_Fragment
  ) | (
    { __typename?: 'SmallScreenContent' }
    & EnrichedMeta_SmallScreenContent_Fragment
  ) | (
    { __typename?: 'SmileAssessmentForm' }
    & EnrichedMeta_SmileAssessmentForm_Fragment
  ) | (
    { __typename?: 'Spacer' }
    & EnrichedMeta_Spacer_Fragment
  ) | (
    { __typename?: 'StateLinks' }
    & EnrichedMeta_StateLinks_Fragment
  ) | (
    { __typename?: 'Stepper' }
    & EnrichedMeta_Stepper_Fragment
  ) | (
    { __typename?: 'SuccessCard' }
    & EnrichedMeta_SuccessCard_Fragment
  ) | (
    { __typename?: 'Tab' }
    & EnrichedMeta_Tab_Fragment
  ) | (
    { __typename?: 'Table' }
    & EnrichedMeta_Table_Fragment
  ) | (
    { __typename?: 'Tabs' }
    & EnrichedMeta_Tabs_Fragment
  ) | (
    { __typename?: 'TermsAndConditions' }
    & EnrichedMeta_TermsAndConditions_Fragment
  ) | (
    { __typename?: 'TextBlockSeo' }
    & EnrichedMeta_TextBlockSeo_Fragment
  ) | (
    { __typename?: 'Video' }
    & EnrichedMeta_Video_Fragment
  ) | (
    { __typename?: 'VideoAsset' }
    & EnrichedMeta_VideoAsset_Fragment
  ) | (
    { __typename?: 'VideoCarousel' }
    & EnrichedMeta_VideoCarousel_Fragment
  ) | (
    { __typename?: 'VideoWithContent' }
    & EnrichedMeta_VideoWithContent_Fragment
  ) | null> };

export type BlogDetailsPageSummaryResourcesFragment = { __typename?: 'BlogDetailsPageSummaryResources', block: Array<(
    { __typename?: 'BlogDetailsPageSummaryResourcesBlock' }
    & ResourceMeta_BlogDetailsPageSummaryResourcesBlock_Fragment
  )>, inline: Array<(
    { __typename?: 'BlogDetailsPageSummaryResourcesInline' }
    & ResourceMeta_BlogDetailsPageSummaryResourcesInline_Fragment
  )>, hyperlink: Array<(
    { __typename?: 'BlogDetailsPageSummaryResourcesHyperlink' }
    & ResourceMeta_BlogDetailsPageSummaryResourcesHyperlink_Fragment
  )> };

export type BlogDetailsPageSummaryFragment = { __typename?: 'BlogDetailsPageSummary', json: any, links: { __typename?: 'BlogDetailsPageSummaryLinks', assets: (
      { __typename?: 'BlogDetailsPageSummaryAssets' }
      & BlogDetailsPageSummaryAssetsFragment
    ), entries: (
      { __typename?: 'BlogDetailsPageSummaryEntries' }
      & BlogDetailsPageSummaryEntriesFragment
    ), resources: (
      { __typename?: 'BlogDetailsPageSummaryResources' }
      & BlogDetailsPageSummaryResourcesFragment
    ) } };

export type BlogDetailsPageTextAssetsFragment = { __typename?: 'BlogDetailsPageTextAssets', block: Array<(
    { __typename?: 'Asset', contentType?: string | null, url?: string | null, description?: string | null, fileName?: string | null }
    & LinkMetaFragment
  ) | null>, hyperlink: Array<(
    { __typename?: 'Asset', contentType?: string | null, url?: string | null, description?: string | null, fileName?: string | null }
    & LinkMetaFragment
  ) | null> };

export type BlogDetailsPageTextEntriesFragment = { __typename?: 'BlogDetailsPageTextEntries', inline: Array<(
    { __typename?: 'Accordions' }
    & EnrichedMeta_Accordions_Fragment
  ) | (
    { __typename?: 'AdFooter' }
    & EnrichedMeta_AdFooter_Fragment
  ) | (
    { __typename?: 'AgendaModal' }
    & EnrichedMeta_AgendaModal_Fragment
  ) | (
    { __typename?: 'AgendaStepper' }
    & EnrichedMeta_AgendaStepper_Fragment
  ) | (
    { __typename?: 'AnalyticsContext' }
    & EnrichedMeta_AnalyticsContext_Fragment
  ) | (
    { __typename?: 'App' }
    & EnrichedMeta_App_Fragment
  ) | (
    { __typename?: 'AppointmentBookingPage' }
    & EnrichedMeta_AppointmentBookingPage_Fragment
  ) | (
    { __typename?: 'Badge' }
    & EnrichedMeta_Badge_Fragment
  ) | (
    { __typename?: 'Banner' }
    & EnrichedMeta_Banner_Fragment
  ) | (
    { __typename?: 'BirdEyeReviews' }
    & EnrichedMeta_BirdEyeReviews_Fragment
  ) | (
    { __typename?: 'BlogAuthor' }
    & EnrichedMeta_BlogAuthor_Fragment
  ) | (
    { __typename?: 'BlogCategory' }
    & EnrichedMeta_BlogCategory_Fragment
  ) | (
    { __typename?: 'BlogDetailsPage' }
    & EnrichedMeta_BlogDetailsPage_Fragment
  ) | (
    { __typename?: 'BlogList' }
    & EnrichedMeta_BlogList_Fragment
  ) | (
    { __typename?: 'BlogListPage' }
    & EnrichedMeta_BlogListPage_Fragment
  ) | (
    { __typename?: 'BlogSubCategory' }
    & EnrichedMeta_BlogSubCategory_Fragment
  ) | (
    { __typename?: 'Brand' }
    & EnrichedMeta_Brand_Fragment
  ) | (
    { __typename?: 'Button' }
    & EnrichedMeta_Button_Fragment
  ) | (
    { __typename?: 'Card' }
    & EnrichedMeta_Card_Fragment
  ) | (
    { __typename?: 'Category' }
    & EnrichedMeta_Category_Fragment
  ) | (
    { __typename?: 'CategoryPicker' }
    & EnrichedMeta_CategoryPicker_Fragment
  ) | (
    { __typename?: 'CityLinks' }
    & EnrichedMeta_CityLinks_Fragment
  ) | (
    { __typename?: 'Columns' }
    & EnrichedMeta_Columns_Fragment
  ) | (
    { __typename?: 'ConfirmationStep' }
    & EnrichedMeta_ConfirmationStep_Fragment
  ) | (
    { __typename?: 'ContentSection' }
    & EnrichedMeta_ContentSection_Fragment
  ) | (
    { __typename?: 'ContentTile' }
    & EnrichedMeta_ContentTile_Fragment
  ) | (
    { __typename?: 'ContentTypeRichText' }
    & EnrichedMeta_ContentTypeRichText_Fragment
  ) | (
    { __typename?: 'DisclaimerV2' }
    & EnrichedMeta_DisclaimerV2_Fragment
  ) | (
    { __typename?: 'Error404' }
    & EnrichedMeta_Error404_Fragment
  ) | (
    { __typename?: 'FacilityDetailsPage' }
    & EnrichedMeta_FacilityDetailsPage_Fragment
  ) | (
    { __typename?: 'FeatureFlags' }
    & EnrichedMeta_FeatureFlags_Fragment
  ) | (
    { __typename?: 'FocalPointImage' }
    & EnrichedMeta_FocalPointImage_Fragment
  ) | (
    { __typename?: 'FooterNavigationGroup' }
    & EnrichedMeta_FooterNavigationGroup_Fragment
  ) | (
    { __typename?: 'FormDropdownField' }
    & EnrichedMeta_FormDropdownField_Fragment
  ) | (
    { __typename?: 'FormDropdownListItem' }
    & EnrichedMeta_FormDropdownListItem_Fragment
  ) | (
    { __typename?: 'FormField' }
    & EnrichedMeta_FormField_Fragment
  ) | (
    { __typename?: 'GoogleMapTemplate' }
    & EnrichedMeta_GoogleMapTemplate_Fragment
  ) | (
    { __typename?: 'HalfScreen' }
    & EnrichedMeta_HalfScreen_Fragment
  ) | (
    { __typename?: 'Header' }
    & EnrichedMeta_Header_Fragment
  ) | (
    { __typename?: 'HeaderMainNav' }
    & EnrichedMeta_HeaderMainNav_Fragment
  ) | (
    { __typename?: 'HeaderNavMenu' }
    & EnrichedMeta_HeaderNavMenu_Fragment
  ) | (
    { __typename?: 'HeaderSubNav' }
    & EnrichedMeta_HeaderSubNav_Fragment
  ) | (
    { __typename?: 'HeroV2' }
    & EnrichedMeta_HeroV2_Fragment
  ) | (
    { __typename?: 'Iframe' }
    & EnrichedMeta_Iframe_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & EnrichedMeta_ImageAsset_Fragment
  ) | (
    { __typename?: 'Insurance' }
    & EnrichedMeta_Insurance_Fragment
  ) | (
    { __typename?: 'LinkForwarder' }
    & EnrichedMeta_LinkForwarder_Fragment
  ) | (
    { __typename?: 'LocalizedServiceTitle' }
    & EnrichedMeta_LocalizedServiceTitle_Fragment
  ) | (
    { __typename?: 'Marquee' }
    & EnrichedMeta_Marquee_Fragment
  ) | (
    { __typename?: 'MediaSlider' }
    & EnrichedMeta_MediaSlider_Fragment
  ) | (
    { __typename?: 'MedicalService' }
    & EnrichedMeta_MedicalService_Fragment
  ) | (
    { __typename?: 'MeetOurStaff' }
    & EnrichedMeta_MeetOurStaff_Fragment
  ) | (
    { __typename?: 'MobileButton' }
    & EnrichedMeta_MobileButton_Fragment
  ) | (
    { __typename?: 'MultiCardV2' }
    & EnrichedMeta_MultiCardV2_Fragment
  ) | (
    { __typename?: 'NavigationGroup' }
    & EnrichedMeta_NavigationGroup_Fragment
  ) | (
    { __typename?: 'NavigationLink' }
    & EnrichedMeta_NavigationLink_Fragment
  ) | (
    { __typename?: 'OdpHero' }
    & EnrichedMeta_OdpHero_Fragment
  ) | (
    { __typename?: 'Page' }
    & EnrichedMeta_Page_Fragment
    & BasePageFragment
  ) | (
    { __typename?: 'PatientReviewV2' }
    & EnrichedMeta_PatientReviewV2_Fragment
  ) | (
    { __typename?: 'PatientReviewsV2' }
    & EnrichedMeta_PatientReviewsV2_Fragment
  ) | (
    { __typename?: 'Product' }
    & EnrichedMeta_Product_Fragment
  ) | (
    { __typename?: 'ProductDisplay' }
    & EnrichedMeta_ProductDisplay_Fragment
  ) | (
    { __typename?: 'ProductFeature' }
    & EnrichedMeta_ProductFeature_Fragment
  ) | (
    { __typename?: 'ProductFeatureDescriptionListItem' }
    & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
  ) | (
    { __typename?: 'ProviderDetailsPage' }
    & EnrichedMeta_ProviderDetailsPage_Fragment
  ) | (
    { __typename?: 'Questionnaire' }
    & EnrichedMeta_Questionnaire_Fragment
  ) | (
    { __typename?: 'QuickLinks' }
    & EnrichedMeta_QuickLinks_Fragment
  ) | (
    { __typename?: 'Quiz' }
    & EnrichedMeta_Quiz_Fragment
  ) | (
    { __typename?: 'ReviewStep' }
    & EnrichedMeta_ReviewStep_Fragment
  ) | (
    { __typename?: 'Schema' }
    & EnrichedMeta_Schema_Fragment
  ) | (
    { __typename?: 'SectionContent' }
    & EnrichedMeta_SectionContent_Fragment
  ) | (
    { __typename?: 'SegmentsContainer' }
    & EnrichedMeta_SegmentsContainer_Fragment
  ) | (
    { __typename?: 'Service' }
    & EnrichedMeta_Service_Fragment
  ) | (
    { __typename?: 'ServiceDetailsPage' }
    & EnrichedMeta_ServiceDetailsPage_Fragment
  ) | (
    { __typename?: 'ServiceLineHero' }
    & EnrichedMeta_ServiceLineHero_Fragment
  ) | (
    { __typename?: 'SingleMessage' }
    & EnrichedMeta_SingleMessage_Fragment
  ) | (
    { __typename?: 'SmallScreenContent' }
    & EnrichedMeta_SmallScreenContent_Fragment
  ) | (
    { __typename?: 'SmileAssessmentForm' }
    & EnrichedMeta_SmileAssessmentForm_Fragment
  ) | (
    { __typename?: 'Spacer' }
    & EnrichedMeta_Spacer_Fragment
  ) | (
    { __typename?: 'StateLinks' }
    & EnrichedMeta_StateLinks_Fragment
  ) | (
    { __typename?: 'Stepper' }
    & EnrichedMeta_Stepper_Fragment
  ) | (
    { __typename?: 'SuccessCard' }
    & EnrichedMeta_SuccessCard_Fragment
  ) | (
    { __typename?: 'Tab' }
    & EnrichedMeta_Tab_Fragment
  ) | (
    { __typename?: 'Table' }
    & EnrichedMeta_Table_Fragment
  ) | (
    { __typename?: 'Tabs' }
    & EnrichedMeta_Tabs_Fragment
  ) | (
    { __typename?: 'TermsAndConditions' }
    & EnrichedMeta_TermsAndConditions_Fragment
  ) | (
    { __typename?: 'TextBlockSeo' }
    & EnrichedMeta_TextBlockSeo_Fragment
  ) | (
    { __typename?: 'Video' }
    & EnrichedMeta_Video_Fragment
  ) | (
    { __typename?: 'VideoAsset' }
    & EnrichedMeta_VideoAsset_Fragment
  ) | (
    { __typename?: 'VideoCarousel' }
    & EnrichedMeta_VideoCarousel_Fragment
  ) | (
    { __typename?: 'VideoWithContent' }
    & EnrichedMeta_VideoWithContent_Fragment
  ) | null>, block: Array<(
    { __typename?: 'Accordions' }
    & EnrichedMeta_Accordions_Fragment
  ) | (
    { __typename?: 'AdFooter' }
    & EnrichedMeta_AdFooter_Fragment
  ) | (
    { __typename?: 'AgendaModal' }
    & EnrichedMeta_AgendaModal_Fragment
  ) | (
    { __typename?: 'AgendaStepper' }
    & EnrichedMeta_AgendaStepper_Fragment
  ) | (
    { __typename?: 'AnalyticsContext' }
    & EnrichedMeta_AnalyticsContext_Fragment
  ) | (
    { __typename?: 'App' }
    & EnrichedMeta_App_Fragment
  ) | (
    { __typename?: 'AppointmentBookingPage' }
    & EnrichedMeta_AppointmentBookingPage_Fragment
  ) | (
    { __typename?: 'Badge' }
    & EnrichedMeta_Badge_Fragment
  ) | (
    { __typename?: 'Banner' }
    & EnrichedMeta_Banner_Fragment
  ) | (
    { __typename?: 'BirdEyeReviews' }
    & EnrichedMeta_BirdEyeReviews_Fragment
  ) | (
    { __typename?: 'BlogAuthor' }
    & EnrichedMeta_BlogAuthor_Fragment
  ) | (
    { __typename?: 'BlogCategory' }
    & EnrichedMeta_BlogCategory_Fragment
  ) | (
    { __typename?: 'BlogDetailsPage' }
    & EnrichedMeta_BlogDetailsPage_Fragment
  ) | (
    { __typename?: 'BlogList' }
    & EnrichedMeta_BlogList_Fragment
  ) | (
    { __typename?: 'BlogListPage' }
    & EnrichedMeta_BlogListPage_Fragment
  ) | (
    { __typename?: 'BlogSubCategory' }
    & EnrichedMeta_BlogSubCategory_Fragment
  ) | (
    { __typename?: 'Brand' }
    & EnrichedMeta_Brand_Fragment
  ) | (
    { __typename?: 'Button' }
    & EnrichedMeta_Button_Fragment
  ) | (
    { __typename?: 'Card' }
    & EnrichedMeta_Card_Fragment
  ) | (
    { __typename?: 'Category' }
    & EnrichedMeta_Category_Fragment
  ) | (
    { __typename?: 'CategoryPicker' }
    & EnrichedMeta_CategoryPicker_Fragment
  ) | (
    { __typename?: 'CityLinks' }
    & EnrichedMeta_CityLinks_Fragment
  ) | (
    { __typename?: 'Columns' }
    & EnrichedMeta_Columns_Fragment
    & ColumnsFragment
  ) | (
    { __typename?: 'ConfirmationStep' }
    & EnrichedMeta_ConfirmationStep_Fragment
  ) | (
    { __typename?: 'ContentSection' }
    & EnrichedMeta_ContentSection_Fragment
  ) | (
    { __typename?: 'ContentTile' }
    & EnrichedMeta_ContentTile_Fragment
  ) | (
    { __typename?: 'ContentTypeRichText' }
    & EnrichedMeta_ContentTypeRichText_Fragment
  ) | (
    { __typename?: 'DisclaimerV2' }
    & EnrichedMeta_DisclaimerV2_Fragment
  ) | (
    { __typename?: 'Error404' }
    & EnrichedMeta_Error404_Fragment
  ) | (
    { __typename?: 'FacilityDetailsPage' }
    & EnrichedMeta_FacilityDetailsPage_Fragment
  ) | (
    { __typename?: 'FeatureFlags' }
    & EnrichedMeta_FeatureFlags_Fragment
  ) | (
    { __typename?: 'FocalPointImage' }
    & EnrichedMeta_FocalPointImage_Fragment
  ) | (
    { __typename?: 'FooterNavigationGroup' }
    & EnrichedMeta_FooterNavigationGroup_Fragment
  ) | (
    { __typename?: 'FormDropdownField' }
    & EnrichedMeta_FormDropdownField_Fragment
  ) | (
    { __typename?: 'FormDropdownListItem' }
    & EnrichedMeta_FormDropdownListItem_Fragment
  ) | (
    { __typename?: 'FormField' }
    & EnrichedMeta_FormField_Fragment
  ) | (
    { __typename?: 'GoogleMapTemplate' }
    & EnrichedMeta_GoogleMapTemplate_Fragment
  ) | (
    { __typename?: 'HalfScreen' }
    & EnrichedMeta_HalfScreen_Fragment
  ) | (
    { __typename?: 'Header' }
    & EnrichedMeta_Header_Fragment
  ) | (
    { __typename?: 'HeaderMainNav' }
    & EnrichedMeta_HeaderMainNav_Fragment
  ) | (
    { __typename?: 'HeaderNavMenu' }
    & EnrichedMeta_HeaderNavMenu_Fragment
  ) | (
    { __typename?: 'HeaderSubNav' }
    & EnrichedMeta_HeaderSubNav_Fragment
  ) | (
    { __typename?: 'HeroV2' }
    & EnrichedMeta_HeroV2_Fragment
  ) | (
    { __typename?: 'Iframe' }
    & EnrichedMeta_Iframe_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & EnrichedMeta_ImageAsset_Fragment
  ) | (
    { __typename?: 'Insurance' }
    & EnrichedMeta_Insurance_Fragment
  ) | (
    { __typename?: 'LinkForwarder' }
    & EnrichedMeta_LinkForwarder_Fragment
  ) | (
    { __typename?: 'LocalizedServiceTitle' }
    & EnrichedMeta_LocalizedServiceTitle_Fragment
  ) | (
    { __typename?: 'Marquee' }
    & EnrichedMeta_Marquee_Fragment
  ) | (
    { __typename?: 'MediaSlider' }
    & EnrichedMeta_MediaSlider_Fragment
  ) | (
    { __typename?: 'MedicalService' }
    & EnrichedMeta_MedicalService_Fragment
  ) | (
    { __typename?: 'MeetOurStaff' }
    & EnrichedMeta_MeetOurStaff_Fragment
  ) | (
    { __typename?: 'MobileButton' }
    & EnrichedMeta_MobileButton_Fragment
  ) | (
    { __typename?: 'MultiCardV2' }
    & EnrichedMeta_MultiCardV2_Fragment
  ) | (
    { __typename?: 'NavigationGroup' }
    & EnrichedMeta_NavigationGroup_Fragment
  ) | (
    { __typename?: 'NavigationLink' }
    & EnrichedMeta_NavigationLink_Fragment
  ) | (
    { __typename?: 'OdpHero' }
    & EnrichedMeta_OdpHero_Fragment
  ) | (
    { __typename?: 'Page' }
    & EnrichedMeta_Page_Fragment
    & BasePageFragment
  ) | (
    { __typename?: 'PatientReviewV2' }
    & EnrichedMeta_PatientReviewV2_Fragment
  ) | (
    { __typename?: 'PatientReviewsV2' }
    & EnrichedMeta_PatientReviewsV2_Fragment
  ) | (
    { __typename?: 'Product' }
    & EnrichedMeta_Product_Fragment
  ) | (
    { __typename?: 'ProductDisplay' }
    & EnrichedMeta_ProductDisplay_Fragment
  ) | (
    { __typename?: 'ProductFeature' }
    & EnrichedMeta_ProductFeature_Fragment
  ) | (
    { __typename?: 'ProductFeatureDescriptionListItem' }
    & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
  ) | (
    { __typename?: 'ProviderDetailsPage' }
    & EnrichedMeta_ProviderDetailsPage_Fragment
  ) | (
    { __typename?: 'Questionnaire' }
    & EnrichedMeta_Questionnaire_Fragment
  ) | (
    { __typename?: 'QuickLinks' }
    & EnrichedMeta_QuickLinks_Fragment
  ) | (
    { __typename?: 'Quiz' }
    & EnrichedMeta_Quiz_Fragment
  ) | (
    { __typename?: 'ReviewStep' }
    & EnrichedMeta_ReviewStep_Fragment
  ) | (
    { __typename?: 'Schema' }
    & EnrichedMeta_Schema_Fragment
  ) | (
    { __typename?: 'SectionContent' }
    & EnrichedMeta_SectionContent_Fragment
  ) | (
    { __typename?: 'SegmentsContainer' }
    & EnrichedMeta_SegmentsContainer_Fragment
  ) | (
    { __typename?: 'Service' }
    & EnrichedMeta_Service_Fragment
  ) | (
    { __typename?: 'ServiceDetailsPage' }
    & EnrichedMeta_ServiceDetailsPage_Fragment
  ) | (
    { __typename?: 'ServiceLineHero' }
    & EnrichedMeta_ServiceLineHero_Fragment
  ) | (
    { __typename?: 'SingleMessage' }
    & EnrichedMeta_SingleMessage_Fragment
    & SingleMessageFragment
  ) | (
    { __typename?: 'SmallScreenContent' }
    & EnrichedMeta_SmallScreenContent_Fragment
  ) | (
    { __typename?: 'SmileAssessmentForm' }
    & EnrichedMeta_SmileAssessmentForm_Fragment
  ) | (
    { __typename?: 'Spacer' }
    & EnrichedMeta_Spacer_Fragment
  ) | (
    { __typename?: 'StateLinks' }
    & EnrichedMeta_StateLinks_Fragment
  ) | (
    { __typename?: 'Stepper' }
    & EnrichedMeta_Stepper_Fragment
  ) | (
    { __typename?: 'SuccessCard' }
    & EnrichedMeta_SuccessCard_Fragment
  ) | (
    { __typename?: 'Tab' }
    & EnrichedMeta_Tab_Fragment
  ) | (
    { __typename?: 'Table' }
    & EnrichedMeta_Table_Fragment
    & TableFragment
  ) | (
    { __typename?: 'Tabs' }
    & EnrichedMeta_Tabs_Fragment
  ) | (
    { __typename?: 'TermsAndConditions' }
    & EnrichedMeta_TermsAndConditions_Fragment
  ) | (
    { __typename?: 'TextBlockSeo' }
    & EnrichedMeta_TextBlockSeo_Fragment
  ) | (
    { __typename?: 'Video' }
    & EnrichedMeta_Video_Fragment
  ) | (
    { __typename?: 'VideoAsset' }
    & EnrichedMeta_VideoAsset_Fragment
    & VideoAssetFragment
  ) | (
    { __typename?: 'VideoCarousel' }
    & EnrichedMeta_VideoCarousel_Fragment
  ) | (
    { __typename?: 'VideoWithContent' }
    & EnrichedMeta_VideoWithContent_Fragment
  ) | null>, hyperlink: Array<(
    { __typename?: 'Accordions' }
    & EnrichedMeta_Accordions_Fragment
  ) | (
    { __typename?: 'AdFooter' }
    & EnrichedMeta_AdFooter_Fragment
  ) | (
    { __typename?: 'AgendaModal' }
    & EnrichedMeta_AgendaModal_Fragment
  ) | (
    { __typename?: 'AgendaStepper' }
    & EnrichedMeta_AgendaStepper_Fragment
  ) | (
    { __typename?: 'AnalyticsContext' }
    & EnrichedMeta_AnalyticsContext_Fragment
  ) | (
    { __typename?: 'App' }
    & EnrichedMeta_App_Fragment
  ) | (
    { __typename?: 'AppointmentBookingPage' }
    & EnrichedMeta_AppointmentBookingPage_Fragment
  ) | (
    { __typename?: 'Badge' }
    & EnrichedMeta_Badge_Fragment
  ) | (
    { __typename?: 'Banner' }
    & EnrichedMeta_Banner_Fragment
  ) | (
    { __typename?: 'BirdEyeReviews' }
    & EnrichedMeta_BirdEyeReviews_Fragment
  ) | (
    { __typename?: 'BlogAuthor' }
    & EnrichedMeta_BlogAuthor_Fragment
  ) | (
    { __typename?: 'BlogCategory' }
    & EnrichedMeta_BlogCategory_Fragment
  ) | (
    { __typename?: 'BlogDetailsPage' }
    & EnrichedMeta_BlogDetailsPage_Fragment
  ) | (
    { __typename?: 'BlogList' }
    & EnrichedMeta_BlogList_Fragment
  ) | (
    { __typename?: 'BlogListPage' }
    & EnrichedMeta_BlogListPage_Fragment
  ) | (
    { __typename?: 'BlogSubCategory' }
    & EnrichedMeta_BlogSubCategory_Fragment
  ) | (
    { __typename?: 'Brand' }
    & EnrichedMeta_Brand_Fragment
  ) | (
    { __typename?: 'Button' }
    & EnrichedMeta_Button_Fragment
  ) | (
    { __typename?: 'Card' }
    & EnrichedMeta_Card_Fragment
  ) | (
    { __typename?: 'Category' }
    & EnrichedMeta_Category_Fragment
  ) | (
    { __typename?: 'CategoryPicker' }
    & EnrichedMeta_CategoryPicker_Fragment
  ) | (
    { __typename?: 'CityLinks' }
    & EnrichedMeta_CityLinks_Fragment
  ) | (
    { __typename?: 'Columns' }
    & EnrichedMeta_Columns_Fragment
  ) | (
    { __typename?: 'ConfirmationStep' }
    & EnrichedMeta_ConfirmationStep_Fragment
  ) | (
    { __typename?: 'ContentSection' }
    & EnrichedMeta_ContentSection_Fragment
  ) | (
    { __typename?: 'ContentTile' }
    & EnrichedMeta_ContentTile_Fragment
  ) | (
    { __typename?: 'ContentTypeRichText' }
    & EnrichedMeta_ContentTypeRichText_Fragment
  ) | (
    { __typename?: 'DisclaimerV2' }
    & EnrichedMeta_DisclaimerV2_Fragment
  ) | (
    { __typename?: 'Error404' }
    & EnrichedMeta_Error404_Fragment
  ) | (
    { __typename?: 'FacilityDetailsPage' }
    & EnrichedMeta_FacilityDetailsPage_Fragment
  ) | (
    { __typename?: 'FeatureFlags' }
    & EnrichedMeta_FeatureFlags_Fragment
  ) | (
    { __typename?: 'FocalPointImage' }
    & EnrichedMeta_FocalPointImage_Fragment
  ) | (
    { __typename?: 'FooterNavigationGroup' }
    & EnrichedMeta_FooterNavigationGroup_Fragment
  ) | (
    { __typename?: 'FormDropdownField' }
    & EnrichedMeta_FormDropdownField_Fragment
  ) | (
    { __typename?: 'FormDropdownListItem' }
    & EnrichedMeta_FormDropdownListItem_Fragment
  ) | (
    { __typename?: 'FormField' }
    & EnrichedMeta_FormField_Fragment
  ) | (
    { __typename?: 'GoogleMapTemplate' }
    & EnrichedMeta_GoogleMapTemplate_Fragment
  ) | (
    { __typename?: 'HalfScreen' }
    & EnrichedMeta_HalfScreen_Fragment
  ) | (
    { __typename?: 'Header' }
    & EnrichedMeta_Header_Fragment
  ) | (
    { __typename?: 'HeaderMainNav' }
    & EnrichedMeta_HeaderMainNav_Fragment
  ) | (
    { __typename?: 'HeaderNavMenu' }
    & EnrichedMeta_HeaderNavMenu_Fragment
  ) | (
    { __typename?: 'HeaderSubNav' }
    & EnrichedMeta_HeaderSubNav_Fragment
  ) | (
    { __typename?: 'HeroV2' }
    & EnrichedMeta_HeroV2_Fragment
  ) | (
    { __typename?: 'Iframe' }
    & EnrichedMeta_Iframe_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & EnrichedMeta_ImageAsset_Fragment
  ) | (
    { __typename?: 'Insurance' }
    & EnrichedMeta_Insurance_Fragment
  ) | (
    { __typename?: 'LinkForwarder' }
    & EnrichedMeta_LinkForwarder_Fragment
  ) | (
    { __typename?: 'LocalizedServiceTitle' }
    & EnrichedMeta_LocalizedServiceTitle_Fragment
  ) | (
    { __typename?: 'Marquee' }
    & EnrichedMeta_Marquee_Fragment
  ) | (
    { __typename?: 'MediaSlider' }
    & EnrichedMeta_MediaSlider_Fragment
  ) | (
    { __typename?: 'MedicalService' }
    & EnrichedMeta_MedicalService_Fragment
  ) | (
    { __typename?: 'MeetOurStaff' }
    & EnrichedMeta_MeetOurStaff_Fragment
  ) | (
    { __typename?: 'MobileButton' }
    & EnrichedMeta_MobileButton_Fragment
  ) | (
    { __typename?: 'MultiCardV2' }
    & EnrichedMeta_MultiCardV2_Fragment
  ) | (
    { __typename?: 'NavigationGroup' }
    & EnrichedMeta_NavigationGroup_Fragment
  ) | (
    { __typename?: 'NavigationLink' }
    & EnrichedMeta_NavigationLink_Fragment
  ) | (
    { __typename?: 'OdpHero' }
    & EnrichedMeta_OdpHero_Fragment
  ) | (
    { __typename?: 'Page' }
    & EnrichedMeta_Page_Fragment
    & BasePageFragment
  ) | (
    { __typename?: 'PatientReviewV2' }
    & EnrichedMeta_PatientReviewV2_Fragment
  ) | (
    { __typename?: 'PatientReviewsV2' }
    & EnrichedMeta_PatientReviewsV2_Fragment
  ) | (
    { __typename?: 'Product' }
    & EnrichedMeta_Product_Fragment
  ) | (
    { __typename?: 'ProductDisplay' }
    & EnrichedMeta_ProductDisplay_Fragment
  ) | (
    { __typename?: 'ProductFeature' }
    & EnrichedMeta_ProductFeature_Fragment
  ) | (
    { __typename?: 'ProductFeatureDescriptionListItem' }
    & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
  ) | (
    { __typename?: 'ProviderDetailsPage' }
    & EnrichedMeta_ProviderDetailsPage_Fragment
  ) | (
    { __typename?: 'Questionnaire' }
    & EnrichedMeta_Questionnaire_Fragment
  ) | (
    { __typename?: 'QuickLinks' }
    & EnrichedMeta_QuickLinks_Fragment
  ) | (
    { __typename?: 'Quiz' }
    & EnrichedMeta_Quiz_Fragment
  ) | (
    { __typename?: 'ReviewStep' }
    & EnrichedMeta_ReviewStep_Fragment
  ) | (
    { __typename?: 'Schema' }
    & EnrichedMeta_Schema_Fragment
  ) | (
    { __typename?: 'SectionContent' }
    & EnrichedMeta_SectionContent_Fragment
  ) | (
    { __typename?: 'SegmentsContainer' }
    & EnrichedMeta_SegmentsContainer_Fragment
  ) | (
    { __typename?: 'Service' }
    & EnrichedMeta_Service_Fragment
  ) | (
    { __typename?: 'ServiceDetailsPage' }
    & EnrichedMeta_ServiceDetailsPage_Fragment
  ) | (
    { __typename?: 'ServiceLineHero' }
    & EnrichedMeta_ServiceLineHero_Fragment
  ) | (
    { __typename?: 'SingleMessage' }
    & EnrichedMeta_SingleMessage_Fragment
  ) | (
    { __typename?: 'SmallScreenContent' }
    & EnrichedMeta_SmallScreenContent_Fragment
  ) | (
    { __typename?: 'SmileAssessmentForm' }
    & EnrichedMeta_SmileAssessmentForm_Fragment
  ) | (
    { __typename?: 'Spacer' }
    & EnrichedMeta_Spacer_Fragment
  ) | (
    { __typename?: 'StateLinks' }
    & EnrichedMeta_StateLinks_Fragment
  ) | (
    { __typename?: 'Stepper' }
    & EnrichedMeta_Stepper_Fragment
  ) | (
    { __typename?: 'SuccessCard' }
    & EnrichedMeta_SuccessCard_Fragment
  ) | (
    { __typename?: 'Tab' }
    & EnrichedMeta_Tab_Fragment
  ) | (
    { __typename?: 'Table' }
    & EnrichedMeta_Table_Fragment
  ) | (
    { __typename?: 'Tabs' }
    & EnrichedMeta_Tabs_Fragment
  ) | (
    { __typename?: 'TermsAndConditions' }
    & EnrichedMeta_TermsAndConditions_Fragment
  ) | (
    { __typename?: 'TextBlockSeo' }
    & EnrichedMeta_TextBlockSeo_Fragment
  ) | (
    { __typename?: 'Video' }
    & EnrichedMeta_Video_Fragment
  ) | (
    { __typename?: 'VideoAsset' }
    & EnrichedMeta_VideoAsset_Fragment
  ) | (
    { __typename?: 'VideoCarousel' }
    & EnrichedMeta_VideoCarousel_Fragment
  ) | (
    { __typename?: 'VideoWithContent' }
    & EnrichedMeta_VideoWithContent_Fragment
  ) | null> };

export type BlogDetailsPageTextResourcesFragment = { __typename?: 'BlogDetailsPageTextResources', block: Array<(
    { __typename?: 'BlogDetailsPageTextResourcesBlock' }
    & ResourceMeta_BlogDetailsPageTextResourcesBlock_Fragment
  )>, inline: Array<(
    { __typename?: 'BlogDetailsPageTextResourcesInline' }
    & ResourceMeta_BlogDetailsPageTextResourcesInline_Fragment
  )>, hyperlink: Array<(
    { __typename?: 'BlogDetailsPageTextResourcesHyperlink' }
    & ResourceMeta_BlogDetailsPageTextResourcesHyperlink_Fragment
  )> };

export type BlogDetailsPageTextFragment = { __typename?: 'BlogDetailsPageText', json: any, links: { __typename?: 'BlogDetailsPageTextLinks', assets: (
      { __typename?: 'BlogDetailsPageTextAssets' }
      & BlogDetailsPageTextAssetsFragment
    ), entries: (
      { __typename?: 'BlogDetailsPageTextEntries' }
      & BlogDetailsPageTextEntriesFragment
    ), resources: (
      { __typename?: 'BlogDetailsPageTextResources' }
      & BlogDetailsPageTextResourcesFragment
    ) } };

export type BlogListFragment = (
  { __typename?: 'BlogList', title?: string | null, displayType?: string | null, buttonLabel?: string | null, loadMoreButtonLabel?: string | null, countAcrossDesktop?: number | null, countAcrossMobile?: number | null, hasPagination?: boolean | null, cardDesignType?: string | null, category?: (
    { __typename?: 'BlogCategory' }
    & BlogCategoryFragment
  ) | null, subCategory?: (
    { __typename?: 'BlogSubCategory' }
    & BlogSubCategoryFragment
  ) | null, brand?: (
    { __typename?: 'Brand' }
    & BrandFragment
  ) | null, heroBlogsListCollection?: { __typename?: 'BlogListHeroBlogsListCollection', items: Array<(
      { __typename?: 'BlogDetailsPage' }
      & HeroBlogDetailsPageListFragment
    ) | null> } | null, featuredBlogsListCollection?: { __typename?: 'BlogListFeaturedBlogsListCollection', items: Array<(
      { __typename?: 'BlogDetailsPage' }
      & FeaturedBlogDetailsPageListFragment
    ) | null> } | null }
  & Meta_BlogList_Fragment
);

export type BlogListPageFragment = (
  { __typename?: 'BlogListPage', metaTitle?: string | null, metaDescription?: string | null, canonical?: string | null, indexed?: boolean | null, title?: string | null, disableStickyFooterOnDesktop?: boolean | null, disableStickyFooterOnMobile?: boolean | null, disableHeaderTopAlertBanner?: boolean | null, disableHeaderBottomAlertBanner?: boolean | null, shouldDisplayCategoryFilterChips?: boolean | null, brand?: (
    { __typename?: 'Brand' }
    & BrandFragment
  ) | null, blogList?: (
    { __typename?: 'BlogList' }
    & BlogListFragment
  ) | null, description?: { __typename?: 'BlogListPageDescription', json: any } | null, contentListCollection?: { __typename?: 'BlogListPageContentListCollection', items: Array<(
      { __typename?: 'BlogList' }
      & BlogListFragment
    ) | null> } | null, contentAfterListCollection?: { __typename?: 'BlogListPageContentAfterListCollection', items: Array<(
      { __typename?: 'SingleMessage' }
      & SingleMessageFragment
    ) | null> } | null }
  & Meta_BlogListPage_Fragment
);

export type BlogSubCategoryFragment = (
  { __typename?: 'BlogSubCategory', name?: string | null, slug?: string | null }
  & Meta_BlogSubCategory_Fragment
);

export type BrandFragment = (
  { __typename?: 'Brand', name?: string | null, title?: string | null }
  & Meta_Brand_Fragment
);

export type ButtonFragment = (
  { __typename?: 'Button', name?: string | null, label?: string | null, variant?: string | null, buttonLink?: string | null, size?: string | null, icon?: string | null, iconPosition?: string | null, iconSize?: string | null, mobileButton?: (
    { __typename?: 'MobileButton' }
    & MobileButtonFragment
  ) | null, analyticsContext?: (
    { __typename?: 'AnalyticsContext' }
    & AnalyticsFragment
  ) | null, navigationDetails?: (
    { __typename?: 'NavigationLink' }
    & NavLinkFragment
  ) | null, quizDetails?: (
    { __typename?: 'Quiz' }
    & QuizFragment
  ) | null }
  & Meta_Button_Fragment
);

export type CardFragment = (
  { __typename?: 'Card', name?: string | null, title?: string | null, titleHtag?: string | null, description?: string | null, imageRatio?: string | null, cardIcon?: string | null, cardIconAlignment?: string | null, cardTextAlignment?: string | null, eyebrow?: string | null, backgroundColor?: string | null, buttonVariant?: string | null, buttonText?: string | null, buttonUrl?: string | null, buttonSize?: string | null, buttonIcon?: string | null, buttonIconSize?: string | null, buttonIconPosition?: string | null, pdfDownloadTitle?: string | null, tags?: Array<string | null> | null, richTextDescription?: { __typename?: 'CardRichTextDescription', json: any } | null, image?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, imageAsset?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
    & ImageAssetFragment
  ) | null, pdfFileLink?: (
    { __typename?: 'Asset' }
    & PdfFragment
  ) | null, tc?: (
    { __typename?: 'TermsAndConditions' }
    & TermOfConditionsFragment
  ) | null, analyticsContext?: (
    { __typename?: 'AnalyticsContext' }
    & AnalyticsFragment
  ) | null, buttonsCollection?: { __typename?: 'CardButtonsCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null }
  & Meta_Card_Fragment
);

export type CategoryPickerFragment = (
  { __typename?: 'CategoryPicker', eyebrow?: string | null, eyebrowHeading?: string | null, mobileThreshold?: number | null, title?: string | null, titleHeading?: string | null, setTwoRows?: boolean | null, anchorId?: string | null, categoriesCollection?: { __typename?: 'CategoryPickerCategoriesCollection', items: Array<{ __typename?: 'Category', icon?: string | null, title?: string | null, link?: string | null, imageAsset?: (
        { __typename?: 'ImageAsset' }
        & ImageAssetFragment
      ) | null } | null> } | null, bodyCopy?: (
    { __typename?: 'ContentTypeRichText' }
    & RichTextFragment
  ) | null, buttonsCollection?: { __typename?: 'CategoryPickerButtonsCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null }
  & Meta_CategoryPicker_Fragment
);

export type ColumnsFragment = (
  { __typename?: 'Columns', eyebrow?: string | null, title?: string | null, titleHtag?: string | null, description?: string | null, fullWidth?: boolean | null, disablePaddingOn?: Array<string | null> | null, backgroundColor?: string | null, allowEqualHeights?: boolean | null, anchorId?: string | null, columnsCollection?: { __typename?: 'ColumnsColumnsCollection', items: Array<(
      { __typename?: 'Accordions' }
      & AccordionFragment
    ) | (
      { __typename?: 'ContentTypeRichText' }
      & RichTextFragment
    ) | (
      { __typename?: 'ImageAsset' }
      & ImageAssetFragment
    ) | (
      { __typename?: 'SingleMessage' }
      & SingleMessageFragment
    ) | null> } | null }
  & Meta_Columns_Fragment
);

export type ContentSectionFragment = (
  { __typename?: 'ContentSection', eyebrow?: string | null, eyebrowHtag?: string | null, title?: string | null, titleHtag?: string | null, alignment?: string | null, titleIcon?: string | null, description?: { __typename?: 'ContentSectionDescription', json: any } | null }
  & Meta_ContentSection_Fragment
);

export type DisclaimerV2Fragment = (
  { __typename?: 'DisclaimerV2', size?: string | null, templateWidth?: string | null, facilitySegmentCollection?: string | null, anchorId?: string | null, disclaimer?: (
    { __typename?: 'ContentTypeRichText' }
    & RichTextFragment
  ) | null }
  & Meta_DisclaimerV2_Fragment
);

export type Meta_Accordions_Fragment = { __typename: 'Accordions', sys: { __typename?: 'Sys', id: string } };

export type Meta_AdFooter_Fragment = { __typename: 'AdFooter', sys: { __typename?: 'Sys', id: string } };

export type Meta_AgendaModal_Fragment = { __typename: 'AgendaModal', sys: { __typename?: 'Sys', id: string } };

export type Meta_AgendaStepper_Fragment = { __typename: 'AgendaStepper', sys: { __typename?: 'Sys', id: string } };

export type Meta_AnalyticsContext_Fragment = { __typename: 'AnalyticsContext', sys: { __typename?: 'Sys', id: string } };

export type Meta_App_Fragment = { __typename: 'App', sys: { __typename?: 'Sys', id: string } };

export type Meta_AppointmentBookingPage_Fragment = { __typename: 'AppointmentBookingPage', sys: { __typename?: 'Sys', id: string } };

export type Meta_Badge_Fragment = { __typename: 'Badge', sys: { __typename?: 'Sys', id: string } };

export type Meta_Banner_Fragment = { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } };

export type Meta_BirdEyeReviews_Fragment = { __typename: 'BirdEyeReviews', sys: { __typename?: 'Sys', id: string } };

export type Meta_BlogAuthor_Fragment = { __typename: 'BlogAuthor', sys: { __typename?: 'Sys', id: string } };

export type Meta_BlogCategory_Fragment = { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string } };

export type Meta_BlogDetailsPage_Fragment = { __typename: 'BlogDetailsPage', sys: { __typename?: 'Sys', id: string } };

export type Meta_BlogList_Fragment = { __typename: 'BlogList', sys: { __typename?: 'Sys', id: string } };

export type Meta_BlogListPage_Fragment = { __typename: 'BlogListPage', sys: { __typename?: 'Sys', id: string } };

export type Meta_BlogSubCategory_Fragment = { __typename: 'BlogSubCategory', sys: { __typename?: 'Sys', id: string } };

export type Meta_Brand_Fragment = { __typename: 'Brand', sys: { __typename?: 'Sys', id: string } };

export type Meta_Button_Fragment = { __typename: 'Button', sys: { __typename?: 'Sys', id: string } };

export type Meta_Card_Fragment = { __typename: 'Card', sys: { __typename?: 'Sys', id: string } };

export type Meta_Category_Fragment = { __typename: 'Category', sys: { __typename?: 'Sys', id: string } };

export type Meta_CategoryPicker_Fragment = { __typename: 'CategoryPicker', sys: { __typename?: 'Sys', id: string } };

export type Meta_CityLinks_Fragment = { __typename: 'CityLinks', sys: { __typename?: 'Sys', id: string } };

export type Meta_Columns_Fragment = { __typename: 'Columns', sys: { __typename?: 'Sys', id: string } };

export type Meta_ConfirmationStep_Fragment = { __typename: 'ConfirmationStep', sys: { __typename?: 'Sys', id: string } };

export type Meta_ContentSection_Fragment = { __typename: 'ContentSection', sys: { __typename?: 'Sys', id: string } };

export type Meta_ContentTile_Fragment = { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } };

export type Meta_ContentTypeRichText_Fragment = { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } };

export type Meta_DisclaimerV2_Fragment = { __typename: 'DisclaimerV2', sys: { __typename?: 'Sys', id: string } };

export type Meta_Error404_Fragment = { __typename: 'Error404', sys: { __typename?: 'Sys', id: string } };

export type Meta_FacilityDetailsPage_Fragment = { __typename: 'FacilityDetailsPage', sys: { __typename?: 'Sys', id: string } };

export type Meta_FeatureFlags_Fragment = { __typename: 'FeatureFlags', sys: { __typename?: 'Sys', id: string } };

export type Meta_FocalPointImage_Fragment = { __typename: 'FocalPointImage', sys: { __typename?: 'Sys', id: string } };

export type Meta_FooterNavigationGroup_Fragment = { __typename: 'FooterNavigationGroup', sys: { __typename?: 'Sys', id: string } };

export type Meta_FormDropdownField_Fragment = { __typename: 'FormDropdownField', sys: { __typename?: 'Sys', id: string } };

export type Meta_FormDropdownListItem_Fragment = { __typename: 'FormDropdownListItem', sys: { __typename?: 'Sys', id: string } };

export type Meta_FormField_Fragment = { __typename: 'FormField', sys: { __typename?: 'Sys', id: string } };

export type Meta_GoogleMapTemplate_Fragment = { __typename: 'GoogleMapTemplate', sys: { __typename?: 'Sys', id: string } };

export type Meta_HalfScreen_Fragment = { __typename: 'HalfScreen', sys: { __typename?: 'Sys', id: string } };

export type Meta_Header_Fragment = { __typename: 'Header', sys: { __typename?: 'Sys', id: string } };

export type Meta_HeaderMainNav_Fragment = { __typename: 'HeaderMainNav', sys: { __typename?: 'Sys', id: string } };

export type Meta_HeaderNavMenu_Fragment = { __typename: 'HeaderNavMenu', sys: { __typename?: 'Sys', id: string } };

export type Meta_HeaderSubNav_Fragment = { __typename: 'HeaderSubNav', sys: { __typename?: 'Sys', id: string } };

export type Meta_HeroV2_Fragment = { __typename: 'HeroV2', sys: { __typename?: 'Sys', id: string } };

export type Meta_Iframe_Fragment = { __typename: 'Iframe', sys: { __typename?: 'Sys', id: string } };

export type Meta_ImageAsset_Fragment = { __typename: 'ImageAsset', sys: { __typename?: 'Sys', id: string } };

export type Meta_Insurance_Fragment = { __typename: 'Insurance', sys: { __typename?: 'Sys', id: string } };

export type Meta_LinkForwarder_Fragment = { __typename: 'LinkForwarder', sys: { __typename?: 'Sys', id: string } };

export type Meta_LocalizedServiceTitle_Fragment = { __typename: 'LocalizedServiceTitle', sys: { __typename?: 'Sys', id: string } };

export type Meta_Marquee_Fragment = { __typename: 'Marquee', sys: { __typename?: 'Sys', id: string } };

export type Meta_MediaSlider_Fragment = { __typename: 'MediaSlider', sys: { __typename?: 'Sys', id: string } };

export type Meta_MedicalService_Fragment = { __typename: 'MedicalService', sys: { __typename?: 'Sys', id: string } };

export type Meta_MeetOurStaff_Fragment = { __typename: 'MeetOurStaff', sys: { __typename?: 'Sys', id: string } };

export type Meta_MobileButton_Fragment = { __typename: 'MobileButton', sys: { __typename?: 'Sys', id: string } };

export type Meta_MultiCardV2_Fragment = { __typename: 'MultiCardV2', sys: { __typename?: 'Sys', id: string } };

export type Meta_NavigationGroup_Fragment = { __typename: 'NavigationGroup', sys: { __typename?: 'Sys', id: string } };

export type Meta_NavigationLink_Fragment = { __typename: 'NavigationLink', sys: { __typename?: 'Sys', id: string } };

export type Meta_OdpHero_Fragment = { __typename: 'OdpHero', sys: { __typename?: 'Sys', id: string } };

export type Meta_Page_Fragment = { __typename: 'Page', sys: { __typename?: 'Sys', id: string } };

export type Meta_PatientReviewV2_Fragment = { __typename: 'PatientReviewV2', sys: { __typename?: 'Sys', id: string } };

export type Meta_PatientReviewsV2_Fragment = { __typename: 'PatientReviewsV2', sys: { __typename?: 'Sys', id: string } };

export type Meta_Product_Fragment = { __typename: 'Product', sys: { __typename?: 'Sys', id: string } };

export type Meta_ProductDisplay_Fragment = { __typename: 'ProductDisplay', sys: { __typename?: 'Sys', id: string } };

export type Meta_ProductFeature_Fragment = { __typename: 'ProductFeature', sys: { __typename?: 'Sys', id: string } };

export type Meta_ProductFeatureDescriptionListItem_Fragment = { __typename: 'ProductFeatureDescriptionListItem', sys: { __typename?: 'Sys', id: string } };

export type Meta_ProviderDetailsPage_Fragment = { __typename: 'ProviderDetailsPage', sys: { __typename?: 'Sys', id: string } };

export type Meta_Questionnaire_Fragment = { __typename: 'Questionnaire', sys: { __typename?: 'Sys', id: string } };

export type Meta_QuickLinks_Fragment = { __typename: 'QuickLinks', sys: { __typename?: 'Sys', id: string } };

export type Meta_Quiz_Fragment = { __typename: 'Quiz', sys: { __typename?: 'Sys', id: string } };

export type Meta_ReviewStep_Fragment = { __typename: 'ReviewStep', sys: { __typename?: 'Sys', id: string } };

export type Meta_Schema_Fragment = { __typename: 'Schema', sys: { __typename?: 'Sys', id: string } };

export type Meta_SectionContent_Fragment = { __typename: 'SectionContent', sys: { __typename?: 'Sys', id: string } };

export type Meta_SegmentsContainer_Fragment = { __typename: 'SegmentsContainer', sys: { __typename?: 'Sys', id: string } };

export type Meta_Service_Fragment = { __typename: 'Service', sys: { __typename?: 'Sys', id: string } };

export type Meta_ServiceDetailsPage_Fragment = { __typename: 'ServiceDetailsPage', sys: { __typename?: 'Sys', id: string } };

export type Meta_ServiceLineHero_Fragment = { __typename: 'ServiceLineHero', sys: { __typename?: 'Sys', id: string } };

export type Meta_SingleMessage_Fragment = { __typename: 'SingleMessage', sys: { __typename?: 'Sys', id: string } };

export type Meta_SmallScreenContent_Fragment = { __typename: 'SmallScreenContent', sys: { __typename?: 'Sys', id: string } };

export type Meta_SmileAssessmentForm_Fragment = { __typename: 'SmileAssessmentForm', sys: { __typename?: 'Sys', id: string } };

export type Meta_Spacer_Fragment = { __typename: 'Spacer', sys: { __typename?: 'Sys', id: string } };

export type Meta_StateLinks_Fragment = { __typename: 'StateLinks', sys: { __typename?: 'Sys', id: string } };

export type Meta_Stepper_Fragment = { __typename: 'Stepper', sys: { __typename?: 'Sys', id: string } };

export type Meta_SuccessCard_Fragment = { __typename: 'SuccessCard', sys: { __typename?: 'Sys', id: string } };

export type Meta_Tab_Fragment = { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } };

export type Meta_Table_Fragment = { __typename: 'Table', sys: { __typename?: 'Sys', id: string } };

export type Meta_Tabs_Fragment = { __typename: 'Tabs', sys: { __typename?: 'Sys', id: string } };

export type Meta_TermsAndConditions_Fragment = { __typename: 'TermsAndConditions', sys: { __typename?: 'Sys', id: string } };

export type Meta_TextBlockSeo_Fragment = { __typename: 'TextBlockSeo', sys: { __typename?: 'Sys', id: string } };

export type Meta_Video_Fragment = { __typename: 'Video', sys: { __typename?: 'Sys', id: string } };

export type Meta_VideoAsset_Fragment = { __typename: 'VideoAsset', sys: { __typename?: 'Sys', id: string } };

export type Meta_VideoCarousel_Fragment = { __typename: 'VideoCarousel', sys: { __typename?: 'Sys', id: string } };

export type Meta_VideoWithContent_Fragment = { __typename: 'VideoWithContent', sys: { __typename?: 'Sys', id: string } };

export type MetaFragment = Meta_Accordions_Fragment | Meta_AdFooter_Fragment | Meta_AgendaModal_Fragment | Meta_AgendaStepper_Fragment | Meta_AnalyticsContext_Fragment | Meta_App_Fragment | Meta_AppointmentBookingPage_Fragment | Meta_Badge_Fragment | Meta_Banner_Fragment | Meta_BirdEyeReviews_Fragment | Meta_BlogAuthor_Fragment | Meta_BlogCategory_Fragment | Meta_BlogDetailsPage_Fragment | Meta_BlogList_Fragment | Meta_BlogListPage_Fragment | Meta_BlogSubCategory_Fragment | Meta_Brand_Fragment | Meta_Button_Fragment | Meta_Card_Fragment | Meta_Category_Fragment | Meta_CategoryPicker_Fragment | Meta_CityLinks_Fragment | Meta_Columns_Fragment | Meta_ConfirmationStep_Fragment | Meta_ContentSection_Fragment | Meta_ContentTile_Fragment | Meta_ContentTypeRichText_Fragment | Meta_DisclaimerV2_Fragment | Meta_Error404_Fragment | Meta_FacilityDetailsPage_Fragment | Meta_FeatureFlags_Fragment | Meta_FocalPointImage_Fragment | Meta_FooterNavigationGroup_Fragment | Meta_FormDropdownField_Fragment | Meta_FormDropdownListItem_Fragment | Meta_FormField_Fragment | Meta_GoogleMapTemplate_Fragment | Meta_HalfScreen_Fragment | Meta_Header_Fragment | Meta_HeaderMainNav_Fragment | Meta_HeaderNavMenu_Fragment | Meta_HeaderSubNav_Fragment | Meta_HeroV2_Fragment | Meta_Iframe_Fragment | Meta_ImageAsset_Fragment | Meta_Insurance_Fragment | Meta_LinkForwarder_Fragment | Meta_LocalizedServiceTitle_Fragment | Meta_Marquee_Fragment | Meta_MediaSlider_Fragment | Meta_MedicalService_Fragment | Meta_MeetOurStaff_Fragment | Meta_MobileButton_Fragment | Meta_MultiCardV2_Fragment | Meta_NavigationGroup_Fragment | Meta_NavigationLink_Fragment | Meta_OdpHero_Fragment | Meta_Page_Fragment | Meta_PatientReviewV2_Fragment | Meta_PatientReviewsV2_Fragment | Meta_Product_Fragment | Meta_ProductDisplay_Fragment | Meta_ProductFeature_Fragment | Meta_ProductFeatureDescriptionListItem_Fragment | Meta_ProviderDetailsPage_Fragment | Meta_Questionnaire_Fragment | Meta_QuickLinks_Fragment | Meta_Quiz_Fragment | Meta_ReviewStep_Fragment | Meta_Schema_Fragment | Meta_SectionContent_Fragment | Meta_SegmentsContainer_Fragment | Meta_Service_Fragment | Meta_ServiceDetailsPage_Fragment | Meta_ServiceLineHero_Fragment | Meta_SingleMessage_Fragment | Meta_SmallScreenContent_Fragment | Meta_SmileAssessmentForm_Fragment | Meta_Spacer_Fragment | Meta_StateLinks_Fragment | Meta_Stepper_Fragment | Meta_SuccessCard_Fragment | Meta_Tab_Fragment | Meta_Table_Fragment | Meta_Tabs_Fragment | Meta_TermsAndConditions_Fragment | Meta_TextBlockSeo_Fragment | Meta_Video_Fragment | Meta_VideoAsset_Fragment | Meta_VideoCarousel_Fragment | Meta_VideoWithContent_Fragment;

export type EnrichedMeta_Accordions_Fragment = { __typename: 'Accordions', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_AdFooter_Fragment = { __typename: 'AdFooter', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_AgendaModal_Fragment = { __typename: 'AgendaModal', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_AgendaStepper_Fragment = { __typename: 'AgendaStepper', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_AnalyticsContext_Fragment = { __typename: 'AnalyticsContext', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_App_Fragment = { __typename: 'App', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_AppointmentBookingPage_Fragment = { __typename: 'AppointmentBookingPage', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Badge_Fragment = { __typename: 'Badge', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Banner_Fragment = { __typename: 'Banner', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_BirdEyeReviews_Fragment = { __typename: 'BirdEyeReviews', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_BlogAuthor_Fragment = { __typename: 'BlogAuthor', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_BlogCategory_Fragment = { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_BlogDetailsPage_Fragment = { __typename: 'BlogDetailsPage', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_BlogList_Fragment = { __typename: 'BlogList', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_BlogListPage_Fragment = { __typename: 'BlogListPage', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_BlogSubCategory_Fragment = { __typename: 'BlogSubCategory', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Brand_Fragment = { __typename: 'Brand', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Button_Fragment = { __typename: 'Button', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Card_Fragment = { __typename: 'Card', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Category_Fragment = { __typename: 'Category', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_CategoryPicker_Fragment = { __typename: 'CategoryPicker', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_CityLinks_Fragment = { __typename: 'CityLinks', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Columns_Fragment = { __typename: 'Columns', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ConfirmationStep_Fragment = { __typename: 'ConfirmationStep', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ContentSection_Fragment = { __typename: 'ContentSection', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ContentTile_Fragment = { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ContentTypeRichText_Fragment = { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_DisclaimerV2_Fragment = { __typename: 'DisclaimerV2', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Error404_Fragment = { __typename: 'Error404', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_FacilityDetailsPage_Fragment = { __typename: 'FacilityDetailsPage', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_FeatureFlags_Fragment = { __typename: 'FeatureFlags', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_FocalPointImage_Fragment = { __typename: 'FocalPointImage', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_FooterNavigationGroup_Fragment = { __typename: 'FooterNavigationGroup', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_FormDropdownField_Fragment = { __typename: 'FormDropdownField', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_FormDropdownListItem_Fragment = { __typename: 'FormDropdownListItem', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_FormField_Fragment = { __typename: 'FormField', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_GoogleMapTemplate_Fragment = { __typename: 'GoogleMapTemplate', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_HalfScreen_Fragment = { __typename: 'HalfScreen', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Header_Fragment = { __typename: 'Header', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_HeaderMainNav_Fragment = { __typename: 'HeaderMainNav', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_HeaderNavMenu_Fragment = { __typename: 'HeaderNavMenu', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_HeaderSubNav_Fragment = { __typename: 'HeaderSubNav', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_HeroV2_Fragment = { __typename: 'HeroV2', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Iframe_Fragment = { __typename: 'Iframe', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ImageAsset_Fragment = { __typename: 'ImageAsset', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Insurance_Fragment = { __typename: 'Insurance', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_LinkForwarder_Fragment = { __typename: 'LinkForwarder', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_LocalizedServiceTitle_Fragment = { __typename: 'LocalizedServiceTitle', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Marquee_Fragment = { __typename: 'Marquee', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_MediaSlider_Fragment = { __typename: 'MediaSlider', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_MedicalService_Fragment = { __typename: 'MedicalService', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_MeetOurStaff_Fragment = { __typename: 'MeetOurStaff', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_MobileButton_Fragment = { __typename: 'MobileButton', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_MultiCardV2_Fragment = { __typename: 'MultiCardV2', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_NavigationGroup_Fragment = { __typename: 'NavigationGroup', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_NavigationLink_Fragment = { __typename: 'NavigationLink', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_OdpHero_Fragment = { __typename: 'OdpHero', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Page_Fragment = { __typename: 'Page', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_PatientReviewV2_Fragment = { __typename: 'PatientReviewV2', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_PatientReviewsV2_Fragment = { __typename: 'PatientReviewsV2', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Product_Fragment = { __typename: 'Product', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ProductDisplay_Fragment = { __typename: 'ProductDisplay', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ProductFeature_Fragment = { __typename: 'ProductFeature', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ProductFeatureDescriptionListItem_Fragment = { __typename: 'ProductFeatureDescriptionListItem', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ProviderDetailsPage_Fragment = { __typename: 'ProviderDetailsPage', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Questionnaire_Fragment = { __typename: 'Questionnaire', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_QuickLinks_Fragment = { __typename: 'QuickLinks', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Quiz_Fragment = { __typename: 'Quiz', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ReviewStep_Fragment = { __typename: 'ReviewStep', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Schema_Fragment = { __typename: 'Schema', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_SectionContent_Fragment = { __typename: 'SectionContent', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_SegmentsContainer_Fragment = { __typename: 'SegmentsContainer', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Service_Fragment = { __typename: 'Service', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ServiceDetailsPage_Fragment = { __typename: 'ServiceDetailsPage', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ServiceLineHero_Fragment = { __typename: 'ServiceLineHero', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_SingleMessage_Fragment = { __typename: 'SingleMessage', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_SmallScreenContent_Fragment = { __typename: 'SmallScreenContent', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_SmileAssessmentForm_Fragment = { __typename: 'SmileAssessmentForm', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Spacer_Fragment = { __typename: 'Spacer', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_StateLinks_Fragment = { __typename: 'StateLinks', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Stepper_Fragment = { __typename: 'Stepper', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_SuccessCard_Fragment = { __typename: 'SuccessCard', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Tab_Fragment = { __typename: 'Tab', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Table_Fragment = { __typename: 'Table', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Tabs_Fragment = { __typename: 'Tabs', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_TermsAndConditions_Fragment = { __typename: 'TermsAndConditions', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_TextBlockSeo_Fragment = { __typename: 'TextBlockSeo', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Video_Fragment = { __typename: 'Video', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_VideoAsset_Fragment = { __typename: 'VideoAsset', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_VideoCarousel_Fragment = { __typename: 'VideoCarousel', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_VideoWithContent_Fragment = { __typename: 'VideoWithContent', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMetaFragment = EnrichedMeta_Accordions_Fragment | EnrichedMeta_AdFooter_Fragment | EnrichedMeta_AgendaModal_Fragment | EnrichedMeta_AgendaStepper_Fragment | EnrichedMeta_AnalyticsContext_Fragment | EnrichedMeta_App_Fragment | EnrichedMeta_AppointmentBookingPage_Fragment | EnrichedMeta_Badge_Fragment | EnrichedMeta_Banner_Fragment | EnrichedMeta_BirdEyeReviews_Fragment | EnrichedMeta_BlogAuthor_Fragment | EnrichedMeta_BlogCategory_Fragment | EnrichedMeta_BlogDetailsPage_Fragment | EnrichedMeta_BlogList_Fragment | EnrichedMeta_BlogListPage_Fragment | EnrichedMeta_BlogSubCategory_Fragment | EnrichedMeta_Brand_Fragment | EnrichedMeta_Button_Fragment | EnrichedMeta_Card_Fragment | EnrichedMeta_Category_Fragment | EnrichedMeta_CategoryPicker_Fragment | EnrichedMeta_CityLinks_Fragment | EnrichedMeta_Columns_Fragment | EnrichedMeta_ConfirmationStep_Fragment | EnrichedMeta_ContentSection_Fragment | EnrichedMeta_ContentTile_Fragment | EnrichedMeta_ContentTypeRichText_Fragment | EnrichedMeta_DisclaimerV2_Fragment | EnrichedMeta_Error404_Fragment | EnrichedMeta_FacilityDetailsPage_Fragment | EnrichedMeta_FeatureFlags_Fragment | EnrichedMeta_FocalPointImage_Fragment | EnrichedMeta_FooterNavigationGroup_Fragment | EnrichedMeta_FormDropdownField_Fragment | EnrichedMeta_FormDropdownListItem_Fragment | EnrichedMeta_FormField_Fragment | EnrichedMeta_GoogleMapTemplate_Fragment | EnrichedMeta_HalfScreen_Fragment | EnrichedMeta_Header_Fragment | EnrichedMeta_HeaderMainNav_Fragment | EnrichedMeta_HeaderNavMenu_Fragment | EnrichedMeta_HeaderSubNav_Fragment | EnrichedMeta_HeroV2_Fragment | EnrichedMeta_Iframe_Fragment | EnrichedMeta_ImageAsset_Fragment | EnrichedMeta_Insurance_Fragment | EnrichedMeta_LinkForwarder_Fragment | EnrichedMeta_LocalizedServiceTitle_Fragment | EnrichedMeta_Marquee_Fragment | EnrichedMeta_MediaSlider_Fragment | EnrichedMeta_MedicalService_Fragment | EnrichedMeta_MeetOurStaff_Fragment | EnrichedMeta_MobileButton_Fragment | EnrichedMeta_MultiCardV2_Fragment | EnrichedMeta_NavigationGroup_Fragment | EnrichedMeta_NavigationLink_Fragment | EnrichedMeta_OdpHero_Fragment | EnrichedMeta_Page_Fragment | EnrichedMeta_PatientReviewV2_Fragment | EnrichedMeta_PatientReviewsV2_Fragment | EnrichedMeta_Product_Fragment | EnrichedMeta_ProductDisplay_Fragment | EnrichedMeta_ProductFeature_Fragment | EnrichedMeta_ProductFeatureDescriptionListItem_Fragment | EnrichedMeta_ProviderDetailsPage_Fragment | EnrichedMeta_Questionnaire_Fragment | EnrichedMeta_QuickLinks_Fragment | EnrichedMeta_Quiz_Fragment | EnrichedMeta_ReviewStep_Fragment | EnrichedMeta_Schema_Fragment | EnrichedMeta_SectionContent_Fragment | EnrichedMeta_SegmentsContainer_Fragment | EnrichedMeta_Service_Fragment | EnrichedMeta_ServiceDetailsPage_Fragment | EnrichedMeta_ServiceLineHero_Fragment | EnrichedMeta_SingleMessage_Fragment | EnrichedMeta_SmallScreenContent_Fragment | EnrichedMeta_SmileAssessmentForm_Fragment | EnrichedMeta_Spacer_Fragment | EnrichedMeta_StateLinks_Fragment | EnrichedMeta_Stepper_Fragment | EnrichedMeta_SuccessCard_Fragment | EnrichedMeta_Tab_Fragment | EnrichedMeta_Table_Fragment | EnrichedMeta_Tabs_Fragment | EnrichedMeta_TermsAndConditions_Fragment | EnrichedMeta_TextBlockSeo_Fragment | EnrichedMeta_Video_Fragment | EnrichedMeta_VideoAsset_Fragment | EnrichedMeta_VideoCarousel_Fragment | EnrichedMeta_VideoWithContent_Fragment;

export type LinkMetaFragment = { __typename: 'Asset', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null, name?: string | null } | null> } };

export type ResourceMeta_AccordionsDescriptionRichTextResourcesBlock_Fragment = { __typename?: 'AccordionsDescriptionRichTextResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_AccordionsDescriptionRichTextResourcesHyperlink_Fragment = { __typename?: 'AccordionsDescriptionRichTextResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_AccordionsDescriptionRichTextResourcesInline_Fragment = { __typename?: 'AccordionsDescriptionRichTextResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_AdFooterAboutResourcesBlock_Fragment = { __typename?: 'AdFooterAboutResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_AdFooterAboutResourcesHyperlink_Fragment = { __typename?: 'AdFooterAboutResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_AdFooterAboutResourcesInline_Fragment = { __typename?: 'AdFooterAboutResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogAuthorAuthorBioSummaryResourcesBlock_Fragment = { __typename?: 'BlogAuthorAuthorBioSummaryResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogAuthorAuthorBioSummaryResourcesHyperlink_Fragment = { __typename?: 'BlogAuthorAuthorBioSummaryResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogAuthorAuthorBioSummaryResourcesInline_Fragment = { __typename?: 'BlogAuthorAuthorBioSummaryResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogDetailsPageHeroContentTitleResourcesBlock_Fragment = { __typename?: 'BlogDetailsPageHeroContentTitleResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogDetailsPageHeroContentTitleResourcesHyperlink_Fragment = { __typename?: 'BlogDetailsPageHeroContentTitleResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogDetailsPageHeroContentTitleResourcesInline_Fragment = { __typename?: 'BlogDetailsPageHeroContentTitleResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogDetailsPageSummaryResourcesBlock_Fragment = { __typename?: 'BlogDetailsPageSummaryResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogDetailsPageSummaryResourcesHyperlink_Fragment = { __typename?: 'BlogDetailsPageSummaryResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogDetailsPageSummaryResourcesInline_Fragment = { __typename?: 'BlogDetailsPageSummaryResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogDetailsPageTextResourcesBlock_Fragment = { __typename?: 'BlogDetailsPageTextResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogDetailsPageTextResourcesHyperlink_Fragment = { __typename?: 'BlogDetailsPageTextResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogDetailsPageTextResourcesInline_Fragment = { __typename?: 'BlogDetailsPageTextResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogListPageDescriptionResourcesBlock_Fragment = { __typename?: 'BlogListPageDescriptionResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogListPageDescriptionResourcesHyperlink_Fragment = { __typename?: 'BlogListPageDescriptionResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogListPageDescriptionResourcesInline_Fragment = { __typename?: 'BlogListPageDescriptionResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_CardRichTextDescriptionResourcesBlock_Fragment = { __typename?: 'CardRichTextDescriptionResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_CardRichTextDescriptionResourcesHyperlink_Fragment = { __typename?: 'CardRichTextDescriptionResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_CardRichTextDescriptionResourcesInline_Fragment = { __typename?: 'CardRichTextDescriptionResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ContentSectionDescriptionResourcesBlock_Fragment = { __typename?: 'ContentSectionDescriptionResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ContentSectionDescriptionResourcesHyperlink_Fragment = { __typename?: 'ContentSectionDescriptionResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ContentSectionDescriptionResourcesInline_Fragment = { __typename?: 'ContentSectionDescriptionResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ContentTypeRichTextContentResourcesBlock_Fragment = { __typename?: 'ContentTypeRichTextContentResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ContentTypeRichTextContentResourcesHyperlink_Fragment = { __typename?: 'ContentTypeRichTextContentResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ContentTypeRichTextContentResourcesInline_Fragment = { __typename?: 'ContentTypeRichTextContentResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ContentTypeRichTextSecondaryContentResourcesBlock_Fragment = { __typename?: 'ContentTypeRichTextSecondaryContentResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ContentTypeRichTextSecondaryContentResourcesHyperlink_Fragment = { __typename?: 'ContentTypeRichTextSecondaryContentResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ContentTypeRichTextSecondaryContentResourcesInline_Fragment = { __typename?: 'ContentTypeRichTextSecondaryContentResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_FacilityDetailsPageMoreTextSeoResourcesBlock_Fragment = { __typename?: 'FacilityDetailsPageMoreTextSeoResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_FacilityDetailsPageMoreTextSeoResourcesHyperlink_Fragment = { __typename?: 'FacilityDetailsPageMoreTextSeoResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_FacilityDetailsPageMoreTextSeoResourcesInline_Fragment = { __typename?: 'FacilityDetailsPageMoreTextSeoResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_FacilityDetailsPageTextSeoResourcesBlock_Fragment = { __typename?: 'FacilityDetailsPageTextSeoResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_FacilityDetailsPageTextSeoResourcesHyperlink_Fragment = { __typename?: 'FacilityDetailsPageTextSeoResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_FacilityDetailsPageTextSeoResourcesInline_Fragment = { __typename?: 'FacilityDetailsPageTextSeoResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_GoogleMapTemplateNoResultsFoundMessageResourcesBlock_Fragment = { __typename?: 'GoogleMapTemplateNoResultsFoundMessageResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_GoogleMapTemplateNoResultsFoundMessageResourcesHyperlink_Fragment = { __typename?: 'GoogleMapTemplateNoResultsFoundMessageResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_GoogleMapTemplateNoResultsFoundMessageResourcesInline_Fragment = { __typename?: 'GoogleMapTemplateNoResultsFoundMessageResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_GoogleMapTemplateSingleComingSoonMessageResourcesBlock_Fragment = { __typename?: 'GoogleMapTemplateSingleComingSoonMessageResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_GoogleMapTemplateSingleComingSoonMessageResourcesHyperlink_Fragment = { __typename?: 'GoogleMapTemplateSingleComingSoonMessageResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_GoogleMapTemplateSingleComingSoonMessageResourcesInline_Fragment = { __typename?: 'GoogleMapTemplateSingleComingSoonMessageResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HalfScreenBodyResourcesBlock_Fragment = { __typename?: 'HalfScreenBodyResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HalfScreenBodyResourcesHyperlink_Fragment = { __typename?: 'HalfScreenBodyResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HalfScreenBodyResourcesInline_Fragment = { __typename?: 'HalfScreenBodyResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HalfScreenHeadingResourcesBlock_Fragment = { __typename?: 'HalfScreenHeadingResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HalfScreenHeadingResourcesHyperlink_Fragment = { __typename?: 'HalfScreenHeadingResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HalfScreenHeadingResourcesInline_Fragment = { __typename?: 'HalfScreenHeadingResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HalfScreenSubHeadingResourcesBlock_Fragment = { __typename?: 'HalfScreenSubHeadingResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HalfScreenSubHeadingResourcesHyperlink_Fragment = { __typename?: 'HalfScreenSubHeadingResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HalfScreenSubHeadingResourcesInline_Fragment = { __typename?: 'HalfScreenSubHeadingResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HeroV2BodyResourcesBlock_Fragment = { __typename?: 'HeroV2BodyResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HeroV2BodyResourcesHyperlink_Fragment = { __typename?: 'HeroV2BodyResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HeroV2BodyResourcesInline_Fragment = { __typename?: 'HeroV2BodyResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HeroV2HeadingResourcesBlock_Fragment = { __typename?: 'HeroV2HeadingResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HeroV2HeadingResourcesHyperlink_Fragment = { __typename?: 'HeroV2HeadingResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HeroV2HeadingResourcesInline_Fragment = { __typename?: 'HeroV2HeadingResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HeroV2PromoHeadlineResourcesBlock_Fragment = { __typename?: 'HeroV2PromoHeadlineResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HeroV2PromoHeadlineResourcesHyperlink_Fragment = { __typename?: 'HeroV2PromoHeadlineResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HeroV2PromoHeadlineResourcesInline_Fragment = { __typename?: 'HeroV2PromoHeadlineResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_InsuranceIntroResourcesBlock_Fragment = { __typename?: 'InsuranceIntroResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_InsuranceIntroResourcesHyperlink_Fragment = { __typename?: 'InsuranceIntroResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_InsuranceIntroResourcesInline_Fragment = { __typename?: 'InsuranceIntroResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MedicalServiceDescriptionResourcesBlock_Fragment = { __typename?: 'MedicalServiceDescriptionResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MedicalServiceDescriptionResourcesHyperlink_Fragment = { __typename?: 'MedicalServiceDescriptionResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MedicalServiceDescriptionResourcesInline_Fragment = { __typename?: 'MedicalServiceDescriptionResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MultiCardV2DescriptionRichTextResourcesBlock_Fragment = { __typename?: 'MultiCardV2DescriptionRichTextResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MultiCardV2DescriptionRichTextResourcesHyperlink_Fragment = { __typename?: 'MultiCardV2DescriptionRichTextResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MultiCardV2DescriptionRichTextResourcesInline_Fragment = { __typename?: 'MultiCardV2DescriptionRichTextResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ProductDisplayProductListDescriptionResourcesBlock_Fragment = { __typename?: 'ProductDisplayProductListDescriptionResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ProductDisplayProductListDescriptionResourcesHyperlink_Fragment = { __typename?: 'ProductDisplayProductListDescriptionResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ProductDisplayProductListDescriptionResourcesInline_Fragment = { __typename?: 'ProductDisplayProductListDescriptionResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_QuickLinksBodyResourcesBlock_Fragment = { __typename?: 'QuickLinksBodyResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_QuickLinksBodyResourcesHyperlink_Fragment = { __typename?: 'QuickLinksBodyResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_QuickLinksBodyResourcesInline_Fragment = { __typename?: 'QuickLinksBodyResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_QuickLinksHeadingResourcesBlock_Fragment = { __typename?: 'QuickLinksHeadingResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_QuickLinksHeadingResourcesHyperlink_Fragment = { __typename?: 'QuickLinksHeadingResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_QuickLinksHeadingResourcesInline_Fragment = { __typename?: 'QuickLinksHeadingResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SectionContentRichTextContentResourcesBlock_Fragment = { __typename?: 'SectionContentRichTextContentResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SectionContentRichTextContentResourcesHyperlink_Fragment = { __typename?: 'SectionContentRichTextContentResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SectionContentRichTextContentResourcesInline_Fragment = { __typename?: 'SectionContentRichTextContentResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceDetailsPageMoreTextSeoResourcesBlock_Fragment = { __typename?: 'ServiceDetailsPageMoreTextSeoResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceDetailsPageMoreTextSeoResourcesHyperlink_Fragment = { __typename?: 'ServiceDetailsPageMoreTextSeoResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceDetailsPageMoreTextSeoResourcesInline_Fragment = { __typename?: 'ServiceDetailsPageMoreTextSeoResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceDetailsPageTextSeoResourcesBlock_Fragment = { __typename?: 'ServiceDetailsPageTextSeoResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceDetailsPageTextSeoResourcesHyperlink_Fragment = { __typename?: 'ServiceDetailsPageTextSeoResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceDetailsPageTextSeoResourcesInline_Fragment = { __typename?: 'ServiceDetailsPageTextSeoResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceLineHeroBodyCopyResourcesBlock_Fragment = { __typename?: 'ServiceLineHeroBodyCopyResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceLineHeroBodyCopyResourcesHyperlink_Fragment = { __typename?: 'ServiceLineHeroBodyCopyResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceLineHeroBodyCopyResourcesInline_Fragment = { __typename?: 'ServiceLineHeroBodyCopyResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceLineHeroHeadlineResourcesBlock_Fragment = { __typename?: 'ServiceLineHeroHeadlineResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceLineHeroHeadlineResourcesHyperlink_Fragment = { __typename?: 'ServiceLineHeroHeadlineResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceLineHeroHeadlineResourcesInline_Fragment = { __typename?: 'ServiceLineHeroHeadlineResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceLineHeroSubHeadlineResourcesBlock_Fragment = { __typename?: 'ServiceLineHeroSubHeadlineResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceLineHeroSubHeadlineResourcesHyperlink_Fragment = { __typename?: 'ServiceLineHeroSubHeadlineResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceLineHeroSubHeadlineResourcesInline_Fragment = { __typename?: 'ServiceLineHeroSubHeadlineResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceRichTextDescriptionResourcesBlock_Fragment = { __typename?: 'ServiceRichTextDescriptionResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceRichTextDescriptionResourcesHyperlink_Fragment = { __typename?: 'ServiceRichTextDescriptionResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceRichTextDescriptionResourcesInline_Fragment = { __typename?: 'ServiceRichTextDescriptionResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SingleMessageContentResourcesBlock_Fragment = { __typename?: 'SingleMessageContentResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SingleMessageContentResourcesHyperlink_Fragment = { __typename?: 'SingleMessageContentResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SingleMessageContentResourcesInline_Fragment = { __typename?: 'SingleMessageContentResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SmallScreenContentBodySmallScreenResourcesBlock_Fragment = { __typename?: 'SmallScreenContentBodySmallScreenResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SmallScreenContentBodySmallScreenResourcesHyperlink_Fragment = { __typename?: 'SmallScreenContentBodySmallScreenResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SmallScreenContentBodySmallScreenResourcesInline_Fragment = { __typename?: 'SmallScreenContentBodySmallScreenResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SmallScreenContentHeadingSmallScreenResourcesBlock_Fragment = { __typename?: 'SmallScreenContentHeadingSmallScreenResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SmallScreenContentHeadingSmallScreenResourcesHyperlink_Fragment = { __typename?: 'SmallScreenContentHeadingSmallScreenResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SmallScreenContentHeadingSmallScreenResourcesInline_Fragment = { __typename?: 'SmallScreenContentHeadingSmallScreenResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TableDescriptionRichTextResourcesBlock_Fragment = { __typename?: 'TableDescriptionRichTextResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TableDescriptionRichTextResourcesHyperlink_Fragment = { __typename?: 'TableDescriptionRichTextResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TableDescriptionRichTextResourcesInline_Fragment = { __typename?: 'TableDescriptionRichTextResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TableFootnoteResourcesBlock_Fragment = { __typename?: 'TableFootnoteResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TableFootnoteResourcesHyperlink_Fragment = { __typename?: 'TableFootnoteResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TableFootnoteResourcesInline_Fragment = { __typename?: 'TableFootnoteResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TableTableContentResourcesBlock_Fragment = { __typename?: 'TableTableContentResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TableTableContentResourcesHyperlink_Fragment = { __typename?: 'TableTableContentResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TableTableContentResourcesInline_Fragment = { __typename?: 'TableTableContentResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TermsAndConditionsContentResourcesBlock_Fragment = { __typename?: 'TermsAndConditionsContentResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TermsAndConditionsContentResourcesHyperlink_Fragment = { __typename?: 'TermsAndConditionsContentResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TermsAndConditionsContentResourcesInline_Fragment = { __typename?: 'TermsAndConditionsContentResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TextBlockSeoContentResourcesBlock_Fragment = { __typename?: 'TextBlockSeoContentResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TextBlockSeoContentResourcesHyperlink_Fragment = { __typename?: 'TextBlockSeoContentResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TextBlockSeoContentResourcesInline_Fragment = { __typename?: 'TextBlockSeoContentResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMetaFragment = ResourceMeta_AccordionsDescriptionRichTextResourcesBlock_Fragment | ResourceMeta_AccordionsDescriptionRichTextResourcesHyperlink_Fragment | ResourceMeta_AccordionsDescriptionRichTextResourcesInline_Fragment | ResourceMeta_AdFooterAboutResourcesBlock_Fragment | ResourceMeta_AdFooterAboutResourcesHyperlink_Fragment | ResourceMeta_AdFooterAboutResourcesInline_Fragment | ResourceMeta_BlogAuthorAuthorBioSummaryResourcesBlock_Fragment | ResourceMeta_BlogAuthorAuthorBioSummaryResourcesHyperlink_Fragment | ResourceMeta_BlogAuthorAuthorBioSummaryResourcesInline_Fragment | ResourceMeta_BlogDetailsPageHeroContentTitleResourcesBlock_Fragment | ResourceMeta_BlogDetailsPageHeroContentTitleResourcesHyperlink_Fragment | ResourceMeta_BlogDetailsPageHeroContentTitleResourcesInline_Fragment | ResourceMeta_BlogDetailsPageSummaryResourcesBlock_Fragment | ResourceMeta_BlogDetailsPageSummaryResourcesHyperlink_Fragment | ResourceMeta_BlogDetailsPageSummaryResourcesInline_Fragment | ResourceMeta_BlogDetailsPageTextResourcesBlock_Fragment | ResourceMeta_BlogDetailsPageTextResourcesHyperlink_Fragment | ResourceMeta_BlogDetailsPageTextResourcesInline_Fragment | ResourceMeta_BlogListPageDescriptionResourcesBlock_Fragment | ResourceMeta_BlogListPageDescriptionResourcesHyperlink_Fragment | ResourceMeta_BlogListPageDescriptionResourcesInline_Fragment | ResourceMeta_CardRichTextDescriptionResourcesBlock_Fragment | ResourceMeta_CardRichTextDescriptionResourcesHyperlink_Fragment | ResourceMeta_CardRichTextDescriptionResourcesInline_Fragment | ResourceMeta_ContentSectionDescriptionResourcesBlock_Fragment | ResourceMeta_ContentSectionDescriptionResourcesHyperlink_Fragment | ResourceMeta_ContentSectionDescriptionResourcesInline_Fragment | ResourceMeta_ContentTypeRichTextContentResourcesBlock_Fragment | ResourceMeta_ContentTypeRichTextContentResourcesHyperlink_Fragment | ResourceMeta_ContentTypeRichTextContentResourcesInline_Fragment | ResourceMeta_ContentTypeRichTextSecondaryContentResourcesBlock_Fragment | ResourceMeta_ContentTypeRichTextSecondaryContentResourcesHyperlink_Fragment | ResourceMeta_ContentTypeRichTextSecondaryContentResourcesInline_Fragment | ResourceMeta_FacilityDetailsPageMoreTextSeoResourcesBlock_Fragment | ResourceMeta_FacilityDetailsPageMoreTextSeoResourcesHyperlink_Fragment | ResourceMeta_FacilityDetailsPageMoreTextSeoResourcesInline_Fragment | ResourceMeta_FacilityDetailsPageTextSeoResourcesBlock_Fragment | ResourceMeta_FacilityDetailsPageTextSeoResourcesHyperlink_Fragment | ResourceMeta_FacilityDetailsPageTextSeoResourcesInline_Fragment | ResourceMeta_GoogleMapTemplateNoResultsFoundMessageResourcesBlock_Fragment | ResourceMeta_GoogleMapTemplateNoResultsFoundMessageResourcesHyperlink_Fragment | ResourceMeta_GoogleMapTemplateNoResultsFoundMessageResourcesInline_Fragment | ResourceMeta_GoogleMapTemplateSingleComingSoonMessageResourcesBlock_Fragment | ResourceMeta_GoogleMapTemplateSingleComingSoonMessageResourcesHyperlink_Fragment | ResourceMeta_GoogleMapTemplateSingleComingSoonMessageResourcesInline_Fragment | ResourceMeta_HalfScreenBodyResourcesBlock_Fragment | ResourceMeta_HalfScreenBodyResourcesHyperlink_Fragment | ResourceMeta_HalfScreenBodyResourcesInline_Fragment | ResourceMeta_HalfScreenHeadingResourcesBlock_Fragment | ResourceMeta_HalfScreenHeadingResourcesHyperlink_Fragment | ResourceMeta_HalfScreenHeadingResourcesInline_Fragment | ResourceMeta_HalfScreenSubHeadingResourcesBlock_Fragment | ResourceMeta_HalfScreenSubHeadingResourcesHyperlink_Fragment | ResourceMeta_HalfScreenSubHeadingResourcesInline_Fragment | ResourceMeta_HeroV2BodyResourcesBlock_Fragment | ResourceMeta_HeroV2BodyResourcesHyperlink_Fragment | ResourceMeta_HeroV2BodyResourcesInline_Fragment | ResourceMeta_HeroV2HeadingResourcesBlock_Fragment | ResourceMeta_HeroV2HeadingResourcesHyperlink_Fragment | ResourceMeta_HeroV2HeadingResourcesInline_Fragment | ResourceMeta_HeroV2PromoHeadlineResourcesBlock_Fragment | ResourceMeta_HeroV2PromoHeadlineResourcesHyperlink_Fragment | ResourceMeta_HeroV2PromoHeadlineResourcesInline_Fragment | ResourceMeta_InsuranceIntroResourcesBlock_Fragment | ResourceMeta_InsuranceIntroResourcesHyperlink_Fragment | ResourceMeta_InsuranceIntroResourcesInline_Fragment | ResourceMeta_MedicalServiceDescriptionResourcesBlock_Fragment | ResourceMeta_MedicalServiceDescriptionResourcesHyperlink_Fragment | ResourceMeta_MedicalServiceDescriptionResourcesInline_Fragment | ResourceMeta_MultiCardV2DescriptionRichTextResourcesBlock_Fragment | ResourceMeta_MultiCardV2DescriptionRichTextResourcesHyperlink_Fragment | ResourceMeta_MultiCardV2DescriptionRichTextResourcesInline_Fragment | ResourceMeta_ProductDisplayProductListDescriptionResourcesBlock_Fragment | ResourceMeta_ProductDisplayProductListDescriptionResourcesHyperlink_Fragment | ResourceMeta_ProductDisplayProductListDescriptionResourcesInline_Fragment | ResourceMeta_QuickLinksBodyResourcesBlock_Fragment | ResourceMeta_QuickLinksBodyResourcesHyperlink_Fragment | ResourceMeta_QuickLinksBodyResourcesInline_Fragment | ResourceMeta_QuickLinksHeadingResourcesBlock_Fragment | ResourceMeta_QuickLinksHeadingResourcesHyperlink_Fragment | ResourceMeta_QuickLinksHeadingResourcesInline_Fragment | ResourceMeta_SectionContentRichTextContentResourcesBlock_Fragment | ResourceMeta_SectionContentRichTextContentResourcesHyperlink_Fragment | ResourceMeta_SectionContentRichTextContentResourcesInline_Fragment | ResourceMeta_ServiceDetailsPageMoreTextSeoResourcesBlock_Fragment | ResourceMeta_ServiceDetailsPageMoreTextSeoResourcesHyperlink_Fragment | ResourceMeta_ServiceDetailsPageMoreTextSeoResourcesInline_Fragment | ResourceMeta_ServiceDetailsPageTextSeoResourcesBlock_Fragment | ResourceMeta_ServiceDetailsPageTextSeoResourcesHyperlink_Fragment | ResourceMeta_ServiceDetailsPageTextSeoResourcesInline_Fragment | ResourceMeta_ServiceLineHeroBodyCopyResourcesBlock_Fragment | ResourceMeta_ServiceLineHeroBodyCopyResourcesHyperlink_Fragment | ResourceMeta_ServiceLineHeroBodyCopyResourcesInline_Fragment | ResourceMeta_ServiceLineHeroHeadlineResourcesBlock_Fragment | ResourceMeta_ServiceLineHeroHeadlineResourcesHyperlink_Fragment | ResourceMeta_ServiceLineHeroHeadlineResourcesInline_Fragment | ResourceMeta_ServiceLineHeroSubHeadlineResourcesBlock_Fragment | ResourceMeta_ServiceLineHeroSubHeadlineResourcesHyperlink_Fragment | ResourceMeta_ServiceLineHeroSubHeadlineResourcesInline_Fragment | ResourceMeta_ServiceRichTextDescriptionResourcesBlock_Fragment | ResourceMeta_ServiceRichTextDescriptionResourcesHyperlink_Fragment | ResourceMeta_ServiceRichTextDescriptionResourcesInline_Fragment | ResourceMeta_SingleMessageContentResourcesBlock_Fragment | ResourceMeta_SingleMessageContentResourcesHyperlink_Fragment | ResourceMeta_SingleMessageContentResourcesInline_Fragment | ResourceMeta_SmallScreenContentBodySmallScreenResourcesBlock_Fragment | ResourceMeta_SmallScreenContentBodySmallScreenResourcesHyperlink_Fragment | ResourceMeta_SmallScreenContentBodySmallScreenResourcesInline_Fragment | ResourceMeta_SmallScreenContentHeadingSmallScreenResourcesBlock_Fragment | ResourceMeta_SmallScreenContentHeadingSmallScreenResourcesHyperlink_Fragment | ResourceMeta_SmallScreenContentHeadingSmallScreenResourcesInline_Fragment | ResourceMeta_TableDescriptionRichTextResourcesBlock_Fragment | ResourceMeta_TableDescriptionRichTextResourcesHyperlink_Fragment | ResourceMeta_TableDescriptionRichTextResourcesInline_Fragment | ResourceMeta_TableFootnoteResourcesBlock_Fragment | ResourceMeta_TableFootnoteResourcesHyperlink_Fragment | ResourceMeta_TableFootnoteResourcesInline_Fragment | ResourceMeta_TableTableContentResourcesBlock_Fragment | ResourceMeta_TableTableContentResourcesHyperlink_Fragment | ResourceMeta_TableTableContentResourcesInline_Fragment | ResourceMeta_TermsAndConditionsContentResourcesBlock_Fragment | ResourceMeta_TermsAndConditionsContentResourcesHyperlink_Fragment | ResourceMeta_TermsAndConditionsContentResourcesInline_Fragment | ResourceMeta_TextBlockSeoContentResourcesBlock_Fragment | ResourceMeta_TextBlockSeoContentResourcesHyperlink_Fragment | ResourceMeta_TextBlockSeoContentResourcesInline_Fragment;

export type Error404Fragment = { __typename?: 'Error404', heading?: string | null, subtitle?: string | null, body?: string | null, buttonLabel?: string | null, darkTextColor?: boolean | null, backgroundImage?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, backgroundImageMobile?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type GoogleMapTemplateFragment = (
  { __typename?: 'GoogleMapTemplate', title?: string | null, titleHtag?: string | null, useUsaCountryMap?: boolean | null, desktopZoom?: number | null, mobileZoom?: number | null, locationScheduleButtonUrl?: string | null, googleMapsBusinessQuery?: string | null, facilityBasePath?: string | null, holidayHoursMessageText?: string | null, listTabIsHorizontalScrolling?: boolean | null, facilityBadgeLabel?: string | null, facilityButtonLabel?: string | null, useModernDesign?: boolean | null, setAsOfficeButtonText?: string | null, useCumulativeDesign?: boolean | null, anchorId?: string | null, defaultImage?: (
    { __typename?: 'Asset', url?: string | null }
    & CommonAssetFragment
  ) | null, selectedImage?: (
    { __typename?: 'Asset', url?: string | null }
    & CommonAssetFragment
  ) | null, noResultsFoundMessage?: { __typename?: 'GoogleMapTemplateNoResultsFoundMessage', json: any } | null, singleComingSoonMessage?: { __typename?: 'GoogleMapTemplateSingleComingSoonMessage', json: any } | null, scheduleButton?: (
    { __typename?: 'Button' }
    & ButtonFragment
  ) | null, officeDetailsButton?: (
    { __typename?: 'Button' }
    & ButtonFragment
  ) | null, noResultsFoundImage?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null, noResultsContent?: (
    { __typename?: 'MultiCardV2' }
    & CardsFragment
  ) | null, availableServicesTabs?: (
    { __typename?: 'Tabs' }
    & TabsFragment
  ) | null }
  & Meta_GoogleMapTemplate_Fragment
);

export type GoogleMapInHeaderFragment = (
  { __typename?: 'GoogleMapTemplate', title?: string | null, titleHtag?: string | null, locationScheduleButtonUrl?: string | null, googleMapsBusinessQuery?: string | null, facilityBadgeLabel?: string | null, facilityButtonLabel?: string | null, setAsOfficeButtonText?: string | null, defaultImage?: (
    { __typename?: 'Asset', url?: string | null }
    & CommonAssetFragment
  ) | null, selectedImage?: (
    { __typename?: 'Asset', url?: string | null }
    & CommonAssetFragment
  ) | null, noResultsFoundMessage?: { __typename?: 'GoogleMapTemplateNoResultsFoundMessage', json: any } | null, scheduleButton?: (
    { __typename?: 'Button' }
    & ButtonFragment
  ) | null, officeDetailsButton?: (
    { __typename?: 'Button' }
    & ButtonFragment
  ) | null }
  & Meta_GoogleMapTemplate_Fragment
);

export type HalfScreenFragment = (
  { __typename?: 'HalfScreen', name?: string | null, backgroundColor?: string | null, eyebrow?: string | null, eyebrowStyle?: string | null, templateSize?: string | null, mediaFirst?: boolean | null, facilitySegmentCollection?: string | null, hideContentHalf?: boolean | null, isInsetLayout?: boolean | null, useStaticImageSize?: boolean | null, anchorId?: string | null, textAlignment?: string | null, termsAndConditions?: (
    { __typename?: 'TermsAndConditions' }
    & TermOfConditionsFragment
  ) | null, heading?: { __typename?: 'HalfScreenHeading', json: any } | null, subHeading?: { __typename?: 'HalfScreenSubHeading', json: any } | null, body?: { __typename?: 'HalfScreenBody', json: any } | null, image?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, buttonCollection?: { __typename?: 'HalfScreenButtonCollection', limit: number, skip: number, total: number, items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null, video?: (
    { __typename?: 'Video' }
    & VideoFragment
  ) | null, contentSmallScreen?: { __typename?: 'SmallScreenContent', mediaFirst?: boolean | null, headingSmallScreen?: { __typename?: 'SmallScreenContentHeadingSmallScreen', json: any } | null, bodySmallScreen?: { __typename?: 'SmallScreenContentBodySmallScreen', json: any } | null, imageSmallScreen?: (
      { __typename?: 'Asset' }
      & ImageFragment
    ) | null } | null, disclaimer?: (
    { __typename?: 'DisclaimerV2' }
    & DisclaimerV2Fragment
  ) | null, imageAsset?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null, videoAsset?: (
    { __typename?: 'VideoAsset' }
    & VideoAssetFragment
  ) | null, imageAssetTwo?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null }
  & Meta_HalfScreen_Fragment
);

export type HeroFragment = (
  { __typename?: 'HeroV2', entryName?: string | null, display?: string | null, backgroundColorSmallScreen?: string | null, bodySize?: string | null, contentAlign?: string | null, contentWidth?: string | null, contentPosition?: string | null, contentPositionSmallScreen?: string | null, darkOverlay?: boolean | null, darkTextColor?: boolean | null, eyebrow?: string | null, eyebrowStyle?: string | null, facilitySegmentCollection?: string | null, headingSize?: string | null, mediaAspectRatioSmallScreen?: string | null, templateWidth?: string | null, heightStyle?: string | null, promoHeadlineSize?: string | null, anchorId?: string | null, body?: { __typename?: 'HeroV2Body', json: any } | null, buttonsCollection?: { __typename?: 'HeroV2ButtonsCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null, contentSmallScreen?: { __typename?: 'SmallScreenContent', eyebrowSmallScreen?: string | null, mediaFirst?: boolean | null, headingSmallScreen?: { __typename?: 'SmallScreenContentHeadingSmallScreen', json: any } | null, bodySmallScreen?: { __typename?: 'SmallScreenContentBodySmallScreen', json: any } | null, imageSmallScreen?: (
      { __typename?: 'Asset' }
      & ImageFragment
    ) | null, focalPointImageSmallScreen?: (
      { __typename?: 'FocalPointImage' }
      & FocalPointImageFragment
    ) | null } | null, focalPointImage?: (
    { __typename?: 'FocalPointImage' }
    & FocalPointImageFragment
  ) | null, heading?: { __typename?: 'HeroV2Heading', json: any } | null, termsConditions?: (
    { __typename?: 'TermsAndConditions' }
    & TermOfConditionsFragment
  ) | null, video?: (
    { __typename?: 'Asset', url?: string | null }
    & CommonAssetFragment
  ) | null, promoHeadline?: { __typename?: 'HeroV2PromoHeadline', json: any } | null, disclaimer?: (
    { __typename?: 'DisclaimerV2' }
    & DisclaimerV2Fragment
  ) | null, imageAsset?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null, videoAsset?: (
    { __typename?: 'VideoAsset' }
    & VideoAssetFragment
  ) | null }
  & Meta_HeroV2_Fragment
);

export type IframeFragment = (
  { __typename?: 'Iframe', title?: string | null, url?: string | null, height?: number | null, rawHtml?: string | null }
  & Meta_Iframe_Fragment
);

export type FocalPointImageFragment = (
  { __typename?: 'FocalPointImage', focalPoint?: any | null, image?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null }
  & Meta_FocalPointImage_Fragment
);

export type ImageFragment = (
  { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null }
  & CommonAssetFragment
);

export type PdfFragment = (
  { __typename?: 'Asset', url?: string | null }
  & CommonAssetFragment
);

export type CommonAssetFragment = { __typename: 'Asset', title?: string | null, description?: string | null, fileName?: string | null, contentType?: string | null, size?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', name?: string | null, id?: string | null } | null> } };

export type VideoFragment = (
  { __typename: 'Video', autoPlay?: boolean | null, isMuted?: boolean | null, isLooped?: boolean | null, posterUrl?: string | null, youtubeId?: string | null, useOriginalVideoSize?: boolean | null, videoSource?: string | null, hlsVideoStreamLink?: string | null, media?: (
    { __typename: 'Asset', url?: string | null }
    & CommonAssetFragment
  ) | null, posterMedia?: (
    { __typename?: 'Asset', url?: string | null }
    & CommonAssetFragment
  ) | null }
  & Meta_Video_Fragment
);

export type ImageAssetFragment = (
  { __typename?: 'ImageAsset', desktopImage?: any | null, mobileImage?: any | null }
  & Meta_ImageAsset_Fragment
);

export type InsuranceFragment = (
  { __typename?: 'Insurance', title?: string | null, intro?: { __typename?: 'InsuranceIntro', json: any } | null }
  & Meta_Insurance_Fragment
);

export type LinkForwarderFragment = (
  { __typename?: 'LinkForwarder', url?: string | null }
  & Meta_LinkForwarder_Fragment
);

export type MarqueeFragment = (
  { __typename?: 'Marquee', textList?: Array<string | null> | null, icon?: string | null, height?: string | null, backgroundColor?: string | null, withAutoScrolling?: boolean | null, facilitySegmentCollection?: string | null, anchorId?: string | null }
  & Meta_Marquee_Fragment
);

export type MeetOurStaffFragment = (
  { __typename?: 'MeetOurStaff', title?: string | null, description?: string | null, sectionBackground?: string | null, alignment?: string | null, contentMaxWidth?: string | null, showDisabledSwiperArrows?: boolean | null, withDesktopPaginationNavigation?: boolean | null, withMobileArrowsNavigation?: boolean | null, anchorId?: string | null }
  & Meta_MeetOurStaff_Fragment
);

export type MobileButtonFragment = (
  { __typename?: 'MobileButton', name?: string | null, label?: string | null, variant?: string | null, size?: string | null, icon?: string | null, iconPosition?: string | null }
  & Meta_MobileButton_Fragment
);

export type CardsFragment = (
  { __typename?: 'MultiCardV2', anchorId?: string | null, backgroundColor?: string | null, bigScreenBackground?: boolean | null, cardsAlignment?: string | null, eyebrowColor?: string | null, eyebrowSx?: string | null, eyebrowTextTransform?: string | null, disablePaddingOn?: Array<string | null> | null, forMobile?: string | null, enableMobileCarouselNavigation?: boolean | null, lastRowCardsAlignment?: string | null, name?: string | null, numberOfCardsInLineDesktop?: number | null, roundedImage?: boolean | null, sectionEyebrow?: string | null, sectionInfoAlignment?: string | null, sectionTitle?: string | null, sectionTitleHtag?: string | null, facilitySegmentCollection?: string | null, displayAsStepper?: boolean | null, fixBackgroundToBottom?: boolean | null, headerSpacing?: string | null, enableResourceCardMode?: boolean | null, shouldDisplayCarouselOnDesktop?: boolean | null, useCardMediaRoundedCorners?: boolean | null, descriptionRichText?: { __typename?: 'MultiCardV2DescriptionRichText', json: any } | null, cardsCollection?: { __typename?: 'MultiCardV2CardsCollection', items: Array<(
      { __typename?: 'Card' }
      & CardFragment
    ) | null> } | null, buttonsCollection?: { __typename?: 'MultiCardV2ButtonsCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null, backgroundImage?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null }
  & Meta_MultiCardV2_Fragment
);

export type FooterNavigationGroupFragment = (
  { __typename?: 'FooterNavigationGroup', componentName?: string | null, navigationGroupLink?: (
    { __typename?: 'Page' }
    & BasePageFragment
  ) | null, navigationLinksForGroupCollection?: { __typename?: 'FooterNavigationGroupNavigationLinksForGroupCollection', skip: number, limit: number, total: number, items: Array<{ __typename?: 'NavigationLink' } | (
      { __typename?: 'Page' }
      & BasePageFragment
    ) | null> } | null }
  & EnrichedMeta_FooterNavigationGroup_Fragment
);

export type BasePageFragment = (
  { __typename?: 'Page', path?: string | null, title?: string | null, breadcrumbTitle?: string | null, description?: string | null, image?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null }
  & EnrichedMeta_Page_Fragment
);

export type NavLinkFragment = (
  { __typename?: 'NavigationLink', externalUrl?: string | null, linkText?: string | null, openInNewTab?: boolean | null, openInNewWindow?: boolean | null, isInternal?: boolean | null, linkIcon?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, pageData?: (
    { __typename?: 'BlogDetailsPage', path?: string | null }
    & Meta_BlogDetailsPage_Fragment
  ) | (
    { __typename?: 'FacilityDetailsPage', path?: string | null }
    & Meta_FacilityDetailsPage_Fragment
  ) | (
    { __typename?: 'Page' }
    & BasePageFragment
  ) | (
    { __typename?: 'ServiceDetailsPage', path?: string | null }
    & Meta_ServiceDetailsPage_Fragment
  ) | null, analyticsContext?: (
    { __typename?: 'AnalyticsContext' }
    & AnalyticsFragment
  ) | null }
  & EnrichedMeta_NavigationLink_Fragment
);

export type ContentTileFragment = (
  { __typename?: 'ContentTile', title?: string | null, description?: string | null, image?: any | null, externalUrl?: string | null, internalPage?: (
    { __typename?: 'Page' }
    & BasePageFragment
  ) | null }
  & EnrichedMeta_ContentTile_Fragment
);

export type HeaderSubNavFragment = { __typename?: 'HeaderSubNav', headerSubNavGroupsCollection?: { __typename?: 'HeaderSubNavHeaderSubNavGroupsCollection', items: Array<{ __typename?: 'NavigationGroup', displayAsExpandedForMobileMenu?: boolean | null, groupLink?: (
        { __typename?: 'NavigationLink' }
        & NavLinkFragment
      ) | null, linksCollection?: { __typename?: 'NavigationGroupLinksCollection', items: Array<(
          { __typename?: 'NavigationLink' }
          & NavLinkFragment
        ) | null> } | null } | null> } | null, contentTilesCollection?: { __typename?: 'HeaderSubNavContentTilesCollection', items: Array<(
      { __typename?: 'ContentTile' }
      & ContentTileFragment
    ) | null> } | null };

export type HeaderMainNavFragment = { __typename?: 'HeaderMainNav', headerMainNavLink?: (
    { __typename?: 'NavigationLink' }
    & NavLinkFragment
  ) | null, headerSubNavMenu?: (
    { __typename?: 'HeaderSubNav' }
    & HeaderSubNavFragment
  ) | null };

export type HeaderNavMenuFragment = { __typename?: 'HeaderNavMenu', headerMainNavLinksCollection?: { __typename?: 'HeaderNavMenuHeaderMainNavLinksCollection', items: Array<(
      { __typename?: 'HeaderMainNav' }
      & HeaderMainNavFragment
    ) | null> } | null };

export type HeaderFragment = (
  { __typename?: 'Header', darkHeader?: boolean | null, componentName?: string | null, hideFullSiteSearch?: boolean | null, locationBarFindOfficeUrl?: string | null, locationBarWithOfficeTitle?: string | null, locationBarWithOutOfficeTitle?: string | null, useNewLayout?: boolean | null, schedulingButtonUrlMobile?: string | null, schedulingButtonUrl?: string | null, schedulingButtonText?: string | null, schedulingButtonTextMobile?: string | null, myAccountLabel?: string | null, profileLinkUrl?: string | null, useHeaderLocationCards?: boolean | null, showSecondaryNavInMobileToolbar?: boolean | null, usePopupScheduling?: boolean | null, bookNowButton?: (
    { __typename?: 'Accordions' }
    & EnrichedMeta_Accordions_Fragment
  ) | (
    { __typename?: 'AdFooter' }
    & EnrichedMeta_AdFooter_Fragment
  ) | (
    { __typename?: 'AgendaModal' }
    & EnrichedMeta_AgendaModal_Fragment
  ) | (
    { __typename?: 'AgendaStepper' }
    & EnrichedMeta_AgendaStepper_Fragment
  ) | (
    { __typename?: 'AnalyticsContext' }
    & EnrichedMeta_AnalyticsContext_Fragment
  ) | (
    { __typename?: 'App' }
    & EnrichedMeta_App_Fragment
  ) | (
    { __typename?: 'AppointmentBookingPage' }
    & EnrichedMeta_AppointmentBookingPage_Fragment
  ) | (
    { __typename?: 'Badge' }
    & EnrichedMeta_Badge_Fragment
  ) | (
    { __typename?: 'Banner' }
    & EnrichedMeta_Banner_Fragment
  ) | (
    { __typename?: 'BirdEyeReviews' }
    & EnrichedMeta_BirdEyeReviews_Fragment
  ) | (
    { __typename?: 'BlogAuthor' }
    & EnrichedMeta_BlogAuthor_Fragment
  ) | (
    { __typename?: 'BlogCategory' }
    & EnrichedMeta_BlogCategory_Fragment
  ) | (
    { __typename?: 'BlogDetailsPage' }
    & EnrichedMeta_BlogDetailsPage_Fragment
  ) | (
    { __typename?: 'BlogList' }
    & EnrichedMeta_BlogList_Fragment
  ) | (
    { __typename?: 'BlogListPage' }
    & EnrichedMeta_BlogListPage_Fragment
  ) | (
    { __typename?: 'BlogSubCategory' }
    & EnrichedMeta_BlogSubCategory_Fragment
  ) | (
    { __typename?: 'Brand' }
    & EnrichedMeta_Brand_Fragment
  ) | (
    { __typename?: 'Button' }
    & EnrichedMeta_Button_Fragment
  ) | (
    { __typename?: 'Card' }
    & EnrichedMeta_Card_Fragment
  ) | (
    { __typename?: 'Category' }
    & EnrichedMeta_Category_Fragment
  ) | (
    { __typename?: 'CategoryPicker' }
    & EnrichedMeta_CategoryPicker_Fragment
  ) | (
    { __typename?: 'CityLinks' }
    & EnrichedMeta_CityLinks_Fragment
  ) | (
    { __typename?: 'Columns' }
    & EnrichedMeta_Columns_Fragment
  ) | (
    { __typename?: 'ConfirmationStep' }
    & EnrichedMeta_ConfirmationStep_Fragment
  ) | (
    { __typename?: 'ContentSection' }
    & EnrichedMeta_ContentSection_Fragment
  ) | (
    { __typename?: 'ContentTile' }
    & EnrichedMeta_ContentTile_Fragment
  ) | (
    { __typename?: 'ContentTypeRichText' }
    & EnrichedMeta_ContentTypeRichText_Fragment
  ) | (
    { __typename?: 'DisclaimerV2' }
    & EnrichedMeta_DisclaimerV2_Fragment
  ) | (
    { __typename?: 'Error404' }
    & EnrichedMeta_Error404_Fragment
  ) | (
    { __typename?: 'FacilityDetailsPage' }
    & EnrichedMeta_FacilityDetailsPage_Fragment
  ) | (
    { __typename?: 'FeatureFlags' }
    & EnrichedMeta_FeatureFlags_Fragment
  ) | (
    { __typename?: 'FocalPointImage' }
    & EnrichedMeta_FocalPointImage_Fragment
  ) | (
    { __typename?: 'FooterNavigationGroup' }
    & EnrichedMeta_FooterNavigationGroup_Fragment
  ) | (
    { __typename?: 'FormDropdownField' }
    & EnrichedMeta_FormDropdownField_Fragment
  ) | (
    { __typename?: 'FormDropdownListItem' }
    & EnrichedMeta_FormDropdownListItem_Fragment
  ) | (
    { __typename?: 'FormField' }
    & EnrichedMeta_FormField_Fragment
  ) | (
    { __typename?: 'GoogleMapTemplate' }
    & EnrichedMeta_GoogleMapTemplate_Fragment
  ) | (
    { __typename?: 'HalfScreen' }
    & EnrichedMeta_HalfScreen_Fragment
  ) | (
    { __typename?: 'Header' }
    & EnrichedMeta_Header_Fragment
  ) | (
    { __typename?: 'HeaderMainNav' }
    & EnrichedMeta_HeaderMainNav_Fragment
  ) | (
    { __typename?: 'HeaderNavMenu' }
    & EnrichedMeta_HeaderNavMenu_Fragment
  ) | (
    { __typename?: 'HeaderSubNav' }
    & EnrichedMeta_HeaderSubNav_Fragment
  ) | (
    { __typename?: 'HeroV2' }
    & EnrichedMeta_HeroV2_Fragment
  ) | (
    { __typename?: 'Iframe' }
    & EnrichedMeta_Iframe_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & EnrichedMeta_ImageAsset_Fragment
  ) | (
    { __typename?: 'Insurance' }
    & EnrichedMeta_Insurance_Fragment
  ) | (
    { __typename?: 'LinkForwarder' }
    & EnrichedMeta_LinkForwarder_Fragment
  ) | (
    { __typename?: 'LocalizedServiceTitle' }
    & EnrichedMeta_LocalizedServiceTitle_Fragment
  ) | (
    { __typename?: 'Marquee' }
    & EnrichedMeta_Marquee_Fragment
  ) | (
    { __typename?: 'MediaSlider' }
    & EnrichedMeta_MediaSlider_Fragment
  ) | (
    { __typename?: 'MedicalService' }
    & EnrichedMeta_MedicalService_Fragment
  ) | (
    { __typename?: 'MeetOurStaff' }
    & EnrichedMeta_MeetOurStaff_Fragment
  ) | (
    { __typename?: 'MobileButton' }
    & EnrichedMeta_MobileButton_Fragment
  ) | (
    { __typename?: 'MultiCardV2' }
    & EnrichedMeta_MultiCardV2_Fragment
  ) | (
    { __typename?: 'NavigationGroup' }
    & EnrichedMeta_NavigationGroup_Fragment
  ) | (
    { __typename?: 'NavigationLink' }
    & EnrichedMeta_NavigationLink_Fragment
  ) | (
    { __typename?: 'OdpHero' }
    & EnrichedMeta_OdpHero_Fragment
  ) | (
    { __typename?: 'Page' }
    & EnrichedMeta_Page_Fragment
  ) | (
    { __typename?: 'PatientReviewV2' }
    & EnrichedMeta_PatientReviewV2_Fragment
  ) | (
    { __typename?: 'PatientReviewsV2' }
    & EnrichedMeta_PatientReviewsV2_Fragment
  ) | (
    { __typename?: 'Product' }
    & EnrichedMeta_Product_Fragment
  ) | (
    { __typename?: 'ProductDisplay' }
    & EnrichedMeta_ProductDisplay_Fragment
  ) | (
    { __typename?: 'ProductFeature' }
    & EnrichedMeta_ProductFeature_Fragment
  ) | (
    { __typename?: 'ProductFeatureDescriptionListItem' }
    & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
  ) | (
    { __typename?: 'ProviderDetailsPage' }
    & EnrichedMeta_ProviderDetailsPage_Fragment
  ) | (
    { __typename?: 'Questionnaire' }
    & EnrichedMeta_Questionnaire_Fragment
  ) | (
    { __typename?: 'QuickLinks' }
    & EnrichedMeta_QuickLinks_Fragment
  ) | (
    { __typename?: 'Quiz' }
    & EnrichedMeta_Quiz_Fragment
  ) | (
    { __typename?: 'ReviewStep' }
    & EnrichedMeta_ReviewStep_Fragment
  ) | (
    { __typename?: 'Schema' }
    & EnrichedMeta_Schema_Fragment
  ) | (
    { __typename?: 'SectionContent' }
    & EnrichedMeta_SectionContent_Fragment
  ) | (
    { __typename?: 'SegmentsContainer' }
    & EnrichedMeta_SegmentsContainer_Fragment
  ) | (
    { __typename?: 'Service' }
    & EnrichedMeta_Service_Fragment
  ) | (
    { __typename?: 'ServiceDetailsPage' }
    & EnrichedMeta_ServiceDetailsPage_Fragment
  ) | (
    { __typename?: 'ServiceLineHero' }
    & EnrichedMeta_ServiceLineHero_Fragment
  ) | (
    { __typename?: 'SingleMessage' }
    & EnrichedMeta_SingleMessage_Fragment
  ) | (
    { __typename?: 'SmallScreenContent' }
    & EnrichedMeta_SmallScreenContent_Fragment
  ) | (
    { __typename?: 'SmileAssessmentForm' }
    & EnrichedMeta_SmileAssessmentForm_Fragment
  ) | (
    { __typename?: 'Spacer' }
    & EnrichedMeta_Spacer_Fragment
  ) | (
    { __typename?: 'StateLinks' }
    & EnrichedMeta_StateLinks_Fragment
  ) | (
    { __typename?: 'Stepper' }
    & EnrichedMeta_Stepper_Fragment
  ) | (
    { __typename?: 'SuccessCard' }
    & EnrichedMeta_SuccessCard_Fragment
  ) | (
    { __typename?: 'Tab' }
    & EnrichedMeta_Tab_Fragment
  ) | (
    { __typename?: 'Table' }
    & EnrichedMeta_Table_Fragment
  ) | (
    { __typename?: 'Tabs' }
    & EnrichedMeta_Tabs_Fragment
  ) | (
    { __typename?: 'TermsAndConditions' }
    & EnrichedMeta_TermsAndConditions_Fragment
  ) | (
    { __typename?: 'TextBlockSeo' }
    & EnrichedMeta_TextBlockSeo_Fragment
  ) | (
    { __typename?: 'Video' }
    & EnrichedMeta_Video_Fragment
  ) | (
    { __typename?: 'VideoAsset' }
    & EnrichedMeta_VideoAsset_Fragment
  ) | (
    { __typename?: 'VideoCarousel' }
    & EnrichedMeta_VideoCarousel_Fragment
  ) | (
    { __typename?: 'VideoWithContent' }
    & EnrichedMeta_VideoWithContent_Fragment
  ) | null, navigationLinksCollection?: { __typename?: 'HeaderNavigationLinksCollection', limit: number, skip: number, total: number, items: Array<(
      { __typename?: 'FooterNavigationGroup' }
      & FooterNavigationGroupFragment
      & EnrichedMeta_FooterNavigationGroup_Fragment
    ) | (
      { __typename?: 'NavigationGroup' }
      & GenericNavigationGroupFragment
      & EnrichedMeta_NavigationGroup_Fragment
    ) | (
      { __typename?: 'NavigationLink' }
      & NavLinkFragment
      & EnrichedMeta_NavigationLink_Fragment
    ) | (
      { __typename?: 'Page' }
      & BasePageFragment
      & EnrichedMeta_Page_Fragment
    ) | null> } | null, topNavigationLinksCollection?: { __typename?: 'HeaderTopNavigationLinksCollection', limit: number, skip: number, total: number, items: Array<(
      { __typename?: 'NavigationLink' }
      & NavLinkFragment
      & EnrichedMeta_NavigationLink_Fragment
    ) | (
      { __typename?: 'Page' }
      & BasePageFragment
      & EnrichedMeta_Page_Fragment
    ) | null> } | null, schedulingNavigationLinksCollection?: { __typename?: 'HeaderSchedulingNavigationLinksCollection', limit: number, skip: number, total: number, items: Array<(
      { __typename?: 'NavigationGroup' }
      & GenericNavigationGroupFragment
      & EnrichedMeta_NavigationGroup_Fragment
    ) | null> } | null, navigationMenu?: (
    { __typename?: 'HeaderNavMenu' }
    & HeaderNavMenuFragment
  ) | null, locationNavigationLinksCollection?: { __typename?: 'HeaderLocationNavigationLinksCollection', items: Array<(
      { __typename?: 'NavigationLink' }
      & NavLinkFragment
    ) | (
      { __typename?: 'Page' }
      & BasePageFragment
    ) | null> } | null, phoneNumber?: (
    { __typename?: 'NavigationLink' }
    & NavLinkFragment
  ) | null, secondaryNavigationLinksCollection?: { __typename?: 'HeaderSecondaryNavigationLinksCollection', limit: number, skip: number, total: number, items: Array<(
      { __typename?: 'NavigationLink' }
      & NavLinkFragment
      & EnrichedMeta_NavigationLink_Fragment
    ) | (
      { __typename?: 'Page' }
      & BasePageFragment
      & EnrichedMeta_Page_Fragment
    ) | null> } | null, googleMapsForLocationCards?: (
    { __typename?: 'GoogleMapTemplate' }
    & GoogleMapInHeaderFragment
  ) | null, topAlertBanner?: (
    { __typename?: 'Banner' }
    & BannerFragment
  ) | null, bottomAlertBanner?: (
    { __typename?: 'Banner' }
    & BannerFragment
  ) | null }
  & EnrichedMeta_Header_Fragment
);

export type GenericNavigationGroupFragment = { __typename?: 'NavigationGroup', groupLink?: (
    { __typename?: 'NavigationLink', linkText?: string | null, isInternal?: boolean | null, openInNewTab?: boolean | null }
    & EnrichedMeta_NavigationLink_Fragment
  ) | null, linksCollection?: { __typename?: 'NavigationGroupLinksCollection', limit: number, skip: number, total: number, items: Array<(
      { __typename?: 'NavigationLink' }
      & NavLinkFragment
    ) | null> } | null };

export type FooterFragment = (
  { __typename?: 'AdFooter', componentName?: string | null, contactNumber?: string | null, copyright?: string | null, isLightFooter?: boolean | null, useMobileStickyFooter?: boolean | null, useDesktopStickyFooter?: boolean | null, stickyFooterScheduleButton?: (
    { __typename?: 'Button' }
    & ButtonFragment
  ) | null, stickyFooterButtonsCollection?: { __typename?: 'AdFooterStickyFooterButtonsCollection', limit: number, skip: number, total: number, items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null, logo?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, disclaimer?: (
    { __typename?: 'DisclaimerV2' }
    & DisclaimerV2Fragment
  ) | null, about?: { __typename?: 'AdFooterAbout', json: any, links: { __typename?: 'AdFooterAboutLinks', assets: { __typename?: 'AdFooterAboutAssets', block: Array<(
          { __typename?: 'Asset' }
          & LinkMetaFragment
        ) | null>, hyperlink: Array<(
          { __typename?: 'Asset' }
          & LinkMetaFragment
        ) | null> }, entries: { __typename?: 'AdFooterAboutEntries', inline: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & EnrichedMeta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null>, block: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & EnrichedMeta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null>, hyperlink: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & EnrichedMeta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null> }, resources: { __typename?: 'AdFooterAboutResources', block: Array<(
          { __typename?: 'AdFooterAboutResourcesBlock' }
          & ResourceMeta_AdFooterAboutResourcesBlock_Fragment
        )>, inline: Array<(
          { __typename?: 'AdFooterAboutResourcesInline' }
          & ResourceMeta_AdFooterAboutResourcesInline_Fragment
        )>, hyperlink: Array<(
          { __typename?: 'AdFooterAboutResourcesHyperlink' }
          & ResourceMeta_AdFooterAboutResourcesHyperlink_Fragment
        )> } } } | null, navigationGroupsCollection?: { __typename?: 'AdFooterNavigationGroupsCollection', skip: number, limit: number, total: number, items: Array<(
      { __typename?: 'FooterNavigationGroup', componentName?: string | null, navigationGroupTitle?: string | null, navigationGroupLink?: (
        { __typename?: 'Page' }
        & BasePageFragment
      ) | null, navigationLinksForGroupCollection?: { __typename?: 'FooterNavigationGroupNavigationLinksForGroupCollection', skip: number, limit: number, total: number, items: Array<(
          { __typename?: 'NavigationLink' }
          & NavLinkFragment
        ) | (
          { __typename?: 'Page' }
          & BasePageFragment
        ) | null> } | null }
      & EnrichedMeta_FooterNavigationGroup_Fragment
    ) | null> } | null, socialNetworksCollection?: { __typename?: 'AdFooterSocialNetworksCollection', skip: number, limit: number, total: number, items: Array<(
      { __typename?: 'Accordions' }
      & EnrichedMeta_Accordions_Fragment
    ) | (
      { __typename?: 'AdFooter' }
      & EnrichedMeta_AdFooter_Fragment
    ) | (
      { __typename?: 'AgendaModal' }
      & EnrichedMeta_AgendaModal_Fragment
    ) | (
      { __typename?: 'AgendaStepper' }
      & EnrichedMeta_AgendaStepper_Fragment
    ) | (
      { __typename?: 'AnalyticsContext' }
      & EnrichedMeta_AnalyticsContext_Fragment
    ) | (
      { __typename?: 'App' }
      & EnrichedMeta_App_Fragment
    ) | (
      { __typename?: 'AppointmentBookingPage' }
      & EnrichedMeta_AppointmentBookingPage_Fragment
    ) | (
      { __typename?: 'Badge' }
      & EnrichedMeta_Badge_Fragment
    ) | (
      { __typename?: 'Banner' }
      & EnrichedMeta_Banner_Fragment
    ) | (
      { __typename?: 'BirdEyeReviews' }
      & EnrichedMeta_BirdEyeReviews_Fragment
    ) | (
      { __typename?: 'BlogAuthor' }
      & EnrichedMeta_BlogAuthor_Fragment
    ) | (
      { __typename?: 'BlogCategory' }
      & EnrichedMeta_BlogCategory_Fragment
    ) | (
      { __typename?: 'BlogDetailsPage' }
      & EnrichedMeta_BlogDetailsPage_Fragment
    ) | (
      { __typename?: 'BlogList' }
      & EnrichedMeta_BlogList_Fragment
    ) | (
      { __typename?: 'BlogListPage' }
      & EnrichedMeta_BlogListPage_Fragment
    ) | (
      { __typename?: 'BlogSubCategory' }
      & EnrichedMeta_BlogSubCategory_Fragment
    ) | (
      { __typename?: 'Brand' }
      & EnrichedMeta_Brand_Fragment
    ) | (
      { __typename?: 'Button' }
      & EnrichedMeta_Button_Fragment
    ) | (
      { __typename?: 'Card' }
      & EnrichedMeta_Card_Fragment
    ) | (
      { __typename?: 'Category' }
      & EnrichedMeta_Category_Fragment
    ) | (
      { __typename?: 'CategoryPicker' }
      & EnrichedMeta_CategoryPicker_Fragment
    ) | (
      { __typename?: 'CityLinks' }
      & EnrichedMeta_CityLinks_Fragment
    ) | (
      { __typename?: 'Columns' }
      & EnrichedMeta_Columns_Fragment
    ) | (
      { __typename?: 'ConfirmationStep' }
      & EnrichedMeta_ConfirmationStep_Fragment
    ) | (
      { __typename?: 'ContentSection' }
      & EnrichedMeta_ContentSection_Fragment
    ) | (
      { __typename?: 'ContentTile' }
      & EnrichedMeta_ContentTile_Fragment
    ) | (
      { __typename?: 'ContentTypeRichText' }
      & EnrichedMeta_ContentTypeRichText_Fragment
    ) | (
      { __typename?: 'DisclaimerV2' }
      & EnrichedMeta_DisclaimerV2_Fragment
    ) | (
      { __typename?: 'Error404' }
      & EnrichedMeta_Error404_Fragment
    ) | (
      { __typename?: 'FacilityDetailsPage' }
      & EnrichedMeta_FacilityDetailsPage_Fragment
    ) | (
      { __typename?: 'FeatureFlags' }
      & EnrichedMeta_FeatureFlags_Fragment
    ) | (
      { __typename?: 'FocalPointImage' }
      & EnrichedMeta_FocalPointImage_Fragment
    ) | (
      { __typename?: 'FooterNavigationGroup' }
      & EnrichedMeta_FooterNavigationGroup_Fragment
    ) | (
      { __typename?: 'FormDropdownField' }
      & EnrichedMeta_FormDropdownField_Fragment
    ) | (
      { __typename?: 'FormDropdownListItem' }
      & EnrichedMeta_FormDropdownListItem_Fragment
    ) | (
      { __typename?: 'FormField' }
      & EnrichedMeta_FormField_Fragment
    ) | (
      { __typename?: 'GoogleMapTemplate' }
      & EnrichedMeta_GoogleMapTemplate_Fragment
    ) | (
      { __typename?: 'HalfScreen' }
      & EnrichedMeta_HalfScreen_Fragment
    ) | (
      { __typename?: 'Header' }
      & EnrichedMeta_Header_Fragment
    ) | (
      { __typename?: 'HeaderMainNav' }
      & EnrichedMeta_HeaderMainNav_Fragment
    ) | (
      { __typename?: 'HeaderNavMenu' }
      & EnrichedMeta_HeaderNavMenu_Fragment
    ) | (
      { __typename?: 'HeaderSubNav' }
      & EnrichedMeta_HeaderSubNav_Fragment
    ) | (
      { __typename?: 'HeroV2' }
      & EnrichedMeta_HeroV2_Fragment
    ) | (
      { __typename?: 'Iframe' }
      & EnrichedMeta_Iframe_Fragment
    ) | (
      { __typename?: 'ImageAsset' }
      & EnrichedMeta_ImageAsset_Fragment
    ) | (
      { __typename?: 'Insurance' }
      & EnrichedMeta_Insurance_Fragment
    ) | (
      { __typename?: 'LinkForwarder' }
      & EnrichedMeta_LinkForwarder_Fragment
    ) | (
      { __typename?: 'LocalizedServiceTitle' }
      & EnrichedMeta_LocalizedServiceTitle_Fragment
    ) | (
      { __typename?: 'Marquee' }
      & EnrichedMeta_Marquee_Fragment
    ) | (
      { __typename?: 'MediaSlider' }
      & EnrichedMeta_MediaSlider_Fragment
    ) | (
      { __typename?: 'MedicalService' }
      & EnrichedMeta_MedicalService_Fragment
    ) | (
      { __typename?: 'MeetOurStaff' }
      & EnrichedMeta_MeetOurStaff_Fragment
    ) | (
      { __typename?: 'MobileButton' }
      & EnrichedMeta_MobileButton_Fragment
    ) | (
      { __typename?: 'MultiCardV2' }
      & EnrichedMeta_MultiCardV2_Fragment
    ) | (
      { __typename?: 'NavigationGroup' }
      & EnrichedMeta_NavigationGroup_Fragment
    ) | (
      { __typename?: 'NavigationLink' }
      & NavLinkFragment
      & EnrichedMeta_NavigationLink_Fragment
    ) | (
      { __typename?: 'OdpHero' }
      & EnrichedMeta_OdpHero_Fragment
    ) | (
      { __typename?: 'Page' }
      & BasePageFragment
      & EnrichedMeta_Page_Fragment
    ) | (
      { __typename?: 'PatientReviewV2' }
      & EnrichedMeta_PatientReviewV2_Fragment
    ) | (
      { __typename?: 'PatientReviewsV2' }
      & EnrichedMeta_PatientReviewsV2_Fragment
    ) | (
      { __typename?: 'Product' }
      & EnrichedMeta_Product_Fragment
    ) | (
      { __typename?: 'ProductDisplay' }
      & EnrichedMeta_ProductDisplay_Fragment
    ) | (
      { __typename?: 'ProductFeature' }
      & EnrichedMeta_ProductFeature_Fragment
    ) | (
      { __typename?: 'ProductFeatureDescriptionListItem' }
      & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
    ) | (
      { __typename?: 'ProviderDetailsPage' }
      & EnrichedMeta_ProviderDetailsPage_Fragment
    ) | (
      { __typename?: 'Questionnaire' }
      & EnrichedMeta_Questionnaire_Fragment
    ) | (
      { __typename?: 'QuickLinks' }
      & EnrichedMeta_QuickLinks_Fragment
    ) | (
      { __typename?: 'Quiz' }
      & EnrichedMeta_Quiz_Fragment
    ) | (
      { __typename?: 'ReviewStep' }
      & EnrichedMeta_ReviewStep_Fragment
    ) | (
      { __typename?: 'Schema' }
      & EnrichedMeta_Schema_Fragment
    ) | (
      { __typename?: 'SectionContent' }
      & EnrichedMeta_SectionContent_Fragment
    ) | (
      { __typename?: 'SegmentsContainer' }
      & EnrichedMeta_SegmentsContainer_Fragment
    ) | (
      { __typename?: 'Service' }
      & EnrichedMeta_Service_Fragment
    ) | (
      { __typename?: 'ServiceDetailsPage' }
      & EnrichedMeta_ServiceDetailsPage_Fragment
    ) | (
      { __typename?: 'ServiceLineHero' }
      & EnrichedMeta_ServiceLineHero_Fragment
    ) | (
      { __typename?: 'SingleMessage' }
      & EnrichedMeta_SingleMessage_Fragment
    ) | (
      { __typename?: 'SmallScreenContent' }
      & EnrichedMeta_SmallScreenContent_Fragment
    ) | (
      { __typename?: 'SmileAssessmentForm' }
      & EnrichedMeta_SmileAssessmentForm_Fragment
    ) | (
      { __typename?: 'Spacer' }
      & EnrichedMeta_Spacer_Fragment
    ) | (
      { __typename?: 'StateLinks' }
      & EnrichedMeta_StateLinks_Fragment
    ) | (
      { __typename?: 'Stepper' }
      & EnrichedMeta_Stepper_Fragment
    ) | (
      { __typename?: 'SuccessCard' }
      & EnrichedMeta_SuccessCard_Fragment
    ) | (
      { __typename?: 'Tab' }
      & EnrichedMeta_Tab_Fragment
    ) | (
      { __typename?: 'Table' }
      & EnrichedMeta_Table_Fragment
    ) | (
      { __typename?: 'Tabs' }
      & EnrichedMeta_Tabs_Fragment
    ) | (
      { __typename?: 'TermsAndConditions' }
      & EnrichedMeta_TermsAndConditions_Fragment
    ) | (
      { __typename?: 'TextBlockSeo' }
      & EnrichedMeta_TextBlockSeo_Fragment
    ) | (
      { __typename?: 'Video' }
      & EnrichedMeta_Video_Fragment
    ) | (
      { __typename?: 'VideoAsset' }
      & EnrichedMeta_VideoAsset_Fragment
    ) | (
      { __typename?: 'VideoCarousel' }
      & EnrichedMeta_VideoCarousel_Fragment
    ) | (
      { __typename?: 'VideoWithContent' }
      & EnrichedMeta_VideoWithContent_Fragment
    ) | null> } | null, footerPolicyGroupCollection?: { __typename?: 'AdFooterFooterPolicyGroupCollection', skip: number, limit: number, total: number, items: Array<(
      { __typename?: 'NavigationLink' }
      & NavLinkFragment
      & EnrichedMeta_NavigationLink_Fragment
    ) | null> } | null }
  & EnrichedMeta_AdFooter_Fragment
);

export type AppMetadataFragment = { __typename: 'App', name?: string | null, branding?: string | null, sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> }, logo?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, logoMobile?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, featureFlags?: (
    { __typename?: 'FeatureFlags' }
    & FeatureFlagsFragment
  ) | null };

export type AppPagesDataFragment = { __typename?: 'App', header?: (
    { __typename?: 'Header' }
    & HeaderFragment
  ) | null, footer?: (
    { __typename?: 'AdFooter' }
    & FooterFragment
  ) | null, notFoundPage?: (
    { __typename?: 'Error404' }
    & Error404Fragment
  ) | null };

export type AppFragment = { __typename: 'App', name?: string | null, branding?: string | null, sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> }, logo?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, logoMobile?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, header?: (
    { __typename?: 'Header' }
    & HeaderFragment
  ) | null, footer?: (
    { __typename?: 'AdFooter' }
    & FooterFragment
  ) | null, notFoundPage?: (
    { __typename?: 'Error404' }
    & Error404Fragment
  ) | null };

export type FeatureFlagsFragment = { __typename?: 'FeatureFlags', continentalUsMapFallbackThreshold?: number | null, enforceContinentalUsZoom?: boolean | null, featureList?: Array<string | null> | null, onPageScheduling?: boolean | null, onPageSchedulingLocations?: Array<string | null> | null, salesForceEvergageScript?: string | null, hideSearchWithLocationCards?: boolean | null, hideOdpHeaderLinks?: boolean | null, providerHeroTheme?: string | null, showMobileHeaderLocationBar?: boolean | null, showHeaderWithLocationNav?: boolean | null, defaultToCdn?: boolean | null, useFacilityBeffeDataSource?: boolean | null, useInlineOneTrust?: boolean | null, useSessionStorageFacilityCode?: boolean | null, doNotIndexWholeSite?: boolean | null, showHeaderNavigationMenu?: boolean | null, hideHeaderFacilityLocator?: boolean | null, hideHeaderSchedulingButton?: boolean | null, hideProviderWithNoImage?: boolean | null, useGoogleMapAutocompleteSearch?: boolean | null, fetchAllLocationsOnEmptyResults?: boolean | null, showSetOfficeButtonInGoogleMapsCards?: boolean | null, useSimpleFindOfficeLink?: boolean | null, enableFluidTypography?: boolean | null };

export type OdpHeroFragment = (
  { __typename?: 'OdpHero', name?: string | null, templateWidth?: string | null, showReviews?: boolean | null, title?: string | null, titleHtag?: string | null, showAddress?: boolean | null, showPhoneNumber?: boolean | null, showHours?: boolean | null, officeHoursLabel?: string | null, callCenterLabel?: string | null, googleMapsBusinessQuery?: string | null, facilitySegmentCollection?: string | null, promoTitle?: string | null, anchorId?: string | null, image?: (
    { __typename?: 'FocalPointImage' }
    & FocalPointImageFragment
  ) | null, bodyCopy?: (
    { __typename?: 'ContentTypeRichText' }
    & RichTextFragment
  ) | null, buttonsCollection?: { __typename?: 'OdpHeroButtonsCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null }
  & Meta_OdpHero_Fragment
);

export type PageFragment = (
  { __typename?: 'Page', name?: string | null, breadcrumbTitle?: string | null, description?: string | null, pageTitle?: string | null, path?: string | null, title?: string | null, canonical?: string | null, indexed?: boolean | null, personalized?: boolean | null, pageTheme?: string | null, disableChatBot?: boolean | null, disableStickyFooterOnDesktop?: boolean | null, disableStickyFooterOnMobile?: boolean | null, disableHeaderTopAlertBanner?: boolean | null, disableHeaderBottomAlertBanner?: boolean | null, hideScheduleButtonInHeader?: boolean | null, ogImage?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null, contentsCollection?: { __typename?: 'PageContentsCollection', items: Array<(
      { __typename?: 'Accordions' }
      & Meta_Accordions_Fragment
    ) | (
      { __typename?: 'AgendaStepper' }
      & Meta_AgendaStepper_Fragment
    ) | (
      { __typename?: 'BirdEyeReviews' }
      & Meta_BirdEyeReviews_Fragment
    ) | (
      { __typename?: 'BlogList' }
      & Meta_BlogList_Fragment
    ) | (
      { __typename?: 'CategoryPicker' }
      & Meta_CategoryPicker_Fragment
      & CategoryPickerFragment
    ) | (
      { __typename?: 'CityLinks' }
      & Meta_CityLinks_Fragment
    ) | (
      { __typename?: 'Columns' }
      & Meta_Columns_Fragment
    ) | (
      { __typename?: 'ContentTypeRichText' }
      & Meta_ContentTypeRichText_Fragment
      & RichTextFragment
    ) | (
      { __typename?: 'DisclaimerV2' }
      & Meta_DisclaimerV2_Fragment
      & DisclaimerV2Fragment
    ) | (
      { __typename?: 'GoogleMapTemplate' }
      & Meta_GoogleMapTemplate_Fragment
    ) | (
      { __typename?: 'HalfScreen' }
      & Meta_HalfScreen_Fragment
      & HalfScreenFragment
    ) | (
      { __typename?: 'HeaderNavMenu' }
      & Meta_HeaderNavMenu_Fragment
    ) | (
      { __typename?: 'HeroV2' }
      & Meta_HeroV2_Fragment
    ) | (
      { __typename?: 'Iframe' }
      & Meta_Iframe_Fragment
      & IframeFragment
    ) | (
      { __typename?: 'Insurance' }
      & Meta_Insurance_Fragment
      & InsuranceFragment
    ) | (
      { __typename?: 'LinkForwarder' }
      & Meta_LinkForwarder_Fragment
      & LinkForwarderFragment
    ) | (
      { __typename?: 'Marquee' }
      & Meta_Marquee_Fragment
    ) | (
      { __typename?: 'MediaSlider' }
      & Meta_MediaSlider_Fragment
    ) | (
      { __typename?: 'MeetOurStaff' }
      & Meta_MeetOurStaff_Fragment
      & MeetOurStaffFragment
    ) | (
      { __typename?: 'MultiCardV2' }
      & Meta_MultiCardV2_Fragment
      & CardsFragment
    ) | (
      { __typename?: 'OdpHero' }
      & Meta_OdpHero_Fragment
      & OdpHeroFragment
    ) | (
      { __typename?: 'PatientReviewsV2' }
      & Meta_PatientReviewsV2_Fragment
      & PatientReviewsV2Fragment
    ) | (
      { __typename?: 'ProductDisplay' }
      & Meta_ProductDisplay_Fragment
    ) | (
      { __typename?: 'ProductFeature' }
      & Meta_ProductFeature_Fragment
    ) | (
      { __typename?: 'Questionnaire' }
      & Meta_Questionnaire_Fragment
    ) | (
      { __typename?: 'QuickLinks' }
      & Meta_QuickLinks_Fragment
      & QuickLinksFragment
    ) | (
      { __typename?: 'Quiz' }
      & Meta_Quiz_Fragment
    ) | (
      { __typename?: 'Schema' }
      & Meta_Schema_Fragment
      & SchemaFragment
    ) | (
      { __typename?: 'SectionContent' }
      & Meta_SectionContent_Fragment
    ) | (
      { __typename?: 'SegmentsContainer' }
      & Meta_SegmentsContainer_Fragment
    ) | (
      { __typename?: 'Service' }
      & Meta_Service_Fragment
      & ServiceFragment
    ) | (
      { __typename?: 'ServiceLineHero' }
      & Meta_ServiceLineHero_Fragment
    ) | (
      { __typename?: 'SingleMessage' }
      & Meta_SingleMessage_Fragment
      & SingleMessageFragment
    ) | (
      { __typename?: 'SmileAssessmentForm' }
      & Meta_SmileAssessmentForm_Fragment
    ) | (
      { __typename?: 'Spacer' }
      & Meta_Spacer_Fragment
      & SpacerFragment
    ) | (
      { __typename?: 'StateLinks' }
      & Meta_StateLinks_Fragment
    ) | (
      { __typename?: 'Stepper' }
      & Meta_Stepper_Fragment
    ) | (
      { __typename?: 'Table' }
      & Meta_Table_Fragment
    ) | (
      { __typename?: 'Tabs' }
      & Meta_Tabs_Fragment
    ) | (
      { __typename?: 'TermsAndConditions' }
      & Meta_TermsAndConditions_Fragment
      & TermOfConditionsFragment
    ) | (
      { __typename?: 'TextBlockSeo' }
      & Meta_TextBlockSeo_Fragment
      & TextBlockSeoFragment
    ) | (
      { __typename?: 'VideoCarousel' }
      & Meta_VideoCarousel_Fragment
    ) | null> } | null, analyticsContext?: (
    { __typename?: 'AnalyticsContext' }
    & AnalyticsFragment
  ) | null }
  & Meta_Page_Fragment
);

export type FacilityDetailsPageBaseFragment = (
  { __typename?: 'FacilityDetailsPage', path?: string | null }
  & Meta_FacilityDetailsPage_Fragment
);

export type ServiceDetailsPageBaseFragment = (
  { __typename?: 'ServiceDetailsPage', path?: string | null }
  & Meta_ServiceDetailsPage_Fragment
);

export type PatientReviewsV2Fragment = (
  { __typename?: 'PatientReviewsV2', eyebrowSmallScreens?: string | null, eyebrowLargeScreens?: string | null, titleSmallScreens?: string | null, titleLargeScreens?: string | null, subtitleSmallScreens?: string | null, subtitleLargeScreens?: string | null, titleHtag?: string | null, maxReviewsSmallScreens?: number | null, maxReviewsLargeScreens?: number | null, trimThreshold?: number | null, disablePaddingOn?: Array<string | null> | null, backgroundColor?: string | null, templateWidth?: string | null, contentAlign?: string | null, mode?: string | null, scoreIcon?: string | null, anchorId?: string | null, imageLeftSide?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null, reviewsCollection?: { __typename?: 'PatientReviewsV2ReviewsCollection', items: Array<(
      { __typename?: 'PatientReviewV2', score?: number | null, text?: string | null, subText1?: string | null, subText2?: string | null, avatar?: (
        { __typename?: 'Asset' }
        & ImageFragment
      ) | null }
      & Meta_PatientReviewV2_Fragment
    ) | null> } | null, buttonsSmallScreensCollection?: { __typename?: 'PatientReviewsV2ButtonsSmallScreensCollection', items: Array<(
      { __typename?: 'Button', variant?: string | null, label?: string | null, buttonLink?: string | null, size?: string | null }
      & Meta_Button_Fragment
    ) | null> } | null, buttonsLargeScreensCollection?: { __typename?: 'PatientReviewsV2ButtonsLargeScreensCollection', items: Array<(
      { __typename?: 'Button', variant?: string | null, label?: string | null, buttonLink?: string | null, size?: string | null }
      & Meta_Button_Fragment
    ) | null> } | null }
  & Meta_PatientReviewsV2_Fragment
);

export type ProductDisplayFragment = (
  { __typename?: 'ProductDisplay', anchorId?: string | null, productListTitleHtag?: string | null, productListTitle?: string | null, showProductCategory?: boolean | null, showProductSubCategory?: boolean | null, productsToDisplay?: Array<string | null> | null, showLocalizedProductPrice?: boolean | null, productListDescription?: { __typename?: 'ProductDisplayProductListDescription', json: any } | null }
  & Meta_ProductDisplay_Fragment
);

export type QuickLinksFragment = (
  { __typename?: 'QuickLinks', templateSize?: string | null, eyebrow?: string | null, eyebrowStyle?: string | null, backgroundColor?: string | null, disablePaddingOn?: Array<string | null> | null, displayAsTitles?: boolean | null, anchorId?: string | null, heading?: { __typename?: 'QuickLinksHeading', json: any } | null, body?: { __typename?: 'QuickLinksBody', json: any } | null, quickLinksCollection?: { __typename?: 'QuickLinksQuickLinksCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null, buttonsCollection?: { __typename?: 'QuickLinksButtonsCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null }
  & Meta_QuickLinks_Fragment
);

export type QuizFragment = (
  { __typename?: 'Quiz', submitEndpointUrl?: string | null, quizFormData?: any | null, quizType?: string | null, isFormBuilder?: boolean | null, formBuilderConfig?: any | null, clearChoicePoorCreditRedirectPath?: string | null }
  & Meta_Quiz_Fragment
);

export type RichTextFragment = (
  { __typename?: 'ContentTypeRichText', fullWidth?: boolean | null, disablePaddingOn?: Array<string | null> | null, backgroundColor?: string | null, centerAlign?: boolean | null, contained?: boolean | null, titleHeading?: string | null, title?: string | null, titleIcon?: string | null, contentMaxWidth?: string | null, facilitySegmentCollection?: string | null, id?: string | null, content?: { __typename?: 'ContentTypeRichTextContent', json: any } | null, secondaryContent?: { __typename?: 'ContentTypeRichTextSecondaryContent', json: any } | null, buttonsCollection?: { __typename?: 'ContentTypeRichTextButtonsCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null }
  & Meta_ContentTypeRichText_Fragment
);

export type RichTextWithLinksFragment = (
  { __typename?: 'ContentTypeRichText', fullWidth?: boolean | null, backgroundColor?: string | null, centerAlign?: boolean | null, contained?: boolean | null, titleHeading?: string | null, title?: string | null, contentMaxWidth?: string | null, facilitySegmentCollection?: string | null, content?: { __typename?: 'ContentTypeRichTextContent', json: any, links: { __typename?: 'ContentTypeRichTextContentLinks', assets: { __typename?: 'ContentTypeRichTextContentAssets', block: Array<(
          { __typename?: 'Asset', contentType?: string | null, url?: string | null, description?: string | null, fileName?: string | null }
          & LinkMetaFragment
        ) | null>, hyperlink: Array<(
          { __typename?: 'Asset', contentType?: string | null, url?: string | null, description?: string | null, fileName?: string | null }
          & LinkMetaFragment
        ) | null> }, entries: { __typename?: 'ContentTypeRichTextContentEntries', inline: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & EnrichedMeta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null>, block: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & EnrichedMeta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
          & ImageAssetFragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
          & TableFragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
          & VideoAssetFragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null>, hyperlink: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage', path?: string | null }
          & Meta_FacilityDetailsPage_Fragment
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & EnrichedMeta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage', path?: string | null }
          & Meta_ServiceDetailsPage_Fragment
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null> }, resources: { __typename?: 'ContentTypeRichTextContentResources', block: Array<(
          { __typename?: 'ContentTypeRichTextContentResourcesBlock' }
          & ResourceMeta_ContentTypeRichTextContentResourcesBlock_Fragment
        )>, inline: Array<(
          { __typename?: 'ContentTypeRichTextContentResourcesInline' }
          & ResourceMeta_ContentTypeRichTextContentResourcesInline_Fragment
        )>, hyperlink: Array<(
          { __typename?: 'ContentTypeRichTextContentResourcesHyperlink' }
          & ResourceMeta_ContentTypeRichTextContentResourcesHyperlink_Fragment
        )> } } } | null, secondaryContent?: { __typename?: 'ContentTypeRichTextSecondaryContent', json: any, links: { __typename?: 'ContentTypeRichTextSecondaryContentLinks', assets: { __typename?: 'ContentTypeRichTextSecondaryContentAssets', block: Array<(
          { __typename?: 'Asset', contentType?: string | null, url?: string | null, description?: string | null, fileName?: string | null }
          & LinkMetaFragment
        ) | null>, hyperlink: Array<(
          { __typename?: 'Asset', contentType?: string | null, url?: string | null, description?: string | null, fileName?: string | null }
          & LinkMetaFragment
        ) | null> }, entries: { __typename?: 'ContentTypeRichTextSecondaryContentEntries', inline: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & EnrichedMeta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null>, block: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & EnrichedMeta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null>, hyperlink: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage', path?: string | null }
          & Meta_FacilityDetailsPage_Fragment
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & EnrichedMeta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage', path?: string | null }
          & Meta_ServiceDetailsPage_Fragment
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null> }, resources: { __typename?: 'ContentTypeRichTextSecondaryContentResources', block: Array<(
          { __typename?: 'ContentTypeRichTextSecondaryContentResourcesBlock' }
          & ResourceMeta_ContentTypeRichTextSecondaryContentResourcesBlock_Fragment
        )>, inline: Array<(
          { __typename?: 'ContentTypeRichTextSecondaryContentResourcesInline' }
          & ResourceMeta_ContentTypeRichTextSecondaryContentResourcesInline_Fragment
        )>, hyperlink: Array<(
          { __typename?: 'ContentTypeRichTextSecondaryContentResourcesHyperlink' }
          & ResourceMeta_ContentTypeRichTextSecondaryContentResourcesHyperlink_Fragment
        )> } } } | null }
  & EnrichedMeta_ContentTypeRichText_Fragment
);

export type SchemaFragment = (
  { __typename?: 'Schema', schema?: any | null }
  & Meta_Schema_Fragment
);

export type SegmentsContainerFragment = (
  { __typename?: 'SegmentsContainer', anchorId?: string | null, contentsCollection?: { __typename?: 'SegmentsContainerContentsCollection', items: Array<(
      { __typename?: 'ContentTypeRichText' }
      & RichTextFragment
    ) | (
      { __typename?: 'DisclaimerV2' }
      & DisclaimerV2Fragment
    ) | (
      { __typename?: 'HalfScreen' }
      & HalfScreenFragment
    ) | (
      { __typename?: 'HeroV2' }
      & HeroFragment
    ) | (
      { __typename?: 'Marquee' }
      & MarqueeFragment
    ) | (
      { __typename?: 'MultiCardV2' }
      & CardsFragment
    ) | (
      { __typename?: 'OdpHero' }
      & OdpHeroFragment
    ) | (
      { __typename?: 'ServiceLineHero' }
      & ServiceLineHeroFragment
    ) | (
      { __typename?: 'SingleMessage' }
      & SingleMessageFragment
    ) | null> } | null }
  & Meta_SegmentsContainer_Fragment
);

export type ServiceFragment = (
  { __typename?: 'Service', name?: string | null, backgroundColor?: string | null, description?: string | null, direction?: string | null, centerAlign?: boolean | null, contained?: boolean | null, eyebrow?: string | null, title?: string | null, titleHtag?: string | null, buttonText?: string | null, buttonUrl?: string | null, buttonType?: string | null, mediaType?: string | null, imageLayout?: string | null, youTubeVideoId?: string | null, facilitySegmentCollection?: string | null, anchorId?: string | null, richTextDescription?: { __typename?: 'ServiceRichTextDescription', json: any } | null, image?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, mobileImage?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, video?: (
    { __typename?: 'Asset', url?: string | null }
    & CommonAssetFragment
  ) | null, buttonsCollection?: { __typename?: 'ServiceButtonsCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null, youTubeVideoImage?: (
    { __typename?: 'Asset', url?: string | null }
    & CommonAssetFragment
  ) | null, tc?: (
    { __typename?: 'TermsAndConditions' }
    & TermOfConditionsFragment
  ) | null }
  & Meta_Service_Fragment
);

export type ServiceLineHeroFragment = (
  { __typename?: 'ServiceLineHero', eyebrow?: string | null, eyebrowHtag?: string | null, templateWidth?: string | null, hideHeroOnMobile?: boolean | null, imgDisplaysFirstOnMobile?: boolean | null, imageWithBorderRadius?: boolean | null, backgroundColor?: string | null, backgroundColorMobile?: string | null, contentAlign?: string | null, facilitySegmentCollection?: string | null, disablePaddingOn?: Array<string | null> | null, mediaRoundedCornerSize?: string | null, imgDisplaysFirstOnDesktop?: boolean | null, showOfficeDetails?: boolean | null, displayOfficeHoursInModal?: boolean | null, googleMapsBusinessQuery?: string | null, anchorId?: string | null, headline?: { __typename?: 'ServiceLineHeroHeadline', json: any } | null, subHeadline?: { __typename?: 'ServiceLineHeroSubHeadline', json: any } | null, bodyCopy?: { __typename?: 'ServiceLineHeroBodyCopy', json: any } | null, termsConditions?: (
    { __typename?: 'TermsAndConditions' }
    & TermOfConditionsFragment
  ) | null, buttonCollection?: { __typename?: 'ServiceLineHeroButtonCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null, focalPointImage?: (
    { __typename?: 'FocalPointImage' }
    & FocalPointImageFragment
  ) | null, servicesCollection?: { __typename?: 'ServiceLineHeroServicesCollection', items: Array<(
      { __typename?: 'MedicalService' }
      & MedicalServiceFragment
    ) | null> } | null, videoAsset?: (
    { __typename?: 'VideoAsset' }
    & VideoAssetFragment
  ) | null, contentListCollection?: { __typename?: 'ServiceLineHeroContentListCollection', items: Array<(
      { __typename?: 'Accordions' }
      & ContentListItem_Accordions_Fragment
    ) | (
      { __typename?: 'ContentTypeRichText' }
      & ContentListItem_ContentTypeRichText_Fragment
    ) | (
      { __typename?: 'SingleMessage' }
      & ContentListItem_SingleMessage_Fragment
    ) | (
      { __typename?: 'Table' }
      & ContentListItem_Table_Fragment
    ) | null> } | null, imageAsset?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null }
  & Meta_ServiceLineHero_Fragment
);

export type ContentListItem_Accordions_Fragment = (
  { __typename?: 'Accordions' }
  & AccordionFragment
);

export type ContentListItem_ContentTypeRichText_Fragment = (
  { __typename?: 'ContentTypeRichText' }
  & RichTextFragment
);

export type ContentListItem_SingleMessage_Fragment = (
  { __typename?: 'SingleMessage' }
  & SingleMessageFragment
);

export type ContentListItem_Table_Fragment = (
  { __typename?: 'Table' }
  & TableFragment
);

export type ContentListItemFragment = ContentListItem_Accordions_Fragment | ContentListItem_ContentTypeRichText_Fragment | ContentListItem_SingleMessage_Fragment | ContentListItem_Table_Fragment;

export type MedicalServiceFragment = (
  { __typename?: 'MedicalService', iconName?: string | null, title?: string | null, description?: { __typename?: 'MedicalServiceDescription', json: any } | null }
  & Meta_MedicalService_Fragment
);

export type SingleMessageFragment = (
  { __typename?: 'SingleMessage', backgroundColor?: string | null, buttonSize?: string | null, buttonText?: string | null, buttonType?: string | null, buttonUrl?: string | null, description?: string | null, disablePaddingOn?: Array<string | null> | null, eyebrow?: string | null, icon?: string | null, iconSize?: string | null, name?: string | null, subText?: string | null, templateWidth?: string | null, templateHeight?: string | null, title?: string | null, titleAlign?: string | null, titleVariant?: string | null, facilitySegmentCollection?: string | null, isBannerImage?: boolean | null, contentFillVerticalSpace?: boolean | null, contentAlign?: string | null, isHeaderAboveSideImages?: boolean | null, isInlineLayout?: boolean | null, displayTitleInline?: boolean | null, useRoundedCorners?: boolean | null, showSubscriptionForm?: boolean | null, anchorId?: string | null, focalPointImage?: (
    { __typename?: 'FocalPointImage' }
    & FocalPointImageFragment
  ) | null, buttonsCollection?: { __typename?: 'SingleMessageButtonsCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null, content?: { __typename?: 'SingleMessageContent', json: any } | null, contentSmallScreen?: (
    { __typename?: 'SmallScreenContent' }
    & SmallScreenContentFragment
  ) | null, tc?: (
    { __typename?: 'TermsAndConditions' }
    & TermOfConditionsFragment
  ) | null, imageAsset?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null, imageLeftSide?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null, imageRightSide?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null }
  & Meta_SingleMessage_Fragment
);

export type SmallScreenContentFragment = { __typename?: 'SmallScreenContent', eyebrowSmallScreen?: string | null, mediaFirst?: boolean | null, headingSmallScreen?: { __typename?: 'SmallScreenContentHeadingSmallScreen', json: any } | null, bodySmallScreen?: { __typename?: 'SmallScreenContentBodySmallScreen', json: any } | null, imageSmallScreen?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, focalPointImageSmallScreen?: (
    { __typename?: 'FocalPointImage' }
    & FocalPointImageFragment
  ) | null, controllableVideo?: (
    { __typename?: 'Video' }
    & VideoFragment
  ) | null, videoSmallScreen?: (
    { __typename?: 'Asset', url?: string | null }
    & CommonAssetFragment
  ) | null };

export type SpacerFragment = (
  { __typename?: 'Spacer', size?: string | null, color?: string | null, anchorId?: string | null }
  & Meta_Spacer_Fragment
);

export type TableFragment = (
  { __typename?: 'Table', variant?: string | null, fontSize?: string | null, border?: boolean | null, firstColumnSticky?: boolean | null, titleHtag?: string | null, title?: string | null, tableJsonData?: any | null, tableJsonDataMobile?: any | null, anchorId?: string | null, descriptionRichText?: { __typename?: 'TableDescriptionRichText', json: any } | null, tableContent?: { __typename?: 'TableTableContent', json: any, links: { __typename?: 'TableTableContentLinks', entries: { __typename?: 'TableTableContentEntries', inline: Array<{ __typename?: 'Accordions' } | { __typename?: 'AdFooter' } | { __typename?: 'AgendaModal' } | { __typename?: 'AgendaStepper' } | { __typename?: 'AnalyticsContext' } | { __typename?: 'App' } | { __typename?: 'AppointmentBookingPage' } | { __typename?: 'Badge' } | { __typename?: 'Banner' } | { __typename?: 'BirdEyeReviews' } | { __typename?: 'BlogAuthor' } | { __typename?: 'BlogCategory' } | { __typename?: 'BlogDetailsPage' } | { __typename?: 'BlogList' } | { __typename?: 'BlogListPage' } | { __typename?: 'BlogSubCategory' } | { __typename?: 'Brand' } | { __typename?: 'Button' } | (
          { __typename?: 'Card', image?: (
            { __typename?: 'Asset', url?: string | null }
            & CommonAssetFragment
          ) | null }
          & Meta_Card_Fragment
        ) | { __typename?: 'Category' } | { __typename?: 'CategoryPicker' } | { __typename?: 'CityLinks' } | { __typename?: 'Columns' } | { __typename?: 'ConfirmationStep' } | { __typename?: 'ContentSection' } | { __typename?: 'ContentTile' } | { __typename?: 'ContentTypeRichText' } | { __typename?: 'DisclaimerV2' } | { __typename?: 'Error404' } | { __typename?: 'FacilityDetailsPage' } | { __typename?: 'FeatureFlags' } | { __typename?: 'FocalPointImage' } | { __typename?: 'FooterNavigationGroup' } | { __typename?: 'FormDropdownField' } | { __typename?: 'FormDropdownListItem' } | { __typename?: 'FormField' } | { __typename?: 'GoogleMapTemplate' } | { __typename?: 'HalfScreen' } | { __typename?: 'Header' } | { __typename?: 'HeaderMainNav' } | { __typename?: 'HeaderNavMenu' } | { __typename?: 'HeaderSubNav' } | { __typename?: 'HeroV2' } | { __typename?: 'Iframe' } | { __typename?: 'ImageAsset' } | { __typename?: 'Insurance' } | { __typename?: 'LinkForwarder' } | { __typename?: 'LocalizedServiceTitle' } | { __typename?: 'Marquee' } | { __typename?: 'MediaSlider' } | { __typename?: 'MedicalService' } | { __typename?: 'MeetOurStaff' } | { __typename?: 'MobileButton' } | { __typename?: 'MultiCardV2' } | { __typename?: 'NavigationGroup' } | { __typename?: 'NavigationLink' } | { __typename?: 'OdpHero' } | { __typename?: 'Page' } | { __typename?: 'PatientReviewV2' } | { __typename?: 'PatientReviewsV2' } | { __typename?: 'Product' } | { __typename?: 'ProductDisplay' } | { __typename?: 'ProductFeature' } | { __typename?: 'ProductFeatureDescriptionListItem' } | { __typename?: 'ProviderDetailsPage' } | { __typename?: 'Questionnaire' } | { __typename?: 'QuickLinks' } | { __typename?: 'Quiz' } | { __typename?: 'ReviewStep' } | { __typename?: 'Schema' } | { __typename?: 'SectionContent' } | { __typename?: 'SegmentsContainer' } | { __typename?: 'Service' } | { __typename?: 'ServiceDetailsPage' } | { __typename?: 'ServiceLineHero' } | { __typename?: 'SingleMessage' } | { __typename?: 'SmallScreenContent' } | { __typename?: 'SmileAssessmentForm' } | { __typename?: 'Spacer' } | { __typename?: 'StateLinks' } | { __typename?: 'Stepper' } | { __typename?: 'SuccessCard' } | { __typename?: 'Tab' } | { __typename?: 'Table' } | { __typename?: 'Tabs' } | { __typename?: 'TermsAndConditions' } | { __typename?: 'TextBlockSeo' } | { __typename?: 'Video' } | { __typename?: 'VideoAsset' } | { __typename?: 'VideoCarousel' } | { __typename?: 'VideoWithContent' } | null> } } } | null, footnote?: { __typename?: 'TableFootnote', json: any } | null }
  & Meta_Table_Fragment
);

export type TabsFragment = (
  { __typename?: 'Tabs', backgroundColor?: string | null, jumplinkTabs?: boolean | null, tabRowVariant?: string | null, tabsSize?: string | null, withContentInnerGap?: boolean | null, anchorId?: string | null, tabsCollection?: { __typename?: 'TabsTabsCollection', items: Array<(
      { __typename?: 'Tab', label?: string | null, jumplinkName?: string | null, content?: (
        { __typename?: 'Accordions' }
        & AccordionFragment
      ) | null }
      & Meta_Tab_Fragment
    ) | null> } | null }
  & Meta_Tabs_Fragment
);

export type TermOfConditionsFragment = (
  { __typename?: 'TermsAndConditions', showTcTextAs?: boolean | null, tcText?: string | null, tcLink?: string | null, headlineText?: string | null, content?: { __typename?: 'TermsAndConditionsContent', json: any } | null }
  & Meta_TermsAndConditions_Fragment
);

export type TextBlockSeoFragment = (
  { __typename?: 'TextBlockSeo', name?: string | null, backgroundColor?: string | null, disablePaddingOn?: Array<string | null> | null, anchorId?: string | null, content?: { __typename?: 'TextBlockSeoContent', json: any } | null }
  & Meta_TextBlockSeo_Fragment
);

export type VideoAssetFragment = (
  { __typename?: 'VideoAsset', desktopVideo?: (
    { __typename?: 'Video' }
    & VideoFragment
  ) | null, mobileVideo?: (
    { __typename?: 'Video' }
    & VideoFragment
  ) | null }
  & Meta_VideoAsset_Fragment
);

export type AccordionsByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AccordionsByIdQuery = { __typename?: 'Query', accordions?: (
    { __typename?: 'Accordions' }
    & AccordionFragment
  ) | null };

export type AgendaStepperByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AgendaStepperByIdQuery = { __typename?: 'Query', agendaStepper?: { __typename?: 'AgendaStepper', icon?: string | null, title?: string | null, titleHtag?: string | null, hideStepperDot?: boolean | null, backgroundColor?: string | null, useNumericStepper?: boolean | null, isHighlightedSteps?: boolean | null, areStepsCenteredForMobile?: boolean | null, anchorId?: string | null, description?: (
      { __typename?: 'ContentTypeRichText' }
      & RichTextFragment
    ) | null, stepsCollection?: { __typename?: 'AgendaStepperStepsCollection', items: Array<(
        { __typename?: 'AgendaModal' }
        & AgendaModalFragment
      ) | null> } | null } | null };

export type AppMetadataByAppNameQueryVariables = Exact<{
  appName: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AppMetadataByAppNameQuery = { __typename?: 'Query', appCollection?: { __typename?: 'AppCollection', items: Array<(
      { __typename?: 'App' }
      & AppMetadataFragment
    ) | null> } | null };

export type AppPagesDataByAppNameQueryVariables = Exact<{
  appName: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AppPagesDataByAppNameQuery = { __typename?: 'Query', appCollection?: { __typename?: 'AppCollection', items: Array<(
      { __typename?: 'App' }
      & AppPagesDataFragment
    ) | null> } | null };

export type BirdEyeReviewsByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BirdEyeReviewsByIdQuery = { __typename?: 'Query', birdEyeReviews?: (
    { __typename?: 'BirdEyeReviews', title?: string | null, titleHeading?: string | null, tags?: Array<string | null> | null, filteredReviewsMinRating?: string | null, filteredReviewsTitle?: string | null, anchorId?: string | null, mediaContent?: (
      { __typename?: 'FocalPointImage' }
      & FocalPointImageFragment
    ) | (
      { __typename?: 'Video' }
      & VideoFragment
    ) | null }
    & Meta_BirdEyeReviews_Fragment
  ) | null };

export type BlogDetailsPageByPathQueryVariables = Exact<{
  path: Scalars['String']['input'];
  title: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BlogDetailsPageByPathQuery = { __typename?: 'Query', blogDetailsPageCollection?: { __typename?: 'BlogDetailsPageCollection', skip: number, limit: number, total: number, items: Array<(
      { __typename?: 'BlogDetailsPage' }
      & BlogDetailsPageFragment
    ) | null> } | null };

export type BlogListByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BlogListByIdQuery = { __typename?: 'Query', blogList?: (
    { __typename?: 'BlogList' }
    & BlogListFragment
  ) | null };

export type BlogListPageByBrandQueryVariables = Exact<{
  brandName: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BlogListPageByBrandQuery = { __typename?: 'Query', blogListPageCollection?: { __typename?: 'BlogListPageCollection', items: Array<(
      { __typename?: 'BlogListPage' }
      & BlogListPageFragment
    ) | null> } | null };

export type BlogDetailsPageItemFragment = { __typename?: 'BlogDetailsPage', path?: string | null, indexed?: boolean | null, sys: { __typename?: 'Sys', publishedAt?: any | null }, category?: (
    { __typename?: 'BlogCategory' }
    & BlogCategoryFragment
  ) | null };

export type BlogListPageItemFragment = { __typename?: 'BlogListPage', indexed?: boolean | null, sys: { __typename?: 'Sys', publishedAt?: any | null } };

export type BlogPagesQueryVariables = Exact<{
  brandName: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  indexed?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BlogPagesQuery = { __typename?: 'Query', blogDetailsPageCollection?: { __typename?: 'BlogDetailsPageCollection', skip: number, limit: number, total: number, items: Array<(
      { __typename?: 'BlogDetailsPage' }
      & BlogDetailsPageItemFragment
    ) | null> } | null, blogListPageCollection?: { __typename?: 'BlogListPageCollection', skip: number, limit: number, total: number, items: Array<(
      { __typename?: 'BlogListPage' }
      & BlogListPageItemFragment
    ) | null> } | null };

export type CityLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CityLinksByIdQuery = { __typename?: 'Query', cityLinks?: (
    { __typename?: 'CityLinks', name?: string | null }
    & Meta_CityLinks_Fragment
  ) | null };

export type ColumnsByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ColumnsByIdQuery = { __typename?: 'Query', columns?: (
    { __typename?: 'Columns' }
    & ColumnsFragment
  ) | null };

export type GoogleMapTemplateByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GoogleMapTemplateByIdQuery = { __typename?: 'Query', googleMapTemplate?: (
    { __typename?: 'GoogleMapTemplate' }
    & GoogleMapTemplateFragment
  ) | null };

export type HeroV2ByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type HeroV2ByIdQuery = { __typename?: 'Query', heroV2?: (
    { __typename?: 'HeroV2' }
    & HeroFragment
  ) | null };

export type MarqueeByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MarqueeByIdQuery = { __typename?: 'Query', marquee?: (
    { __typename?: 'Marquee' }
    & MarqueeFragment
  ) | null };

export type LandingPageByPathQueryVariables = Exact<{
  path: Scalars['String']['input'];
  content_limit?: InputMaybe<Scalars['Int']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type LandingPageByPathQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', skip: number, limit: number, total: number, items: Array<(
      { __typename?: 'Page' }
      & PageFragment
    ) | null> } | null };

export type LandingPageByAppNameWithPathQueryVariables = Exact<{
  appName: Scalars['String']['input'];
  path: Scalars['String']['input'];
  content_limit?: InputMaybe<Scalars['Int']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type LandingPageByAppNameWithPathQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', skip: number, limit: number, total: number, items: Array<(
      { __typename?: 'Page' }
      & PageFragment
    ) | null> } | null };

export type PageByAppAndAlternatePathQueryVariables = Exact<{
  appName: Scalars['String']['input'];
  path: Scalars['String']['input'];
  alternativePath: Scalars['String']['input'];
  content_limit?: InputMaybe<Scalars['Int']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PageByAppAndAlternatePathQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', skip: number, limit: number, total: number, items: Array<(
      { __typename?: 'Page' }
      & PageFragment
    ) | null> } | null };

export type ProductDisplayByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProductDisplayByIdQuery = { __typename?: 'Query', productDisplay?: (
    { __typename?: 'ProductDisplay' }
    & Meta_ProductDisplay_Fragment
    & ProductDisplayFragment
  ) | null };

export type ProductFeatureByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProductFeatureByIdQuery = { __typename?: 'Query', productFeature?: (
    { __typename?: 'ProductFeature', enableSliderControlsBackgroundGradient?: boolean | null, anchorId?: string | null, headline?: (
      { __typename?: 'ContentSection' }
      & ContentSectionFragment
    ) | null, descriptionRichText?: (
      { __typename?: 'ContentTypeRichText' }
      & RichTextFragment
    ) | null, descriptionButton?: (
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null, descriptionButtonsCollection?: { __typename?: 'ProductFeatureDescriptionButtonsCollection', items: Array<(
        { __typename?: 'Button' }
        & ButtonFragment
      ) | null> } | null, descriptionListCollection?: { __typename?: 'ProductFeatureDescriptionListCollection', items: Array<(
        { __typename?: 'ProductFeatureDescriptionListItem', icon?: string | null, content?: (
          { __typename?: 'ContentTypeRichText' }
          & RichTextFragment
        ) | null }
        & Meta_ProductFeatureDescriptionListItem_Fragment
      ) | null> } | null, buttonsCollection?: { __typename?: 'ProductFeatureButtonsCollection', items: Array<(
        { __typename?: 'Button' }
        & ButtonFragment
      ) | null> } | null, media?: { __typename?: 'MediaSlider', badge?: { __typename?: 'Badge', label?: string | null, variant?: string | null } | null, contentsCollection?: { __typename?: 'MediaSliderContentsCollection', items: Array<(
          { __typename?: 'FocalPointImage' }
          & FocalPointImageFragment
        ) | (
          { __typename?: 'Video' }
          & VideoFragment
        ) | null> } | null } | null, disclaimer?: (
      { __typename?: 'DisclaimerV2' }
      & DisclaimerV2Fragment
    ) | null }
    & Meta_ProductFeature_Fragment
  ) | null };

export type QuizByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type QuizByIdQuery = { __typename?: 'Query', quiz?: (
    { __typename?: 'Quiz' }
    & QuizFragment
  ) | null };

export type RichTextByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RichTextByIdQuery = { __typename?: 'Query', contentTypeRichText?: (
    { __typename?: 'ContentTypeRichText' }
    & RichTextWithLinksFragment
  ) | null };

export type SmallScreenContentEntryLinksFragment = (
  { __typename?: 'SmallScreenContent', entryName?: string | null, bodySmallScreen?: { __typename?: 'SmallScreenContentBodySmallScreen', links: { __typename?: 'SmallScreenContentBodySmallScreenLinks', entries: { __typename?: 'SmallScreenContentBodySmallScreenEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & Meta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null }
  & Meta_SmallScreenContent_Fragment
);

export type ContentTypeRichTextEntryLinksFragment = (
  { __typename?: 'ContentTypeRichText', content?: { __typename?: 'ContentTypeRichTextContent', links: { __typename?: 'ContentTypeRichTextContentLinks', entries: { __typename?: 'ContentTypeRichTextContentEntries', block: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & EnrichedMeta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
          & ImageAssetFragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null>, hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & Meta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null, secondaryContent?: { __typename?: 'ContentTypeRichTextSecondaryContent', links: { __typename?: 'ContentTypeRichTextSecondaryContentLinks', entries: { __typename?: 'ContentTypeRichTextSecondaryContentEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & Meta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null }
  & Meta_ContentTypeRichText_Fragment
);

export type HeroV2EntryLinksFragment = (
  { __typename?: 'HeroV2', entryName?: string | null, body?: { __typename?: 'HeroV2Body', links: { __typename?: 'HeroV2BodyLinks', entries: { __typename?: 'HeroV2BodyEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & Meta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null, contentSmallScreen?: (
    { __typename?: 'SmallScreenContent' }
    & SmallScreenContentEntryLinksFragment
  ) | null, termsConditions?: (
    { __typename?: 'TermsAndConditions' }
    & TermsAndConditionsEntryLinksFragment
  ) | null, disclaimer?: (
    { __typename?: 'DisclaimerV2' }
    & DisclaimerV2EntryLinksFragment
  ) | null }
  & Meta_HeroV2_Fragment
);

export type HalfScreenEntryLinksFragment = (
  { __typename?: 'HalfScreen', name?: string | null, body?: { __typename?: 'HalfScreenBody', links: { __typename?: 'HalfScreenBodyLinks', entries: { __typename?: 'HalfScreenBodyEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & Meta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null, contentSmallScreen?: (
    { __typename?: 'SmallScreenContent' }
    & SmallScreenContentEntryLinksFragment
  ) | null, termsAndConditions?: (
    { __typename?: 'TermsAndConditions' }
    & TermsAndConditionsEntryLinksFragment
  ) | null, disclaimer?: (
    { __typename?: 'DisclaimerV2' }
    & DisclaimerV2EntryLinksFragment
  ) | null }
  & Meta_HalfScreen_Fragment
);

export type SingleMessageEntryLinksFragment = (
  { __typename?: 'SingleMessage', name?: string | null, content?: { __typename?: 'SingleMessageContent', links: { __typename?: 'SingleMessageContentLinks', entries: { __typename?: 'SingleMessageContentEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & Meta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null, contentSmallScreen?: (
    { __typename?: 'SmallScreenContent' }
    & SmallScreenContentEntryLinksFragment
  ) | null, tc?: (
    { __typename?: 'TermsAndConditions' }
    & TermsAndConditionsEntryLinksFragment
  ) | null }
  & Meta_SingleMessage_Fragment
);

export type CardEntryLinksFragment = (
  { __typename?: 'Card', name?: string | null, richTextDescription?: { __typename?: 'CardRichTextDescription', links: { __typename?: 'CardRichTextDescriptionLinks', entries: { __typename?: 'CardRichTextDescriptionEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & Meta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null, tc?: (
    { __typename?: 'TermsAndConditions' }
    & TermsAndConditionsEntryLinksFragment
  ) | null }
  & Meta_Card_Fragment
);

export type MulticardV2EntryLinksFragment = (
  { __typename?: 'MultiCardV2', descriptionRichText?: { __typename?: 'MultiCardV2DescriptionRichText', links: { __typename?: 'MultiCardV2DescriptionRichTextLinks', entries: { __typename?: 'MultiCardV2DescriptionRichTextEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & EnrichedMeta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null> } } } | null, cardsCollection?: { __typename?: 'MultiCardV2CardsCollection', items: Array<(
      { __typename?: 'Card' }
      & CardEntryLinksFragment
    ) | null> } | null }
  & Meta_MultiCardV2_Fragment
);

export type TextBlockSeoEntryLinksFragment = (
  { __typename?: 'TextBlockSeo', content?: { __typename?: 'TextBlockSeoContent', links: { __typename?: 'TextBlockSeoContentLinks', entries: { __typename?: 'TextBlockSeoContentEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & Meta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null }
  & Meta_TextBlockSeo_Fragment
);

export type TermsAndConditionsEntryLinksFragment = (
  { __typename?: 'TermsAndConditions', content?: { __typename?: 'TermsAndConditionsContent', links: { __typename?: 'TermsAndConditionsContentLinks', entries: { __typename?: 'TermsAndConditionsContentEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & Meta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null }
  & Meta_TermsAndConditions_Fragment
);

export type AccordionsEntryLinksFragment = (
  { __typename?: 'Accordions', title?: string | null, descriptionRichText?: { __typename?: 'AccordionsDescriptionRichText', links: { __typename?: 'AccordionsDescriptionRichTextLinks', entries: { __typename?: 'AccordionsDescriptionRichTextEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & EnrichedMeta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null> } } } | null, accordionsCollection?: { __typename?: 'AccordionsAccordionsCollection', items: Array<{ __typename?: 'AgendaStepper' } | (
      { __typename?: 'ContentTypeRichText' }
      & ContentTypeRichTextEntryLinksFragment
    ) | null> } | null }
  & Meta_Accordions_Fragment
);

export type DisclaimerV2EntryLinksFragment = (
  { __typename?: 'DisclaimerV2', entryName?: string | null, disclaimer?: (
    { __typename?: 'ContentTypeRichText' }
    & ContentTypeRichTextEntryLinksFragment
  ) | null }
  & Meta_DisclaimerV2_Fragment
);

export type InsuranceEntryLinksFragment = (
  { __typename?: 'Insurance', name?: string | null, intro?: { __typename?: 'InsuranceIntro', links: { __typename?: 'InsuranceIntroLinks', entries: { __typename?: 'InsuranceIntroEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & Meta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null }
  & Meta_Insurance_Fragment
);

export type CategoryPickerEntryLinksFragment = (
  { __typename?: 'CategoryPicker', name?: string | null, bodyCopy?: (
    { __typename?: 'ContentTypeRichText' }
    & ContentTypeRichTextEntryLinksFragment
  ) | null }
  & Meta_CategoryPicker_Fragment
);

export type ColumnsEntryLinksFragment = (
  { __typename?: 'Columns', title?: string | null, columnsCollection?: { __typename?: 'ColumnsColumnsCollection', items: Array<(
      { __typename?: 'Accordions' }
      & AccordionsEntryLinksFragment
    ) | (
      { __typename?: 'ContentTypeRichText' }
      & ContentTypeRichTextEntryLinksFragment
    ) | { __typename?: 'ImageAsset' } | (
      { __typename?: 'SingleMessage' }
      & SingleMessageEntryLinksFragment
    ) | null> } | null }
  & Meta_Columns_Fragment
);

export type MedicalServiceEntryLinksFragment = (
  { __typename?: 'MedicalService', title?: string | null, description?: { __typename?: 'MedicalServiceDescription', links: { __typename?: 'MedicalServiceDescriptionLinks', entries: { __typename?: 'MedicalServiceDescriptionEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & Meta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null }
  & Meta_MedicalService_Fragment
);

export type ContentListItemEntryLinks_Accordions_Fragment = (
  { __typename?: 'Accordions' }
  & AccordionsEntryLinksFragment
);

export type ContentListItemEntryLinks_ContentTypeRichText_Fragment = (
  { __typename?: 'ContentTypeRichText' }
  & ContentTypeRichTextEntryLinksFragment
);

export type ContentListItemEntryLinks_SingleMessage_Fragment = (
  { __typename?: 'SingleMessage' }
  & SingleMessageEntryLinksFragment
);

export type ContentListItemEntryLinks_Table_Fragment = { __typename?: 'Table' };

export type ContentListItemEntryLinksFragment = ContentListItemEntryLinks_Accordions_Fragment | ContentListItemEntryLinks_ContentTypeRichText_Fragment | ContentListItemEntryLinks_SingleMessage_Fragment | ContentListItemEntryLinks_Table_Fragment;

export type ServiceLineHeroEntryLinksFragment = (
  { __typename?: 'ServiceLineHero', subHeadline?: { __typename?: 'ServiceLineHeroSubHeadline', links: { __typename?: 'ServiceLineHeroSubHeadlineLinks', entries: { __typename?: 'ServiceLineHeroSubHeadlineEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & Meta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null, bodyCopy?: { __typename?: 'ServiceLineHeroBodyCopy', links: { __typename?: 'ServiceLineHeroBodyCopyLinks', entries: { __typename?: 'ServiceLineHeroBodyCopyEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & Meta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null, termsConditions?: (
    { __typename?: 'TermsAndConditions' }
    & TermsAndConditionsEntryLinksFragment
  ) | null, servicesCollection?: { __typename?: 'ServiceLineHeroServicesCollection', items: Array<(
      { __typename?: 'MedicalService' }
      & MedicalServiceEntryLinksFragment
    ) | null> } | null, contentListCollection?: { __typename?: 'ServiceLineHeroContentListCollection', items: Array<(
      { __typename?: 'Accordions' }
      & ContentListItemEntryLinks_Accordions_Fragment
    ) | (
      { __typename?: 'ContentTypeRichText' }
      & ContentListItemEntryLinks_ContentTypeRichText_Fragment
    ) | (
      { __typename?: 'SingleMessage' }
      & ContentListItemEntryLinks_SingleMessage_Fragment
    ) | (
      { __typename?: 'Table' }
      & ContentListItemEntryLinks_Table_Fragment
    ) | null> } | null }
  & Meta_ServiceLineHero_Fragment
);

export type OdpHeroEntryLinksFragment = (
  { __typename?: 'OdpHero', name?: string | null, bodyCopy?: (
    { __typename?: 'ContentTypeRichText' }
    & ContentTypeRichTextEntryLinksFragment
  ) | null }
  & Meta_OdpHero_Fragment
);

export type QuickLinksEntryLinksFragment = (
  { __typename?: 'QuickLinks', body?: { __typename?: 'QuickLinksBody', links: { __typename?: 'QuickLinksBodyLinks', entries: { __typename?: 'QuickLinksBodyEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & Meta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null }
  & Meta_QuickLinks_Fragment
);

export type ServiceEntryLinksFragment = (
  { __typename?: 'Service', name?: string | null, richTextDescription?: { __typename?: 'ServiceRichTextDescription', links: { __typename?: 'ServiceRichTextDescriptionLinks', entries: { __typename?: 'ServiceRichTextDescriptionEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormDropdownListItem' }
          & Meta_FormDropdownListItem_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null, tc?: (
    { __typename?: 'TermsAndConditions' }
    & TermsAndConditionsEntryLinksFragment
  ) | null }
  & Meta_Service_Fragment
);

export type SegmentContainerEntryLinksFragment = (
  { __typename?: 'SegmentsContainer', contentsCollection?: { __typename?: 'SegmentsContainerContentsCollection', items: Array<(
      { __typename?: 'ContentTypeRichText' }
      & ContentTypeRichTextEntryLinksFragment
    ) | { __typename?: 'DisclaimerV2' } | (
      { __typename?: 'HalfScreen' }
      & HalfScreenEntryLinksFragment
    ) | (
      { __typename?: 'HeroV2' }
      & HeroV2EntryLinksFragment
    ) | { __typename?: 'Marquee' } | (
      { __typename?: 'MultiCardV2' }
      & MulticardV2EntryLinksFragment
    ) | (
      { __typename?: 'OdpHero' }
      & OdpHeroEntryLinksFragment
    ) | { __typename?: 'ServiceLineHero' } | (
      { __typename?: 'SingleMessage' }
      & SingleMessageEntryLinksFragment
    ) | null> } | null }
  & Meta_SegmentsContainer_Fragment
);

export type ProductFeatureEntryLinksFragment = (
  { __typename?: 'ProductFeature', descriptionRichText?: (
    { __typename?: 'ContentTypeRichText' }
    & ContentTypeRichTextEntryLinksFragment
  ) | null, descriptionListCollection?: { __typename?: 'ProductFeatureDescriptionListCollection', items: Array<(
      { __typename?: 'ProductFeatureDescriptionListItem', content?: (
        { __typename?: 'ContentTypeRichText' }
        & ContentTypeRichTextEntryLinksFragment
      ) | null }
      & Meta_ProductFeatureDescriptionListItem_Fragment
    ) | null> } | null }
  & Meta_ProductFeature_Fragment
);

export type AgendaStepperEntryLinksFragment = (
  { __typename?: 'AgendaStepper', description?: (
    { __typename?: 'ContentTypeRichText' }
    & ContentTypeRichTextEntryLinksFragment
  ) | null, stepsCollection?: { __typename?: 'AgendaStepperStepsCollection', items: Array<(
      { __typename?: 'AgendaModal', bodyText?: (
        { __typename?: 'ContentTypeRichText' }
        & ContentTypeRichTextEntryLinksFragment
      ) | null }
      & Meta_AgendaModal_Fragment
    ) | null> } | null }
  & Meta_AgendaStepper_Fragment
);

export type HeroV2EntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type HeroV2EntryLinksByIdQuery = { __typename?: 'Query', heroV2?: (
    { __typename?: 'HeroV2' }
    & HeroV2EntryLinksFragment
  ) | null };

export type SingleMessageEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SingleMessageEntryLinksByIdQuery = { __typename?: 'Query', singleMessage?: (
    { __typename?: 'SingleMessage' }
    & SingleMessageEntryLinksFragment
  ) | null };

export type MultiCardV2EntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MultiCardV2EntryLinksByIdQuery = { __typename?: 'Query', multiCardV2?: (
    { __typename?: 'MultiCardV2' }
    & MulticardV2EntryLinksFragment
  ) | null };

export type TextBlockSeoEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TextBlockSeoEntryLinksByIdQuery = { __typename?: 'Query', textBlockSeo?: (
    { __typename?: 'TextBlockSeo' }
    & TextBlockSeoEntryLinksFragment
  ) | null };

export type TermsAndConditionsEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TermsAndConditionsEntryLinksByIdQuery = { __typename?: 'Query', termsAndConditions?: (
    { __typename?: 'TermsAndConditions' }
    & TermsAndConditionsEntryLinksFragment
  ) | null };

export type AccordionsEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AccordionsEntryLinksByIdQuery = { __typename?: 'Query', accordions?: (
    { __typename?: 'Accordions' }
    & AccordionsEntryLinksFragment
  ) | null };

export type HalfScreenEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type HalfScreenEntryLinksByIdQuery = { __typename?: 'Query', halfScreen?: (
    { __typename?: 'HalfScreen' }
    & HalfScreenEntryLinksFragment
  ) | null };

export type DisclaimerV2EntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DisclaimerV2EntryLinksByIdQuery = { __typename?: 'Query', disclaimerV2?: (
    { __typename?: 'DisclaimerV2' }
    & DisclaimerV2EntryLinksFragment
  ) | null };

export type InsuranceEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InsuranceEntryLinksByIdQuery = { __typename?: 'Query', insurance?: (
    { __typename?: 'Insurance' }
    & InsuranceEntryLinksFragment
  ) | null };

export type CategoryPickerEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CategoryPickerEntryLinksByIdQuery = { __typename?: 'Query', categoryPicker?: (
    { __typename?: 'CategoryPicker' }
    & CategoryPickerEntryLinksFragment
  ) | null };

export type ColumnsEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ColumnsEntryLinksByIdQuery = { __typename?: 'Query', columns?: (
    { __typename?: 'Columns' }
    & ColumnsEntryLinksFragment
  ) | null };

export type ServiceLineHeroEntryLinksQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ServiceLineHeroEntryLinksQuery = { __typename?: 'Query', serviceLineHero?: (
    { __typename?: 'ServiceLineHero' }
    & ServiceLineHeroEntryLinksFragment
  ) | null };

export type OdpHeroEntryLinksQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OdpHeroEntryLinksQuery = { __typename?: 'Query', odpHero?: (
    { __typename?: 'OdpHero' }
    & OdpHeroEntryLinksFragment
  ) | null };

export type QuickLinksEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type QuickLinksEntryLinksByIdQuery = { __typename?: 'Query', quickLinks?: (
    { __typename?: 'QuickLinks' }
    & QuickLinksEntryLinksFragment
  ) | null };

export type ServiceEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ServiceEntryLinksByIdQuery = { __typename?: 'Query', service?: (
    { __typename?: 'Service' }
    & ServiceEntryLinksFragment
  ) | null };

export type SegmentContainerLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SegmentContainerLinksByIdQuery = { __typename?: 'Query', segmentsContainer?: (
    { __typename?: 'SegmentsContainer' }
    & SegmentContainerEntryLinksFragment
  ) | null };

export type ProductFeatureEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProductFeatureEntryLinksByIdQuery = { __typename?: 'Query', productFeature?: (
    { __typename?: 'ProductFeature' }
    & ProductFeatureEntryLinksFragment
  ) | null };

export type AgendaStepperEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AgendaStepperEntryLinksByIdQuery = { __typename?: 'Query', agendaStepper?: (
    { __typename?: 'AgendaStepper' }
    & AgendaStepperEntryLinksFragment
  ) | null };

export type SegmentsContainerByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SegmentsContainerByIdQuery = { __typename?: 'Query', segmentsContainer?: (
    { __typename?: 'SegmentsContainer' }
    & SegmentsContainerFragment
  ) | null };

export type ServiceLineHeroByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ServiceLineHeroByIdQuery = { __typename?: 'Query', serviceLineHero?: (
    { __typename?: 'ServiceLineHero' }
    & ServiceLineHeroFragment
  ) | null };

export type SitemapPagesFragment = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', items: Array<{ __typename?: 'Page', path?: string | null, indexed?: boolean | null, sys: { __typename?: 'Sys', publishedAt?: any | null } } | null> } | null };

export type SitemapPagesQueryVariables = Exact<{
  appName: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  indexed?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SitemapPagesQuery = (
  { __typename?: 'Query' }
  & SitemapPagesFragment
);

export type SmileAssessmentFormByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SmileAssessmentFormByIdQuery = { __typename?: 'Query', smileAssessmentForm?: { __typename?: 'SmileAssessmentForm', formContent?: { __typename?: 'Questionnaire', buttonText?: string | null, buttonUrl?: string | null, defaultErrorMessage?: string | null, formCollection?: { __typename?: 'QuestionnaireFormCollection', items: Array<{ __typename?: 'FormDropdownField' } | { __typename?: 'FormField' } | { __typename?: 'SectionContent', title?: string | null, type?: string | null, aditionalReferencesCollection?: { __typename?: 'SectionContentAditionalReferencesCollection', items: Array<{ __typename?: 'Accordions' } | { __typename?: 'AdFooter' } | { __typename?: 'AgendaModal' } | { __typename?: 'AgendaStepper' } | { __typename?: 'AnalyticsContext' } | { __typename?: 'App' } | { __typename?: 'AppointmentBookingPage' } | { __typename?: 'Badge' } | { __typename?: 'Banner' } | { __typename?: 'BirdEyeReviews' } | { __typename?: 'BlogAuthor' } | { __typename?: 'BlogCategory' } | { __typename?: 'BlogDetailsPage' } | { __typename?: 'BlogList' } | { __typename?: 'BlogListPage' } | { __typename?: 'BlogSubCategory' } | { __typename?: 'Brand' } | { __typename?: 'Button' } | { __typename?: 'Card' } | { __typename?: 'Category' } | { __typename?: 'CategoryPicker' } | { __typename?: 'CityLinks' } | { __typename?: 'Columns' } | { __typename?: 'ConfirmationStep' } | { __typename?: 'ContentSection' } | { __typename?: 'ContentTile' } | { __typename?: 'ContentTypeRichText' } | { __typename?: 'DisclaimerV2' } | { __typename?: 'Error404' } | { __typename?: 'FacilityDetailsPage' } | { __typename?: 'FeatureFlags' } | { __typename?: 'FocalPointImage' } | { __typename?: 'FooterNavigationGroup' } | { __typename?: 'FormDropdownField', title?: string | null, clearTextItem?: string | null, itemList?: Array<string | null> | null, apiKey?: string | null, required?: boolean | null } | { __typename?: 'FormDropdownListItem' } | { __typename?: 'FormField', title?: string | null, required?: boolean | null, onSubmitFormUrl?: string | null, alertMessage?: string | null, type?: string | null, label?: string | null, placeholder?: string | null, apiKey?: string | null, image?: { __typename?: 'Asset', url?: string | null } | null } | { __typename?: 'GoogleMapTemplate' } | { __typename?: 'HalfScreen' } | { __typename?: 'Header' } | { __typename?: 'HeaderMainNav' } | { __typename?: 'HeaderNavMenu' } | { __typename?: 'HeaderSubNav' } | { __typename?: 'HeroV2' } | { __typename?: 'Iframe' } | { __typename?: 'ImageAsset' } | { __typename?: 'Insurance' } | { __typename?: 'LinkForwarder' } | { __typename?: 'LocalizedServiceTitle' } | { __typename?: 'Marquee' } | { __typename?: 'MediaSlider' } | { __typename?: 'MedicalService' } | { __typename?: 'MeetOurStaff' } | { __typename?: 'MobileButton' } | { __typename?: 'MultiCardV2' } | { __typename?: 'NavigationGroup' } | { __typename?: 'NavigationLink' } | { __typename?: 'OdpHero' } | { __typename?: 'Page' } | { __typename?: 'PatientReviewV2' } | { __typename?: 'PatientReviewsV2' } | { __typename?: 'Product' } | { __typename?: 'ProductDisplay' } | { __typename?: 'ProductFeature' } | { __typename?: 'ProductFeatureDescriptionListItem' } | { __typename?: 'ProviderDetailsPage' } | { __typename?: 'Questionnaire' } | { __typename?: 'QuickLinks' } | { __typename?: 'Quiz' } | { __typename?: 'ReviewStep' } | { __typename?: 'Schema' } | { __typename?: 'SectionContent' } | { __typename?: 'SegmentsContainer' } | { __typename?: 'Service' } | { __typename?: 'ServiceDetailsPage' } | { __typename?: 'ServiceLineHero' } | { __typename?: 'SingleMessage' } | { __typename?: 'SmallScreenContent' } | { __typename?: 'SmileAssessmentForm' } | { __typename?: 'Spacer' } | { __typename?: 'StateLinks' } | { __typename?: 'Stepper' } | { __typename?: 'SuccessCard' } | { __typename?: 'Tab' } | { __typename?: 'Table' } | { __typename?: 'Tabs' } | { __typename?: 'TermsAndConditions' } | { __typename?: 'TextBlockSeo' } | { __typename?: 'Video' } | { __typename?: 'VideoAsset' } | { __typename?: 'VideoCarousel' } | { __typename?: 'VideoWithContent' } | null> } | null } | null> } | null } | null } | null };

export type StateLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type StateLinksByIdQuery = { __typename?: 'Query', stateLinks?: (
    { __typename?: 'StateLinks', name?: string | null }
    & Meta_StateLinks_Fragment
  ) | null };

export type TableByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TableByIdQuery = { __typename?: 'Query', table?: (
    { __typename?: 'Table' }
    & TableFragment
  ) | null };

export type TabsByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TabsByIdQuery = { __typename?: 'Query', tabs?: (
    { __typename?: 'Tabs' }
    & TabsFragment
  ) | null };

export type VideoCarouselByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type VideoCarouselByIdQuery = { __typename?: 'Query', videoCarousel?: (
    { __typename?: 'VideoCarousel', backgroundColor?: string | null, desktopVideosAspectRatio?: string | null, mobileVideosAspectRatio?: string | null, anchorId?: string | null, topFields?: (
      { __typename?: 'ContentSection' }
      & ContentSectionFragment
    ) | null, videosCollection?: { __typename?: 'VideoCarouselVideosCollection', skip: number, total: number, items: Array<(
        { __typename?: 'VideoWithContent', content?: (
          { __typename?: 'ContentSection' }
          & ContentSectionFragment
        ) | null, video?: (
          { __typename?: 'VideoAsset' }
          & VideoAssetFragment
        ) | null, buttonsCollection?: { __typename?: 'VideoWithContentButtonsCollection', items: Array<(
            { __typename?: 'Button' }
            & ButtonFragment
          ) | null> } | null }
        & Meta_VideoWithContent_Fragment
      ) | null> } | null, buttonsCollection?: { __typename?: 'VideoCarouselButtonsCollection', items: Array<(
        { __typename?: 'Button' }
        & ButtonFragment
      ) | null> } | null }
    & Meta_VideoCarousel_Fragment
  ) | null };

export type InsuranceByStateQueryVariables = Exact<{
  filter: InsuranceCompaniesFilterInput;
}>;


export type InsuranceByStateQuery = { __typename?: 'Query', insuranceCompanies?: { __typename?: 'InsuranceCompaniesList', total: number, items: Array<{ __typename?: 'InsuranceCompany', name?: string | null }> } | null };

export type NearbyFacilitiesQueryVariables = Exact<{
  filter: NearbyFacilitiesLocationFilter;
  skip?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  take?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type NearbyFacilitiesQuery = { __typename?: 'Query', nearbyFacilities?: { __typename?: 'NearbyFacilitiesList', hasMore: boolean, items: Array<{ __typename?: 'NearbyFacility', distanceInMiles: any, facility: { __typename?: 'Facility', name: string, code: string, address: { __typename?: 'FacilityAddress', address1?: string | null, zipCode?: string | null, city?: string | null } } }> } | null };

export const MetaFragmentDoc = gql`
    fragment Meta on Entry {
  __typename
  sys {
    id
  }
}
    `;
export const MobileButtonFragmentDoc = gql`
    fragment MobileButton on MobileButton {
  ...Meta
  name
  label
  variant
  size
  icon
  iconPosition
}
    `;
export const AnalyticsFragmentDoc = gql`
    fragment Analytics on AnalyticsContext {
  brand
  event
  pageUrl
  pageName
  linkUrl
  linkText
  clickName
  clickPosition
  siteSection
  virtualPageUrl
  virtualPageTitle
  appointmentSelectedFacilityId
  appointmentSelectedFacilityName
}
    `;
export const EnrichedMetaFragmentDoc = gql`
    fragment EnrichedMeta on Entry {
  __typename
  sys {
    id
    environmentId
    spaceId
  }
  contentfulMetadata {
    tags {
      id
    }
  }
}
    `;
export const CommonAssetFragmentDoc = gql`
    fragment CommonAsset on Asset {
  __typename
  sys {
    id
    spaceId
    environmentId
  }
  contentfulMetadata {
    tags {
      name
      id
    }
  }
  title
  description
  fileName
  contentType
  size
}
    `;
export const ImageFragmentDoc = gql`
    fragment Image on Asset {
  ...CommonAsset
  url(
    transform: {resizeStrategy: FILL, resizeFocus: FACE, backgroundColor: "rgb:321032", format: WEBP, quality: 90}
  )
  width
  height
}
    `;
export const BasePageFragmentDoc = gql`
    fragment BasePage on Page {
  ...EnrichedMeta
  path
  title
  breadcrumbTitle
  description
  image {
    ...Image
  }
}
    `;
export const NavLinkFragmentDoc = gql`
    fragment NavLink on NavigationLink {
  ...EnrichedMeta
  externalUrl
  linkText
  openInNewTab
  openInNewWindow
  isInternal
  linkIcon {
    ...Image
  }
  pageData {
    ... on Page {
      ...BasePage
    }
    ... on BlogDetailsPage {
      ...Meta
      path
    }
    ... on ServiceDetailsPage {
      ...Meta
      path
    }
    ... on FacilityDetailsPage {
      ...Meta
      path
    }
  }
  analyticsContext {
    ...Analytics
  }
}
    `;
export const QuizFragmentDoc = gql`
    fragment Quiz on Quiz {
  ...Meta
  submitEndpointUrl
  quizFormData
  quizType
  isFormBuilder
  formBuilderConfig
  clearChoicePoorCreditRedirectPath
}
    `;
export const ButtonFragmentDoc = gql`
    fragment Button on Button {
  ...Meta
  name
  label
  variant
  buttonLink
  size
  icon
  iconPosition
  iconSize
  mobileButton {
    ... on MobileButton {
      ...MobileButton
    }
  }
  analyticsContext {
    ...Analytics
  }
  navigationDetails {
    ... on NavigationLink {
      ...NavLink
    }
  }
  quizDetails {
    ...Quiz
  }
}
    `;
export const RichTextFragmentDoc = gql`
    fragment RichText on ContentTypeRichText {
  ...Meta
  fullWidth
  disablePaddingOn
  backgroundColor
  centerAlign
  contained
  titleHeading
  title
  titleIcon
  contentMaxWidth
  facilitySegmentCollection
  id
  content {
    json
  }
  secondaryContent {
    json
  }
  buttonsCollection(limit: 2) {
    items {
      ... on Button {
        ...Button
      }
    }
  }
}
    `;
export const AgendaModalFragmentDoc = gql`
    fragment AgendaModal on AgendaModal {
  ...Meta
  headlineText
  headlineHeading
  bodyText {
    ... on ContentTypeRichText {
      ...RichText
    }
  }
  icon
}
    `;
export const BrandFragmentDoc = gql`
    fragment Brand on Brand {
  ...Meta
  name
  title
}
    `;
export const LinkMetaFragmentDoc = gql`
    fragment LinkMeta on Asset {
  __typename
  sys {
    id
    environmentId
    spaceId
  }
  contentfulMetadata {
    tags {
      id
      name
    }
  }
}
    `;
export const BlogDetailsPageSummaryAssetsFragmentDoc = gql`
    fragment BlogDetailsPageSummaryAssets on BlogDetailsPageSummaryAssets {
  block {
    ...LinkMeta
    contentType
    url
    description
    fileName
  }
  hyperlink {
    ...LinkMeta
    contentType
    url
    description
    fileName
  }
}
    `;
export const BlogDetailsPageSummaryEntriesFragmentDoc = gql`
    fragment BlogDetailsPageSummaryEntries on BlogDetailsPageSummaryEntries {
  inline {
    ...EnrichedMeta
    ...BasePage
  }
  block {
    ...EnrichedMeta
    ...BasePage
  }
  hyperlink {
    ...EnrichedMeta
    ...BasePage
  }
}
    `;
export const ResourceMetaFragmentDoc = gql`
    fragment ResourceMeta on ResourceLink {
  sys {
    urn
    linkType
  }
}
    `;
export const BlogDetailsPageSummaryResourcesFragmentDoc = gql`
    fragment BlogDetailsPageSummaryResources on BlogDetailsPageSummaryResources {
  block {
    ...ResourceMeta
  }
  inline {
    ...ResourceMeta
  }
  hyperlink {
    ...ResourceMeta
  }
}
    `;
export const BlogDetailsPageSummaryFragmentDoc = gql`
    fragment BlogDetailsPageSummary on BlogDetailsPageSummary {
  json
  links {
    assets {
      ...BlogDetailsPageSummaryAssets
    }
    entries {
      ...BlogDetailsPageSummaryEntries
    }
    resources {
      ...BlogDetailsPageSummaryResources
    }
  }
}
    `;
export const BlogCategoryFragmentDoc = gql`
    fragment BlogCategory on BlogCategory {
  ...Meta
  name
  slug
}
    `;
export const BlogSubCategoryFragmentDoc = gql`
    fragment BlogSubCategory on BlogSubCategory {
  ...Meta
  name
  slug
}
    `;
export const BlogDetailsPageTextAssetsFragmentDoc = gql`
    fragment BlogDetailsPageTextAssets on BlogDetailsPageTextAssets {
  block {
    ...LinkMeta
    contentType
    url
    description
    fileName
  }
  hyperlink {
    ...LinkMeta
    contentType
    url
    description
    fileName
  }
}
    `;
export const TableFragmentDoc = gql`
    fragment Table on Table {
  ...Meta
  variant
  fontSize
  border
  firstColumnSticky
  titleHtag
  title
  descriptionRichText {
    json
  }
  tableContent {
    json
    links {
      entries {
        inline {
          ... on Card {
            ...Meta
            image {
              ...CommonAsset
              url
            }
          }
        }
      }
    }
  }
  footnote {
    json
  }
  tableJsonData
  tableJsonDataMobile
  anchorId
}
    `;
export const VideoFragmentDoc = gql`
    fragment Video on Video {
  ...Meta
  media {
    ...CommonAsset
    url
    __typename
  }
  autoPlay
  isMuted
  isLooped
  posterUrl
  posterMedia {
    ...CommonAsset
    url
  }
  __typename
  youtubeId
  useOriginalVideoSize
  videoSource
  hlsVideoStreamLink
}
    `;
export const VideoAssetFragmentDoc = gql`
    fragment VideoAsset on VideoAsset {
  ...Meta
  desktopVideo {
    ...Video
  }
  mobileVideo {
    ...Video
  }
}
    `;
export const FocalPointImageFragmentDoc = gql`
    fragment FocalPointImage on FocalPointImage {
  ...Meta
  image {
    ...Image
  }
  focalPoint
}
    `;
export const SmallScreenContentFragmentDoc = gql`
    fragment SmallScreenContent on SmallScreenContent {
  eyebrowSmallScreen
  headingSmallScreen {
    json
  }
  bodySmallScreen {
    json
  }
  imageSmallScreen {
    ...Image
  }
  focalPointImageSmallScreen {
    ...FocalPointImage
  }
  controllableVideo {
    ...Video
  }
  videoSmallScreen {
    ...CommonAsset
    url
  }
  mediaFirst
}
    `;
export const TermOfConditionsFragmentDoc = gql`
    fragment TermOfConditions on TermsAndConditions {
  ...Meta
  showTcTextAs
  tcText
  tcLink
  headlineText
  content {
    json
  }
}
    `;
export const ImageAssetFragmentDoc = gql`
    fragment ImageAsset on ImageAsset {
  ...Meta
  desktopImage
  mobileImage
}
    `;
export const SingleMessageFragmentDoc = gql`
    fragment SingleMessage on SingleMessage {
  ...Meta
  backgroundColor
  focalPointImage {
    ...FocalPointImage
  }
  buttonsCollection(limit: 2) {
    items {
      ... on Button {
        ...Button
      }
    }
  }
  buttonSize
  buttonText
  buttonType
  buttonUrl
  description
  disablePaddingOn
  eyebrow
  icon
  iconSize
  name
  subText
  templateWidth
  templateHeight
  title
  titleAlign
  titleVariant
  facilitySegmentCollection
  isBannerImage
  contentFillVerticalSpace
  content {
    json
  }
  contentSmallScreen {
    ...SmallScreenContent
  }
  tc {
    ...TermOfConditions
  }
  contentAlign
  imageAsset {
    ...ImageAsset
  }
  imageLeftSide {
    ...ImageAsset
  }
  imageRightSide {
    ...ImageAsset
  }
  isHeaderAboveSideImages
  isInlineLayout
  displayTitleInline
  useRoundedCorners
  showSubscriptionForm
  anchorId
}
    `;
export const AccordionFragmentDoc = gql`
    fragment Accordion on Accordions {
  ...Meta
  title
  titleHtag
  titleColor
  descriptionRichText {
    json
  }
  centerAlign
  fullWidth
  disablePaddingOn
  imagePositionRight
  imageRoundedCorner
  titleAlignment
  descriptionAlignment
  image {
    ...FocalPointImage
  }
  backgroundColor
  backgroundImage {
    ...Image
  }
  accordionsCollection(limit: 20) {
    items {
      ... on ContentTypeRichText {
        ...RichText
      }
      ... on AgendaStepper {
        ...Meta
      }
    }
  }
  buttonsCollection(limit: 2) {
    items {
      ...Button
    }
  }
  expandIconType
  expandIconPosition
  roundedCornersSize
  withInnerGap
  anchorId
}
    `;
export const ColumnsFragmentDoc = gql`
    fragment Columns on Columns {
  ...Meta
  eyebrow
  title
  titleHtag
  description
  fullWidth
  disablePaddingOn
  backgroundColor
  allowEqualHeights
  anchorId
  columnsCollection(limit: 5) {
    items {
      ... on ContentTypeRichText {
        ...RichText
      }
      ... on SingleMessage {
        ...SingleMessage
      }
      ... on Accordions {
        ...Accordion
      }
      ... on ImageAsset {
        ...ImageAsset
      }
    }
  }
}
    `;
export const BlogDetailsPageTextEntriesFragmentDoc = gql`
    fragment BlogDetailsPageTextEntries on BlogDetailsPageTextEntries {
  inline {
    ...EnrichedMeta
    ...BasePage
  }
  block {
    ...EnrichedMeta
    ...BasePage
    ...Table
    ...VideoAsset
    ...Columns
    ...SingleMessage
  }
  hyperlink {
    ...EnrichedMeta
    ...BasePage
  }
}
    `;
export const BlogDetailsPageTextResourcesFragmentDoc = gql`
    fragment BlogDetailsPageTextResources on BlogDetailsPageTextResources {
  block {
    ...ResourceMeta
  }
  inline {
    ...ResourceMeta
  }
  hyperlink {
    ...ResourceMeta
  }
}
    `;
export const BlogDetailsPageTextFragmentDoc = gql`
    fragment BlogDetailsPageText on BlogDetailsPageText {
  json
  links {
    assets {
      ...BlogDetailsPageTextAssets
    }
    entries {
      ...BlogDetailsPageTextEntries
    }
    resources {
      ...BlogDetailsPageTextResources
    }
  }
}
    `;
export const BlogAuthorAuthorBioSummaryAssetsFragmentDoc = gql`
    fragment BlogAuthorAuthorBioSummaryAssets on BlogAuthorAuthorBioSummaryAssets {
  block {
    ...LinkMeta
    contentType
    url
    description
    fileName
  }
  hyperlink {
    ...LinkMeta
    contentType
    url
    description
    fileName
  }
}
    `;
export const BlogAuthorAuthorBioSummaryEntriesFragmentDoc = gql`
    fragment BlogAuthorAuthorBioSummaryEntries on BlogAuthorAuthorBioSummaryEntries {
  inline {
    ...EnrichedMeta
    ...BasePage
  }
  block {
    ...EnrichedMeta
    ...BasePage
  }
  hyperlink {
    ...EnrichedMeta
    ...BasePage
  }
}
    `;
export const BlogAuthorAuthorBioSummaryResourcesFragmentDoc = gql`
    fragment BlogAuthorAuthorBioSummaryResources on BlogAuthorAuthorBioSummaryResources {
  block {
    ...ResourceMeta
  }
  inline {
    ...ResourceMeta
  }
  hyperlink {
    ...ResourceMeta
  }
}
    `;
export const BlogAuthorAuthorBioSummaryFragmentDoc = gql`
    fragment BlogAuthorAuthorBioSummary on BlogAuthorAuthorBioSummary {
  json
  links {
    assets {
      ...BlogAuthorAuthorBioSummaryAssets
    }
    entries {
      ...BlogAuthorAuthorBioSummaryEntries
    }
    resources {
      ...BlogAuthorAuthorBioSummaryResources
    }
  }
}
    `;
export const BlogAuthorFragmentDoc = gql`
    fragment BlogAuthor on BlogAuthor {
  ...Meta
  title
  name
  image
  authorBioSummary {
    ...BlogAuthorAuthorBioSummary
  }
}
    `;
export const ContentSectionFragmentDoc = gql`
    fragment ContentSection on ContentSection {
  ...Meta
  eyebrow
  eyebrowHtag
  title
  titleHtag
  description {
    json
  }
  alignment
  titleIcon
}
    `;
export const BlogDetailsPageFragmentDoc = gql`
    fragment BlogDetailsPage on BlogDetailsPage {
  ...Meta
  name
  brand {
    ...Brand
  }
  path
  metaTitle
  metaDescription
  canonical
  indexed
  pageDesignType
  heroBackgroundColor
  date
  title
  summary {
    ...BlogDetailsPageSummary
  }
  category {
    ...BlogCategory
  }
  subCategory {
    ...BlogSubCategory
  }
  text {
    ...BlogDetailsPageText
  }
  blogImage
  timeToRead
  author {
    ...BlogAuthor
  }
  reviewer {
    ...BlogAuthor
  }
  imageAsset {
    ...ImageAsset
  }
  disableStickyFooterOnDesktop
  disableStickyFooterOnMobile
  disableHeaderTopAlertBanner
  disableHeaderBottomAlertBanner
  heroContentTitle {
    json
  }
  heroContentCollection(limit: 3) {
    items {
      ... on ContentTypeRichText {
        ...RichText
      }
    }
  }
  heroButtonCollection(limit: 1) {
    items {
      ...Button
    }
  }
  relatedBlogsContentSection {
    ...ContentSection
  }
  additionalContentCollection(limit: 2) {
    items {
      ... on SingleMessage {
        ...SingleMessage
      }
      ... on Accordions {
        ...Accordion
      }
    }
  }
}
    `;
export const HeroBlogDetailsPageListFragmentDoc = gql`
    fragment HeroBlogDetailsPageList on BlogDetailsPage {
  ...Meta
  title
  path
  summary {
    json
  }
  blogImage
  imageAsset {
    ...ImageAsset
  }
}
    `;
export const FeaturedBlogDetailsPageListFragmentDoc = gql`
    fragment FeaturedBlogDetailsPageList on BlogDetailsPage {
  ...Meta
  title
  date
  path
  summary {
    json
  }
  timeToRead
  blogImage
  imageAsset {
    ...ImageAsset
  }
  category {
    ...BlogCategory
  }
  subCategory {
    ...BlogSubCategory
  }
}
    `;
export const BlogListFragmentDoc = gql`
    fragment BlogList on BlogList {
  ...Meta
  title
  category {
    ...BlogCategory
  }
  subCategory {
    ...BlogSubCategory
  }
  displayType
  brand {
    ...Brand
  }
  buttonLabel
  loadMoreButtonLabel
  heroBlogsListCollection(limit: 4) {
    items {
      ...HeroBlogDetailsPageList
    }
  }
  featuredBlogsListCollection(limit: 4) {
    items {
      ...FeaturedBlogDetailsPageList
    }
  }
  countAcrossDesktop
  countAcrossMobile
  hasPagination
  cardDesignType
}
    `;
export const BlogListPageFragmentDoc = gql`
    fragment BlogListPage on BlogListPage {
  ...Meta
  metaTitle
  metaDescription
  canonical
  indexed
  brand {
    ...Brand
  }
  title
  blogList {
    ...BlogList
  }
  disableStickyFooterOnDesktop
  disableStickyFooterOnMobile
  disableHeaderTopAlertBanner
  disableHeaderBottomAlertBanner
  description {
    json
  }
  contentListCollection(limit: 1) {
    items {
      ... on BlogList {
        ...BlogList
      }
    }
  }
  contentAfterListCollection(limit: 1) {
    items {
      ... on SingleMessage {
        ...SingleMessage
      }
    }
  }
  shouldDisplayCategoryFilterChips
}
    `;
export const PdfFragmentDoc = gql`
    fragment Pdf on Asset {
  ...CommonAsset
  url
}
    `;
export const CardFragmentDoc = gql`
    fragment Card on Card {
  ...Meta
  name
  title
  titleHtag
  description
  richTextDescription {
    json
  }
  image {
    ...Image
  }
  imageAsset {
    ...ImageAsset
  }
  imageRatio
  cardIcon
  cardIconAlignment
  cardTextAlignment
  eyebrow
  backgroundColor
  buttonVariant
  buttonText
  buttonUrl
  buttonSize
  buttonIcon
  buttonIconSize
  buttonIconPosition
  pdfFileLink {
    ...Pdf
  }
  pdfDownloadTitle
  tc {
    ...TermOfConditions
  }
  imageAsset {
    ...ImageAsset
  }
  analyticsContext {
    ...Analytics
  }
  buttonsCollection(limit: 1) {
    items {
      ...Button
    }
  }
  tags
}
    `;
export const CardsFragmentDoc = gql`
    fragment Cards on MultiCardV2 {
  ...Meta
  anchorId
  backgroundColor
  bigScreenBackground
  cardsAlignment
  eyebrowColor
  eyebrowSx
  eyebrowTextTransform
  disablePaddingOn
  forMobile
  enableMobileCarouselNavigation
  lastRowCardsAlignment
  name
  numberOfCardsInLineDesktop
  roundedImage
  sectionEyebrow
  sectionInfoAlignment
  sectionTitle
  sectionTitleHtag
  descriptionRichText {
    json
  }
  facilitySegmentCollection
  cardsCollection(limit: 8) {
    items {
      ... on Card {
        ...Card
      }
    }
  }
  buttonsCollection(limit: 2) {
    items {
      ...Button
    }
  }
  displayAsStepper
  fixBackgroundToBottom
  backgroundImage {
    ...ImageAsset
  }
  headerSpacing
  enableResourceCardMode
  shouldDisplayCarouselOnDesktop
  useCardMediaRoundedCorners
}
    `;
export const TabsFragmentDoc = gql`
    fragment Tabs on Tabs {
  ...Meta
  tabsCollection(limit: 5) {
    items {
      ...Meta
      label
      jumplinkName
      content {
        ... on Accordions {
          ...Accordion
        }
      }
    }
  }
  backgroundColor
  jumplinkTabs
  tabRowVariant
  tabsSize
  withContentInnerGap
  anchorId
}
    `;
export const GoogleMapTemplateFragmentDoc = gql`
    fragment GoogleMapTemplate on GoogleMapTemplate {
  ...Meta
  title
  titleHtag
  useUsaCountryMap
  desktopZoom
  mobileZoom
  locationScheduleButtonUrl
  googleMapsBusinessQuery
  defaultImage {
    ...CommonAsset
    url
  }
  selectedImage {
    ...CommonAsset
    url
  }
  facilityBasePath
  holidayHoursMessageText
  noResultsFoundMessage {
    json
  }
  singleComingSoonMessage {
    json
  }
  listTabIsHorizontalScrolling
  facilityBadgeLabel
  facilityButtonLabel
  scheduleButton {
    ...Button
  }
  officeDetailsButton {
    ...Button
  }
  useModernDesign
  noResultsFoundImage {
    ...ImageAsset
  }
  noResultsContent {
    ... on MultiCardV2 {
      ...Cards
    }
  }
  availableServicesTabs {
    ... on Tabs {
      ...Tabs
    }
  }
  setAsOfficeButtonText
  useCumulativeDesign
  anchorId
}
    `;
export const FeatureFlagsFragmentDoc = gql`
    fragment FeatureFlags on FeatureFlags {
  continentalUsMapFallbackThreshold
  enforceContinentalUsZoom
  featureList
  onPageScheduling
  onPageSchedulingLocations
  salesForceEvergageScript
  hideSearchWithLocationCards
  hideOdpHeaderLinks
  providerHeroTheme
  showMobileHeaderLocationBar
  showHeaderWithLocationNav
  defaultToCdn
  useFacilityBeffeDataSource
  useInlineOneTrust
  useSessionStorageFacilityCode
  doNotIndexWholeSite
  showHeaderNavigationMenu
  hideHeaderFacilityLocator
  hideHeaderSchedulingButton
  hideProviderWithNoImage
  useGoogleMapAutocompleteSearch
  fetchAllLocationsOnEmptyResults
  showSetOfficeButtonInGoogleMapsCards
  useSimpleFindOfficeLink
  enableFluidTypography
}
    `;
export const AppMetadataFragmentDoc = gql`
    fragment AppMetadata on App {
  __typename
  sys {
    id
    environmentId
    spaceId
  }
  contentfulMetadata {
    tags {
      id
    }
  }
  name
  branding
  logo {
    ...Image
  }
  logoMobile {
    ...Image
  }
  featureFlags {
    ...FeatureFlags
  }
}
    `;
export const FooterNavigationGroupFragmentDoc = gql`
    fragment FooterNavigationGroup on FooterNavigationGroup {
  ...EnrichedMeta
  componentName
  navigationGroupLink {
    ... on Page {
      ...BasePage
    }
  }
  navigationLinksForGroupCollection(limit: 10) {
    items {
      ... on Page {
        ...BasePage
      }
    }
    skip
    limit
    total
  }
}
    `;
export const GenericNavigationGroupFragmentDoc = gql`
    fragment GenericNavigationGroup on NavigationGroup {
  groupLink {
    ...EnrichedMeta
    linkText
    isInternal
    openInNewTab
  }
  linksCollection(limit: 6) {
    items {
      ... on NavigationLink {
        ...NavLink
      }
    }
    limit
    skip
    total
  }
}
    `;
export const ContentTileFragmentDoc = gql`
    fragment ContentTile on ContentTile {
  ...EnrichedMeta
  title
  description
  image
  internalPage {
    ... on Page {
      ...BasePage
    }
  }
  externalUrl
}
    `;
export const HeaderSubNavFragmentDoc = gql`
    fragment HeaderSubNav on HeaderSubNav {
  headerSubNavGroupsCollection(limit: 20) {
    items {
      displayAsExpandedForMobileMenu
      groupLink {
        ... on NavigationLink {
          ...NavLink
        }
      }
      linksCollection(limit: 10) {
        items {
          ... on NavigationLink {
            ...NavLink
          }
        }
      }
    }
  }
  contentTilesCollection(limit: 3) {
    items {
      ...ContentTile
    }
  }
}
    `;
export const HeaderMainNavFragmentDoc = gql`
    fragment HeaderMainNav on HeaderMainNav {
  headerMainNavLink {
    ... on NavigationLink {
      ...NavLink
    }
  }
  headerSubNavMenu {
    ...HeaderSubNav
  }
}
    `;
export const HeaderNavMenuFragmentDoc = gql`
    fragment HeaderNavMenu on HeaderNavMenu {
  headerMainNavLinksCollection(limit: 10) {
    items {
      ...HeaderMainNav
    }
  }
}
    `;
export const GoogleMapInHeaderFragmentDoc = gql`
    fragment GoogleMapInHeader on GoogleMapTemplate {
  ...Meta
  title
  titleHtag
  locationScheduleButtonUrl
  googleMapsBusinessQuery
  defaultImage {
    ...CommonAsset
    url
  }
  selectedImage {
    ...CommonAsset
    url
  }
  noResultsFoundMessage {
    json
  }
  facilityBadgeLabel
  facilityButtonLabel
  scheduleButton {
    ...Button
  }
  officeDetailsButton {
    ...Button
  }
  setAsOfficeButtonText
}
    `;
export const BannerFragmentDoc = gql`
    fragment Banner on Banner {
  ...Meta
  variant
  alertMessagesCollection(limit: 5) {
    items {
      ... on ContentTypeRichText {
        backgroundColor
        content {
          json
        }
        __typename
      }
      __typename
    }
  }
  mobileAlertMessagesCollection(limit: 5) {
    items {
      ... on ContentTypeRichText {
        backgroundColor
        content {
          json
        }
        __typename
      }
      __typename
    }
  }
}
    `;
export const HeaderFragmentDoc = gql`
    fragment Header on Header {
  ...EnrichedMeta
  bookNowButton {
    ...EnrichedMeta
  }
  darkHeader
  componentName
  hideFullSiteSearch
  locationBarFindOfficeUrl
  locationBarWithOfficeTitle
  locationBarWithOutOfficeTitle
  useNewLayout
  schedulingButtonUrlMobile
  schedulingButtonUrl
  schedulingButtonText
  schedulingButtonTextMobile
  myAccountLabel
  profileLinkUrl
  useHeaderLocationCards
  showSecondaryNavInMobileToolbar
  navigationLinksCollection(limit: 10) {
    items {
      ...EnrichedMeta
      ... on Page {
        ...BasePage
      }
      ... on NavigationLink {
        ...NavLink
      }
      ... on FooterNavigationGroup {
        ...FooterNavigationGroup
      }
      ... on NavigationGroup {
        ...GenericNavigationGroup
      }
    }
    limit
    skip
    total
  }
  topNavigationLinksCollection(limit: 4) {
    items {
      ...EnrichedMeta
      ... on Page {
        ...BasePage
      }
      ... on NavigationLink {
        ...NavLink
      }
    }
    limit
    skip
    total
  }
  usePopupScheduling
  schedulingNavigationLinksCollection(limit: 4) {
    items {
      ...EnrichedMeta
      ... on NavigationGroup {
        ...GenericNavigationGroup
      }
    }
    limit
    skip
    total
  }
  navigationMenu {
    ...HeaderNavMenu
  }
  locationNavigationLinksCollection(limit: 5) {
    items {
      ... on Page {
        ...BasePage
      }
      ... on NavigationLink {
        ...NavLink
      }
    }
  }
  phoneNumber {
    ... on NavigationLink {
      ...NavLink
    }
  }
  secondaryNavigationLinksCollection(limit: 4) {
    items {
      ...EnrichedMeta
      ... on Page {
        ...BasePage
      }
      ... on NavigationLink {
        ...NavLink
      }
    }
    limit
    skip
    total
  }
  googleMapsForLocationCards {
    ...GoogleMapInHeader
  }
  topAlertBanner {
    ...Banner
  }
  bottomAlertBanner {
    ...Banner
  }
}
    `;
export const DisclaimerV2FragmentDoc = gql`
    fragment DisclaimerV2 on DisclaimerV2 {
  ...Meta
  disclaimer {
    ...RichText
  }
  size
  templateWidth
  facilitySegmentCollection
  anchorId
}
    `;
export const FooterFragmentDoc = gql`
    fragment Footer on AdFooter {
  ...EnrichedMeta
  componentName
  contactNumber
  copyright
  isLightFooter
  useMobileStickyFooter
  useDesktopStickyFooter
  stickyFooterScheduleButton {
    ... on Button {
      ...Button
    }
  }
  stickyFooterButtonsCollection(limit: 3) {
    items {
      ...Button
    }
    limit
    skip
    total
  }
  logo {
    ...Image
  }
  disclaimer {
    ...DisclaimerV2
  }
  about {
    json
    links {
      assets {
        block {
          ...LinkMeta
        }
        hyperlink {
          ...LinkMeta
        }
      }
      entries {
        inline {
          ...EnrichedMeta
        }
        block {
          ...EnrichedMeta
        }
        hyperlink {
          ...EnrichedMeta
        }
      }
      resources {
        block {
          ...ResourceMeta
        }
        inline {
          ...ResourceMeta
        }
        hyperlink {
          ...ResourceMeta
        }
      }
    }
  }
  navigationGroupsCollection(limit: 20, skip: 0) {
    items {
      ...EnrichedMeta
      componentName
      navigationGroupTitle
      navigationGroupLink {
        ... on Page {
          ...BasePage
        }
      }
      navigationLinksForGroupCollection(limit: 20) {
        items {
          ... on Page {
            ...BasePage
          }
          ... on NavigationLink {
            ...NavLink
          }
        }
        skip
        limit
        total
      }
    }
    skip
    limit
    total
  }
  socialNetworksCollection(limit: 20) {
    items {
      ...EnrichedMeta
      ... on Page {
        ...BasePage
      }
      ... on NavigationLink {
        ...NavLink
      }
    }
    skip
    limit
    total
  }
  footerPolicyGroupCollection(limit: 5) {
    items {
      ...EnrichedMeta
      ... on NavigationLink {
        ...NavLink
      }
    }
    skip
    limit
    total
  }
}
    `;
export const Error404FragmentDoc = gql`
    fragment Error404 on Error404 {
  heading
  subtitle
  body
  buttonLabel
  backgroundImage {
    ...Image
  }
  backgroundImageMobile {
    ...Image
  }
  sys {
    id
    environmentId
    spaceId
  }
  contentfulMetadata {
    tags {
      id
    }
  }
  darkTextColor
}
    `;
export const AppPagesDataFragmentDoc = gql`
    fragment AppPagesData on App {
  header {
    ...Header
  }
  footer {
    ...Footer
  }
  notFoundPage {
    ...Error404
  }
}
    `;
export const AppFragmentDoc = gql`
    fragment App on App {
  __typename
  sys {
    id
    environmentId
    spaceId
  }
  contentfulMetadata {
    tags {
      id
    }
  }
  name
  branding
  logo {
    ...Image
  }
  logoMobile {
    ...Image
  }
  header {
    ...Header
  }
  footer {
    ...Footer
  }
  notFoundPage {
    ...Error404
  }
}
    `;
export const InsuranceFragmentDoc = gql`
    fragment Insurance on Insurance {
  ...Meta
  title
  intro {
    json
  }
}
    `;
export const SchemaFragmentDoc = gql`
    fragment Schema on Schema {
  ...Meta
  schema
}
    `;
export const SpacerFragmentDoc = gql`
    fragment Spacer on Spacer {
  ...Meta
  size
  color
  anchorId
}
    `;
export const TextBlockSeoFragmentDoc = gql`
    fragment TextBlockSeo on TextBlockSeo {
  ...Meta
  name
  backgroundColor
  disablePaddingOn
  content {
    json
  }
  anchorId
}
    `;
export const PatientReviewsV2FragmentDoc = gql`
    fragment PatientReviewsV2 on PatientReviewsV2 {
  ...Meta
  eyebrowSmallScreens
  eyebrowLargeScreens
  titleSmallScreens
  titleLargeScreens
  subtitleSmallScreens
  subtitleLargeScreens
  titleHtag
  maxReviewsSmallScreens
  maxReviewsLargeScreens
  trimThreshold
  disablePaddingOn
  backgroundColor
  templateWidth
  contentAlign
  imageLeftSide {
    ...ImageAsset
  }
  reviewsCollection(limit: 4) {
    items {
      ...Meta
      score
      text
      subText1
      subText2
      avatar {
        ...Image
      }
    }
  }
  buttonsSmallScreensCollection(limit: 2) {
    items {
      ...Meta
      variant
      label
      buttonLink
      size
    }
  }
  buttonsLargeScreensCollection(limit: 2) {
    items {
      ...Meta
      variant
      label
      buttonLink
      size
    }
  }
  mode
  scoreIcon
  anchorId
}
    `;
export const IframeFragmentDoc = gql`
    fragment Iframe on Iframe {
  ...Meta
  title
  url
  height
  rawHtml
}
    `;
export const HalfScreenFragmentDoc = gql`
    fragment HalfScreen on HalfScreen {
  ...Meta
  name
  backgroundColor
  eyebrow
  eyebrowStyle
  templateSize
  mediaFirst
  facilitySegmentCollection
  termsAndConditions {
    ...TermOfConditions
  }
  heading {
    json
  }
  subHeading {
    json
  }
  body {
    json
  }
  image {
    ...Image
  }
  buttonCollection(limit: 2) {
    items {
      ...Button
    }
    limit
    skip
    total
  }
  video {
    ...Video
  }
  contentSmallScreen {
    headingSmallScreen {
      json
    }
    bodySmallScreen {
      json
    }
    imageSmallScreen {
      ...Image
    }
    mediaFirst
  }
  disclaimer {
    ...DisclaimerV2
  }
  imageAsset {
    ...ImageAsset
  }
  videoAsset {
    ...VideoAsset
  }
  hideContentHalf
  imageAssetTwo {
    ...ImageAsset
  }
  isInsetLayout
  useStaticImageSize
  anchorId
  textAlignment
}
    `;
export const MeetOurStaffFragmentDoc = gql`
    fragment MeetOurStaff on MeetOurStaff {
  ...Meta
  title
  description
  sectionBackground
  alignment
  contentMaxWidth
  showDisabledSwiperArrows
  withDesktopPaginationNavigation
  withMobileArrowsNavigation
  anchorId
}
    `;
export const QuickLinksFragmentDoc = gql`
    fragment QuickLinks on QuickLinks {
  ...Meta
  templateSize
  eyebrow
  eyebrowStyle
  heading {
    json
  }
  body {
    json
  }
  backgroundColor
  disablePaddingOn
  displayAsTitles
  quickLinksCollection(limit: 4) {
    items {
      ... on Button {
        ...Button
      }
    }
  }
  buttonsCollection(limit: 4) {
    items {
      ... on Button {
        ...Button
      }
    }
  }
  anchorId
}
    `;
export const LinkForwarderFragmentDoc = gql`
    fragment LinkForwarder on LinkForwarder {
  ...Meta
  url
}
    `;
export const ServiceFragmentDoc = gql`
    fragment Service on Service {
  ...Meta
  name
  backgroundColor
  description
  direction
  centerAlign
  contained
  eyebrow
  title
  titleHtag
  direction
  buttonText
  buttonUrl
  buttonType
  mediaType
  imageLayout
  richTextDescription {
    json
  }
  image {
    ...Image
  }
  mobileImage {
    ...Image
  }
  video {
    ...CommonAsset
    url
  }
  buttonsCollection(limit: 4) {
    items {
      ... on Button {
        ...Button
      }
    }
  }
  youTubeVideoId
  youTubeVideoImage {
    ...CommonAsset
    url
  }
  facilitySegmentCollection
  tc {
    ...TermOfConditions
  }
  anchorId
}
    `;
export const CategoryPickerFragmentDoc = gql`
    fragment CategoryPicker on CategoryPicker {
  ...Meta
  categoriesCollection(limit: 12) {
    items {
      icon
      title
      link
      imageAsset {
        ...ImageAsset
      }
    }
  }
  bodyCopy: description {
    ... on ContentTypeRichText {
      ...RichText
    }
  }
  eyebrow
  eyebrowHeading
  mobileThreshold
  title
  titleHeading
  setTwoRows
  buttonsCollection(limit: 2) {
    items {
      ...Button
    }
  }
  anchorId
}
    `;
export const OdpHeroFragmentDoc = gql`
    fragment OdpHero on OdpHero {
  ...Meta
  name
  templateWidth
  image {
    ...FocalPointImage
  }
  showReviews
  title
  titleHtag
  bodyCopy: description {
    ... on ContentTypeRichText {
      ...RichText
    }
  }
  showAddress
  showPhoneNumber
  showHours
  buttonsCollection(limit: 4) {
    items {
      ... on Button {
        ...Button
      }
    }
  }
  officeHoursLabel
  callCenterLabel
  googleMapsBusinessQuery
  facilitySegmentCollection
  promoTitle
  anchorId
}
    `;
export const PageFragmentDoc = gql`
    fragment Page on Page {
  ...Meta
  name
  breadcrumbTitle
  description
  pageTitle
  path
  title
  canonical
  indexed
  personalized
  pageTheme
  disableChatBot
  ogImage {
    ...ImageAsset
  }
  disableStickyFooterOnDesktop
  disableStickyFooterOnMobile
  disableHeaderTopAlertBanner
  disableHeaderBottomAlertBanner
  hideScheduleButtonInHeader
  contentsCollection(limit: $content_limit) {
    items {
      ...Insurance
      ...DisclaimerV2
      ...RichText
      ...Schema
      ...Spacer
      ...TextBlockSeo
      ...PatientReviewsV2
      ...Iframe
      ...TermOfConditions
      ...HalfScreen
      ...SingleMessage
      ...MeetOurStaff
      ...QuickLinks
      ...Cards
      ...LinkForwarder
      ...Service
      ...CategoryPicker
      ...OdpHero
      ... on Entry {
        ...Meta
      }
    }
  }
  analyticsContext {
    ...Analytics
  }
}
    `;
export const ProductDisplayFragmentDoc = gql`
    fragment ProductDisplay on ProductDisplay {
  ...Meta
  anchorId
  productListTitleHtag
  productListTitle
  productListDescription {
    json
  }
  showProductCategory
  showProductSubCategory
  productsToDisplay
  showLocalizedProductPrice
}
    `;
export const BlogDetailsPageBaseFragmentDoc = gql`
    fragment BlogDetailsPageBase on BlogDetailsPage {
  ...Meta
  path
}
    `;
export const RichTextWithLinksFragmentDoc = gql`
    fragment RichTextWithLinks on ContentTypeRichText {
  ...EnrichedMeta
  fullWidth
  backgroundColor
  centerAlign
  contained
  titleHeading
  title
  contentMaxWidth
  facilitySegmentCollection
  content {
    json
    links {
      assets {
        block {
          ...LinkMeta
          contentType
          url
          description
          fileName
        }
        hyperlink {
          ...LinkMeta
          contentType
          url
          description
          fileName
        }
      }
      entries {
        inline {
          ...EnrichedMeta
          ...BasePage
        }
        block {
          ...EnrichedMeta
          ...BasePage
          ...Table
          ...ImageAsset
          ...VideoAsset
        }
        hyperlink {
          ...EnrichedMeta
          ...BasePage
          ...BlogDetailsPageBase
          ... on ServiceDetailsPage {
            ...Meta
            path
          }
          ... on FacilityDetailsPage {
            ...Meta
            path
          }
        }
      }
      resources {
        block {
          ...ResourceMeta
        }
        inline {
          ...ResourceMeta
        }
        hyperlink {
          ...ResourceMeta
        }
      }
    }
  }
  secondaryContent {
    json
    links {
      assets {
        block {
          ...LinkMeta
          contentType
          url
          description
          fileName
        }
        hyperlink {
          ...LinkMeta
          contentType
          url
          description
          fileName
        }
      }
      entries {
        inline {
          ...EnrichedMeta
          ...BasePage
        }
        block {
          ...EnrichedMeta
          ...BasePage
        }
        hyperlink {
          ...EnrichedMeta
          ...BasePage
          ...BlogDetailsPageBase
          ... on ServiceDetailsPage {
            ...Meta
            path
          }
          ... on FacilityDetailsPage {
            ...Meta
            path
          }
        }
      }
      resources {
        block {
          ...ResourceMeta
        }
        inline {
          ...ResourceMeta
        }
        hyperlink {
          ...ResourceMeta
        }
      }
    }
  }
}
    `;
export const HeroFragmentDoc = gql`
    fragment Hero on HeroV2 {
  ...Meta
  entryName
  display
  backgroundColorSmallScreen
  body {
    json
  }
  bodySize
  buttonsCollection(limit: 4) {
    items {
      ... on Button {
        ...Button
      }
    }
  }
  contentAlign
  contentWidth
  contentPosition
  contentPositionSmallScreen
  contentSmallScreen {
    eyebrowSmallScreen
    headingSmallScreen {
      json
    }
    bodySmallScreen {
      json
    }
    imageSmallScreen {
      ...Image
    }
    focalPointImageSmallScreen {
      ...FocalPointImage
    }
    mediaFirst
  }
  darkOverlay
  darkTextColor
  eyebrow
  eyebrowStyle
  facilitySegmentCollection
  focalPointImage {
    ...FocalPointImage
  }
  heading {
    json
  }
  headingSize
  mediaAspectRatioSmallScreen
  templateWidth
  termsConditions {
    ...TermOfConditions
  }
  video {
    ...CommonAsset
    url
  }
  heightStyle
  promoHeadline {
    json
  }
  promoHeadlineSize
  disclaimer {
    ...DisclaimerV2
  }
  imageAsset {
    ...ImageAsset
  }
  videoAsset {
    ...VideoAsset
  }
  anchorId
}
    `;
export const MedicalServiceFragmentDoc = gql`
    fragment MedicalService on MedicalService {
  ...Meta
  iconName
  title
  description {
    json
  }
}
    `;
export const ContentListItemFragmentDoc = gql`
    fragment ContentListItem on ServiceLineHeroContentListItem {
  ... on ContentTypeRichText {
    ...RichText
  }
  ... on SingleMessage {
    ...SingleMessage
  }
  ... on Table {
    ...Table
  }
  ... on Accordions {
    ...Accordion
  }
}
    `;
export const ServiceLineHeroFragmentDoc = gql`
    fragment ServiceLineHero on ServiceLineHero {
  ...Meta
  eyebrow
  eyebrowHtag
  headline {
    json
  }
  subHeadline {
    json
  }
  bodyCopy {
    json
  }
  termsConditions {
    ...TermOfConditions
  }
  buttonCollection(limit: 2) {
    items {
      ...Button
    }
  }
  focalPointImage {
    ...FocalPointImage
  }
  templateWidth
  servicesCollection(limit: 8) {
    items {
      ...MedicalService
    }
  }
  videoAsset {
    ...VideoAsset
  }
  hideHeroOnMobile
  imgDisplaysFirstOnMobile
  imageWithBorderRadius
  backgroundColor
  backgroundColorMobile
  contentAlign
  facilitySegmentCollection
  disablePaddingOn
  mediaRoundedCornerSize
  imgDisplaysFirstOnDesktop
  showOfficeDetails
  displayOfficeHoursInModal
  googleMapsBusinessQuery
  contentListCollection(limit: 1) {
    items {
      ...ContentListItem
    }
  }
  anchorId
  imageAsset {
    ...ImageAsset
  }
}
    `;
export const MarqueeFragmentDoc = gql`
    fragment Marquee on Marquee {
  ...Meta
  textList
  icon
  height
  backgroundColor
  withAutoScrolling
  facilitySegmentCollection
  anchorId
}
    `;
export const SegmentsContainerFragmentDoc = gql`
    fragment SegmentsContainer on SegmentsContainer {
  ...Meta
  contentsCollection(limit: 12) {
    items {
      ... on HeroV2 {
        ...Hero
      }
      ... on HalfScreen {
        ...HalfScreen
      }
      ... on SingleMessage {
        ...SingleMessage
      }
      ... on ContentTypeRichText {
        ...RichText
      }
      ... on MultiCardV2 {
        ...Cards
      }
      ... on OdpHero {
        ...OdpHero
      }
      ... on ServiceLineHero {
        ...ServiceLineHero
      }
      ... on Marquee {
        ...Marquee
      }
      ... on DisclaimerV2 {
        ...DisclaimerV2
      }
    }
  }
  anchorId
}
    `;
export const BlogDetailsPageItemFragmentDoc = gql`
    fragment BlogDetailsPageItem on BlogDetailsPage {
  path
  indexed
  sys {
    publishedAt
  }
  category {
    ...BlogCategory
  }
}
    `;
export const BlogListPageItemFragmentDoc = gql`
    fragment BlogListPageItem on BlogListPage {
  indexed
  sys {
    publishedAt
  }
}
    `;
export const ServiceDetailsPageBaseFragmentDoc = gql`
    fragment ServiceDetailsPageBase on ServiceDetailsPage {
  ...Meta
  path
}
    `;
export const FacilityDetailsPageBaseFragmentDoc = gql`
    fragment FacilityDetailsPageBase on FacilityDetailsPage {
  ...Meta
  path
}
    `;
export const TextBlockSeoEntryLinksFragmentDoc = gql`
    fragment TextBlockSeoEntryLinks on TextBlockSeo {
  ...Meta
  content {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
}
    `;
export const InsuranceEntryLinksFragmentDoc = gql`
    fragment InsuranceEntryLinks on Insurance {
  ...Meta
  name
  intro {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
}
    `;
export const ContentTypeRichTextEntryLinksFragmentDoc = gql`
    fragment ContentTypeRichTextEntryLinks on ContentTypeRichText {
  ...Meta
  content {
    links {
      entries {
        block {
          ...EnrichedMeta
          ...ImageAsset
        }
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
  secondaryContent {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
}
    `;
export const CategoryPickerEntryLinksFragmentDoc = gql`
    fragment CategoryPickerEntryLinks on CategoryPicker {
  ...Meta
  name
  bodyCopy: description {
    ...ContentTypeRichTextEntryLinks
  }
}
    `;
export const SmallScreenContentEntryLinksFragmentDoc = gql`
    fragment SmallScreenContentEntryLinks on SmallScreenContent {
  ...Meta
  entryName
  bodySmallScreen {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
}
    `;
export const TermsAndConditionsEntryLinksFragmentDoc = gql`
    fragment TermsAndConditionsEntryLinks on TermsAndConditions {
  ...Meta
  content {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
}
    `;
export const SingleMessageEntryLinksFragmentDoc = gql`
    fragment SingleMessageEntryLinks on SingleMessage {
  ...Meta
  name
  content {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
  contentSmallScreen {
    ...SmallScreenContentEntryLinks
  }
  tc {
    ...TermsAndConditionsEntryLinks
  }
}
    `;
export const AccordionsEntryLinksFragmentDoc = gql`
    fragment AccordionsEntryLinks on Accordions {
  ...Meta
  title
  descriptionRichText {
    links {
      entries {
        hyperlink {
          ...EnrichedMeta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
  accordionsCollection(limit: 20) {
    items {
      ... on ContentTypeRichText {
        ...ContentTypeRichTextEntryLinks
      }
    }
  }
}
    `;
export const ColumnsEntryLinksFragmentDoc = gql`
    fragment ColumnsEntryLinks on Columns {
  ...Meta
  title
  columnsCollection(limit: 5) {
    items {
      ... on ContentTypeRichText {
        ...ContentTypeRichTextEntryLinks
      }
      ... on SingleMessage {
        ...SingleMessageEntryLinks
      }
      ... on Accordions {
        ...AccordionsEntryLinks
      }
    }
  }
}
    `;
export const MedicalServiceEntryLinksFragmentDoc = gql`
    fragment MedicalServiceEntryLinks on MedicalService {
  ...Meta
  title
  description {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
}
    `;
export const ContentListItemEntryLinksFragmentDoc = gql`
    fragment ContentListItemEntryLinks on ServiceLineHeroContentListItem {
  ... on ContentTypeRichText {
    ...ContentTypeRichTextEntryLinks
  }
  ... on SingleMessage {
    ...SingleMessageEntryLinks
  }
  ... on Accordions {
    ...AccordionsEntryLinks
  }
}
    `;
export const ServiceLineHeroEntryLinksFragmentDoc = gql`
    fragment ServiceLineHeroEntryLinks on ServiceLineHero {
  ...Meta
  subHeadline {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
  bodyCopy {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
  termsConditions {
    ...TermsAndConditionsEntryLinks
  }
  servicesCollection(limit: 8) {
    items {
      ...MedicalServiceEntryLinks
    }
  }
  contentListCollection(limit: 1) {
    items {
      ...ContentListItemEntryLinks
    }
  }
}
    `;
export const QuickLinksEntryLinksFragmentDoc = gql`
    fragment QuickLinksEntryLinks on QuickLinks {
  ...Meta
  body {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
}
    `;
export const ServiceEntryLinksFragmentDoc = gql`
    fragment ServiceEntryLinks on Service {
  ...Meta
  name
  richTextDescription {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
  tc {
    ...TermsAndConditionsEntryLinks
  }
}
    `;
export const DisclaimerV2EntryLinksFragmentDoc = gql`
    fragment DisclaimerV2EntryLinks on DisclaimerV2 {
  ...Meta
  entryName
  disclaimer {
    ...ContentTypeRichTextEntryLinks
  }
}
    `;
export const HeroV2EntryLinksFragmentDoc = gql`
    fragment HeroV2EntryLinks on HeroV2 {
  ...Meta
  entryName
  body {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
  contentSmallScreen {
    ...SmallScreenContentEntryLinks
  }
  termsConditions {
    ...TermsAndConditionsEntryLinks
  }
  disclaimer {
    ...DisclaimerV2EntryLinks
  }
}
    `;
export const HalfScreenEntryLinksFragmentDoc = gql`
    fragment HalfScreenEntryLinks on HalfScreen {
  ...Meta
  name
  body {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
  contentSmallScreen {
    ...SmallScreenContentEntryLinks
  }
  termsAndConditions {
    ...TermsAndConditionsEntryLinks
  }
  disclaimer {
    ...DisclaimerV2EntryLinks
  }
}
    `;
export const CardEntryLinksFragmentDoc = gql`
    fragment CardEntryLinks on Card {
  ...Meta
  name
  richTextDescription {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
  tc {
    ...TermsAndConditionsEntryLinks
  }
}
    `;
export const MulticardV2EntryLinksFragmentDoc = gql`
    fragment MulticardV2EntryLinks on MultiCardV2 {
  ...Meta
  descriptionRichText {
    links {
      entries {
        hyperlink {
          ...EnrichedMeta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
  cardsCollection(limit: 8) {
    items {
      ...CardEntryLinks
    }
  }
}
    `;
export const OdpHeroEntryLinksFragmentDoc = gql`
    fragment ODPHeroEntryLinks on OdpHero {
  ...Meta
  name
  bodyCopy: description {
    ...ContentTypeRichTextEntryLinks
  }
}
    `;
export const SegmentContainerEntryLinksFragmentDoc = gql`
    fragment SegmentContainerEntryLinks on SegmentsContainer {
  ...Meta
  contentsCollection(limit: 12) {
    items {
      ... on HeroV2 {
        ...HeroV2EntryLinks
      }
      ... on HalfScreen {
        ...HalfScreenEntryLinks
      }
      ... on SingleMessage {
        ...SingleMessageEntryLinks
      }
      ... on ContentTypeRichText {
        ...ContentTypeRichTextEntryLinks
      }
      ... on MultiCardV2 {
        ...MulticardV2EntryLinks
      }
      ... on OdpHero {
        ...ODPHeroEntryLinks
      }
    }
  }
}
    `;
export const ProductFeatureEntryLinksFragmentDoc = gql`
    fragment ProductFeatureEntryLinks on ProductFeature {
  ...Meta
  descriptionRichText {
    ...ContentTypeRichTextEntryLinks
  }
  descriptionListCollection(limit: 5) {
    items {
      ...Meta
      ... on ProductFeatureDescriptionListItem {
        content {
          ...ContentTypeRichTextEntryLinks
        }
      }
    }
  }
}
    `;
export const AgendaStepperEntryLinksFragmentDoc = gql`
    fragment AgendaStepperEntryLinks on AgendaStepper {
  ...Meta
  description {
    ...ContentTypeRichTextEntryLinks
  }
  stepsCollection(limit: 10) {
    items {
      ...Meta
      ... on AgendaModal {
        bodyText {
          ...ContentTypeRichTextEntryLinks
        }
      }
    }
  }
}
    `;
export const SitemapPagesFragmentDoc = gql`
    fragment sitemapPages on Query {
  pageCollection(
    limit: $limit
    skip: $skip
    where: {indexed: $indexed, appName: $appName}
    locale: $locale
  ) {
    items {
      path
      indexed
      sys {
        publishedAt
      }
    }
  }
}
    `;
export const AccordionsByIdDocument = gql`
    query accordionsById($id: String!, $preview: Boolean = false) {
  accordions(id: $id, preview: $preview) {
    ...Accordion
  }
}
    ${AccordionFragmentDoc}
${MetaFragmentDoc}
${FocalPointImageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${RichTextFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}`;

export function useAccordionsByIdQuery(options: Omit<Urql.UseQueryArgs<AccordionsByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<AccordionsByIdQuery, AccordionsByIdQueryVariables>({ query: AccordionsByIdDocument, ...options });
};
export const AgendaStepperByIdDocument = gql`
    query agendaStepperById($id: String!, $preview: Boolean = false) {
  agendaStepper(id: $id, preview: $preview) {
    icon
    title
    titleHtag
    description {
      ... on ContentTypeRichText {
        ...RichText
      }
    }
    stepsCollection(limit: 10) {
      items {
        ...AgendaModal
      }
    }
    hideStepperDot
    backgroundColor
    useNumericStepper
    isHighlightedSteps
    areStepsCenteredForMobile
    anchorId
  }
}
    ${RichTextFragmentDoc}
${MetaFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${AgendaModalFragmentDoc}`;

export function useAgendaStepperByIdQuery(options: Omit<Urql.UseQueryArgs<AgendaStepperByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<AgendaStepperByIdQuery, AgendaStepperByIdQueryVariables>({ query: AgendaStepperByIdDocument, ...options });
};
export const AppMetadataByAppNameDocument = gql`
    query appMetadataByAppName($appName: String!, $preview: Boolean = false) {
  appCollection(limit: 1, where: {name: $appName}, preview: $preview) {
    items {
      ...AppMetadata
    }
  }
}
    ${AppMetadataFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${FeatureFlagsFragmentDoc}`;

export function useAppMetadataByAppNameQuery(options: Omit<Urql.UseQueryArgs<AppMetadataByAppNameQueryVariables>, 'query'>) {
  return Urql.useQuery<AppMetadataByAppNameQuery, AppMetadataByAppNameQueryVariables>({ query: AppMetadataByAppNameDocument, ...options });
};
export const AppPagesDataByAppNameDocument = gql`
    query appPagesDataByAppName($appName: String!, $preview: Boolean = false) {
  appCollection(limit: 1, where: {name: $appName}, preview: $preview) {
    items {
      ...AppPagesData
    }
  }
}
    ${AppPagesDataFragmentDoc}
${HeaderFragmentDoc}
${EnrichedMetaFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${NavLinkFragmentDoc}
${MetaFragmentDoc}
${AnalyticsFragmentDoc}
${FooterNavigationGroupFragmentDoc}
${GenericNavigationGroupFragmentDoc}
${HeaderNavMenuFragmentDoc}
${HeaderMainNavFragmentDoc}
${HeaderSubNavFragmentDoc}
${ContentTileFragmentDoc}
${GoogleMapInHeaderFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${QuizFragmentDoc}
${BannerFragmentDoc}
${FooterFragmentDoc}
${DisclaimerV2FragmentDoc}
${RichTextFragmentDoc}
${LinkMetaFragmentDoc}
${ResourceMetaFragmentDoc}
${Error404FragmentDoc}`;

export function useAppPagesDataByAppNameQuery(options: Omit<Urql.UseQueryArgs<AppPagesDataByAppNameQueryVariables>, 'query'>) {
  return Urql.useQuery<AppPagesDataByAppNameQuery, AppPagesDataByAppNameQueryVariables>({ query: AppPagesDataByAppNameDocument, ...options });
};
export const BirdEyeReviewsByIdDocument = gql`
    query birdEyeReviewsById($id: String!, $preview: Boolean = false) {
  birdEyeReviews(id: $id, preview: $preview) {
    ...Meta
    title
    titleHeading
    mediaContent {
      ...Video
      ...FocalPointImage
    }
    tags
    filteredReviewsMinRating
    filteredReviewsTitle
    anchorId
  }
}
    ${MetaFragmentDoc}
${VideoFragmentDoc}
${CommonAssetFragmentDoc}
${FocalPointImageFragmentDoc}
${ImageFragmentDoc}`;

export function useBirdEyeReviewsByIdQuery(options: Omit<Urql.UseQueryArgs<BirdEyeReviewsByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<BirdEyeReviewsByIdQuery, BirdEyeReviewsByIdQueryVariables>({ query: BirdEyeReviewsByIdDocument, ...options });
};
export const BlogDetailsPageByPathDocument = gql`
    query blogDetailsPageByPath($path: String!, $title: String!, $preview: Boolean = false) {
  blogDetailsPageCollection(
    limit: 1
    where: {path: $path, brand: {title: $title}}
    preview: $preview
  ) {
    items {
      ...BlogDetailsPage
    }
    skip
    limit
    total
  }
}
    ${BlogDetailsPageFragmentDoc}
${MetaFragmentDoc}
${BrandFragmentDoc}
${BlogDetailsPageSummaryFragmentDoc}
${BlogDetailsPageSummaryAssetsFragmentDoc}
${LinkMetaFragmentDoc}
${BlogDetailsPageSummaryEntriesFragmentDoc}
${EnrichedMetaFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageSummaryResourcesFragmentDoc}
${ResourceMetaFragmentDoc}
${BlogCategoryFragmentDoc}
${BlogSubCategoryFragmentDoc}
${BlogDetailsPageTextFragmentDoc}
${BlogDetailsPageTextAssetsFragmentDoc}
${BlogDetailsPageTextEntriesFragmentDoc}
${TableFragmentDoc}
${VideoAssetFragmentDoc}
${VideoFragmentDoc}
${ColumnsFragmentDoc}
${RichTextFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${QuizFragmentDoc}
${SingleMessageFragmentDoc}
${FocalPointImageFragmentDoc}
${SmallScreenContentFragmentDoc}
${TermOfConditionsFragmentDoc}
${ImageAssetFragmentDoc}
${AccordionFragmentDoc}
${BlogDetailsPageTextResourcesFragmentDoc}
${BlogAuthorFragmentDoc}
${BlogAuthorAuthorBioSummaryFragmentDoc}
${BlogAuthorAuthorBioSummaryAssetsFragmentDoc}
${BlogAuthorAuthorBioSummaryEntriesFragmentDoc}
${BlogAuthorAuthorBioSummaryResourcesFragmentDoc}
${ContentSectionFragmentDoc}`;

export function useBlogDetailsPageByPathQuery(options: Omit<Urql.UseQueryArgs<BlogDetailsPageByPathQueryVariables>, 'query'>) {
  return Urql.useQuery<BlogDetailsPageByPathQuery, BlogDetailsPageByPathQueryVariables>({ query: BlogDetailsPageByPathDocument, ...options });
};
export const BlogListByIdDocument = gql`
    query blogListById($id: String!, $preview: Boolean = false) {
  blogList(id: $id, preview: $preview) {
    ...BlogList
  }
}
    ${BlogListFragmentDoc}
${MetaFragmentDoc}
${BlogCategoryFragmentDoc}
${BlogSubCategoryFragmentDoc}
${BrandFragmentDoc}
${HeroBlogDetailsPageListFragmentDoc}
${ImageAssetFragmentDoc}
${FeaturedBlogDetailsPageListFragmentDoc}`;

export function useBlogListByIdQuery(options: Omit<Urql.UseQueryArgs<BlogListByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<BlogListByIdQuery, BlogListByIdQueryVariables>({ query: BlogListByIdDocument, ...options });
};
export const BlogListPageByBrandDocument = gql`
    query blogListPageByBrand($brandName: String!, $preview: Boolean = false) {
  blogListPageCollection(
    limit: 1
    where: {brand: {title: $brandName}}
    preview: $preview
  ) {
    items {
      ...BlogListPage
    }
  }
}
    ${BlogListPageFragmentDoc}
${MetaFragmentDoc}
${BrandFragmentDoc}
${BlogListFragmentDoc}
${BlogCategoryFragmentDoc}
${BlogSubCategoryFragmentDoc}
${HeroBlogDetailsPageListFragmentDoc}
${ImageAssetFragmentDoc}
${FeaturedBlogDetailsPageListFragmentDoc}
${SingleMessageFragmentDoc}
${FocalPointImageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${SmallScreenContentFragmentDoc}
${VideoFragmentDoc}
${TermOfConditionsFragmentDoc}`;

export function useBlogListPageByBrandQuery(options: Omit<Urql.UseQueryArgs<BlogListPageByBrandQueryVariables>, 'query'>) {
  return Urql.useQuery<BlogListPageByBrandQuery, BlogListPageByBrandQueryVariables>({ query: BlogListPageByBrandDocument, ...options });
};
export const BlogPagesDocument = gql`
    query blogPages($brandName: String!, $locale: String!, $indexed: Boolean = true, $limit: Int = 500, $skip: Int = 0) {
  blogDetailsPageCollection(
    limit: $limit
    skip: $skip
    where: {indexed: $indexed, brand: {title: $brandName}}
    locale: $locale
  ) {
    items {
      ...BlogDetailsPageItem
    }
    skip
    limit
    total
  }
  blogListPageCollection(
    limit: $limit
    skip: $skip
    where: {indexed: $indexed, brand: {title: $brandName}}
    locale: $locale
  ) {
    items {
      ...BlogListPageItem
    }
    skip
    limit
    total
  }
}
    ${BlogDetailsPageItemFragmentDoc}
${BlogCategoryFragmentDoc}
${MetaFragmentDoc}
${BlogListPageItemFragmentDoc}`;

export function useBlogPagesQuery(options: Omit<Urql.UseQueryArgs<BlogPagesQueryVariables>, 'query'>) {
  return Urql.useQuery<BlogPagesQuery, BlogPagesQueryVariables>({ query: BlogPagesDocument, ...options });
};
export const CityLinksByIdDocument = gql`
    query cityLinksById($id: String!, $preview: Boolean = false) {
  cityLinks(id: $id, preview: $preview) {
    ...Meta
    name
  }
}
    ${MetaFragmentDoc}`;

export function useCityLinksByIdQuery(options: Omit<Urql.UseQueryArgs<CityLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<CityLinksByIdQuery, CityLinksByIdQueryVariables>({ query: CityLinksByIdDocument, ...options });
};
export const ColumnsByIdDocument = gql`
    query columnsById($id: String!, $preview: Boolean = false) {
  columns(id: $id, preview: $preview) {
    ...Columns
  }
}
    ${ColumnsFragmentDoc}
${MetaFragmentDoc}
${RichTextFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${SingleMessageFragmentDoc}
${FocalPointImageFragmentDoc}
${SmallScreenContentFragmentDoc}
${VideoFragmentDoc}
${TermOfConditionsFragmentDoc}
${ImageAssetFragmentDoc}
${AccordionFragmentDoc}`;

export function useColumnsByIdQuery(options: Omit<Urql.UseQueryArgs<ColumnsByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ColumnsByIdQuery, ColumnsByIdQueryVariables>({ query: ColumnsByIdDocument, ...options });
};
export const GoogleMapTemplateByIdDocument = gql`
    query googleMapTemplateById($id: String!, $preview: Boolean = false) {
  googleMapTemplate(id: $id, preview: $preview) {
    ...GoogleMapTemplate
  }
}
    ${GoogleMapTemplateFragmentDoc}
${MetaFragmentDoc}
${CommonAssetFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${ImageAssetFragmentDoc}
${CardsFragmentDoc}
${CardFragmentDoc}
${PdfFragmentDoc}
${TermOfConditionsFragmentDoc}
${TabsFragmentDoc}
${AccordionFragmentDoc}
${FocalPointImageFragmentDoc}
${RichTextFragmentDoc}`;

export function useGoogleMapTemplateByIdQuery(options: Omit<Urql.UseQueryArgs<GoogleMapTemplateByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<GoogleMapTemplateByIdQuery, GoogleMapTemplateByIdQueryVariables>({ query: GoogleMapTemplateByIdDocument, ...options });
};
export const HeroV2ByIdDocument = gql`
    query heroV2ById($id: String!, $preview: Boolean = false) {
  heroV2(id: $id, preview: $preview) {
    ...Hero
  }
}
    ${HeroFragmentDoc}
${MetaFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${FocalPointImageFragmentDoc}
${TermOfConditionsFragmentDoc}
${DisclaimerV2FragmentDoc}
${RichTextFragmentDoc}
${ImageAssetFragmentDoc}
${VideoAssetFragmentDoc}
${VideoFragmentDoc}`;

export function useHeroV2ByIdQuery(options: Omit<Urql.UseQueryArgs<HeroV2ByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<HeroV2ByIdQuery, HeroV2ByIdQueryVariables>({ query: HeroV2ByIdDocument, ...options });
};
export const MarqueeByIdDocument = gql`
    query marqueeById($id: String!, $preview: Boolean = false) {
  marquee(id: $id, preview: $preview) {
    ...Marquee
  }
}
    ${MarqueeFragmentDoc}
${MetaFragmentDoc}`;

export function useMarqueeByIdQuery(options: Omit<Urql.UseQueryArgs<MarqueeByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<MarqueeByIdQuery, MarqueeByIdQueryVariables>({ query: MarqueeByIdDocument, ...options });
};
export const LandingPageByPathDocument = gql`
    query landingPageByPath($path: String!, $content_limit: Int = 20, $preview: Boolean = false) {
  pageCollection(limit: 1, where: {path: $path}, preview: $preview) {
    items {
      ...Page
    }
    skip
    limit
    total
  }
}
    ${PageFragmentDoc}
${MetaFragmentDoc}
${ImageAssetFragmentDoc}
${InsuranceFragmentDoc}
${DisclaimerV2FragmentDoc}
${RichTextFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${SchemaFragmentDoc}
${SpacerFragmentDoc}
${TextBlockSeoFragmentDoc}
${PatientReviewsV2FragmentDoc}
${IframeFragmentDoc}
${TermOfConditionsFragmentDoc}
${HalfScreenFragmentDoc}
${VideoFragmentDoc}
${VideoAssetFragmentDoc}
${SingleMessageFragmentDoc}
${FocalPointImageFragmentDoc}
${SmallScreenContentFragmentDoc}
${MeetOurStaffFragmentDoc}
${QuickLinksFragmentDoc}
${CardsFragmentDoc}
${CardFragmentDoc}
${PdfFragmentDoc}
${LinkForwarderFragmentDoc}
${ServiceFragmentDoc}
${CategoryPickerFragmentDoc}
${OdpHeroFragmentDoc}`;

export function useLandingPageByPathQuery(options: Omit<Urql.UseQueryArgs<LandingPageByPathQueryVariables>, 'query'>) {
  return Urql.useQuery<LandingPageByPathQuery, LandingPageByPathQueryVariables>({ query: LandingPageByPathDocument, ...options });
};
export const LandingPageByAppNameWithPathDocument = gql`
    query landingPageByAppNameWithPath($appName: String!, $path: String!, $content_limit: Int = 20, $preview: Boolean = false) {
  pageCollection(
    limit: 1
    where: {path: $path, appName: $appName}
    preview: $preview
  ) {
    items {
      ...Page
    }
    skip
    limit
    total
  }
}
    ${PageFragmentDoc}
${MetaFragmentDoc}
${ImageAssetFragmentDoc}
${InsuranceFragmentDoc}
${DisclaimerV2FragmentDoc}
${RichTextFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${SchemaFragmentDoc}
${SpacerFragmentDoc}
${TextBlockSeoFragmentDoc}
${PatientReviewsV2FragmentDoc}
${IframeFragmentDoc}
${TermOfConditionsFragmentDoc}
${HalfScreenFragmentDoc}
${VideoFragmentDoc}
${VideoAssetFragmentDoc}
${SingleMessageFragmentDoc}
${FocalPointImageFragmentDoc}
${SmallScreenContentFragmentDoc}
${MeetOurStaffFragmentDoc}
${QuickLinksFragmentDoc}
${CardsFragmentDoc}
${CardFragmentDoc}
${PdfFragmentDoc}
${LinkForwarderFragmentDoc}
${ServiceFragmentDoc}
${CategoryPickerFragmentDoc}
${OdpHeroFragmentDoc}`;

export function useLandingPageByAppNameWithPathQuery(options: Omit<Urql.UseQueryArgs<LandingPageByAppNameWithPathQueryVariables>, 'query'>) {
  return Urql.useQuery<LandingPageByAppNameWithPathQuery, LandingPageByAppNameWithPathQueryVariables>({ query: LandingPageByAppNameWithPathDocument, ...options });
};
export const PageByAppAndAlternatePathDocument = gql`
    query pageByAppAndAlternatePath($appName: String!, $path: String!, $alternativePath: String!, $content_limit: Int = 20, $preview: Boolean = false) {
  pageCollection(
    limit: 1
    where: {appName: $appName, path_in: [$path, $alternativePath]}
    preview: $preview
  ) {
    items {
      ...Page
    }
    skip
    limit
    total
  }
}
    ${PageFragmentDoc}
${MetaFragmentDoc}
${ImageAssetFragmentDoc}
${InsuranceFragmentDoc}
${DisclaimerV2FragmentDoc}
${RichTextFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${SchemaFragmentDoc}
${SpacerFragmentDoc}
${TextBlockSeoFragmentDoc}
${PatientReviewsV2FragmentDoc}
${IframeFragmentDoc}
${TermOfConditionsFragmentDoc}
${HalfScreenFragmentDoc}
${VideoFragmentDoc}
${VideoAssetFragmentDoc}
${SingleMessageFragmentDoc}
${FocalPointImageFragmentDoc}
${SmallScreenContentFragmentDoc}
${MeetOurStaffFragmentDoc}
${QuickLinksFragmentDoc}
${CardsFragmentDoc}
${CardFragmentDoc}
${PdfFragmentDoc}
${LinkForwarderFragmentDoc}
${ServiceFragmentDoc}
${CategoryPickerFragmentDoc}
${OdpHeroFragmentDoc}`;

export function usePageByAppAndAlternatePathQuery(options: Omit<Urql.UseQueryArgs<PageByAppAndAlternatePathQueryVariables>, 'query'>) {
  return Urql.useQuery<PageByAppAndAlternatePathQuery, PageByAppAndAlternatePathQueryVariables>({ query: PageByAppAndAlternatePathDocument, ...options });
};
export const ProductDisplayByIdDocument = gql`
    query productDisplayById($id: String!, $preview: Boolean = false) {
  productDisplay(id: $id, preview: $preview) {
    ...Meta
    ...ProductDisplay
  }
}
    ${MetaFragmentDoc}
${ProductDisplayFragmentDoc}`;

export function useProductDisplayByIdQuery(options: Omit<Urql.UseQueryArgs<ProductDisplayByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductDisplayByIdQuery, ProductDisplayByIdQueryVariables>({ query: ProductDisplayByIdDocument, ...options });
};
export const ProductFeatureByIdDocument = gql`
    query productFeatureById($id: String!, $preview: Boolean = false) {
  productFeature(id: $id, preview: $preview) {
    ...Meta
    headline {
      ...ContentSection
    }
    descriptionRichText {
      ...RichText
    }
    descriptionButton {
      ...Button
    }
    descriptionButtonsCollection(limit: 2) {
      items {
        ...Button
      }
    }
    descriptionListCollection(limit: 5) {
      items {
        ...Meta
        icon
        content {
          ...RichText
        }
      }
    }
    buttonsCollection(limit: 10) {
      items {
        ...Button
      }
    }
    media {
      badge {
        label
        variant
      }
      contentsCollection(limit: 5) {
        items {
          ...FocalPointImage
          ...Video
        }
      }
    }
    disclaimer {
      ...DisclaimerV2
    }
    enableSliderControlsBackgroundGradient
    anchorId
  }
}
    ${MetaFragmentDoc}
${ContentSectionFragmentDoc}
${RichTextFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${FocalPointImageFragmentDoc}
${VideoFragmentDoc}
${DisclaimerV2FragmentDoc}`;

export function useProductFeatureByIdQuery(options: Omit<Urql.UseQueryArgs<ProductFeatureByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductFeatureByIdQuery, ProductFeatureByIdQueryVariables>({ query: ProductFeatureByIdDocument, ...options });
};
export const QuizByIdDocument = gql`
    query quizById($id: String!, $preview: Boolean = false) {
  quiz(id: $id, preview: $preview) {
    ...Quiz
  }
}
    ${QuizFragmentDoc}
${MetaFragmentDoc}`;

export function useQuizByIdQuery(options: Omit<Urql.UseQueryArgs<QuizByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<QuizByIdQuery, QuizByIdQueryVariables>({ query: QuizByIdDocument, ...options });
};
export const RichTextByIdDocument = gql`
    query richTextById($id: String!, $preview: Boolean = false) {
  contentTypeRichText(id: $id, preview: $preview) {
    ...RichTextWithLinks
  }
}
    ${RichTextWithLinksFragmentDoc}
${EnrichedMetaFragmentDoc}
${LinkMetaFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${TableFragmentDoc}
${MetaFragmentDoc}
${ImageAssetFragmentDoc}
${VideoAssetFragmentDoc}
${VideoFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ResourceMetaFragmentDoc}`;

export function useRichTextByIdQuery(options: Omit<Urql.UseQueryArgs<RichTextByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<RichTextByIdQuery, RichTextByIdQueryVariables>({ query: RichTextByIdDocument, ...options });
};
export const HeroV2EntryLinksByIdDocument = gql`
    query heroV2EntryLinksById($id: String!, $preview: Boolean = false) {
  heroV2(id: $id, preview: $preview) {
    ...HeroV2EntryLinks
  }
}
    ${HeroV2EntryLinksFragmentDoc}
${MetaFragmentDoc}
${BasePageFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}
${SmallScreenContentEntryLinksFragmentDoc}
${TermsAndConditionsEntryLinksFragmentDoc}
${DisclaimerV2EntryLinksFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${ImageAssetFragmentDoc}`;

export function useHeroV2EntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<HeroV2EntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<HeroV2EntryLinksByIdQuery, HeroV2EntryLinksByIdQueryVariables>({ query: HeroV2EntryLinksByIdDocument, ...options });
};
export const SingleMessageEntryLinksByIdDocument = gql`
    query singleMessageEntryLinksById($id: String!, $preview: Boolean = false) {
  singleMessage(id: $id, preview: $preview) {
    ...SingleMessageEntryLinks
  }
}
    ${SingleMessageEntryLinksFragmentDoc}
${MetaFragmentDoc}
${BasePageFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}
${SmallScreenContentEntryLinksFragmentDoc}
${TermsAndConditionsEntryLinksFragmentDoc}`;

export function useSingleMessageEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<SingleMessageEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<SingleMessageEntryLinksByIdQuery, SingleMessageEntryLinksByIdQueryVariables>({ query: SingleMessageEntryLinksByIdDocument, ...options });
};
export const MultiCardV2EntryLinksByIdDocument = gql`
    query multiCardV2EntryLinksById($id: String!, $preview: Boolean = false) {
  multiCardV2(id: $id, preview: $preview) {
    ...MulticardV2EntryLinks
  }
}
    ${MulticardV2EntryLinksFragmentDoc}
${MetaFragmentDoc}
${EnrichedMetaFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}
${CardEntryLinksFragmentDoc}
${TermsAndConditionsEntryLinksFragmentDoc}`;

export function useMultiCardV2EntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<MultiCardV2EntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<MultiCardV2EntryLinksByIdQuery, MultiCardV2EntryLinksByIdQueryVariables>({ query: MultiCardV2EntryLinksByIdDocument, ...options });
};
export const TextBlockSeoEntryLinksByIdDocument = gql`
    query textBlockSeoEntryLinksById($id: String!, $preview: Boolean = false) {
  textBlockSeo(id: $id, preview: $preview) {
    ...TextBlockSeoEntryLinks
  }
}
    ${TextBlockSeoEntryLinksFragmentDoc}
${MetaFragmentDoc}
${BasePageFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}`;

export function useTextBlockSeoEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<TextBlockSeoEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<TextBlockSeoEntryLinksByIdQuery, TextBlockSeoEntryLinksByIdQueryVariables>({ query: TextBlockSeoEntryLinksByIdDocument, ...options });
};
export const TermsAndConditionsEntryLinksByIdDocument = gql`
    query termsAndConditionsEntryLinksById($id: String!, $preview: Boolean = false) {
  termsAndConditions(id: $id, preview: $preview) {
    ...TermsAndConditionsEntryLinks
  }
}
    ${TermsAndConditionsEntryLinksFragmentDoc}
${MetaFragmentDoc}
${BasePageFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}`;

export function useTermsAndConditionsEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<TermsAndConditionsEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<TermsAndConditionsEntryLinksByIdQuery, TermsAndConditionsEntryLinksByIdQueryVariables>({ query: TermsAndConditionsEntryLinksByIdDocument, ...options });
};
export const AccordionsEntryLinksByIdDocument = gql`
    query accordionsEntryLinksById($id: String!, $preview: Boolean = false) {
  accordions(id: $id, preview: $preview) {
    ...AccordionsEntryLinks
  }
}
    ${AccordionsEntryLinksFragmentDoc}
${MetaFragmentDoc}
${EnrichedMetaFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${ImageAssetFragmentDoc}`;

export function useAccordionsEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<AccordionsEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<AccordionsEntryLinksByIdQuery, AccordionsEntryLinksByIdQueryVariables>({ query: AccordionsEntryLinksByIdDocument, ...options });
};
export const HalfScreenEntryLinksByIdDocument = gql`
    query halfScreenEntryLinksById($id: String!, $preview: Boolean = false) {
  halfScreen(id: $id, preview: $preview) {
    ...HalfScreenEntryLinks
  }
}
    ${HalfScreenEntryLinksFragmentDoc}
${MetaFragmentDoc}
${BasePageFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}
${SmallScreenContentEntryLinksFragmentDoc}
${TermsAndConditionsEntryLinksFragmentDoc}
${DisclaimerV2EntryLinksFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${ImageAssetFragmentDoc}`;

export function useHalfScreenEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<HalfScreenEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<HalfScreenEntryLinksByIdQuery, HalfScreenEntryLinksByIdQueryVariables>({ query: HalfScreenEntryLinksByIdDocument, ...options });
};
export const DisclaimerV2EntryLinksByIdDocument = gql`
    query disclaimerV2EntryLinksById($id: String!, $preview: Boolean = false) {
  disclaimerV2(id: $id, preview: $preview) {
    ...DisclaimerV2EntryLinks
  }
}
    ${DisclaimerV2EntryLinksFragmentDoc}
${MetaFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageAssetFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}`;

export function useDisclaimerV2EntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<DisclaimerV2EntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<DisclaimerV2EntryLinksByIdQuery, DisclaimerV2EntryLinksByIdQueryVariables>({ query: DisclaimerV2EntryLinksByIdDocument, ...options });
};
export const InsuranceEntryLinksByIdDocument = gql`
    query insuranceEntryLinksById($id: String!, $preview: Boolean = false) {
  insurance(id: $id, preview: $preview) {
    ...InsuranceEntryLinks
  }
}
    ${InsuranceEntryLinksFragmentDoc}
${MetaFragmentDoc}
${BasePageFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}`;

export function useInsuranceEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<InsuranceEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<InsuranceEntryLinksByIdQuery, InsuranceEntryLinksByIdQueryVariables>({ query: InsuranceEntryLinksByIdDocument, ...options });
};
export const CategoryPickerEntryLinksByIdDocument = gql`
    query categoryPickerEntryLinksById($id: String!, $preview: Boolean = false) {
  categoryPicker(id: $id, preview: $preview) {
    ...CategoryPickerEntryLinks
  }
}
    ${CategoryPickerEntryLinksFragmentDoc}
${MetaFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageAssetFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}`;

export function useCategoryPickerEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<CategoryPickerEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<CategoryPickerEntryLinksByIdQuery, CategoryPickerEntryLinksByIdQueryVariables>({ query: CategoryPickerEntryLinksByIdDocument, ...options });
};
export const ColumnsEntryLinksByIdDocument = gql`
    query columnsEntryLinksById($id: String!, $preview: Boolean = false) {
  columns(id: $id, preview: $preview) {
    ...ColumnsEntryLinks
  }
}
    ${ColumnsEntryLinksFragmentDoc}
${MetaFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageAssetFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}
${SingleMessageEntryLinksFragmentDoc}
${SmallScreenContentEntryLinksFragmentDoc}
${TermsAndConditionsEntryLinksFragmentDoc}
${AccordionsEntryLinksFragmentDoc}`;

export function useColumnsEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<ColumnsEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ColumnsEntryLinksByIdQuery, ColumnsEntryLinksByIdQueryVariables>({ query: ColumnsEntryLinksByIdDocument, ...options });
};
export const ServiceLineHeroEntryLinksDocument = gql`
    query serviceLineHeroEntryLinks($id: String!, $preview: Boolean = false) {
  serviceLineHero(id: $id, preview: $preview) {
    ...ServiceLineHeroEntryLinks
  }
}
    ${ServiceLineHeroEntryLinksFragmentDoc}
${MetaFragmentDoc}
${BasePageFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}
${TermsAndConditionsEntryLinksFragmentDoc}
${MedicalServiceEntryLinksFragmentDoc}
${ContentListItemEntryLinksFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${ImageAssetFragmentDoc}
${SingleMessageEntryLinksFragmentDoc}
${SmallScreenContentEntryLinksFragmentDoc}
${AccordionsEntryLinksFragmentDoc}`;

export function useServiceLineHeroEntryLinksQuery(options: Omit<Urql.UseQueryArgs<ServiceLineHeroEntryLinksQueryVariables>, 'query'>) {
  return Urql.useQuery<ServiceLineHeroEntryLinksQuery, ServiceLineHeroEntryLinksQueryVariables>({ query: ServiceLineHeroEntryLinksDocument, ...options });
};
export const OdpHeroEntryLinksDocument = gql`
    query ODPHeroEntryLinks($id: String!, $preview: Boolean = false) {
  odpHero(id: $id, preview: $preview) {
    ...ODPHeroEntryLinks
  }
}
    ${OdpHeroEntryLinksFragmentDoc}
${MetaFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageAssetFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}`;

export function useOdpHeroEntryLinksQuery(options: Omit<Urql.UseQueryArgs<OdpHeroEntryLinksQueryVariables>, 'query'>) {
  return Urql.useQuery<OdpHeroEntryLinksQuery, OdpHeroEntryLinksQueryVariables>({ query: OdpHeroEntryLinksDocument, ...options });
};
export const QuickLinksEntryLinksByIdDocument = gql`
    query QuickLinksEntryLinksById($id: String!, $preview: Boolean = false) {
  quickLinks(id: $id, preview: $preview) {
    ...QuickLinksEntryLinks
  }
}
    ${QuickLinksEntryLinksFragmentDoc}
${MetaFragmentDoc}
${BasePageFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}`;

export function useQuickLinksEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<QuickLinksEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<QuickLinksEntryLinksByIdQuery, QuickLinksEntryLinksByIdQueryVariables>({ query: QuickLinksEntryLinksByIdDocument, ...options });
};
export const ServiceEntryLinksByIdDocument = gql`
    query ServiceEntryLinksById($id: String!, $preview: Boolean = false) {
  service(id: $id, preview: $preview) {
    ...ServiceEntryLinks
  }
}
    ${ServiceEntryLinksFragmentDoc}
${MetaFragmentDoc}
${BasePageFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}
${TermsAndConditionsEntryLinksFragmentDoc}`;

export function useServiceEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<ServiceEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ServiceEntryLinksByIdQuery, ServiceEntryLinksByIdQueryVariables>({ query: ServiceEntryLinksByIdDocument, ...options });
};
export const SegmentContainerLinksByIdDocument = gql`
    query SegmentContainerLinksById($id: String!, $preview: Boolean = false) {
  segmentsContainer(id: $id, preview: $preview) {
    ...SegmentContainerEntryLinks
  }
}
    ${SegmentContainerEntryLinksFragmentDoc}
${MetaFragmentDoc}
${HeroV2EntryLinksFragmentDoc}
${BasePageFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}
${SmallScreenContentEntryLinksFragmentDoc}
${TermsAndConditionsEntryLinksFragmentDoc}
${DisclaimerV2EntryLinksFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${ImageAssetFragmentDoc}
${HalfScreenEntryLinksFragmentDoc}
${SingleMessageEntryLinksFragmentDoc}
${MulticardV2EntryLinksFragmentDoc}
${CardEntryLinksFragmentDoc}
${OdpHeroEntryLinksFragmentDoc}`;

export function useSegmentContainerLinksByIdQuery(options: Omit<Urql.UseQueryArgs<SegmentContainerLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<SegmentContainerLinksByIdQuery, SegmentContainerLinksByIdQueryVariables>({ query: SegmentContainerLinksByIdDocument, ...options });
};
export const ProductFeatureEntryLinksByIdDocument = gql`
    query ProductFeatureEntryLinksById($id: String!, $preview: Boolean = false) {
  productFeature(id: $id, preview: $preview) {
    ...ProductFeatureEntryLinks
  }
}
    ${ProductFeatureEntryLinksFragmentDoc}
${MetaFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageAssetFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}`;

export function useProductFeatureEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<ProductFeatureEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductFeatureEntryLinksByIdQuery, ProductFeatureEntryLinksByIdQueryVariables>({ query: ProductFeatureEntryLinksByIdDocument, ...options });
};
export const AgendaStepperEntryLinksByIdDocument = gql`
    query AgendaStepperEntryLinksById($id: String!, $preview: Boolean = false) {
  agendaStepper(id: $id, preview: $preview) {
    ...AgendaStepperEntryLinks
  }
}
    ${AgendaStepperEntryLinksFragmentDoc}
${MetaFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageAssetFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}`;

export function useAgendaStepperEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<AgendaStepperEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<AgendaStepperEntryLinksByIdQuery, AgendaStepperEntryLinksByIdQueryVariables>({ query: AgendaStepperEntryLinksByIdDocument, ...options });
};
export const SegmentsContainerByIdDocument = gql`
    query segmentsContainerById($id: String!, $preview: Boolean = false) {
  segmentsContainer(id: $id, preview: $preview) {
    ...SegmentsContainer
  }
}
    ${SegmentsContainerFragmentDoc}
${MetaFragmentDoc}
${HeroFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${FocalPointImageFragmentDoc}
${TermOfConditionsFragmentDoc}
${DisclaimerV2FragmentDoc}
${RichTextFragmentDoc}
${ImageAssetFragmentDoc}
${VideoAssetFragmentDoc}
${VideoFragmentDoc}
${HalfScreenFragmentDoc}
${SingleMessageFragmentDoc}
${SmallScreenContentFragmentDoc}
${CardsFragmentDoc}
${CardFragmentDoc}
${PdfFragmentDoc}
${OdpHeroFragmentDoc}
${ServiceLineHeroFragmentDoc}
${MedicalServiceFragmentDoc}
${ContentListItemFragmentDoc}
${TableFragmentDoc}
${AccordionFragmentDoc}
${MarqueeFragmentDoc}`;

export function useSegmentsContainerByIdQuery(options: Omit<Urql.UseQueryArgs<SegmentsContainerByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<SegmentsContainerByIdQuery, SegmentsContainerByIdQueryVariables>({ query: SegmentsContainerByIdDocument, ...options });
};
export const ServiceLineHeroByIdDocument = gql`
    query serviceLineHeroById($id: String!, $preview: Boolean = false) {
  serviceLineHero(id: $id, preview: $preview) {
    ...ServiceLineHero
  }
}
    ${ServiceLineHeroFragmentDoc}
${MetaFragmentDoc}
${TermOfConditionsFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${FocalPointImageFragmentDoc}
${MedicalServiceFragmentDoc}
${VideoAssetFragmentDoc}
${VideoFragmentDoc}
${ContentListItemFragmentDoc}
${RichTextFragmentDoc}
${SingleMessageFragmentDoc}
${SmallScreenContentFragmentDoc}
${ImageAssetFragmentDoc}
${TableFragmentDoc}
${AccordionFragmentDoc}`;

export function useServiceLineHeroByIdQuery(options: Omit<Urql.UseQueryArgs<ServiceLineHeroByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ServiceLineHeroByIdQuery, ServiceLineHeroByIdQueryVariables>({ query: ServiceLineHeroByIdDocument, ...options });
};
export const SitemapPagesDocument = gql`
    query sitemapPages($appName: String!, $locale: String!, $indexed: Boolean = true, $limit: Int = 500, $skip: Int = 0) {
  ...sitemapPages
}
    ${SitemapPagesFragmentDoc}`;

export function useSitemapPagesQuery(options: Omit<Urql.UseQueryArgs<SitemapPagesQueryVariables>, 'query'>) {
  return Urql.useQuery<SitemapPagesQuery, SitemapPagesQueryVariables>({ query: SitemapPagesDocument, ...options });
};
export const SmileAssessmentFormByIdDocument = gql`
    query smileAssessmentFormById($id: String!, $preview: Boolean = false) {
  smileAssessmentForm(id: $id, preview: $preview) {
    formContent {
      buttonText
      buttonUrl
      defaultErrorMessage
      formCollection(limit: 10) {
        items {
          ... on SectionContent {
            title
            type
            aditionalReferencesCollection(limit: 10) {
              items {
                ... on FormField {
                  title
                  required
                  onSubmitFormUrl
                  alertMessage
                  type
                  label
                  placeholder
                  apiKey
                  image {
                    url
                  }
                }
                ... on FormDropdownField {
                  title
                  clearTextItem
                  itemList
                  apiKey
                  required
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export function useSmileAssessmentFormByIdQuery(options: Omit<Urql.UseQueryArgs<SmileAssessmentFormByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<SmileAssessmentFormByIdQuery, SmileAssessmentFormByIdQueryVariables>({ query: SmileAssessmentFormByIdDocument, ...options });
};
export const StateLinksByIdDocument = gql`
    query stateLinksById($id: String!, $preview: Boolean = false) {
  stateLinks(id: $id, preview: $preview) {
    ...Meta
    name
  }
}
    ${MetaFragmentDoc}`;

export function useStateLinksByIdQuery(options: Omit<Urql.UseQueryArgs<StateLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<StateLinksByIdQuery, StateLinksByIdQueryVariables>({ query: StateLinksByIdDocument, ...options });
};
export const TableByIdDocument = gql`
    query tableById($id: String!, $preview: Boolean = false) {
  table(id: $id, preview: $preview) {
    ...Table
  }
}
    ${TableFragmentDoc}
${MetaFragmentDoc}
${CommonAssetFragmentDoc}`;

export function useTableByIdQuery(options: Omit<Urql.UseQueryArgs<TableByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<TableByIdQuery, TableByIdQueryVariables>({ query: TableByIdDocument, ...options });
};
export const TabsByIdDocument = gql`
    query tabsById($id: String!, $preview: Boolean = false) {
  tabs(id: $id, preview: $preview) {
    ...Tabs
  }
}
    ${TabsFragmentDoc}
${MetaFragmentDoc}
${AccordionFragmentDoc}
${FocalPointImageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${RichTextFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}`;

export function useTabsByIdQuery(options: Omit<Urql.UseQueryArgs<TabsByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<TabsByIdQuery, TabsByIdQueryVariables>({ query: TabsByIdDocument, ...options });
};
export const VideoCarouselByIdDocument = gql`
    query videoCarouselById($id: String!, $preview: Boolean = false) {
  videoCarousel(id: $id, preview: $preview) {
    ...Meta
    backgroundColor
    topFields {
      ...ContentSection
    }
    desktopVideosAspectRatio
    mobileVideosAspectRatio
    videosCollection(limit: 5) {
      skip
      total
      items {
        ... on VideoWithContent {
          ...Meta
          content {
            ...ContentSection
          }
          video {
            ...VideoAsset
          }
          buttonsCollection(limit: 1) {
            items {
              ...Button
            }
          }
        }
      }
    }
    buttonsCollection(limit: 2) {
      items {
        ...Button
      }
    }
    anchorId
  }
}
    ${MetaFragmentDoc}
${ContentSectionFragmentDoc}
${VideoAssetFragmentDoc}
${VideoFragmentDoc}
${CommonAssetFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}`;

export function useVideoCarouselByIdQuery(options: Omit<Urql.UseQueryArgs<VideoCarouselByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<VideoCarouselByIdQuery, VideoCarouselByIdQueryVariables>({ query: VideoCarouselByIdDocument, ...options });
};
export const InsuranceByStateDocument = gql`
    query insuranceByState($filter: InsuranceCompaniesFilterInput!) {
  insuranceCompanies(filter: $filter) {
    total
    items {
      name
    }
  }
}
    `;

export function useInsuranceByStateQuery(options: Omit<Urql.UseQueryArgs<InsuranceByStateQueryVariables>, 'query'>) {
  return Urql.useQuery<InsuranceByStateQuery, InsuranceByStateQueryVariables>({ query: InsuranceByStateDocument, ...options });
};
export const NearbyFacilitiesDocument = gql`
    query nearbyFacilities($filter: NearbyFacilitiesLocationFilter!, $skip: NonNegativeInt = 0, $take: NonNegativeInt = 5) {
  nearbyFacilities(filter: $filter, skip: $skip, take: $take) {
    items {
      distanceInMiles
      facility {
        name
        code
        address {
          address1
          zipCode
          city
        }
      }
    }
    hasMore
  }
}
    `;

export function useNearbyFacilitiesQuery(options: Omit<Urql.UseQueryArgs<NearbyFacilitiesQueryVariables>, 'query'>) {
  return Urql.useQuery<NearbyFacilitiesQuery, NearbyFacilitiesQueryVariables>({ query: NearbyFacilitiesDocument, ...options });
};